// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23334155%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MyMarginCls{
    margin-top: 100px;
} */
:root {
  /* --oragne-color: #d37c1d; */
  /* --orange: #fe7f3c; */
  --font-family: "Plus Jakarta Sans", sans-serif;
  --orange-color: #cd601d;
  /* --green-color: #49bf2b; */
  --green-color: #63a211;
  --red: #ff4d62;
  --half-red: #d37881;
  --green: #33c18d;
  --white: #fff;
  --black: #000;
  --primary-black: rgba(0, 0, 0, 0.12);
  --secondary-black: #212529;

  --primary-blue-color: #293b83;
  --secondary-blue-color: #3e56bf;
  --dark-blue: #0e527d;
  --border-lines: #e1e6e9;
  --light-blue: #1a87cb;
  --very-dark-blue: #24397a;
  --very-dark-elephant-gray: #8f7777;
  --elephant-dark-grey: #aaa;
  --light-eleph-light-grey: #e5f0ff;
  --disabled-light-grey: #e9ecef;
  --very-light-grey: #d1d1d1;
  --v-grey-light: #eee;
  --table-row-bg-light-grey: #fafafa;
  --box-shadow-color: #8b8084;
  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);
  /* linear-gradient(90deg, #031978, #3e56bf) */
  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);
  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);
  --light-blue-gradient-angle: linear-gradient(
    90deg,
    #46a4cf 8%,
    #2f324f 86.9%
  );
  --green-gradient: linear-gradient(
    73.1deg,
    rgba(34, 126, 34, 1) 8%,
    rgba(99, 162, 17, 1) 86.9%
  );
  /* --roboto-font-family: "Roboto", 'Halvetica', sans-serif; */
  --stickyBackground: #f5f5f5;
  --borderColor: #c9d1dc;
}

.OrganizationTableView thead th,
.CandidateListTableView thead th,
.DepartmentTableView thead th,
.JobTableView thead th {
  background-color: #e6f3ff;
}
body {
  font-family: var(--font-family);
}

.CandidateListTableView tbody td {
  background-color: white;
}

.job-candidate-table thead th {
  background-color: #afd6ee !important;
}

.CandidateTestTablewView thead th {
  background-color: #4a94da !important;
  color: #fff !important;
}

#CreateJobOrder .p-tabmenu-nav.p-reset {
  border: 0;
}

#CreateJobOrder .p-tabmenuitem.p-highlight {
  border-bottom: 2px solid #1a87cb;
}

#CreateJobOrder .p-tabmenuitem .p-menuitem-link {
  color: #1a87cb;
}

.create-job-candidate-panel {
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.create-job-candidate-panel #CandidateTest_DataTableView {
  padding: 0 12px 12px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_Table {
  border: 1px solid #e3ecf7;
  border-radius: 8px;
  overflow: hidden;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableHeadRow {
  background: #eef7ff;
  border-bottom: 1px solid #d8e8f7;
  min-height: 44px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableRow {
  min-height: 52px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableBody {
  background: #fff;
}

.create-job-candidate-panel .form-control,
.create-job-candidate-panel .form-select,
.create-job-candidate-panel select {
  min-height: 34px;
  border-color: #d7e3ef;
  font-size: 13px;
}

.create-job-candidate-panel .btn-sm {
  min-height: 32px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.create-job-candidate-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #e6edf8;
  background: #f8fbff;
}

.create-job-candidate-count {
  min-width: 34px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #145b84;
  background: #e6f3ff;
  border: 1px solid #b9ddf4;
  font-size: 12px;
  font-weight: 700;
}

.create-job-candidate-search {
  padding: 12px;
  border-bottom: 1px solid #eef3f8;
}

.create-job-candidate-search .input-group-text {
  color: #1a87cb;
  background: #fff;
  border-color: #d7e3ef;
}

.create-job-candidate-search .form-control {
  border-color: #d7e3ef;
  font-size: 13px;
}

.create-job-candidate-list {
  max-height: 560px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  min-width: 0;
  padding: 8px;
  background: #f8fafc;
}

.create-job-candidate-list > .row {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-left: 0;
  margin-right: 0;
}

.create-job-candidate-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #e1e8f0;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;
}

.create-job-candidate-item:hover,
.create-job-candidate-item:focus {
  border-color: #1a87cb;
  background: #f3f9ff;
  box-shadow: 0 8px 18px rgba(26, 135, 203, 0.12);
  transform: translateY(-1px);
  outline: none;
}

.create-job-candidate-item.is-selected {
  border-color: #1a87cb;
  background: #eaf6ff;
  box-shadow: inset 4px 0 0 #1a87cb, 0 8px 18px rgba(26, 135, 203, 0.12);
}

.create-job-candidate-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #fff;
  background: #1a87cb;
  font-weight: 700;
  font-size: 13px;
}

.create-job-candidate-summary {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.create-job-candidate-name {
  color: #172033;
  font-weight: 700;
  line-height: 1.25;
}

.create-job-candidate-meta {
  color: #6c757d;
  font-size: 12px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.create-job-candidate-preview {
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.create-job-candidate-preview-header {
  padding: 14px 16px;
  background: #f8fbff;
  border-bottom: 1px solid #e6edf8;
}

.create-job-candidate-preview-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #145b84;
  background: #e6f3ff;
  border: 1px solid #b9ddf4;
  font-weight: 700;
}

.create-job-candidate-preview-meta {
  color: #6c757d;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.create-job-candidate-detail-card {
  background: #fff;
}

.create-job-candidate-detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e6edf8;
  background: #fff;
}

.create-job-candidate-detail-tabs .btn {
  margin: 0;
  border-radius: 6px;
  font-weight: 600;
}

.create-job-candidate-detail-body {
  padding: 16px;
}

.create-job-candidate-detail-body .badge {
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 9px;
  white-space: normal;
  text-align: left;
}

.create-job-candidate-detail-body iframe {
  min-height: 620px;
}

.ats-candidate-detail-side {
  padding: 1rem;
  border-right: 1px solid #e2e8f0;
  overflow: hidden;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ats-candidate-detail-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 4px;
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #f8fbff;
  flex: 0 0 auto;
}

.ats-candidate-detail-switch button {
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 10px;
  cursor: pointer;
}

.ats-candidate-detail-switch button.active {
  background: #1a87cb;
  color: #fff;
  box-shadow: 0 6px 14px rgba(26, 135, 203, 0.18);
}

.ats-candidate-detail-content {
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0;
}

.ats-candidate-detail-fields {
  display: grid;
  gap: 8px;
}

.ats-candidate-detail-field {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  background: #fbfdff;
}

.ats-candidate-detail-field i {
  color: #1a87cb;
  font-size: 13px;
  margin-top: 2px;
}

.candidate-modal .candidate-contact-icon,
.candidate-modal .candidate-contact-icon * {
  color: #4f46e5 !important;
  stroke: #4f46e5 !important;
}

.ats-candidate-detail-field span {
  display: block;
  color: #64748b;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.ats-candidate-detail-field strong {
  display: block;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.ats-candidate-detail-content section {
  font-size: 13px;
}

.ats-candidate-detail-content section > p {
  font-size: 11.5px !important;
  letter-spacing: 0.02em;
  margin-bottom: 9px !important;
}

.ats-candidate-detail-content .candidate-contact-icon {
  width: 14px !important;
  height: 14px !important;
  min-width: 14px !important;
}

.ats-candidate-detail-content .d-flex.align-items-start span,
.ats-candidate-detail-content .d-flex.align-items-center span {
  font-size: 13px !important;
  line-height: 1.4;
}

.ats-candidate-history-item {
  font-size: 13px !important;
  line-height: 1.4;
}

.ats-candidate-history-item .fw-semibold {
  font-size: 13.5px !important;
  line-height: 1.35;
}

.ats-candidate-history-item .text-muted,
.ats-candidate-history-item .small {
  font-size: 12.5px !important;
  line-height: 1.4;
}

.expander-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 50px;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.expander-bubble:hover {
  background-color: #e0e0e0;
  border-radius: 50%;
  background-color: #f4f4f4;
  border: 1px solid #d0d0d0;
}

.CDV_Container {
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 12px;
}

.CDV_Icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/* #JobOrder_DataTableView .rdt_Table {
    min-width: 100%;
} */

#CandidateTest_DataTableView .rdt_Table {
  /* min-width: 190%; */
  /* border: 2px solid red; */
}
.closeBtn,
.addBtn {
  padding: 8px 18px;
  margin-bottom: 8px;
  /* font-size: 16px; */
  font-weight: 700;
  background: var(--green-gradient);
  /* box-shadow: 5px 5px 10px var(--very-dark-elephant-gray); */
  /* text-transform: uppercase; */
  color: var(--white) !important;
  /* border: 0; */
  /* font-family: 'Mukta', sans-serif; */
}

.addBtn:hover {
  box-shadow: -1px 1px 5px 5px var(--box-shadow-color);
}
.blueBtn {
  background: var(--blue-gradient-right) !important;
  color: var(--white) !important;
  font-weight: 700;
  margin: 10px;
}
.candidate-status-modal-header .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
  opacity: 0.95;
}
.candidate-status-modal-header .btn-close:hover {
  opacity: 1;
}
.talent-scan-view-result-btn {
  min-width: 82px;
  height: 34px;
  margin: 0;
  white-space: nowrap;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.talent-scan-view-result-btn:hover,
.talent-scan-view-result-btn:focus {
  font-size: 15px;
}
.searchIconBtn {
  background: var(--blue-gradient-right) !important;
  color: var(--white) !important;
  font-weight: 700;
}

.candidate-name-with-initials {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 44px;
  padding: 4px 0;
}

.candidate-name-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  flex: 0 0 30px;
  margin-top: 0;
  padding: 0;
  box-sizing: border-box;
  border-radius: 50%;
  background: #f3e8ff;
  color: #7e22ce;
  border: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
  text-decoration: none;
}

.candidate-name-with-initials > span:last-child {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: break-word;
  font-size: 14px;
}

.expander-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 50px;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.expander-bubble:hover {
  background-color: #e0e0e0;
  border-radius: 50%;
  background-color: #f4f4f4;
  border: 1px solid #d0d0d0;
}
#JobOrderTableView .rdt_TableCol:nth-child(1),
#JobOrderTableView .rdt_TableCol:nth-child(3),
#JobOrderTableView .rdt_TableCol:nth-child(5) {
  justify-content: initial;
  text-align: center;
}
#JobOrderTableView .sc-hJRrWL .rdt_TableCell,
#JobOrderTableView .sc-hJRrWL .rdt_TableCell span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#JobOrderTableView,
#JobOrderTableView .rdt_Table,
#JobOrderTableView .rdt_TableHead,
#JobOrderTableView .rdt_TableBody,
#JobOrderTableView .rdt_TableRow {
  width: 100% !important;
}

#JobOrderTableView .rdt_Table,
#JobOrderTableView .rdt_TableBody {
  overflow-x: hidden !important;
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol {
  padding: 8px 8px !important;
}

#JobOrderTableView a.job-order-title-link,
#JobOrderTableView a.job-order-title-link > span {
  text-decoration-line: underline !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 2px !important;
}

@media (min-width: 1200px) {
  #JobOrderTableView .rdt_TableHeadRow > .rdt_TableCol,
  #JobOrderTableView .rdt_TableRow > .rdt_TableCell {
    flex-shrink: 1 !important;
    min-width: 0 !important;
  }

  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > div,
  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > a {
    min-width: 0;
    max-width: 100%;
  }

  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol,
#JobOrderTableView .rdt_TableHead .rdt_TableCol > div {
  min-width: 0;
  justify-content: center;
  overflow: visible;
  white-space: normal;
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol .fs-6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  font-size: 14px !important;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
}

#JobOrderTableView .addCandidateHeaderBtn {
  width: 100%;
  min-width: 0;
  padding: 0 !important;
  justify-content: center;
  white-space: normal;
  line-height: 1.2;
}

#JobOrderTableView .addCandidateHeaderBtn .ms-1 {
  margin-left: 0 !important;
}

#JobOrderTableView .job-order-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  width: 100%;
}

#JobOrderTableView .job-order-actions-cell .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0 !important;
}
/* #JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM{
        padding-left: 8px;
    padding-right: 4px;
    border-right: 1px solid var(--border-lines);
    border-bottom: 1px solid var(--border-lines);
} */

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  border-right: 1px solid var(--border-lines);
  border-bottom: 1px solid var(--border-lines);
  /* border-right: 1px solid blue;
  border-bottom: 1px solid blue; */
  padding-left: 2px;
  padding-right: 2px;
}

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell span {
  /* width: 90%; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM:first-child {
  border-left: 1px solid var(--border-lines);
}

/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11), */
/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10), */
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(12),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2){
  justify-content: center;
}

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {
  font-weight: 500;
}

/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) span {
  font-weight: 500;
  background-color: #ebe9e9;
  border-radius: 0.375rem;
} */

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) {
  font-weight: 500;
}

#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(6),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(8),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(15),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(17),
/* #CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13), */
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(16),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(9) {
  justify-content: center;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5) {
  justify-content: center;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(16),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(14),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(17),
/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15), */
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6) {
  justify-content: center;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {
  justify-content: start !important;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div {
  width: 95%;
  /* border: 2px solid red; */
}

/* 
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div > span {
  border: 2px solid red;
} */

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div span {
  width: 180px;
}

#CalendarScheduled_TableView tbody tr td:nth-child(2) {
  text-align: center !important;
}

/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9) {
  border: 2px solid red;
} */
/* MobilePhoneContaier */

/* #CalendarScheduled_TableView tbody tr td:nth-child(4) {
  border: 2px solid red;
  white-space: nowrap;
  width: 150px !important;
  overflow: hidden;
  text-overflow: ellipsis;
} */

#CandidateTest_DataTableView {
  /* Chandu */
}

#CandidateTest_DataTableView .rdt_TableHeadRow {
  min-height: 52px;
}

#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol {
  align-items: center;
  justify-content: center;
  padding: 8px 8px !important;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol > div {
  min-width: 0;
  justify-content: center;
  white-space: normal;
}

#CandidateTest_DataTableView .ColumnTitle,
#CandidateTest_DataTableView .font_15 {
  font-size: 14px !important;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableRow {
  min-height: 40px;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell {
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 5px 8px !important;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell > div {
  min-width: 0;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(2),
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(3),
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(4) {
  justify-content: flex-start;
  text-align: left;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(9) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(10) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(11) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(12) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(13) > div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

#CandidateTest_DataTableView .job-candidate-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

#CandidateTest_DataTableView .job-candidate-actions-cell .btn,
#CandidateTest_DataTableView .job-candidate-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 1;
}

#CandidateTest_DataTableView .job-candidate-actions-cell svg,
#CandidateTest_DataTableView .job-candidate-action-btn svg {
  display: block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

#CandidateTest_DataTableView .job-candidate-hrms-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

#CandidateTest_DataTableView .job-candidate-hrms-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

#CandidateTest_DataTableView .job-candidate-hrms-sent {
  margin: 0 !important;
  min-width: 42px;
}

#CandidateTest_DataTableView .job-candidate-hrms-history {
  display: block;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: #333;
}

#CandidateTest_DataTableView .job-candidate-hrms-resend {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a5fa8;
  cursor: pointer;
}

#CandidateTest_DataTableView .job-candidate-hrms-resend:hover {
  color: #0c447c;
}

#CandidateTest_DataTableView .job-candidate-hrms-resend:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.candidate-modal .modal-content {
  border-radius: 16px;
  border: none;
}
.candidate-modal .modal-header {
  border-bottom: 1px solid #e9ecef;
}

.bg-light-subtle {
  background-color: #f8f9fa !important;
}

.candidate-modal .border {
  border-color: #dee2e6 !important;
}

.candidate-modal strong {
  /* min-width: 160px; */
  display: inline-block;
}

.candidate-modal .badge {
  font-size: 0.85rem;
  padding: 0.4em 0.8em;
  border-radius: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  /* padding: 20px; */
  border-radius: 8px;
  width: 400px;
  /* max-width: 90%; */
  border: 0px !important;
}
.modal-content h3 {
  margin-top: 0;
}
.modal-content textarea {
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.modal-buttons button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.modal-buttons button:first-child {
  background: #ccc;
}
.modal-buttons button:last-child {
  background: #3b82f6;
  color: white;
}

#ExistingCandidate_MultiSel .searchWrapper {
  display: flex;
  overflow-x: auto;
  padding: 0.1375rem 0.75rem !important;
  border-radius: 0.375rem !important;
  font-size: 0.875rem;
  height: 34px;
}

#ExistingCandidate_MultiSel .chip {
  position: absolute;
  left: 10px;
  cursor: pointer;
}

#ExistingCandidate_MultiSel input::placeholder {
  position: absolute;
  bottom: 1px;
  left: 0px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--secondary-black);
}

.JobTimeLineContainer {
  position: relative;
  border-left: 2px solid #1a87cb;
}

.JobTimeLineBlock {
  position: relative;
}

.JobTimeLineBlock::before {
  position: absolute;
  content: "";
  width: 20px;
  height: 20px;
  background-color: #1a87cb;
  border-radius: 50%;
}
.JobTimeLineBlock::after {
  position: absolute;
  top: 8px;
  /* right: 98%; */
  right: 97.7%;
  content: "";
  width: 18px;
  height: 2px;
  border: 2px solid #1a87cb;
}

.CandyTimeLine_ActionType,
.JobTimeLine_ActionType {
  font-weight: 600;
  font-size: 0.875rem;
}

.CandyTimeLine_CreaedBy,
.CandyTimeLine_ActionDateTime,
.JobTimeLine_CreaedBy,
.JobTimeLine_ActionDateTime {
  font-weight: 500;
  font-size: 0.75rem !important;
  color: #b1b0b0;
}

.CandyTimeLine_Actioned_By,
.JobTimeLine_Actioned_By {
  font-weight: 400;
  font-size: 0.75rem !important;
}

.TimeStamp {
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  background-color: #1a87cb;
  color: #fff;
}

#JobOrderTableView header {
  min-height: 1px;
}

.bg_blue {
  background-color: #1a87cb;
}
.skill-tag {
  background-color: #e9ecef;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  display: inline-block;
  margin-right: 0.5rem;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
  font-weight: 500;
}
.skill-box {
  border: 1px solid #dee2e6;
  padding: 0.9rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background-color: #fdfdfd;
}

input::-ms-reveal {
  display: none;
}
.section-title {
  color: #0e527d;
  font-weight: 600;
}
.calendar-container {
  height: 650px;
}
.calendar-cell {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
  padding: 3px;
  border-right: 1px solid #ddd;
}
.event-block {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 6px;
  border-radius: 4px;
  margin-top: 20px;
  height: 80px;
  overflow-y: auto;
}
.event-item {
  background: white;
  border: 1px solid #b6d4fe;
  padding: 4px;
  margin-bottom: 4px;
  border-radius: 3px;
}

.event-item div {
  font-size: 12px;
}
.event-join-link {
  font-size: 12px;
  color: #0d6efd;
}
.event-no-link {
  font-size: 11px;
  color: #888;
}

/* .event-more-btn {
  font-size: 11px !important;
  padding: 0 !important;
  text-decoration: underline;
} */
.event-box {
  max-height: 80px;
  overflow-y: auto;
}
.rbc-day-cell {
  padding: 4px;
}

.rbc-time-view .rbc-row {
  min-height: initial;
  height: 80px;
  overflow-y: visible;
}

/* Calendar container height */
.calendar-container {
  height: 80vh;
}

/* Enable scrolling in Week & Day view */
.rbc-time-view,
.rbc-time-content {
  overflow-y: auto !important;
}

/* Fix pointer events */
.calendar-cell,
.rbc-date-cell,
.rbc-event,
.rbc-timeslot-group,
.rbc-time-slot {
  pointer-events: auto !important;
}

.rbc-row-segment {
  display: block;
}

.outlook-calendar-page {
  background: #f4f7fb;
  min-height: calc(100vh - 80px);
}

.calendar-modern-page {
  padding: 20px 24px !important;
}

.calendar-hero {
  min-height: 106px;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
  margin-bottom: 16px;
}

.calendar-hero-actions {
  align-items: flex-end !important;
  flex-shrink: 0;
}

.calendar-hero-actions label {
  margin-bottom: 6px !important;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700 !important;
}

.calendar-hero-actions .form-select,
.calendar-hero-actions .ats-company-selector {
  height: 38px !important;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  color: #1f2937 !important;
  box-shadow: none !important;
}

.calendar-hero-actions > div {
  align-items: stretch !important;
}

.calendar-hero .agent-list-title {
  align-items: center;
}

.calendar-hero .agent-list-title h1 {
  margin-bottom: 2px;
}

.telephonic-tests-hero {
  align-items: flex-start;
  margin-bottom: 14px;
}

.telephonic-hero-actions {
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  min-width: 0;
  max-width: none;
}

.telephonic-tests-hero .telephonic-filter-bar {
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
}

.telephonic-tests-hero .telephonic-filter-group {
  min-width: 0;
}

.telephonic-tests-hero .telephonic-filter-group:first-child {
  flex: 0 1 170px;
}

.telephonic-tests-hero .telephonic-filter-group:nth-child(2) {
  flex: 1 1 200px;
}

.telephonic-tests-hero .job-order-filter-dropdown {
  min-width: 0;
}

.telephonic-tests-hero .job-order-filter-dropdown .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.telephonic-tests-hero .telephonic-filter-group label {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.telephonic-tests-hero .telephonic-filter-group .form-select,
.telephonic-tests-hero .telephonic-filter-group .form-control,
.telephonic-tests-hero .telephonic-filter-group .p-dropdown {
  height: 36px;
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.telephonic-tests-hero .telephonic-filter-search-wrap .form-control {
  padding-top: 0;
  padding-bottom: 0;
}

.telephonic-tests-hero .telephonic-filter-reset-btn {
  height: 36px;
  border-color: rgba(255, 255, 255, 0.5) !important;
  background: #ffffff !important;
  color: #334155 !important;
  border-radius: 8px !important;
}

.telephonic-date-error {
  margin: -6px 0 10px;
}

.outlook-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 46px 0 16px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #dbe5f1;
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.outlook-page-title {
  color: #0f4c81;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.outlook-page-subtitle {
  color: #64748b;
  font-size: 13px;
  margin: 4px 0 0;
}

.outlook-company-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  font-weight: 500;
}

.outlook-calendar-note {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 0 1 auto;
  max-width: 620px;
  margin-left: auto;
  padding: 9px 12px;
  color: #315b7d;
  font-size: 12px;
  line-height: 1.4;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #cfe0f2;
  border-left: 3px solid #1a5fa8;
  border-radius: 7px;
}

.outlook-calendar-note svg {
  flex: 0 0 auto;
  color: #1a5fa8;
  font-size: 14px;
}

.outlook-calendar-note strong {
  color: #0f4c81;
  font-weight: 700;
}

.outlook-calendar-container {
  background: #fff;
  border: 1px solid #dbe5f1;
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}

.calendar-list-table {
  table-layout: fixed;
}

.calendar-list-table th:nth-child(1),
.calendar-list-table td:nth-child(1) { width: 11%; }
.calendar-list-table th:nth-child(2),
.calendar-list-table td:nth-child(2) { width: 10%; }
.calendar-list-table th:nth-child(3),
.calendar-list-table td:nth-child(3) { width: 9%; }
.calendar-list-table th:nth-child(4),
.calendar-list-table td:nth-child(4) { width: 18%; }
.calendar-list-table th:nth-child(5),
.calendar-list-table td:nth-child(5) { width: 11%; }
.calendar-list-table th:nth-child(6),
.calendar-list-table td:nth-child(6) { width: 11%; }
.calendar-list-table th:nth-child(7),
.calendar-list-table td:nth-child(7) { width: 12%; }
.calendar-list-table th:nth-child(8),
.calendar-list-table td:nth-child(8) { width: 9%; }
.calendar-list-table th:nth-child(9),
.calendar-list-table td:nth-child(9) { width: 9%; }

.calendar-list-table th,
.calendar-list-table td {
  min-width: 0 !important;
  max-width: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.calendar-list-table td:nth-child(9) {
  overflow: visible;
  white-space: nowrap;
  padding-left: 6px;
  padding-right: 6px;
}

.calendar-archive-table {
  width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

.calendar-archive-table th:nth-child(1),
.calendar-archive-table td:nth-child(1) { width: 10%; }
.calendar-archive-table th:nth-child(2),
.calendar-archive-table td:nth-child(2) { width: 18%; }
.calendar-archive-table th:nth-child(3),
.calendar-archive-table td:nth-child(3) { width: 10%; }
.calendar-archive-table th:nth-child(4),
.calendar-archive-table td:nth-child(4) { width: 10%; }
.calendar-archive-table th:nth-child(5),
.calendar-archive-table td:nth-child(5) { width: 10%; }
.calendar-archive-table th:nth-child(6),
.calendar-archive-table td:nth-child(6) { width: 10%; }
.calendar-archive-table th:nth-child(7),
.calendar-archive-table td:nth-child(7) { width: 12%; }
.calendar-archive-table th:nth-child(8),
.calendar-archive-table td:nth-child(8) { width: 8%; }
.calendar-archive-table th:nth-child(9),
.calendar-archive-table td:nth-child(9) { width: 12%; }

.calendar-archive-table th,
.calendar-archive-table td {
  min-width: 0 !important;
  max-width: none;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: middle;
}

.calendar-archive-table th {
  white-space: normal !important;
  line-height: 1.25;
}

.calendar-archive-table th:first-child,
.calendar-archive-table td:first-child {
  padding-left: 16px !important;
  text-align: left !important;
}

.outlook-calendar-page {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.outlook-calendar-page .outlook-calendar-container {
  max-width: 100%;
  overflow-x: hidden;
}

.calendar-archive-table th:nth-child(9),
.calendar-archive-table td:nth-child(9) {
  min-width: 0 !important;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: normal !important;
}

.calendar-archive-table .archive-reason {
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  line-height: 1.45;
  white-space: normal;
}

.calendar-archive-table .archive-reason span {
  display: block;
  max-width: 100%;
  overflow-wrap: anywhere;
  white-space: normal;
}

.calendar-archive-job-cell {
  display: block;
  width: 100%;
  overflow: hidden;
  line-height: 1.45;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.outlook-calendar-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 12px;
  padding: 0 0 14px;
}

.outlook-calendar-title {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.outlook-calendar-title-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.outlook-calendar-title-main {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
}

.outlook-calendar-title-sub {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.outlook-calendar-nav,
.outlook-calendar-views {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.outlook-calendar-nav button,
.outlook-calendar-views button {
  height: 34px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #0f172a;
  border-radius: 6px;
  padding: 0 12px;
  font-weight: 600;
}

.outlook-calendar-nav button:hover,
.outlook-calendar-views button:hover,
.outlook-calendar-views button.active {
  background: #0f77b4;
  border-color: #0f77b4;
  color: #fff;
}

.outlook-calendar-nav button.today {
  color: #0f77b4;
  border-color: #93c5fd;
  background: #eff6ff;
}

.outlook-calendar-nav button.today:hover {
  color: #fff;
  background: #0f77b4;
}

.outlook-calendar-container .rbc-header {
  padding: 9px 6px;
  background: #f8fafc;
  color: #334155;
  font-weight: 700;
  border-color: #dbe5f1;
}

.outlook-calendar-container .rbc-month-view,
.outlook-calendar-container .rbc-time-view {
  border-color: #dbe5f1;
  border-radius: 8px;
  overflow: hidden;
}

.outlook-calendar-container .rbc-today {
  background: #eff6ff;
}

.outlook-calendar-container .rbc-event {
  cursor: pointer;
  margin: 1px 2px;
  width: calc(100% - 4px);
}

.outlook-calendar-container .rbc-month-row {
  overflow: visible;
}

.outlook-calendar-container .rbc-row-content {
  z-index: 2;
}

.outlook-calendar-container .rbc-date-cell {
  color: #0f172a;
  font-weight: 600;
  padding: 3px 6px 2px;
}

.outlook-calendar-container .rbc-month-view .rbc-day-bg,
.outlook-calendar-container .rbc-date-cell,
.outlook-calendar-container .rbc-time-slot,
.outlook-calendar-container .rbc-timeslot-group {
  cursor: pointer;
}

.outlook-calendar-event {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-height: 18px;
  padding: 1px 5px;
  background: #dbeafe;
  border: 1px solid #60a5fa;
  color: #0f172a;
  font-size: 11px;
  line-height: 1.25;
  white-space: normal;
  overflow: visible;
  overflow-wrap: anywhere;
}

.outlook-calendar-event:hover {
  background: #bfdbfe;
  border-color: #0f77b4;
}

.outlook-calendar-event.cancelled {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #475569;
}

.outlook-calendar-event-time {
  color: #075985;
  font-weight: 800;
  flex: 0 0 auto;
}

.outlook-calendar-event-text {
  min-width: 0;
  overflow: visible;
  overflow-wrap: anywhere;
}

.outlook-calendar-container .rbc-event,
.outlook-calendar-container .rbc-event-content {
  overflow: visible;
  white-space: normal;
}

.outlook-calendar-container .rbc-time-header .rbc-allday-cell {
  min-height: 28px;
  max-height: 48px;
}

.outlook-calendar-container .rbc-time-view .rbc-event-label {
  display: none;
}

.outlook-calendar-container .rbc-time-view .rbc-timeslot-group {
  min-height: 160px;
}

.outlook-calendar-container .rbc-time-view .rbc-event-content {
  height: 100%;
  min-height: 0;
}

.outlook-calendar-container .rbc-time-view .rbc-event,
.outlook-calendar-container .rbc-time-view .rbc-event-content {
  overflow: hidden;
}

.outlook-calendar-container .rbc-time-view .outlook-calendar-event {
  height: 100%;
  min-height: 0;
  flex-direction: row;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 4px;
  border-left: 3px solid #087f8c;
  background: #e4f3f2;
  font-size: 12px;
  line-height: 1.3;
  overflow: hidden;
}

.outlook-calendar-container .rbc-time-view .outlook-calendar-event.cancelled {
  background: #f1f3f5;
  border-left-color: #7b8794;
}

.outlook-calendar-container .rbc-time-view .outlook-calendar-event-text {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: break-word;
}

.outlook-calendar-container .rbc-time-view .outlook-calendar-event-time {
  font-weight: 600;
  font-size: 11px;
}

.calendar-interviews-table-scroll {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden !important;
}

.calendar-event-actions {
  min-width: 112px;
  white-space: nowrap;
}

.calendar-event-actions > button {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.calendar-interviews-table {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  table-layout: fixed !important;
}

.calendar-interviews-table th,
.calendar-interviews-table td {
  width: auto !important;
  min-width: 0 !important;
  max-width: 0;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: top;
  overflow: hidden;
}

.calendar-interviews-table td > * {
  max-width: 100%;
}

.calendar-interviews-table td span {
  white-space: normal !important;
  overflow-wrap: anywhere;
}

.outlook-calendar-container .rbc-today .rbc-date-cell {
  background: #0f77b4;
  color: #fff;
}

.calendar-interview-details-dialog.modal-dialog {
  width: calc(100vw - 32px);
  max-width: 1800px;
  margin-left: auto;
  margin-right: auto;
}

.calendar-interview-details-dialog .calendar-interviews-table-scroll {
  overflow-x: auto !important;
}

.calendar-interview-details-dialog .calendar-interviews-table {
  min-width: 1400px !important;
  table-layout: auto !important;
}

.calendar-interview-details-dialog .calendar-interviews-table th,
.calendar-interview-details-dialog .calendar-interviews-table td {
  max-width: none;
  white-space: nowrap !important;
  overflow-wrap: normal;
  word-break: normal;
  overflow: visible;
  padding: 12px 14px;
}

.calendar-interview-details-dialog .calendar-interviews-table td span {
  white-space: nowrap !important;
  overflow-wrap: normal;
}

.calendar-interview-details-dialog .calendar-interviews-table td:last-child > div {
  flex-wrap: nowrap !important;
}

.outlook-agenda-card {
  border: 1px solid #dbe5f1 !important;
  border-radius: 10px !important;
}

.outlook-agenda-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.outlook-summary-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #dbe5f1;
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.outlook-summary-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #e0f2fe;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.outlook-summary-icon.video {
  background: #dcfce7;
  color: #15803d;
}

.outlook-summary-icon.priority {
  background: #fee2e2;
  color: #dc2626;
}

.outlook-summary-value {
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
}

.outlook-summary-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  margin-top: 4px;
}

.outlook-agenda-card .p-datatable-thead > tr > th {
  background: #f8fafc;
  color: #334155;
  font-weight: 700;
  border-color: #dbe5f1;
}

.outlook-agenda-card .p-datatable-tbody > tr > td {
  vertical-align: middle;
  border-color: #e2e8f0;
}

.outlook-join-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
}

#ScreeningConfigTab .p-tabview-nav {
  display: none;
}

#CreateJobOrderTabs .p-tabview-nav {
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  margin-bottom: 4px !important;
}

#CreateJobOrderTabs .job-tab-header {
  align-items: center;
  display: inline-flex;
  gap: 7px;
  white-space: nowrap;
}

#CreateJobOrderTabs .job-tab-header .pi {
  font-size: 13px;
}

#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link,
#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  align-items: center;
  background: #ffffff !important;
  background-image: none !important;
  border: 1px solid #d8d8d8 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  color: #171717 !important;
  margin: 0 0 0 0 !important;
  padding: 10px 14px !important;
}

#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link:hover,
#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link:hover {
  background: #f8fafc !important;
  border-color: #bfc8d0 !important;
  color: #171717 !important;
}

#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link span,
#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link span {
  color: #171717 !important;
}

#CreateJobOrderTabs .p-tabview-nav li.p-highlight:not(:first-child) .p-tabview-nav-link {
  background: #0e527d !important;
  background-image: linear-gradient(90deg, #0e527d, #1a87cb) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

#CreateJobOrderTabs .p-tabview-nav li.p-highlight:not(:first-child) .p-tabview-nav-link span {
  color: #ffffff !important;
}

#CreateJobOrderTabs .p-tabview-nav li:first-child .p-tabview-nav-link {
  background: #ffffff !important;
  background-image: none !important;
  border-color: #d8d8d8 !important;
  color: #171717 !important;
}

#CreateJobOrderTabs .p-tabview-nav li.screening-agent-tab-header {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.create-job-order-page {
  min-height: calc(100vh - 80px);
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
}

#CreateJobOrderTabs > .p-tabview-nav-container {
  position: sticky;
  top: 69px;
  z-index: 20;
  background: #fff;
  padding-top: 4px;
}

#CreateJobOrderTabs > .p-tabview-panels {
  overflow: visible;
  padding-top: 16px;
}

#SkillsAndQuestionsBlock .p-accordion-header-text {
  color: #1a87cb;
}

#AgentList_TableView {
  overflow-x: hidden;
}

#AgentList_TableView .rdt_TableWrapper,
#AgentList_TableView .rdt_Table,
#AgentList_TableView .rdt_TableHead,
#AgentList_TableView .rdt_TableBody {
  overflow-x: hidden !important;
}

#AgentList_TableView .rdt_Table,
#AgentList_TableView .rdt_TableHead,
#AgentList_TableView .rdt_TableBody,
#AgentList_TableView .rdt_TableRow {
  width: 100% !important;
}

#AgentList_TableView .rdt_TableCol,
#AgentList_TableView .rdt_TableCell {
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-left: 6px !important;
  padding-right: 6px !important;
  border-right: 1px solid #e0e0e0;
}

#AgentList_TableView .rdt_TableCol > div,
#AgentList_TableView .rdt_TableCell > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#AgentList_TableView .rdt_TableCol > div {
  justify-content: center !important;
  text-align: center !important;
}

#AgentList_TableView .rdt_TableCol .fs-6 {
  font-size: 14px !important;
  line-height: 1.15;
  white-space: normal;
  text-align: center;
}

#AgentList_TableView .rdt_TableCell span,
#AgentList_TableView .rdt_TableCell a {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#AgentList_TableView .rdt_Table,
#AgentList_TableView .rdt_TableBody {
  overflow-x: hidden !important;
}

#AgentList_TableView .rdt_TableHeadRow {
  min-height: 50px;
  border-bottom: 1px solid #d7dfe7;
}

#AgentList_TableView .rdt_TableRow {
  min-height: 48px;
  border-bottom: 1px solid #e6e6e6 !important;
}

#AgentList_TableView .rdt_TableCol:last-child,
#AgentList_TableView .rdt_TableCell:last-child {
  justify-content: center;
  text-align: center;
  border-right: 0;
}

#AgentList_TableView .rdt_TableCol:last-child > div,
#AgentList_TableView .rdt_TableCell:last-child > div {
  justify-content: center;
  text-align: center;
}

#AgentList_TableView .rdt_TableHeadRow .rdt_TableCol:nth-child(11),
#AgentList_TableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11) {
  justify-content: center !important;
  text-align: center !important;
}

#AgentList_TableView .rdt_TableHeadRow .rdt_TableCol:nth-child(11) > div,
#AgentList_TableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11) > div {
  justify-content: center !important;
  text-align: center !important;
}

#AgentList_TableView .rdt_Pagination {
  border-top: 1px solid #e6e6e6;
}

.agent-page {
  background: #f4f8fb;
}

.agent-list-hero,
.agent-create-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  margin-bottom: 16px;
  border: 1px solid #cfe1f1;
  border-radius: 12px;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);
  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);
}

.agent-list-title {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.agent-list-hero-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.agent-list-title h1 {
  margin: 0;
  color: #ffffff;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.15;
}

.agent-list-title p {
  margin: 3px 0 0;
  color: #dceef8;
  font-size: 13px;
  line-height: 1.4;
}

.agent-list-count-card {
  min-width: 132px;
  padding: 10px 13px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.agent-list-count-card span {
  display: block;
  color: #dceef8;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
}

.agent-list-count-card strong {
  display: block;
  margin-top: 4px;
  font-size: 21px;
  line-height: 1;
}

.agent-list-hero-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
}

.agent-list-hero-controls {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  min-width: 0;
}

.agent-list-hero-controls .agent-list-filter,
.agent-list-hero-controls .agent-list-search {
  min-width: 0;
}

.agent-list-hero-controls .agent-list-filter {
  width: 260px;
}

.agent-list-hero-controls .agent-list-search {
  width: 420px;
}

.agent-list-hero-controls .agent-list-filter label,
.agent-list-hero-controls .agent-list-search label {
  color: #ffffff;
}

.agent-list-hero-controls .agent-list-create-btn {
  justify-self: auto;
}

.agent-list-hero-actions .agent-list-count-card {
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 132px;
  white-space: nowrap;
}

.agent-list-hero-actions .agent-list-count-card span,
.agent-list-hero-actions .agent-list-count-card strong {
  margin: 0;
}

.candidate-outcome-page {
  background: #f4f8fb;
}

.candidate-outcome-hero {
  margin-bottom: 18px;
}

.candidate-outcome-hero-selected {
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);
}

.candidate-outcome-hero-rejected {
  background: linear-gradient(100deg, #0f4c81 0%, #7f1d1d 100%);
}

.candidate-outcome-hero-actions {
  display: flex;
  align-items: end;
  gap: 14px;
  flex-shrink: 0;
}

.candidate-outcome-company {
  min-width: 270px;
}

.candidate-outcome-job {
  min-width: 240px;
}

.candidate-outcome-company label {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.candidate-outcome-job label {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.candidate-outcome-company .form-select,
.candidate-outcome-company .p-dropdown,
.candidate-outcome-company select {
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.ats-company-selector.form-select,
.ats-company-selector {
  padding-right: 36px !important;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #ffffff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 12px 12px !important;
}

.candidate-outcome-job .p-dropdown {
  width: 100%;
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.candidate-outcome-job .p-dropdown-label {
  display: flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  color: #1f2937;
  font-size: 13px;
}

.candidate-outcome-hero .agent-list-count-card {
  width: 190px;
  min-width: 190px;
  min-height: 36px;
  align-self: center;
  height: 36px;
  padding: 6px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.candidate-outcome-hero .agent-list-count-card span {
  font-size: 10px;
  line-height: 1.1;
  white-space: nowrap;
  flex-shrink: 0;
}

.candidate-outcome-hero .agent-list-count-card strong {
  margin-top: 0;
  font-size: 18px;
  line-height: 1;
}

.candidate-all-hero-actions {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
}

.candidate-all-field label {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.candidate-all-company {
  width: 270px;
}

.candidate-all-company .form-select,
.candidate-all-company .p-dropdown,
.candidate-all-company select {
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.candidate-all-company .ats-company-selector.form-select {
  padding-right: 36px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 12px 12px !important;
}

.candidate-all-search {
  width: 310px;
}

.candidate-all-search .input-group {
  min-height: 36px;
}

.candidate-all-search .form-control {
  min-height: 36px;
  border-radius: 8px 0 0 8px;
  font-size: 13px;
}

.candidate-all-search .input-group-text {
  min-height: 36px;
  background: #ffffff !important;
}

.candidate-all-search .searchIconBtn {
  min-height: 36px;
  border-radius: 0 8px 8px 0;
}

.candidate-all-count-card {
  align-self: flex-end !important;
  margin-top: 0 !important;
}

.job-orders-toolbar {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 8px 10px;
}

.job-orders-header-field label {
  margin-bottom: 5px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.job-orders-company {
  width: 220px;
}

.job-orders-search {
  width: 280px;
}

.job-orders-search .input-group,
.job-orders-search .form-control,
.job-orders-search .input-group-text,
.job-orders-search .searchIconBtn {
  min-height: 36px;
}

.job-orders-total-card {
  min-height: 36px;
  min-width: 176px;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #cfe1f1;
  border-radius: 8px;
  background: #f1f7fc;
  color: #0f4c81;
}

.job-orders-total-card span {
  font-size: 10px;
  font-weight: 800;
  line-height: 1.1;
  text-transform: uppercase;
  white-space: nowrap;
}

.job-orders-total-card strong {
  font-size: 18px;
  line-height: 1;
}

.job-orders-create-btn {
  min-height: 36px;
  padding: 7px 14px;
  white-space: nowrap;
}

.job-orders-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0 8px 12px;
}

.job-orders-filter-bar > div {
  width: 190px;
}

.job-orders-filter-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 14px 16px;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);
  border: 1px solid #cfe1f1;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);
}

.job-orders-filter-left {
  width: 190px;
  flex: 0 0 190px;
}

.job-orders-filter-select.form-select {
  height: 38px;
  min-height: 38px;
  border: 1px solid #d1d9e6 !important;
  border-radius: 6px !important;
  background-color: #ffffff !important;
  color: #1f2937;
  font-size: 14px;
  box-shadow: none !important;
}

.job-orders-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 1 1 auto;
  min-width: 0;
}

.job-orders-company-inline {
  flex: 0 0 auto;
}

.job-orders-company-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.job-orders-company-control label {
  margin: 0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.job-orders-company-select {
  width: 170px;
}

.job-orders-company-select .ats-company-selector.form-select {
  height: 38px;
  min-height: 38px;
  border: 1px solid #d1d9e6 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.job-orders-search-inline {
  width: 220px;
  flex: 0 0 220px;
}

.job-orders-search-group {
  height: 38px;
  flex-wrap: nowrap;
}

.job-orders-search-input.form-control {
  height: 38px;
  min-height: 38px;
  border: 1px solid #d1d9e6 !important;
  border-right: 0 !important;
  border-radius: 6px 0 0 6px !important;
  font-size: 14px;
  box-shadow: none !important;
}

.job-orders-search-clear.input-group-text {
  height: 38px;
  border-color: #d1d9e6 !important;
  border-left: 0 !important;
  background: #ffffff !important;
}

.job-orders-search-btn {
  width: 42px;
  height: 38px;
  min-height: 38px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  border-radius: 0 6px 6px 0 !important;
  background: #0f6fa8 !important;
  color: #ffffff !important;
}

.job-orders-create-inline {
  height: 38px;
  min-height: 38px;
  padding: 0 16px !important;
  border-radius: 6px !important;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.job-candidate-filter-row .job-candidate-filter-controls {
  display: contents !important;
}

@media (min-width: 1200px) {
  body.vertical-collpsed .job-candidate-filter-row,
  body[data-sidebar-size="small"] .job-candidate-filter-row {
    flex: 0 1 auto !important;
  }
  body.vertical-collpsed .job-candidate-send-email,
  body[data-sidebar-size="small"] .job-candidate-send-email {
    order: 1 !important;
    flex-shrink: 0;
  }
}

.job-candidate-date-picker { width: 170px; flex: 0 0 170px; }
.job-website-applicant-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 11px;
  border: 1px solid #e4d38b;
  border-radius: 999px;
  background: #fff9df;
  color: #705619;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.job-website-applicant-count > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #80631e;
  color: #fff;
  font-size: 12px;
}
.job-website-applicant-count small { font-weight: 400; font-size: 11px; }
.job-candidate-date-picker .job-candidate-date-input {
  width: 100%;
  height: 34px;
  font-size: 12px;
  color: #1a5fa8;
  border: 1px solid #1a5fa8;
  background: #f8fbff;
}

.job-candidate-filter-row > div:first-child {
  min-width: 0;
  max-width: 100%;
}

.job-candidate-filter-controls > input,
.job-candidate-filter-controls > select {
  flex-shrink: 0;
  box-sizing: border-box;
  max-width: 100%;
}

.job-details-redesign {
  max-width: 960px;
  width: calc(100% - 32px);
}

.job-details-redesign .modal-content {
  border: 1px solid #dce2e7;
  border-radius: 8px;
  overflow: hidden;
}

.job-details-redesign .job-info-hero {
  background: #fff;
  color: #202b33;
  padding: 24px 28px;
  border-bottom: 1px solid #e3e7eb;
}

.job-details-redesign .job-info-kicker {
  color: #687580;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
}

.job-details-redesign .job-info-title {
  color: #202b33;
  font-size: 23px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.job-details-redesign .job-info-chips {
  gap: 8px 20px;
}

.job-details-redesign .job-info-chips span {
  background: none;
  border: 0;
  border-radius: 0;
  padding: 0;
  color: #53616b;
  font-size: 13px;
  font-weight: 400;
}

.job-details-redesign .job-details-content {
  padding: 0 28px 16px !important;
}

.job-details-redesign .job-details-facts {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 0 28px !important;
  margin-bottom: 0 !important;
}

.job-details-redesign .job-details-fact {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  border: 0 !important;
  border-bottom: 1px solid #e3e7eb !important;
  border-radius: 0 !important;
  padding: 16px 0 !important;
}

.job-details-redesign .job-details-fact > div:first-child {
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  margin: 0 !important;
}

.job-details-redesign .job-details-fact > div:last-child {
  white-space: normal !important;
  text-align: right;
  overflow-wrap: anywhere;
  font-weight: 600 !important;
}

.job-details-redesign .job-details-section {
  border: 0 !important;
  border-bottom: 1px solid #e3e7eb !important;
  border-radius: 0 !important;
  padding: 22px 0 !important;
  margin-bottom: 0 !important;
}

.job-details-redesign .job-details-section-title {
  color: #24343e !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  margin-bottom: 12px !important;
}

.job-details-redesign .job-details-skill {
  background: #eef5f2 !important;
  border: 1px solid #d8e7de !important;
  color: #315f4c !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
}

.job-details-redesign .job-details-rich-text {
  font-size: 14px !important;
  color: #45535d !important;
  line-height: 1.7 !important;
  overflow-wrap: anywhere;
}

.job-details-redesign .job-details-rich-text > :first-child {
  margin-top: 0;
}

.job-details-redesign .job-details-rich-text img,
.job-details-redesign .job-details-rich-text table {
  max-width: 100%;
}

.job-details-redesign .job-details-footer {
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 28px;
}

@media (max-width: 600px) {
  .job-details-redesign .job-details-facts {
    grid-template-columns: 1fr !important;
  }
  .job-details-redesign .job-info-hero {
    padding: 20px 16px;
  }
  .job-details-redesign .job-details-content {
    padding: 0 16px 12px !important;
  }
  .job-details-redesign .job-info-title {
    font-size: 20px;
  }
  .job-details-redesign .job-details-footer {
    padding: 12px 16px;
  }
}

.job-info-modal-header {
  min-height: 54px;
  padding: 14px 20px !important;
  border-bottom: 1px solid #dbe4f0 !important;
  background: #ffffff !important;
  color: #0f172a !important;
  font-size: 17px;
  font-weight: 800;
}

.job-info-modal-header .btn-close {
  width: 30px;
  height: 30px;
  padding: 0 !important;
  border-radius: 8px;
  background-color: #eef2f7;
  opacity: 0.9;
  background-size: 12px;
}

.job-info-modal-header .btn-close:hover {
  background-color: #dbeafe;
  opacity: 1;
}

.job-info-hero {
  padding: 18px 24px 20px;
  background: linear-gradient(105deg, #0f4c81 0%, #0f766e 100%);
  color: #ffffff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.job-info-kicker {
  margin-bottom: 7px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.job-info-title {
  margin: 0;
  color: #ffffff;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0;
}

.job-info-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 13px;
}

.job-info-chips span {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 10px;
  border: 1px solid rgba(255, 255, 255, 0.34);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

@media (max-width: 991px) {
  .job-orders-filter-strip,
  .job-orders-filter-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .job-orders-filter-left,
  .job-orders-company-inline,
  .job-orders-search-inline,
  .job-orders-company-select,
  .job-orders-create-inline {
    width: 100%;
    flex: 1 1 auto;
  }

  .job-orders-company-control {
    align-items: stretch;
    flex-direction: column;
    gap: 6px;
  }
}

.org-master-page {
  background: #f4f8fb;
}

.org-master-hero {
  margin-bottom: 16px;
}

.org-master-actions {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: nowrap;
  flex-shrink: 0;
  max-width: none;
}

.org-master-field {
  min-width: 190px;
}

.org-master-company {
  min-width: 210px;
}

.org-master-search {
  min-width: 220px;
}

.org-master-field label {
  display: block;
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.org-master-field .form-control,
.org-master-field .form-select,
.org-master-field .p-dropdown,
.org-master-field select {
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 13px;
}

.org-master-create-btn {
  min-height: 36px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 7px 13px !important;
  border: 1px solid rgba(255, 255, 255, 0.32) !important;
  border-radius: 8px !important;
  background: rgba(255, 255, 255, 0.16) !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  box-shadow: none !important;
  white-space: nowrap;
}

.org-master-create-btn:hover {
  background: rgba(255, 255, 255, 0.24) !important;
  border-color: rgba(255, 255, 255, 0.46) !important;
}

.org-master-hero .agent-list-count-card {
  width: 168px;
  min-width: 168px;
  min-height: 36px;
  height: 36px;
  padding: 6px 12px;
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.org-master-hero .agent-list-count-card span {
  font-size: 9px;
  line-height: 1.1;
  white-space: nowrap;
}

.org-master-hero .agent-list-count-card strong {
  margin-top: 0;
  font-size: 18px;
  line-height: 1;
}

@media (max-width: 992px) {
  .candidate-outcome-hero,
  .candidate-outcome-hero-actions {
    align-items: stretch;
  }

  .candidate-outcome-hero-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .candidate-outcome-company {
    flex: 1 1 260px;
  }

  .candidate-all-company,
  .candidate-all-search {
    flex: 1 1 260px;
    width: auto;
  }

  .job-orders-search,
  .job-orders-company {
    flex: 1 1 260px;
    width: auto;
  }

  .job-orders-filter-bar > div {
    flex: 1 1 190px;
    width: auto;
  }

  .org-master-hero,
  .org-master-actions {
    align-items: stretch;
  }

  .org-master-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .org-master-field {
    flex: 1 1 220px;
  }
}

.agent-list-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px 420px auto;
  align-items: end;
  gap: 14px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid #d6e2ee;
  border-left: 4px solid #0f766e;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.agent-list-toolbar::before {
  content: "";
  display: block;
}

.agent-list-filter label,
.agent-list-search label,
.agent-create-company label,
.agent-form-section .form-label {
  display: block;
  margin-bottom: 6px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.agent-list-search .form-control,
.agent-list-filter .form-select,
.agent-list-filter .p-dropdown,
.agent-create-company .form-select,
.agent-create-company .p-dropdown,
.agent-form-section .form-control,
.agent-form-section .form-select {
  min-height: 38px;
  border-color: #cbd5e1;
  border-radius: 7px;
  color: #0f172a;
  font-size: 14px;
}

.agent-list-search .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  border-color: #0f766e;
  background: #0f766e;
  color: #ffffff;
}

.agent-list-create-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  justify-self: end;
  min-height: 38px;
  min-width: 178px;
  padding: 0 18px !important;
  border-color: #0f4c81 !important;
  background: #0f4c81 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  white-space: nowrap;
}

.agent-list-table-card {
  overflow: hidden;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.agent-list-table-card .rdt_Table {
  table-layout: fixed;
}

.agent-list-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.agent-list-avatar {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid #bde6ff;
  border-radius: 50%;
  background: #e8f5ff;
  color: #075985;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.agent-list-main-name,
.agent-list-ellipsis,
.agent-list-link {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-list-main-name {
  font-weight: 800;
}

.agent-list-link {
  color: #075985;
  text-decoration: none;
}

.agent-list-link:hover {
  color: #0f4c81;
  text-decoration: underline;
}

.agent-list-time-pill,
.agent-list-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 76px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.agent-list-time-pill {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #075985;
}

.agent-list-status-active {
  border: 1px solid #86efac;
  background: #dcfce7;
  color: #15803d;
}

.agent-list-status-inactive {
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.agent-list-action {
  width: 31px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d7e3f0;
  border-radius: 7px;
  background: #ffffff;
  cursor: pointer;
}

.agent-list-action-edit {
  color: #0f766e;
}

.agent-list-action-delete {
  color: #dc2626;
}

.agent-list-action:hover {
  background: #edf7ff;
  border-color: #b7d8f4;
}

.agent-list-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 160px;
  color: #64748b;
  font-size: 14px;
  font-weight: 700;
}

.agent-create-hero-actions {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex: 0 0 auto;
}

.agent-create-company {
  width: 230px;
}

.agent-create-company label {
  color: #e7f3fb;
}

.agent-create-back-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  border-color: rgba(255, 255, 255, 0.42) !important;
  background: rgba(255, 255, 255, 0.14) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

.agent-form-shell {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agent-form-section {
  padding: 16px;
  border: 1px solid #d6e2ee;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.agent-form-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  color: #0f4c81;
  font-size: 14px;
  font-weight: 800;
}

.agent-template-textarea {
  resize: vertical;
  min-height: 220px;
  font-family: Consolas, "Courier New", monospace;
  font-size: 12px !important;
  line-height: 1.45;
}

.agent-voice-preview {
  width: 100%;
  margin-top: 10px;
}

.agent-form-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 8px 0 20px;
}

.agent-form-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 118px;
  min-height: 38px;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 991.98px) {
  .agent-list-hero,
  .agent-create-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .agent-list-toolbar {
    grid-template-columns: 1fr;
  }

  .agent-list-create-btn {
    width: 100%;
  }

  .agent-list-hero-actions,
  .agent-list-hero-controls {
    width: 100%;
    flex-wrap: wrap;
  }

  .agent-list-hero-controls .agent-list-filter,
  .agent-list-hero-controls .agent-list-search {
    width: 100%;
  }

  .agent-list-hero-actions .agent-list-count-card {
    width: 100%;
  }

  .agent-create-hero-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .agent-create-company {
    width: 100%;
  }
}

.candidate-bulk-stage-trigger.btn,
.candidate-bulk-stage-trigger.btn:hover,
.candidate-bulk-stage-trigger.btn:focus,
.candidate-bulk-stage-trigger.btn:active {
  min-width: 158px;
  height: 34px;
  padding: 6px 12px;
  border: 1px solid #1a5fa8;
  background: #1a5fa8;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  transform: none;
  animation: none;
  transition: none;
}

.candidate-bulk-stage-trigger.btn:focus-visible {
  outline: 2px solid #1a5fa8;
  outline-offset: 2px;
}

.settings-option-grid {
  row-gap: 16px;
}

.settings-page-shell {
  margin-top: 40px;
  margin-bottom: 40px;
}

.settings-page-loader {
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #0f4c81;
  font-size: 14px;
  font-weight: 600;
  background: #ffffff;
  border: 1px solid #dbe5f1;
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.settings-page-loader .spinner-border {
  width: 1.35rem;
  height: 1.35rem;
  border-width: 0.18em;
}

.settings-success-modal .modal-header {
  position: relative;
  justify-content: center;
  text-align: center;
}

.settings-success-modal .modal-header .modal-title {
  width: 100%;
  margin: 0;
  text-align: center;
}

.settings-success-modal .modal-header .btn-close {
  position: absolute;
  right: 1rem;
}

.roles-form-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding-bottom: 4px;
}

.roles-form-actions .p-button {
  min-width: 110px;
  justify-content: center;
}

.link-contacts-select__value-container,
.interviewer-select__value-container {
  flex-wrap: nowrap !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  scrollbar-width: none;
}

.link-contacts-select__value-container::-webkit-scrollbar,
.interviewer-select__value-container::-webkit-scrollbar {
  display: none;
}

.link-contacts-select__multi-value,
.interviewer-select__multi-value {
  flex: 0 0 auto;
  max-width: none;
}

.link-contacts-select__multi-value__label,
.interviewer-select__multi-value__label {
  overflow: visible;
  white-space: nowrap;
}

.roles-permission-dialog .p-dialog-content {
  overflow-x: hidden;
  overflow-y: auto;
}

.role-permission-grid {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.role-permission-item {
  width: auto !important;
  max-width: none !important;
  min-width: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.role-permission-item > .mb-3 {
  height: auto;
  margin-bottom: 0 !important;
  padding: 0 !important;
  background: #ffffff;
  border: 1px solid #d7e2ec !important;
  border-radius: 9px !important;
  box-shadow: 0 3px 10px rgba(20, 58, 90, 0.06);
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.role-permission-item > .role-permission-card:hover {
  border-color: #9fc4df !important;
  box-shadow: 0 7px 16px rgba(20, 58, 90, 0.11);
  transform: translateY(-1px);
}

.role-permission-item .mt-3 {
  margin-top: 0 !important;
}

.role-permission-card > .row > div {
  width: 100%;
}

.role-permission-card-title {
  display: flex !important;
  align-items: center;
  min-height: 44px;
  padding: 11px 14px;
  color: #16496b;
  font-weight: 700;
  background: #f2f8fc;
  border-bottom: 1px solid #dceaf3;
}

.role-permission-card-title .form-check-input {
  margin: 0 7px 0 0;
}

.role-permission-children-wrap {
  display: block !important;
  margin: 0 !important;
  padding: 12px 14px 14px;
}

.role-permission-children {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 14px;
  min-width: 0;
  margin: 0 0 0 18px !important;
}

.role-permission-child {
  min-width: 0;
  margin-top: 0 !important;
}

.role-permission-child label,
.role-permission-item > .mb-3 > .row label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  min-width: 0;
  line-height: 1.35;
  white-space: normal;
}

.role-permission-child .ms-2,
.role-permission-item > .mb-3 > .row .ms-2 {
  margin-left: 0 !important;
}

@media (max-width: 1200px) {
  .role-permission-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .role-permission-grid {
    grid-template-columns: 1fr;
  }

  .role-permission-children {
    grid-template-columns: 1fr;
  }
}

.interview-email-audit {
  flex: 0 0 245px;
  padding: 9px 12px;
  border-left: 3px solid #d8e8f6;
  border-radius: 0 6px 6px 0;
  background: #f7fbff;
  color: #6b7a90;
  font-size: 11px;
  line-height: 1.6;
}

.interview-email-audit strong {
  color: #263442;
  font-weight: 600;
}

@media (max-width: 720px) {
  .interview-email-setting-row {
    align-items: flex-start !important;
    flex-wrap: wrap;
    gap: 12px !important;
  }

  .interview-email-setting-copy {
    flex: 1 1 100%;
  }

  .interview-email-audit {
    flex: 1 1 100%;
    width: 100%;
    border-left: 0;
    border-top: 3px solid #d8e8f6;
    border-radius: 0 0 6px 6px;
  }
}

.settings-page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding: 18px 20px;
  border: 1px solid #cfe1f1;
  border-radius: 12px;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);
  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);
}

.settings-page-header-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 20px;
}

.settings-page-header h1 {
  margin: 0;
  color: #ffffff;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.15;
}

.settings-page-header p {
  margin: 3px 0 0;
  color: #dceef8;
  font-size: 13px;
  line-height: 1.4;
}

.settings-option-card {
  min-height: 82px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border: 1px solid #d7dfe7;
  border-radius: 8px;
  background: #fff;
  color: #10263f;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(16, 38, 63, 0.05);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.settings-option-card:hover {
  border-color: #0d6efd;
  box-shadow: 0 6px 16px rgba(16, 38, 63, 0.1);
  transform: translateY(-1px);
}

.settings-option-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eaf4ff;
  color: #0b6fb3;
  border: 1px solid #cbe4fb;
  flex: 0 0 auto;
}

.settings-option-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
}

#CalendarScheduled_TableView {
  overflow-x: hidden;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

#CalendarScheduled_TableView::after,
#CalendarScheduled_TableView::before {
  display: none !important;
  content: none !important;
}

#CalendarScheduled_TableView .p-datatable-wrapper {
  overflow-x: hidden !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

#CalendarScheduled_TableView .p-datatable-table {
  width: 100% !important;
  table-layout: fixed;
}

#CalendarScheduled_TableView .p-datatable-thead > tr > th,
#CalendarScheduled_TableView .p-datatable-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 8px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

#CalendarScheduled_TableView .p-datatable-tbody > tr > td {
  height: 76px;
}

#CalendarScheduled_TableView .p-datatable-tbody > tr > td * {
  max-width: 100%;
}

#CalendarScheduled_TableView .p-paginator-bottom {
  border: 0 !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
  box-shadow: none;
}

#CalendarScheduled_TableView .p-datatable,
#CalendarScheduled_TableView .p-datatable-wrapper,
#CalendarScheduled_TableView .p-datatable-scrollable-wrapper,
#CalendarScheduled_TableView .p-datatable-scrollable-view,
#CalendarScheduled_TableView .p-datatable-scrollable-body,
#CalendarScheduled_TableView .p-datatable-footer,
#CalendarScheduled_TableView .p-paginator,
#CalendarScheduled_TableView .p-datatable .p-paginator-bottom {
  border: 0 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

#CalendarScheduled_TableView .icons-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
/* Remove hover background */
.p-dropdown:not(.p-disabled):hover {
  box-shadow: none !important;
  border-color: #ced4da !important;
}

/* Remove blue focus outline */
.p-dropdown:focus,
.p-dropdown:focus-visible,
.p-dropdown.p-focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #ced4da !important;
}
.p-multiselect .p-multiselect-label {
  transition: none;
}
.p-dropdown-label.p-inputtext.p-placeholder:hover {
  border-color: inherit !important;
  box-shadow: none !important;
  cursor: pointer !important;
}
.p-dropdown-label.p-inputtext.p-placeholder {
  color: black !important ;
}
.p-dropdown:not(.p-disabled):hover .p-dropdown-label.p-inputtext.p-placeholder {
  color: white !important;
}

/* Default icon color = black */
.p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon {
  color: black !important;
}

/* On hover of the dropdown, icon color = white */
.p-dropdown:not(.p-disabled):hover
  .p-dropdown-trigger
  .p-dropdown-trigger-icon {
  color: white !important;
}

.job-access-section .job-access-toolbar { align-items: center; margin-bottom: 16px; }
.job-question-workspace { row-gap: 16px; }
.job-questions-empty-state {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px;
  text-align: center;
  border: 1px dashed #c9d9df;
  border-radius: 10px;
  background: linear-gradient(180deg, #fbfefe 0%, #f1f8f7 100%);
}
.job-questions-empty-art {
  position: relative;
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin-bottom: 14px;
  border-radius: 20px;
  background: #e3f2ef;
  color: #197666;
  font-size: 26px;
  box-shadow: 0 8px 18px rgba(25, 118, 102, 0.12);
}
.job-questions-empty-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #62b6a6;
}
.job-questions-empty-dot-one { top: 10px; right: 12px; }
.job-questions-empty-dot-two { bottom: 12px; left: 10px; background: #f0b35b; }
.job-questions-empty-state h6 {
  margin: 0 0 6px;
  color: #203b47;
  font-size: 15px;
  font-weight: 700;
}
.job-questions-empty-state p {
  max-width: 310px;
  margin: 0;
  color: #71858d;
  font-size: 12px;
  line-height: 1.55;
}
.job-round-config-table { width: 100%; max-width: none; margin: 20px 0; border: 1px solid #dce5eb; border-radius: 6px; overflow: hidden; }
.job-skill-config-grid { border: 1px solid #cddbe4; border-radius: 6px; overflow-x: auto; }
.job-skill-grid-header, .job-skill-grid-row { gap: 0 !important; padding: 0 !important; margin: 0 !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; min-width: 1100px; }
.job-skill-grid-header { background: #eef4f7 !important; }
.job-skill-grid-row { border-top: 1px solid #dce5eb !important; }
.job-skill-grid-row:nth-child(odd) { background: #f9fbfc !important; }
.job-skill-grid-header > div, .job-skill-grid-row > div { padding: 14px 12px; border-right: 1px solid #dce5eb; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 0; }
.job-skill-grid-header > div:last-child, .job-skill-grid-row > div:last-child { border-right: 0; }
.job-skill-grid-header > div { font-size: 12px !important; letter-spacing: 0 !important; }
.job-skill-grid-row .p-inputtext { width: 100%; min-width: 0; font-size: 13px; }
.job-skill-grid-row .p-inputnumber { width: 100%; }
.job-skill-rating-scale { display: flex; justify-content: space-between; align-items: baseline; width: 140px; max-width: 100%; color: #82929d; font-size: 10px; }
.job-skill-rating-scale strong { color: #294b5b; font-size: 16px; font-weight: 600; }
.job-skill-rating-scale small { color: #82929d; font-size: 11px; font-weight: 400; }
.job-skill-rating .p-slider { height: 6px; border-radius: 4px; background: #e0e8ed; margin: 8px 0 10px; max-width: 100%; }
.job-skill-rating .p-slider-range { background: #168575; border-radius: 4px; }
.job-skill-rating .p-slider-handle { width: 20px; height: 20px; margin-top: -10px; border: 2px solid #168575; background: #fff; box-shadow: 0 1px 4px rgba(29, 64, 75, .15); }
.job-skill-rating > span { border-radius: 4px !important; padding: 4px 10px !important; font-size: 11px !important; }
.job-skill-grid-row > .job-skill-rating { display: grid !important; grid-template-columns: auto auto; grid-template-rows: auto auto; justify-content: center; align-content: center; gap: 14px 16px !important; }
.job-skill-rating .job-skill-rating-scale { grid-column: 1; grid-row: 1; width: auto; justify-content: flex-start !important; }
.job-skill-rating-scale strong { font-size: 15px; }
.job-skill-rating .job-skill-proficiency { grid-column: 2; grid-row: 1; font-size: 11px !important; font-weight: 500 !important; padding: 3px 7px !important; border: 1px solid transparent; }
.job-skill-rating .job-skill-proficiency.beginner { color: #336b9a !important; background: #edf4fd !important; border-color: #d6e5f5; }
.job-skill-rating .job-skill-proficiency.intermediate { color: #876620 !important; background: #fff5dc !important; border-color: #ede0b6; }
.job-skill-rating .job-skill-proficiency.advanced { color: #327252 !important; background: #e8f6ee !important; border-color: #cde7d8; }
.job-skill-rating .p-slider { grid-column: 1 / -1; grid-row: 2; width: 100% !important; height: 4px; margin: 0 0 4px; }
.job-skill-rating .p-slider-handle { width: 16px; height: 16px; margin-top: -8px; box-shadow: none; }
.job-skill-duration { display: inline-flex; align-items: center; justify-content: center; gap: 6px; color: #345d72; }
.job-skill-duration .pi { font-size: 15px; color: #5f8b9f; }
.job-skill-duration strong { font-size: 18px; font-weight: 600; }
.job-skill-duration > span { font-size: 12px; font-weight: 400; }
.job-skill-duration-time { font-size: 11px !important; font-variant-numeric: tabular-nums; margin-top: 3px; }
.job-skill-ratio { gap: 5px !important; width: 145px; max-width: 100%; }
.job-skill-ratio > span { display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 12px; color: #516976; }
.job-skill-ratio strong { display: grid; place-items: center; min-width: 25px; height: 22px; border-radius: 4px; font-size: 11px; }
.job-skill-ratio .beginner strong { background: #edf4fd; color: #336b9a; }
.job-skill-ratio .intermediate strong { background: #fff5dc; color: #927029; }
.job-skill-ratio .advanced strong { background: #e8f6ee; color: #327252; }
.job-skill-config-grid .job-skill-grid-footer { margin: 0 !important; padding: 12px 16px !important; border-top: 1px solid #cddbe4; background: #f4f8fa; min-height: 52px; }
.job-skill-grid-footer > span { background: #eaf3f8 !important; border-color: #c7dbe6 !important; color: #235c77 !important; }
.job-round-config-table .rdt_TableHeadRow { background: #eef4f7 !important; min-height: 48px; }
.job-round-config-table .rdt_TableCol { justify-content: center !important; color: #395665; font-size: 13px; font-weight: 600; }
.job-round-config-table .rdt_TableCell { justify-content: center !important; padding: 10px 16px; }
.job-round-config-table .rdt_TableCell:first-child { justify-content: center !important; }
.job-round-config-table .rdt_TableCell:first-child .form-check { width: 200px; max-width: 100%; display: flex; align-items: center; gap: 8px; padding: 0; margin: 0; }
.job-round-config-table .rdt_TableCell:first-child .form-check-input { float: none; margin: 0; flex: 0 0 17px; }
.job-round-config-table .rdt_TableCell:first-child .form-check-label { margin: 0; text-align: left; }
.job-round-config-table .rdt_TableRow:nth-child(even) { background: #f9fbfc; }
.job-round-config-table input:not([type="checkbox"]) { text-align: center; height: 38px; max-width: 180px; border-color: #cedbe3; border-radius: 4px; font-size: 14px; }
.job-round-config-table input[type="checkbox"] { width: 17px; height: 17px; accent-color: #147d70; }
#CreateJobOrderTabs { scroll-margin-top: 90px; }
.job-generation-dialog .modal-body { padding: 28px 24px; }
.job-generation-dialog .modal-content { border-radius: 8px; overflow: hidden; }
.job-generation-dialog .p-progress-spinner { width: 52px; height: 52px; }
.job-screening-categories { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px; align-items: start; }
.job-recruiter-selection .p-multiselect-label { display: flex; align-items: center; flex-wrap: nowrap; gap: 6px; min-width: 0; overflow: hidden; padding: 8px 10px; white-space: nowrap; }
.job-recruiter-selection .p-multiselect-token { flex: 0 1 auto; min-width: 0; background: #eaf4f2; color: #246454; border: 1px solid #cbe2db; border-radius: 4px; padding: 5px 8px; margin: 0; font-size: 13px; }
.job-recruiter-selected-name { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.job-recruiter-chip { display: inline-flex; align-items: center; gap: 7px; min-width: 0; max-width: 180px; overflow: hidden; background: #edf5f3; border: 1px solid #c9e0d9; border-radius: 4px; padding: 5px 7px 5px 9px; color: #285f51; font-size: 13px; line-height: 1.4; }
.job-recruiter-chip > .pi { font-size: 12px; flex-shrink: 0; color: #548777; }
.job-recruiter-chip-remove { display: inline-grid; place-items: center; width: 22px; height: 22px; flex-shrink: 0; padding: 0; border: 0; border-radius: 3px; background: transparent; color: #548777; }
.job-recruiter-chip-remove:hover { background: #d9eae4; color: #214d42; }
.job-recruiter-chip-remove .pi { font-size: 10px; }
.lookup-add-option {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 40px;
  padding: 9px 12px;
  border-top: 1px solid #d7e5ef;
  background: #ffffff;
  color: #0b6eaa;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 -2px 6px rgba(18, 61, 91, 0.08);
}
.lookup-add-option:hover { background: #edf7fc; color: #095985; }
.lookup-add-option .pi { font-size: 12px; }
.job-recruiter-selection .p-multiselect-token-icon { margin-left: 8px; width: 14px; height: 14px; }
.job-candidate-heading-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.job-screening-reviewed-note { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; color: #26705c; background: #edf8f3; border: 1px solid #cfe7dc; border-radius: 4px; padding: 8px 10px; }
.job-screening-automation-toolbar { justify-content: flex-end; align-items: center; gap: 12px; margin-bottom: 8px !important; }
.job-screening-automation-toolbar > .job-screening-header-title { width: auto !important; flex: 1 1 !important; min-width: 0; margin-right: auto; }
.job-screening-header-title .job-question-heading { margin: 0; }
.job-screening-automation-toolbar { flex-wrap: nowrap !important; }
.job-screening-automation-toolbar .job-screening-automation-control { display: flex; align-items: center; justify-content: flex-end; gap: 16px; width: auto; max-width: 100%; flex: 0 0 auto; padding: 10px 16px; }
.job-screening-automation-control > label { margin: 0 !important; font-size: 15px; flex: 0 0 auto !important; width: max-content !important; min-width: 175px; max-width: none !important; white-space: nowrap; overflow: visible !important; text-overflow: clip !important; }
.job-screening-automation-control > .d-flex { margin: 0 !important; flex: 0 0 auto; }
.job-screening-automation-control .form-switch { display: flex; align-items: center; gap: 10px; padding: 0 !important; min-height: 28px; margin: 0; }
.job-screening-automation-control .form-check-input { float: none !important; margin: 0 !important; position: static !important; flex: 0 0 48px !important; width: 48px !important; }
.job-screening-automation-control .form-check-label { margin: 0 !important; }
.job-screening-percentage-control {
  display: flex;
  flex: 0 0 230px;
  flex-direction: column;
  gap: 6px;
  width: 230px;
  max-width: 230px;
  padding: 0 !important;
}
.job-screening-percentage-control .form-label {
  margin: 0 !important;
  color: #31586d;
  font-size: 13px;
  line-height: 1.2;
}
.job-screening-percentage-control .form-control {
  min-height: 40px;
  border: 1px solid #c7d8e3;
  border-radius: 8px;
  padding: 8px 12px;
  color: #173f63;
  background: #ffffff;
}
.job-screening-percentage-control .form-control:focus {
  border-color: #1765a5;
  box-shadow: 0 0 0 3px rgba(23, 101, 165, .12);
}
@media (max-width: 600px) { .job-screening-automation-toolbar .job-screening-automation-control { flex-wrap: wrap; } }
.job-details-form-workspace .form-label,
.job-details-form-workspace input.form-control,
.job-details-form-workspace select.form-control,
.job-details-form-workspace textarea.form-control,
.job-details-form-workspace .p-dropdown-label,
.job-details-form-workspace .p-multiselect-label,
.job-screening-question textarea,
.job-question-level textarea { font-size: 15px !important; }
.job-question-heading { font-size: 18px !important; }
.job-screening-category > h6,
.job-question-level h6,
.job-question-workspace .p-accordion-header-link { font-size: 15px !important; }
.job-screening-actions .p-button,
.job-question-actions .p-button,
.job-details-form-actions .btn,
.job-details-form-toolbar .btn { font-size: 14px !important; }
.job-screening-actions, .job-details-form-actions { align-items: center; flex-wrap: wrap; gap: 10px !important; padding: 20px 0 8px; border-top: 0; }
.job-screening-actions .p-button, .job-screening-actions .btn,
.job-details-form-actions .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; margin: 0 !important; height: 40px !important; min-height: 40px; padding: 8px 16px !important; border-radius: 4px !important; font-size: 13px; }
.job-screening-actions .job-screening-action {
  min-height: 42px;
  height: 42px !important;
  padding: 10px 17px !important;
  border-radius: 9px !important;
  border: 1px solid transparent !important;
  font-size: 13px !important;
  font-weight: 600;
  letter-spacing: 0;
  box-shadow: 0 2px 5px rgba(18, 61, 91, 0.12);
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.job-screening-actions .job-screening-action:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(18, 61, 91, 0.18);
}
.job-screening-actions .job-screening-action:focus-visible {
  outline: 3px solid rgba(31, 126, 190, 0.22);
  outline-offset: 2px;
}
.job-screening-actions .job-screening-action .p-button-icon { font-size: 14px; }
.job-screening-actions .job-screening-back-button {
  color: #12649b !important;
  background: #ffffff !important;
  border-color: #8db9d5 !important;
}
.job-screening-actions .job-screening-back-button:hover:not(:disabled) {
  color: #0d4f7c !important;
  background: #edf7fc !important;
  border-color: #5d9fc8 !important;
}
.job-screening-actions .job-screening-save-button {
  color: #ffffff !important;
  background: #3b8f3b !important;
  border-color: #3b8f3b !important;
}
.job-screening-actions .job-screening-save-button:hover:not(:disabled) {
  background: #2e7530 !important;
  border-color: #2e7530 !important;
}
.job-screening-actions .job-screening-download-button {
  color: #ffffff !important;
  background: #137eaa !important;
  border-color: #137eaa !important;
}
.job-screening-actions .job-screening-download-button:hover:not(:disabled) {
  background: #0e6388 !important;
  border-color: #0e6388 !important;
}
.job-screening-actions .job-screening-view-button {
  color: #ffffff !important;
  background: #6451b5 !important;
  border-color: #6451b5 !important;
}
.job-screening-actions .job-screening-view-button:hover:not(:disabled) {
  background: #4f3f95 !important;
  border-color: #4f3f95 !important;
}
.job-details-form-workspace .job-website-posting-choice { margin: 8px 0 2px !important; padding: 0 !important; }
.job-website-posting-choice .card-body { padding: 2px 0 !important; }
.job-website-posting-choice .card { margin-bottom: 0 !important; min-height: 0; }
.job-details-form-workspace .job-details-form-actions { padding: 4px 0 !important; margin-top: 0 !important; margin-bottom: 4px !important; }
.job-details-form-toolbar { padding: 12px 0 20px; margin-bottom: 20px !important; border-bottom: 0; }
.job-details-form-toolbar { width: auto !important; }
.job-details-form-toolbar > div { align-items: center !important; justify-content: flex-start !important; flex-wrap: wrap; gap: 10px; width: auto !important; padding-left: 0 !important; padding-right: 0 !important; }
@media (min-width: 1500px) {
  #CreateJobOrderTabs { position: relative; }
  #CreateJobOrderTabs > .p-tabview-nav-container { display: flex; align-items: center; gap: 16px; min-height: 54px; }
  #CreateJobOrderTabs > .p-tabview-nav-container > .p-tabview-nav-content { flex: 1 1; min-width: 0; }
  #CreateJobOrderTabs > .p-tabview-nav-container .p-tabview-nav { flex-wrap: nowrap; }
  #CreateJobOrderTabs > .p-tabview-nav-container .p-tabview-nav-link { padding: 10px 12px; font-size: 13px; white-space: nowrap; }
  #CreateJobOrderTabs .job-details-form-toolbar {
    position: static;
    flex: 0 0 auto;
    width: auto;
    padding: 0;
    margin: 0 !important;
    min-height: 44px;
  }
  #CreateJobOrderTabs .job-details-form-toolbar > div { padding: 0; flex-wrap: nowrap; }
  #CreateJobOrderTabs .job-details-company-control { flex-wrap: nowrap; gap: 8px; }
  #CreateJobOrderTabs .job-details-company-control > div { width: 150px !important; }
  #CreateJobOrderTabs .job-details-form-toolbar > div { gap: 8px; }
  #CreateJobOrderTabs .job-details-company-control label { white-space: nowrap; }
}
.job-details-company-control { align-items: flex-start; flex-direction: column; flex-wrap: nowrap; gap: 4px; }
.job-details-form-toolbar .job-details-company-control,
.job-details-form-toolbar .btn { align-self: center; }
.job-details-company-control label { margin: 0 !important; font-size: 13px; font-weight: 500; color: #526a79; }
.job-details-company-control .job-company-selector-label { margin: 0 !important; color: #526a79; font-size: 12px; font-weight: 600; line-height: 1.2; }
.job-details-form-toolbar .btn { margin: 0 !important; border-radius: 4px; font-size: 13px; }
.job-details-form-workspace .form-label { color: #4c6372; font-size: 12px; font-weight: 600 !important; margin-bottom: 7px !important; }
.job-edit-mode-note { padding: 12px 16px; margin-bottom: 18px; background: #edf6fb; border: 1px solid #c9dfea; border-left: 3px solid #257ea5; border-radius: 4px; font-size: 13px; line-height: 1.5; }
.job-edit-mode-note .text-muted { color: #285c75 !important; font-weight: 500 !important; }
.job-edit-mode-note:empty { display: none; }
#CreateJobOrderTabs .p-tabview-panel.job-details-form-workspace { padding-top: 18px !important; }
.job-details-form-workspace input.form-control,
.job-details-form-workspace select.form-control,
.job-details-form-workspace .p-dropdown,
.job-details-form-workspace .p-multiselect { min-height: 38px; border-color: #cedbe3; border-radius: 4px; font-size: 13px; background: #fff; }
.job-details-form-workspace textarea.form-control { border-color: #cedbe3; border-radius: 4px; font-size: 13px; line-height: 1.6; }
.job-details-form-workspace .form-control:focus { border-color: #368d9b; box-shadow: 0 0 0 3px rgba(54, 141, 155, .12); }
.job-details-form-workspace .sun-editor { border: 1px solid #cedbe3; border-radius: 6px; overflow: hidden; }
.job-details-form-workspace .sun-editor .se-toolbar { background: #f5f8fa; outline: none; border-bottom: 1px solid #dce5eb; }
.job-details-form-workspace .sun-editor .se-btn { border-radius: 4px; }
.job-details-form-workspace .sun-editor .sun-editor-editable { padding: 18px 20px; font-family: Arial, sans-serif !important; font-size: 15px !important; line-height: 1.65 !important; color: #283d49; }
.job-details-form-workspace .sun-editor .sun-editor-editable p { margin: 0 0 12px; }
.job-details-form-workspace .sun-editor .sun-editor-editable h1,
.job-details-form-workspace .sun-editor .sun-editor-editable h2 { font-size: 20px; line-height: 1.4; margin: 16px 0 10px; }
.job-details-form-workspace .sun-editor .sun-editor-editable h3 { font-size: 17px; margin: 14px 0 8px; }
.job-details-form-workspace .sun-editor .sun-editor-editable li { margin-bottom: 8px; }
.job-details-form-workspace fieldset > .row { row-gap: 20px !important; }
.job-screening-workspace {
  padding: 18px 18px 26px;
  background: #f6fafc;
  border: 1px solid #dce8ee;
  border-radius: 10px;
}
.job-screening-automation-toolbar {
  align-items: center;
  margin: 0 0 22px !important;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #d9e6ed;
  border-radius: 9px;
  box-shadow: 0 3px 10px rgba(27, 71, 96, .06);
}
.job-screening-header-title .job-question-heading {
  margin: 0;
  color: #16496b;
}
.job-screening-automation-control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.job-screening-automation-control .form-label {
  margin: 0 !important;
  color: #31586d;
  font-size: 13px;
}
.job-screening-automation-control .form-switch {
  padding-left: 2.8rem !important;
}
.job-screening-automation-control .form-check-input {
  width: 2.45rem;
  height: 1.3rem;
  margin-top: 0;
  border-color: #b8cbd7;
  cursor: pointer;
}
.job-screening-automation-control .form-check-input:checked {
  background-color: #167b70;
  border-color: #167b70;
}
.job-screening-category { padding: 18px; border: 1px solid #dce5eb !important; border-radius: 6px; background: #fff; min-width: 0; }
.job-screening-category { border-radius: 10px; box-shadow: 0 3px 12px rgba(27, 71, 96, .06); }
.job-screening-category > h6 { font-size: 14px; font-weight: 600; color: #304c5b; margin: 0 0 16px; padding-bottom: 12px; border-bottom: 1px solid #e5ebef; }
.job-screening-category > h6 { display: flex; align-items: center; justify-content: space-between; gap: 12px; color: #16496b; }
.job-screening-number { display: grid; place-items: center; flex: 0 0 24px; height: 24px; margin-top: 10px; background: #edf3f6; color: #657c89; border-radius: 4px; font-size: 11px; }
.job-screening-question { margin-bottom: 12px !important; }
.job-screening-question textarea { min-height: 78px; font-size: 13px; line-height: 1.6; padding: 12px 14px; border-color: #cbdce6; border-radius: 8px; background: #fbfdff; resize: vertical; transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease; }
.job-screening-question textarea:hover { border-color: #83abc2; background: #ffffff; }
.job-screening-question textarea:focus { border-color: #1765a5; background: #ffffff; box-shadow: 0 0 0 3px rgba(23, 101, 165, .11); outline: none; }
.job-screening-question .job-screening-delete { width: 32px; min-width: 32px; height: 32px; padding: 0; margin-top: 6px; background: #fff2f2 !important; color: #bf4850 !important; border: 1px solid #efd6d8 !important; border-radius: 4px; box-shadow: none; }
.job-screening-question .job-screening-delete:hover { background: #ffe2e3 !important; border-color: #e8aeb2 !important; transform: translateY(-1px); }
.job-screening-category > .p-button,
.job-screening-category .question-add-button { min-height: 38px; font-size: 13px; border-radius: 8px !important; padding: 8px 14px; background: #0b6eaa !important; border-color: #0b6eaa !important; box-shadow: 0 2px 5px rgba(11, 110, 170, .16); }
.job-screening-category > .p-button:hover,
.job-screening-category .question-add-button:hover { background: #095985 !important; border-color: #095985 !important; box-shadow: 0 4px 8px rgba(11, 110, 170, .22); }
@media (max-width: 900px) { .job-screening-categories { grid-template-columns: 1fr; } }
.job-question-level { padding: 0 0 18px; margin-bottom: 18px; border-bottom: 1px solid #e1e8ed; }
.job-question-level:last-child { border: 0; margin-bottom: 0; padding-bottom: 0; }
.job-question-level h6 { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #405d6b; margin-bottom: 12px; }
.job-question-level h6 span { padding: 2px 7px; background: #edf3f6; border-radius: 4px; font-size: 11px; }
.job-question-heading { display: flex; align-items: center; gap: 10px; margin: 0 0 16px; font-size: 16px; font-weight: 600; color: #273f4c; }
.job-question-heading .pi { display: grid; place-items: center; width: 32px; height: 32px; border-radius: 6px; background: #eaf4f2; color: #197666; font-size: 15px; }
.job-question-workspace .p-accordion-header-link { min-height: 48px; padding: 12px 16px !important; background: #f8fafc !important; color: #304958 !important; border: 1px solid #dce5eb !important; border-radius: 4px !important; box-shadow: none !important; font-size: 13px; font-weight: 500; }
.job-question-workspace .p-accordion-header-link:hover { background: #eef5f7 !important; border-color: #b9ced7 !important; }
.job-question-workspace .p-accordion-header.p-highlight .p-accordion-header-link { background: #eaf4f2 !important; color: #166b5d !important; }
.job-question-workspace .p-accordion-header-text { flex: 1 1; min-width: 0; }
.job-question-category { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; }
.job-question-count { display: grid; place-items: center; min-width: 26px; height: 24px; padding: 0 7px; border-radius: 4px; background: #e4edf2; color: #466171; font-size: 12px; }
.job-question-workspace .p-accordion-content { border-color: #dce5eb; padding: 16px; background: #fff; }
.job-question-workspace .shadow-sm { box-shadow: none !important; }
.job-question-actions { align-items: center; flex-wrap: wrap; padding: 20px 0 8px; border-top: 0; }
.job-question-actions .p-button, .job-question-actions .btn { margin: 0 !important; min-height: 40px; border-radius: 4px !important; padding: 8px 16px !important; font-size: 13px; }
.job-question-workspace .question-add-button,
.job-question-workspace .question-ai-button {
  min-height: 40px;
  border-radius: 8px !important;
  padding: 9px 16px !important;
  font-weight: 600;
  box-shadow: 0 2px 5px rgba(18, 55, 86, .14);
  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}
.job-question-workspace .question-add-button {
  background: #0b6eaa !important;
  border-color: #0b6eaa !important;
}
.job-question-workspace .question-add-button:hover {
  background: #095985 !important;
  border-color: #095985 !important;
  box-shadow: 0 4px 9px rgba(11, 110, 170, .24);
  transform: translateY(-1px);
}
.job-question-workspace .question-ai-button {
  background: #6b4cc2 !important;
  border-color: #6b4cc2 !important;
}
.job-question-workspace .question-ai-button:hover {
  background: #5438a1 !important;
  border-color: #5438a1 !important;
  box-shadow: 0 4px 9px rgba(107, 76, 194, .24);
  transform: translateY(-1px);
}
.job-question-workspace .job-question-textarea {
  min-height: 64px;
  border: 1px solid #cddbe7 !important;
  border-radius: 8px !important;
  background: #fbfdff !important;
  color: #203b52;
  font-size: 14px;
  line-height: 1.5;
  padding: 12px 14px !important;
  resize: vertical;
  box-shadow: inset 0 1px 2px rgba(19, 55, 82, .04);
  transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;
}
.job-question-workspace .job-question-textarea:hover {
  border-color: #8db6d2 !important;
  background: #ffffff !important;
}
.job-question-workspace .job-question-textarea:focus {
  border-color: #0b6eaa !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(11, 110, 170, .12) !important;
  outline: none;
}
.job-order-selector {
  width: 240px;
  min-width: 240px;
}
.job-order-selector .job-order-tab-select__control:hover {
  border-color: #74a9cb !important;
}
.job-order-selector .job-order-tab-select__control--is-focused {
  border-color: #1765a5 !important;
  box-shadow: 0 0 0 3px rgba(23, 101, 165, .12) !important;
}
.job-order-selector .job-order-tab-select__menu {
  border: 1px solid #cbddea;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(20, 58, 90, .16);
  overflow: hidden;
}
.job-access-heading { display: flex; align-items: center; gap: 10px; margin: 0; font-size: 18px; font-weight: 600; color: #263b48; }
.job-access-heading .pi { display: grid; place-items: center; width: 36px; height: 36px; background: #e8f4f1; color: #167562; border-radius: 6px; font-size: 18px; }
.job-access-section .card { border: 1px solid #dce5eb; border-radius: 6px; padding: 0; box-shadow: none; overflow: hidden; }
.job-access-employee { display: flex; align-items: center; gap: 10px; min-width: 0; width: 100%; }
.job-access-avatar { display: grid; place-items: center; width: 30px; height: 30px; flex: 0 0 30px; border: 1px solid #cbe2db; background: #eef7f3; color: #28634f; border-radius: 50%; font-size: 11px; font-weight: 600; }
.job-access-name { min-width: 0; overflow: visible; text-overflow: clip; white-space: normal; overflow-wrap: anywhere; line-height: 1.5; padding: 8px 0; font-size: 13px; color: #293d49; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableHeadRow { background: #eef3f7 !important; min-height: 48px; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableCol { color: #486171; font-size: 12px; font-weight: 600; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableCol,
.job-access-section #AccessPrivileges_UserTable .rdt_TableCol_Sortable { justify-content: center !important; text-align: center !important; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableCol_Sortable > div { white-space: normal !important; overflow: visible !important; text-overflow: clip !important; text-align: center; line-height: 1.4; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableRow { min-height: 48px; border-bottom: 1px solid #e5ebef; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableRow:nth-child(even) { background: #f9fbfc; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableRow:hover { background: #eef7f5; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableCell:not(:first-child) { justify-content: center; }
.job-access-section #AccessPrivileges_UserTable .rdt_TableCell:first-child { justify-content: flex-start; }
.job-access-section #AccessPrivileges_UserTable input[type="checkbox"] { width: 18px !important; height: 18px !important; accent-color: #147d70; cursor: pointer; }
.job-access-section #AccessPrivileges_UserTable input[type="checkbox"]:disabled { cursor: not-allowed; opacity: .5; }
@media (max-width: 600px) { .job-access-toolbar > div:last-child { margin-top: 12px; } }

#AccessPrivileges_UserTable .rdt_TableCell input[type="checkbox"] {
  margin: 0 auto;
  display: block;
}
#AccessPrivileges_UserTable .rdt_TableCol_Sortable {
  text-align: center;
}

#AccessPrivileges_UserTable .sc-jwIPbr,
#AccessPrivileges_UserTable .bAhklE {
  text-align: center;
}

#AccessPrivileges_UserTable .rdt_TableCol_Sortable .rdt_TableSortLabel {
  display: inline-block;
  margin: 0 auto;
}

#RoleDropdown div svg,
#RoleDropdown div,
#RoleDropdown span {
  color: #000;
  background: #e0e0ea !important;
}

#SubTypeDropdown div svg,
#SubTypeDropdown span,
#PriorityDropdown div svg,
#PriorityDropdown span {
  color: #000 !important;
}
/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  border: 2px solid red;
} */
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(10),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(10),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(12),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1) {
  /* border: 2px solid red; */
  justify-content: center;
  border-right: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {
  border-left: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(5),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {
  border-top: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6) {
  border-right: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {
  border-left: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {
  border-right: 1px solid #e0e0e0;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  text-align: center;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* padding-left: 20px; */
}

/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{
  border: 2px solid blue;
} */

#UserManagement_TableView .p-dropdown:not(.p-disabled):hover,
#UserManagement_TableView .p-dropdown:not(.p-disabled):hover {
  background-color: transparent !important;
  color: #000;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown span,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown span,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span,
#LookupCustomize .p-paginator-bottom .p-dropdown span,
#JobDatatable .p-paginator-bottom .p-dropdown span,
#RolesList .p-paginator-bottom .p-dropdown span,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown span,
#RecruiterReports_TableView .p-paginator-bottom .p-dropdown span,
#JobTableView .p-paginator-bottom .p-dropdown span,
#CandidateInfo .p-paginator-bottom .p-dropdown span,
#ArchiveReasonTableView .p-paginator-bottom .p-dropdown span,
#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown span,
#PlacementReportTable .p-paginator-bottom .p-dropdown span,
#UserManagement_TableView .p-paginator-bottom .p-dropdown span {
  background-color: white;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown div,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown div,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown div,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown div,
#LookupCustomize .p-paginator-bottom .p-dropdown div,
#RolesList .p-paginator-bottom .p-dropdown div,
#JobDatatable .p-paginator-bottom .p-dropdown div,
#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown div,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown div,
#PlacementReportTable .p-paginator-bottom .p-dropdown div,
#JobTableView .p-paginator-bottom .p-dropdown div,
#CandidateInfo .p-paginator-bottom .p-dropdown div,
#ArchiveReasonTableView .p-paginator-bottom .p-dropdown div,
#RecruiterReports_TableView .p-paginator-bottom .p-dropdown div,
#UserManagement_TableView .p-paginator-bottom .p-dropdown div {
  border: 1px solid #ddd;
  background-color: white;
  color: black;
  border-radius: 2px;
}

#All_Employees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#AllEmployees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#ActiveJobSummaryReport .p-paginator-bottom div .p-dropdown-trigger svg,
#RecruiterPerformanceReport .p-paginator-bottom div .p-dropdown-trigger svg,
#LookupCustomize .p-paginator-bottom div .p-dropdown-trigger svg,
#RolesList .p-paginator-bottom div .p-dropdown-trigger svg,
#JobDatatable .p-paginator-bottom div .p-dropdown-trigger svg,
#JobTableView .p-paginator-bottom div .p-dropdown-trigger svg,
#MyPlaceMentReportTable .p-paginator-bottom div .p-dropdown-trigger svg,
#PlacementReportTable .p-paginator-bottom div .p-dropdown-trigger svg,
#RecruiterReports_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#AllCandidates_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#UserManagement_TableView .p-paginator-bottom div .p-dropdown-trigger svg {
  color: black !important;
  background-color: white;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown span:hover,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown span:hover,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span:hover,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span:hover,
#LookupCustomize .p-paginator-bottom .p-dropdown span:hover,
#RolesList .p-paginator-bottom .p-dropdown span:hover,
#JobDatatable .p-paginator-bottom .p-dropdown span:hover,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown span:hover,
#UserManagement_TableView .p-paginator-bottom .p-dropdown span:hover {
  background-color: white;
  color: black;
}

.contacts-active-shell {
  padding: 0;
}

.contacts-active-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  margin-bottom: 14px;
  border: 1px solid #cfe1f1;
  border-radius: 12px;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);
  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);
}

.contacts-active-title {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.contacts-active-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 20px;
}

.contacts-active-heading {
  margin: 0;
  color: #ffffff;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.15;
}

.contacts-active-title p {
  margin: 3px 0 0;
  color: #dceef8;
  font-size: 13px;
  line-height: 1.4;
}

.contacts-active-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

@media (max-width: 1200px) {
  .telephonic-tests-hero .telephonic-filter-bar {
    flex-wrap: wrap;
  }
}

.contacts-active-controls {
  width: auto;
  gap: 10px;
}

.contacts-active-controls .contacts-search-filter {
  width: 320px;
}

.contacts-active-controls .contacts-company-filter label {
  color: #dceef8;
}

.contacts-active-controls .contacts-company-select {
  width: 240px;
}

.contacts-active-stat {
  min-width: 148px;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
  margin-top: 18px;
}

.contacts-active-stat span {
  display: inline;
  color: #dceef8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.2;
}

.contacts-active-stat strong {
  display: inline;
  margin-top: 0;
  font-size: 20px;
  line-height: 1;
}

.contacts-active-stat-selected {
  border-color: rgba(251, 191, 36, 0.42);
}

.contacts-toolbar-card {
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid #d6e2ee;
  border-left: 4px solid #0f766e;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.contacts-toolbar-card .contacts-header-actions {
  justify-content: flex-end;
}

.contacts-header-box .row {
  row-gap: 12px;
}

.contacts-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  width: 100%;
}

.contacts-company-filter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
}

.contacts-company-filter label {
  margin: 0;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.contacts-company-select {
  width: 240px;
}

.contacts-company-control,
.contacts-search-input,
.contacts-search-btn {
  height: 38px;
}

.contacts-company-control {
  font-size: 14px;
}

.contacts-search-filter {
  width: min(420px, 100%);
  align-self: flex-end;
}

.contacts-search-group {
  flex-wrap: nowrap;
  border-radius: 8px;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
}

.contacts-search-input {
  min-width: 0;
  font-size: 14px !important;
  border-color: #cbd5e1;
}

.contacts-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  padding: 0;
  border-color: #0f766e !important;
  background: #0f766e !important;
  color: #ffffff !important;
}

.contacts-table-card {
  overflow: hidden;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.contacts-table-card .rdt_TableCell,
.contacts-table-card .rdt_TableCol {
  min-width: 0;
}

.contacts-table-card .rdt_Pagination select {
  min-height: 30px;
}

.table-cell-ellipsis {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contacts-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.contacts-status-active {
  border-color: #86efac;
  background: #dcfce7;
  color: #15803d;
}

.contacts-status-inactive,
.contacts-status-in-active {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.contacts-status-dnd-do-not-disturb,
.contacts-status-blacklisted {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.contacts-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 160px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .contacts-active-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .contacts-active-meta {
    width: 100%;
    flex-wrap: wrap;
  }

  .contacts-header-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .contacts-company-select,
  .contacts-search-filter {
    width: 100%;
  }

  .contacts-active-meta {
    width: 100%;
    align-items: stretch;
    flex-wrap: wrap;
  }

  .contacts-active-stat {
    margin-top: 0;
  }

  .contacts-active-controls {
    width: 100%;
  }

  .contacts-active-controls .contacts-search-filter,
  .contacts-active-controls .contacts-company-select {
    width: 100%;
  }
}

.roles-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 14px;
}

.roles-header-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

.roles-company-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 200px;
}

.roles-company-filter label {
  margin: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.roles-company-control,
.roles-add-action .p-button {
  height: 38px;
}

.roles-company-control {
  font-size: 14px;
}

.roles-add-action .p-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 767.98px) {
  .roles-header-row,
  .roles-header-actions {
    align-items: flex-start;
    flex-direction: column;
  }
}

.user-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 14px;
}

.user-header-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

.user-company-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 200px;
}

.user-company-filter label {
  margin: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.user-company-control,
.user-search-input,
.user-search-btn {
  height: 38px;
}

.user-company-control {
  font-size: 14px;
}

.user-search-filter {
  width: 260px;
}

.user-search-group {
  flex-wrap: nowrap;
}

.user-search-input {
  min-width: 0;
  font-size: 14px !important;
}

.user-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  padding: 0;
}

.admin-user-hero {
  margin-bottom: 18px;
}

.admin-user-page-shell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.admin-user-content-shell {
  padding: 0 10px;
}

.admin-user-hero-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.admin-user-company {
  width: 240px;
}

.admin-user-company .ats-company-selector.form-select {
  padding-right: 36px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 12px 12px !important;
}

.admin-user-search-filter {
  width: 300px;
}

.admin-user-search-filter label,
.admin-user-company label {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.admin-user-search-filter .user-search-group {
  height: 38px;
  flex-wrap: nowrap;
}

.admin-user-search-filter .user-search-input {
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.38) !important;
  border-right: 0 !important;
  border-radius: 8px 0 0 8px !important;
  box-shadow: none !important;
}

.admin-user-search-filter .input-group-text {
  height: 38px;
  border-color: rgba(255, 255, 255, 0.38) !important;
  border-left: 0 !important;
  background: #ffffff !important;
}

.admin-user-search-filter .user-search-btn {
  height: 38px;
  width: 42px;
  border: 1px solid #0f6fa8 !important;
  border-radius: 0 8px 8px 0 !important;
  background: #0f6fa8 !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

.admin-user-count-card {
  align-self: flex-end !important;
  margin-top: 0 !important;
}

#UserManagement_TableView {
  overflow: hidden;
  border: 1px solid #dfe7ef;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

#UserManagement_TableView .p-datatable-wrapper {
  border-radius: 10px 10px 0 0;
}

#UserManagement_TableView .p-datatable-thead > tr > th {
  padding: 12px 16px !important;
  border-color: #dfe7ef !important;
  background: #f8fafc !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  text-align: left !important;
}

#UserManagement_TableView .p-datatable-tbody > tr > td {
  padding: 9px 16px !important;
  border-color: #e5eaf0 !important;
  color: #24364b;
  font-size: 13px;
  text-align: left !important;
  vertical-align: middle;
}

#UserManagement_TableView .p-datatable-thead > tr > th:nth-child(3),
#UserManagement_TableView .p-datatable-thead > tr > th:nth-child(4),
#UserManagement_TableView .p-datatable-tbody > tr > td:nth-child(3),
#UserManagement_TableView .p-datatable-tbody > tr > td:nth-child(4),
#UserManagement_TableView .admin-user-role-pill,
#UserManagement_TableView .admin-user-date-cell {
  font-size: 12px !important;
}

#UserManagement_TableView .p-datatable-thead > tr > th:first-child,
#UserManagement_TableView .p-datatable-tbody > tr > td:first-child {
  text-align: center !important;
}

#UserManagement_TableView .p-datatable-thead > tr > th:first-child .p-column-header-content {
  justify-content: center;
}

#UserManagement_TableView .p-datatable-tbody > tr:hover {
  background: #f8fbff;
}

#UserManagement_TableView .p-paginator {
  padding: 10px 12px !important;
  border-top: 1px solid #e5eaf0 !important;
  background: #ffffff !important;
}

.admin-user-name-cell {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 280px;
  max-width: 100%;
  margin-inline: auto;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.admin-user-avatar {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  border: 1px solid;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.admin-user-name-text {
  min-width: 0;
  text-align: left;
  overflow: hidden;
  color: #0758a8;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-user-role-pill {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef6ff;
  color: #0f4c81;
  font-size: 12px;
  font-weight: 700;
}

.admin-user-date-cell {
  color: #475569;
  font-weight: 600;
}

.admin-user-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.admin-user-details-btn.p-button {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  border: 1px solid #b9e1df !important;
  border-radius: 8px !important;
  background: #ecfdfb !important;
  color: #0f766e !important;
  box-shadow: none !important;
}

.admin-user-details-btn.p-button:hover {
  background: #d5f5f1 !important;
  border-color: #7dd3ca !important;
}

.admin-user-edit-btn.p-button {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 8px !important;
  background: #f1f5f9 !important;
  color: #0f4c81 !important;
  box-shadow: none !important;
}

.admin-user-edit-btn.p-button:hover {
  background: #e0f2fe !important;
  border-color: #bae6fd !important;
}

.admin-user-edit-form {
  margin: 0 0 14px;
  padding: 14px 16px;
  border: 1px solid #dfe7ef;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.admin-user-edit-form .field {
  margin-bottom: 12px !important;
}

.admin-user-edit-form label {
  margin-bottom: 6px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.admin-user-hero .text-danger,
.admin-role-hero .text-danger,
.admin-user-edit-form label .text-danger {
  background: transparent !important;
  background-color: transparent !important;
  color: #dc2626 !important;
  box-shadow: none !important;
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline !important;
}

.admin-user-edit-form .p-inputtext,
.admin-user-edit-form .p-dropdown {
  min-height: 38px;
  border: 1px solid #cfd8e3 !important;
  border-radius: 7px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.admin-user-edit-form .admin-user-role-dropdown .p-dropdown-label {
  display: flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.admin-role-hero {
  margin-bottom: 18px;
}

.admin-role-hero-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.admin-role-company {
  width: 240px;
}

.admin-role-company .ats-company-selector.form-select {
  padding-right: 36px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 12px 12px !important;
}

.admin-role-hero .roles-add-action .p-button {
  min-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.32) !important;
  border-radius: 8px !important;
  background: #0f6fa8 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.admin-role-count-card {
  align-self: flex-end !important;
  margin-top: 0 !important;
}

.usermanagement-tab--header-tabs-hidden > .p-tabview-nav-container {
  display: none;
}

.usermanagement-tab--header-tabs-hidden > .p-tabview-panels {
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
}

.admin-user-section-tabs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.12);
}

.admin-user-hero-actions .admin-user-section-tabs,
.admin-role-hero-actions .admin-user-section-tabs {
  align-self: flex-end;
  margin-top: 0;
}

.admin-user-section-tab {
  min-width: 74px;
  min-height: 32px;
  padding: 6px 14px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

.admin-user-section-tab.active {
  border-color: rgba(255, 255, 255, 0.36);
  background: #ffffff;
  color: #0f4c81;
}

.roles-header-row .admin-user-section-tabs {
  margin-top: 8px;
  border-color: #d9e4ef;
  background: #f3f6fb;
}

.roles-header-row .admin-user-section-tab {
  color: #0f4c81;
}

.roles-header-row .admin-user-section-tab.active {
  border-color: #0f6fa8;
  background: #0f6fa8;
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .user-header-row,
  .user-header-actions,
  .admin-user-hero,
  .admin-user-hero-actions,
  .admin-role-hero,
  .admin-role-hero-actions {
    align-items: flex-start;
    flex-direction: column;
  }

  .admin-user-hero-actions,
  .admin-user-company,
  .admin-user-search-filter,
  .admin-role-hero-actions,
  .admin-role-company {
    width: 100%;
  }
}

#CandidateFinishTable table thead tr th:nth-child(5) {
  text-align: center;
}

#CandidateFinishTable table tbody tr td:nth-child(5) {
  text-align: center;
}
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  font-size: 0.85rem;
}



#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#AllCandidates_TableView table tr td:nth-child(7),
#AllCandidates_TableView table tr td:nth-child(6),
#AllCandidates_TableView table tr td:nth-child(5),
#AllCandidates_TableView table tr td:nth-child(4),
#AllCandidates_TableView table tr td:nth-child(3),
#AllCandidates_TableView table tr td:nth-child(2),
#AllCandidates_TableView table tr td:nth-child(1) {
  width: 150px !important;
}

.JobCreateBy_AllCandidates,
.JobName_AllCandidates,
.JobEmail_AllCandidates,
.JobTitle_AllCandidates {
  width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#CandidateList_CardView #AllCandidates_TableView .p-datatable-wrapper {
  overflow-x: hidden !important;
}

#CandidateList_CardView #AllCandidates_TableView table {
  width: 100% !important;
  table-layout: fixed;
}

#AllCandidates_TableView table tr th:nth-child(1),
#AllCandidates_TableView table tr td:nth-child(1) {
  width: 44px !important;
  min-width: 56px !important;
  max-width: 44px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  text-align: center !important;
}

#AllCandidates_TableView table tr th:nth-child(6),
#AllCandidates_TableView table tr td:nth-child(6) {
  width: 230px !important;
  min-width: 230px !important;
}

#AllCandidates_TableView table tr th:nth-child(2),
#AllCandidates_TableView table tr td:nth-child(2) {
  width: 200px !important;
  min-width: 200px !important;
}

#AllCandidates_TableView table tr th:nth-child(3),
#AllCandidates_TableView table tr td:nth-child(3) {
  width: 185px !important;
  min-width: 185px !important;
}

#AllCandidates_TableView table tr th:nth-child(4),
#AllCandidates_TableView table tr td:nth-child(4) {
  width: 145px !important;
  min-width: 145px !important;
}

#AllCandidates_TableView table tr th:nth-child(5),
#AllCandidates_TableView table tr td:nth-child(5) {
  width: 95px !important;
  min-width: 95px !important;
}

#AllCandidates_TableView table tr th:nth-child(8),
#AllCandidates_TableView table tr td:nth-child(8) {
  width: 190px !important;
  min-width: 190px !important;
}

#AllCandidates_TableView table tr th:nth-child(9),
#AllCandidates_TableView table tr td:nth-child(9) {
  width: 155px !important;
  min-width: 155px !important;
}

#CandidateList_CardView .JobName_AllCandidates,
#CandidateList_CardView .JobTitle_AllCandidates,
#CandidateList_CardView .JobCreateBy_AllCandidates {
  width: auto !important;
  max-width: 100%;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

#CandidateList_CardView .JobName_AllCandidates {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .JobName_AllCandidates > span:first-child {
  flex: 0 0 30px;
}

#CandidateList_CardView .JobName_AllCandidates > span:last-child {
  display: inline-block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .candidate-name-with-initials > span:last-child {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .JobEmail_AllCandidates,
#CandidateList_CardView .JobPhone_AllCandidates {
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

#CandidateList_CardView .JobEmail_AllCandidates span,
#CandidateList_CardView .JobPhone_AllCandidates span {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#CandidateList_CardView .JobTitle_AllCandidates span,
#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.3;
}

#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {
  margin-bottom: 4px;
}

#CandidateList_CardView .JobCreateBy_AllCandidates > div:last-child {
  white-space: nowrap;
}

#CandidateList_CardView .candidate-pipeline-stage-cell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 34px;
}

#CandidateList_CardView .candidate-pipeline-stage-cell.no-history {
  display: flex;
  justify-content: center;
}

#CandidateList_CardView .candidate-pipeline-stage-text {
  display: block;
  min-width: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#CandidateList_CardView .candidate-pipeline-history-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  color: #111827;
  background: #f8fafc;
  box-shadow: none;
}

#CandidateList_CardView .candidate-pipeline-history-btn svg {
  width: 14px;
  height: 14px;
}

#CandidateList_CardView .stage-filter-dropdown {
  height: 31px;
  font-size: 12px;
}

#CandidateList_CardView .stage-filter-dropdown .p-dropdown-label {
  padding: 5px 8px;
  font-size: 12px;
  line-height: 19px;
}

#CandidateList_CardView .stage-filter-dropdown .p-dropdown-trigger,
#CandidateList_CardView .stage-filter-dropdown .p-dropdown-clear-icon {
  width: 28px;
  font-size: 12px;
}

.stage-filter-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 7px 10px;
  font-size: 12px;
}

#CandidateList_CardView .CandidateListTableView .p-radiobutton,
#CandidateList_CardView .CandidateListTableView .p-radiobutton .p-radiobutton-box {
  width: 18px;
  height: 18px;
}

#CandidateList_CardView .candidate-actions-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

#CandidateList_CardView .candidate-action-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  padding: 0 !important;
  margin: 0;
  border-radius: 6px;
  line-height: 1;
}

#CandidateList_CardView .candidate-action-icon-btn svg,
#CandidateList_CardView .candidate-action-icon-btn i {
  display: block;
  margin: 0;
  font-size: 14px;
}

#CandidateList_CardView .candidate-actions-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

#CandidateList_CardView .candidate-actions-approval {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  white-space: nowrap;
}

#CandidateList_CardView .candidate-approval-btn {
  border: 1px solid transparent;
  border-radius: 6px;
  width: 28px;
  min-width: 28px;
  height: 26px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  background: #fff;
}

#CandidateList_CardView .candidate-approval-btn svg {
  display: block;
  margin: 0;
}

#CandidateList_CardView .candidate-approval-btn--approve {
  color: #047857;
  border-color: #a7f3d0;
  background: #ecfdf5;
}

#CandidateList_CardView .candidate-approval-btn--reject {
  color: #dc2626;
  border-color: #fecaca;
  background: #fef2f2;
}

#CandidateList_CardView .candidate-approval-btn--view {
  color: #0369a1;
  border-color: #bae6fd;
  background: #f0f9ff;
}

.approve-reject-modal .modal-content {
  border: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.24);
}

.approve-reject-modal-header {
  border: 0;
  padding: 18px 22px;
  color: #fff;
}

.approve-reject-modal-header.approve {
  background: linear-gradient(135deg, #047857, #10b981);
}

.approve-reject-modal-header.reject {
  background: linear-gradient(135deg, #b91c1c, #ef4444);
}

.approve-reject-modal-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.approve-reject-modal-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}

.approve-reject-modal-title span {
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  font-weight: 600;
}

.approve-reject-modal-body {
  padding: 20px 22px 18px;
  background: #f8fafc;
}

.approve-reject-field {
  margin-bottom: 14px;
}

.approve-reject-field .form-label {
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 6px;
}

.approve-reject-field .form-control:disabled {
  background: #eef2f7;
  border-color: #dbe3ec;
  color: #334155;
  opacity: 1;
}

.approve-reject-field textarea.form-control {
  min-height: 96px;
  resize: vertical;
}

.approve-reject-modal-footer {
  display: flex;
  justify-content: center !important;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  padding: 16px 22px;
}

.approve-reject-cancel-btn,
.approve-reject-submit-btn {
  min-width: 96px;
  height: 38px;
  border-radius: 8px;
  font-weight: 700;
}

.approve-reject-submit-btn.approve {
  background: #059669;
  border-color: #059669;
}

.approve-reject-submit-btn.reject {
  background: #dc2626;
  border-color: #dc2626;
}

#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child {
  border-left: 1px solid #e0e0e0;
}

#JobOrderTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  background-color: #e6f3ff;
}
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child {
  border-left: 1px solid #e0e0e0;
}
#CandidateTest_DataTableView .rdt_Table .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  background-color: #f8f8f8;
}
#JobOrderTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#UserManagement_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  font-size: 0.85rem;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#TelephonicTest_Table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#TalentScanResultView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  background-color: #e6f3ff;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#ExtensionLogs_Datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#TelephonicTest_Table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}

/* #CandidateViewSummaryTable .rdt_Table .rdt_TableBody,
#CandidateViewSummaryTable .rdt_Table .rdt_TableHead {
  border-left: 1px solid #e0e0e0;
} */

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  text-align: center;
  justify-content: center;
}

/* #CandidateViewSummaryTable .rdt_Table {
  border: 1px solid #e0e0e0;
  
} */

#CandidateViewSummaryTable .rdt_ExpanderRow {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable .rdt_Table .rdt_TableHead .bGNKtt:first-child,
#JobOrderTableView .rdt_Table .rdt_TableHead .bGNKtt:first-child {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable .rdt_Table .rdt_TableRow .gOAnHZ:first-child,
#JobOrderTableView .rdt_Table .rdt_TableRow .gOAnHZ:first-child {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  /* border-right: 2px solid red; */
}

#TalentScanResultView.rdt_Table .rdt_TableRow div:first-child {
  border-right: 2px solid blue;
}

#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(12),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1) {
  justify-content: center;
}

.font_12 {
  font-size: 12px;
}

.font_15,
.ColumnTitle {
  font-size: 0.85rem;
}

#CandidateApprovalTable table thead tr th {
  text-align: center;
}

#CandidateApprovalTable table tbody tr td:nth-child(2) div,
#CandidateApprovalTable table tbody tr td:nth-child(4) div,
#CandidateApprovalTable table tbody tr td:nth-child(3) div {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* #UserManagement_TableView table tbody tr td:nth-child(4),
#UserManagement_TableView table tbody tr td:nth-child(3),
#UserManagement_TableView table tbody tr td:nth-child(2), */
/* #CandidateApprovalTable table tbody tr td:nth-child(3), */
/* #CandidateApprovalTable table tbody tr td:nth-child(2) {
  text-align: center;
   
} */
#UserManagement_TableView table tbody tr td:nth-child(1),
#UserManagement_TableView table tbody tr td:nth-child(2),
#UserManagement_TableView table tbody tr td:nth-child(3),
#UserManagement_TableView table tbody tr td:nth-child(4),
#UserManagement_TableView table tbody tr td:nth-child(5) {
  text-align: center !important;
  border-right: 1px solid #e0e0e0;
}

#VitelMeetLink .p-datatable table {
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}

#VitelMeetLink .p-datatable table thead tr th,
#VitelMeetLink .p-datatable table tbody tr td {
  text-align: center !important;
  vertical-align: middle;
  border-right: 1px solid #e0e0e0 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

#VitelMeetLink .p-datatable table thead tr th .p-column-header-content {
  justify-content: center;
}

#VitelMeetLink .p-datatable table tbody tr td > span:not(.p-button-icon):not(.pi) {
  display: block;
  max-width: 180px;
  margin: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#VitelMeetLink .p-button .p-button-icon,
#VitelMeetLink .p-button .pi {
  display: inline-flex !important;
  max-width: none !important;
  margin: 0 !important;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: normal !important;
}

#UserManagement_TableView table tbody tr td:nth-child(5) div {
  justify-content: center;
}

#UserManagement_TableView table thead tr th div span {
  width: 100%;
  text-align: center !important;
}

#CandidateTest_DataTableView .rdt_Table {
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}

#All_Employees_TableView table tbody tr td {
  border-right: 1px solid #e0e0e0;
}

#All_Employees_TableView table tbody tr td span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#All_Employees_TableView table tbody tr td:nth-child(3) {
  width: 150px;
}

#All_Employees_TableView table tbody tr td:nth-child(2) {
  width: 150px;
}

#All_Employees_TableView table tbody tr td:nth-child(3) span,
#All_Employees_TableView table tbody tr td:nth-child(2) span {
  display: block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* #All_Employees_TableView table thead tr th:nth-child(3) div,
 */

#All_Employees_TableView table thead tr th:nth-child(6) div,
#All_Employees_TableView table thead tr th:nth-child(5) div,
#All_Employees_TableView table thead tr th:nth-child(4) div,
#All_Employees_TableView table thead tr th:nth-child(2) div,
#All_Employees_TableView table thead tr th:nth-child(1) div {
  justify-content: center;
}
#recentAactivityTable table thead tr th:nth-child(1) div,
#recentAactivityTable table thead tr th:nth-child(2) div,
#recentAactivityTable table thead tr th:nth-child(3) div,
#recentAactivityTable table thead tr th:nth-child(4) div,

#Smtp_table table thead tr th:nth-child(1) div,
#Smtp_table table thead tr th:nth-child(2) div,
#Smtp_table table thead tr th:nth-child(3) div,
#Smtp_table table thead tr th:nth-child(4) div,
#Smtp_table table thead tr th:nth-child(5) div,
#Smtp_table table thead tr th:nth-child(6) div,
#Smtp_table table thead tr th:nth-child(7) div,
#Smtp_table table thead tr th:nth-child(8) div,
#Smtp_table table thead tr th:nth-child(9) div,
#Smtp_table table thead tr th:nth-child(10) div{
  /* text-align: center !important; */
  /* text-align: center !important; */
  justify-content: center;
}

#recentAactivityTable table thead tr th:nth-child(1),
#recentAactivityTable table tbody tr td:nth-child(2),
#recentAactivityTable table tbody tr td:nth-child(3),
#recentAactivityTable table tbody tr td:nth-child(4),
#recentAactivityTable table tbody tr td:nth-child(5),
#Smtp_table table tbody tr td:nth-child(1),
#Smtp_table table tbody tr td:nth-child(2),
#Smtp_table table tbody tr td:nth-child(3),
#Smtp_table table tbody tr td:nth-child(4),
#Smtp_table table tbody tr td:nth-child(5),
#Smtp_table table tbody tr td:nth-child(6),
#Smtp_table table tbody tr td:nth-child(7),
#Smtp_table table tbody tr td:nth-child(8),
#Smtp_table table tbody tr td:nth-child(9),
#Smtp_table table tbody tr td:nth-child(10){
  text-align: center !important;
  border-left: 1px solid #e0e0e0;
}

#Smtp_table table tbody tr td:nth-child(6) div {
  justify-content: space-evenly;
}

#Smtp_table,
#Vitel_table {
  width: 100%;
  overflow: visible;
}

#Smtp_table .p-datatable-table,
#Vitel_table .p-datatable-table {
  width: 100%;
  table-layout: fixed;
}

#Smtp_table .p-datatable-thead > tr > th,
#Smtp_table .p-datatable-tbody > tr > td,
#Vitel_table .p-datatable-thead > tr > th,
#Vitel_table .p-datatable-tbody > tr > td {
  padding: 10px 8px !important;
  font-size: 14px;
  overflow-wrap: anywhere;
}

#Smtp_table .p-datatable-thead > tr > th,
#Vitel_table .p-datatable-thead > tr > th {
  font-size: 14px;
  font-weight: 600;
}

.smtp-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}

.smtp-actions-cell .p-button {
  width: 34px;
  height: 34px;
  min-width: 34px;
  padding: 0 !important;
  border: 1px solid #d7e0eb !important;
  border-radius: 6px !important;
  background: #f8fafc !important;
  color: #174f79 !important;
  box-shadow: none !important;
}

.smtp-actions-cell .p-button:hover {
  background: #eaf3fb !important;
  border-color: #9fc4e2 !important;
}

.smtp-actions-cell .p-button-danger {
  color: #b42318 !important;
}

.smtp-actions-cell .p-button-info {
  color: #0f6f9f !important;
}

.advanced-search-dialog.p-dialog {
  width: min(680px, calc(100vw - 32px)) !important;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

.advanced-search-dialog .p-dialog-header {
  min-height: 54px;
  padding: 14px 20px;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%) !important;
  color: #ffffff !important;
  border: 0;
}

.advanced-search-dialog .p-dialog-title {
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0;
}

.advanced-search-dialog .p-dialog-header-icons button,
.advanced-search-dialog .p-dialog-header-close {
  color: #ffffff !important;
  width: 34px;
  height: 34px;
}

.advanced-search-dialog .p-dialog-content {
  padding: 18px 20px 20px !important;
  background: #f8fafc !important;
}

.advanced-search-dialog .advan-modal,
.advanced-search-dialog .popoup-clr,
.advanced-search-dialog .card {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.advanced-search-dialog .card-body {
  padding: 0 !important;
}

.advanced-search-dialog .advan-modal > .card,
.advanced-search-dialog .popoup-clr {
  padding: 0 !important;
}

.advanced-search-dialog .row {
  margin-left: 0;
  margin-right: 0;
}

.advanced-search-dialog .col-xl-12 {
  padding-left: 0;
  padding-right: 0;
}

.advanced-search-dialog label {
  margin-bottom: 6px;
  color: #334155;
  font-size: 12.5px;
  font-weight: 700;
}

.advanced-search-dialog .p-dropdown,
.advanced-search-dialog .p-inputtext {
  width: 100%;
  min-height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 13px;
  box-shadow: none !important;
}

.advanced-search-dialog .p-dropdown-label {
  padding: 8px 12px;
  font-size: 13px;
}

.advanced-search-dialog .p-error {
  display: block;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 7px;
  background: #fef2f2;
  color: #dc2626;
  font-size: 12px;
}

.advanced-search-dialog .d-flex.justify-content-center {
  justify-content: flex-end !important;
  gap: 8px;
  margin-top: 16px;
}

.advanced-search-dialog .addfield-pop {
  min-width: 92px;
  height: 36px;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: var(--blue-gradient-right) !important;
  color: #ffffff !important;
  font-size: 13px;
  font-weight: 700;
}

.advanced-search-dialog .addfield-pop:nth-child(2),
.advanced-search-dialog .addfield-pop:nth-child(3) {
  background: #ffffff !important;
  color: #0f4c81 !important;
  border: 1px solid #bfdbfe !important;
}

.manager-dashboard-activity-table,
.manager-dashboard-recent-table,
.manager-dashboard-interviews-table {
  font-size: 12px;
}

.manager-dashboard-activity-table .p-datatable-thead > tr > th,
.manager-dashboard-recent-table .p-datatable-thead > tr > th,
.manager-dashboard-interviews-table .p-datatable-thead > tr > th {
  padding: 9px 10px !important;
  background: #f8fafc !important;
  color: #334155 !important;
  font-size: 11.5px;
  font-weight: 800;
  line-height: 1.25;
  text-transform: none;
  vertical-align: middle;
}

.manager-dashboard-activity-table .p-datatable-tbody > tr > td,
.manager-dashboard-recent-table .p-datatable-tbody > tr > td,
.manager-dashboard-interviews-table .p-datatable-tbody > tr > td {
  padding: 8px 10px !important;
  color: #334155;
  font-size: 12px;
  line-height: 1.25;
  vertical-align: middle;
}

.candidate-empty-state {
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #64748b;
  text-align: center;
}

.candidate-empty-state i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-bottom: 4px;
  border-radius: 50%;
  background: #e8f2fb;
  color: #176ea8;
  font-size: 18px;
}

.candidate-empty-state strong {
  color: #173f63;
  font-size: 15px;
  font-weight: 700;
}

.candidate-empty-state span {
  font-size: 12px;
}

.job-order-empty-state {
  min-height: 180px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #64748b;
  text-align: center;
}

.job-order-empty-state i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 4px;
  border-radius: 50%;
  background: #e8f2fb;
  color: #176ea8;
  font-size: 19px;
}

.job-order-empty-state strong {
  color: #173f63;
  font-size: 15px;
  font-weight: 700;
}

.job-order-empty-state span {
  font-size: 12px;
}

.org-master-empty-state {
  min-height: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #64748b;
  text-align: center;
}

.org-master-empty-state i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-bottom: 4px;
  border-radius: 50%;
  background: #e8f2fb;
  color: #176ea8;
  font-size: 18px;
}

.org-master-empty-state strong {
  color: #173f63;
  font-size: 15px;
  font-weight: 700;
}

.org-master-empty-state span {
  font-size: 12px;
}

.schedule-timezone-summary {
  width: 100%;
}

.candidate-detail-name {
  font-size: 16px !important;
  line-height: 1.25;
}

.interview-popup .p-dialog-header {
  padding: 16px 22px;
  border-bottom: 1px solid #dbe7f3;
  background: linear-gradient(135deg, #f7fbff 0%, #edf6ff 100%);
}
.interview-popup .p-fileupload-choose,
.interview-popup .p-fileupload-choose:hover,
.interview-popup .p-fileupload-choose:focus,
.interview-popup .p-fileupload-choose:active {
  background: #e9edf3 !important;
  border-color: #e9edf3 !important;
  box-shadow: none !important;
  color: #1f2937 !important;
  transform: none !important;
}

.interview-popup .p-dialog-title {
  color: #123f68 !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.schedule-date-picker {
  width: 100%;
}

.schedule-date-picker .react-date-picker__wrapper {
  min-height: 38px;
  border: 1px solid #cbd9e6;
  border-radius: 7px;
  background: #fff;
}

.schedule-date-picker .react-date-picker__inputGroup {
  padding: 0 10px;
}

.schedule-date-picker .react-date-picker__button {
  padding: 7px 10px;
}

.schedule-date-picker .react-date-picker__button:enabled:hover,
.schedule-date-picker .react-date-picker__button:enabled:focus {
  background: #f1f5f9;
}

.interview-popup .p-dialog-header .p-dialog-header-icon {
  width: 32px;
  height: 32px;
  border-radius: 7px;
  color: #31536e !important;
  background: transparent !important;
  opacity: 1;
}

.interview-popup .p-dialog-header .p-dialog-header-icon:hover,
.interview-popup .p-dialog-header .p-dialog-header-icon:focus {
  color: #123f68 !important;
  background: #dcecf9 !important;
}

.interview-popup .p-dialog-content {
  padding: 0;
  background: #f6f9fc;
}

.schedule-dialog-header {
  display: flex;
  align-items: center;
  gap: 11px;
  color: #123f68;
}

.schedule-dialog-header-icon,
.schedule-section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #0d6efd;
  color: #fff;
  font-size: 15px;
}

.schedule-dialog-header strong,
.schedule-dialog-header small,
.schedule-section-heading strong,
.schedule-section-heading small {
  display: block;
}

.schedule-dialog-header strong {
  font-size: 17px;
  line-height: 1.2;
}

.schedule-dialog-header small,
.schedule-section-heading small {
  margin-top: 3px;
  color: #6b7f93;
  font-size: 11px;
  font-weight: 500;
}

.schedule-interview-form {
  padding: 8px 22px 20px;
}

.schedule-form-section {
  margin-bottom: 14px;
  padding: 15px;
  border: 1px solid #dbe7f3;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(26, 74, 112, .05);
}

.schedule-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  color: #173f63;
}

.schedule-section-heading strong {
  font-size: 13px;
}

.schedule-section-number {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  font-size: 12px;
}

.schedule-form-section .row {
  row-gap: 12px;
}

.schedule-form-section label {
  margin-bottom: 6px;
  color: #294b68;
  font-size: 12px;
  font-weight: 700;
}

.schedule-form-section .p-inputtext,
.schedule-form-section .p-dropdown,
.schedule-form-section .p-calendar,
.schedule-form-section .p-calendar .p-inputtext {
  min-height: 38px;
  border-color: #cbd9e6;
  border-radius: 7px;
}

.schedule-form-section .p-inputtext:enabled:focus,
.schedule-form-section .p-dropdown:not(.p-disabled).p-focus,
.schedule-form-section .p-calendar:not(.p-disabled).p-focus > .p-inputtext {
  border-color: #2684c7;
  box-shadow: 0 0 0 3px rgba(38, 132, 199, .12);
}

.interview-popup .p-dropdown,
.interview-popup .p-dropdown:hover,
.interview-popup .p-dropdown.p-focus,
.interview-popup .p-dropdown .p-dropdown-trigger,
.interview-popup .p-dropdown .p-dropdown-trigger:hover,
.interview-popup .p-dropdown .p-dropdown-trigger:focus {
  background: #fff !important;
  background-image: none !important;
  color: #294b68 !important;
}

.interview-popup .p-dropdown .p-dropdown-trigger {
  width: 2.5rem;
  border-left: 1px solid #d5e1ec;
}

.schedule-panel-timezones {
  margin-top: 15px !important;
  padding: 14px !important;
  border-color: #c9def1 !important;
  background: #f5faff !important;
}

.schedule-timezone-heading-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.schedule-timezone-heading-row small {
  color: #6b7f93;
  font-size: 11px;
}

.schedule-timezone-heading {
  margin-bottom: 0;
}

.schedule-timezone-field {
  padding: 10px;
  border: 1px solid #d7e5f1;
  border-radius: 8px;
  background: #fff;
}

.schedule-form-actions {
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid #dbe7f3;
}

.schedule-form-actions button {
  min-width: 112px;
  border-radius: 7px;
  font-weight: 700;
}

@media (max-width: 640px) {
  .schedule-interview-form {
    padding: 14px 12px 16px;
  }

  .schedule-form-section {
    padding: 12px;
  }

  .schedule-timezone-heading-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
}

/* New Mail uses the full compose workspace; replies and forwards remain compact. */
.em-compose-fullscreen {
  inset: 0;
  top: 0;
  left: 0;
  transform: none;
  width: 100vw;
  max-width: none;
  height: 100vh;
  max-height: none;
  border: 0;
  border-radius: 0;
  z-index: 11000;
  box-shadow: none;
}

.em-compose-fullscreen .em-compose-header {
  min-height: 52px;
  padding: 10px 18px;
  border-radius: 0;
}

.em-compose-fullscreen .em-compose-body {
  flex: 1 1;
  max-height: none;
  min-height: 0;
}

.em-compose-fullscreen .em-compose-field {
  min-height: 48px;
  padding: 0 18px;
}

.em-compose-fullscreen .em-compose-field-label {
  width: 52px;
  font-size: 13px;
}

.em-compose-fullscreen .em-compose-toolbar {
  padding: 7px 18px;
}

.em-compose-fullscreen .em-compose-editor {
  flex: 1 1;
  min-height: 0;
}

.em-compose-fullscreen .em-compose-editor textarea {
  height: 100%;
  min-height: 320px;
  resize: none;
  padding: 22px 18px;
  font-size: 14px;
}

.em-compose-fullscreen .em-compose-footer {
  min-height: 64px;
  padding: 12px 18px;
}

.schedule-timezone-heading {
  display: block;
  margin-bottom: 10px;
  color: #173f63;
  font-size: 13px;
  font-weight: 700;
}

.schedule-timezone-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 18px;
}

.schedule-timezone-field {
  display: flex;
  flex-direction: column;
  gap: 9px;
  min-width: 0;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.schedule-timezone-name-row {
  display: block;
  line-height: 1.35;
  min-width: 0;
}

.schedule-timezone-name {
  color: #1e293b;
}

.schedule-timezone-preview {
  display: block;
  margin-top: 3px;
  color: #64748b;
  font-weight: 500;
}

.schedule-timezone-dropdown {
  width: 100%;
  min-height: 38px;
  border: 1px solid #cbd9e6 !important;
  border-radius: 7px !important;
  background: #fff !important;
  box-shadow: none !important;
}

.schedule-timezone-dropdown .p-dropdown-label {
  padding: 9px 12px !important;
  color: #294b68 !important;
  font-size: 13px;
}

.schedule-timezone-dropdown .p-dropdown-trigger {
  width: 2.5rem !important;
  border-left: 1px solid #d5e1ec !important;
  border-radius: 0 7px 7px 0 !important;
  background: #fff !important;
  color: #294b68 !important;
}

.schedule-timezone-dropdown:not(.p-disabled):hover,
.schedule-timezone-dropdown.p-focus {
  background: #fff !important;
  background-image: none !important;
  color: #1f2937 !important;
  border-color: #94a3b8 !important;
  box-shadow: none !important;
}

.schedule-timezone-dropdown:not(.p-disabled):hover .p-dropdown-trigger,
.schedule-timezone-dropdown.p-focus .p-dropdown-trigger {
  background: #fff !important;
  background-image: none !important;
  color: #1f2937 !important;
}

.schedule-timezone-dropdown .p-dropdown-trigger,
.schedule-timezone-dropdown .p-dropdown-trigger:hover,
.schedule-timezone-dropdown .p-dropdown-trigger:focus {
  background: #fff !important;
  background-image: none !important;
  color: #1f2937 !important;
}

.schedule-timezone-preview {
  display: inline-block;
  color: #52677d;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
  margin-left: 2px;
  overflow-wrap: anywhere;
}

@media (max-width: 640px) {
  .schedule-timezone-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Keep SweetAlert overlays from toggling the document scrollbar and shifting the page. */
html {
  scrollbar-gutter: stable;
}

html.swal2-shown,
body.swal2-shown {
  overflow-y: auto !important;
}

body.swal2-shown {
  padding-right: 0 !important;
}

body.modal-open {
  padding-right: 0 !important;
}

.modal {
  padding-right: 0 !important;
}

.manager-dashboard-page .manager-dashboard-activity-table .manager-table-strong,
.manager-dashboard-page .manager-dashboard-recent-table .manager-table-strong {
  font-size: 11px !important;
  line-height: 1.2;
}

.resume-upload-result-modal .modal-content {
  border: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(15, 23, 42, .18);
}

.resume-upload-result-modal .modal-body {
  padding: 24px 28px 18px !important;
  background: #f8fafc;
}

.resume-upload-invite-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.resume-upload-summary-section {
  padding: 0;
}

.resume-upload-summary-title {
  margin: 0 0 10px;
  color: #164e73;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .02em;
  text-transform: uppercase;
}

.resume-upload-metric,
.resume-upload-total-summary > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 54px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
}

.resume-upload-metric strong,
.resume-upload-total-summary strong {
  font-size: 18px;
}

.resume-upload-metric-success { color: #168457; background: #f0fdf7; border-color: #c6f0dc; }
.resume-upload-metric-warning { color: #a66a00; background: #fffaf0; border-color: #f9dfaa; }
.resume-upload-metric-danger { color: #c53030; background: #fff5f5; border-color: #f3c5c5; }

.resume-upload-total-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.resume-upload-total-summary > div {
  flex-direction: column;
  align-items: flex-start;
  min-height: 74px;
  color: #334155;
}

.resume-upload-result-modal table {
  margin-bottom: 0;
  background: #fff;
  border-color: #dbe3ec;
}

.resume-upload-result-modal table thead th {
  padding: 11px 13px;
  color: #1e3a56;
  background: #eaf4fb;
  border-color: #dbe3ec;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .02em;
}

.resume-upload-result-modal table tbody td {
  padding: 12px 13px;
  color: #334155;
  vertical-align: middle;
}

@media (max-width: 576px) {
  .resume-upload-result-modal .modal-body { padding: 18px 14px 12px !important; }
  .resume-upload-invite-summary,
  .resume-upload-total-summary { grid-template-columns: 1fr; }
}

.manager-dashboard-activity-table .p-paginator {
  min-height: 42px;
  padding: 5px 8px !important;
  border-top: 1px solid #dbe3ef;
  gap: 4px;
  justify-content: center;
}

.manager-dashboard-activity-table .p-paginator .p-dropdown {
  width: 64px !important;
  height: 30px !important;
  min-height: 30px !important;
}

.manager-dashboard-activity-table .p-paginator .p-dropdown-label {
  padding: 5px 8px !important;
  font-size: 12px !important;
  line-height: 18px !important;
}

.manager-dashboard-activity-table .p-paginator .p-dropdown-trigger {
  width: 26px !important;
}

.manager-dashboard-activity-table .p-paginator .p-paginator-first,
.manager-dashboard-activity-table .p-paginator .p-paginator-prev,
.manager-dashboard-activity-table .p-paginator .p-paginator-next,
.manager-dashboard-activity-table .p-paginator .p-paginator-last {
  width: 28px !important;
  min-width: 28px !important;
  height: 28px !important;
  margin: 0 1px !important;
}

.manager-dashboard-activity-table .p-paginator .p-paginator-current {
  font-size: 12px;
  color: #64748b;
  margin: 0 8px !important;
  min-width: auto;
}

.manager-role-application-row {
  gap: 12px;
}

.manager-role-application-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.manager-role-application-count {
  flex: 0 0 auto;
}
#All_Employees_TableView table tbody tr td:nth-child(5),
#All_Employees_TableView table tbody tr td:nth-child(4),
#All_Employees_TableView table tbody tr td:nth-child(2),
#All_Employees_TableView table tbody tr td:nth-child(1) {
  text-align: center !important;
}
/* Modal */
.notification-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
}

/* Header */
.notification-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 16px;
}

/* Body */
.notification-body {
  max-height: 420px;
  overflow-y: auto;
  padding: 8px;
}

/* Notification Item */
.notification-item {
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 6px;
  transition: background 0.2s ease;
}

.notification-item.unread {
  background: #f1f7ff;
}

.notification-item.read {
  background: #ffffff;
  opacity: 0.8;
}

.notification-item:hover {
  background: #eef4ff;
}

/* Icon */
.notification-icon {
  width: 40px;
  height: 40px;
  background: #e7f0ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
  font-size: 16px;
}

/* Content */
.notification-content {
  flex: 1 1;
  padding-left: 12px;
}

.notification-title {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}

.notification-message {
  font-size: 13px;
  color: #495057;
  margin-top: 2px;
}

/* Footer */
.notification-footer {
  margin-top: 6px;
  font-size: 11px;
  color: #6c757d;
}

/* Date */
.notification-date {
  font-size: 11px;
}

/* Mark Read Button */
.mark-read-btn {
  background: none;
  border: none;
  color: #0d6efd;
  font-size: 11px;
  cursor: pointer;
  padding: 0;
}

.mark-read-btn:hover {
  text-decoration: underline;
}

/* Empty State */
.no-notification {
  text-align: center;
  padding: 30px;
  color: #6c757d;
  font-size: 14px;
}

/* #All_Employees_TableView table thead tr th:nth-child(2) {
  border: 2px solid red;
  width: 120px;
}

#All_Employees_TableView table tbody tr td:nth-child(2) span {
  border: 2px solid red;
  width: 120px;
} */

.CandidateAprRejReason {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}

#AdminModule_Tabs .p-tabview-panels {
  display: none;
}

.admin-dashboard-workspace #AdminModule_Tabs > .p-tabview {
  flex: 1 1 480px;
  min-width: 0;
  max-width: 100%;
}

.admin-dashboard-workspace #AdminModule_Tabs > button {
  flex: 0 0 auto;
  max-width: 100%;
}

#PreviewJobPortalCards ul {
}

#All_Notifications_Modal .btn-close {
  margin-left: 3px;
  filter: invert(1);
  opacity: 1;
}
.tab-btn {
  background: none;
  border: none;
  padding: 10px 14px;
  font-size: 14px;
  color: #6b7280;
  position: relative;
  cursor: pointer;
}

.tab-btn.active {
  color: #3a85f7;
  font-weight: 600;
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #4c8cec;
  border-radius: 2px;
}

/* #RecentOpenJobs_TableView table tr td { 
  border: 2px solid red;
   
} */
#RecentOpenJobs_TableView table tbody tr td {
  border-right: 1px solid #ddd;
}

#RecentOpenJobs_TableView table tbody tr td:last-child {
  border-right: initial;
}

#RecentOpenJobs_TableView table tr td:nth-child(10) span,
#RecentOpenJobs_TableView table tr td:nth-child(9) span,
#RecentOpenJobs_TableView table tr td:nth-child(6) span,
#RecentOpenJobs_TableView table tr td:nth-child(5) span,
#RecentOpenJobs_TableView table tr td:nth-child(2) span {
  display: inline-block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#RecentOpenJobs_TableView table tr th:nth-child(12) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(11) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(10) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(9) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(8) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(7) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(6) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(5) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(4) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(3) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(2) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(1) span:first-child {
  width: 100%;
  justify-content: center !important;
  display: inline-block;
  text-align: center;
}

#RecentOpenJobs_TableView table tr td:nth-child(12),
#RecentOpenJobs_TableView table tr td:nth-child(11),
#RecentOpenJobs_TableView table tr td:nth-child(7),
#RecentOpenJobs_TableView table tr td:nth-child(4),
#RecentOpenJobs_TableView table tr td:nth-child(3),
#RecentOpenJobs_TableView table tr td:nth-child(1) {
  text-align: center !important;
}
/* 
white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 */
#JObInfoModal .btn-close {
  /* border: 2px solid red; */
  /* display: none; */
}
#BulkUploadModal .btn-close {
  border: 2px solid red;
  display: none;
}
/* highlight today's cell */
/* .rbc-month-view .rbc-day-bg.today-highlight {
  background-color: #eaf6ff; /* light blue */
/* }  */
.today-highlight {
  /* border: 2px solid #0d6efd; */
  background-color: #eaf6ff;
  /* border-radius: 6px;   */
}

.Selected_BgColor {
  /* background-color: lightblue; */
  background-color: #e0f2f7;
}
#AllEmployees_TableView table th:nth-child(1),
#AllEmployees_TableView table th:nth-child(2),
#AllEmployees_TableView table th:nth-child(3),
#AllEmployees_TableView table th:nth-child(4),
#AllEmployees_TableView table th:nth-child(5) {
  width: 260px;
}
/* #AllEmployees_TableView table tbody td:nth-child(3) span, */
#AllEmployees_TableView
  table
  tbody
  td:nth-child(2)
  #AllEmployees_TableView
  table
  tbody
  td:nth-child(5) {
  border: 2px solid red;
  width: 200px;
}
.sun-editor-wrapper .sun-editor {
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.sun-editor-wrapper.sun-error .sun-editor {
  border: 2px solid #dc3545 !important;
}

.RecruiterNamesListContainer {
  height: 50vh;
  overflow: auto;
}
#SectioScoreDatatable table tbody td:nth-child(1),
#SectioScoreDatatable table tbody td:nth-child(2),
#SectioScoreDatatable table tbody td:nth-child(3),
#SectioScoreDatatable table tbody td:nth-child(4),
#SectioScoreDatatable table tbody td:nth-child(5),
#SectioScoreDatatable table tbody td:nth-child(6) {
  text-align: center !important;
  border-right: 1px solid #eaf6ff;
}
#SectioScoreDatatable table th:nth-child(1) div,
#SectioScoreDatatable table th:nth-child(2) div,
#SectioScoreDatatable table th:nth-child(3) div,
#SectioScoreDatatable table th:nth-child(4) div,
#SectioScoreDatatable table th:nth-child(5) div,
#SectioScoreDatatable table th:nth-child(6) div {
  justify-content: center !important;
}

/* #LinkCandidates_DataTableView table tbody {
  height: 60vh;
  overflow: auto;
} */
#ArchiveReasonTableView table tr td:nth-child(10) div {
  width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(4) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(3) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.MobilePhoneContaier {
  display: inline-block;
  /* width: 80px !important; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#RecruiterReports_TableView table thead tr th:nth-child(6) div,
#RecruiterReports_TableView table thead tr th:nth-child(5) div,
#RecruiterReports_TableView table thead tr th:nth-child(4) div,
#MyPipelineReportTable table thead tr th:nth-child(6) div,
#MyPipelineReportTable table thead tr th:nth-child(5) div,
#MyPipelineReportTable table thead tr th:nth-child(4) div,
#MyPipelineReportTable table thead tr th:nth-child(3) div,
#MyPipelineReportTable table thead tr th:nth-child(2) div,
#MyPipelineReportTable table thead tr th:nth-child(1) div,
#RecruiterPerformanceReport table thead tr th:nth-child(11) div,
#RecruiterPerformanceReport table thead tr th:nth-child(10) div,
#RecruiterPerformanceReport table thead tr th:nth-child(9) div,
#RecruiterPerformanceReport table thead tr th:nth-child(8) div,
#RecruiterPerformanceReport table thead tr th:nth-child(7) div,
#RecruiterPerformanceReport table thead tr th:nth-child(6) div,
#RecruiterPerformanceReport table thead tr th:nth-child(5) div,
#RecruiterPerformanceReport table thead tr th:nth-child(4) div,
#RecruiterPerformanceReport table thead tr th:nth-child(3) div,
#RecruiterPerformanceReport table thead tr th:nth-child(2) div,
#RecruiterPerformanceReport table thead tr th:nth-child(1) div,
#MyPlaceMentReportTable table thead tr th:nth-child(9) div,
#MyPlaceMentReportTable table thead tr th:nth-child(8) div,
#MyPlaceMentReportTable table thead tr th:nth-child(7) div,
#MyPlaceMentReportTable table thead tr th:nth-child(6) div,
#MyPlaceMentReportTable table thead tr th:nth-child(5) div,
#MyPlaceMentReportTable table thead tr th:nth-child(4) div,
#MyPlaceMentReportTable table thead tr th:nth-child(3) div,
#MyPlaceMentReportTable table thead tr th:nth-child(2) div,
#MyPlaceMentReportTable table thead tr th:nth-child(1) div,
#JobTableView table thead tr th:nth-child(1) div,
#JobTableView table thead tr th:nth-child(2) div,
#JobTableView table thead tr th:nth-child(3) div,
#JobTableView table thead tr th:nth-child(1) div,
#CandidateInfo table thead tr th:nth-child(2) div,
#CandidateInfo table thead tr th:nth-child(3) div,
#CandidateInfo table thead tr th:nth-child(4) div,
#ArchiveReasonTableView table thead tr th:nth-child(1) div,
#ArchiveReasonTableView table thead tr th:nth-child(2) div,
#ArchiveReasonTableView table thead tr th:nth-child(3) div,
#ArchiveReasonTableView table thead tr th:nth-child(4) div,
#ArchiveReasonTableView table thead tr th:nth-child(5) div,
#ArchiveReasonTableView table thead tr th:nth-child(6) div,
#ArchiveReasonTableView table thead tr th:nth-child(7) div,
#ArchiveReasonTableView table thead tr th:nth-child(8) div,
#ArchiveReasonTableView table thead tr th:nth-child(9) div,
#ArchiveReasonTableView table thead tr th:nth-child(10) div,
#ActiveJobSummaryReport table thead tr th:nth-child(11) div,
#ActiveJobSummaryReport table thead tr th:nth-child(12) div,
#ActiveJobSummaryReport table thead tr th:nth-child(10) div,
#ActiveJobSummaryReport table thead tr th:nth-child(9) div,
#ActiveJobSummaryReport table thead tr th:nth-child(8) div,
#ActiveJobSummaryReport table thead tr th:nth-child(7) div,
#ActiveJobSummaryReport table thead tr th:nth-child(6) div,
#ActiveJobSummaryReport table thead tr th:nth-child(5) div,
#ActiveJobSummaryReport table thead tr th:nth-child(4) div,
#ActiveJobSummaryReport table thead tr th:nth-child(3) div,
#ActiveJobSummaryReport table thead tr th:nth-child(2) div,
#ActiveJobSummaryReport table thead tr th:nth-child(1) div,
#RecruiterReports_TableView table thead tr th:nth-child(3) div,
#RecruiterReports_TableView table thead tr th:nth-child(2) div,
#RecruiterReports_TableView table thead tr th:nth-child(1) div,
#RolesList table thead tr th:nth-child(1) div,
#RolesList table thead tr th:nth-child(2) div,
#RolesList table thead tr th:nth-child(3) div,
#RolesList table thead tr th:nth-child(4) div {
  justify-content: center;
  border-right: 1px solid #eaf6ff;
}

#RecruiterReports_TableView table tbody tr td:nth-child(15),
#RecruiterReports_TableView table tbody tr td:nth-child(14),
#RecruiterReports_TableView table tbody tr td:nth-child(13),
#RecruiterReports_TableView table tbody tr td:nth-child(12),
#RecruiterReports_TableView table tbody tr td:nth-child(11),
#RecruiterReports_TableView table tbody tr td:nth-child(10),
#RecruiterReports_TableView table tbody tr td:nth-child(9),
#RecruiterReports_TableView table tbody tr td:nth-child(8),
#RecruiterReports_TableView table tbody tr td:nth-child(7),
#RecruiterReports_TableView table tbody tr td:nth-child(6),
#RecruiterReports_TableView table tbody tr td:nth-child(5),
#RecruiterReports_TableView table tbody tr td:nth-child(4),
#RecruiterReports_TableView table tbody tr td:nth-child(3),
#RecruiterReports_TableView table tbody tr td:nth-child(2),
#RecruiterReports_TableView table tbody tr td:nth-child(1),
#JobTableView table tbody tr td:nth-child(3),
#JobTableView table tbody tr td:nth-child(2),
#JobTableView table tbody tr td:nth-child(1),
#CandidateInfo table tbody tr td:nth-child(1),
#CandidateInfo table tbody tr td:nth-child(2),
#CandidateInfo table tbody tr td:nth-child(3),
#CandidateInfo table tbody tr td:nth-child(4),
#ArchiveReasonTableView table tbody tr td:nth-child(1),
#ArchiveReasonTableView table tbody tr td:nth-child(2),
#ArchiveReasonTableView table tbody tr td:nth-child(3),
#ArchiveReasonTableView table tbody tr td:nth-child(4),
#ArchiveReasonTableView table tbody tr td:nth-child(5),
#ArchiveReasonTableView table tbody tr td:nth-child(6),
#ArchiveReasonTableView table tbody tr td:nth-child(7),
#ArchiveReasonTableView table tbody tr td:nth-child(8),
#ArchiveReasonTableView table tbody tr td:nth-child(9),
#ArchiveReasonTableView table tbody tr td:nth-child(10),
#ArchiveReasonTableView table tbody tr td:nth-child(11),
#RecruiterReports_TableView table tbody tr td:nth-child(2),
#RecruiterPerformanceReport table tbody tr td:nth-child(14),
#RecruiterPerformanceReport table tbody tr td:nth-child(13),
#RecruiterPerformanceReport table tbody tr td:nth-child(12),
#RecruiterPerformanceReport table tbody tr td:nth-child(11),
#RecruiterPerformanceReport table tbody tr td:nth-child(10),
#RecruiterPerformanceReport table tbody tr td:nth-child(9),
#RecruiterPerformanceReport table tbody tr td:nth-child(8),
#RecruiterPerformanceReport table tbody tr td:nth-child(7),
#RecruiterPerformanceReport table tbody tr td:nth-child(6),
#RecruiterPerformanceReport table tbody tr td:nth-child(5),
#RecruiterPerformanceReport table tbody tr td:nth-child(4),
#RecruiterPerformanceReport table tbody tr td:nth-child(3),
#RecruiterPerformanceReport table tbody tr td:nth-child(2),
#RecruiterPerformanceReport table tbody tr td:nth-child(1),
#ActiveJobSummaryReport table tbody tr td:nth-child(12),
#ActiveJobSummaryReport table tbody tr td:nth-child(11),
#ActiveJobSummaryReport table tbody tr td:nth-child(10),
#ActiveJobSummaryReport table tbody tr td:nth-child(9),
#ActiveJobSummaryReport table tbody tr td:nth-child(8),
#ActiveJobSummaryReport table tbody tr td:nth-child(7),
#ActiveJobSummaryReport table tbody tr td:nth-child(6),
#ActiveJobSummaryReport table tbody tr td:nth-child(5),
#ActiveJobSummaryReport table tbody tr td:nth-child(4),
#ActiveJobSummaryReport table tbody tr td:nth-child(3),
#ActiveJobSummaryReport table tbody tr td:nth-child(2),
#ActiveJobSummaryReport table tbody tr td:nth-child(1),
#TimeToHireReport table tbody tr td:nth-child(13),
#TimeToHireReport table tbody tr td:nth-child(12),
#TimeToHireReport table tbody tr td:nth-child(11),
#TimeToHireReport table tbody tr td:nth-child(10),
#TimeToHireReport table tbody tr td:nth-child(9),
#TimeToHireReport table tbody tr td:nth-child(8),
#TimeToHireReport table tbody tr td:nth-child(7),
#TimeToHireReport table tbody tr td:nth-child(6),
#TimeToHireReport table tbody tr td:nth-child(5),
#TimeToHireReport table tbody tr td:nth-child(4),
#TimeToHireReport table tbody tr td:nth-child(3),
#TimeToHireReport table tbody tr td:nth-child(2),
#TimeToHireReport table tbody tr td:nth-child(1),
#PlacementReportTable table tbody tr td:nth-child(7),
#PlacementReportTable table tbody tr td:nth-child(6),
#PlacementReportTable table tbody tr td:nth-child(5),
#PlacementReportTable table tbody tr td:nth-child(4),
#PlacementReportTable table tbody tr td:nth-child(3),
#PlacementReportTable table tbody tr td:nth-child(2),
#PlacementReportTable table tbody tr td:nth-child(1),
#MyPlaceMentReportTable table tbody tr td:nth-child(9),
#MyPlaceMentReportTable table tbody tr td:nth-child(8),
#MyPlaceMentReportTable table tbody tr td:nth-child(7),
#MyPlaceMentReportTable table tbody tr td:nth-child(6),
#MyPlaceMentReportTable table tbody tr td:nth-child(5),
#MyPlaceMentReportTable table tbody tr td:nth-child(4),
#MyPlaceMentReportTable table tbody tr td:nth-child(3),
#MyPlaceMentReportTable table tbody tr td:nth-child(2),
#MyPlaceMentReportTable table tbody tr td:nth-child(1),
#AllEmployees_TableView table tbody tr td:nth-child(10),
#AllEmployees_TableView table tbody tr td:nth-child(9),
#AllEmployees_TableView table tbody tr td:nth-child(7),
#MyPipelineReportTable table tbody tr td:nth-child(7),
#MyPipelineReportTable table tbody tr td:nth-child(6),
#MyPipelineReportTable table tbody tr td:nth-child(5),
#MyPipelineReportTable table tbody tr td:nth-child(4),
#MyPipelineReportTable table tbody tr td:nth-child(3),
#MyPipelineReportTable table tbody tr td:nth-child(2),
#MyPipelineReportTable table tbody tr td:nth-child(1),
#RolesList table tbody tr td:nth-child(1),
#RolesList table tbody tr td:nth-child(2),
#RolesList table tbody tr td:nth-child(3),
#RolesList table tbody tr td:nth-child(4) {
  text-align: center !important;
  border-right: 1px solid #dbe1e6;
}

#RolesList table tbody tr td:nth-child(4) > div {
  justify-content: center !important;
  align-items: center;
}
#RecruiterReports_TableView table tbody tr td:nth-child(2) div {
  width: 240px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  div
  #TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  div {
  font-size: 14px;
}

/* ========== Candidate View Modal - Clean UI ========== */
.cv-modal .modal-content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.cv-modal .modal-body {
  max-height: 85vh;
  overflow-y: auto;
  padding: 0 !important;
}

/* Profile Header */
.cv-profile-header {
  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 100%);
  padding: 2rem 2rem 1.8rem;
  text-align: center;
  position: relative;
}

.cv-close-btn {
  position: absolute;
  top: 12px;
  right: 14px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.cv-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.cv-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 3px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
  letter-spacing: 2px;
}

.cv-profile-name {
  color: #fff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.cv-profile-company {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
}

.cv-profile-exp {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  font-style: italic;
}

/* Sections */
.cv-section {
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid #f0f0f0;
}

.cv-section--last {
  border-bottom: none;
  padding-bottom: 1.75rem;
}

.cv-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #0e527d;
  margin-bottom: 1rem;
}

/* Info Items */
.cv-info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  background: #f8fafb;
  transition: background 0.2s;
}

.cv-info-item:hover {
  background: #eef4f8;
}

.cv-info-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.cv-info-label {
  font-size: 0.75rem;
  color: #8a9bae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 2px;
}

.cv-info-value {
  font-size: 0.95rem;
  color: #212529;
  font-weight: 500;
  word-break: break-word;
}

/* Skills Section */
.cv-skills-section {
  margin-bottom: 0.85rem;
}

.cv-skills-section:last-child {
  margin-bottom: 0;
}

.cv-skills-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #8a9bae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.4rem;
}

.cv-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.cv-skill-badge {
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  font-size: 0.82rem;
  font-weight: 500;
  display: inline-block;
  transition: transform 0.15s, box-shadow 0.15s;
}

.cv-skill-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.cv-skill-badge--primary {
  background: #e3f2fd;
  color: #0d47a1;
  border: 1px solid #bbdefb;
}

.cv-skill-badge--secondary {
  background: #e8f5e9;
  color: #1b5e20;
  border: 1px solid #c8e6c9;
}

.cv-skill-badge--other {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffe0b2;
}

/* Resume Button */
.cv-resume-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.6rem 1.25rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.15s;
}

.cv-resume-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  color: #fff;
  text-decoration: none;
}

.cv-resume-ext {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-left: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* ========== Candidates Page - Premium UI ========== */

/* Hero Banner */
.cd-hero {
  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 50%, #46a4cf 100%);
  border-radius: 16px;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
}

.cd-hero::before {
  content: "";
  position: absolute;
  top: -40%;
  right: -5%;
  width: 250px;
  height: 250px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.cd-hero::after {
  content: "";
  position: absolute;
  bottom: -60%;
  right: 10%;
  width: 180px;
  height: 180px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 50%;
}

.cd-hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.cd-hero-title {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
}

.cd-hero-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  margin: 0.2rem 0 0;
}

.cd-hero-right {
  display: flex;
  gap: 1.5rem;
}

.cd-hero-stat {
  text-align: center;
}

.cd-hero-stat-number {
  display: block;
  color: #fff;
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
}

.cd-hero-stat-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

/* Controls Bar */
.cd-controls {
  background: #fff;
  border-radius: 14px;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
}

.cd-controls-top {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #f5f5f5;
}

.cd-search-wrapper {
  flex: 1 1;
  max-width: 400px;
  position: relative;
}

.cd-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.85rem;
  z-index: 2;
}

.cd-search-wrapper .cd-search-input {
  padding-left: 36px !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 10px !important;
  height: 40px;
  font-size: 0.88rem;
  background: #f9fafb !important;
  transition: all 0.2s;
}

.cd-search-wrapper .cd-search-input:focus {
  border-color: #1a87cb !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(26, 135, 203, 0.1) !important;
}

.cd-search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  font-size: 11px;
  z-index: 2;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-search-clear:hover {
  background: #f3f4f6;
  color: #374151;
}

.cd-controls-right-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.cd-company-select {
  width: 185px;
}

/* Filter Chips */
.cd-controls-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cd-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cd-filter-chip-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.cd-filter-chip {
  display: flex;
  align-items: center;
  background: #f4f7fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  transition: border-color 0.2s;
}

.cd-filter-chip:focus-within {
  border-color: #1a87cb;
  box-shadow: 0 0 0 2px rgba(26, 135, 203, 0.1);
}

.cd-filter-chip-icon {
  padding: 0 0.6rem;
  color: #6b7280;
  font-size: 0.8rem;
  border-right: 1px solid #e5e7eb;
  height: 36px;
  display: flex;
  align-items: center;
  background: #eef1f5;
}

.cd-filter-chip-select {
  border: none !important;
  background: transparent !important;
  font-size: 0.84rem;
  color: #374151;
  padding: 0.35rem 1.75rem 0.35rem 0.6rem;
  cursor: pointer;
  outline: none;
  min-width: 120px;
  appearance: auto;
}

.cd-clear-filters {
  display: flex;
  align-items: center;
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cd-clear-filters:hover {
  background: #fee2e2;
  border-color: #f87171;
}

/* Action Buttons */
.cd-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.cd-action-btn {
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  padding: 0.42rem 0.85rem !important;
  transition: all 0.2s !important;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.15rem;
}

.cd-action-btn--outline {
  background: #fff !important;
  color: #374151 !important;
  border: 1px solid #d1d5db !important;
}

.cd-action-btn--outline:hover {
  background: #f9fafb !important;
  border-color: #9ca3af !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.cd-action-btn--outline:disabled {
  opacity: 0.5 !important;
  transform: none !important;
}

.cd-action-btn--primary {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.25);
}

.cd-action-btn--primary:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(14, 82, 125, 0.35) !important;
}

/* Data Card */
.cd-data-card {
  border: none !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04) !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #fff !important;
  border: 1px solid #f0f0f0 !important;
}

.cd-table-wrapper {
  overflow: hidden;
}

.cd-loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  background: #fafbfc;
}

/* ===== DataTable Cell Styles ===== */

/* Name Cell - Avatar + Name + Email */
.cd-name-cell {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.cd-name-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
}

.cd-name-text {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.88rem;
  line-height: 1.3;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cd-name-email {
  font-size: 0.73rem;
  color: #94a3b8;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Job Tag */
.cd-job-tag {
  background: #eff6ff;
  color: #1d4ed8;
  padding: 0.25rem 0.6rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #dbeafe;
}

/* Phone */
.cd-phone-cell {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: #475569;
}

.cd-phone-icon {
  color: #10b981;
  font-size: 0.7rem;
}

/* Source Badge */
.cd-source-badge {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* Cell Primary / Meta */
.cd-cell-primary {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.85rem;
}

.cd-cell-meta {
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* Pipeline Badge */
.cd-pipeline-badge {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* HRMS Badge */
.cd-hrms-badge {
  background: #fae8ff;
  color: #86198f;
  border: 1px solid #f0abfc;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* Talent Scan Button */
.cd-scan-btn {
  border: none;
  border-radius: 8px;
  padding: 0.3rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s;
}

.cd-scan-btn--ready {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.cd-scan-btn--ready:hover {
  background: #d1fae5;
  transform: translateY(-1px);
}

.cd-scan-btn--pending {
  background: #f1f5f9;
  color: #94a3b8;
  border: 1px solid #e2e8f0;
  cursor: not-allowed;
}

/* Actions Cell */
.cd-actions-cell {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  align-items: center;
}

.cd-actions-main {
  display: flex;
  gap: 0.3rem;
}

.cd-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.82rem;
  transition: all 0.2s;
  color: #64748b;
}

.cd-icon-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.cd-icon-btn--edit:hover {
  background: #eff6ff;
  color: #2563eb;
  border-color: #bfdbfe;
}

.cd-icon-btn--view:hover {
  background: #f0fdf4;
  color: #16a34a;
  border-color: #bbf7d0;
}

.cd-icon-btn--logs:hover {
  background: #fefce8;
  color: #ca8a04;
  border-color: #fde68a;
}

/* Approval Buttons */
.cd-actions-approval {
  display: flex;
  gap: 0.25rem;
}

.cd-approval-btn {
  border: none;
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.15s;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.cd-approval-btn--approve {
  background: #dcfce7;
  color: #15803d;
}

.cd-approval-btn--approve:hover {
  background: #bbf7d0;
}

.cd-approval-btn--reject {
  background: #fee2e2;
  color: #dc2626;
}

.cd-approval-btn--reject:hover {
  background: #fecaca;
}

.cd-approval-btn--info {
  background: #e0f2fe;
  color: #0369a1;
}

.cd-approval-btn--info:hover {
  background: #bae6fd;
}

/* Empty State */
.cd-empty-state {
  text-align: center;
  padding: 3rem 1rem;
}

.cd-empty-icon {
  font-size: 2.5rem;
  color: #cbd5e1;
  margin-bottom: 0.75rem;
  display: block;
}

.cd-empty-text {
  font-size: 1rem;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

.cd-empty-sub {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0.25rem 0 0;
}

/* ===== DataTable Overrides ===== */
#CandidateList_CardView .cd-datatable .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  border-bottom: 2px solid #e2e8f0 !important;
  border-top: none !important;
  padding: 0.9rem 0.75rem;
  white-space: nowrap;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr {
  transition: all 0.15s ease;
  border-left: 3px solid transparent;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:nth-child(even) {
  background: #fafbfc;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:hover {
  background: #eff6ff !important;
  border-left-color: #1a87cb;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr > td {
  padding: 0.7rem 0.75rem;
  font-size: 0.86rem;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

/* Paginator */
#CandidateList_CardView .cd-datatable .p-paginator {
  border: none !important;
  background: #f8fafc !important;
  padding: 0.75rem 1rem !important;
  border-top: 2px solid #e2e8f0 !important;
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page {
  border-radius: 8px;
  min-width: 34px;
  height: 34px;
  margin: 0 2px;
  font-weight: 600;
  font-size: 0.82rem;
  transition: all 0.15s;
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page.p-highlight {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.3);
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page:not(.p-highlight):hover {
  background: #eff6ff !important;
}

/* Checkbox */
#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box {
  border-radius: 6px;
  border: 2px solid #cbd5e1;
  width: 20px;
  height: 20px;
  transition: all 0.15s;
}

#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box.p-highlight {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  border-color: #0e527d !important;
}

/* Scrollbar */
#CandidateList_CardView .cd-datatable .p-datatable-wrapper::-webkit-scrollbar {
  height: 6px;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive */
@media (max-width: 992px) {
  .cd-hero-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .cd-hero-right {
    align-self: flex-start;
  }
  .cd-controls-top {
    flex-direction: column;
    align-items: stretch;
  }
  .cd-search-wrapper {
    max-width: 100%;
  }
  .cd-controls-right-group {
    margin-left: 0;
  }
  .cd-controls-bottom {
    flex-direction: column;
    align-items: stretch;
  }
  .cd-actions {
    justify-content: flex-start;
  }
}

@media (max-width: 576px) {
  .cd-hero {
    padding: 1.25rem;
    border-radius: 12px;
  }
  .cd-hero-title {
    font-size: 1.25rem;
  }
  .cd-filter-chip-group {
    flex-direction: column;
  }
  .cd-actions {
    flex-direction: column;
  }
  .cd-action-btn {
    width: 100% !important;
    justify-content: center !important;
  }
}

#SecondScreeningContainer {
  height: 500px;
  overflow-y: scroll;
}

/* Telephonic Test Table Sticky Columns Starting */
#TelephonicTest_Table {
  position: relative;
}

#TelephonicTest_Table .rdt_Table,
#TelephonicTest_Table .sc-fLlhyt {
  position: relative;
}

#TelephonicTest_Table .rdt_TableBody {
  position: sticky;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(1) {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(2) {
  position: sticky;
  left: 180px;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(3) {
  position: sticky;
  left: 380px;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {
  position: sticky;
  left: 0;
  top: 0;
  background-color: var(--white);
  z-index: 1;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {
  position: sticky;
  left: 180px;
  top: 0;
  z-index: 1;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {
  position: sticky;
  left: 380px;
  top: 0;
  z-index: 1;
  justify-content: initial;
}

#TelephonicTest_Table .rdt_TableRow:nth-child(even) .rdt_TableCell {
  background-color: var(--white);
}

#TelephonicTest_Table .rdt_TableRow:nth-child(odd) .rdt_TableCell {
  background-color: var(--table-row-bg-light-grey);
}

@media screen and (min-width: 100px) and (max-width: 991px) {
  #TelephonicTest_Table .rdt_TableBody {
    position: relative;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(1) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(2) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(3) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {
    position: relative;
    left: initial;
    top: initial;
  }
}
/* /Telephonic Test Table Sticky Columns Ending */

#SkillLevelConfiguration_TableView .rdt_Table .rdt_TableBody .rdt_TableRow {
  /* border: 2px solid white; */
  /* margin-bottom: 8px;
  margin-top: 8px; */
  padding-top: 5px;
  padding-bottom: 5px;
}
/* ── Bulk Outreach Modal ─────────────────────────────────────── */
.bo-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}
.bo-modal .modal-header {
  padding: 20px 24px 0;
  border: none;
}
.bo-modal .modal-body {
  padding: 0 24px 14px;
  background: linear-gradient(180deg, #f8fbff 0%, #f4f8ff 100%);
}
.bo-modal .modal-footer {
  padding: 18px 24px 22px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}
.bo-modal .modal-content {
  border: 0;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
}
.bo-modal .modal-header {
  padding: 22px 24px 10px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.bo-colored-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.bo-colored-header .btn-close:hover {
  opacity: 1;
}

.sent-email-modal .modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
}

.sent-email-modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.sent-email-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.4;
}

.sent-email-modal-body {
  padding: 16px;
  max-height: 78vh;
  overflow-y: auto;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.sent-email-modal-footer {
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.sent-email-preview-shell {
  width: 100%;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #f8fafc;
}

.email-body-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.email-body-content img {
  max-width: 100% !important;
  height: auto !important;
}

.email-body-content table {
  max-width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.email-body-content td,
.email-body-content th {
  word-break: break-word;
  vertical-align: top;
}

.email-body-content a {
  color: #2563eb;
}

.email-body-content p,
.email-body-content div,
.email-body-content li,
.email-body-content span {
  line-height: 1.55;
}

.email-body-content ul,
.email-body-content ol {
  padding-left: 24px;
  margin-bottom: 1rem;
}

.email-body-content * {
  max-width: 100%;
}

.email-body-content > * {
  margin-left: auto !important;
  margin-right: auto !important;
}

.email-body-content > table,
.email-body-content > div,
.email-body-content > section {
  width: 100%;
}
.bo-tabs {
  display: flex;
  gap: 10px;
  margin: 14px 0 22px;
  border-bottom: 0;
}
.bo-tab {
  flex: 1 1;
  text-align: center;
  padding: 11px 12px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  border: 1px solid #dbe7f5;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s ease;
}
.bo-tab.active {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
}
.bo-tab.done {
  color: #15803d;
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.bo-channel-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
  font-size: 0;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s ease;
}
.bo-channel-btn::after {
  content: "Email";
  font-size: 13px;
  line-height: 1;
}
.bo-channel-btn.wp::after {
  content: "WhatsApp";
}
.bo-channel-btn.active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #2563eb;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);
}
.bo-channel-btn.active.wp {
  border-color: #16a34a;
  background: #f0fdf4;
  color: #16a34a;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.12);
}
.bo-channel-btn svg {
  font-size: 15px;
  flex-shrink: 0;
}
.bo-channel-btn input {
  flex-shrink: 0;
}

.bo-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.bo-input {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 11px 14px;
  font-size: 14px;
  background: #ffffff;
  color: #0f172a;
  outline: none;
  transition: 0.15s ease;
}
.bo-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}
.bo-textarea {
  resize: vertical;
  min-height: 190px;
  font-family: inherit;
}
.bo-input-subject {
  min-height: 48px;
  border-width: 1.5px;
  font-weight: 600;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}
.bo-input-message {
  min-height: 220px;
  line-height: 1.65;
  border-width: 1.5px;
  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 100%);
}
.bo-input-subject::placeholder,
.bo-input-message::placeholder {
  color: #94a3b8;
}
.bo-review-list {
  height: auto;
  min-height: 0;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}
.bo-review-list::-webkit-scrollbar {
  width: 8px;
}
.bo-review-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}
.bo-review-list::-webkit-scrollbar-track {
  background: #f8fafc;
}
.bo-panel {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}
.bo-section-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}
.bo-section-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2563eb;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
  flex-shrink: 0;
}
.bo-section-title {
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  color: #0f172a;
}
.bo-section-subtitle {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.bo-vars {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.bo-var {
  background: #f1f5f9;
  color: #475569;
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 12px;
  font-family: monospace;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  transition: 0.15s;
}
.bo-var:hover {
  background: #e2e8f0;
}

.bo-hint {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 13px;
  color: #9a3412;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 16px;
}

.bo-alert {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 13px;
  color: #1d4ed8;
  margin-bottom: 18px;
}

.bo-info-row {
  display: flex;
  align-items: baseline;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
}
.bo-info-row:last-child {
  border: none;
}
.bo-info-label {
  width: 110px;
  color: #64748b;
  font-size: 13px;
  flex-shrink: 0;
}

.bo-card {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px 20px;
  height: 300px;
  overflow: auto;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}
.bo-card-1 {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px 20px;
  /* height: 300px; */
  /* overflow: auto; */
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.bo-candidate-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.bo-candidate-item:last-child {
  border: none;
}
.bo-avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.bo-check-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 14px;
  cursor: pointer;
}
.bo-check-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
  cursor: pointer;
}

.bo-btn-primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
}
.bo-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24);
}
.bo-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.bo-btn-secondary {
  background: #fff;
  color: #374151;
  border: 1px solid #d6deeb;
  border-radius: 12px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.15s ease;
}
.bo-btn-secondary:hover {
  background: #f8fafc;
  border-color: #bfdbfe;
  color: #1d4ed8;
}
@media (max-width: 767px) {
  .bo-tabs {
    flex-direction: column;
  }
  .bo-modal .modal-body {
    padding: 0 16px 14px;
  }
  .bo-modal .modal-footer {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
  }
  .bo-card,
  .bo-card-1,
  .bo-panel {
    padding: 16px;
  }
}
.cs-root {
  min-height: 100vh;
  background: #eef0f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 16px 48px;
    font-family: 'DM Sans', sans-serif;
}

.cs-card {
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 420px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.10);
  overflow: hidden;
}

/* ── Header Banner ── */
.cs-header {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 60%, #6366f1 100%);
  padding: 28px 24px 32px;
  position: relative;
  overflow: hidden;
}
.cs-header::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -40px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.cs-header::after {
  content: "";
  position: absolute;
  bottom: -30px;
  left: -20px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}
.cs-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.cs-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cs-logo {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.cs-company-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.cs-company-sub {
  color: rgba(255, 255, 255, 0.65);
  font-size: 11px;
  font-weight: 400;
}
.cs-expires {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}
.cs-job-title {
  font-family: "Fraunces", serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 8px;
  line-height: 1.2;
}
.cs-greeting {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  line-height: 1.5;
}
.cs-greeting strong {
  color: #fff;
  font-weight: 600;
}

/* ── Body ── */
.cs-body {
  padding: 24px;
}

/* Info grid */
.cs-info-grid {
  display: grid;
  /* grid-template-columns: 2fr 2fr; */
  gap: 10px;
  margin-bottom: 22px;
}
.cs-info-box {
  background: #f7f8fc;
  border: 1px solid #ebebf0;
  border-radius: 12px;
  padding: 12px 14px;
}
.cs-info-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #9399a6;
  text-transform: uppercase;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cs-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
  line-height: 1.3;
}

/* Section label */
.cs-section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9399a6;
  margin-bottom: 10px;
}

/* About the role */
.cs-about {
  margin-bottom: 22px;
}
.cs-about-text {
  font-size: 13.5px;
  color: #444b5a;
  line-height: 1.65;
  margin-bottom: 10px;
}
.cs-bullet {
  font-size: 13px;
  color: #555e6e;
  line-height: 1.6;
  padding-left: 14px;
  position: relative;
}
.cs-bullet::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #7c3aed;
  font-weight: 700;
}

/* Skills */
.cs-skills {
  margin-bottom: 22px;
}
.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.cs-skill-chip {
  background: #f0f0f8;
  border: 1px solid #ddddf5;
  color: #3d3d8f;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 20px;
}

/* Interview process */
.cs-process {
  margin-bottom: 26px;
}
.cs-round {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: #f7f8fc;
  border: 1px solid #ebebf0;
  border-radius: 12px;
  margin-bottom: 8px;
}
.cs-round:last-child {
  margin-bottom: 0;
}
.cs-round-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #7c3aed;
  color: #7c3aed;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.cs-round-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 2px;
}
.cs-round-sub {
  font-size: 12px;
  color: #8b93a4;
}

/* Divider */
.cs-divider {
  border: none;
  border-top: 1px solid #ebebf0;
  margin: 6px 0 22px;
}

/* CTA section */
.cs-cta-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1d23;
  text-align: center;
  margin-bottom: 5px;
}
.cs-cta-sub {
  font-size: 13px;
  color: #9399a6;
  text-align: center;
  margin-bottom: 18px;
}

/* Response buttons */
.cs-btn-interested {
  width: 100%;
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.18s ease;
  text-align: left;
}
.cs-btn-interested:hover {
  background: #dcfce7;
  border-color: #4ade80;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.15);
}
.cs-btn-interested.selected {
  background: #dcfce7;
  border-color: #22c55e;
}
.cs-btn-decline {
  width: 100%;
  background: #fff;
  border: 1.5px solid #fecaca;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: all 0.18s ease;
  text-align: left;
}
.cs-btn-decline:hover {
  background: #fef2f2;
  border-color: #f87171;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.12);
}
.cs-btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.cs-btn-icon.green {
  background: #22c55e;
}
.cs-btn-icon.red {
  background: #ef4444;
}
.cs-btn-label {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  margin-bottom: 2px;
}
.cs-btn-label.green {
  color: #15803d;
}
.cs-btn-label.red {
  color: #dc2626;
}
.cs-btn-sublabel {
  font-size: 12px;
  color: #8b93a4;
}
.cs-btn-arrow {
  margin-left: auto;
  color: #22c55e;
  font-size: 18px;
  font-weight: 300;
}

/* Schedule slot picker */
.cs-schedule-box {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 10px;
  animation: fadeSlideIn 0.25s ease;
}
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.cs-schedule-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.cs-schedule-icon {
  width: 28px;
  height: 28px;
  background: #22c55e;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.cs-schedule-title {
  font-size: 14px;
  font-weight: 700;
  color: #15803d;
}
.cs-schedule-sub {
  font-size: 12px;
  color: #4ade80;
}
.cs-slot-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 14px;
}
.cs-slot-field label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cs-slot-field input {
  width: 100%;
  padding: 9px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  font-size: 13px;
  font-family: "DM Sans", sans-serif;
  color: #1a1d23;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
}
.cs-slot-field input:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}
.cs-slot-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}
.cs-back-btn {
  background: #fff;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.cs-back-btn:hover {
  background: #f9fafb;
}
.cs-confirm-btn {
  flex: 1 1;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border: none;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.18s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 3px 12px rgba(124, 58, 237, 0.35);
}
.cs-confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
}
.cs-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.cs-slot-error {
  font-size: 12px;
  color: #f59e0b;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Declined state */
.cs-declined-box {
  background: #fef2f2;
  border: 1.5px solid #fecaca;
  border-radius: 14px;
  padding: 16px;
  text-align: center;
  animation: fadeSlideIn 0.25s ease;
}
.cs-declined-icon {
  font-size: 28px;
  margin-bottom: 8px;
}
.cs-declined-title {
  font-size: 15px;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 4px;
}
.cs-declined-sub {
  font-size: 13px;
  color: #9399a6;
}

/* Confirmed state */
.cs-confirmed-box {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  animation: fadeSlideIn 0.25s ease;
}
.cs-confirmed-icon {
  font-size: 36px;
  margin-bottom: 10px;
}
.cs-confirmed-title {
  font-size: 16px;
  font-weight: 700;
  color: #15803d;
  margin-bottom: 4px;
}
.cs-confirmed-sub {
  font-size: 13px;
  color: #6b7280;
}

/* Privacy note */
.cs-privacy {
  text-align: center;
  font-size: 12px;
  color: #9399a6;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* Footer */
.cs-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #9399a6;
}
.cs-footer a {
  color: #6366f1;
  font-weight: 600;
  text-decoration: none;
}
.cs-root {
  min-height: 100vh;
  background: linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 40px;
  font-family: "Segoe UI", sans-serif;
}
.cs-card {
  width: 100%;
  max-width: 820px;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 16px 50px rgba(15, 23, 42, 0.12);
}
.cs-header {
  padding: 20px 20px 10px 20px;
  background: linear-gradient(135deg, #0f766e 0%, #155e75 100%);
  color: #fff;
}
.cs-kicker {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.8;
  margin-bottom: 8px;
}
.cs-company-name {
  font-size: 15px;
  font-weight: 600;
  opacity: 0.92;
  margin-bottom: 8px;
}
.cs-job-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 10px;
}
.cs-greeting {
  font-size: 14px;
  line-height: 1.6;
  opacity: 0.95;
  max-width: 680px;
}
.cs-body {
  padding: 28px;
}
.cs-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}
.cs-info-box {
  padding: 14px 16px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.cs-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 6px;
}
.cs-info-value {
  font-size: 14px;
  color: #0f172a;
  font-weight: 600;
  line-height: 1.5;
}
.cs-section {
  margin-bottom: 24px;
}
.cs-section-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  margin-bottom: 12px;
}
.cs-about-text {
  color: #334155;
  font-size: 14px;
  line-height: 1.7;
  margin: 0 0 10px;
}
.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.cs-skill-chip {
  padding: 8px 12px;
  border-radius: 999px;
  background: #ecfeff;
  border: 1px solid #a5f3fc;
  color: #155e75;
  font-size: 13px;
  font-weight: 600;
}
.cs-divider {
  border: 0;
  border-top: 1px solid #e2e8f0;
  margin: 24px 0;
}
.cs-cta-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 6px;
}
.cs-cta-sub {
  text-align: center;
  color: #64748b;
  margin-bottom: 20px;
  font-size: 14px;
}
.cs-btn-interested,
.cs-btn-decline {
  width: 100%;
  border-radius: 16px;
  padding: 16px 18px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: 0.2s ease;
}
.cs-btn-interested {
  border: 1px solid #86efac;
  background: #f0fdf4;
  margin-bottom: 12px;
}
.cs-btn-decline {
  border: 1px solid #fecaca;
  background: #fff7f7;
}
.cs-btn-interested.selected {
  background: #dcfce7;
}
.cs-btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
}
.cs-btn-icon.green {
  background: #16a34a;
}
.cs-btn-icon.red {
  background: #dc2626;
}
.cs-btn-label {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}
.cs-btn-sublabel {
  font-size: 13px;
  color: #64748b;
}
.cs-btn-arrow {
  margin-left: auto;
  color: #16a34a;
  font-size: 20px;
}
.cs-schedule-box,
.cs-declined-box,
.cs-confirmed-box {
  border-radius: 16px;
  padding: 18px;
}
.cs-schedule-box {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}
.cs-slot-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}
.cs-slot-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}
.cs-slot-field input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
}
.cs-slot-actions {
  display: flex;
  gap: 10px;
}
.cs-back-btn,
.cs-confirm-btn {
  border-radius: 10px;
  padding: 11px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.cs-back-btn {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.cs-confirm-btn {
  border: 0;
  background: #0f766e;
  color: #fff;
  flex: 1 1;
}

#TemplateForJobOpportunity .btn-success {
  border: 0;
  background: #0f766e !important;
  color: #fff;
}

.cs-slot-error {
  margin-top: 10px;
  color: #b45309;
  font-size: 13px;
  font-weight: 600;
}
.cs-declined-box {
  background: #fef2f2;
  border: 1px solid #fecaca;
  text-align: center;
}
.cs-confirmed-box {
  background: #f0fdf4;
  border: 1px solid #86efac;
  text-align: center;
}
.cs-state-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}
.cs-state-sub {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
}
.cs-privacy {
  text-align: center;
  margin-top: 18px;
  color: #64748b;
  font-size: 13px;
}
.cs-footer {
  margin-top: 16px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}
@media (max-width: 640px) {
  .cs-header,
  .cs-body {
    padding: 20px;
  }
  .cs-job-title {
    font-size: 26px;
  }
  .cs-info-grid,
  .cs-slot-row {
    grid-template-columns: 1fr;
  }
}
.bo-input {
  padding: 6px 30px 6px 10px; /* space for arrow */
  appearance: none; /* remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  border: 1px solid #d4dce7;
  border-radius: 6px;
  font-size: 14px;
  height: 36px;
  /* background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='14' viewBox='0 0 20 20' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.148l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.041a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>"); */
  background-repeat: no-repeat;
  background-position: right 10px center; /* arrow aligned */
  cursor: pointer;
}
.react-select__menu {
  z-index: 99999 !important;
}

.react-select__menu-list {
  z-index: 99999 !important;
}
/* Recruiter Report */
.recruiter-report-page {
  padding: 16px 12px 28px;
  background: radial-gradient(
      circle at top right,
      rgba(59, 130, 246, 0.08),
      transparent 22%
    ),
    linear-gradient(180deg, #f6f9fc 0%, #eef4fb 100%);
  min-height: calc(100vh - 110px);
}

.recruiter-report-hero {
  background: radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.22),
      transparent 18%
    ),
    linear-gradient(135deg, #163b8c 0%, #155e75 45%, #0f172a 100%);
  border-radius: 28px;
  padding: 22px 24px;
  color: #fff;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.18);
}

.recruiter-report-hero-copy {
  flex: 1 1 560px;
}

.recruiter-report-eyebrow {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.78;
  font-weight: 700;
  margin-bottom: 6px;
}

.recruiter-report-title {
  font-size: 32px;
  font-weight: 800;
  line-height: 1.05;
}

.recruiter-report-subtitle {
  font-size: 14px;
  opacity: 0.92;
  line-height: 1.55;
  max-width: 760px;
}

.recruiter-report-company-card {
  min-width: 250px;
  max-width: 300px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  padding: 12px;
  backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.recruiter-report-company-label {
  font-size: 11px;
  margin-bottom: 6px;
  display: block;
  opacity: 0.92;
  font-weight: 700;
}

.recruiter-report-loading,
.recruiter-report-error {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dbe7f5;
  border-radius: 22px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.06);
}

.recruiter-report-loading {
  padding: 40px 18px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.recruiter-report-loading-text {
  margin-top: 12px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.recruiter-report-error {
  color: #be123c;
  padding: 16px;
}

.recruiter-report-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.recruiter-summary-card {
  border-radius: 22px;
  padding: 18px 16px;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.recruiter-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);
}

.recruiter-summary-card-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.recruiter-summary-value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
}

.recruiter-summary-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  margin-top: 8px;
}

.recruiter-summary-accent {
  width: 34px;
  height: 34px;
  border-radius: 12px;
}

.recruiter-panel,
.recruiter-breakdown-panel {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #dbe7f5;
  border-radius: 24px;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.06);
}

.recruiter-panel {
  padding: 18px;
  height: 100%;
}

.recruiter-panel-header,
.recruiter-breakdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.recruiter-panel-header {
  margin-bottom: 16px;
}

.recruiter-panel-title {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-panel-kicker,
.recruiter-breakdown-count {
  font-size: 11px;
  color: #64748b;
  font-weight: 700;
}

.recruiter-snapshot-list,
.recruiter-metrics-list {
  display: grid;
  gap: 12px;
}

.recruiter-snapshot-card {
  display: grid;
  grid-template-columns: 48px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 16px 18px;
  border-radius: 20px;
  border: 1px solid #e5edf8;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.03);
}

.recruiter-avatar,
.recruiter-table-avatar {
  background: linear-gradient(135deg, #2563eb 0%, #0f766e 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  flex-shrink: 0;
}

.recruiter-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.recruiter-snapshot-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-snapshot-meta {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
}

.recruiter-progress-track,
.recruiter-table-bartrack {
  margin-top: 9px;
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.recruiter-progress-bar {
  height: 100%;
  border-radius: 999px;
}

.recruiter-snapshot-side {
  text-align: right;
}

.recruiter-snapshot-score {
  font-size: 20px;
  font-weight: 800;
  color: #2563eb;
  line-height: 1;
}

.recruiter-snapshot-side-label,
.recruiter-table-subtext,
.recruiter-breakdown-subtitle,
.recruiter-empty-state {
  font-size: 10px;
  color: #64748b;
}

.recruiter-snapshot-side-label {
  margin-top: 4px;
}

.recruiter-metric-card {
  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);
  border: 1px solid #e5edf8;
  border-radius: 16px;
  padding: 14px 15px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.02);
}

.recruiter-metric-title {
  font-size: 12px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 4px;
}

.recruiter-metric-desc {
  font-size: 12px;
  color: #475569;
}

.recruiter-breakdown-panel {
  overflow: hidden;
}

.recruiter-breakdown-header {
  padding: 18px;
  border-bottom: 1px solid #e5edf8;
}

.recruiter-breakdown-subtitle {
  margin-top: 4px;
}

.recruiter-breakdown-table-wrap {
  overflow-x: auto;
}

.recruiter-breakdown-table {
  width: 100%;
}

.recruiter-breakdown-table thead {
  background: #f8fbff;
}

.recruiter-breakdown-table th {
  padding: 14px 16px;
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  border-bottom: 1px solid #e5edf8;
  white-space: nowrap;
}

.recruiter-breakdown-table tbody tr.is-alt td {
  background: #fcfdff !important;
}

.recruiter-table-person {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recruiter-table-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 13px;
}

.recruiter-table-name {
  color: #0f172a;
  font-weight: 200;
}

.recruiter-table-barcell {
  min-width: 90px;
}

.recruiter-table-barvalue {
  color: #0f172a;
  font-weight: 700;
}

.recruiter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.recruiter-chip-warn {
  color: #b45309;
  background: #fff7ed;
}

.recruiter-chip-pink {
  color: #be185d;
  background: #fdf2f8;
}

.recruiter-chip-blue {
  color: #1d4ed8;
  background: #eff6ff;
}

.recruiter-chip-teal {
  color: #0f766e;
  background: #ecfeff;
}

.recruiter-chip-green {
  color: #15803d;
  background: #f0fdf4;
}

.recruiter-empty-table {
  padding: 24px;
  text-align: center;
  color: #64748b;
}

@media (max-width: 991px) {
  .recruiter-report-hero {
    border-radius: 22px;
    padding: 18px 16px;
  }

  .recruiter-report-title {
    font-size: 26px;
  }

  .recruiter-report-company-card {
    width: 100%;
    max-width: none;
  }

  .recruiter-panel,
  .recruiter-breakdown-panel {
    border-radius: 20px;
  }
}

@media (max-width: 640px) {
  .recruiter-report-page {
    padding: 12px 6px 24px;
  }

  .recruiter-report-title {
    font-size: 22px;
  }

  .recruiter-summary-card,
  .recruiter-panel {
    border-radius: 18px;
  }

  .recruiter-snapshot-card {
    grid-template-columns: 44px 1fr;
  }

  .recruiter-snapshot-side {
    grid-column: 2;
    text-align: left;
  }
}

/* Recruiter Report Refinements */
.recruiter-report-page {
  padding: 14px 14px 28px;
  background: radial-gradient(
      circle at top left,
      rgba(14, 165, 233, 0.08),
      transparent 24%
    ),
    radial-gradient(
      circle at right 20%,
      rgba(37, 99, 235, 0.07),
      transparent 18%
    ),
    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
}

.recruiter-report-hero {
  position: relative;
  overflow: hidden;
  /* min-height: 152px; */
  margin-bottom: 14px;
  padding: 20px 22px 16px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.12);
}

.recruiter-report-hero-copy,
.recruiter-report-company-card {
  position: relative;
  z-index: 2;
}

.recruiter-report-hero-copy {
  max-width: 820px;
}

.recruiter-report-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  letter-spacing: 0.16em;
}

.recruiter-report-title {
  margin-top: 12px;
  margin-bottom: 6px !important;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
  color: #ffffff;
}

.recruiter-report-subtitle {
  max-width: 720px;
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
}

.recruiter-report-hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.recruiter-report-hero-pill {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
  min-width: 118px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.recruiter-report-hero-pill-highlight {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.14) 0%,
    rgba(59, 130, 246, 0.18) 100%
  );
}

.recruiter-report-hero-pill-value {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.1;
  color: #ffffff;
}

.recruiter-report-company-card {
  min-width: 260px;
  max-width: 290px;
  padding: 14px;
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
}

.recruiter-report-company-label {
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.68);
}

.recruiter-report-company-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
}

.recruiter-report-company-footnote {
  margin-top: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.74);
}

.recruiter-report-company-card .form-select,
.recruiter-report-company-card select,
.recruiter-report-company-card .form-control {
  min-height: 46px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: none;
}

.recruiter-report-filter-bar {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1.2fr) repeat(
      2,
      minmax(160px, 0.8fr)
    ) auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 14px;
  padding: 14px 16px;
  border-radius: 20px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.recruiter-report-filter-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 90px;
  padding: 12px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #f2f7fd 100%);
  border: 1px solid #dbe7f3;
}

.recruiter-report-filter-summary-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-report-filter-summary-value {
  margin-top: 5px;
  font-size: 20px;
  line-height: 1.15;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-report-filter-summary-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}

.recruiter-report-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.recruiter-report-filter-group-wide {
  min-width: 0;
}

.recruiter-report-filter-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-report-filter-input {
  min-height: 40px;
  border-radius: 12px;
  border: 1px solid #d7e3f1;
  background: #f8fbff;
  color: #0f172a;
  box-shadow: none;
}

.recruiter-report-filter-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);
  background: #ffffff;
}

.recruiter-report-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.recruiter-report-filter-chip {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-report-filter-chip-soft {
  background: #f8fafc;
  color: #475569;
}

.recruiter-report-filter-reset {
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 12px;
  border: 1px solid #d7e3f1;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-report-filter-reset:hover {
  background: #f8fbff;
  border-color: #bfd3ea;
}

.recruiter-report-hero-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  opacity: 0.55;
}

.recruiter-report-hero-orb-one {
  top: -40px;
  right: 220px;
  width: 160px;
  height: 160px;
  background: radial-gradient(
    circle,
    rgba(14, 165, 233, 0.42) 0%,
    rgba(14, 165, 233, 0) 72%
  );
}

.recruiter-report-hero-orb-two {
  right: -20px;
  bottom: -36px;
  width: 220px;
  height: 220px;
  background: radial-gradient(
    circle,
    rgba(37, 99, 235, 0.34) 0%,
    rgba(37, 99, 235, 0) 72%
  );
}

.recruiter-report-loading,
.recruiter-report-error {
  min-height: 180px;
  border-radius: 22px;
  border: 1px solid #dce8f5;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(246, 250, 255, 0.98) 100%
  );
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.06);
}

.recruiter-report-loading {
  gap: 14px;
}

.recruiter-report-loading-text {
  font-size: 15px;
  font-weight: 600;
  color: #47617d;
}

.recruiter-report-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 14px;
}

.recruiter-summary-card {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
}

.recruiter-summary-card::after {
  content: "";
  position: absolute;
  inset: auto -18px -18px auto;
  width: 88px;
  height: 88px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.24);
}

.recruiter-summary-card-inner {
  position: relative;
  z-index: 1;
  min-height: 74px;
}

.recruiter-summary-value {
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.recruiter-summary-label {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #47617d;
}

.recruiter-summary-accent {
  width: 38px;
  height: 38px;
  border-radius: 14px;
}

.recruiter-insight-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.recruiter-insight-item {
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.recruiter-insight-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-insight-value {
  margin-top: 8px;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-insight-value-small {
  font-size: 15px;
}

.recruiter-panel,
.recruiter-breakdown-panel {
  border-radius: 20px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(12px);
}

.recruiter-panel-header,
.recruiter-breakdown-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px 12px;
}

.recruiter-panel-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.recruiter-panel-subtitle,
.recruiter-breakdown-subtitle {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.recruiter-panel-kicker,
.recruiter-breakdown-count {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-snapshot-list,
.recruiter-metrics-list {
  padding: 0 18px 18px;
}

.recruiter-snapshot-list {
  display: grid;
  gap: 12px;
}

.recruiter-snapshot-card {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.recruiter-rank-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 999px;
  background: #e8f1ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.recruiter-snapshot-main {
  min-width: 0;
}

.recruiter-snapshot-card:hover,
.recruiter-metric-card:hover,
.recruiter-summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);
}

.recruiter-avatar,
.recruiter-table-avatar {
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
}

.recruiter-progress-track,
.recruiter-table-bartrack {
  height: 8px;
  background: #e8eef7;
}

.recruiter-snapshot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.recruiter-inline-chip {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.recruiter-inline-chip-violet {
  background: #f5f3ff;
  color: #7c3aed;
}

.recruiter-inline-chip-blue {
  background: #eff6ff;
  color: #2563eb;
}

.recruiter-snapshot-score {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-snapshot-side {
  min-width: 110px;
  text-align: right;
}

.recruiter-snapshot-side-label {
  font-size: 11px;
  color: #64748b;
}

.recruiter-metrics-list {
  display: grid;
  gap: 12px;
}

.recruiter-metrics-list-tight {
  gap: 10px;
}

.recruiter-scope-card {
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #dbe7f3;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);
}

.recruiter-scope-title {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-scope-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.recruiter-scope-k {
  display: block;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-scope-v {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  word-break: break-word;
}

.recruiter-metric-card {
  position: relative;
  overflow: hidden;
  padding: 12px 14px 12px;
  border-radius: 14px;
}

.recruiter-metric-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(180deg, #2563eb 0%, #0f766e 100%);
}

.recruiter-breakdown-header {
  padding-bottom: 18px;
}

.recruiter-breakdown-table thead {
  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fd 100%);
}

.recruiter-breakdown-table th {
  font-size: 10.5px;
  letter-spacing: 0.08em;
}

.recruiter-breakdown-table td {
  font-size: 13px;
}

.recruiter-breakdown-table tbody td {
  vertical-align: middle;
}

.recruiter-breakdown-table tbody tr:hover td {
  background: #f8fbff !important;
}

.recruiter-chip {
  min-width: 44px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);
}

.recruiter-detail-modal .modal-content {
  overflow: hidden;
  border: 1px solid rgba(191, 219, 254, 0.8);
  border-radius: 24px;
  background: radial-gradient(
      circle at top right,
      rgba(59, 130, 246, 0.12),
      transparent 28%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);
}

.recruiter-detail-modal .modal-dialog {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.recruiter-detail-modal-header {
  position: relative;
  padding: 22px 24px 14px !important;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 56%, #f0fdf4 100%);
  border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;
}

.recruiter-detail-modal-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-right: 64px;
}

.recruiter-detail-modal-header::after {
  content: "";
  position: absolute;
  inset: auto 24px 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(37, 99, 235, 0.2),
    rgba(16, 185, 129, 0.16)
  );
}

.recruiter-detail-modal-heading {
  min-width: 0;
  flex: 1 1 auto;
}

.recruiter-detail-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
}

.recruiter-detail-modal-title {
  font-size: 1.12rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.recruiter-detail-modal-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
  font-size: 0;
  color: #64748b;
}

.recruiter-detail-modal-meta > span {
  font-size: 0.9rem;
}

.recruiter-detail-modal-dot {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: #94a3b8;
}

.recruiter-detail-modal-count {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.08);
  color: #1d4ed8;
  font-size: 0.78rem;
  font-weight: 700;
}

.recruiter-detail-modal .btn-close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 34px;
  height: 34px;
  margin: 0 !important;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.86);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  opacity: 1;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.recruiter-detail-modal .btn-close:hover {
  transform: rotate(90deg);
  background-color: #ffffff;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
}

.recruiter-detail-modal-export {
  min-height: 42px;
  padding: 10px 16px;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 12px;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.recruiter-detail-modal-export:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(29, 78, 216, 0.28);
}

.recruiter-detail-modal-export:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.recruiter-detail-modal-body {
  padding: 18px 24px 24px !important;
  max-height: 68vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.7) transparent;
}

.recruiter-detail-modal-body::-webkit-scrollbar {
  width: 10px;
}

.recruiter-detail-modal-body::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.65);
  background-clip: padding-box;
}

.recruiter-detail-modal-table-wrap {
  overflow: hidden;
  border: 1px solid #dbe7f3;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.recruiter-detail-modal-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);
  white-space: nowrap;
  font-size: 0.8rem;
  font-weight: 800;
  color: #334155;
  border-bottom: 1px solid #dbeafe;
  border-right: 1px solid #e2e8f0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.recruiter-detail-modal-table tbody td {
  border-color: #edf2f7;
  transition: background-color 0.18s ease;
}

.recruiter-detail-modal-table tbody tr:nth-child(even) td {
  background: rgba(248, 251, 255, 0.72);
}

.recruiter-detail-modal-table tbody tr:hover td {
  background: #eff6ff;
}

.recruiter-detail-modal-empty {
  padding: 42px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);
  text-align: center;
  color: #64748b;
  font-weight: 600;
}

@media (max-width: 991px) {
  .recruiter-report-page {
    padding: 16px 10px 28px;
  }

  .recruiter-report-filter-bar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recruiter-report-filter-summary {
    grid-column: 1 / -1;
  }

  .recruiter-report-filter-actions {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }

  .recruiter-report-hero {
    min-height: auto;
    padding: 20px 18px 18px;
  }

  .recruiter-report-title {
    font-size: 28px;
  }

  .recruiter-report-hero-meta {
    gap: 10px;
  }

  .recruiter-report-hero-pill {
    min-width: calc(50% - 10px);
  }

  .recruiter-insight-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recruiter-detail-modal-body {
    padding: 16px 16px 18px !important;
  }

  .recruiter-detail-modal-header-row {
    flex-direction: column;
    align-items: flex-start;
    padding-right: 56px;
  }

  .recruiter-detail-modal-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  .recruiter-report-page {
    padding: 12px 4px 24px;
  }

  .recruiter-report-hero {
    border-radius: 24px;
    padding: 18px 14px 16px;
  }

  .recruiter-report-title {
    font-size: 24px;
  }

  .recruiter-report-subtitle {
    font-size: 13px;
  }

  .recruiter-report-hero-pill,
  .recruiter-report-company-card {
    width: 100%;
    max-width: none;
  }

  .recruiter-report-filter-bar {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .recruiter-insight-strip,
  .recruiter-scope-grid {
    grid-template-columns: 1fr;
  }

  .recruiter-panel-header,
  .recruiter-breakdown-header,
  .recruiter-snapshot-list,
  .recruiter-metrics-list {
    padding-left: 14px;
    padding-right: 14px;
  }

  .recruiter-snapshot-card {
    grid-template-columns: 1fr;
  }

  .recruiter-snapshot-side {
    text-align: left;
  }

  .recruiter-rank-badge {
    position: static;
    width: fit-content;
    margin-bottom: 8px;
  }

  .recruiter-detail-modal .modal-content {
    border-radius: 18px;
  }

  .recruiter-detail-modal-header {
    padding: 18px 16px 12px !important;
  }

  .recruiter-detail-modal-heading {
    width: 100%;
  }

  .recruiter-detail-modal-title {
    font-size: 1rem;
  }

  .recruiter-detail-modal-meta {
    gap: 8px;
    font-size: 0.82rem;
  }

  .recruiter-detail-modal .btn-close {
    top: 14px;
    right: 14px;
  }
}
.recruiter-report-filter-summary-value {
  min-height: 22px;
  display: inline-flex;
  align-items: center;
}

.ModalStickyTabs {
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.activeBorder {
  border-bottom: 3px solid #2563eb !important;
}

.inActiveBorder {
  border: 1px solid #dbe7f3 !important;
}
.addCandidateBtn {
  display: flex;
  align-items: center;
  gap: 6px;

  border: none;
  background: transparent;

  color: #1976d2;
  font-size: 14px;
  font-weight: 600;

  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;

  transition: all 0.2s ease;
}

.addCandidateBtn:hover {
  background-color: rgba(25, 118, 210, 0.08);
}

.addCandidateHeaderBtn {
  display: flex;
  align-items: center;
  gap: 4px;

  border: none;
  background: transparent;
  color: inherit;
}
.manager-pipeline-panel .p-card-body,
.manager-pipeline-panel .p-card-content {
  overflow: hidden !important;
  padding: 12px !important;
  height: 100%;
  box-sizing: border-box;
}
.candidate-modal .modal-content {
  height: 85vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}
.candidate-modal .modal-body {
  overflow: hidden;
}
.candidate-modal .modal-dialog {
  display: flex;
  align-items: center;
  min-height: 100vh;
  margin: 0 auto;
}
.candidate-modal .modal-content {
  height: 85vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}
#ExpandBtn {
  position: absolute;
  right: 40px;
  top: 10px;
  z-index: 1050;
}

/* .CreateJobOrderFooter {
  position: absolute;
  top:80px;
  right: 0;
  z-index: 1050;
  background: red;
  width: 100px;
} */
.cs-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.cs-tabs button {
  padding: 8px 14px;
  border: 1px solid #ddd;
  background: #f8fafc;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
}

.cs-tabs button.active {
  background: #103d63;
  color: #fff;
  border-color: #103d63;
  border-radius: 40px;
}
/* Full-screen initial loader shown before the React app mounts. */
#global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f7fbff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.loader-logo {
  width: 150px;
  height: 150px;
  max-width: 46vw;
  max-height: 46vw;
  object-fit: contain;
  animation: loader-logo-float 1.35s ease-in-out infinite;
}

@keyframes loader-logo-float {
  0%,
  100% {
    transform: translateY(0) rotateY(360deg) scale(0.96);
    opacity: 0.78;
  }
  50% {
    transform: translateY(-8px) rotateY(180deg) scale(1.04);
    opacity: 1;
  }
}

/* .calendar-container {
  display: flex;
  height: 500px;
}

.calendar-left {
  width: 40%;
  padding: 20px;
  border-right: 1px solid #eee;
}

.calendar-right {
  width: 60%;
  padding: 20px;
  overflow-y: auto;
}

.slots {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.slot-btn {
  border: 1px solid #0d6efd;
  background: white;
  color: #0d6efd;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  font-weight: 500;
}

.slot-btn:hover {
  background: #e7f1ff;
}

.slot-btn.active {
  background: #0d6efd;
  color: white;
} */

.cs-root {
  min-height: 100vh;
  background: #f0f4f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 40px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
}

.cs-card {
  width: 100%;
  max-width: 640px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.cs-header {
  background: linear-gradient(135deg, #103d63 0%, #1a5a90 100%);
  padding: 24px 24px 20px;
}

.cs-kicker {
  display: inline-block;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 20px;
}

.cs-body {
  padding: 20px 20px 24px;
}

@media (min-width: 480px) {
  .cs-body {
    padding: 24px 28px 28px;
  }
  .cs-header {
    padding: 20px 28px 6px;
  }
}

.cs-section {
  margin-bottom: 16px;
}

.cs-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #3e4b5f;
  margin-bottom: 6px;
}

.cs-about-text {
  font-size: 14px;
  color: #374151;
  line-height: 1.65;
  margin: 0 0 6px;
}

.cs-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
  border-bottom: 2px solid #f1f5f9;
  padding-bottom: 0;
}

.cs-tabs button {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 0;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.cs-tabs button.active {
  border-bottom-color: #103d63;
}

.cs-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}

@media (min-width: 480px) {
  .cs-info-grid {
    /* grid-template-columns: repeat(4, 1fr); gap: 12px; */
  }
}

.cs-info-box {
  background: #f8fafc;
  border: 1px solid #e9eef4;
  border-radius: 10px;
  padding: 10px 12px;
}

.cs-info-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
  margin-bottom: 3px;
}

.cs-info-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
}

.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cs-skill-chip {
  background: #e8f4fd;
  color: #0e5fa3;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

.cs-divider {
  border: none;
  border-top: 1px solid #f1f5f9;
  margin: 16px 0;
}

.cs-cta-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
  text-align: center;
}

.cs-cta-sub {
  font-size: 13px;
  color: #64748b;
  text-align: center;
  margin-bottom: 16px;
}

.cs-btn-interested,
.cs-btn-decline {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1.5px solid;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
  margin-bottom: 10px;
  text-align: left;
  background: #fff;
}

.cs-btn-interested {
  border-color: #22c55e;
}
.cs-btn-interested:hover {
  background: #f0fdf4;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);
}

.cs-btn-decline {
  border-color: #f87171;
}
.cs-btn-decline:hover {
  background: #fff5f5;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(248, 113, 113, 0.15);
}

.cs-btn-icon {
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}
.cs-btn-icon.green {
  background: #22c55e;
}
.cs-btn-icon.red {
  background: #f87171;
}

.cs-btn-label {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.cs-btn-sublabel {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.cs-btn-arrow {
  margin-left: auto;
  font-size: 22px;
  color: #cbd5e1;
}

.cs-declined-box,
.cs-confirmed-box {
  background: #f8fafc;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  margin-bottom: 12px;
}

.cs-state-title {
  font-size: 16px;
  font-weight: 700;
  color: #103d63;
  margin-bottom: 6px;
}

.cs-state-sub {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.cs-privacy {
  font-size: 11px;
  color: #cbd5e1;
  text-align: center;
  margin-top: 12px;
}

.cs-footer {
  margin-top: 20px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

/* ── Schedule Modal ── */
.sched-modal .modal-dialog {
  margin: 0 auto;
  max-width: 860px;
  width: 100%;
}

@media (max-width: 767px) {
  .sched-modal .modal-dialog {
    margin: 0;
    max-width: 100%;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .sched-modal .modal-content {
    border-radius: 20px 20px 0 0 !important;
    max-height: 92vh;
    overflow-y: auto;
  }
}

.sched-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.sched-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: #e8f4fd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #0069ff;
}

.sched-company {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 2px;
}
.sched-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

@media (min-width: 480px) {
  .sched-title {
    max-width: 340px;
  }
}

.sched-close {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: #9ca3af;
  line-height: 1;
  padding: 4px 6px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sched-subheader {
  padding: 14px 20px 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.sched-body {
  display: flex;
  flex-direction: column;
  padding: 14px 20px 20px;
  gap: 20px;
}

@media (min-width: 640px) {
  .sched-body {
    flex-direction: row;
    gap: 24px;
  }
}

.sched-calendar {
  width: 100%;
}

@media (min-width: 640px) {
  .sched-calendar {
    width: 280px;
    min-width: 280px;
  }
}

.sched-divider-v {
  display: none;
}
@media (min-width: 640px) {
  .sched-divider-v {
    display: block;
    width: 1px;
    background: #f1f5f9;
    flex-shrink: 0;
  }
}

.sched-divider-h {
  display: block;
  height: 1px;
  background: #f1f5f9;
  width: 100%;
}
@media (min-width: 640px) {
  .sched-divider-h {
    display: none;
  }
}

.sched-slots {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.sched-slots-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 10px;
}

.sched-slots-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  overflow-y: auto;
  max-height: 260px;
  padding-right: 2px;
}

@media (min-width: 640px) {
  .sched-slots-grid {
    grid-template-columns: 1fr;
    max-height: 300px;
  }
}

.sched-slot-btn {
  padding: 11px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.1s, background 0.1s;
  white-space: nowrap;
}

.sched-footer {
  padding: 14px 20px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sched-footer-btns {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.sched-footer-btns button {
  flex: 1 1;
  max-width: 200px;
  padding: 11px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-height: 44px;
}

.sched-btn-cancel {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
}

.sched-btn-confirm {
  border: none;
  background: #0069ff;
  color: #fff;
}
.sched-btn-confirm:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.sched-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #b91c1c;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cal nav */
.cal-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.cal-nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  font-size: 18px;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  min-width: 44px;
}

.cal-month-label {
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.cal-days-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 6px;
}

.cal-day-name {
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.04em;
  padding: 3px 0;
}

.cal-days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px 0;
}

.cal-day-btn {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 13px;
  cursor: pointer;
  min-height: 36px;
  min-width: 36px;
}
.offer-letter-modal .modal-dialog {
  max-width: 1200px; /* Increase width */
  margin-top: 30px; /* Distance from top */
}

.offer-letter-modal .modal-content {
  min-height: 85vh; /* Taller modal */
}

.offer-letter-modal .modal-body {
  max-height: calc(85vh - 140px);
  overflow-y: auto;
}
.sun-editor-editable[contenteditable="true"] .se-component {
  outline: "" !important;
}
#OfferLetterModal .btn-close {
  color: white !important;
}
.offer-letter-modal .modal-header .btn-close {
  filter: invert(1) brightness(2);
}
.sun-editor-editable p {
  border: none !important;
}
.table tbody tr:hover {
  background: #f8fafc;
}

.nav-tabs .nav-link.active {
  font-weight: 600;
  color: #12395c !important;
}

.card {
  border-radius: 12px;
}

.modal-content {
  border-radius: 12px;
}
/* Remove SunEditor's default dashed border on inserted images */
.sun-editor-editable img,
.sun-editor img,
#OfferLetterModal .sun-editor-editable img,
#OfferLetterModal .sun-editor img {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.jor-page {
  --bg: #f6f7f9;
  --surface: #ffffff;
  --line: #e4e7ec;
  --line-soft: #eef0f3;
  --text: #13202e;
  --muted: #5f6b7a;
  --faint: #98a2b1;
  --navy: #000053;
  --orange: #ee751d;
  --orange-hover: #d4661a;
  --orange-soft: #fdeedd;
  --accent: #1f4fd8;
  --accent-soft: #eef3fe;
  --green: #0f9d58;
  --green-soft: #e9f7ef;
  --amber: #b97509;
  --amber-soft: #fdf4e3;
  --red: #d23b3b;
  --red-soft: #fdeeee;
  --radius: 10px;
  --font-display: "Manrope", sans-serif;
  --font-body: "Inter", sans-serif;
  font-family: var(--font-body);
  background: var(--bg);
  color: var(--text);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  position: relative;
}
.jor-page * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.jor-page button {
  font: inherit;
  cursor: pointer;
}

.jor-page .content {
  padding: 22px 24px 32px;
  width: 100%;
  margin: 0 auto;
}
.jor-page .page-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.jor-page .page-head h1 {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.01em;
  color: var(--navy);
}
.jor-page .page-head .sub {
  color: var(--muted);
  font-size: 13.5px;
  margin-top: 3px;
}

.jor-page .selbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px 16px;
  margin-bottom: 18px;
}
.jor-page .selbar .lbl {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--faint);
}
.jor-page .selbar select {
  height: 40px;
  min-width: 280px;
  padding: 0 12px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--navy);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .selbar select:focus {
  outline: none;
  border-color: var(--orange);
  box-shadow: 0 0 0 3px var(--orange-soft);
}
.jor-page .selbar .meta {
  font-size: 13px;
  color: var(--muted);
}
.jor-page .selbar .meta b {
  color: var(--navy);
}

.jor-page .stat-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 18px;
}
.jor-page .stat-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
}
.jor-page .stat-card .sc-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line-soft);
}
.jor-page .stat-card .sc-head .ico {
  width: 40px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.jor-page .stat-card .sc-head .ico.blue {
  background: var(--accent-soft);
  color: var(--accent);
}
.jor-page .stat-card .sc-head .ico.orange {
  background: var(--orange-soft);
  color: var(--orange);
}
.jor-page .stat-card .sc-head .ico.green-ico {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .stat-card .sc-head h3 {
  font-family: var(--font-display);
  font-size: 14.5px;
  font-weight: 700;
  color: var(--navy);
}
.jor-page .stat-card .sc-body {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.jor-page .stat-card .sc-item {
  padding: 14px 16px;
  border-right: 1px solid var(--line-soft);
}
.jor-page .stat-card .sc-item:last-child {
  border-right: none;
}
.jor-page .stat-card .sc-item .v {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.02em;
}
.jor-page .stat-card .sc-item .v.green {
  color: var(--green);
}
.jor-page .stat-card .sc-item .v.amber {
  color: var(--amber);
}
.jor-page .stat-card .sc-item .v.gray {
  color: var(--faint);
}
.jor-page .stat-card .sc-item .l {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.jor-page .panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
}
.jor-page .toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line-soft);
}
.jor-page .toolbar .lbl {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--faint);
}
.jor-page .toolbar select {
  height: 36px;
  padding: 0 10px;
  font: inherit;
  font-size: 13.5px;
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .toolbar input[type="date"] {
  height: 36px;
  padding: 0 10px;
  font: inherit;
  font-size: 13px;
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .toolbar select:focus,
.jor-page .toolbar input[type="date"]:focus {
  outline: none;
  border-color: var(--orange);
}
.jor-page .toolbar .reset {
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  color: var(--muted);
  font-weight: 500;
  font-size: 13px;
}
.jor-page .toolbar .reset:hover {
  background: var(--bg);
  color: var(--text);
}
.jor-page .toolbar .right {
  margin-left: auto;
  display: flex;
  gap: 10px;
  align-items: center;
}
.jor-page .t-search {
  position: relative;
}
.jor-page .t-search svg {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--faint);
}
.jor-page .t-search input {
  height: 36px;
  width: 220px;
  padding: 0 10px 0 32px;
  font: inherit;
  font-size: 13.5px;
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--text);
}
.jor-page .t-search input:focus {
  outline: none;
  border-color: var(--orange);
  box-shadow: 0 0 0 3px var(--orange-soft);
}
.jor-page .btn-export {
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  color: var(--muted);
  font-weight: 500;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.jor-page .btn-export:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-soft);
}

.jor-page table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.jor-page thead th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--faint);
  padding: 11px 14px;
  border-bottom: 1px solid var(--line-soft);
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  background: #fcfcfd;
  vertical-align: bottom;
}
.jor-page thead th.sortable {
  cursor: pointer;
}
.jor-page thead th.sortable:hover {
  color: var(--muted);
}
.jor-page thead th .arrow {
  font-size: 10px;
  margin-left: 3px;
}
.jor-page thead tr.grouprow th {
  font-size: 10px;
  text-align: left;
  color: var(--navy);
  border-bottom: none;
  padding-bottom: 2px;
  letter-spacing: 0.05em;
}
.jor-page thead tr.grouprow th.gsep {
  border-left: 1px solid var(--line-soft);
}
.jor-page tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
  white-space: nowrap;
}
.jor-page tbody tr:last-child td {
  border-bottom: none;
}
.jor-page tbody tr:hover td {
  background: #fafbfc;
}
.jor-page td.gsep,
.jor-page th.gsep {
  border-left: 1px solid var(--line-soft);
}

.jor-page .person {
  display: flex;
  align-items: center;
  gap: 10px;
}
.jor-page .person .avatar {
  width: 30px;
  height: 30px;
  font-size: 11.5px;
}
.jor-page .person .p-name {
  font-weight: 600;
}
.jor-page .person .p-sub {
  font-size: 12px;
  color: var(--faint);
}
.jor-page .jobtag {
  font-size: 12px;
  color: var(--faint);
}
.jor-page .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex: none;
}

.jor-page .badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
  white-space: nowrap;
}
.jor-page .badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.jor-page .badge.green {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .badge.amber {
  background: var(--amber-soft);
  color: var(--amber);
}
.jor-page .badge.blue {
  background: var(--accent-soft);
  color: var(--accent);
}
.jor-page .badge.gray {
  background: var(--line-soft);
  color: var(--muted);
}
.jor-page .badge.red {
  background: var(--red-soft);
  color: var(--red);
}
.jor-page .badge.navy {
  background: #e6e6f2;
  color: var(--navy);
}

.jor-page .tl {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 210px;
}
.jor-page .tl .step {
  display: grid;
  grid-template-columns: 8px 78px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
}
.jor-page .tl .step .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
  background: var(--line);
  position: relative;
}
.jor-page .tl .step.done .dot {
  background: var(--green);
}
.jor-page .tl .step.sched .dot {
  background: var(--amber);
}
.jor-page .tl .step.sent .dot {
  background: var(--accent);
}
.jor-page .tl .step .lab {
  color: var(--muted);
  white-space: nowrap;
}
.jor-page .tl .step .time {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
}
.jor-page .tl .step.pending .lab,
.jor-page .tl .step.pending .time {
  color: var(--faint);
  font-weight: 400;
}
.jor-page .tl .step .time.muted {
  color: var(--faint);
  font-weight: 400;
}

.jor-page .res-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px dashed var(--line);
}
.jor-page .score {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 13px;
  color: var(--navy);
  font-variant-numeric: tabular-nums;
}
.jor-page .score .den {
  color: var(--faint);
  font-weight: 600;
  font-size: 12px;
}
.jor-page .res-chip {
  font-size: 11.5px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}
.jor-page .res-chip.pass {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .res-chip.fail {
  background: var(--red-soft);
  color: var(--red);
}
.jor-page .res-chip.pend {
  background: var(--amber-soft);
  color: var(--amber);
}
.jor-page .scorebar {
  flex: 1 1;
  height: 5px;
  border-radius: 3px;
  background: var(--line-soft);
  overflow: hidden;
  min-width: 40px;
}
.jor-page .scorebar i {
  display: block;
  height: 100%;
  border-radius: 3px;
}
.jor-page .scorebar i.pass {
  background: var(--green);
}
.jor-page .scorebar i.fail {
  background: var(--red);
}

.jor-page .locked {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: var(--faint);
  font-size: 12.5px;
  line-height: 1.45;
  padding: 2px 0;
}
.jor-page .locked svg {
  flex: none;
  margin-top: 1px;
  color: var(--faint);
}
.jor-page .locked .lk-title {
  font-weight: 600;
  color: var(--muted);
}
.jor-page .badge.lock {
  background: var(--line-soft);
  color: var(--faint);
}
.jor-page .badge.lock::before {
  display: none;
}

.jor-page .table-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--line-soft);
  font-size: 13px;
  color: var(--muted);
  flex-wrap: wrap;
  gap: 10px;
}
.jor-page .rows-per {
  display: flex;
  align-items: center;
  gap: 8px;
}
.jor-page .rows-per select {
  height: 30px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  padding: 0 8px;
  font: inherit;
  font-size: 13px;
}
.jor-page .pager {
  display: flex;
  gap: 4px;
}
.jor-page .pager button {
  min-width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--muted);
  font-size: 13px;
}
.jor-page .pager button:hover:not(:disabled) {
  background: var(--bg);
}
.jor-page .pager button.cur {
  background: var(--navy);
  color: #fff;
  border-color: var(--navy);
  font-weight: 600;
}
.jor-page .pager button:disabled {
  opacity: 0.4;
  cursor: default;
}
.jor-page .empty {
  padding: 36px 18px;
  text-align: center;
  color: var(--faint);
  font-size: 13.5px;
}

.jor-page .toast {
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%) translateY(8px);
  background: var(--navy);
  color: #fff;
  font-size: 13.5px;
  font-weight: 500;
  padding: 10px 18px;
  border-radius: 999px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s, transform 0.2s;
  z-index: 60;
}
.jor-page .toast.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@media (max-width: 1100px) {
  .jor-page .stat-groups {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .jor-page * {
    transition: none !important;
  }
}

.test-result-modal .modal-content {
  border: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #f6f8fb;
}

.talent-scan-result-dialog.p-dialog {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  background: #f6f8fb;
}

.talent-scan-result-dialog .p-dialog-header {
  padding: 14px 18px;
  border: 0;
  color: #fff;
  background: #1976ad;
}

.talent-scan-result-dialog .p-dialog-title {
  min-width: 0;
}

.talent-scan-result-dialog .p-dialog-header-icons {
  flex: 0 0 auto;
}

.talent-scan-result-dialog .p-dialog-header-close {
  color: #fff;
}

.talent-scan-result-dialog .p-dialog-content {
  max-height: 75vh;
  overflow-y: auto;
  padding: 16px;
  background: #f6f8fb;
}

.test-result-modal-header {
  position: sticky;
  top: 0;
  z-index: 10;
  align-items: center;
  padding: 14px 18px;
  border: 0;
  color: #fff;
  background: #1976ad;
}

.test-result-modal-header .modal-title {
  min-width: 0;
}

.test-result-modal-header .btn-close {
  flex: 0 0 auto;
  margin: 0;
  opacity: 0.85;
  filter: brightness(0) invert(1);
}

.test-result-modal-header .btn-close:hover {
  opacity: 1;
}

.test-result-modal-heading {
  min-width: 0;
}

.test-result-modal-title {
  overflow: hidden;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-result-modal-candidate-contact {
  overflow: hidden;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-result-modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding: 16px;
  background: #f6f8fb;
}

.test-result-modal-footer {
  justify-content: center;
  display: flex;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #d8e1eb;
  background: #fff;
}

.ts-result-list,
.ts-result-content,
.ts-result-section-list {
  display: flex;
  flex-direction: column;
}

.ts-result-list {
  gap: 16px;
}

.ts-result-shell {
  border: 1px solid #d8e1eb;
  border-radius: 16px;
  overflow: hidden;
  background: #f6f8fb;
}

.ts-result-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: #0c447c;
}

.ts-result-header-main {
  min-width: 0;
}

.ts-result-title {
  color: #e6f1fb;
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.ts-result-subtitle {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 5px;
  color: #b7daf9;
  font-size: 12px;
}

.ts-result-header-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.ts-result-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.ts-result-badge.success,
.ts-result-score-pill.good {
  color: #27500a;
  background: #eaf3de;
}

.ts-result-badge.danger,
.ts-result-score-pill.low {
  color: #791f1f;
  background: #fcebeb;
}

.ts-result-badge.warning {
  color: #633806;
  background: #faeeda;
}

.ts-result-badge.info,
.ts-result-score-pill.mid {
  color: #0c447c;
  background: #e6f1fb;
}

.ts-result-badge.neutral {
  color: #444441;
  background: #f1efe8;
}

.ts-result-content {
  gap: 14px;
  padding: 16px;
  background: #f6f8fb;
}

.ts-result-section-label {
  margin-bottom: 8px;
  /* color: #7b8794; */
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.ts-result-card {
  padding: 14px 16px;
  border: 1px solid #d8e1eb;
  border-radius: 12px;
  background: #fff;
}

.ts-result-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
}

.ts-result-card.ts-result-grid-2 {
  overflow: hidden;
  padding: 0;
  border-color: #c7d2df;
}

.ts-result-info-table {
  overflow: hidden;
  padding: 0;
  border-color: #c7d2df;
}

.ts-result-info-table-heading {
  padding: 8px 12px;
  border-bottom: 1px solid #c7d2df;
  color: #0c447c;
  background: #edf5fc;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.ts-result-info-table .ts-result-grid-2 + .ts-result-info-table-heading {
  border-top: 1px solid #c7d2df;
}

.ts-result-kv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 30px;
  padding: 8px 12px;
  border-right: 1px solid #d8e1eb;
  border-bottom: 1px solid #d8e1eb;
}

.ts-result-kv-row:nth-child(even) {
  border-right: 0;
}

.ts-result-kv-row:nth-last-child(-n + 2) {
  border-bottom: 0;
}

.ts-result-kv-key {
  color: #667085;
  font-size: 12px;
}

.ts-result-kv-val {
  max-width: 58%;
  color: #172033;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}

.ts-result-kv-val.timeline {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 9px;
  border: 1px solid #b9d7ef;
  border-radius: 999px;
  color: #0c447c;
  background: #eaf4fc;
  box-shadow: 0 2px 5px rgba(24, 95, 165, 0.12);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.ts-result-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.ts-result-metrics.ts-result-metrics-four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ts-result-metric {
  position: relative;
  overflow: hidden;
  min-height: 72px;
  padding: 14px 16px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  box-shadow: 0 2px 7px rgba(23, 32, 51, 0.06);
}

.ts-result-metric::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: currentColor;
  content: "";
  opacity: 0.75;
}

.ts-result-metric.info,
.ts-result-metric.mid {
  color: #0c447c;
  border-color: #b9d7ef;
  background: #f0f7fd;
}

.ts-result-metric.good {
  color: #27500a;
  border-color: #b8d698;
  background: #f2f8e9;
}

.ts-result-metric.low {
  color: #991b1b;
  border-color: #f0b8b8;
  background: #fff3f3;
}

.ts-result-metric.advanced {
  color: #26215c;
  background: #eeedfe;
}

.ts-result-metric.neutral {
  color: #172033;
  background: #fff;
  border: 1px solid #e5ebf1;
}

.ts-result-metric-val {
  color: currentColor;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.2;
}

.ts-result-metric-label {
  margin-top: 5px;
  color: #475467;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ts-result-dict-row {
  display: grid;
  grid-template-columns: minmax(120px, 160px) 1fr minmax(82px, auto) minmax(
      66px,
      auto
    );
  align-items: center;
  gap: 10px;
  min-height: 34px;
  padding: 7px 0;
  border-bottom: 1px solid #e5ebf1;
}

.ts-result-dict-row:last-child {
  border-bottom: 0;
}

.ts-result-dict-name {
  color: #172033;
  font-size: 12px;
  font-weight: 600;
}

.ts-result-bar,
.ts-result-level-bar {
  overflow: hidden;
  border: 1px solid #d8e1eb;
  border-radius: 999px;
  background: #eef2f6;
}

.ts-result-bar {
  height: 6px;
}

.ts-result-bar-fill {
  height: 100%;
  border-radius: inherit;
}

.ts-result-bar-fill.good {
  background: #639922;
}

.ts-result-bar-fill.mid {
  background: #185fa5;
}

.ts-result-bar-fill.low {
  background: #e24b4a;
}

.ts-result-score-pill {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.ts-result-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
  /* color: #7b8794; */
  font-size: 11px;
  font-weight: 600;
}

.ts-result-legend-item,
.ts-result-level-head {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.ts-result-legend-item {
  color: #667085;
  font-weight: 500;
}

.ts-result-legend-item span,
.ts-result-level-head span {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex: 0 0 auto;
}

.ts-result-legend-item.beginner span,
.ts-result-level.beginner .ts-result-level-head span,
.ts-result-level.beginner .ts-result-level-bar div {
  background: #639922;
}

.ts-result-legend-item.intermediate span,
.ts-result-level.intermediate .ts-result-level-head span,
.ts-result-level.intermediate .ts-result-level-bar div {
  background: #185fa5;
}

.ts-result-legend-item.advanced span,
.ts-result-level.advanced .ts-result-level-head span,
.ts-result-level.advanced .ts-result-level-bar div {
  background: #534ab7;
}

.ts-result-section-list {
  gap: 8px;
}

.ts-result-section-card {
  display: grid;
  grid-template-columns:
    minmax(260px, 300px)
    minmax(180px, 240px)
    minmax(360px, 1fr);
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #cbd7e4;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(23, 32, 51, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ts-result-section-card:hover {
  border-color: #aebdcd;
  box-shadow: 0 4px 12px rgba(23, 32, 51, 0.08);
}

.ts-result-section-card.cheated {
  border: 2px solid #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.ts-result-section-card.cheated .ts-result-section-name-col,
.ts-result-section-card.cheated .ts-result-section-score-col,
.ts-result-section-card.cheated .ts-result-level {
  background: #fff7f7;
}

.ts-result-section-top {
  display: contents;
}

.ts-result-section-name-col {
  padding: 12px 14px;
  border-right: 1px solid #d8e1eb;
  background: #fbfcfe;
}

.ts-result-section-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  color: #101828;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.25;
}

.ts-result-cheated-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 9px;
  border-radius: 999px;
  color: #fff;
  background: #dc2626;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}

.ts-result-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.ts-result-chip-row > span:not(.ts-result-badge) {
  padding: 3px 8px;
  border: 1px solid #d6e0eb;
  border-radius: 999px;
  color: #344054;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.25;
}

.ts-result-chip-row.status {
  margin-top: 7px;
}


.ts-result-level-head {
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ts-result-section-score-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-right: 1px solid #d8e1eb;
  height: 100%;
  background: #f8fbff;
}

.ts-result-big-score {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
}

.ts-result-big-score span {
  color: #475467;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0;
}

.ts-result-big-score strong {
  color: #12639a;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  margin: 1px 0;
}

.ts-result-big-score small {
  color: #344054;
  font-size: 11px;
  line-height: 1.3;
  margin: 0;
}
.ts-result-section-bar-wrap {
  flex: 1 1 auto;
  min-width: 110px;
}

.ts-result-section-bar-label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
  /* color: #7b8794; */
  font-size: 11px;
}

.ts-result-section-bar-label .good {
  color: #27500a;
}

.ts-result-section-bar-label .mid {
  color: #0c447c;
}

.ts-result-section-bar-label .low {
  color: #791f1f;
}

.ts-result-levels {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: stretch;
}

.ts-result-level {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 12px 14px;
  border-right: 1px solid #d8e1eb;
  border-top: 3px solid transparent;
}

.ts-result-level:last-child {
  border-right: 0;
}

.ts-result-level-head {
  margin-bottom: 7px;
  color: #344054;
  font-size: 9px;
}

.ts-result-level-score-label {
  margin-bottom: 3px;
  color: #667085;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
}

.ts-result-level-score {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 4px;
}

.ts-result-level-score strong {
  font-size: 17px;
  line-height: 1;
}

.ts-result-level.beginner {
  border-top-color: #639922;
  background: #fbfdf8;
}

.ts-result-level.intermediate {
  border-top-color: #185fa5;
  background: #f8fbff;
}

.ts-result-level.advanced {
  border-top-color: #534ab7;
  background: #faf9ff;
}

.ts-result-level > small {
  color: #475467;
  font-size: 11px;
  font-weight: 600;
}

.ts-result-level.beginner .ts-result-level-score strong {
  color: #639922;
}

.ts-result-level.intermediate .ts-result-level-score strong {
  color: #185fa5;
}

.ts-result-level.advanced .ts-result-level-score strong {
  color: #534ab7;
}

.ts-result-level-score span {
  /* color: #7b8794; */
  font-size: 11px;
}

.ts-result-level-bar {
  height: 4px;
}

.ts-result-level-bar div {
  height: 100%;
}

.ts-result-level-empty {
  color: #b91c1c;
  font-size: 13px;
}

.ts-result-section-extra {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid #d8e1eb;
}

.ts-result-section-extra div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  border-right: 1px solid #d8e1eb;
}

.ts-result-section-extra div:last-child {
  border-right: 0;
}

.ts-result-section-extra span {
  color: #7b8794;
  font-size: 10px;
}

.ts-result-section-extra strong {
  color: #172033;
  font-size: 11px;
}

.ts-result-cheated-note {
  grid-column: 1 / -1;
  padding: 9px 14px;
  border-top: 1px solid #dc2626;
  color: #991b1b;
  background: #fee2e2;
  font-size: 12px;
  font-weight: 700;
}

.ts-result-actions {
  display: flex;
  justify-content: center;
}

.ts-result-detail-btn,
.ts-result-close-btn {
  min-height: 34px;
  padding: 7px 20px;
  border: 1px solid #185fa5 !important;
  border-radius: 8px !important;
  color: #0c447c !important;
  background: #e6f1fb !important;
  font-size: 13px;
  font-weight: 700;
}

.ts-result-close-btn {
  border-color: #cbd5e1 !important;
  color: #172033 !important;
  background: #f8fafc !important;
}

.ts-result-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 260px;
  padding: 48px 24px;
  color: #667085;
  text-align: center;
}

.ts-result-empty-icon {
  width: 56px;
  height: 56px;
  border: 2px solid #d8e1eb;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0c447c;
  background: #e6f1fb;
  font-size: 24px;
  font-weight: 800;
  font-family: Georgia, serif;
}

.ts-result-empty-title {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
}

.ts-result-empty-copy {
  max-width: 300px;
  font-size: 14px;
}

@media (max-width: 991.98px) {
.ts-result-grid-2,
.ts-result-levels,
.ts-result-section-extra {
  grid-template-columns: repeat(2, 1fr);
}

.ts-result-metrics {
  grid-template-columns: repeat(3, 1fr);
}

  .ts-result-kv-row:nth-last-child(-n + 2) {
    border-bottom: 1px solid #e5ebf1;
  }

  .ts-result-kv-row:last-child {
    border-bottom: 0;
  }

  .ts-result-section-top {
    display: contents;
  }

  .ts-result-section-card {
    grid-template-columns: 1fr;
  }

  .ts-result-section-name-col,
  .ts-result-section-score-col,
  .ts-result-level,
  .ts-result-section-extra div {
    border-right: 0;
  }

  .ts-result-section-name-col,
  .ts-result-section-score-col,
  .ts-result-level {
    border-bottom: 1px solid #d8e1eb;
  }

  .ts-result-dict-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

@media (max-width: 575.98px) {
  .test-result-modal-body,
  .ts-result-content {
    padding: 12px;
  }

  .ts-result-header,
  .ts-result-section-score-col {
    flex-direction: column;
  }

  .ts-result-header-badges {
    justify-content: flex-start;
  }

  .ts-result-kv-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }

  .ts-result-kv-val {
    max-width: 100%;
    text-align: left;
  }
}
.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  color: #667085;
  font-size: 14px;
}

.search-box input[type="search"] {
  width: 300px;
  padding: 10px 14px 10px 36px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  transition: all 0.3s ease;
}

.search-box input[type="search"]:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
  outline: none;
}
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.right input[type="search"] {
  width: 280px;
  padding: 10px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  background: #fff;
}

.right input[type="search"]:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.right input[type="search"]::placeholder {
  color: #98a2b3;
}
.count-bubble {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--navy, #000053);
  background: #eef1f6;
  border: 1px solid var(--line, #e4e7ec);
  border-radius: 999px;
  padding: 4px 12px;
  white-space: nowrap;
}
.count-bubble b {
  color: var(--orange, #ee751d);
  font-weight: 700;
}
.cutoff-bubble {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--orange, #ee751d);
  background: #fff4e6;
  border: 1px solid #ffd9b3;
  border-radius: 999px;
  padding: 2px 10px;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.cutoff-bubble b {
  color: var(--orange, #ee751d);
}
  .job-title-filter-dropdown.p-dropdown {
    background: #fff !important;
    border: 1px solid #ced4da !important;
    box-shadow: none !important;
    min-height: 31px;
  }
  .job-title-filter-dropdown .p-dropdown-label {
    background: transparent !important;
    color: #212529 !important;
    font-weight: 400 !important;
    padding: 4px 8px !important;
    text-shadow: none !important;
  }
  .job-title-filter-dropdown .p-dropdown-label.p-placeholder {
    color: #6c757d !important;
  }
  .job-title-filter-dropdown .p-dropdown-clear-icon {
    color: #6c757d !important;
    right: 2rem;
  }
  .job-title-filter-dropdown .p-dropdown-trigger {
    color: #6c757d !important;
  }
  .job-title-filter-dropdown:not(.p-disabled):hover {
    border-color: #adb5bd !important;
  }
  .job-title-filter-dropdown:not(.p-disabled).p-focus {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25) !important;
  }

  #TelephonicTest_Table .rdt_TableHead {
    z-index: 1;
  }
.swal-on-top {
  z-index: 99999 !important;
}

.swal2-popup .ats-swal-title {
  font-size: 18px !important;
  line-height: 1.3 !important;
}

.swal2-popup .ats-swal-text {
  font-size: 16px !important;
  line-height: 1.45 !important;
}

.import-step-card {
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(15, 76, 129, 0.08);
  padding: 18px;
}

.import-step-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.import-step-header h6 {
  margin: 0 0 4px;
  color: #0f4c81;
  font-size: 20px;
  font-weight: 800;
}

.import-step-header p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.import-duplicate-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.import-option-card {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 10px;
  align-items: flex-start;
  min-height: 104px;
  padding: 14px;
  border: 1px solid #dbe4f0;
  border-radius: 9px;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.import-option-card.active {
  border-color: #0f6fa8;
  background: #eff6ff;
  box-shadow: 0 10px 22px rgba(15, 111, 168, 0.12);
}

.import-option-card strong {
  display: block;
  color: #0f172a;
  font-size: 13.5px;
  margin-bottom: 4px;
}

.import-option-card small {
  display: block;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
}

.import-step-field {
  display: grid;
  gap: 7px;
  max-width: 520px;
}

.import-step-field label {
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.import-step-field small {
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
}

.import-step-field .form-select,
.import-step-field .p-treeselect,
.import-step-field .p-inputtext {
  min-height: 38px;
  border-radius: 7px;
  font-size: 13px;
}

.import-tag-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.import-step-field-full {
  max-width: none;
  grid-column: 1 / -1;
}

.import-stage-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.import-stage-pills label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #dbe4f0;
  border-radius: 999px;
  background: #f8fafc;
  color: #334155;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.import-stage-pills label.active {
  border-color: #0f6fa8;
  background: #eff6ff;
  color: #0f4c81;
}

.import-step-field .p-inputgroup {
  max-width: 520px;
}

.edit-profile-dialog.p-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22);
}

.edit-profile-dialog .p-dialog-header {
  min-height: 54px;
  padding: 15px 20px !important;
  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%) !important;
  color: #ffffff !important;
  border: 0 !important;
}

.edit-profile-dialog .p-dialog-title {
  color: #ffffff !important;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
}

.edit-profile-dialog .p-dialog-header-icon,
.edit-profile-dialog .p-dialog-header-close {
  color: #ffffff !important;
  width: 34px;
  height: 34px;
  border-radius: 8px;
}

.edit-profile-dialog .p-dialog-header-icon:hover,
.edit-profile-dialog .p-dialog-header-close:hover {
  background: rgba(255, 255, 255, 0.14) !important;
}

.edit-profile-dialog .p-dialog-content {
  padding: 0 !important;
  overflow-x: hidden !important;
  background: #f8fafc !important;
}

.edit-profile-body {
  padding: 20px;
  overflow-x: hidden;
}

.edit-profile-dialog .row {
  margin-left: 0;
  margin-right: 0;
}

.edit-profile-dialog [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.edit-profile-form {
  display: grid;
  gap: 16px;
}

.edit-profile-form > .flex.flex-wrap {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px !important;
  margin-bottom: 0 !important;
}

.edit-profile-form > .flex.flex-wrap:nth-of-type(3) {
  grid-template-columns: 1fr;
}

.edit-profile-form .flex-auto {
  min-width: 0;
  width: 100%;
}

.edit-profile-form label {
  margin-bottom: 6px !important;
  color: #334155;
  font-size: 12.5px;
  font-weight: 700;
}

.edit-profile-form .p-inputtext,
.edit-profile-form .p-dropdown,
.edit-profile-form .p-multiselect {
  width: 100%;
  min-height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
  box-shadow: none !important;
}

.edit-profile-form .p-inputtext:enabled:focus,
.edit-profile-form .p-dropdown:not(.p-disabled).p-focus,
.edit-profile-form .p-multiselect:not(.p-disabled).p-focus {
  border-color: #0f6fa8;
  box-shadow: 0 0 0 3px rgba(15, 111, 168, 0.12) !important;
}

.edit-profile-form .p-dropdown-label,
.edit-profile-form .p-multiselect-label {
  padding: 8px 12px;
  font-size: 13px;
}

.edit-profile-form .p-multiselect-label {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  white-space: normal;
  line-height: 1.3;
}

.edit-profile-form .p-multiselect-token {
  max-width: 100%;
  margin: 0;
  border-radius: 999px;
  background: #e8eef5;
  color: #334155;
  font-size: 12px;
}

.edit-profile-form .p-multiselect-token-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-profile-dialog .p-dialog-footer {
  padding: 12px 20px !important;
  border-top: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  overflow-x: hidden !important;
}

.edit-profile-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
}

.edit-profile-footer .p-button {
  min-width: 96px;
  height: 36px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
}

.edit-profile-footer .p-button-text {
  color: #0f4c81 !important;
  background: #ffffff !important;
  border: 1px solid #bfdbfe !important;
}

.edit-profile-footer .p-button-raised {
  border: 0 !important;
  background: var(--blue-gradient-right) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

@media (max-width: 900px) {
  .edit-profile-form > .flex.flex-wrap {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 992px) {
  .import-duplicate-grid,
  .import-tag-grid {
    grid-template-columns: 1fr;
  }
}

#VitelMeetLink{

}

.interview-popup .from-width .p-dropdown-trigger {
  display: none !important;
}

.interview-popup .from-width.p-dropdown {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #fff !important;
}

.interview-popup .from-width.p-dropdown:hover,
.interview-popup .from-width.p-dropdown.p-focus {
  background: #fff !important;
  border-color: #ced4da !important;
  box-shadow: none !important;
}

.interview-popup .from-width .p-dropdown-label {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-right: 8px !important;
  color: #111827 !important;
  text-align: center !important;
}

.interview-popup .from-width.p-dropdown:hover .p-dropdown-label,
.interview-popup .from-width.p-dropdown.p-focus .p-dropdown-label {
  color: #111827 !important;
  background: transparent !important;
}

.interview-popup label[for="interview"] {
  display: block !important;
  width: auto;
  min-height: 0;
  margin: 0 0 6px !important;
  text-align: left !important;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 34px;
  row-gap: 12px;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row {
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  column-gap: 12px;
  align-items: flex-start;
  margin: 0;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-1,
.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-11 {
  flex: initial;
  max-width: none;
  width: auto;
  padding-left: 0;
  padding-right: 0;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-11 {
  min-width: 0;
  padding-left: 0;
}

.interview-popup .label-input {
  width: 100%;
}

.interview-popup .label-input .p-dropdown,
.interview-popup .label-input label {
  width: 100%;
}

.interview-popup .label-input .p-dropdown,
.interview-popup .label-input label,
.interview-popup label[for="interview"] {
  border-radius: 6px !important;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row.size-mail.mt-2 {
  grid-column: 1 / -1;
  margin-top: 0 !important;
  align-items: center !important;
  column-gap: 8px;
}

.interview-popup .form-insidepop p:empty {
  display: none !important;
  margin: 0 !important;
}

.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row.size-mail.mt-2 > .col-xl-11 > div > div {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.interview-popup .form-insidepop > .row:not(.mb-2) {
  margin-top: 4px;
}

.interview-popup .form-insidepop > .row:not(.mb-2) > .col-xl-12 {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.interview-popup .popup-header-bg {
  margin: 0 0 12px;
  padding: 12px 14px;
  border-radius: 8px;
  border-bottom: 1px solid #dbe4f0;
  background: #f4f7fb;
}

.interview-popup .bg-form.form-insidepop {
  padding: 18px 14px 14px;
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: none;
}

.interview-popup .email-inline-fields {
  width: 100%;
}

.interview-popup .email-inline-fields .from-width.p-dropdown,
.interview-popup .email-inline-fields label[for="interview"] {
  min-height: 38px !important;
  border: 1px solid #7db7e8 !important;
  background: #e8f3ff !important;
  color: #0f4e7a !important;
  font-weight: 700 !important;
  box-shadow: inset 0 0 0 1px rgba(15, 78, 122, 0.04) !important;
}

.interview-popup .email-inline-fields .from-width .p-dropdown-label {
  color: #0f4e7a !important;
  font-weight: 700 !important;
}

.interview-popup .email-inline-fields .p-chips,
.interview-popup .email-inline-fields .p-inputtext {
  width: 100% !important;
  min-width: 0 !important;
}

.interview-popup .email-inline-fields .to-recipient-chips .p-chips-multiple-container,
.interview-popup .email-inline-fields .email-recipient-chips .p-chips-multiple-container {
  width: 100% !important;
  min-height: 38px !important;
  height: 38px !important;
  resize: none !important;
  overflow-y: hidden !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  align-content: center !important;
  border-color: #b7d6f0 !important;
  background: #f8fbff !important;
}

.interview-popup .email-inline-fields .to-recipient-chips .p-chips-token,
.interview-popup .email-inline-fields .email-recipient-chips .p-chips-token {
  max-width: 100% !important;
  background: #dff0ff !important;
  color: #0f4e7a !important;
  border: 1px solid #a7d0f2 !important;
}

.interview-popup .email-inline-fields .p-inputtext {
  height: 38px !important;
  border-color: #b7d6f0 !important;
  background: #ffffff !important;
  color: #111827 !important;
}

.interview-popup .to-recipient-chips .p-chips-multiple-container,
.interview-popup .email-recipient-chips .p-chips-multiple-container {
  min-height: 38px;
  height: 38px;
  max-height: 180px;
  padding: 6px 8px !important;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  gap: 5px;
  overflow-y: auto;
  overflow-x: hidden;
  cursor: pointer;
  resize: vertical;
}

.interview-popup .to-recipient-chips .p-chips-multiple-container {
  height: 62px;
  max-height: 180px;
}

.interview-popup .to-recipient-chips .p-chips-token,
.interview-popup .email-recipient-chips .p-chips-token {
  max-width: 235px;
  min-height: 24px;
  margin: 0 !important;
  padding: 2px 8px !important;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #eef3f7;
  color: #1f2937;
  cursor: pointer;
}

.interview-popup .to-recipient-chips .p-chips-token span,
.interview-popup .to-recipient-chips .p-chips-token .p-chips-token-label,
.interview-popup .email-recipient-chips .p-chips-token span,
.interview-popup .email-recipient-chips .p-chips-token .p-chips-token-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.interview-popup .to-recipient-chips .p-chips-input-token,
.interview-popup .email-recipient-chips .p-chips-input-token {
  flex: 1 0 120px;
  min-width: 120px;
  margin: 0 !important;
  padding: 0 !important;
}

.interview-popup .to-recipient-chips .p-chips-input-token input,
.interview-popup .email-recipient-chips .p-chips-input-token input {
  width: 100% !important;
  min-height: 24px;
  padding: 0 !important;
}

/* Keep every recipient visible in the email composer, including the legacy size-mail fields. */
.interview-popup .size-mail.p-chips .p-chips-multiple-container {
  width: 100% !important;
  min-height: 38px !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  align-content: center !important;
  gap: 5px;
  padding: 6px 8px !important;
}

.interview-popup .size-mail.p-chips .p-chips-token {
  max-width: calc(100% - 12px) !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
}

.interview-popup .editorpage,
.interview-popup .jobsall-editor {
  margin-top: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.interview-popup .editorpage .p-editor-container,
.interview-popup .jobsall-editor .p-editor-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
  box-sizing: border-box;
}

.interview-popup .editorpage .p-editor-toolbar,
.interview-popup .jobsall-editor .p-editor-toolbar {
  border-color: #dbe4f0 !important;
  border-radius: 8px 8px 0 0 !important;
  background: #f8fafc !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.interview-popup .editorpage .p-editor-content,
.interview-popup .jobsall-editor .p-editor-content {
  border-color: #dbe4f0 !important;
  border-radius: 0 0 8px 8px !important;
  background: #ffffff !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow: hidden;
}

.interview-popup .editorpage .ql-editor,
.interview-popup .jobsall-editor .ql-editor {
  min-height: 220px;
  max-height: 310px;
  overflow-y: auto;
  padding: 14px 16px !important;
  color: #334155;
  font-size: 14px;
  line-height: 1.55;
}

.interview-popup .email-signature-block {
  display: block !important;
  clear: both;
  margin-top: 10px;
  padding-top: 4px;
  max-width: 360px;
}

.interview-popup .email-signature-block img {
  max-width: 180px !important;
  max-height: 70px !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
  display: block !important;
  margin: 6px 0 !important;
}

.interview-popup .email-signature-block table {
  width: auto !important;
  max-width: 100% !important;
}

.interview-popup .signature-dropdown {
  min-width: 280px !important;
  width: 280px !important;
}

.email-dialog-host {
  display: contents;
}

.email-compose-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(2px);
}

.email-compose-modal {
  width: min(1160px, calc(100vw - 48px));
  height: min(820px, calc(100vh - 48px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #d6dee8;
  border-radius: 14px;
  background: #f8fafc;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.24);
}

.email-compose-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid #dbe3ee;
  background: #ffffff;
}

.email-compose-modal-header h2 {
  margin: 0;
  color: #12385f;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: 0;
}

.email-compose-modal-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.email-compose-header-actions {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.email-compose-header-actions .signature-dropdown {
  width: 240px !important;
  min-width: 220px !important;
}

.email-compose-header-actions .signature-dropdown.p-dropdown {
  height: 38px !important;
  border-color: #cbd5e1 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-header-actions .signature-dropdown.p-dropdown:hover,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-inputwrapper-focus {
  border-color: #94a3b8 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-header-actions .signature-dropdown .p-dropdown-label,
.email-compose-header-actions .signature-dropdown.p-dropdown:hover .p-dropdown-label,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus .p-dropdown-label {
  color: #1f2937 !important;
  background: transparent !important;
}

.email-compose-header-actions .p-fileupload-choose {
  height: 38px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  color: #12385f !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.email-compose-header-actions .p-fileupload-choose:hover {
  background: #f8fafc !important;
  border-color: #94a3b8 !important;
}

.email-compose-close {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1dae6;
  border-radius: 9px;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
}

.email-compose-close:hover {
  background: #eef4fb;
  color: #12385f;
}

.email-compose-modal-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
}

.email-compose-modal-footer {
  padding: 14px 20px;
  border-top: 1px solid #d9e6f2;
  background: #ffffff;
}

.email-compose-dialog .p-dialog-header {
  background: linear-gradient(90deg, #eaf4ff 0%, #f7fbff 100%) !important;
  border-bottom: 1px solid #cfe1f4 !important;
  padding: 16px 20px !important;
}

.email-compose-dialog .p-dialog-title {
  color: #0f3f6e !important;
  font-size: 20px !important;
  font-weight: 700 !important;
}

.email-compose-dialog .p-dialog-content {
  background: #f4f8fc !important;
  padding: 18px !important;
}

.email-compose-dialog .p-dialog-footer {
  padding: 14px 20px !important;
  border-top: 1px solid #d9e6f2 !important;
  background: #ffffff !important;
}

.email-compose-dialog .preview-btn {
  min-width: 112px !important;
  height: 40px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: #126fb3 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 18px rgba(18, 111, 179, 0.22) !important;
}

.email-compose-dialog .email-compose-shell {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 100%;
}

.email-compose-dialog .email-compose-toolbar {
  width: 100%;
  margin: 0 !important;
  padding: 10px 12px !important;
  border: 1px solid #d9e2ec !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: none;
}

.email-compose-dialog .email-compose-toolbar .p-fileupload-choose {
  height: 38px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  background: #f8fafc !important;
  color: #12385f !important;
  font-weight: 700 !important;
}

.email-compose-dialog .signature-dropdown {
  min-width: 260px !important;
  width: 280px !important;
}

.email-compose-dialog .bg-form.form-insidepop {
  padding: 12px !important;
  border: 1px solid #d9e2ec !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-dialog .email-inline-fields {
  grid-template-columns: minmax(240px, 0.9fr) minmax(260px, 1fr) minmax(220px, 0.8fr) minmax(300px, 1.15fr) !important;
  gap: 12px !important;
  overflow-x: visible !important;
  padding: 0 0 8px !important;
}

.email-compose-dialog .email-inline-fields > div {
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #ffffff;
}

.email-compose-dialog .email-inline-fields .from-width.p-dropdown,
.email-compose-dialog .email-inline-fields label[for="interview"] {
  border-color: #cbd5e1 !important;
  background: #f1f5f9 !important;
  color: #12385f !important;
}

.email-compose-dialog .email-inline-fields .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .p-inputtext {
  border-color: #cbd5e1 !important;
  background: #ffffff !important;
}

.email-compose-dialog .email-attachment-panel {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
  padding: 8px 10px;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #ffffff;
}

.email-compose-dialog .email-attachment-label {
  margin: 0;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.email-compose-dialog .email-attachment-list {
  display: flex;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
}

.email-compose-dialog .email-attachment-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: min(100%, 520px);
  padding: 6px 10px;
  border: 1px solid #d1dae6;
  border-radius: 999px;
  background: #ffffff;
  color: #12385f;
  box-shadow: inset 0 0 0 1px rgba(15, 78, 122, 0.03);
}

.email-compose-dialog .email-attachment-chip .pi-file {
  color: #12385f;
}

.email-compose-dialog .email-attachment-chip .pi-times {
  color: #dc2626;
  cursor: pointer;
}

.email-compose-dialog .email-no-attachments {
  flex: 1 1;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
}

.email-compose-dialog .email-include-jd {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-left: auto;
  padding: 5px 9px;
  border: 1px solid #d1dae6;
  border-radius: 8px;
  background: #f8fafc;
  color: #12385f;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.email-compose-dialog .email-include-jd label {
  margin: 0;
  cursor: pointer;
}

.email-compose-dialog .email-compose-editor-row {
  margin-top: 10px;
}

.email-compose-dialog .editorpage .p-editor-toolbar {
  background: #ffffff !important;
  border-color: #d9e2ec !important;
}

.email-compose-dialog .editorpage .p-editor-content {
  border-color: #d9e2ec !important;
}

.email-compose-dialog .editorpage .ql-editor {
  min-height: 250px !important;
  max-height: 340px !important;
  color: #1f2937 !important;
}

.email-compose-modal {
  width: min(1080px, calc(100vw - 56px));
  background: #ffffff;
}

.email-compose-modal-body {
  background: #f8fafc;
}

.email-compose-dialog .email-compose-shell {
  gap: 12px;
}

.email-compose-dialog .email-compose-toolbar {
  padding: 10px 12px !important;
  border-color: #e2e8f0 !important;
  background: #ffffff !important;
}

.email-compose-dialog .bg-form.form-insidepop {
  padding: 0 !important;
  border-color: #d8e0ea !important;
  background: #ffffff !important;
  overflow: hidden;
}

.email-compose-dialog .form-insidepop > .mb-2 {
  margin: 0 !important;
}

.email-compose-dialog .form-insidepop > .mb-2 > .col-xl-12 {
  display: block !important;
}

.email-compose-dialog .email-inline-fields {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 0 !important;
  padding: 0 !important;
  border-bottom: 1px solid #e2e8f0;
}

.email-compose-dialog .email-inline-fields > div {
  padding: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid #eef2f7 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
}

.email-compose-dialog .email-inline-fields > div:last-child {
  border-bottom: 0 !important;
}

.email-compose-dialog .email-inline-fields > div > div {
  min-height: 46px;
  align-items: center;
  gap: 0 !important;
}

.email-compose-dialog .email-inline-fields .from-width.p-dropdown,
.email-compose-dialog .email-inline-fields label[for="interview"] {
  width: 104px !important;
  flex: 0 0 104px !important;
  height: 46px !important;
  min-height: 46px !important;
  border: 0 !important;
  border-right: 1px solid #e2e8f0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  justify-content: flex-start !important;
  padding-left: 16px !important;
  box-shadow: none !important;
}

.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {
  justify-content: flex-start !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  padding-left: 0 !important;
  background: #ffffff !important;
}

.email-compose-dialog .email-inline-fields .p-chips,
.email-compose-dialog .email-inline-fields .p-inputtext {
  flex: 1 1 auto !important;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .p-inputtext {
  height: 46px !important;
  min-height: 46px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-dialog .email-inline-fields .p-inputtext {
  padding: 0 16px !important;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container {
  padding: 9px 12px !important;
  overflow-x: hidden !important;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-token,
.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-token {
  max-width: min(100%, 380px) !important;
  min-height: 30px;
  padding: 5px 9px !important;
  gap: 8px;
  border: 1px solid #bcd6e8 !important;
  border-radius: 6px !important;
  background: #eef7fc !important;
  color: #164c6c !important;
  font-size: 13px;
  line-height: 18px;
}

.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-left: 0;
  color: #52758c;
  border-radius: 50%;
  cursor: pointer;
}

.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-icon:hover {
  color: #b42318;
  background: #fee4e2;
}

.email-compose-dialog .email-attachment-panel {
  margin: 0;
  padding: 10px 16px;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 0;
  background: #ffffff;
}

.email-compose-dialog .email-attachment-label {
  width: 94px;
  color: #334155;
}

.email-compose-dialog .email-include-jd {
  border-color: #cbd5e1;
  background: #ffffff;
}

.email-compose-dialog .email-attachment-panel,
.email-compose-dialog .email-attachment-label,
.email-compose-dialog .email-include-jd {
  background: #ffffff !important;
}

.email-compose-dialog .email-compose-editor-row {
  margin: 0;
}

.email-compose-dialog .email-compose-editor-row > .col-xl-12 {
  padding: 0;
}

.email-compose-dialog .editorpage {
  border-radius: 0;
}

.email-compose-dialog .editorpage .p-editor-toolbar {
  border: 0 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
}

.email-compose-dialog .editorpage .p-editor-content {
  border: 0 !important;
  border-radius: 0 !important;
}

.email-compose-dialog .editorpage .ql-editor {
  min-height: 300px !important;
  max-height: 420px !important;
  padding: 18px 20px !important;
}

.email-compose-modal {
  width: min(1380px, calc(100vw - 32px));
  height: min(920px, calc(100vh - 24px));
  height: min(830px, calc(100vh - 48px));
  border: 0;
  border-radius: 16px;
  background: #f3f6fa;
}

.email-compose-modal-header {
  padding: 20px 24px;
  border-bottom: 3px solid #f97316;
  background: #164c78;
}

.email-compose-modal-header h2 {
  color: #ffffff;
}

.email-compose-modal-header p {
  color: #dcecff;
}

.email-compose-header-actions .signature-dropdown.p-dropdown,
.email-compose-header-actions .signature-dropdown.p-dropdown:hover,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-inputwrapper-focus,
.email-compose-header-actions .p-fileupload-choose,
.email-compose-header-actions .p-fileupload-choose:hover {
  border-color: rgba(255, 255, 255, 0.42) !important;
  background: rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-header-actions .signature-dropdown .p-dropdown-label,
.email-compose-header-actions .signature-dropdown.p-dropdown:hover .p-dropdown-label,
.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus .p-dropdown-label,
.email-compose-header-actions .signature-dropdown .p-dropdown-trigger,
.email-compose-header-actions .signature-dropdown .p-dropdown-trigger-icon {
  color: #ffffff !important;
  background: transparent !important;
}

.email-compose-close,
.email-compose-close:hover {
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.email-compose-modal-body {
  padding: 18px 22px 0;
  background: #ffffff;
}

.email-compose-modal-footer {
  padding: 20px 24px;
}

.email-compose-dialog .email-compose-shell,
.email-compose-dialog .email-compose-main,
.email-compose-dialog .email-compose-left-panel {
  min-height: 0;
}

.email-compose-dialog .email-compose-main {
  display: grid;
  grid-template-columns: minmax(720px, 1.45fr) minmax(320px, 0.75fr);
  gap: 26px;
  min-height: 100%;
}

.email-compose-dialog .email-compose-left-panel {
  min-width: 0;
}

.email-compose-dialog .bg-form.form-insidepop {
  width: 100%;
  border: 1px solid #d8e0ea !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-dialog .form-insidepop > .mb-2 {
  flex: 0 0 auto;
}

.email-compose-dialog .email-compose-editor-row {
  min-height: 0;
}

.email-compose-dialog .email-compose-editor-row > .col-xl-12,
.email-compose-dialog .editorpage,
.email-compose-dialog .editorpage .p-editor-container {
  min-height: 0;
}

.email-compose-dialog .editorpage .p-editor-container {
  display: block;
}

.email-compose-dialog .editorpage .p-editor-content {
  min-height: 0;
}

.email-compose-dialog .email-attachment-panel {
  background: #fbfdff;
}

.email-compose-dialog .editorpage .ql-editor {
  min-height: 620px !important;
  max-height: 760px !important;
  height: auto !important;
}

.email-compose-dialog .email-preview-label {
  margin: 0 0 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.email-compose-dialog .email-preview-card {
  min-height: 280px;
  padding: 16px;
  border: 1px solid #d8e0ea;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);
}

.email-compose-dialog .email-preview-subject {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.35;
}

.email-compose-dialog .email-preview-meta {
  margin-top: 5px;
  color: #64748b;
  font-size: 12px;
}

.email-compose-dialog .email-preview-divider {
  height: 1px;
  margin: 14px 0;
  background: #e2e8f0;
}

.email-compose-dialog .email-preview-body {
  height: 560px;
  max-height: max(360px, calc(100vh - 230px));
  overflow: auto;
  color: #1f2937;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
}

.email-compose-dialog .email-preview-body img {
  max-width: 180px;
  height: auto;
}

/* Final selected-candidate email composer layout */
.email-compose-modal {
  width: min(1360px, calc(100vw - 32px));
  height: auto;
  max-height: calc(100vh - 28px);
  background: #ffffff;
}

.email-compose-modal-body {
  padding: 18px;
  background: #ffffff;
}

.email-compose-dialog .email-compose-main {
  display: grid;
  grid-template-columns: minmax(760px, 1.55fr) minmax(360px, 0.8fr);
  gap: 24px;
  min-height: 0;
}

.email-compose-dialog .email-compose-left-panel {
  width: 100%;
}

.email-compose-dialog .email-compose-preview-panel {
  display: block;
  min-width: 0;
}

.email-compose-dialog .bg-form.form-insidepop {
  border: 1px solid #d4dee9 !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.email-compose-dialog .email-inline-fields {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 0 !important;
  padding: 0 !important;
  border-bottom: 1px solid #e2e8f0;
}

.email-compose-dialog .email-inline-fields > div {
  border: 0 !important;
  border-bottom: 1px solid #e9eef5 !important;
  border-radius: 0 !important;
}

.email-compose-dialog .email-inline-fields > div:last-child {
  border-bottom: 0 !important;
}

.email-compose-dialog .email-inline-fields > div > div {
  min-height: 62px;
  gap: 0 !important;
}

.email-compose-dialog .email-inline-fields .from-width.p-dropdown,
.email-compose-dialog .email-inline-fields label[for="interview"] {
  width: 116px !important;
  flex: 0 0 116px !important;
  height: 48px !important;
  min-height: 48px !important;
  padding-left: 16px !important;
  border: 0 !important;
  border-right: 1px solid #e2e8f0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  color: #1f2a44 !important;
  font-weight: 700 !important;
  justify-content: flex-start !important;
}

.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {
  justify-content: flex-start !important;
  padding-left: 0 !important;
  color: #1f2a44 !important;
}

.email-compose-dialog .email-inline-fields .p-chips,
.email-compose-dialog .email-inline-fields .p-inputtext {
  flex: 1 1 auto !important;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .p-inputtext {
  height: 48px !important;
  min-height: 48px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.email-compose-dialog .email-inline-fields .p-inputtext {
  padding: 0 16px !important;
}

.email-compose-dialog .email-attachment-panel {
  margin: 0;
  padding: 10px 14px;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 0;
  background: #ffffff !important;
}

.email-compose-dialog .email-attachment-label {
  width: 100px;
  margin: 0;
  color: #1f2a44;
  font-weight: 500;
}

.email-compose-dialog .email-attachment-list {
  flex: 1 1;
  min-width: 0;
}

.email-compose-dialog .email-attachment-chip {
  max-width: min(100%, 520px);
  border-radius: 4px;
  background: #ffffff;
}

.email-compose-dialog .email-include-jd {
  margin-left: 12px;
  border: 0;
  background: #ffffff !important;
}

.email-compose-dialog .email-compose-editor-row {
  margin: 0;
}

.email-compose-dialog .email-compose-editor-row > .col-xl-12 {
  padding: 0;
}

.email-compose-dialog .editorpage .p-editor-toolbar {
  border: 0 !important;
  border-bottom: 1px solid #d4dee9 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
}

.email-compose-dialog .editorpage .p-editor-content {
  border: 0 !important;
  border-radius: 0 !important;
}

.email-compose-dialog .editorpage .ql-editor {
  min-height: 190px !important;
  max-height: 320px !important;
  height: auto !important;
}

.email-compose-dialog .email-preview-body table {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed;
}

.email-compose-dialog .email-preview-body td,
.email-compose-dialog .email-preview-body th {
  padding: 8px 10px !important;
  border: 1px solid #cbd5e1 !important;
  vertical-align: top !important;
  word-break: normal !important;
  overflow-wrap: break-word;
}

.email-compose-dialog .email-html-editor .sun-editor {
  width: 100% !important;
  border: 0;
}

.email-compose-dialog .email-html-editor .sun-editor-editable table {
  width: 100% !important;
  table-layout: fixed;
  border-collapse: collapse;
}

.email-compose-dialog .email-html-editor .sun-editor-editable td,
.email-compose-dialog .email-html-editor .sun-editor-editable th {
  vertical-align: top !important;
  word-break: normal;
  overflow-wrap: break-word;
}

.email-compose-dialog .email-html-editor .sun-editor-editable .se-component,
.email-compose-dialog .email-html-editor .sun-editor-editable figure,
.email-compose-dialog .email-preview-body .se-component,
.email-compose-dialog .email-preview-body figure {
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  margin: 6px 0 !important;
  padding: 0 !important;
}

.email-compose-dialog .email-html-editor .sun-editor-editable p,
.email-compose-dialog .email-preview-body .email-signature-block p {
  margin: 0 0 4px;
  line-height: 1.5;
}

.email-compose-dialog .email-html-editor .sun-editor-editable .se-image-container {
  width: fit-content !important;
  max-width: 100%;
}

.email-compose-dialog .email-preview-body table td:last-child {
  width: 70% !important;
}

.email-compose-dialog .email-preview-body td:first-child,
.email-compose-dialog .email-preview-body th:first-child {
  width: 30% !important;
  background: #f8fafc !important;
  color: #0f3f6e !important;
  font-family: Arial, sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.email-compose-dialog .email-preview-body td:first-child strong,
.email-compose-dialog .email-preview-body th:first-child strong {
  font-family: inherit;
  font-weight: inherit;
}

.email-compose-dialog .preview-btn {
  background: #f97316 !important;
  box-shadow: 0 8px 18px rgba(249, 115, 22, 0.24) !important;
}

.email-compose-dialog .email-inline-fields .from-width.p-dropdown,
.email-compose-dialog .email-inline-fields label[for="interview"] {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-left: 0 !important;
  text-align: center !important;
}

.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {
  justify-content: center !important;
  text-align: center !important;
}

.email-compose-dialog .email-compose-attachments,
.email-compose-dialog .email-compose-attachments > .col-xl-12 {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  flex: 0 0 100% !important;
  grid-column: 1 / -1;
}

.email-compose-dialog .email-attachment-panel {
  display: grid !important;
  grid-template-columns: 70px minmax(0, 1fr) auto;
  align-items: center !important;
  gap: 10px !important;
  width: 100% !important;
}

.email-compose-dialog .email-attachment-label {
  flex: 0 0 auto;
  margin: 0 !important;
  white-space: nowrap;
}

.email-compose-dialog .email-attachment-list {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  flex: none !important;
  max-width: 100%;
  min-width: 0;
  width: 100% !important;
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 6px 2px 0;
}

.email-compose-dialog .email-attachment-list:has(> .email-attachment-chip:only-child) {
  grid-template-columns: minmax(0, 1fr);
}

.email-compose-dialog .email-attachment-chip {
  display: inline-flex !important;
  align-items: center !important;
  gap: 7px !important;
  min-width: 0;
  width: 100% !important;
  max-width: 100% !important;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cbdbea;
  border-radius: 6px;
  background: #f8fbff;
}

.email-compose-dialog .email-attachment-list:has(> .email-attachment-chip:only-child) .email-attachment-chip {
  width: 100% !important;
  max-width: none !important;
}

.email-compose-dialog .email-attachment-chip a,
.email-compose-dialog .email-attachment-chip > span {
  min-width: 0;
  flex: 1 1;
  overflow: visible;
  white-space: normal;
  overflow-wrap: anywhere;
}

.email-compose-dialog .email-include-jd {
  display: inline-flex !important;
  align-items: center;
  flex: 0 0 auto;
  margin: 0 !important;
  white-space: nowrap;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips,
.email-compose-dialog .email-inline-fields .email-recipient-chips {
  height: auto !important;
  min-height: 48px !important;
  max-height: 150px !important;
  min-width: 0;
}

.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,
.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container {
  height: auto !important;
  min-height: 48px !important;
  max-height: 150px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  flex-wrap: wrap !important;
  align-content: flex-start !important;
}

@media (max-width: 1200px) {
  .interview-popup .form-insidepop > .mb-2 > .col-xl-12 {
    grid-template-columns: 1fr;
  }

  .email-compose-dialog .email-attachment-panel {
    align-items: flex-start !important;
    grid-template-columns: 70px minmax(0, 1fr);
  }

  .email-compose-dialog .email-include-jd {
    grid-column: 2;
  }

  .email-compose-dialog .email-attachment-list {
    grid-template-columns: 1fr;
  }

  .email-compose-dialog .email-inline-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

.interview-popup .schedule-interview-form .row {
  align-items: flex-start;
  row-gap: 12px;
}

.interview-popup .schedule-interview-form label,
.interview-popup .schedule-interview-form label[for="interview"] {
  display: block !important;
  width: auto;
  min-height: 0;
  margin: 0 0 6px !important;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  text-align: left !important;
}

.interview-popup .schedule-interview-form .p-inputtext,
.interview-popup .schedule-interview-form .p-dropdown,
.interview-popup .schedule-interview-form .p-calendar,
.interview-popup .schedule-interview-form .p-calendar .p-inputtext {
  width: 100%;
}

.interview-popup .schedule-interview-form .p-inputtext,
.interview-popup .schedule-interview-form .p-dropdown {
  min-height: 38px;
}

.interview-popup .schedule-interview-form .p-dropdown {
  display: flex;
  align-items: center;
  background: #fff !important;
}

.interview-popup .schedule-interview-form .p-dropdown-label {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  line-height: 1.2;
  background: #fff !important;
  color: #111827 !important;
}

.interview-popup .schedule-interview-form .p-dropdown-trigger,
.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown,
.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown-label,
.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown-trigger,
.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown,
.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown-label,
.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown-trigger {
  background: #fff !important;
}

.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown:hover,
.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown.p-focus,
.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown:hover,
.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown.p-focus {
  background: #fff !important;
  border-color: #ced4da !important;
  box-shadow: none !important;
}

.interview-popup .schedule-interview-form .p-calendar .p-button {
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  margin: 0;
  border: 0 !important;
  border-left: 1px solid #d9dee7 !important;
  border-radius: 0 !important;
  background: #eef0f5 !important;
  color: #111827 !important;
}

.interview-popup .schedule-interview-form .p-calendar {
  display: flex;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
}

.interview-popup .schedule-interview-form .p-calendar .p-inputtext {
  flex: 1 1 auto;
  min-width: 0;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.job-candidate-toolbar {
  justify-content: flex-start !important;
  column-gap: 10px !important;
  row-gap: 10px !important;
}

.job-candidate-toolbar .job-candidate-action-row {
  display: contents !important;
}

.interview-popup .schedule-interview-form .field,
.interview-popup .schedule-interview-form .p-field {
  margin-bottom: 0;
}

.interview-popup .schedule-interview-form .schedule-priority-col {
  flex: 0 0 auto;
  max-width: 230px;
}

.interview-popup .calendar-event-edit-form label {
  display: block !important;
  margin: 0 0 6px !important;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  text-align: left !important;
}

.interview-popup .calendar-event-edit-form .p-inputtext,
.interview-popup .calendar-event-edit-form textarea,
.interview-popup .calendar-event-edit-form .p-dropdown,
.interview-popup .calendar-event-edit-form .p-calendar,
.interview-popup .calendar-event-edit-form .p-checkbox,
.interview-popup .calendar-event-edit-form .pi-chevron-down {
  pointer-events: none !important;
}

.interview-popup .calendar-event-edit-form .p-inputtext,
.interview-popup .calendar-event-edit-form textarea,
.interview-popup .calendar-event-edit-form .p-dropdown {
  background: #f8fafc !important;
  color: #6b7280 !important;
}

.interview-popup .calendar-schedule-readonly-form label {
  display: block !important;
  margin: 0 0 6px !important;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  text-align: left !important;
}

.interview-popup .calendar-schedule-readonly-form .p-inputtext,
.interview-popup .calendar-schedule-readonly-form textarea,
.interview-popup .calendar-schedule-readonly-form .p-dropdown,
.interview-popup .calendar-schedule-readonly-form .p-calendar,
.interview-popup .calendar-schedule-readonly-form .p-checkbox,
.interview-popup .calendar-schedule-readonly-form .p-multiselect,
.interview-popup .calendar-schedule-readonly-form .pi-chevron-down,
.interview-popup .calendar-schedule-readonly-form .inline-link-selector,
.interview-popup .calendar-schedule-readonly-form [role="button"] {
  pointer-events: none !important;
}

.interview-popup .calendar-schedule-readonly-form .p-inputtext,
.interview-popup .calendar-schedule-readonly-form textarea,
.interview-popup .calendar-schedule-readonly-form .p-dropdown,
.interview-popup .calendar-schedule-readonly-form .p-multiselect {
  background: #f8fafc !important;
  color: #6b7280 !important;
}

#SendForApprovalBtn,
#SentForApprovalBtn {
  font-size: 0.68rem !important;
}

.feedback-panel-modal-header {
  align-items: center !important;
  gap: 12px;
}

.feedback-panel-modal-header .modal-title {
  min-width: 0 !important;
  width: calc(100% - 44px) !important;
  max-width: calc(100% - 44px) !important;
}

.feedback-panel-modal-header .btn-close {
  flex: 0 0 auto;
  margin-left: auto;
  filter: invert(1) grayscale(100%) brightness(200%);
  opacity: 1;
}

.feedback-panel-modal-header .btn-close:hover {
  opacity: 0.85;
}

.feedback-panel-modal-title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.extension-logs-modern-page {
  padding-top: 28px !important;
}

.extension-logs-modern-page .page-title-box {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Table,
.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead,
.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody,
.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableRow {
  width: 100% !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Table,
.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody {
  max-height: none !important;
  height: auto !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody::-webkit-scrollbar {
  display: none !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHeadRow {
  background: #eaf4ff !important;
  border-bottom: 1px solid #c4d8ea !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol,
.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol > div {
  color: #0b3a5d !important;
  justify-content: flex-start !important;
  text-align: left !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  justify-content: flex-start !important;
  text-align: left !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Pagination {
  position: relative !important;
  z-index: 1;
  border-top: 1px solid #e7edf3 !important;
  background: #fff !important;
}
/* =====================================================================
   EMAIL MODULE — Outlook-style CSS
   ===================================================================== */

/* --- Layout --- */
.em-module {
  display: flex;
  flex-direction: column;
  /* Offset the fixed 70px app header so the ribbon is never clipped,
     and fill the remaining viewport height so panels lay out cleanly. */
  margin-top: 70px;
  height: calc(100vh - 70px);
  background: #f3f3f3;
  font-family: "Segoe UI", "San Francisco", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  font-size: 13px;
  color: #1a1a1a;
  overflow: hidden;
  --em-accent: #2563eb;
  --em-accent-hover: #1d4ed8;
  --em-bg: #ffffff;
  --em-bg-secondary: #fafafa;
  --em-bg-tertiary: #f0f0f0;
  --em-border: #e0e0e0;
  --em-border-light: #ebebeb;
  --em-text: #1a1a1a;
  --em-text-secondary: #616161;
  --em-text-muted: #999;
  --em-hover: #eaeaea;
  --em-active: #cce4ff;
  --em-ribbon-bg: #f8f9fa;
  --em-ribbon-border: #d0d0d0;
  --em-sidebar-bg: #fafafa;
  --em-unread-bg: #f5f7fa;
  --em-reading-pane-bg: #fff;
}

/* --- Main Layout --- */
.em-module-body {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* ===================== RIBBON ===================== */
.em-ribbon {
  background: var(--em-ribbon-bg);
  border-bottom: 1px solid var(--em-ribbon-border);
  -webkit-user-select: none;
          user-select: none;
  z-index: 10;
}

.em-ribbon-tabs {
  display: flex;
  align-items: stretch;
  height: 32px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
  padding: 0 8px;
}

.em-ribbon-tab {
  padding: 0 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: inherit;
  transition: none;
}

.em-ribbon-tab:hover {
  background: #eaeaea;
}

.em-ribbon-tab-active {
  color: var(--em-text);
  background: #f8f9fa;
  border-bottom-color: var(--em-accent);
  font-weight: 500;
}

.em-ribbon-content {
  background: var(--em-ribbon-bg);
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 56px;
}

.em-ribbon-group {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px;
  border-right: 1px solid var(--em-border);
}

.em-ribbon-group:last-child {
  border-right: none;
}

.em-ribbon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  padding: 3px 8px;
  cursor: pointer;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  color: var(--em-text);
  font-family: inherit;
  font-size: 11px;
  min-width: 44px;
  text-align: center;
  transition: none;
}

.em-ribbon-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-ribbon-btn:active {
  background: #ccc;
}

.em-ribbon-btn svg {
  display: block;
}

.em-ribbon-btn-label {
  font-size: 10px;
  line-height: 1.1;
  white-space: nowrap;
}

.em-ribbon-new-btn {
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  padding: 4px 16px 4px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.em-ribbon-new-btn:hover {
  background: #004578;
}

.em-ribbon-search {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 2px;
  padding: 0 6px;
  height: 24px;
  margin-left: auto;
  min-width: 180px;
}

.em-ribbon-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: inherit;
  padding: 0 4px;
  flex: 1 1;
  color: var(--em-text);
}

.em-ribbon-search input::placeholder {
  color: var(--em-text-muted);
}

.em-ribbon-quickbar {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
  padding: 2px 8px;
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-ribbon-quickbar em {
  font-style: normal;
  font-weight: 600;
  margin: 0 2px;
}

/* ===================== SIDEBAR ===================== */
.em-sidebar {
  width: 200px;
  min-width: 200px;
  background: var(--em-sidebar-bg);
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
}

.em-sidebar-newmail {
  margin: 8px 8px 4px;
  padding: 6px 12px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: none;
}

.em-sidebar-newmail:hover {
  background: #004578;
}

.em-sidebar-search-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  padding: 5px 12px;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-size: 12.5px;
  margin: 1px 6px;
  border-radius: 4px;
}

.em-sidebar-search-btn:hover {
  background: var(--em-hover);
}

.em-sidebar-section {
  padding: 6px 0;
  margin-top: 4px;
  border-top: 1px solid var(--em-border-light);
}

.em-sidebar-section-title {
  padding: 4px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--em-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.em-sidebar-folder {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  padding: 5px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin: 1px 6px;
  position: relative;
  color: var(--em-text);
  font-size: 13px;
}

.em-sidebar-folder:hover {
  background: var(--em-hover);
}

.em-sidebar-folder-active {
  background: var(--em-active) !important;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #0e527d;
}

.em-sidebar-folder-icon {
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--em-text-secondary);
  flex-shrink: 0;
}

.em-sidebar-folder-active .em-sidebar-folder-icon {
  color: var(--em-accent);
}

.em-sidebar-folder-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-sidebar-folder-count {
  font-size: 11px;
  color: var(--em-text-secondary);
  margin-left: auto;
  padding-left: 4px;
}

.em-sidebar-folder-count-primary {
  color: #005a9e;
  font-weight: 600;
}

.em-sidebar-more-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 16px;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-size: 11px;
  margin: 0 4px;
  border-radius: 3px;
}

.em-sidebar-more-btn:hover {
  background: var(--em-hover);
}

.em-sidebar-labels {
  padding: 2px 0;
}

.em-sidebar-label-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 16px;
  cursor: pointer;
  border-radius: 3px;
  margin: 0 4px;
}

.em-sidebar-label-item:hover {
  background: var(--em-hover);
}

.em-sidebar-label-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.em-sidebar-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border-top: 1px solid var(--em-border);
  color: var(--em-text-secondary);
  cursor: pointer;
}

/* ===================== EMAIL LIST ===================== */
.em-list {
  width: 360px;
  min-width: 300px;
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  background: var(--em-bg);
  overflow: hidden;
}

.em-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
  min-height: 28px;
}

.em-list-toolbar-left {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-list-toolbar-left input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.em-list-toolbar-label {
  cursor: pointer;
  padding: 0 2px;
}

.em-list-toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--em-text-secondary);
  cursor: pointer;
}

.em-list-range {
  font-size: 12px;
  color: var(--em-text-secondary);
  white-space: nowrap;
}

.em-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 4px;
  background: #fff;
  color: var(--em-text-secondary);
  cursor: pointer;
}

.em-page-btn:hover:not(:disabled) {
  background: #f3f4f6;
  color: var(--em-text-primary, #111);
}

.em-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.em-list-column-header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11px;
  color: var(--em-text-secondary);
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
}

.em-list-col-sort {
  font-weight: 500;
}

.em-list-body {
  flex: 1 1;
  overflow-y: auto;
}

.em-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--em-text-muted);
  gap: 4px;
}

.em-list-empty h3 {
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 400;
  color: var(--em-text-secondary);
}

.em-list-empty p {
  margin: 0;
  font-size: 13px;
}

/* --- Mail Item --- */
.em-mail-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--em-border-light);
  cursor: pointer;
  transition: none;
}

.em-mail-item:hover {
  background: var(--em-bg-tertiary);
}

.em-mail-active {
  background: var(--em-active) !important;
}

.em-mail-unread {
  background: var(--em-unread-bg);
}

.em-mail-unread .em-mail-sender {
  font-weight: 700;
}

.em-mail-unread .em-mail-subject {
  font-weight: 600;
}

.em-mail-chk {
  margin-top: 4px;
  flex-shrink: 0;
}

.em-mail-star {
  flex-shrink: 0;
  margin-top: 3px;
  cursor: pointer;
  line-height: 0;
  min-width: 15px;
}

.em-mail-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 1px;
}

.em-mail-content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.em-mail-row1 {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1.3;
}

.em-mail-sender {
  font-size: 13px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}

.em-mail-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.em-mail-row2 {
  display: flex;
  align-items: baseline;
  gap: 2px;
  line-height: 1.3;
  color: var(--em-text-secondary);
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
}

.em-mail-subject {
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  max-width: 50%;
}

.em-mail-preview {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--em-text-muted);
}

.em-mail-flags {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  margin-top: 2px;
}

.em-mail-attach-icon {
  color: var(--em-text-secondary);
}

.em-mail-unread-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2563eb;
  display: inline-block;
}

/* --- Skeleton --- */
.em-mail-item-skeleton {
  cursor: default;
}

.em-skeleton {
  background: #e8e8e8;
  border-radius: 3px;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
}

.em-skeleton-check {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
  margin-top: 4px;
}

.em-skeleton-star {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-top: 3px;
}

.em-skeleton-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}

.em-skeleton-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 0;
}

.em-skeleton-line {
  height: 12px;
}

.w-50 { width: 50%; }
.w-80 { width: 80%; }

@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.em-loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: var(--em-text-secondary);
  font-size: 12px;
}

.em-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--em-border);
  border-top-color: var(--em-accent);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===================== VIEWER (Reading Pane) ===================== */
.em-viewer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: var(--em-reading-pane-bg);
  min-width: 0;
  overflow: hidden;
}

.em-viewer-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-viewer-empty-content {
  text-align: center;
  color: var(--em-text-muted);
}

.em-viewer-empty-content h3 {
  font-size: 16px;
  font-weight: 400;
  color: var(--em-text-secondary);
  margin: 8px 0 4px;
}

.em-viewer-empty-content p {
  margin: 0;
  font-size: 12px;
}

/* --- Viewer Toolbar --- */
.em-viewer-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
  flex-wrap: wrap;
  min-height: 32px;
}

.em-vtb-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text-secondary);
  font-family: inherit;
  border-radius: 3px;
  height: 26px;
  transition: none;
}

.em-vtb-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-vtb-btn span {
  font-size: 11px;
}

.em-vtb-divider {
  width: 1px;
  height: 20px;
  background: var(--em-border);
  margin: 0 2px;
}

.em-vtb-right {
  margin-left: auto;
}

.em-vtb-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-vtb-close-btn:hover {
  background: #e5e5e5;
}

/* --- Viewer Header --- */
.em-viewer-header {
  padding: 12px 16px 8px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-viewer-subject-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.em-viewer-subject {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  line-height: 1.3;
}

.em-viewer-thread-badge {
  background: var(--em-bg-tertiary);
  padding: 0 6px;
  border-radius: 10px;
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-viewer-from-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.em-viewer-avatar-lg {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-viewer-from-details {
  flex: 1 1;
  min-width: 0;
}

.em-viewer-from-name {
  font-size: 14px;
  font-weight: 500;
}

.em-viewer-from-addr {
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-viewer-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
  margin-top: 4px;
}

/* Reply / Reply All / Forward moved into the header (top-right, Outlook style) */
.em-viewer-header-right {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}
.em-viewer-header-actions {
  display: flex;
  gap: 6px;
}
.em-viewer-hdr-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 12.5px;
  font-weight: 500;
  color: #0e527d;
  background: #fff;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}
.em-viewer-hdr-btn:hover {
  background: #eaf3f9;
  border-color: #cfe3ef;
}
.em-viewer-hdr-btn svg { color: #0e527d; }

/* --- Viewer Body --- */
.em-viewer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
}

.em-viewer-html-body {
  line-height: 1.6;
  font-size: 14px;
}

.em-viewer-html-body blockquote {
  margin: 8px 0;
  padding: 0 0 0 8px;
  border-left: 2px solid #ccc;
  color: #666;
}

.em-viewer-text-body {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* --- Attachments --- */
.em-viewer-attachments {
  border-top: 1px solid var(--em-border-light);
  padding: 8px 16px;
}

.em-viewer-att-header {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--em-text-secondary);
  font-size: 12px;
  margin-bottom: 8px;
}

.em-viewer-att-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.em-viewer-att-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  background: var(--em-bg-secondary);
  min-width: 160px;
}

.em-viewer-att-info {
  flex: 1 1;
  min-width: 0;
}

.em-viewer-att-name {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-viewer-att-size {
  font-size: 10px;
  color: var(--em-text-muted);
}

.em-viewer-att-dl {
  color: var(--em-accent);
  text-decoration: none;
  flex-shrink: 0;
}

/* --- Actions Bar --- */
.em-viewer-actions-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 16px;
  border-top: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-viewer-act-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text);
  font-family: inherit;
  border-radius: 3px;
}

.em-viewer-act-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-viewer-act-primary {
  font-weight: 600;
}

/* ===================== COMPOSE ===================== */
.em-compose-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: calc(100vw - 80px);
  max-height: 90vh;
  z-index: 1000;
  box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.em-compose-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #005a9e;
  color: #fff;
  border-radius: 8px 8px 0 0;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.em-compose-header h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}

.em-compose-header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.em-compose-header-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  border-radius: 3px;
}

.em-compose-header-btn:hover {
  background: rgba(255,255,255,0.15);
  color: #fff;
}

.em-compose-body {
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
}

.em-compose-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--em-border-light);
  padding: 0 4px;
}

.em-compose-field-label {
  width: 44px;
  font-size: 12px;
  color: var(--em-text-secondary);
  flex-shrink: 0;
  padding: 6px 4px;
}

.em-compose-field-input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 6px 4px;
  color: var(--em-text);
  background: transparent;
}

.em-compose-field-input::placeholder {
  color: var(--em-text-muted);
}

.em-compose-to-field {
  position: relative;
}

.em-compose-candidate-list {
  position: absolute;
  top: 100%;
  left: 44px;
  right: 0;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  max-height: 180px;
  overflow-y: auto;
  z-index: 10;
}

.em-compose-candidate-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
}

.em-compose-candidate-item:hover {
  background: var(--em-active);
}

.em-compose-candidate-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--em-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
}

.em-compose-candidate-info {
  flex: 1 1;
}

.em-compose-candidate-name {
  font-size: 12px;
  color: var(--em-text);
}

.em-compose-candidate-email {
  font-size: 11px;
  color: var(--em-text-muted);
}

.em-compose-tag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  flex: 1 1;
}

.em-compose-tag {
  display: flex;
  align-items: center;
  gap: 3px;
  background: #e8effa;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 11px;
  color: var(--em-accent);
}

.em-compose-tag-remove {
  cursor: pointer;
  opacity: 0.6;
  display: flex;
  align-items: center;
}

.em-compose-tag-remove:hover {
  opacity: 1;
}

.em-compose-tag-input {
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 2px;
  flex: 1 1;
  min-width: 60px;
  background: transparent;
}

.em-compose-cc-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 4px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-compose-toggle-cc {
  font-size: 11px;
  color: var(--em-accent);
  cursor: pointer;
  padding: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.em-compose-toggle-cc:hover {
  text-decoration: underline;
}

.em-compose-subject-field input {
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 6px 8px;
  width: 100%;
  color: var(--em-text);
  background: transparent;
}

.em-compose-subject-field input::placeholder {
  color: var(--em-text-muted);
}

.em-compose-editor {
  padding: 8px;
  min-height: 180px;
  flex: 1 1;
}

.em-compose-editor textarea {
  width: 100%;
  height: 100%;
  min-height: 180px;
  border: none;
  outline: none;
  resize: vertical;
  font-family: "Segoe UI", sans-serif;
  font-size: 13px;
  line-height: 1.5;
  color: var(--em-text);
}

.em-compose-editor textarea::placeholder {
  color: var(--em-text-muted);
}

.em-compose-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-top: 1px solid var(--em-border-light);
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-compose-tool-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-tool-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-tool-btn-active {
  background: #cce4ff;
  border-color: #a8cff5;
}

.em-compose-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid var(--em-border-light);
}

.em-compose-footer-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.em-compose-send-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 20px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
}

.em-compose-send-btn:hover {
  background: #004578;
}

.em-compose-send-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.em-compose-attach-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-attach-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-trash-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-trash-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-footer-right {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--em-text-muted);
}

/* ===================== SEARCH OVERLAY ===================== */
.em-search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.08); /* light scrim — keep the page bright, don't darken it */
  z-index: 999;
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.em-search-panel {
  width: 600px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow: hidden;
}

.em-search-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-search-header input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  color: var(--em-text);
}

.em-search-header input::placeholder {
  color: var(--em-text-muted);
}

.em-search-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-search-close:hover {
  background: #e5e5e5;
}

.em-search-results {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 0;
}

.em-search-result-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
}

.em-search-result-item:hover {
  background: var(--em-bg-tertiary);
}

.em-search-result-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--em-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
}

.em-search-result-content {
  flex: 1 1;
  min-width: 0;
}

.em-search-result-sender {
  font-size: 12px;
  font-weight: 500;
}

.em-search-result-subject {
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-search-result-preview {
  font-size: 11px;
  color: var(--em-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-search-result-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.em-search-empty {
  padding: 24px;
  text-align: center;
  color: var(--em-text-muted);
  font-size: 13px;
}

/* ===================== CONTEXT MENU ===================== */
.em-context-menu {
  position: fixed;
  z-index: 2000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  padding: 4px 0;
  min-width: 160px;
}

.em-context-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text);
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-family: inherit;
}

.em-context-menu-item:hover {
  background: var(--em-active);
}

.em-context-menu-divider {
  height: 1px;
  background: var(--em-border);
  margin: 4px 0;
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 768px) {
  .em-module-body {
    flex-direction: column;
  }

  .em-sidebar {
    width: 100%;
    min-width: unset;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid var(--em-border);
  }

  .em-list {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid var(--em-border);
  }

  .em-compose-overlay {
    right: 0;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }

  .em-ribbon-content {
    flex-wrap: wrap;
    min-height: 40px;
  }

  .em-ribbon-search {
    min-width: 120px;
  }
}

/* ===================== SCROLLBARS ===================== */
.em-list-body::-webkit-scrollbar,
.em-sidebar::-webkit-scrollbar,
.em-viewer-body::-webkit-scrollbar,
.em-compose-body::-webkit-scrollbar {
  width: 8px;
}

.em-list-body::-webkit-scrollbar-track,
.em-sidebar::-webkit-scrollbar-track,
.em-viewer-body::-webkit-scrollbar-track,
.em-compose-body::-webkit-scrollbar-track {
  background: transparent;
}

.em-list-body::-webkit-scrollbar-thumb,
.em-sidebar::-webkit-scrollbar-thumb,
.em-viewer-body::-webkit-scrollbar-thumb,
.em-compose-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.em-list-body::-webkit-scrollbar-thumb:hover,
.em-sidebar::-webkit-scrollbar-thumb:hover,
.em-viewer-body::-webkit-scrollbar-thumb:hover,
.em-compose-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Firefox */
.em-list-body,
.em-sidebar,
.em-viewer-body,
.em-compose-body {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

/* ===================== TOAST ===================== */
.em-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 13px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  animation: em-toast-in 0.25s ease-out;
  background: #323130;
  color: #fff;
}

.em-toast-success {
  background: #005a9e;
  color: #fff;
}

.em-toast-error {
  background: #d32f2f;
  color: #fff;
}

.em-toast-warning {
  background: #b26a00;
  color: #fff;
}

.em-toast-info {
  background: #323130;
  color: #fff;
}

@keyframes em-toast-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ===================== SEARCH FILTERS ===================== */
.em-search-filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-search-filter-btn:hover {
  background: #e5e5e5;
}

.em-search-filters {
  padding: 12px 16px;
  border-top: 1px solid var(--em-border-light);
}

.em-search-filters-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

.em-search-filter-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.em-search-filter-field label {
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-search-filter-field input {
  padding: 4px 8px;
  border: 1px solid var(--em-border);
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  outline: none;
  color: var(--em-text);
  background: var(--em-bg);
}

.em-search-filter-field input:focus {
  border-color: var(--em-accent);
}

.em-search-filter-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.em-search-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--em-text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.em-search-toggle input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.em-search-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.em-search-apply-btn {
  padding: 4px 16px;
  background: var(--em-accent);
  color: #fff;
  border: 1px solid var(--em-accent-hover);
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
}

.em-search-apply-btn:hover {
  background: var(--em-accent-hover);
}

.em-search-clear-btn {
  padding: 4px 16px;
  background: transparent;
  color: var(--em-text-secondary);
  border: 1px solid var(--em-border);
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
}

.em-search-clear-btn:hover {
  background: var(--em-bg-tertiary);
}

/* =====================================================================
   RIBBON POLISH (alignment)
   ===================================================================== */
.em-ribbon-content {
  min-height: 60px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

.em-ribbon-content::-webkit-scrollbar {
  height: 6px;
}

.em-ribbon-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.em-ribbon-quickbar-btn {
  border: none;
  background: transparent;
  font-size: 11px;
  padding: 0 4px;
  color: var(--em-text-secondary);
  cursor: pointer;
  font-family: inherit;
  border-radius: 3px;
}

.em-ribbon-quickbar-btn:hover {
  background: #e5e5e5;
  color: var(--em-text);
}

.em-ribbon-search {
  cursor: pointer;
}

.em-ribbon-search input {
  cursor: pointer;
}

.em-ribbon-view-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--em-accent);
  padding: 0 4px;
}

/* =====================================================================
   OUTLOOK TOP BAR (Row 1: quick-access / title bar)
   ===================================================================== */
.em-topbar {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 8px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
}

.em-topbar-left {
  display: flex;
  align-items: center;
  gap: 2px;
}

.em-topbar-logo {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(135deg, #0364b8, #0a2767);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  flex-shrink: 0;
}

.em-topbar-icon {
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444;
}

.em-topbar-icon:hover {
  background: #e5e5e5;
}

.em-topbar-people {
  display: flex;
  align-items: center;
  gap: 2px;
  border: 1px solid var(--em-border);
  background: #fff;
  border-radius: 3px;
  padding: 0 4px;
  height: 24px;
  margin-left: 6px;
  color: var(--em-text-muted);
}

.em-topbar-people input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: inherit;
  width: 96px;
  color: var(--em-text);
  cursor: pointer;
}

.em-topbar-search {
  flex: 1 1;
  max-width: 620px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 26px;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 0 10px;
  color: var(--em-text-muted);
  cursor: pointer;
}

.em-topbar-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  font-family: inherit;
  flex: 1 1;
  color: var(--em-text);
  cursor: pointer;
}

.em-topbar-right {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
}

.em-topbar-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #0a8577;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-right: 8px;
}

.em-topbar-win {
  width: 32px;
  height: 30px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444;
}

.em-topbar-win:hover {
  background: #e5e5e5;
}

.em-topbar-win-close:hover {
  background: #d13438;
  color: #fff;
}

/* Ribbon: quick steps + small buttons + people search */
.em-ribbon-new-btn .em-ribbon-btn-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.em-ribbon-btn-label {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  justify-content: center;
}

.em-ribbon-btn-sm {
  min-width: 0;
  flex-direction: row;
  gap: 1px;
  padding: 3px 5px;
}

.em-ribbon-group-quicksteps {
  gap: 0;
}

.em-ribbon-step {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid var(--em-border);
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  color: var(--em-text);
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
}

.em-ribbon-step + .em-ribbon-step {
  border-left: none;
}

.em-ribbon-step:hover {
  background: #eaf2fb;
  border-color: #a8cff5;
}

.em-ribbon-step span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-ribbon-search-people {
  min-width: 130px;
  height: 22px;
}

.em-ribbon-search-people input {
  cursor: pointer;
}

.em-ribbon-group-last {
  border-right: none;
}

@media (max-width: 1100px) {
  .em-ribbon-group-quicksteps,
  .em-ribbon-search-people {
    display: none;
  }
}

@media (max-width: 768px) {
  .em-topbar-people {
    display: none;
  }
  .em-topbar-search {
    max-width: none;
  }
}

/* =====================================================================
   MODULE NAV RAIL (Outlook module switcher)
   ===================================================================== */
.em-nav-rail {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  background: transparent;
  border: none;
  flex-shrink: 0;
}

/* The visible bar wraps only the icons, so it can never stretch full-width. */
.em-nav-rail-top,
.em-nav-rail-bottom {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: auto;
  background: #f0f2f5;
  border-top: 1px solid var(--em-border);
  border-right: 1px solid var(--em-border);
  border-top-right-radius: 8px;
  padding: 5px 14px;
}

.em-nav-rail-btn {
  width: auto;
  height: auto;
  padding: 6px 9px;
  border: none;
  background: transparent;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-family: inherit;
  position: relative;
}

.em-nav-rail-btn:hover {
  background: #e2e6ea;
  color: var(--em-text);
}

.em-nav-rail-btn-active {
  background: #dbe7ff;
  color: var(--em-accent);
}

.em-nav-rail-btn-active::before {
  content: "";
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: -5px;
  height: 2px;
  border-radius: 2px;
  background: var(--em-accent);
}

.em-nav-rail-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.em-nav-rail-label {
  display: none;
}

.em-nav-rail-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: #dc2626;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  border-radius: 9px;
  padding: 1px 4px;
  min-width: 16px;
  text-align: center;
  line-height: 1.3;
}

/* =====================================================================
   CALENDAR
   ===================================================================== */
.em-cal {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-cal-sidebar {
  width: 240px;
  min-width: 240px;
  border-right: 1px solid var(--em-border);
  background: var(--em-sidebar-bg);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 12px;
}

.em-cal-new-btn {
  justify-content: center;
}

.em-cal-mini {
  padding: 8px 12px;
}

.em-cal-mini-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: var(--em-text);
  margin-bottom: 6px;
}

.em-cal-mini-nav {
  display: flex;
  gap: 2px;
}

.em-cal-mini-nav button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-cal-mini-nav button:hover {
  background: var(--em-hover);
}

.em-cal-mini-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}

.em-cal-mini-dow {
  text-align: center;
  font-size: 10px;
  color: var(--em-text-muted);
  padding: 2px 0;
  font-weight: 600;
}

.em-cal-mini-day {
  position: relative;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  color: var(--em-text);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

.em-cal-mini-day:hover {
  background: var(--em-hover);
}

.em-cal-mini-day-muted {
  color: var(--em-text-muted);
}

.em-cal-mini-day-today {
  background: var(--em-accent);
  color: #fff;
  font-weight: 600;
}

.em-cal-mini-day-today:hover {
  background: var(--em-accent-hover);
}

.em-cal-mini-day-sel {
  outline: 1px solid var(--em-accent);
}

.em-cal-mini-dot {
  position: absolute;
  bottom: 2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

.em-cal-upcoming {
  padding: 4px 4px 0;
}

.em-cal-upcoming-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 4px;
}

.em-cal-upcoming-item:hover {
  background: var(--em-hover);
}

.em-cal-upcoming-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 4px;
  flex-shrink: 0;
}

.em-cal-upcoming-info {
  min-width: 0;
}

.em-cal-upcoming-title {
  font-size: 12px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-cal-upcoming-time {
  font-size: 11px;
  color: var(--em-text-muted);
}

.em-cal-upcoming-empty {
  padding: 8px 16px;
  font-size: 12px;
  color: var(--em-text-muted);
}

/* Calendar main */
.em-cal-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.em-cal-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
}

.em-cal-today-btn {
  padding: 5px 14px;
  border: 1px solid var(--em-border);
  background: var(--em-bg);
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text);
  font-weight: 500;
}

.em-cal-today-btn:hover {
  background: var(--em-hover);
}

.em-cal-nav {
  display: flex;
  gap: 2px;
}

.em-cal-nav button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-cal-nav button:hover {
  background: var(--em-hover);
}

.em-cal-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--em-text);
  flex: 1 1;
}

.em-cal-view-switch {
  display: flex;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  overflow: hidden;
}

.em-cal-view-switch button {
  border: none;
  background: var(--em-bg);
  padding: 5px 14px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text-secondary);
  border-right: 1px solid var(--em-border);
}

.em-cal-view-switch button:last-child {
  border-right: none;
}

.em-cal-view-switch button:hover {
  background: var(--em-hover);
}

.em-cal-view-active {
  background: var(--em-accent) !important;
  color: #fff !important;
}

/* Month grid */
.em-cal-month {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.em-cal-month-dow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid var(--em-border-light);
}

.em-cal-month-dow-cell {
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--em-text-secondary);
  text-align: right;
  text-transform: uppercase;
}

.em-cal-month-grid {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 1fr;
  overflow-y: auto;
}

.em-cal-cell {
  border-right: 1px solid var(--em-border-light);
  border-bottom: 1px solid var(--em-border-light);
  padding: 4px;
  min-height: 92px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.em-cal-cell:hover {
  background: var(--em-bg-secondary);
}

.em-cal-cell-muted {
  background: #fafafa;
}

.em-cal-cell-muted .em-cal-cell-date {
  color: var(--em-text-muted);
}

.em-cal-cell-date {
  font-size: 12px;
  color: var(--em-text);
  text-align: right;
  padding: 2px 4px;
}

.em-cal-cell-month {
  font-weight: 600;
  color: var(--em-accent);
}

.em-cal-cell-today-num {
  background: var(--em-accent);
  color: #fff;
  border-radius: 50%;
  padding: 1px 6px;
  font-weight: 600;
}

.em-cal-cell-events {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.em-cal-event-chip {
  color: #fff;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.em-cal-event-time {
  font-weight: 700;
  opacity: 0.9;
}

.em-cal-event-more {
  font-size: 10px;
  color: var(--em-text-secondary);
  padding-left: 4px;
}

/* Week view */
.em-cal-week {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  overflow-y: auto;
}

.em-cal-week-col {
  border-right: 1px solid var(--em-border-light);
  display: flex;
  flex-direction: column;
}

.em-cal-week-col-today {
  background: #f5f9ff;
}

.em-cal-week-head {
  text-align: center;
  padding: 8px 4px;
  border-bottom: 1px solid var(--em-border-light);
  cursor: pointer;
}

.em-cal-week-head:hover {
  background: var(--em-hover);
}

.em-cal-week-dow {
  display: block;
  font-size: 11px;
  color: var(--em-text-secondary);
  text-transform: uppercase;
}

.em-cal-week-num {
  font-size: 18px;
  font-weight: 600;
}

.em-cal-week-body {
  flex: 1 1;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 200px;
  cursor: pointer;
}

.em-cal-week-event {
  background: var(--em-bg-secondary);
  border-left: 3px solid var(--em-accent);
  border-radius: 3px;
  padding: 4px 6px;
  cursor: pointer;
}

.em-cal-week-event:hover {
  background: var(--em-hover);
}

.em-cal-week-event-time {
  font-size: 10px;
  color: var(--em-text-secondary);
}

.em-cal-week-event-title {
  font-size: 12px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-cal-week-empty {
  color: var(--em-text-muted);
  font-size: 11px;
  opacity: 0;
}

.em-cal-week-body:hover .em-cal-week-empty {
  opacity: 1;
}

/* Day view */
.em-cal-day {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 24px;
}

.em-cal-day-add {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--em-accent);
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
  border: 1px dashed var(--em-border);
  border-radius: 6px;
  margin-bottom: 12px;
}

.em-cal-day-add:hover {
  background: var(--em-bg-secondary);
}

.em-cal-day-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--em-text-muted);
  padding: 48px;
  gap: 8px;
}

.em-cal-day-event {
  display: flex;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  align-items: stretch;
}

.em-cal-day-event:hover {
  background: var(--em-bg-secondary);
}

.em-cal-day-event-time {
  width: 60px;
  flex-shrink: 0;
  font-size: 13px;
  display: flex;
  flex-direction: column;
}

.em-cal-day-event-end {
  color: var(--em-text-muted);
  font-size: 11px;
}

.em-cal-day-event-bar {
  width: 4px;
  border-radius: 2px;
  flex-shrink: 0;
}

.em-cal-day-event-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--em-text);
}

.em-cal-day-event-loc,
.em-cal-day-event-desc {
  font-size: 12px;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

/* Event / contact modal */
.em-cal-modal {
  width: 460px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-self: flex-start;
}

.em-cal-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #005a9e;
  color: #fff;
}

.em-cal-modal-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.em-cal-modal-header .em-search-close {
  color: rgba(255,255,255,0.85);
}

.em-cal-modal-header .em-search-close:hover {
  background: rgba(255,255,255,0.15);
}

.em-cal-modal-body {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.em-cal-modal-field {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--em-text-secondary);
  border-bottom: 1px solid var(--em-border-light);
  padding-bottom: 8px;
}

.em-cal-modal-field-top {
  align-items: flex-start;
}

.em-cal-modal-field input,
.em-cal-modal-field textarea {
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  color: var(--em-text);
  background: transparent;
  flex: 1 1;
  min-width: 0;
}

.em-cal-modal-field input[type="date"],
.em-cal-modal-field input[type="time"] {
  flex: 0 0 auto;
}

.em-cal-modal-field textarea {
  resize: vertical;
}

.em-cal-modal-dash {
  color: var(--em-text-muted);
}

.em-cal-modal-allday {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--em-text-secondary);
  cursor: pointer;
  padding-left: 26px;
}

.em-cal-modal-colors {
  display: flex;
  gap: 6px;
}

.em-cal-color-swatch {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
}

.em-cal-color-swatch-active {
  border-color: #1a1a1a;
  outline: 1px solid #fff;
  outline-offset: -3px;
}

.em-cal-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-cal-modal-footer-right {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.em-cal-modal-delete {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid transparent;
  background: transparent;
  color: #dc2626;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  border-radius: 3px;
  padding: 4px 10px;
}

.em-cal-modal-delete:hover {
  background: #fdecec;
}

/* =====================================================================
   PEOPLE / CONTACTS
   ===================================================================== */
.em-people {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-people-list {
  width: 320px;
  min-width: 280px;
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  background: var(--em-bg);
}

.em-people-toolbar {
  padding: 8px;
  border-bottom: 1px solid var(--em-border-light);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.em-people-new {
  margin: 0;
  justify-content: center;
}

.em-people-search {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 5px 8px;
  color: var(--em-text-muted);
}

.em-people-search input {
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  flex: 1 1;
  background: transparent;
  color: var(--em-text);
}

.em-people-scroll {
  flex: 1 1;
  overflow-y: auto;
}

.em-people-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--em-border-light);
}

.em-people-item:hover {
  background: var(--em-bg-tertiary);
}

.em-people-item-active {
  background: var(--em-active) !important;
}

.em-people-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-people-item-info {
  min-width: 0;
}

.em-people-item-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-people-item-email {
  font-size: 12px;
  color: var(--em-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-people-empty,
.em-tasks-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 48px 24px;
  color: var(--em-text-muted);
  text-align: center;
}

.em-people-empty p,
.em-tasks-empty p {
  margin: 8px 0 0;
  font-size: 15px;
  color: var(--em-text-secondary);
}

.em-people-empty span,
.em-tasks-empty span {
  font-size: 12px;
}

.em-people-detail {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  background: var(--em-bg-secondary);
}

.em-people-detail-empty {
  color: var(--em-text-muted);
}

.em-people-card {
  align-self: flex-start;
  width: 100%;
  max-width: 560px;
  margin: 32px auto;
  background: #fff;
  border: 1px solid var(--em-border-light);
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  overflow: hidden;
}

.em-people-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(180deg, #eaf1fb, #fff);
  border-bottom: 1px solid var(--em-border-light);
}

.em-people-card-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-people-card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.em-people-card-title {
  font-size: 13px;
  color: var(--em-text-secondary);
}

.em-people-card-actions {
  margin-left: auto;
  display: flex;
  gap: 4px;
}

.em-people-card-actions button,
.em-people-card-actions a {
  width: 32px;
  height: 32px;
  border: 1px solid var(--em-border);
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.em-people-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  padding: 48px 24px;
  color: var(--em-text-muted);
  text-align: center;
}
.em-people-empty-state p { margin: 8px 0 0; font-size: 15px; color: var(--em-text-secondary); }
.em-people-empty-state span { font-size: 12px; max-width: 320px; }

.em-muted { color: var(--em-text-muted); font-size: 12px; }

.em-people-card-actions button:hover,
.em-people-card-actions a:hover {
  background: var(--em-hover);
}

.em-people-card-body {
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.em-people-card-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--em-text);
}

.em-people-card-row svg {
  color: var(--em-text-secondary);
  flex-shrink: 0;
}

.em-people-card-row a,
.em-people-link-btn {
  color: var(--em-accent);
  text-decoration: none;
}

.em-people-card-row a:hover,
.em-people-link-btn:hover {
  text-decoration: underline;
}

.em-people-link-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-align: left;
}

/* =====================================================================
   TASKS / TO DO
   ===================================================================== */
.em-tasks {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-tasks-sidebar {
  width: 220px;
  min-width: 200px;
  border-right: 1px solid var(--em-border);
  background: var(--em-sidebar-bg);
  padding-bottom: 8px;
  overflow-y: auto;
}

.em-tasks-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: linear-gradient(180deg, #eef3fb, #fff 220px);
}

.em-tasks-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 24px 12px;
  color: var(--em-accent);
}

.em-tasks-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--em-text);
}

.em-tasks-add {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 24px 12px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  color: var(--em-text-secondary);
}

.em-tasks-add > input:first-of-type {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  background: transparent;
  color: var(--em-text);
}

.em-tasks-add-due {
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text-secondary);
  outline: none;
}

.em-tasks-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 24px 24px;
}

.em-tasks-done-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--em-text-secondary);
  margin: 16px 0 8px;
}

.em-task-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid var(--em-border-light);
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 6px;
}

.em-task-row:hover {
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.em-task-check {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-accent);
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.em-task-row-done .em-task-check {
  color: #059669;
}

.em-task-info {
  flex: 1 1;
  min-width: 0;
}

.em-task-title {
  font-size: 14px;
  color: var(--em-text);
}

.em-task-row-done .em-task-title {
  text-decoration: line-through;
  color: var(--em-text-muted);
}

.em-task-due {
  font-size: 11px;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.em-task-star,
.em-task-delete {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-muted);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 3px;
  padding: 4px;
}

.em-task-star:hover,
.em-task-delete:hover {
  background: var(--em-hover);
}

.em-task-star-on {
  color: #f59e0b;
}

.em-task-delete:hover {
  color: #dc2626;
}

/* =====================================================================
   MAILBOX ACCOUNT SETTINGS MODAL
   ===================================================================== */
.em-acct-modal {
  width: 560px;
  max-width: calc(100vw - 40px);
  align-self: flex-start;
}

.em-acct-body {
  max-height: 70vh;
  overflow-y: auto;
}

.em-acct-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #eef4ff;
  border: 1px solid #d3e2ff;
  color: #274b8f;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.4;
}

.em-acct-hint svg {
  flex-shrink: 0;
  margin-top: 1px;
}

.em-acct-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--em-text-secondary);
  margin-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-acct-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.em-acct-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.em-acct-col2 {
  grid-column: 1 / -1;
}

.em-acct-field > span {
  font-size: 11px;
  color: var(--em-text-secondary);
  font-weight: 500;
}

.em-acct-field input:not([type="checkbox"]) {
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  font-family: inherit;
  color: var(--em-text);
  outline: none;
  background: var(--em-bg);
}

.em-acct-field input:not([type="checkbox"]):focus {
  border-color: var(--em-accent);
}

.em-acct-password-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.em-acct-password-wrap input {
  width: 100%;
  padding-right: 32px !important;
}

.em-acct-password-toggle {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--em-text-secondary);
  cursor: pointer;
  border-radius: 3px;
}

.em-acct-password-toggle:hover {
  color: var(--em-text);
  background: var(--em-hover);
}

.em-acct-check {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  grid-column: 1 / -1;
}

.em-acct-check span {
  font-size: 12px;
  color: var(--em-text-secondary);
}

/* Calendar/People/Tasks responsive */
@media (max-width: 900px) {
  .em-cal-sidebar,
  .em-tasks-sidebar {
    display: none;
  }
  .em-people-list {
    width: 100%;
  }
  .em-people-detail {
    display: none;
  }
}


/* ── Resume attachment actions (Add to Job / Database) ── */
.em-att-actions { position: relative; display: inline-flex; }
.em-att-action-btn {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 8px; font-size: 12px; font-weight: 600;
  color: #0e527d; background: #eaf3f9; border: 1px solid #cfe3ef;
  border-radius: 5px; cursor: pointer; white-space: nowrap;
}
.em-att-action-btn:hover:not(:disabled) { background: #dcecf6; }
.em-att-action-btn:disabled { opacity: 0.6; cursor: default; }
.em-att-menu {
  /* position/top/left are set inline (fixed) so the menu is never clipped by
     the reading-pane overflow. */
  z-index: 2000;
  min-width: 220px; background: #fff; border: 1px solid #e0e0e0;
  border-radius: 6px; box-shadow: 0 6px 20px rgba(0,0,0,0.18); padding: 4px;
}
.em-att-menu-item {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 8px 10px; font-size: 13px; color: #222; background: none;
  border: none; border-radius: 4px; cursor: pointer; text-align: left;
}
.em-att-menu-item:hover { background: #f2f6f9; color: #0e527d; }
.em-spin { animation: em-spin 0.8s linear infinite; }
@keyframes em-spin { to { transform: rotate(360deg); } }

.em-jobpick-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.35);
  display: flex; align-items: center; justify-content: center; z-index: 10000;
}
.em-jobpick {
  width: 460px; max-width: 92vw; max-height: 80vh; display: flex; flex-direction: column;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25); overflow: hidden;
}
.em-jobpick-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 16px; font-size: 14px; font-weight: 700; color: #fff; background: #0e527d;
}
.em-jobpick-x { background: none; border: none; color: #fff; cursor: pointer; display: flex; }
.em-jobpick-company { display: flex; align-items: center; gap: 10px; padding: 12px 16px 6px; }
.em-jobpick-company label { font-size: 12px; font-weight: 600; color: #555; min-width: 62px; }
.em-jobpick-company select { flex: 1 1; padding: 7px 10px; font-size: 13px; border: 1px solid #dcdcdc; border-radius: 6px; background: #fff; outline: none; }
.em-jobpick-dbnote { padding: 8px 16px 4px; font-size: 12.5px; color: #666; }
.em-jobpick-search { display: flex; align-items: center; gap: 8px; padding: 10px 16px; border-bottom: 1px solid #eee; color: #888; }
.em-jobpick-search input { flex: 1 1; border: 1px solid #dcdcdc; border-radius: 6px; padding: 7px 10px; font-size: 13px; outline: none; }
.em-jobpick-searchbtn { padding: 7px 12px; font-size: 12px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }
.em-jobpick-list { flex: 1 1; overflow-y: auto; padding: 6px 8px; min-height: 160px; }
.em-jobpick-empty { padding: 30px 12px; text-align: center; color: #999; font-size: 13px; }
.em-jobpick-item { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 6px; cursor: pointer; font-size: 13px; }
.em-jobpick-item:hover { background: #f2f6f9; }
.em-jobpick-item-sel { background: #eaf3f9; }
.em-jobpick-item-txt { flex: 1 1; }
.em-jobpick-pager { display: flex; align-items: center; justify-content: center; gap: 14px; padding: 8px 16px; border-top: 1px solid #eee; font-size: 12px; color: #666; }
.em-jobpick-pager button { display: inline-flex; align-items: center; gap: 3px; padding: 5px 10px; font-size: 12px; background: #fff; border: 1px solid #dcdcdc; border-radius: 5px; cursor: pointer; }
.em-jobpick-pager button:disabled { opacity: 0.45; cursor: not-allowed; }
.em-jobpick-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 16px; border-top: 1px solid #eee; }
.em-jobpick-cancel { padding: 8px 16px; font-size: 13px; background: #f2f2f2; border: 1px solid #ddd; border-radius: 6px; cursor: pointer; }
.em-jobpick-add { padding: 8px 18px; font-size: 13px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }
.em-jobpick-add:disabled { opacity: 0.55; cursor: not-allowed; }

/* Attachment destination modal: keep long filenames readable without crowding
   the title or close control. */
.em-jobpick {
  width: min(560px, calc(100vw - 32px));
  max-height: min(80vh, 620px);
}

.em-jobpick-head {
  gap: 16px;
  padding: 16px 18px;
}

.em-jobpick-title {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.em-jobpick-title-main {
  font-size: 15px;
  line-height: 1.25;
}

.em-jobpick-title-file {
  min-width: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-jobpick-x {
  flex: 0 0 auto;
  padding: 6px;
  border-radius: 6px;
}

.em-jobpick-company {
  gap: 12px;
  padding: 18px 18px 8px;
}

.em-jobpick-company label {
  flex: 0 0 64px;
  min-width: 0;
  color: #334155;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.em-jobpick-company select {
  min-width: 0;
  min-height: 38px;
  border-color: #cbd5e1;
  color: #1e293b;
}

.em-jobpick-dbnote {
  margin: 8px 18px 14px;
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #f8fbff;
  color: #475569;
  font-size: 13px;
  line-height: 1.45;
}

.em-jobpick-foot {
  gap: 8px;
  padding: 14px 18px;
  background: #f8fafc;
}

.em-jobpick-cancel,
.em-jobpick-add {
  min-height: 38px;
  padding: 8px 16px;
}

@media (max-width: 520px) {
  .em-jobpick-company {
    align-items: flex-start;
    flex-direction: column;
  }

  .em-jobpick-company select {
    width: 100%;
  }
}

/* ── Calendar sync loader ── */
.em-cal-syncing {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: #0e527d;
  background: #eaf3f9;
  border: 1px solid #cfe3ef;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.em-cal { position: relative; }

.em-viewer-hdr-icon { padding: 6px 8px; }

/* ── Attachment click-to-preview ── */
.em-viewer-att-clickable {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}
.em-viewer-att-preview { cursor: pointer; }
.em-viewer-att-preview:hover .em-viewer-att-name { color: #0e527d; text-decoration: underline; }
.em-viewer-att-eye {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; padding: 0; margin-right: 4px;
  border: 1px solid var(--em-border, #e0e0e0); border-radius: 4px;
  background: #fff; color: #0e527d; cursor: pointer;
}
.em-viewer-att-eye:hover { background: #eaf3f9; }

.em-att-preview-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center; z-index: 2000;
}
.em-att-preview {
  width: 860px; max-width: 94vw; height: 88vh; max-height: 92vh;
  background: #fff; border-radius: 10px; overflow: hidden;
  display: flex; flex-direction: column; box-shadow: 0 16px 50px rgba(0,0,0,0.35);
}
.em-att-preview-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; background: #0e527d; color: #fff; flex-shrink: 0;
}
.em-att-preview-title {
  display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.em-att-preview-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.em-att-preview-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border: none; border-radius: 5px;
  background: rgba(255,255,255,0.15); color: #fff; cursor: pointer;
}
.em-att-preview-btn:hover { background: rgba(255,255,255,0.28); }
.em-att-preview-body { flex: 1 1; background: #f4f6f8; overflow: auto; display: flex; }
.em-att-preview-frame { width: 100%; height: 100%; border: none; }
.em-att-preview-img { max-width: 100%; max-height: 100%; margin: auto; object-fit: contain; }
.em-att-preview-none {
  margin: auto; text-align: center; color: #6b7280; display: flex;
  flex-direction: column; align-items: center; gap: 10px; padding: 30px;
}
.em-att-preview-dl {
  padding: 8px 16px; background: #0e527d; color: #fff; border-radius: 6px;
  text-decoration: none; font-size: 13px; font-weight: 600;
}

/* ── Sidebar module switcher (Mail / Calendar / People / To Do) ── */
.em-sidebar-modules {
  gap: 6px;
  padding: 8px 12px;
  cursor: default;
  justify-content: flex-start;
}
.em-sidebar-module-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--em-text-secondary, #555);
  cursor: pointer;
}
.em-sidebar-module-btn:hover { background: #e6ebf1; color: #0e527d; }
.em-sidebar-module-active { background: #dcecf6; color: #0e527d; }
.em-sidebar-module-icon { position: relative; display: inline-flex; }
.em-sidebar-module-badge {
  position: absolute;
  top: -7px;
  right: -9px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  font-size: 9px;
  font-weight: 700;
  line-height: 15px;
  text-align: center;
  color: #fff;
  background: #d13438;
  border-radius: 8px;
}

/* ── Mail view: folder bar on top, list + reading pane below ── */
.em-mailview {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}
.em-mailview-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.em-folderbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 7px 16px;
  background: #fafafa;
  border-bottom: 1px solid var(--em-border);
  flex-shrink: 0;
}
.em-folderbar-newmail {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 5px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}
.em-folderbar-newmail:hover { background: #00437a; }

.em-folderbar-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}
.em-folderbar-tabs::-webkit-scrollbar { height: 4px; }
.em-folderbar-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  color: var(--em-text-secondary, #555);
  white-space: nowrap;
}
.em-folderbar-tab:hover { background: #ececec; color: var(--em-text, #222); }
.em-folderbar-tab-active {
  background: #dcecf6;
  color: #0e527d;
  font-weight: 600;
}
.em-folderbar-count {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  background: #e2e6ea;
  border-radius: 9px;
  padding: 0 6px;
  min-width: 16px;
  text-align: center;
}
.em-folderbar-count-primary { background: #005a9e; color: #fff; }

.em-folderbar-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.em-folderbar-account {
  max-width: 200px;
  padding: 5px 8px;
  font-size: 12px;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 5px;
  background: #fff;
  color: #333;
  margin-right: 4px;
}
.em-folderbar-ibtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--em-text-secondary, #555);
  cursor: pointer;
}
.em-folderbar-ibtn:hover { background: #ececec; color: #0e527d; }

/* ── Mailbox settings: centered footer + logout ── */
.em-cal-modal-footer-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.em-acct-logout-row {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--em-border-light, #ebebeb);
  display: flex;
  justify-content: center;
}
.em-acct-logout-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #b42318;
  background: #fff;
  border: 1px solid #f0c6c0;
  border-radius: 6px;
  cursor: pointer;
}
.em-acct-logout-btn:hover:not(:disabled) { background: #fdecea; }
.em-acct-logout-btn:disabled { opacity: 0.6; cursor: default; }

/* ── In-app confirm modal (logout) ── */
.em-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.em-confirm-modal {
  width: 360px;
  max-width: 90%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.28);
  overflow: hidden;
}
.em-confirm-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 700;
  color: #b42318;
  border-bottom: 1px solid #f0e0de;
}
.em-confirm-body {
  padding: 16px 18px;
  font-size: 13px;
  color: #444;
  line-height: 1.6;
}
.em-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 18px 16px;
}
.em-confirm-danger {
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #d13438;
  border: 1px solid #b42318;
  border-radius: 6px;
  cursor: pointer;
}
.em-confirm-danger:hover:not(:disabled) { background: #b42318; }
.em-confirm-danger:disabled { opacity: 0.6; cursor: default; }

/* ===================== OUTLOOK-STYLE MESSAGE LIST ===================== */
.em-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  border-bottom: 1px solid var(--em-border);
  flex-shrink: 0;
  background: #fff;
}
.em-list-filters { display: flex; gap: 16px; }
.em-list-filter {
  border: none;
  background: transparent;
  font-size: 14px;
  color: var(--em-text-secondary, #666);
  cursor: pointer;
  padding: 2px 0;
  position: relative;
  font-family: inherit;
}
.em-list-filter-active { color: #0f6cbd; font-weight: 600; }
.em-list-filter-active::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: -8px;
  height: 2px;
  background: #0f6cbd;
}
.em-list-sort {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  color: var(--em-text-secondary, #666);
  cursor: pointer;
}
.em-list-loading { font-size: 12px; color: #888; padding: 4px; }

.em-mail-group {
  padding: 6px 14px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #0f6cbd;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Message row — no avatar, three lines (sender/time, subject, preview). */
.em-mail-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 14px 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  background: #fff;
}
.em-mail-item:hover { background: #f5f8fb; }
.em-mail-active, .em-mail-active:hover { background: #eaf2fb; }
.em-mail-unread::before {
  content: "";
  position: absolute;
  left: 0; top: 6px; bottom: 6px;
  width: 3px;
  border-radius: 2px;
  background: #0f6cbd;
}
.em-mail-body { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.em-mail-row1 { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.em-mail-sender {
  font-size: 13.5px;
  color: #1a1a1a;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-unread .em-mail-sender { font-weight: 700; }
.em-mail-date { font-size: 12px; color: #888; white-space: nowrap; flex-shrink: 0; }
.em-mail-unread .em-mail-date { color: #0f6cbd; font-weight: 600; }
.em-mail-subject-line {
  font-size: 13px;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-unread .em-mail-subject-line { color: #0f6cbd; font-weight: 600; }
.em-mail-preview-line {
  font-size: 12.5px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-side {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding-top: 2px;
}
.em-mail-star { display: inline-flex; cursor: pointer; opacity: 0.4; transition: opacity 0.1s; }
.em-mail-item:hover .em-mail-star { opacity: 1; }
.em-mail-attach-icon { color: #888; }

.em-list-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 6px 14px;
  border-top: 1px solid var(--em-border);
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
  background: #fff;
}
.em-list-nounread { padding: 24px; text-align: center; color: #999; font-size: 13px; }

/* ===================== BOTTOM STATUS BAR ===================== */
.em-statusbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--em-border);
  background: #f3f3f3;
  padding: 0 16px 0 0;
  flex-shrink: 0;
  min-height: 30px;
}
.em-statusbar .em-nav-rail { width: auto; }
.em-statusbar .em-nav-rail-top {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 3px 8px;
}
.em-statusbar-info {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
}
.em-statusbar-conn { color: #107c10; }

/* ===================== OUTLOOK-MATCH FOLDER PANE ===================== */
.em-sidebar { background: #faf9f8; }
.em-sidebar-section-title {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px 3px;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  text-transform: none;
  letter-spacing: 0;
}
.em-sidebar-section-chevron { color: #888; flex-shrink: 0; }
.em-sidebar-account-title { color: #201f1e; }
.em-sidebar-account-title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.em-sidebar-folder {
  padding: 4px 10px 4px 24px;
  margin: 0;
  border-radius: 0;
  min-height: 26px;
  font-size: 13px;
  color: #201f1e;
}
.em-sidebar-folder:hover { background: #f0eeed; }
.em-sidebar-folder-active { background: #dcecf6 !important; box-shadow: inset 3px 0 0 #0f6cbd; }
.em-sidebar-folder-label { flex: 1 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-sidebar-folder-count {
  margin-left: auto;
  font-size: 12px;
  color: #605e5c;
  background: transparent;
  padding: 0;
}
.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 600; }
.em-sidebar-more-btn { padding-left: 24px; }

/* Action buttons row — subtler, Outlook-ish */
.em-sidebar-search-btn { color: #444; }
.em-sidebar-search-btn:hover { background: #f0eeed; }

/* Message list selected-row: Outlook look */
.em-mail-active, .em-mail-active:hover { background: #eaf1fb; box-shadow: inset 2px 0 0 #0f6cbd; }

/* Date group header: subtle Outlook style */
.em-mail-group {
  background: #faf9f8;
  color: #444;
  border-bottom: 1px solid #f0f0f0;
}

/* ===================== OUTLOOK READING PANE ===================== */
.em-viewer { background: #fff; }
.em-viewer-header {
  background: #fff;
  padding: 14px 20px 10px;
  border-bottom: 1px solid #edebe9;
}
.em-viewer-subject {
  font-size: 18px;
  font-weight: 600;
  color: #242424;
  margin: 0 0 12px;
  line-height: 1.3;
}
.em-viewer-from-name { font-weight: 600; color: #242424; }
.em-viewer-from-addr { color: #605e5c; }

.em-viewer-webbanner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px;
  font-size: 12px;
  color: #605e5c;
  background: #fff;
  border-bottom: 1px solid #edebe9;
}
.em-viewer-webbanner svg { color: #0f6cbd; flex-shrink: 0; }
.em-viewer-weblink {
  background: none;
  border: none;
  color: #0f6cbd;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  font-family: inherit;
}
.em-viewer-weblink:hover { text-decoration: underline; }

.em-viewer-body {
  background: #fff;            /* no grey backdrop / white card */
  padding: 0;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  background: transparent;    /* no card — plain white reading area */
  max-width: 900px;
  margin: 0;                  /* left-aligned, not centered */
  padding: 0;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
}

/* Message content: left-aligned with comfortable padding (Gmail-style). */
.em-viewer-html-body {
  background: transparent;
  padding: 18px 26px;
  text-align: left;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;
  color: #242424;
  line-height: 1.5;
  overflow-x: auto;           /* never let a wide fixed-width template break the layout */
}
/* Normalize legacy / arbitrary templates so nothing overflows and images scale. */
.em-viewer-html-body img { max-width: 100%; height: auto; }
.em-viewer-html-body table { max-width: 100%; border-collapse: collapse; }
/* Left-align top-level content instead of centering it. */
.em-viewer-html-body > table,
.em-viewer-html-body > div,
.em-viewer-html-body > center > table { margin-left: 0 !important; margin-right: auto !important; }
.em-viewer-html-body a { color: #0f6cbd; }

/* Plain-text emails keep readable padding (no template to bleed). */
.em-viewer-text-body {
  background: transparent;
  margin: 0;
  padding: 24px 28px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 13.5px;
  color: #242424;
  line-height: 1.5;
}

/* ===================== RIBBON / SIDEBAR TWEAKS (tabbed ribbon) ===================== */
.em-ribbon-btn:disabled {
  opacity: 0.4;
  cursor: default;
  background: transparent;
  border-color: transparent;
}
.em-ribbon-btn:disabled:hover { background: transparent; border-color: transparent; }
.em-ribbon-content { flex-wrap: wrap; }

/* Clickable collapsible section headers in the folder pane */
.em-sidebar-section-title-toggle { cursor: pointer; border-radius: 3px; }
.em-sidebar-section-title-toggle:hover { background: #f0eeed; }
.em-sidebar-section-title-toggle .em-sidebar-section-chevron { transition: transform 0.15s; }

/* ===================== CLEAN & BEAUTIFUL SIDEBAR (polish) ===================== */
.em-sidebar {
  width: 214px;
  min-width: 214px;
  background: #fbfbfa;
  border-right: 1px solid #ececec;
  padding: 4px 4px 12px;
}

/* New mail button */
.em-sidebar-newmail {
  margin: 6px 6px 10px;
  padding: 9px 14px;
  background: #0f6cbd;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  gap: 9px;
  box-shadow: 0 1px 2px rgba(15, 108, 189, 0.25);
  transition: background 0.12s;
}
.em-sidebar-newmail:hover { background: #0c5aa0; }
.em-sidebar-newmail:active { background: #0a4e8c; }

/* Action rows: Sync / Settings / Add mailbox */
.em-sidebar-search-btn {
  margin: 1px 6px;
  padding: 7px 10px;
  min-height: 32px;
  gap: 11px;
  border-radius: 6px;
  font-size: 13px;
  color: #3b3a39;
}
.em-sidebar-search-btn svg { color: #605e5c; }
.em-sidebar-search-btn:hover { background: #f0efee; }

/* Sections */
.em-sidebar-section {
  padding: 2px 0 6px;
  margin-top: 6px;
  border-top: 1px solid #ededed;
}
.em-sidebar-section-title {
  padding: 9px 12px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #605e5c;
  text-transform: none;
  letter-spacing: 0;
}
.em-sidebar-section-title-toggle { margin: 0 6px; padding-left: 6px; border-radius: 6px; }
.em-sidebar-section-title-toggle:hover { background: #f0efee; }
.em-sidebar-account-title span { color: #201f1e; font-weight: 600; }

/* Folder rows — soft rounded pills */
.em-sidebar-folder {
  margin: 1px 6px;
  padding: 7px 10px;
  min-height: 32px;
  gap: 11px;
  border-radius: 6px;
  font-size: 13.5px;
  color: #201f1e;
  box-shadow: none;
  transition: background 0.1s, color 0.1s;
}
.em-sidebar-folder:hover { background: #f0efee; }
.em-sidebar-folder-active,
.em-sidebar-folder-active:hover {
  background: #eaf1fb !important;
  box-shadow: none;
  color: #0f6cbd;
  font-weight: 600;
}
.em-sidebar-folder-icon { color: #605e5c; display: inline-flex; align-items: center; }
.em-sidebar-folder-active .em-sidebar-folder-icon { color: #0f6cbd; }
.em-sidebar-folder-count { margin-left: auto; font-size: 12px; color: #797775; font-weight: 500; }
.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 700; }

/* More */
.em-sidebar-more-btn {
  margin: 2px 6px 0;
  padding: 6px 10px 6px 34px;
  border-radius: 6px;
  font-size: 12.5px;
  color: #605e5c;
  gap: 6px;
}
.em-sidebar-more-btn:hover { background: #f0efee; }

/* ===================== GROUPED OUTLOOK RIBBON ===================== */
.em-rb-content {
  display: flex;
  align-items: stretch;
  padding: 4px 4px 2px;
  background: #fff;
  overflow-x: auto;
  min-height: 90px;
  border-bottom: 1px solid var(--em-ribbon-border, #e1dfdd);
}
.em-rb-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #e8e6e4;
  padding: 2px 6px 0;
  flex-shrink: 0;
}
.em-rb-group:last-child { border-right: none; }
.em-rb-buttons { display: flex; align-items: stretch; gap: 1px; flex: 1 1; }
.em-rb-group-label {
  font-size: 10px;
  color: #8a8886;
  text-align: center;
  padding: 3px 0 3px;
  white-space: nowrap;
}
.em-rb-big {
  display: flex; flex-direction: column; align-items: center; justify-content: flex-start;
  gap: 3px;
  min-width: 44px; max-width: 68px;
  padding: 4px 5px;
  background: transparent; border: 1px solid transparent; border-radius: 3px;
  cursor: pointer; color: #201f1e; font-family: inherit;
}
.em-rb-big:hover { background: #eef4fb; border-color: #d6e4f5; }
.em-rb-big:disabled { opacity: 0.4; cursor: default; }
.em-rb-big:disabled:hover { background: transparent; border-color: transparent; }
.em-rb-big-label { font-size: 10.5px; line-height: 1.15; text-align: center; }
.em-rb-stack { display: flex; flex-direction: column; justify-content: center; gap: 1px; padding: 0 2px; }
.em-rb-small {
  display: flex; align-items: center; gap: 5px;
  padding: 2px 6px 2px 4px; border-radius: 3px;
  background: transparent; border: 1px solid transparent; cursor: pointer;
  color: #201f1e; font-family: inherit; font-size: 11px; white-space: nowrap;
}
.em-rb-small:hover { background: #eef4fb; border-color: #d6e4f5; }
.em-rb-small span { flex: 1 1; text-align: left; }
.em-rb-small:disabled { opacity: 0.4; cursor: default; }
.em-rb-people {
  display: flex; align-items: center; gap: 4px;
  border: 1px solid #d0d0d0; border-radius: 3px; padding: 1px 6px; background: #fff; margin-bottom: 2px;
}
.em-rb-people input { border: none; outline: none; font-size: 11px; width: 96px; background: transparent; }

/* ===================== NEW-MAIL DESKTOP TOAST ===================== */
.em-nmt {
  position: fixed; right: 18px; bottom: 44px; z-index: 4000;
  width: 344px; background: #fff; border: 1px solid #e1dfdd; border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0,0,0,0.22); overflow: hidden;
  font-family: 'Segoe UI', Arial, sans-serif;
  animation: em-nmt-in 0.25s ease;
}
@keyframes em-nmt-in { from { transform: translateY(14px); opacity: 0; } to { transform: none; opacity: 1; } }
.em-nmt-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; border-bottom: 1px solid #f0f0f0; }
.em-nmt-brand { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: #444; font-weight: 500; }
.em-nmt-logo { width: 18px; height: 18px; border-radius: 3px; background: #0f6cbd; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; }
.em-nmt-count { font-size: 11px; color: #0f6cbd; margin-left: 2px; }
.em-nmt-head-actions { display: flex; align-items: center; gap: 2px; }
.em-nmt-head-actions button { background: none; border: none; cursor: pointer; color: #666; padding: 3px; border-radius: 4px; display: inline-flex; }
.em-nmt-head-actions button:hover { background: #f0f0f0; }
.em-nmt-body { display: flex; gap: 12px; padding: 12px 14px; cursor: pointer; }
.em-nmt-body:hover { background: #f7fafd; }
.em-nmt-avatar { width: 44px; height: 44px; border-radius: 50%; background: #b3b0ad; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0; }
.em-nmt-text { min-width: 0; flex: 1 1; }
.em-nmt-sender { font-size: 14px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-nmt-subject { font-size: 12.5px; color: #605e5c; margin: 1px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-nmt-preview { font-size: 12px; color: #797775; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.em-nmt-foot { display: flex; border-top: 1px solid #f0f0f0; }
.em-nmt-foot button { flex: 1 1; padding: 9px 0; background: #f7f6f5; border: none; border-right: 1px solid #eaeaea; cursor: pointer; color: #444; display: inline-flex; align-items: center; justify-content: center; }
.em-nmt-foot button:last-child { border-right: none; }
.em-nmt-foot button:hover { background: #eaeaea; }

/* ===================== RULES MODAL ===================== */
.em-rules {
  width: 580px; max-width: calc(100vw - 40px); max-height: 84vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
}
.em-rules-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-rules-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-rules-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-rules-x:hover { background: #f0f0f0; }
.em-rules-body { padding: 16px 18px; overflow-y: auto; }
.em-rules-hint { font-size: 12.5px; color: #605e5c; margin: 0 0 14px; line-height: 1.5; }
.em-rules-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }
.em-rules-empty { font-size: 13px; color: #999; padding: 14px; text-align: center; border: 1px dashed #ddd; border-radius: 8px; }
.em-rules-item { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border: 1px solid #ececec; border-radius: 8px; background: #fbfbfa; }
.em-rules-item-off { opacity: 0.55; }
.em-rules-item-text { flex: 1 1; min-width: 0; }
.em-rules-item-name { font-size: 13.5px; font-weight: 600; color: #201f1e; }
.em-rules-item-desc { font-size: 12px; color: #605e5c; margin-top: 2px; }
.em-rules-del { background: none; border: none; cursor: pointer; color: #b0413e; padding: 5px; border-radius: 5px; }
.em-rules-del:hover { background: #fde7e6; }
.em-rules-toggle { position: relative; display: inline-flex; cursor: pointer; flex-shrink: 0; }
.em-rules-toggle input { position: absolute; opacity: 0; width: 34px; height: 18px; margin: 0; cursor: pointer; }
.em-rules-check { width: 34px; height: 18px; border-radius: 10px; background: #c8c6c4; position: relative; transition: background .15s; }
.em-rules-check::after { content: ''; position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: #fff; transition: left .15s; }
.em-rules-toggle input:checked + .em-rules-check { background: #0f6cbd; }
.em-rules-toggle input:checked + .em-rules-check::after { left: 18px; }
.em-rules-new { border: 1px solid #ececec; border-radius: 8px; padding: 14px; background: #fafafa; }
.em-rules-new-title { font-size: 13px; font-weight: 600; color: #201f1e; margin-bottom: 10px; }
.em-rules-row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.em-rules-lbl { font-size: 12.5px; color: #444; width: 56px; flex-shrink: 0; }
.em-rules-input, .em-rules-select { border: 1px solid #d0d0d0; border-radius: 6px; padding: 7px 9px; font-size: 13px; font-family: inherit; outline: none; }
.em-rules-input { width: 100%; }
.em-rules-input:focus, .em-rules-select:focus { border-color: #0f6cbd; }
.em-rules-input-value { flex: 1 1; width: auto; }
.em-rules-select { background: #fff; }
.em-rules-add { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 7px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-rules-add:disabled { opacity: 0.5; cursor: default; }
.em-rules-foot { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-top: 1px solid #ececec; }
.em-rules-run { display: inline-flex; align-items: center; gap: 6px; background: #107c10; color: #fff; border: none; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-rules-run:hover { background: #0e6b0e; }
.em-rules-close { background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 8px 16px; font-size: 13px; cursor: pointer; }
.em-rules-close:hover { background: #e8e6e4; }

/* Give bulleted/numbered lists in HTML email templates proper indentation. */
.em-viewer-html-body ul,
.em-viewer-html-body ol { padding-left: 2rem; }

/* Folder deep-sync progress strip (shown while a folder's messages download). */
.em-list-syncbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  font-size: 12px;
  color: #0f6cbd;
  background: #eef4fb;
  border-bottom: 1px solid #dbe7f5;
  flex-shrink: 0;
}
.em-list-syncbar .em-spinner {
  width: 13px; height: 13px;
  border: 2px solid #bcd4ef;
  border-top-color: #0f6cbd;
  border-radius: 50%;
  display: inline-block;
  animation: em-spin 0.7s linear infinite;
}
@keyframes em-spin { to { transform: rotate(360deg); } }

/* Sender initial-avatar in front of each message row (space in front of emails). */
.em-mail-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 1px;
  margin-right: 4px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;
}
/* Center the avatar against the 3-line message body. */
.em-mail-item { align-items: center; }

/* ===================== VIEW: density / preview / active toggles ===================== */
/* Compact ("Use Tighter Spacing") — tighter rows, smaller avatar, no preview line. */
.em-list-compact .em-mail-item { padding-top: 5px; padding-bottom: 5px; gap: 8px; }
.em-list-compact .em-mail-avatar { width: 26px; height: 26px; font-size: 11px; }
.em-list-compact .em-mail-preview-line { display: none; }
.em-list-compact .em-mail-subject-line { font-size: 12.5px; }

/* Message Preview off — hide the preview line. */
.em-list-nopreview .em-mail-preview-line { display: none; }

/* Active/toggled ribbon command (Reading Pane on, Work Offline on, current sort…). */
.em-rb-active { background: #dbeafe !important; border-color: #a9c9f0 !important; }
.em-rb-big.em-rb-active { color: #0f6cbd; }
.em-rb-small.em-rb-active { color: #0f6cbd; font-weight: 600; }

/* ===================== READ ALOUD CONTROL BAR ===================== */
.em-ra {
  position: fixed;
  top: 132px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5000;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-ra-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #e1dfdd;
  border-radius: 10px;
  box-shadow: 0 6px 22px rgba(0,0,0,0.18);
  padding: 6px 8px;
}
.em-ra-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 7px;
  color: #333;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.em-ra-btn:hover { background: #f0f0f0; }
.em-ra-btn-active { background: #eaf1fb; color: #0f6cbd; }
.em-ra-play { color: #0f6cbd; }
.em-ra-close:hover { background: #fde7e6; color: #d13438; }

.em-ra-panel {
  margin-top: 8px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  box-shadow: 0 6px 22px rgba(0,0,0,0.18);
  padding: 14px 16px;
  width: 240px;
}
.em-ra-field { margin-bottom: 12px; }
.em-ra-field:last-child { margin-bottom: 0; }
.em-ra-field label {
  display: block;
  font-size: 13px;
  color: #201f1e;
  margin-bottom: 6px;
}
.em-ra-field input[type="range"] { width: 78%; vertical-align: middle; accent-color: #0f6cbd; }
.em-ra-rate { font-size: 12px; color: #605e5c; margin-left: 8px; }
.em-ra-field select {
  width: 100%;
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  background: #fff;
  font-family: inherit;
  color: #201f1e;
}

/* ===================== SCHEDULE MEETING MODAL ===================== */
.em-meeting {
  width: 460px; max-width: calc(100vw - 40px); max-height: 86vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-meeting-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-meeting-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-meeting-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-meeting-x:hover { background: #f0f0f0; }
.em-meeting-body { padding: 16px 18px; overflow-y: auto; }
.em-meeting-body label { display: block; font-size: 12.5px; color: #444; margin: 10px 0 4px; }
.em-meeting-body input, .em-meeting-body select, .em-meeting-body textarea {
  width: 100%; padding: 8px 10px; font-size: 13.5px; border: 1px solid #d0d0d0; border-radius: 6px;
  font-family: inherit; outline: none; box-sizing: border-box;
}
.em-meeting-body input:focus, .em-meeting-body select:focus, .em-meeting-body textarea:focus { border-color: #0f6cbd; }
.em-meeting-row { display: flex; gap: 10px; }
.em-meeting-row > div { flex: 1 1; }
.em-meeting-foot { display: flex; align-items: center; gap: 8px; padding: 12px 18px; border-top: 1px solid #ececec; }
.em-meeting-google { display: inline-flex; align-items: center; gap: 7px; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 9px 14px; font-size: 13.5px; font-weight: 600; cursor: pointer; }
.em-meeting-google:hover { background: #0c5aa0; }
.em-meeting-ics { display: inline-flex; align-items: center; gap: 5px; background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 12px; font-size: 13px; cursor: pointer; }
.em-meeting-ics:hover { background: #e8e6e4; }
.em-meeting-cancel { margin-left: auto; background: none; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 16px; font-size: 13px; cursor: pointer; }
.em-meeting-cancel:hover { background: #f3f2f1; }

/* ===================== REMINDERS WINDOW ===================== */
.em-reminders {
  width: 420px; max-width: calc(100vw - 40px); max-height: 80vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-reminders-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-reminders-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-reminders-count { background: #d13438; color: #fff; border-radius: 10px; font-size: 11px; font-weight: 700; padding: 1px 7px; }
.em-reminders-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-reminders-x:hover { background: #f0f0f0; }
.em-reminders-body { padding: 8px 0; overflow-y: auto; }
.em-reminders-empty { text-align: center; color: #888; padding: 30px 20px; display: flex; flex-direction: column; align-items: center; gap: 6px; }
.em-reminders-empty p { margin: 4px 0 0; font-size: 15px; color: #555; }
.em-reminders-empty span { font-size: 12.5px; }
.em-reminder-item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 18px; border-bottom: 1px solid #f2f2f2; }
.em-reminder-item:hover { background: #faf9f8; }
.em-reminder-icon { margin-top: 2px; flex-shrink: 0; }
.em-reminder-text { flex: 1 1; min-width: 0; cursor: pointer; }
.em-reminder-title { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-reminder-sub { font-size: 12px; color: #605e5c; margin: 2px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-reminder-when { font-size: 12px; color: #0f6cbd; font-weight: 500; }
.em-reminder-dismiss { align-self: center; background: #f3f2f1; border: 1px solid #d8d8d8; border-radius: 5px; padding: 5px 10px; font-size: 12px; cursor: pointer; flex-shrink: 0; }
.em-reminder-dismiss:hover { background: #e8e6e4; }
.em-reminders-foot { padding: 10px 18px; border-top: 1px solid #ececec; text-align: right; }
.em-reminders-dismissall { background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-reminders-dismissall:hover { background: #0c5aa0; }

/* ===================== RIBBON: COLOURED, SPACED, CLEANER ===================== */
/* Left space so the toolbar isn't cluttered against the edge. */
.em-ribbon-tabs { padding: 0 8px 0 22px; }
.em-rb-content { padding: 7px 14px 3px 22px; gap: 2px; }

/* More horizontal breathing room + softer separators between groups. */
.em-rb-group { padding: 2px 15px 0; border-right: 1px solid #eef0f2; }
.em-rb-group:last-child { border-right: none; }
.em-rb-buttons { gap: 4px; }
.em-rb-big { min-width: 48px; max-width: 74px; padding: 5px 7px; gap: 4px; }
.em-rb-small { padding: 3px 7px 3px 5px; }
.em-rb-stack { gap: 2px; padding: 0 3px; }
.em-rb-group-label { color: #9aa0a6; padding-top: 5px; font-size: 10px; }

/* Softer hover (keep the coloured icons visible). */
.em-rb-big:hover, .em-rb-small:hover { background: #f2f5f9; border-color: #e2e8f0; }

/* Active/toggled command — light rounded blue chip. */
.em-rb-active { background: #eaf1fb !important; border-color: #cfe0f5 !important; border-radius: 6px; }
.em-rb-big.em-rb-active .em-rb-big-label,
.em-rb-small.em-rb-active span { color: #1a5fbf; font-weight: 600; }

/* Search-people pill spacing. */
.em-rb-people { margin-bottom: 3px; }

/* ===================== NO SCROLLBARS — SHOW EVERYTHING ===================== */
/* Ribbon: never scroll horizontally — wrap groups onto a second row instead. */
.em-rb-content {
  overflow-x: hidden;
  flex-wrap: wrap;
  align-content: flex-start;
  row-gap: 2px;
}

/* Folder pane: compact rows so all folders fit without a scrollbar. */
.em-sidebar { overflow-y: auto; }
.em-sidebar-newmail { margin: 5px 6px 6px; padding: 7px 12px; }
.em-sidebar-search-btn { min-height: 26px; padding: 4px 10px; margin: 0 6px; }
.em-sidebar-section { margin-top: 3px; padding: 1px 0 3px; border-top-color: #f0f0f0; }
.em-sidebar-section-title { padding: 5px 12px 2px; }
.em-sidebar-folder { min-height: 26px; padding: 4px 10px 4px 24px; margin: 0 6px; }
.em-sidebar-more-btn { padding-top: 3px; padding-bottom: 3px; }

/* Slim, unobtrusive scrollbar if content still just barely overflows. */
.em-sidebar::-webkit-scrollbar { width: 6px; }
.em-sidebar::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }
.em-sidebar::-webkit-scrollbar-track { background: transparent; }

/* ===================== COMPACT SINGLE-ROW OUTLOOK RIBBON (match reference) ===================== */
.em-rb-content {
  flex-wrap: nowrap;          /* single row like classic Outlook */
  overflow-x: auto;
  overflow-y: hidden;
  align-content: stretch;
  padding: 5px 8px 2px 12px;
  gap: 0;
  min-height: 82px;
  row-gap: 0;
}
.em-rb-group { padding: 2px 8px 0; }
.em-rb-buttons { gap: 1px; }
.em-rb-stack { gap: 0; padding: 0 2px; }
.em-rb-big { min-width: 40px; max-width: 64px; padding: 3px 5px; gap: 2px; }
.em-rb-big svg { width: 17px; height: 17px; }
.em-rb-big-label { font-size: 10px; line-height: 1.1; }
.em-rb-small { padding: 2px 5px 2px 4px; font-size: 10.5px; gap: 4px; }
.em-rb-small svg { width: 13px; height: 13px; }
.em-rb-group-label { font-size: 9px; padding-top: 3px; }
.em-rb-people { padding: 1px 6px; margin-bottom: 2px; }
.em-rb-people input { width: 84px; font-size: 10.5px; }

/* If it can't fit (very narrow window) the scrollbar is slim, not a big grey bar. */
.em-rb-content::-webkit-scrollbar { height: 6px; }
.em-rb-content::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }
.em-rb-content::-webkit-scrollbar-track { background: transparent; }

/* ===================== CLEAN STRUCTURED EMAIL / TEMPLATE RENDERING ===================== */
/* Reading pane = soft canvas; the email sits on a centered white "sheet". */
.em-viewer-body {
  background: #f3f4f6;
  padding: 22px 18px;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  max-width: 840px;
  margin: 0 auto;                 /* centered, not floating left */
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;               /* clip full-width headers to the rounded card */
  padding: 0;
}
.em-viewer-html-body {
  padding: 30px 36px;
  text-align: left;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;
  color: #242424;
  line-height: 1.6;
  overflow-x: auto;
}
.em-viewer-html-body img { max-width: 100%; height: auto; }
.em-viewer-html-body table { max-width: 100%; }
/* Centre the template's top-level blocks so headers/logos sit balanced. */
.em-viewer-html-body > table,
.em-viewer-html-body > div,
.em-viewer-html-body > center,
.em-viewer-html-body > center > table {
  margin-left: auto !important;
  margin-right: auto !important;
}
.em-viewer-html-body p { margin: 0 0 12px; }
.em-viewer-html-body ul,
.em-viewer-html-body ol { padding-left: 1.5rem; margin: 10px 0; }
.em-viewer-html-body a { color: #0f6cbd; }
.em-viewer-text-body {
  padding: 30px 36px;
  max-width: none;
  font-size: 14px;
  line-height: 1.6;
}

/* ===================== IFRAME EMAIL RENDERING (clean, isolated) ===================== */
.em-viewer-body {
  background: #f3f4f6;
  padding: 22px 18px;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  max-width: 880px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;
  padding: 0;
}
.em-viewer-frame {
  width: 100%;
  border: none;
  display: block;
  background: #ffffff;
  min-height: 180px;
}
.em-viewer-text-body {
  padding: 26px 30px;
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

/* ===================== ACCOUNT AVATAR + POPOVER (ribbon top-right) ===================== */
.em-ribbon-tabs { position: relative; }
.em-ribbon-account { margin-left: auto; position: relative; display: flex; align-items: center; padding-right: 12px; }
.em-ribbon-avatar-btn { background: none; border: none; cursor: pointer; padding: 3px; border-radius: 50%; display: inline-flex; }
.em-ribbon-avatar-btn:hover { background: #e5e7eb; }
.em-ribbon-avatar {
  width: 28px; height: 28px; border-radius: 50%; background: #4b7c72; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600;
}
.em-account-backdrop { position: fixed; inset: 0; z-index: 6000; }
.em-account-pop {
  position: absolute; top: 40px; right: 8px; z-index: 6001; width: 330px;
  background: #fff; border: 1px solid #e1dfdd; border-radius: 10px;
  box-shadow: 0 12px 36px rgba(0,0,0,0.22); overflow: hidden;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-account-pop-main { display: flex; gap: 16px; padding: 20px; }
.em-account-pop-avatar {
  width: 58px; height: 58px; border-radius: 50%; background: #4b7c72; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 600; flex-shrink: 0;
}
.em-account-pop-info { min-width: 0; }
.em-account-pop-name { font-size: 16px; font-weight: 700; color: #201f1e; word-break: break-word; line-height: 1.3; }
.em-account-pop-email { font-size: 13px; color: #605e5c; margin: 2px 0 6px; word-break: break-word; }
.em-account-pop-view { background: none; border: none; color: #0f6cbd; font-size: 13px; cursor: pointer; padding: 0; font-family: inherit; }
.em-account-pop-view:hover { text-decoration: underline; }
.em-account-pop-add {
  display: flex; align-items: center; gap: 12px; width: 100%; padding: 14px 20px;
  background: #fff; border: none; border-top: 1px solid #ececec; cursor: pointer;
  font-size: 14px; color: #201f1e; font-family: inherit; text-align: left;
}
.em-account-pop-add svg { color: #605e5c; }
.em-account-pop-add:hover { background: #f5f5f5; }

/* ===================== SIDEBAR: MORE BREATHING ROOM (top actions) ===================== */
.em-sidebar-newmail { margin: 10px 8px 8px; padding: 10px 14px; gap: 9px; }
.em-sidebar-search-btn { min-height: 34px; padding: 8px 12px; margin: 2px 8px; gap: 12px; }
.em-sidebar-search-btn:last-of-type { margin-bottom: 10px; }

/* Account button now shows the name next to the avatar. */
.em-ribbon-avatar-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 3px 6px 3px 10px;
  border-radius: 18px;
}
.em-ribbon-username {
  font-size: 12.5px;
  font-weight: 600;
  color: #201f1e;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.em-ribbon-avatar-caret { color: #605e5c; flex-shrink: 0; }

/* ===================== SIDEBAR COLLAPSE TOGGLE ===================== */
.em-sidebar-collapsehdr { display: flex; justify-content: flex-end; padding: 4px 6px 0; }
.em-sidebar-collapse-btn {
  background: none; border: none; cursor: pointer; color: #605e5c;
  padding: 4px; border-radius: 5px; display: inline-flex;
}
.em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }

/* Narrow rail shown when the folder pane is collapsed — click to expand. */
.em-collapsed-rail {
  width: 34px; min-width: 34px; flex-shrink: 0;
  background: #fbfbfa; border-right: 1px solid #ececec;
  display: flex; flex-direction: column; align-items: center; padding-top: 8px;
}
.em-collapsed-expand {
  background: none; border: none; cursor: pointer; color: #605e5c;
  padding: 5px; border-radius: 5px; display: inline-flex;
}
.em-collapsed-expand:hover { background: #eceff2; color: #0f6cbd; }

/* ===================== COMPACT ICON-ONLY MODULE RAIL (bottom-left) ===================== */
.em-nav-rail-top { display: flex; flex-direction: row; align-items: center; gap: 2px; }
.em-nav-rail-btn {
  flex-direction: row; min-width: auto; padding: 6px 9px; gap: 0;
}
.em-nav-rail-label { display: none; }
.em-nav-rail-more svg { color: #605e5c; }

/* New mail button + collapse toggle on one row (no separate top row/space). */
.em-sidebar-collapsehdr { display: none; }
.em-sidebar-newmail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 8px 6px;
}
.em-sidebar-newmail-row .em-sidebar-newmail { flex: 1 1; margin: 0; }
.em-sidebar-newmail-row .em-sidebar-collapse-btn {
  flex-shrink: 0;
  color: #605e5c;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
}
.em-sidebar-newmail-row .em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }

/* ===================== OUTLOOK-WEB READING PANE TOOLBAR ===================== */
.em-viewer-toolbar {
  display: flex;
  align-items: center;
  gap: 1px;
  padding: 6px 12px;
  border-bottom: 1px solid #eaeaea;
  background: #ffffff;
  flex-shrink: 0;
  overflow-x: auto;
}
.em-vt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: none;
  background: transparent;
  border-radius: 5px;
  cursor: pointer;
  color: #3b3a39;
  font-size: 13px;
  font-family: inherit;
  white-space: nowrap;
}
.em-vt-btn:hover { background: #f3f2f1; }
.em-vt-btn svg { color: #605e5c; }
.em-vt-icon { padding: 6px 8px; }
.em-vt-sep { width: 1px; height: 20px; background: #e6e6e6; margin: 0 6px; flex-shrink: 0; }
.em-vt-spacer { flex: 1 1; min-width: 8px; }

/* Slim the sender row now that actions live in the top toolbar. */
.em-viewer-header-right { text-align: right; }

/* ===================== CRM / INSIGHTS RIGHT PANE ===================== */
.em-crm {
  width: 210px;
  min-width: 210px;
  flex-shrink: 0;
  border-left: 1px solid #eaeaea;
  background: #faf9f8;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-crm-head { padding: 12px 16px; font-size: 13px; font-weight: 600; color: #605e5c; border-bottom: 1px solid #ededed; }
.em-crm-body { padding: 14px 16px; }
.em-crm-contact { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.em-crm-avatar {
  width: 40px; height: 40px; border-radius: 50%; background: #8764b8; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0;
}
.em-crm-info { min-width: 0; }
.em-crm-name { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-crm-email { font-size: 12px; color: #605e5c; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-crm-note {
  display: flex; gap: 8px; align-items: flex-start;
  font-size: 12.5px; color: #605e5c; line-height: 1.45;
  background: #fff; border: 1px solid #ededed; border-radius: 8px; padding: 10px 12px;
}
.em-crm-note svg { color: #0f6cbd; flex-shrink: 0; margin-top: 1px; }
.em-crm-note strong { color: #201f1e; word-break: break-all; }

/* Final email preview subject size override */
.em-module .em-viewer .em-viewer-header .em-viewer-subject-row .em-viewer-subject,
.em-module.em-ribbon-collapsed .em-viewer .em-viewer-header .em-viewer-subject-row .em-viewer-subject {
  font-size: 14px !important;
  line-height: 1.28 !important;
  font-weight: 600 !important;
}

/* Final email preview action alignment override */
.em-module .em-viewer .em-viewer-header .em-viewer-subject-row {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  width: 100% !important;
  margin: 0 0 12px 0 !important;
}

.em-module .em-viewer .em-viewer-header .em-preview-head-actions {
  margin-left: auto !important;
  margin-top: 0 !important;
  align-self: center !important;
  transform: none !important;
}

.em-module .em-viewer .em-viewer-header .em-preview-action-btn {
  height: 30px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Final Outlook-clean frame and folder pane */
.em-module {
  padding: 10px 14px 10px 14px !important;
  background: #f3f6fa !important;
}

.em-module .em-ribbon,
.em-module .em-module-body,
.em-module .em-statusbar {
  width: 100% !important;
  box-sizing: border-box !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.em-module .em-ribbon {
  border: 1px solid #cfd8e3 !important;
  border-bottom: 0 !important;
  border-radius: 10px 10px 0 0 !important;
  box-shadow: none !important;
}

.em-module .em-module-body {
  border: 1px solid #cfd8e3 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.em-module .em-statusbar {
  border: 1px solid #cfd8e3 !important;
  border-top: 0 !important;
  border-radius: 0 0 10px 10px !important;
  box-shadow: none !important;
}

.em-module .em-sidebar {
  width: 228px !important;
  min-width: 228px !important;
  background: #f3f3f3 !important;
  border-right: 1px solid #d9d9d9 !important;
  border-radius: 0 !important;
  padding: 4px 0 8px 0 !important;
}

.em-module .em-sidebar-newmail-row {
  min-height: 0 !important;
  height: 18px !important;
  margin: 0 4px 0 4px !important;
  justify-content: flex-end !important;
}

.em-module .em-sidebar-newmail-row .em-sidebar-newmail {
  display: none !important;
}

.em-module .em-sidebar-newmail-row .em-sidebar-collapse-btn {
  width: 20px !important;
  height: 18px !important;
  padding: 0 !important;
  justify-content: center !important;
  color: #4b5563 !important;
  border-radius: 3px !important;
}

.em-module .em-sidebar-search-btn {
  min-height: 25px !important;
  width: 100% !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 6px 14px 6px 28px !important;
  border-radius: 0 !important;
  background: transparent !important;
  color: #242424 !important;
  font-size: 12px !important;
  gap: 8px !important;
  display: flex !important;
  align-items: center !important;
}

.em-module .em-sidebar-search-btn:hover {
  background: #e8e8e8 !important;
}

.em-module .em-sidebar-section {
  margin: 6px 8px 0 8px !important;
  padding: 0 0 7px 0 !important;
  border-top: 1px solid #dedede !important;
}

.em-module .em-sidebar-section:first-of-type {
  border-top: 0 !important;
}

.em-module .em-sidebar-section-title {
  min-height: 24px !important;
  padding: 5px 4px 3px 0 !important;
  margin: 0 !important;
  color: #242424 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.em-module .em-sidebar-account-title span {
  font-weight: 600 !important;
}

.em-module .em-sidebar-section-chevron {
  color: #3f3f46 !important;
  width: 11px !important;
  height: 11px !important;
}

.em-module .em-sidebar-folder,
.em-module .em-sidebar-more-btn {
  min-height: 24px !important;
  margin: 0 !important;
  padding: 3px 8px 3px 18px !important;
  border-radius: 0 !important;
  background: transparent !important;
  color: #242424 !important;
  font-size: 12px !important;
  line-height: 1.2 !important;
}

.em-module .em-sidebar-folder:hover,
.em-module .em-sidebar-more-btn:hover {
  background: #e8e8e8 !important;
}

.em-module .em-sidebar-folder-active,
.em-module .em-sidebar-folder-active:hover {
  background: #dedede !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-left: 0 !important;
}

.em-module .em-sidebar-folder-icon {
  display: none !important;
}

.em-module .em-sidebar-folder-label {
  color: inherit !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.em-module .em-sidebar-folder-active .em-sidebar-folder-label {
  font-weight: 600 !important;
}

.em-module .em-sidebar-folder-count {
  margin-left: auto !important;
  color: #005a9e !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

.em-module .em-statusbar .em-nav-rail-top {
  background: #f8fafc !important;
  border: 1px solid #d6e1ec !important;
  border-radius: 999px !important;
}

/* Attachment file type icons */
.em-viewer-att-type-icon {
  width: 24px !important;
  height: 24px !important;
  border-radius: 6px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  border: 1px solid transparent !important;
}

.em-viewer-att-type-icon svg {
  width: 16px !important;
  height: 16px !important;
}

.em-att-icon-pdf {
  color: #c2410c !important;
  background: #fff1e8 !important;
  border-color: #fed7aa !important;
}

.em-att-icon-word {
  color: #1d4ed8 !important;
  background: #eff6ff !important;
  border-color: #bfdbfe !important;
}

.em-att-icon-excel {
  color: #047857 !important;
  background: #ecfdf5 !important;
  border-color: #a7f3d0 !important;
}

.em-att-icon-image {
  color: #7c3aed !important;
  background: #f5f3ff !important;
  border-color: #ddd6fe !important;
}

.em-att-icon-default {
  color: #475569 !important;
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
}

/* Email list selected item: no blue fill, only Outlook-style left bar */
.em-module .em-list .em-mail-item.em-mail-active,
.em-module .em-list .em-mail-item.em-mail-active:hover {
  background: #ffffff !important;
  box-shadow: inset 3px 0 0 #0f6cbd !important;
}

.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-sender,
.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-subject-line {
  color: #111827 !important;
}

.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-date {
  color: #888 !important;
}

/* ===================== Email module rounded Outlook shell ===================== */
.em-module {
  padding: 14px 18px 14px 18px !important;
  background:
    radial-gradient(circle at top left, rgba(15, 108, 189, 0.08), transparent 34%),
    linear-gradient(180deg, #eef5fb 0%, #f7f9fc 100%) !important;
}

.em-ribbon {
  border-radius: 16px 16px 0 0 !important;
  border: 1px solid #d7e3f1 !important;
  border-bottom: 0 !important;
  box-shadow: 0 10px 26px rgba(15, 52, 94, 0.08) !important;
  overflow: visible !important;
  position: relative !important;
  z-index: 20 !important;
}

.em-ribbon-tabs {
  overflow: visible !important;
  border-radius: 16px 16px 0 0 !important;
  position: relative !important;
  z-index: 40 !important;
  display: flex !important;
  align-items: center !important;
}

.em-ribbon-account,
.em-ribbon-avatar-btn {
  position: relative !important;
  z-index: 80 !important;
}

.em-account-pop {
  top: calc(100% + 8px) !important;
  right: 8px !important;
  z-index: 9999 !important;
  border-radius: 16px !important;
  border: 1px solid #d8e3ef !important;
  box-shadow: 0 18px 48px rgba(15, 52, 94, 0.22) !important;
  overflow: hidden !important;
}

.em-module-body {
  border-radius: 0 0 16px 16px !important;
  border: 1px solid #d7e3f1 !important;
  overflow: hidden !important;
  box-shadow: 0 14px 32px rgba(15, 52, 94, 0.09) !important;
}

.em-sidebar {
  border-radius: 0 0 0 16px !important;
}

.em-viewer {
  border-radius: 0 0 16px 0 !important;
}

.em-viewer-body {
  background:
    linear-gradient(180deg, #f8fbff 0%, #f4f6f9 100%) !important;
}

.em-viewer-paper {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 14px 34px rgba(15, 52, 94, 0.10) !important;
}

.em-statusbar {
  min-height: 40px !important;
  margin-top: 0 !important;
  padding: 5px 14px 6px 10px !important;
  border: 1px solid #d7e3f1 !important;
  border-top: 0 !important;
  border-radius: 0 0 16px 16px !important;
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow: 0 12px 26px rgba(15, 52, 94, 0.08) !important;
}

.em-statusbar .em-nav-rail-top {
  gap: 7px !important;
  padding: 4px 8px !important;
  border: 1px solid #dce8f4 !important;
  border-radius: 999px !important;
  background: #f7fbff !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;
}

.em-statusbar .em-nav-rail-btn {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  color: #4b647a !important;
}

.em-statusbar .em-nav-rail-btn:hover {
  background: #e6f2ff !important;
  color: #0f6cbd !important;
}

.em-statusbar .em-nav-rail-btn-active {
  background: linear-gradient(135deg, #0f6cbd, #0b7f74) !important;
  color: #fff !important;
  box-shadow: 0 6px 14px rgba(15, 108, 189, 0.24) !important;
}

.em-nav-rail-badge {
  border: 2px solid #fff !important;
  box-shadow: 0 3px 8px rgba(220, 38, 38, 0.24) !important;
}

.em-statusbar-info {
  padding: 6px 12px !important;
  border-radius: 999px !important;
  background: #f8fafc !important;
  border: 1px solid #e1e8f0 !important;
}

/* Compact email message action toolbar */
.em-viewer-toolbar {
  min-height: 30px !important;
  padding: 3px 8px !important;
  gap: 2px !important;
}

.em-vt-btn {
  min-height: 22px !important;
  padding: 3px 6px !important;
  gap: 4px !important;
  font-size: 11px !important;
  line-height: 1.1 !important;
}

.em-vt-btn span {
  font-size: 11px !important;
}

.em-vt-btn svg {
  width: 12px !important;
  height: 12px !important;
}

/* Ribbon collapse toggle for a larger reading preview */
.em-ribbon-toggle {
  margin-left: 8px !important;
  margin-right: 8px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  width: 28px !important;
  height: 24px !important;
  border: 1px solid #cfe0f2 !important;
  border-radius: 999px !important;
  background: #f7fbff !important;
  color: #0f6cbd !important;
  line-height: 1 !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: center !important;
  flex-shrink: 0 !important;
  box-shadow: 0 2px 7px rgba(15, 108, 189, 0.12) !important;
}

.em-ribbon-toggle svg {
  display: block !important;
  margin: 0 !important;
  stroke-width: 2.4 !important;
}

.em-ribbon-toggle:hover {
  background: #e7f2ff !important;
  border-color: #8fc0ef !important;
}

.em-ribbon-mini .em-rb-content {
  display: none !important;
}

.em-ribbon-mini {
  min-height: 36px !important;
  border-bottom: 1px solid #d7e3f1 !important;
}

.em-ribbon-mini .em-ribbon-tabs {
  min-height: 34px !important;
}

.em-ribbon-collapsed .em-module-body {
  height: calc(100vh - 92px) !important;
  min-height: 610px !important;
}

.em-viewer-subject,
.em-ribbon-collapsed .em-viewer-subject {
  font-size: 16px !important;
  line-height: 1.25 !important;
  font-weight: 600 !important;
}

/* Compact Outlook preview header with inline reply controls */
.em-viewer > .em-viewer-toolbar {
  display: none !important;
}

.em-viewer-header {
  padding: 13px 24px 11px 24px !important;
  border-bottom: 1px solid #e5e7eb !important;
  background: #fff !important;
}

.em-viewer-subject-row {
  display: flex !important;
  align-items: flex-start !important;
  gap: 12px !important;
  margin-bottom: 12px !important;
}

.em-viewer-subject {
  flex: 1 1 auto !important;
  margin: 0 !important;
  color: #0f172a !important;
}

.em-preview-head-actions {
  display: inline-flex !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border: 1px solid #bfc7d1 !important;
  border-radius: 3px !important;
  background: #fff !important;
  overflow: hidden !important;
}

.em-preview-action-btn {
  height: 30px !important;
  padding: 0 10px !important;
  border: 0 !important;
  border-right: 1px solid #bfc7d1 !important;
  background: #fff !important;
  color: #1f2937 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  font-size: 12px !important;
  line-height: 1 !important;
  cursor: pointer !important;
  font-family: inherit !important;
}

.em-preview-action-btn:last-child {
  border-right: 0 !important;
}

.em-preview-action-btn:hover {
  background: #f3f7fb !important;
}

.em-preview-action-btn svg {
  color: #0f6cbd !important;
  stroke-width: 2 !important;
}

.em-preview-more-btn {
  width: 32px !important;
  padding: 0 !important;
  justify-content: center !important;
}

.em-viewer-from-row {
  align-items: center !important;
  gap: 10px !important;
}

.em-viewer-avatar-lg {
  width: 43px !important;
  height: 43px !important;
  font-size: 14px !important;
  background: #008272 !important;
  color: #fff !important;
}

.em-viewer-from-name {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #111827 !important;
}

.em-viewer-from-addr {
  font-size: 11px !important;
  line-height: 1.35 !important;
  color: #334155 !important;
}

.em-viewer-date {
  font-size: 11px !important;
  color: #475569 !important;
  white-space: nowrap !important;
}

.em-viewer-webbanner {
  min-height: 25px !important;
  padding: 4px 24px !important;
  font-size: 11px !important;
  background: #fff !important;
}

/* Email module final polish: ATS spacing + calmer blue/teal grading */
.em-module {
  padding-left: 16px;
  padding-right: 14px;
  background: #f4f8fb !important;
  --em-accent: #0f766e;
  --em-accent-hover: #0f4c81;
  --em-ribbon-bg: #ffffff;
  --em-ribbon-border: #d7e3f0;
  --em-sidebar-bg: #ffffff;
  --em-hover: #eef7f4;
  --em-active: #e3f3ff;
}

.em-ribbon {
  margin-top: 10px;
  border: 1px solid #d7e3f0;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: #ffffff !important;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
}

.em-ribbon-tabs {
  background: linear-gradient(90deg, #f8fbff 0%, #eef7f4 100%) !important;
  border-bottom: 1px solid #d7e3f0 !important;
}

.em-ribbon-tab {
  color: #334155 !important;
}

.em-ribbon-tab-active {
  color: #0f4c81 !important;
  background: #ffffff !important;
  border-bottom-color: #0f766e !important;
}

.em-ribbon-content,
.em-rb-content {
  background: #ffffff !important;
}

.em-ribbon-btn:hover,
.em-rb-big:hover,
.em-rb-small:hover {
  background: #eef7f4 !important;
  border-color: #c8e7df !important;
}

.em-sidebar {
  margin-left: 10px;
  border: 1px solid #d7e3f0 !important;
  border-top: 0 !important;
  border-radius: 0 0 12px 12px;
  background: #ffffff !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.07);
}

.em-sidebar-newmail {
  background: linear-gradient(90deg, #0f4c81, #0f766e) !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 18px rgba(15, 76, 129, 0.18);
}

.em-sidebar-newmail:hover {
  background: linear-gradient(90deg, #0d426f, #0d665f) !important;
}

.em-sidebar-search-btn {
  border-radius: 8px !important;
  color: #334155 !important;
}

.em-sidebar-search-btn:hover {
  background: #eef7f4 !important;
  color: #0f4c81 !important;
}

.em-sidebar-section {
  border-top-color: #e2e8f0 !important;
}

.em-sidebar-section-title {
  color: #64748b !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
}

.em-sidebar-account-title span {
  color: #0f172a !important;
}

.em-sidebar-folder {
  border-radius: 8px !important;
  color: #334155 !important;
}

.em-sidebar-folder:hover {
  background: #f0fdfa !important;
}

.em-sidebar-folder-active,
.em-sidebar-folder-active:hover {
  background: #e0f2fe !important;
  color: #0f4c81 !important;
  box-shadow: inset 3px 0 0 #0f766e !important;
}

.em-sidebar-folder-active .em-sidebar-folder-icon,
.em-sidebar-folder-count-primary {
  color: #0f766e !important;
}

.em-sidebar-folder-count {
  color: #64748b !important;
}

.em-sidebar-modules {
  margin-left: 10px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #d7e3f0;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
}

.em-sidebar-module-active {
  background: #e0f2fe !important;
  color: #0f766e !important;
}

/* Email module Outlook preview style override */
.em-module {
  padding-left: 16px;
  padding-right: 14px;
  background: #f3f2f1 !important;
  font-family: "Segoe UI", Arial, sans-serif !important;
  --em-accent: #0f6cbd;
  --em-accent-hover: #0c5aa0;
  --em-ribbon-bg: #ffffff;
  --em-ribbon-border: #e1dfdd;
  --em-sidebar-bg: #faf9f8;
  --em-hover: #f3f2f1;
  --em-active: #eaf3ff;
}

.em-ribbon {
  margin-top: 8px;
  border: 1px solid #e1dfdd !important;
  border-radius: 4px 4px 0 0 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.em-ribbon-tabs {
  height: 34px !important;
  background: #ffffff !important;
  border-bottom: 1px solid #e1dfdd !important;
}

.em-ribbon-tab {
  color: #323130 !important;
  font-size: 13px !important;
  border-bottom: 2px solid transparent !important;
}

.em-ribbon-tab:hover {
  background: #f3f2f1 !important;
}

.em-ribbon-tab-active {
  color: #0f6cbd !important;
  background: #ffffff !important;
  border-bottom-color: #0f6cbd !important;
}

.em-ribbon-content,
.em-rb-content {
  background: #ffffff !important;
  border-bottom: 1px solid #d2d0ce !important;
}

.em-ribbon-group,
.em-rb-group {
  border-right-color: #edebe9 !important;
}

.em-ribbon-btn,
.em-rb-big,
.em-rb-small {
  color: #323130 !important;
  border-radius: 2px !important;
}

.em-ribbon-btn:hover,
.em-rb-big:hover,
.em-rb-small:hover {
  background: #f3f2f1 !important;
  border-color: #edebe9 !important;
}

.em-module-body {
  background: #f3f2f1 !important;
}

.em-sidebar {
  margin-left: 10px;
  border: 1px solid #e1dfdd !important;
  border-top: 0 !important;
  border-radius: 0 !important;
  background: #faf9f8 !important;
  box-shadow: none !important;
}

.em-sidebar-newmail {
  background: #0f6cbd !important;
  border: 1px solid #0f6cbd !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.em-sidebar-newmail:hover {
  background: #0c5aa0 !important;
  border-color: #0c5aa0 !important;
}

.em-sidebar-search-btn,
.em-sidebar-folder,
.em-sidebar-more-btn {
  border-radius: 4px !important;
  color: #323130 !important;
}

.em-sidebar-search-btn:hover,
.em-sidebar-folder:hover,
.em-sidebar-more-btn:hover {
  background: #f3f2f1 !important;
}

.em-sidebar-section {
  border-top-color: #edebe9 !important;
}

.em-sidebar-section-title {
  color: #605e5c !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.em-sidebar-folder-active,
.em-sidebar-folder-active:hover {
  background: #eaf3ff !important;
  color: #0f6cbd !important;
  box-shadow: inset 3px 0 0 #0f6cbd !important;
}

.em-sidebar-folder-active .em-sidebar-folder-icon,
.em-sidebar-folder-count-primary {
  color: #0f6cbd !important;
}

.em-sidebar-folder-count {
  color: #605e5c !important;
}

.em-mail-list,
.em-list-pane {
  background: #ffffff !important;
  border-color: #e1dfdd !important;
}

.em-mail-item,
.em-list-item {
  border-bottom-color: #edebe9 !important;
}

.em-mail-item:hover,
.em-list-item:hover {
  background: #f3f9ff !important;
}

.em-mail-item-active,
.em-list-item-active {
  background: #cfe8ff !important;
}

.em-viewer-body {
  background: #f3f2f1 !important;
}

.em-viewer-paper {
  border: 1px solid #e1dfdd !important;
  border-radius: 2px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) !important;
}

.em-viewer-toolbar {
  background: #ffffff !important;
  border-bottom: 1px solid #edebe9 !important;
}

.em-vt-btn:hover {
  background: #f3f2f1 !important;
}

.em-sidebar-modules {
  margin-left: 10px;
  border: 1px solid #e1dfdd !important;
  border-radius: 0 !important;
  background: #faf9f8 !important;
  box-shadow: none !important;
}

.em-sidebar-module-active {
  background: #eaf3ff !important;
  color: #0f6cbd !important;
}

/* Clean Outlook-like three-pane structure */
.em-module {
  padding: 10px 18px 0 18px !important;
  background: #f5f6f8 !important;
}

.em-ribbon {
  margin: 0 !important;
  border: 1px solid #d9d9d9 !important;
  border-bottom: 0 !important;
  border-radius: 2px 2px 0 0 !important;
  background: #ffffff !important;
}

.em-ribbon-tabs {
  height: 34px !important;
  padding-left: 22px !important;
  background: #ffffff !important;
}

.em-ribbon-tab {
  padding: 0 10px !important;
  font-size: 13px !important;
}

.em-ribbon-content,
.em-rb-content {
  min-height: 82px !important;
  max-height: 96px !important;
  padding: 6px 12px 4px 22px !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.em-rb-group,
.em-ribbon-group {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.em-rb-big,
.em-ribbon-btn {
  min-width: 42px !important;
}

.em-module-body {
  height: calc(100vh - 174px) !important;
  min-height: 560px;
  border: 1px solid #d9d9d9;
  background: #ffffff !important;
  overflow: hidden;
}

.em-sidebar {
  width: 230px !important;
  min-width: 230px !important;
  margin: 0 !important;
  border: 0 !important;
  border-right: 1px solid #d9d9d9 !important;
  border-radius: 0 !important;
  background: #faf9f8 !important;
  box-shadow: none !important;
}

.em-sidebar-newmail-row {
  margin: 12px 12px 10px !important;
}

.em-sidebar-newmail {
  height: 42px !important;
  border-radius: 6px !important;
  background: #0f6cbd !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.em-sidebar-search-btn {
  min-height: 34px !important;
  margin: 2px 12px !important;
  padding: 7px 10px !important;
  border-radius: 4px !important;
  font-size: 13px !important;
}

.em-sidebar-section {
  margin: 8px 12px 0 !important;
  padding: 8px 0 !important;
}

.em-sidebar-section-title {
  padding: 5px 8px !important;
}

.em-sidebar-folder {
  min-height: 32px !important;
  margin: 1px 0 !important;
  padding: 6px 8px 6px 18px !important;
  border-radius: 4px !important;
  font-size: 13px !important;
}

.em-sidebar-folder-active,
.em-sidebar-folder-active:hover {
  background: #e7f1fb !important;
  box-shadow: inset 3px 0 0 #0f6cbd !important;
}

.em-sidebar-modules {
  margin: 0 !important;
  border: 0 !important;
  border-top: 1px solid #d9d9d9 !important;
  border-radius: 0 !important;
}

.em-list {
  width: 360px !important;
  min-width: 360px !important;
  border-right: 1px solid #d9d9d9 !important;
  background: #ffffff !important;
}

.em-list-header {
  height: 46px !important;
  padding: 0 14px !important;
  border-bottom: 1px solid #e1dfdd !important;
  background: #ffffff !important;
}

.em-list-filters {
  gap: 18px !important;
}

.em-list-filter {
  height: 46px !important;
  padding: 0 !important;
  color: #323130 !important;
  font-size: 14px !important;
}

.em-list-filter-active {
  color: #0f6cbd !important;
  font-weight: 600 !important;
}

.em-list-sort {
  color: #605e5c !important;
  font-size: 12px !important;
}

.em-mail-group {
  padding: 8px 14px 5px !important;
  color: #323130 !important;
  background: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-bottom: 1px solid #edebe9 !important;
}

.em-mail-item {
  min-height: 76px !important;
  padding: 10px 10px 10px 14px !important;
  border-left: 3px solid transparent !important;
  border-bottom: 1px solid #edebe9 !important;
  background: #ffffff !important;
}

.em-mail-item:hover {
  background: #f8fbff !important;
}

.em-mail-active,
.em-mail-active:hover {
  background: #dbeeff !important;
  border-left-color: #0f6cbd !important;
}

.em-mail-avatar {
  width: 36px !important;
  height: 36px !important;
  font-size: 13px !important;
}

.em-mail-sender {
  color: #111827 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.em-mail-date {
  color: #0f6cbd !important;
  font-size: 12px !important;
}

.em-mail-subject-line {
  color: #0f6cbd !important;
  font-size: 13px !important;
  font-weight: 600 !important;
}

.em-mail-preview-line {
  color: #605e5c !important;
  font-size: 12px !important;
}

.em-list-pager {
  height: 38px !important;
  border-top: 1px solid #e1dfdd !important;
  background: #ffffff !important;
}

.em-viewer {
  min-width: 0;
  background: #ffffff !important;
}

.em-viewer-toolbar {
  height: 44px !important;
  padding: 0 16px !important;
  border-bottom: 1px solid #e1dfdd !important;
  background: #ffffff !important;
}

.em-vt-btn {
  height: 32px !important;
  padding: 0 9px !important;
  border-radius: 4px !important;
  color: #323130 !important;
  font-size: 14px !important;
}

.em-vt-btn svg {
  color: #605e5c !important;
}

.em-vt-btn:hover {
  background: #f3f2f1 !important;
}

.em-viewer-header {
  padding: 18px 22px 12px !important;
  border-bottom: 1px solid #edebe9 !important;
  background: #ffffff !important;
}

.em-viewer-subject {
  margin: 0 0 14px !important;
  color: #111827 !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 1.35 !important;
}

.em-viewer-avatar-lg {
  width: 34px !important;
  height: 34px !important;
  background: #2563eb !important;
  font-size: 12px !important;
}

.em-viewer-from-name {
  color: #111827 !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.em-viewer-from-addr,
.em-viewer-date {
  color: #605e5c !important;
  font-size: 12px !important;
}

.em-viewer-webbanner {
  min-height: 34px !important;
  padding: 8px 22px !important;
  border-bottom: 1px solid #edebe9 !important;
  background: #ffffff !important;
  color: #605e5c !important;
  font-size: 12px !important;
}

.em-viewer-body {
  padding: 26px 34px !important;
  background: #f3f2f1 !important;
}

.em-viewer-paper {
  max-width: 960px !important;
  margin: 0 auto !important;
  border: 1px solid #e1dfdd !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.em-viewer-frame {
  background: #ffffff !important;
}

.em-crm {
  border-left-color: #d9d9d9 !important;
  background: #faf9f8 !important;
}

@media (max-width: 1200px) {
  .em-list {
    width: 330px !important;
    min-width: 330px !important;
  }

  .em-sidebar {
    width: 220px !important;
    min-width: 220px !important;
  }
}

#RecruiterTrackerReport_TableView {
    position: relative;
}

#RecruiterTrackerReport_TableView .rdt_TableBody {
    position: sticky;
}

#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {
    position: sticky;
    left: 0;
    top: 0;
    background-color: green;
    z-index: 1008;
}

#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {
    position: sticky;
    left: 64px;
    top: 0;
    background-color: green;
    z-index: 1008;
}

#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {
    position: sticky;
    left: 184px;
    top: 0;
    background-color: green;
    z-index: 1008;
}

#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {
    position: sticky;
    left: 324px;
    top: 0;
    background-color: green;
    z-index: 1008;
}

#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {
    position: sticky;
    left: 0;
    top: 0;
    background-color: #dfdfdf;
    z-index: 1;
}

#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {
    position: sticky;
    left: 64px;
    top: 0;
    z-index: 1;
    background-color: #dfdfdf;
}

#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {
    position: sticky;
    left: 184px;
    top: 0;
    z-index: 1;
    justify-content: initial;
    background-color: #dfdfdf;
}

#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {
    position: sticky;
    left: 324px;
    top: 0;
    z-index: 1;
    justify-content: initial;
    background-color: #dfdfdf;
}


@media screen and (min-width: 100px) and (max-width: 768px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: 320%;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {
        position: initial;
        left: initial;
        top: initial;
    }
}

@media screen and (min-width: 769px) and (max-width: 1199px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {
        position: initial;
        left: initial;
        top: initial;
    }

    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {
        position: initial;
        left: initial;
        top: initial;
    }
}

@media screen and (min-width: 1200px) and (max-width: 1399px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }
}

@media screen and (min-width: 1400px) and (max-width: 1599px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }
}


@media screen and (min-width: 1600px) and (max-width: 1799px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }
}

@media screen and (min-width: 1800px) and (max-width: 2099px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }
}

@media screen and (min-width: 2100px) and (max-width: 4099px) {
    #RecruiterTrackerReport_TableView .rdt_Table {
        min-width: initial;
    }
}
/* =====================================================================
   EMAIL MODULE — Outlook-style CSS
   ===================================================================== */

/* --- Layout --- */
.em-module {
  display: flex;
  flex-direction: column;
  /* Offset the fixed 70px app header so the ribbon is never clipped,
     and fill the remaining viewport height so panels lay out cleanly. */
  margin-top: 70px;
  height: calc(100vh - 70px);
  background: #f3f3f3;
  font-family: "Segoe UI", "San Francisco", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  font-size: 13px;
  color: #1a1a1a;
  overflow: hidden;
  --em-accent: #2563eb;
  --em-accent-hover: #1d4ed8;
  --em-bg: #ffffff;
  --em-bg-secondary: #fafafa;
  --em-bg-tertiary: #f0f0f0;
  --em-border: #e0e0e0;
  --em-border-light: #ebebeb;
  --em-text: #1a1a1a;
  --em-text-secondary: #616161;
  --em-text-muted: #999;
  --em-hover: #eaeaea;
  --em-active: #cce4ff;
  --em-ribbon-bg: #f8f9fa;
  --em-ribbon-border: #d0d0d0;
  --em-sidebar-bg: #fafafa;
  --em-unread-bg: #f5f7fa;
  --em-reading-pane-bg: #fff;
}

/* --- Main Layout --- */
.em-module-body {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* ===================== RIBBON ===================== */
.em-ribbon {
  background: var(--em-ribbon-bg);
  border-bottom: 1px solid var(--em-ribbon-border);
  -webkit-user-select: none;
          user-select: none;
  z-index: 10;
}

.em-ribbon-tabs {
  display: flex;
  align-items: stretch;
  height: 32px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
  padding: 0 8px;
}

.em-ribbon-tab {
  padding: 0 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: inherit;
  transition: none;
}

.em-ribbon-tab:hover {
  background: #eaeaea;
}

.em-ribbon-tab-active {
  color: var(--em-text);
  background: #f8f9fa;
  border-bottom-color: var(--em-accent);
  font-weight: 500;
}

.em-ribbon-content {
  background: var(--em-ribbon-bg);
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 56px;
}

.em-ribbon-group {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px;
  border-right: 1px solid var(--em-border);
}

.em-ribbon-group:last-child {
  border-right: none;
}

.em-ribbon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  padding: 3px 8px;
  cursor: pointer;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  color: var(--em-text);
  font-family: inherit;
  font-size: 11px;
  min-width: 44px;
  text-align: center;
  transition: none;
}

.em-ribbon-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-ribbon-btn:active {
  background: #ccc;
}

.em-ribbon-btn svg {
  display: block;
}

.em-ribbon-btn-label {
  font-size: 10px;
  line-height: 1.1;
  white-space: nowrap;
}

.em-ribbon-new-btn {
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  padding: 4px 16px 4px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.em-ribbon-new-btn:hover {
  background: #004578;
}

.em-ribbon-search {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 2px;
  padding: 0 6px;
  height: 24px;
  margin-left: auto;
  min-width: 180px;
}

.em-ribbon-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: inherit;
  padding: 0 4px;
  flex: 1 1;
  color: var(--em-text);
}

.em-ribbon-search input::placeholder {
  color: var(--em-text-muted);
}

.em-ribbon-quickbar {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
  padding: 2px 8px;
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-ribbon-quickbar em {
  font-style: normal;
  font-weight: 600;
  margin: 0 2px;
}

/* ===================== SIDEBAR ===================== */
.em-sidebar {
  width: 200px;
  min-width: 200px;
  background: var(--em-sidebar-bg);
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
}

.em-sidebar-newmail {
  margin: 8px 8px 4px;
  padding: 6px 12px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: none;
}

.em-sidebar-newmail:hover {
  background: #004578;
}

.em-sidebar-search-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  padding: 5px 12px;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-size: 12.5px;
  margin: 1px 6px;
  border-radius: 4px;
}

.em-sidebar-search-btn:hover {
  background: var(--em-hover);
}

.em-sidebar-section {
  padding: 6px 0;
  margin-top: 4px;
  border-top: 1px solid var(--em-border-light);
}

.em-sidebar-section-title {
  padding: 4px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--em-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.em-sidebar-folder {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  padding: 5px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin: 1px 6px;
  position: relative;
  color: var(--em-text);
  font-size: 13px;
}

.em-sidebar-folder:hover {
  background: var(--em-hover);
}

.em-sidebar-folder-active {
  background: var(--em-active) !important;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #0e527d;
}

.em-sidebar-folder-icon {
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--em-text-secondary);
  flex-shrink: 0;
}

.em-sidebar-folder-active .em-sidebar-folder-icon {
  color: var(--em-accent);
}

.em-sidebar-folder-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-sidebar-folder-count {
  font-size: 11px;
  color: var(--em-text-secondary);
  margin-left: auto;
  padding-left: 4px;
}

.em-sidebar-folder-count-primary {
  color: #005a9e;
  font-weight: 600;
}

.em-sidebar-more-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 16px;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-size: 11px;
  margin: 0 4px;
  border-radius: 3px;
}

.em-sidebar-more-btn:hover {
  background: var(--em-hover);
}

.em-sidebar-labels {
  padding: 2px 0;
}

.em-sidebar-label-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 16px;
  cursor: pointer;
  border-radius: 3px;
  margin: 0 4px;
}

.em-sidebar-label-item:hover {
  background: var(--em-hover);
}

.em-sidebar-label-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.em-sidebar-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border-top: 1px solid var(--em-border);
  color: var(--em-text-secondary);
  cursor: pointer;
}

/* ===================== EMAIL LIST ===================== */
.em-list {
  width: 360px;
  min-width: 300px;
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  background: var(--em-bg);
  overflow: hidden;
}

.em-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
  min-height: 28px;
}

.em-list-toolbar-left {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-list-toolbar-left input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.em-list-toolbar-label {
  cursor: pointer;
  padding: 0 2px;
}

.em-list-toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--em-text-secondary);
  cursor: pointer;
}

.em-list-range {
  font-size: 12px;
  color: var(--em-text-secondary);
  white-space: nowrap;
}

.em-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 4px;
  background: #fff;
  color: var(--em-text-secondary);
  cursor: pointer;
}

.em-page-btn:hover:not(:disabled) {
  background: #f3f4f6;
  color: var(--em-text-primary, #111);
}

.em-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.em-list-column-header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11px;
  color: var(--em-text-secondary);
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
}

.em-list-col-sort {
  font-weight: 500;
}

.em-list-body {
  flex: 1 1;
  overflow-y: auto;
}

.em-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--em-text-muted);
  gap: 4px;
}

.em-list-empty h3 {
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 400;
  color: var(--em-text-secondary);
}

.em-list-empty p {
  margin: 0;
  font-size: 13px;
}

/* --- Mail Item --- */
.em-mail-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--em-border-light);
  cursor: pointer;
  transition: none;
}

.em-mail-item:hover {
  background: var(--em-bg-tertiary);
}

.em-mail-active {
  background: var(--em-active) !important;
}

.em-mail-unread {
  background: var(--em-unread-bg);
}

.em-mail-unread .em-mail-sender {
  font-weight: 700;
}

.em-mail-unread .em-mail-subject {
  font-weight: 600;
}

.em-mail-chk {
  margin-top: 4px;
  flex-shrink: 0;
}

.em-mail-star {
  flex-shrink: 0;
  margin-top: 3px;
  cursor: pointer;
  line-height: 0;
  min-width: 15px;
}

.em-mail-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 1px;
}

.em-mail-content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.em-mail-row1 {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1.3;
}

.em-mail-sender {
  font-size: 13px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}

.em-mail-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.em-mail-row2 {
  display: flex;
  align-items: baseline;
  gap: 2px;
  line-height: 1.3;
  color: var(--em-text-secondary);
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
}

.em-mail-subject {
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  max-width: 50%;
}

.em-mail-preview {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--em-text-muted);
}

.em-mail-flags {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  margin-top: 2px;
}

.em-mail-attach-icon {
  color: var(--em-text-secondary);
}

.em-mail-unread-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2563eb;
  display: inline-block;
}

/* --- Skeleton --- */
.em-mail-item-skeleton {
  cursor: default;
}

.em-skeleton {
  background: #e8e8e8;
  border-radius: 3px;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
}

.em-skeleton-check {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
  margin-top: 4px;
}

.em-skeleton-star {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-top: 3px;
}

.em-skeleton-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}

.em-skeleton-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 0;
}

.em-skeleton-line {
  height: 12px;
}

.w-50 { width: 50%; }
.w-80 { width: 80%; }

@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.em-loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: var(--em-text-secondary);
  font-size: 12px;
}

.em-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--em-border);
  border-top-color: var(--em-accent);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===================== VIEWER (Reading Pane) ===================== */
.em-viewer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: var(--em-reading-pane-bg);
  min-width: 0;
  overflow: hidden;
}

.em-viewer-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-viewer-empty-content {
  text-align: center;
  color: var(--em-text-muted);
}

.em-viewer-empty-content h3 {
  font-size: 16px;
  font-weight: 400;
  color: var(--em-text-secondary);
  margin: 8px 0 4px;
}

.em-viewer-empty-content p {
  margin: 0;
  font-size: 12px;
}

/* --- Viewer Toolbar --- */
.em-viewer-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
  flex-wrap: wrap;
  min-height: 32px;
}

.em-vtb-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text-secondary);
  font-family: inherit;
  border-radius: 3px;
  height: 26px;
  transition: none;
}

.em-vtb-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-vtb-btn span {
  font-size: 11px;
}

.em-vtb-divider {
  width: 1px;
  height: 20px;
  background: var(--em-border);
  margin: 0 2px;
}

.em-vtb-right {
  margin-left: auto;
}

.em-vtb-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-vtb-close-btn:hover {
  background: #e5e5e5;
}

/* --- Viewer Header --- */
.em-viewer-header {
  padding: 12px 16px 8px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-viewer-subject-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.em-viewer-subject {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  line-height: 1.3;
}

.em-viewer-thread-badge {
  background: var(--em-bg-tertiary);
  padding: 0 6px;
  border-radius: 10px;
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-viewer-from-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.em-viewer-avatar-lg {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-viewer-from-details {
  flex: 1 1;
  min-width: 0;
}

.em-viewer-from-name {
  font-size: 14px;
  font-weight: 500;
}

.em-viewer-from-addr {
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-viewer-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
  margin-top: 4px;
}

/* Reply / Reply All / Forward moved into the header (top-right, Outlook style) */
.em-viewer-header-right {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}
.em-viewer-header-actions {
  display: flex;
  gap: 6px;
}
.em-viewer-hdr-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 12.5px;
  font-weight: 500;
  color: #0e527d;
  background: #fff;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}
.em-viewer-hdr-btn:hover {
  background: #eaf3f9;
  border-color: #cfe3ef;
}
.em-viewer-hdr-btn svg { color: #0e527d; }

/* --- Viewer Body --- */
.em-viewer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
}

.em-viewer-html-body {
  line-height: 1.6;
  font-size: 14px;
}

.em-viewer-html-body blockquote {
  margin: 8px 0;
  padding: 0 0 0 8px;
  border-left: 2px solid #ccc;
  color: #666;
}

.em-viewer-text-body {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* --- Attachments --- */
.em-viewer-attachments {
  border-top: 1px solid var(--em-border-light);
  padding: 8px 16px;
}

.em-viewer-att-header {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--em-text-secondary);
  font-size: 12px;
  margin-bottom: 8px;
}

.em-viewer-att-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.em-viewer-att-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  background: var(--em-bg-secondary);
  min-width: 160px;
}

.em-viewer-att-info {
  flex: 1 1;
  min-width: 0;
}

.em-viewer-att-name {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-viewer-att-size {
  font-size: 10px;
  color: var(--em-text-muted);
}

.em-viewer-att-dl {
  color: var(--em-accent);
  text-decoration: none;
  flex-shrink: 0;
}

/* --- Actions Bar --- */
.em-viewer-actions-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 16px;
  border-top: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-viewer-act-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text);
  font-family: inherit;
  border-radius: 3px;
}

.em-viewer-act-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-viewer-act-primary {
  font-weight: 600;
}

/* ===================== COMPOSE ===================== */
.em-compose-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: calc(100vw - 80px);
  max-height: 90vh;
  z-index: 1000;
  box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.em-compose-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #005a9e;
  color: #fff;
  border-radius: 8px 8px 0 0;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.em-compose-header h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}

.em-compose-header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.em-compose-header-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  border-radius: 3px;
}

.em-compose-header-btn:hover {
  background: rgba(255,255,255,0.15);
  color: #fff;
}

.em-compose-body {
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
}

.em-compose-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--em-border-light);
  padding: 0 4px;
}

.em-compose-field-label {
  width: 44px;
  font-size: 12px;
  color: var(--em-text-secondary);
  flex-shrink: 0;
  padding: 6px 4px;
}

.em-compose-field-input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 6px 4px;
  color: var(--em-text);
  background: transparent;
}

.em-compose-field-input::placeholder {
  color: var(--em-text-muted);
}

.em-compose-to-field {
  position: relative;
}

.em-compose-candidate-list {
  position: absolute;
  top: 100%;
  left: 44px;
  right: 0;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  max-height: 180px;
  overflow-y: auto;
  z-index: 10;
}

.em-compose-candidate-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
}

.em-compose-candidate-item:hover {
  background: var(--em-active);
}

.em-compose-candidate-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--em-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
}

.em-compose-candidate-info {
  flex: 1 1;
}

.em-compose-candidate-name {
  font-size: 12px;
  color: var(--em-text);
}

.em-compose-candidate-email {
  font-size: 11px;
  color: var(--em-text-muted);
}

.em-compose-tag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  flex: 1 1;
}

.em-compose-tag {
  display: flex;
  align-items: center;
  gap: 3px;
  background: #e8effa;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 11px;
  color: var(--em-accent);
}

.em-compose-tag-remove {
  cursor: pointer;
  opacity: 0.6;
  display: flex;
  align-items: center;
}

.em-compose-tag-remove:hover {
  opacity: 1;
}

.em-compose-tag-input {
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 2px;
  flex: 1 1;
  min-width: 60px;
  background: transparent;
}

.em-compose-cc-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 4px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-compose-toggle-cc {
  font-size: 11px;
  color: var(--em-accent);
  cursor: pointer;
  padding: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.em-compose-toggle-cc:hover {
  text-decoration: underline;
}

.em-compose-subject-field input {
  border: none;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  padding: 6px 8px;
  width: 100%;
  color: var(--em-text);
  background: transparent;
}

.em-compose-subject-field input::placeholder {
  color: var(--em-text-muted);
}

.em-compose-editor {
  padding: 8px;
  min-height: 180px;
  flex: 1 1;
}

.em-compose-editor textarea {
  width: 100%;
  height: 100%;
  min-height: 180px;
  border: none;
  outline: none;
  resize: vertical;
  font-family: "Segoe UI", sans-serif;
  font-size: 13px;
  line-height: 1.5;
  color: var(--em-text);
}

.em-compose-editor textarea::placeholder {
  color: var(--em-text-muted);
}

/* Read-only "Original Message" / "Forwarded Message" block — kept visually
   and structurally separate from the editable reply textarea above it. */
.em-compose-quote {
  margin: 0 8px 8px;
  border-top: 1px solid var(--em-border-light);
  padding-top: 10px;
}

.em-compose-quote-sep {
  font-size: 11px;
  font-weight: 600;
  color: var(--em-text-muted);
  letter-spacing: 0.02em;
  margin-bottom: 8px;
}

.em-compose-quote-meta {
  font-size: 12px;
  color: var(--em-text-secondary);
  line-height: 1.6;
  margin-bottom: 8px;
}

.em-compose-quote-body {
  border: 1px solid var(--em-border-light);
  border-radius: 6px;
  overflow: hidden;
  max-height: 360px;
  overflow-y: auto;
}

.em-compose-quote-body .em-viewer-frame {
  width: 100%;
  border: none;
  display: block;
}

.em-compose-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-top: 1px solid var(--em-border-light);
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-compose-tool-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-tool-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-tool-btn-active {
  background: #cce4ff;
  border-color: #a8cff5;
}

.em-compose-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid var(--em-border-light);
}

.em-compose-footer-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.em-compose-send-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 20px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
}

.em-compose-send-btn:hover {
  background: #004578;
}

.em-compose-send-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.em-compose-attach-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-attach-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-trash-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-compose-trash-btn:hover {
  background: #e5e5e5;
  border-color: #d0d0d0;
}

.em-compose-footer-right {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--em-text-muted);
}

/* ===================== SEARCH OVERLAY ===================== */
.em-search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.08); /* light scrim — keep the page bright, don't darken it */
  z-index: 999;
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.em-search-panel {
  width: 600px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow: hidden;
}

.em-search-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-search-header input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  color: var(--em-text);
}

.em-search-header input::placeholder {
  color: var(--em-text-muted);
}

.em-search-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-search-close:hover {
  background: #e5e5e5;
}

.em-search-results {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 0;
}

.em-search-result-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
}

.em-search-result-item:hover {
  background: var(--em-bg-tertiary);
}

.em-search-result-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--em-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
}

.em-search-result-content {
  flex: 1 1;
  min-width: 0;
}

.em-search-result-sender {
  font-size: 12px;
  font-weight: 500;
}

.em-search-result-subject {
  font-size: 12px;
  color: var(--em-text-secondary);
}

.em-search-result-preview {
  font-size: 11px;
  color: var(--em-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.em-search-result-date {
  font-size: 11px;
  color: var(--em-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.em-search-empty {
  padding: 24px;
  text-align: center;
  color: var(--em-text-muted);
  font-size: 13px;
}

/* ===================== CONTEXT MENU ===================== */
.em-context-menu {
  position: fixed;
  z-index: 2000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  padding: 4px 0;
  min-width: 160px;
}

.em-context-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 12px;
  color: var(--em-text);
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-family: inherit;
}

.em-context-menu-item:hover {
  background: var(--em-active);
}

.em-context-menu-divider {
  height: 1px;
  background: var(--em-border);
  margin: 4px 0;
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 768px) {
  .em-module-body {
    flex-direction: column;
  }

  .em-sidebar {
    width: 100%;
    min-width: unset;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid var(--em-border);
  }

  .em-list {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid var(--em-border);
  }

  .em-compose-overlay {
    right: 0;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }

  .em-ribbon-content {
    flex-wrap: wrap;
    min-height: 40px;
  }

  .em-ribbon-search {
    min-width: 120px;
  }
}

/* ===================== SCROLLBARS ===================== */
.em-list-body::-webkit-scrollbar,
.em-sidebar::-webkit-scrollbar,
.em-viewer-body::-webkit-scrollbar,
.em-compose-body::-webkit-scrollbar {
  width: 8px;
}

.em-list-body::-webkit-scrollbar-track,
.em-sidebar::-webkit-scrollbar-track,
.em-viewer-body::-webkit-scrollbar-track,
.em-compose-body::-webkit-scrollbar-track {
  background: transparent;
}

.em-list-body::-webkit-scrollbar-thumb,
.em-sidebar::-webkit-scrollbar-thumb,
.em-viewer-body::-webkit-scrollbar-thumb,
.em-compose-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.em-list-body::-webkit-scrollbar-thumb:hover,
.em-sidebar::-webkit-scrollbar-thumb:hover,
.em-viewer-body::-webkit-scrollbar-thumb:hover,
.em-compose-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Firefox */
.em-list-body,
.em-sidebar,
.em-viewer-body,
.em-compose-body {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

/* ===================== TOAST ===================== */
.em-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 13px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  animation: em-toast-in 0.25s ease-out;
  background: #323130;
  color: #fff;
}

.em-toast-success {
  background: #005a9e;
  color: #fff;
}

.em-toast-error {
  background: #d32f2f;
  color: #fff;
}

.em-toast-warning {
  background: #b26a00;
  color: #fff;
}

.em-toast-info {
  background: #323130;
  color: #fff;
}

@keyframes em-toast-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ===================== SEARCH FILTERS ===================== */
.em-search-filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
}

.em-search-filter-btn:hover {
  background: #e5e5e5;
}

.em-search-filters {
  padding: 12px 16px;
  border-top: 1px solid var(--em-border-light);
}

.em-search-filters-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

.em-search-filter-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.em-search-filter-field label {
  font-size: 11px;
  color: var(--em-text-secondary);
}

.em-search-filter-field input {
  padding: 4px 8px;
  border: 1px solid var(--em-border);
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  outline: none;
  color: var(--em-text);
  background: var(--em-bg);
}

.em-search-filter-field input:focus {
  border-color: var(--em-accent);
}

.em-search-filter-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.em-search-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--em-text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.em-search-toggle input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.em-search-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.em-search-apply-btn {
  padding: 4px 16px;
  background: var(--em-accent);
  color: #fff;
  border: 1px solid var(--em-accent-hover);
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
}

.em-search-apply-btn:hover {
  background: var(--em-accent-hover);
}

.em-search-clear-btn {
  padding: 4px 16px;
  background: transparent;
  color: var(--em-text-secondary);
  border: 1px solid var(--em-border);
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
}

.em-search-clear-btn:hover {
  background: var(--em-bg-tertiary);
}

/* =====================================================================
   RIBBON POLISH (alignment)
   ===================================================================== */
.em-ribbon-content {
  min-height: 60px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

.em-ribbon-content::-webkit-scrollbar {
  height: 6px;
}

.em-ribbon-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.em-ribbon-quickbar-btn {
  border: none;
  background: transparent;
  font-size: 11px;
  padding: 0 4px;
  color: var(--em-text-secondary);
  cursor: pointer;
  font-family: inherit;
  border-radius: 3px;
}

.em-ribbon-quickbar-btn:hover {
  background: #e5e5e5;
  color: var(--em-text);
}

.em-ribbon-search {
  cursor: pointer;
}

.em-ribbon-search input {
  cursor: pointer;
}

.em-ribbon-view-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--em-accent);
  padding: 0 4px;
}

/* =====================================================================
   OUTLOOK TOP BAR (Row 1: quick-access / title bar)
   ===================================================================== */
.em-topbar {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 8px;
  background: #f3f3f3;
  border-bottom: 1px solid var(--em-ribbon-border);
}

.em-topbar-left {
  display: flex;
  align-items: center;
  gap: 2px;
}

.em-topbar-logo {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(135deg, #0364b8, #0a2767);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  flex-shrink: 0;
}

.em-topbar-icon {
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444;
}

.em-topbar-icon:hover {
  background: #e5e5e5;
}

.em-topbar-people {
  display: flex;
  align-items: center;
  gap: 2px;
  border: 1px solid var(--em-border);
  background: #fff;
  border-radius: 3px;
  padding: 0 4px;
  height: 24px;
  margin-left: 6px;
  color: var(--em-text-muted);
}

.em-topbar-people input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: inherit;
  width: 96px;
  color: var(--em-text);
  cursor: pointer;
}

.em-topbar-search {
  flex: 1 1;
  max-width: 620px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 26px;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 0 10px;
  color: var(--em-text-muted);
  cursor: pointer;
}

.em-topbar-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  font-family: inherit;
  flex: 1 1;
  color: var(--em-text);
  cursor: pointer;
}

.em-topbar-right {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
}

.em-topbar-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #0a8577;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-right: 8px;
}

.em-topbar-win {
  width: 32px;
  height: 30px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #444;
}

.em-topbar-win:hover {
  background: #e5e5e5;
}

.em-topbar-win-close:hover {
  background: #d13438;
  color: #fff;
}

/* Ribbon: quick steps + small buttons + people search */
.em-ribbon-new-btn .em-ribbon-btn-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.em-ribbon-btn-label {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  justify-content: center;
}

.em-ribbon-btn-sm {
  min-width: 0;
  flex-direction: row;
  gap: 1px;
  padding: 3px 5px;
}

.em-ribbon-group-quicksteps {
  gap: 0;
}

.em-ribbon-step {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid var(--em-border);
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  color: var(--em-text);
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
}

.em-ribbon-step + .em-ribbon-step {
  border-left: none;
}

.em-ribbon-step:hover {
  background: #eaf2fb;
  border-color: #a8cff5;
}

.em-ribbon-step span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-ribbon-search-people {
  min-width: 130px;
  height: 22px;
}

.em-ribbon-search-people input {
  cursor: pointer;
}

.em-ribbon-group-last {
  border-right: none;
}

@media (max-width: 1100px) {
  .em-ribbon-group-quicksteps,
  .em-ribbon-search-people {
    display: none;
  }
}

@media (max-width: 768px) {
  .em-topbar-people {
    display: none;
  }
  .em-topbar-search {
    max-width: none;
  }
}

/* =====================================================================
   MODULE NAV RAIL (Outlook module switcher)
   ===================================================================== */
.em-nav-rail {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  background: transparent;
  border: none;
  flex-shrink: 0;
}

/* The visible bar wraps only the icons, so it can never stretch full-width. */
.em-nav-rail-top,
.em-nav-rail-bottom {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: auto;
  background: #f0f2f5;
  border-top: 1px solid var(--em-border);
  border-right: 1px solid var(--em-border);
  border-top-right-radius: 8px;
  padding: 5px 14px;
}

.em-nav-rail-btn {
  width: auto;
  height: auto;
  padding: 6px 9px;
  border: none;
  background: transparent;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--em-text-secondary);
  font-family: inherit;
  position: relative;
}

.em-nav-rail-btn:hover {
  background: #e2e6ea;
  color: var(--em-text);
}

.em-nav-rail-btn-active {
  background: #dbe7ff;
  color: var(--em-accent);
}

.em-nav-rail-btn-active::before {
  content: "";
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: -5px;
  height: 2px;
  border-radius: 2px;
  background: var(--em-accent);
}

.em-nav-rail-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.em-nav-rail-label {
  display: none;
}

.em-nav-rail-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: #dc2626;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  border-radius: 9px;
  padding: 1px 4px;
  min-width: 16px;
  text-align: center;
  line-height: 1.3;
}

/* =====================================================================
   CALENDAR
   ===================================================================== */
.em-cal {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-cal-sidebar {
  width: 240px;
  min-width: 240px;
  border-right: 1px solid var(--em-border);
  background: var(--em-sidebar-bg);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 12px;
}

.em-cal-new-btn {
  justify-content: center;
}

.em-cal-mini {
  padding: 8px 12px;
}

.em-cal-mini-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: var(--em-text);
  margin-bottom: 6px;
}

.em-cal-mini-nav {
  display: flex;
  gap: 2px;
}

.em-cal-mini-nav button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  border-radius: 3px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-cal-mini-nav button:hover {
  background: var(--em-hover);
}

.em-cal-mini-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}

.em-cal-mini-dow {
  text-align: center;
  font-size: 10px;
  color: var(--em-text-muted);
  padding: 2px 0;
  font-weight: 600;
}

.em-cal-mini-day {
  position: relative;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  color: var(--em-text);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

.em-cal-mini-day:hover {
  background: var(--em-hover);
}

.em-cal-mini-day-muted {
  color: var(--em-text-muted);
}

.em-cal-mini-day-today {
  background: var(--em-accent);
  color: #fff;
  font-weight: 600;
}

.em-cal-mini-day-today:hover {
  background: var(--em-accent-hover);
}

.em-cal-mini-day-sel {
  outline: 1px solid var(--em-accent);
}

.em-cal-mini-dot {
  position: absolute;
  bottom: 2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

.em-cal-upcoming {
  padding: 4px 4px 0;
}

.em-cal-upcoming-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 4px;
}

.em-cal-upcoming-item:hover {
  background: var(--em-hover);
}

.em-cal-upcoming-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 4px;
  flex-shrink: 0;
}

.em-cal-upcoming-info {
  min-width: 0;
}

.em-cal-upcoming-title {
  font-size: 12px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-cal-upcoming-time {
  font-size: 11px;
  color: var(--em-text-muted);
}

.em-cal-upcoming-empty {
  padding: 8px 16px;
  font-size: 12px;
  color: var(--em-text-muted);
}

/* Calendar main */
.em-cal-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.em-cal-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--em-border-light);
  background: var(--em-bg);
}

.em-cal-today-btn {
  padding: 5px 14px;
  border: 1px solid var(--em-border);
  background: var(--em-bg);
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text);
  font-weight: 500;
}

.em-cal-today-btn:hover {
  background: var(--em-hover);
}

.em-cal-nav {
  display: flex;
  gap: 2px;
}

.em-cal-nav button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-secondary);
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.em-cal-nav button:hover {
  background: var(--em-hover);
}

.em-cal-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--em-text);
  flex: 1 1;
}

.em-cal-view-switch {
  display: flex;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  overflow: hidden;
}

.em-cal-view-switch button {
  border: none;
  background: var(--em-bg);
  padding: 5px 14px;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text-secondary);
  border-right: 1px solid var(--em-border);
}

.em-cal-view-switch button:last-child {
  border-right: none;
}

.em-cal-view-switch button:hover {
  background: var(--em-hover);
}

.em-cal-view-active {
  background: var(--em-accent) !important;
  color: #fff !important;
}

/* Month grid */
.em-cal-month {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.em-cal-month-dow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid var(--em-border-light);
}

.em-cal-month-dow-cell {
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--em-text-secondary);
  text-align: right;
  text-transform: uppercase;
}

.em-cal-month-grid {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 1fr;
  overflow-y: auto;
}

.em-cal-cell {
  border-right: 1px solid var(--em-border-light);
  border-bottom: 1px solid var(--em-border-light);
  padding: 4px;
  min-height: 92px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.em-cal-cell:hover {
  background: var(--em-bg-secondary);
}

.em-cal-cell-muted {
  background: #fafafa;
}

.em-cal-cell-muted .em-cal-cell-date {
  color: var(--em-text-muted);
}

.em-cal-cell-date {
  font-size: 12px;
  color: var(--em-text);
  text-align: right;
  padding: 2px 4px;
}

.em-cal-cell-month {
  font-weight: 600;
  color: var(--em-accent);
}

.em-cal-cell-today-num {
  background: var(--em-accent);
  color: #fff;
  border-radius: 50%;
  padding: 1px 6px;
  font-weight: 600;
}

.em-cal-cell-events {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.em-cal-event-chip {
  color: #fff;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.em-cal-event-time {
  font-weight: 700;
  opacity: 0.9;
}

.em-cal-event-more {
  font-size: 10px;
  color: var(--em-text-secondary);
  padding-left: 4px;
}

/* Week view */
.em-cal-week {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  overflow-y: auto;
}

.em-cal-week-col {
  border-right: 1px solid var(--em-border-light);
  display: flex;
  flex-direction: column;
}

.em-cal-week-col-today {
  background: #f5f9ff;
}

.em-cal-week-head {
  text-align: center;
  padding: 8px 4px;
  border-bottom: 1px solid var(--em-border-light);
  cursor: pointer;
}

.em-cal-week-head:hover {
  background: var(--em-hover);
}

.em-cal-week-dow {
  display: block;
  font-size: 11px;
  color: var(--em-text-secondary);
  text-transform: uppercase;
}

.em-cal-week-num {
  font-size: 18px;
  font-weight: 600;
}

.em-cal-week-body {
  flex: 1 1;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 200px;
  cursor: pointer;
}

.em-cal-week-event {
  background: var(--em-bg-secondary);
  border-left: 3px solid var(--em-accent);
  border-radius: 3px;
  padding: 4px 6px;
  cursor: pointer;
}

.em-cal-week-event:hover {
  background: var(--em-hover);
}

.em-cal-week-event-time {
  font-size: 10px;
  color: var(--em-text-secondary);
}

.em-cal-week-event-title {
  font-size: 12px;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-cal-week-empty {
  color: var(--em-text-muted);
  font-size: 11px;
  opacity: 0;
}

.em-cal-week-body:hover .em-cal-week-empty {
  opacity: 1;
}

/* Day view */
.em-cal-day {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 24px;
}

.em-cal-day-add {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--em-accent);
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
  border: 1px dashed var(--em-border);
  border-radius: 6px;
  margin-bottom: 12px;
}

.em-cal-day-add:hover {
  background: var(--em-bg-secondary);
}

.em-cal-day-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--em-text-muted);
  padding: 48px;
  gap: 8px;
}

.em-cal-day-event {
  display: flex;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  align-items: stretch;
}

.em-cal-day-event:hover {
  background: var(--em-bg-secondary);
}

.em-cal-day-event-time {
  width: 60px;
  flex-shrink: 0;
  font-size: 13px;
  display: flex;
  flex-direction: column;
}

.em-cal-day-event-end {
  color: var(--em-text-muted);
  font-size: 11px;
}

.em-cal-day-event-bar {
  width: 4px;
  border-radius: 2px;
  flex-shrink: 0;
}

.em-cal-day-event-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--em-text);
}

.em-cal-day-event-loc,
.em-cal-day-event-desc {
  font-size: 12px;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

/* Event / contact modal */
.em-cal-modal {
  width: 460px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-self: flex-start;
}

.em-cal-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #005a9e;
  color: #fff;
}

.em-cal-modal-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.em-cal-modal-header .em-search-close {
  color: rgba(255,255,255,0.85);
}

.em-cal-modal-header .em-search-close:hover {
  background: rgba(255,255,255,0.15);
}

.em-cal-modal-body {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.em-cal-modal-field {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--em-text-secondary);
  border-bottom: 1px solid var(--em-border-light);
  padding-bottom: 8px;
}

.em-cal-modal-field-top {
  align-items: flex-start;
}

.em-cal-modal-field input,
.em-cal-modal-field textarea {
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  color: var(--em-text);
  background: transparent;
  flex: 1 1;
  min-width: 0;
}

.em-cal-modal-field input[type="date"],
.em-cal-modal-field input[type="time"] {
  flex: 0 0 auto;
}

.em-cal-modal-field textarea {
  resize: vertical;
}

.em-cal-modal-dash {
  color: var(--em-text-muted);
}

.em-cal-modal-allday {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--em-text-secondary);
  cursor: pointer;
  padding-left: 26px;
}

.em-cal-modal-colors {
  display: flex;
  gap: 6px;
}

.em-cal-color-swatch {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
}

.em-cal-color-swatch-active {
  border-color: #1a1a1a;
  outline: 1px solid #fff;
  outline-offset: -3px;
}

.em-cal-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--em-border-light);
  background: var(--em-bg-secondary);
}

.em-cal-modal-footer-right {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.em-cal-modal-delete {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid transparent;
  background: transparent;
  color: #dc2626;
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  border-radius: 3px;
  padding: 4px 10px;
}

.em-cal-modal-delete:hover {
  background: #fdecec;
}

/* =====================================================================
   PEOPLE / CONTACTS
   ===================================================================== */
.em-people {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-people-list {
  width: 320px;
  min-width: 280px;
  border-right: 1px solid var(--em-border);
  display: flex;
  flex-direction: column;
  background: var(--em-bg);
}

.em-people-toolbar {
  padding: 8px;
  border-bottom: 1px solid var(--em-border-light);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.em-people-new {
  margin: 0;
  justify-content: center;
}

.em-people-search {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 5px 8px;
  color: var(--em-text-muted);
}

.em-people-search input {
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  flex: 1 1;
  background: transparent;
  color: var(--em-text);
}

.em-people-scroll {
  flex: 1 1;
  overflow-y: auto;
}

.em-people-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--em-border-light);
}

.em-people-item:hover {
  background: var(--em-bg-tertiary);
}

.em-people-item-active {
  background: var(--em-active) !important;
}

.em-people-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-people-item-info {
  min-width: 0;
}

.em-people-item-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--em-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-people-item-email {
  font-size: 12px;
  color: var(--em-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.em-people-empty,
.em-tasks-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 48px 24px;
  color: var(--em-text-muted);
  text-align: center;
}

.em-people-empty p,
.em-tasks-empty p {
  margin: 8px 0 0;
  font-size: 15px;
  color: var(--em-text-secondary);
}

.em-people-empty span,
.em-tasks-empty span {
  font-size: 12px;
}

.em-people-detail {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  background: var(--em-bg-secondary);
}

.em-people-detail-empty {
  color: var(--em-text-muted);
}

.em-people-card {
  align-self: flex-start;
  width: 100%;
  max-width: 560px;
  margin: 32px auto;
  background: #fff;
  border: 1px solid var(--em-border-light);
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  overflow: hidden;
}

.em-people-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(180deg, #eaf1fb, #fff);
  border-bottom: 1px solid var(--em-border-light);
}

.em-people-card-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  flex-shrink: 0;
}

.em-people-card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.em-people-card-title {
  font-size: 13px;
  color: var(--em-text-secondary);
}

.em-people-card-actions {
  margin-left: auto;
  display: flex;
  gap: 4px;
}

.em-people-card-actions button,
.em-people-card-actions a {
  width: 32px;
  height: 32px;
  border: 1px solid var(--em-border);
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.em-people-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  padding: 48px 24px;
  color: var(--em-text-muted);
  text-align: center;
}
.em-people-empty-state p { margin: 8px 0 0; font-size: 15px; color: var(--em-text-secondary); }
.em-people-empty-state span { font-size: 12px; max-width: 320px; }

.em-muted { color: var(--em-text-muted); font-size: 12px; }

.em-people-card-actions button:hover,
.em-people-card-actions a:hover {
  background: var(--em-hover);
}

.em-people-card-body {
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.em-people-card-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--em-text);
}

.em-people-card-row svg {
  color: var(--em-text-secondary);
  flex-shrink: 0;
}

.em-people-card-row a,
.em-people-link-btn {
  color: var(--em-accent);
  text-decoration: none;
}

.em-people-card-row a:hover,
.em-people-link-btn:hover {
  text-decoration: underline;
}

.em-people-link-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-align: left;
}

/* =====================================================================
   TASKS / TO DO
   ===================================================================== */
.em-tasks {
  flex: 1 1;
  display: flex;
  min-width: 0;
  background: var(--em-bg);
  overflow: hidden;
}

.em-tasks-sidebar {
  width: 220px;
  min-width: 200px;
  border-right: 1px solid var(--em-border);
  background: var(--em-sidebar-bg);
  padding-bottom: 8px;
  overflow-y: auto;
}

.em-tasks-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: linear-gradient(180deg, #eef3fb, #fff 220px);
}

.em-tasks-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 24px 12px;
  color: var(--em-accent);
}

.em-tasks-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--em-text);
}

.em-tasks-add {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 24px 12px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--em-border);
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  color: var(--em-text-secondary);
}

.em-tasks-add > input:first-of-type {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  background: transparent;
  color: var(--em-text);
}

.em-tasks-add-due {
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  color: var(--em-text-secondary);
  outline: none;
}

.em-tasks-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 24px 24px;
}

.em-tasks-done-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--em-text-secondary);
  margin: 16px 0 8px;
}

.em-task-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid var(--em-border-light);
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 6px;
}

.em-task-row:hover {
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.em-task-check {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-accent);
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.em-task-row-done .em-task-check {
  color: #059669;
}

.em-task-info {
  flex: 1 1;
  min-width: 0;
}

.em-task-title {
  font-size: 14px;
  color: var(--em-text);
}

.em-task-row-done .em-task-title {
  text-decoration: line-through;
  color: var(--em-text-muted);
}

.em-task-due {
  font-size: 11px;
  color: var(--em-text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.em-task-star,
.em-task-delete {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--em-text-muted);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 3px;
  padding: 4px;
}

.em-task-star:hover,
.em-task-delete:hover {
  background: var(--em-hover);
}

.em-task-star-on {
  color: #f59e0b;
}

.em-task-delete:hover {
  color: #dc2626;
}

/* =====================================================================
   MAILBOX ACCOUNT SETTINGS MODAL
   ===================================================================== */
.em-acct-modal {
  width: 560px;
  max-width: calc(100vw - 40px);
  align-self: flex-start;
}

.em-acct-body {
  max-height: 70vh;
  overflow-y: auto;
}

.em-acct-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #eef4ff;
  border: 1px solid #d3e2ff;
  color: #274b8f;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.4;
}

.em-acct-hint svg {
  flex-shrink: 0;
  margin-top: 1px;
}

.em-acct-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--em-text-secondary);
  margin-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--em-border-light);
}

.em-acct-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.em-acct-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.em-acct-col2 {
  grid-column: 1 / -1;
}

.em-acct-field > span {
  font-size: 11px;
  color: var(--em-text-secondary);
  font-weight: 500;
}

.em-acct-field input:not([type="checkbox"]) {
  border: 1px solid var(--em-border);
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  font-family: inherit;
  color: var(--em-text);
  outline: none;
  background: var(--em-bg);
}

.em-acct-field input:not([type="checkbox"]):focus {
  border-color: var(--em-accent);
}

.em-acct-password-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.em-acct-password-wrap input {
  width: 100%;
  padding-right: 32px !important;
}

.em-acct-password-toggle {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--em-text-secondary);
  cursor: pointer;
  border-radius: 3px;
}

.em-acct-password-toggle:hover {
  color: var(--em-text);
  background: var(--em-hover);
}

.em-acct-check {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  grid-column: 1 / -1;
}

.em-acct-check span {
  font-size: 12px;
  color: var(--em-text-secondary);
}

/* Calendar/People/Tasks responsive */
@media (max-width: 900px) {
  .em-cal-sidebar,
  .em-tasks-sidebar {
    display: none;
  }
  .em-people-list {
    width: 100%;
  }
  .em-people-detail {
    display: none;
  }
}


/* ── Resume attachment actions (Add to Job / Database) ── */
.em-att-actions { position: relative; display: inline-flex; }
.em-att-action-btn {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 8px; font-size: 12px; font-weight: 600;
  color: #0e527d; background: #eaf3f9; border: 1px solid #cfe3ef;
  border-radius: 5px; cursor: pointer; white-space: nowrap;
}
.em-att-action-btn:hover:not(:disabled) { background: #dcecf6; }
.em-att-action-btn:disabled { opacity: 0.6; cursor: default; }
.em-att-menu {
  /* position/top/left are set inline (fixed) so the menu is never clipped by
     the reading-pane overflow. */
  z-index: 2000;
  min-width: 220px; background: #fff; border: 1px solid #e0e0e0;
  border-radius: 6px; box-shadow: 0 6px 20px rgba(0,0,0,0.18); padding: 4px;
}
.em-att-menu-item {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 8px 10px; font-size: 13px; color: #222; background: none;
  border: none; border-radius: 4px; cursor: pointer; text-align: left;
}
.em-att-menu-item:hover { background: #f2f6f9; color: #0e527d; }
.em-spin { animation: em-spin 0.8s linear infinite; }
@keyframes em-spin { to { transform: rotate(360deg); } }

.em-jobpick-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.35);
  display: flex; align-items: center; justify-content: center; z-index: 10000;
}
.em-jobpick {
  width: 460px; max-width: 92vw; max-height: 80vh; display: flex; flex-direction: column;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25); overflow: hidden;
}
.em-jobpick-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 16px; font-size: 14px; font-weight: 700; color: #fff; background: #0e527d;
}
.em-jobpick-x { background: none; border: none; color: #fff; cursor: pointer; display: flex; }
.em-jobpick-company { display: flex; align-items: center; gap: 10px; padding: 12px 16px 6px; }
.em-jobpick-company label { font-size: 12px; font-weight: 600; color: #555; min-width: 62px; }
.em-jobpick-company select { flex: 1 1; padding: 7px 10px; font-size: 13px; border: 1px solid #dcdcdc; border-radius: 6px; background: #fff; outline: none; }
.em-jobpick-dbnote { padding: 8px 16px 4px; font-size: 12.5px; color: #666; }
.em-jobpick-search { display: flex; align-items: center; gap: 8px; padding: 10px 16px; border-bottom: 1px solid #eee; color: #888; }
.em-jobpick-search input { flex: 1 1; border: 1px solid #dcdcdc; border-radius: 6px; padding: 7px 10px; font-size: 13px; outline: none; }
.em-jobpick-searchbtn { padding: 7px 12px; font-size: 12px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }
.em-jobpick-list { flex: 1 1; overflow-y: auto; padding: 6px 8px; min-height: 160px; }
.em-jobpick-empty { padding: 30px 12px; text-align: center; color: #999; font-size: 13px; }
.em-jobpick-item { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 6px; cursor: pointer; font-size: 13px; }
.em-jobpick-item:hover { background: #f2f6f9; }
.em-jobpick-item-sel { background: #eaf3f9; }
.em-jobpick-item-txt { flex: 1 1; }
.em-jobpick-pager { display: flex; align-items: center; justify-content: center; gap: 14px; padding: 8px 16px; border-top: 1px solid #eee; font-size: 12px; color: #666; }
.em-jobpick-pager button { display: inline-flex; align-items: center; gap: 3px; padding: 5px 10px; font-size: 12px; background: #fff; border: 1px solid #dcdcdc; border-radius: 5px; cursor: pointer; }
.em-jobpick-pager button:disabled { opacity: 0.45; cursor: not-allowed; }
.em-jobpick-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 16px; border-top: 1px solid #eee; }
.em-jobpick-cancel { padding: 8px 16px; font-size: 13px; background: #f2f2f2; border: 1px solid #ddd; border-radius: 6px; cursor: pointer; }
.em-jobpick-add { padding: 8px 18px; font-size: 13px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }
.em-jobpick-add:disabled { opacity: 0.55; cursor: not-allowed; }

/* Final modal overrides (the email module styles are declared in two bundles). */
.em-jobpick {
  width: min(560px, calc(100vw - 32px));
  max-height: min(80vh, 620px);
}

.em-jobpick-head {
  gap: 16px;
  padding: 16px 18px;
}

.em-jobpick-x {
  flex: 0 0 auto;
  padding: 6px;
  border-radius: 6px;
}

.em-jobpick-company {
  gap: 12px;
  padding: 18px 18px 8px;
}

.em-jobpick-company label {
  flex: 0 0 64px;
  min-width: 0;
  color: #334155;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.em-jobpick-company select {
  min-width: 0;
  min-height: 38px;
  border-color: #cbd5e1;
  color: #1e293b;
}

.em-jobpick-dbnote {
  margin: 8px 18px 14px;
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #f8fbff;
  color: #475569;
  font-size: 13px;
  line-height: 1.45;
}

.em-jobpick-foot {
  gap: 8px;
  padding: 14px 18px;
  background: #f8fafc;
}

.em-jobpick-cancel,
.em-jobpick-add {
  min-height: 38px;
  padding: 8px 16px;
}

@media (max-width: 520px) {
  .em-jobpick-company {
    align-items: flex-start;
    flex-direction: column;
  }

  .em-jobpick-company select {
    width: 100%;
  }
}

/* ── Calendar sync loader ── */
.em-cal-syncing {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: #0e527d;
  background: #eaf3f9;
  border: 1px solid #cfe3ef;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.em-cal { position: relative; }

.em-viewer-hdr-icon { padding: 6px 8px; }

/* ── Attachment click-to-preview ── */
.em-viewer-att-clickable {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}
.em-viewer-att-preview { cursor: pointer; }
.em-viewer-att-preview:hover .em-viewer-att-name { color: #0e527d; text-decoration: underline; }
.em-viewer-att-eye {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; padding: 0; margin-right: 4px;
  border: 1px solid var(--em-border, #e0e0e0); border-radius: 4px;
  background: #fff; color: #0e527d; cursor: pointer;
}
.em-viewer-att-eye:hover { background: #eaf3f9; }

.em-att-preview-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center; z-index: 2000;
}
.em-att-preview {
  width: 860px; max-width: 94vw; height: 88vh; max-height: 92vh;
  background: #fff; border-radius: 10px; overflow: hidden;
  display: flex; flex-direction: column; box-shadow: 0 16px 50px rgba(0,0,0,0.35);
}
.em-att-preview-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; background: #0e527d; color: #fff; flex-shrink: 0;
}
.em-att-preview-title {
  display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.em-att-preview-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.em-att-preview-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border: none; border-radius: 5px;
  background: rgba(255,255,255,0.15); color: #fff; cursor: pointer;
}
.em-att-preview-btn:hover { background: rgba(255,255,255,0.28); }
.em-att-preview-body { flex: 1 1; background: #f4f6f8; overflow: auto; display: flex; }
.em-att-preview-frame { width: 100%; height: 100%; border: none; }
.em-att-preview-img { max-width: 100%; max-height: 100%; margin: auto; object-fit: contain; }
.em-att-preview-none {
  margin: auto; text-align: center; color: #6b7280; display: flex;
  flex-direction: column; align-items: center; gap: 10px; padding: 30px;
}
.em-att-preview-dl {
  padding: 8px 16px; background: #0e527d; color: #fff; border-radius: 6px;
  text-decoration: none; font-size: 13px; font-weight: 600;
}

/* ── Sidebar module switcher (Mail / Calendar / People / To Do) ── */
.em-sidebar-modules {
  gap: 6px;
  padding: 8px 12px;
  cursor: default;
  justify-content: flex-start;
}
.em-sidebar-module-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--em-text-secondary, #555);
  cursor: pointer;
}
.em-sidebar-module-btn:hover { background: #e6ebf1; color: #0e527d; }
.em-sidebar-module-active { background: #dcecf6; color: #0e527d; }
.em-sidebar-module-icon { position: relative; display: inline-flex; }
.em-sidebar-module-badge {
  position: absolute;
  top: -7px;
  right: -9px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  font-size: 9px;
  font-weight: 700;
  line-height: 15px;
  text-align: center;
  color: #fff;
  background: #d13438;
  border-radius: 8px;
}

/* ── Mail view: folder bar on top, list + reading pane below ── */
.em-mailview {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}
.em-mailview-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.em-folderbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 7px 16px;
  background: #fafafa;
  border-bottom: 1px solid var(--em-border);
  flex-shrink: 0;
}
.em-folderbar-newmail {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  background: #005a9e;
  color: #fff;
  border: 1px solid #004578;
  border-radius: 5px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}
.em-folderbar-newmail:hover { background: #00437a; }

.em-folderbar-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}
.em-folderbar-tabs::-webkit-scrollbar { height: 4px; }
.em-folderbar-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  color: var(--em-text-secondary, #555);
  white-space: nowrap;
}
.em-folderbar-tab:hover { background: #ececec; color: var(--em-text, #222); }
.em-folderbar-tab-active {
  background: #dcecf6;
  color: #0e527d;
  font-weight: 600;
}
.em-folderbar-count {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  background: #e2e6ea;
  border-radius: 9px;
  padding: 0 6px;
  min-width: 16px;
  text-align: center;
}
.em-folderbar-count-primary { background: #005a9e; color: #fff; }

.em-folderbar-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.em-folderbar-account {
  max-width: 200px;
  padding: 5px 8px;
  font-size: 12px;
  border: 1px solid var(--em-border, #e0e0e0);
  border-radius: 5px;
  background: #fff;
  color: #333;
  margin-right: 4px;
}
.em-folderbar-ibtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--em-text-secondary, #555);
  cursor: pointer;
}
.em-folderbar-ibtn:hover { background: #ececec; color: #0e527d; }

/* ── Mailbox settings: centered footer + logout ── */
.em-cal-modal-footer-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.em-acct-logout-row {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--em-border-light, #ebebeb);
  display: flex;
  justify-content: center;
}
.em-acct-logout-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #b42318;
  background: #fff;
  border: 1px solid #f0c6c0;
  border-radius: 6px;
  cursor: pointer;
}
.em-acct-logout-btn:hover:not(:disabled) { background: #fdecea; }
.em-acct-logout-btn:disabled { opacity: 0.6; cursor: default; }

/* ── In-app confirm modal (logout) ── */
.em-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.em-confirm-modal {
  width: 360px;
  max-width: 90%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.28);
  overflow: hidden;
}
.em-confirm-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 700;
  color: #b42318;
  border-bottom: 1px solid #f0e0de;
}
.em-confirm-body {
  padding: 16px 18px;
  font-size: 13px;
  color: #444;
  line-height: 1.6;
}
.em-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 18px 16px;
}
.em-confirm-danger {
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #d13438;
  border: 1px solid #b42318;
  border-radius: 6px;
  cursor: pointer;
}
.em-confirm-danger:hover:not(:disabled) { background: #b42318; }
.em-confirm-danger:disabled { opacity: 0.6; cursor: default; }

/* ===================== OUTLOOK-STYLE MESSAGE LIST ===================== */
.em-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  border-bottom: 1px solid var(--em-border);
  flex-shrink: 0;
  background: #fff;
}
.em-list-filters { display: flex; gap: 16px; }
.em-list-filter {
  border: none;
  background: transparent;
  font-size: 14px;
  color: var(--em-text-secondary, #666);
  cursor: pointer;
  padding: 2px 0;
  position: relative;
  font-family: inherit;
}
.em-list-filter-active { color: #0f6cbd; font-weight: 600; }
.em-list-filter-active::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: -8px;
  height: 2px;
  background: #0f6cbd;
}
.em-list-sort {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  color: var(--em-text-secondary, #666);
  cursor: pointer;
}
.em-list-loading { font-size: 12px; color: #888; padding: 4px; }

.em-mail-group {
  padding: 6px 14px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #0f6cbd;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Message row — no avatar, three lines (sender/time, subject, preview). */
.em-mail-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 14px 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  background: #fff;
}
.em-mail-item:hover { background: #f5f8fb; }
.em-mail-active, .em-mail-active:hover { background: #eaf2fb; }
.em-mail-unread::before {
  content: "";
  position: absolute;
  left: 0; top: 6px; bottom: 6px;
  width: 3px;
  border-radius: 2px;
  background: #0f6cbd;
}
.em-mail-body { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.em-mail-row1 { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.em-mail-sender {
  font-size: 13.5px;
  color: #1a1a1a;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-unread .em-mail-sender { font-weight: 700; }
.em-mail-date { font-size: 12px; color: #888; white-space: nowrap; flex-shrink: 0; }
.em-mail-unread .em-mail-date { color: #0f6cbd; font-weight: 600; }
.em-mail-subject-line {
  font-size: 13px;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-unread .em-mail-subject-line { color: #0f6cbd; font-weight: 600; }
.em-mail-preview-line {
  font-size: 12.5px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.em-mail-side {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding-top: 2px;
}
.em-mail-star { display: inline-flex; cursor: pointer; opacity: 0.4; transition: opacity 0.1s; }
.em-mail-item:hover .em-mail-star { opacity: 1; }
.em-mail-attach-icon { color: #888; }

.em-list-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 6px 14px;
  border-top: 1px solid var(--em-border);
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
  background: #fff;
}
.em-list-nounread { padding: 24px; text-align: center; color: #999; font-size: 13px; }

/* ===================== BOTTOM STATUS BAR ===================== */
.em-statusbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--em-border);
  background: #f3f3f3;
  padding: 0 16px 0 0;
  flex-shrink: 0;
  min-height: 30px;
}
.em-statusbar .em-nav-rail { width: auto; }
.em-statusbar .em-nav-rail-top {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 3px 8px;
}
.em-statusbar-info {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
}
.em-statusbar-conn { color: #107c10; }

/* ===================== OUTLOOK-MATCH FOLDER PANE ===================== */
.em-sidebar { background: #faf9f8; }
.em-sidebar-section-title {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px 3px;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  text-transform: none;
  letter-spacing: 0;
}
.em-sidebar-section-chevron { color: #888; flex-shrink: 0; }
.em-sidebar-account-title { color: #201f1e; }
.em-sidebar-account-title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.em-sidebar-folder {
  padding: 4px 10px 4px 24px;
  margin: 0;
  border-radius: 0;
  min-height: 26px;
  font-size: 13px;
  color: #201f1e;
}
.em-sidebar-folder:hover { background: #f0eeed; }
.em-sidebar-folder-active { background: #dcecf6 !important; box-shadow: inset 3px 0 0 #0f6cbd; }
.em-sidebar-folder-label { flex: 1 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-sidebar-folder-count {
  margin-left: auto;
  font-size: 12px;
  color: #605e5c;
  background: transparent;
  padding: 0;
}
.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 600; }
.em-sidebar-more-btn { padding-left: 24px; }

/* Action buttons row — subtler, Outlook-ish */
.em-sidebar-search-btn { color: #444; }
.em-sidebar-search-btn:hover { background: #f0eeed; }

/* Message list selected-row: Outlook look */
.em-mail-active, .em-mail-active:hover { background: #eaf1fb; box-shadow: inset 2px 0 0 #0f6cbd; }

/* Date group header: subtle Outlook style */
.em-mail-group {
  background: #faf9f8;
  color: #444;
  border-bottom: 1px solid #f0f0f0;
}

/* ===================== OUTLOOK READING PANE ===================== */
.em-viewer { background: #fff; }
.em-viewer-header {
  background: #fff;
  padding: 14px 20px 10px;
  border-bottom: 1px solid #edebe9;
}
.em-viewer-subject {
  font-size: 18px;
  font-weight: 600;
  color: #242424;
  margin: 0 0 12px;
  line-height: 1.3;
}
.em-viewer-from-name { font-weight: 600; color: #242424; }
.em-viewer-from-addr { color: #605e5c; }

.em-viewer-webbanner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px;
  font-size: 12px;
  color: #605e5c;
  background: #fff;
  border-bottom: 1px solid #edebe9;
}
.em-viewer-webbanner svg { color: #0f6cbd; flex-shrink: 0; }
.em-viewer-weblink {
  background: none;
  border: none;
  color: #0f6cbd;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  font-family: inherit;
}
.em-viewer-weblink:hover { text-decoration: underline; }

.em-viewer-body {
  background: #fff;            /* no grey backdrop / white card */
  padding: 0;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  background: transparent;    /* no card — plain white reading area */
  max-width: 900px;
  margin: 0;                  /* left-aligned, not centered */
  padding: 0;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
}

/* Message content: left-aligned with comfortable padding (Gmail-style). */
.em-viewer-html-body {
  background: transparent;
  padding: 18px 26px;
  text-align: left;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;
  color: #242424;
  line-height: 1.5;
  overflow-x: auto;           /* never let a wide fixed-width template break the layout */
}
/* Normalize legacy / arbitrary templates so nothing overflows and images scale. */
.em-viewer-html-body img { max-width: 100%; height: auto; }
.em-viewer-html-body table { max-width: 100%; border-collapse: collapse; }
/* Left-align top-level content instead of centering it. */
.em-viewer-html-body > table,
.em-viewer-html-body > div,
.em-viewer-html-body > center > table { margin-left: 0 !important; margin-right: auto !important; }
.em-viewer-html-body a { color: #0f6cbd; }

/* Plain-text emails keep readable padding (no template to bleed). */
.em-viewer-text-body {
  background: transparent;
  margin: 0;
  padding: 24px 28px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 13.5px;
  color: #242424;
  line-height: 1.5;
}

/* ===================== RIBBON / SIDEBAR TWEAKS (tabbed ribbon) ===================== */
.em-ribbon-btn:disabled {
  opacity: 0.4;
  cursor: default;
  background: transparent;
  border-color: transparent;
}
.em-ribbon-btn:disabled:hover { background: transparent; border-color: transparent; }
.em-ribbon-content { flex-wrap: wrap; }

/* Clickable collapsible section headers in the folder pane */
.em-sidebar-section-title-toggle { cursor: pointer; border-radius: 3px; }
.em-sidebar-section-title-toggle:hover { background: #f0eeed; }
.em-sidebar-section-title-toggle .em-sidebar-section-chevron { transition: transform 0.15s; }

/* ===================== CLEAN & BEAUTIFUL SIDEBAR (polish) ===================== */
.em-sidebar {
  width: 214px;
  min-width: 214px;
  background: #fbfbfa;
  border-right: 1px solid #ececec;
  padding: 4px 4px 12px;
}

/* New mail button */
.em-sidebar-newmail {
  margin: 6px 6px 10px;
  padding: 9px 14px;
  background: #0f6cbd;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  gap: 9px;
  box-shadow: 0 1px 2px rgba(15, 108, 189, 0.25);
  transition: background 0.12s;
}
.em-sidebar-newmail:hover { background: #0c5aa0; }
.em-sidebar-newmail:active { background: #0a4e8c; }

/* Action rows: Sync / Settings / Add mailbox */
.em-sidebar-search-btn {
  margin: 1px 6px;
  padding: 7px 10px;
  min-height: 32px;
  gap: 11px;
  border-radius: 6px;
  font-size: 13px;
  color: #3b3a39;
}
.em-sidebar-search-btn svg { color: #605e5c; }
.em-sidebar-search-btn:hover { background: #f0efee; }

/* Sections */
.em-sidebar-section {
  padding: 2px 0 6px;
  margin-top: 6px;
  border-top: 1px solid #ededed;
}
.em-sidebar-section-title {
  padding: 9px 12px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #605e5c;
  text-transform: none;
  letter-spacing: 0;
}
.em-sidebar-section-title-toggle { margin: 0 6px; padding-left: 6px; border-radius: 6px; }
.em-sidebar-section-title-toggle:hover { background: #f0efee; }
.em-sidebar-account-title span { color: #201f1e; font-weight: 600; }

/* Folder rows — soft rounded pills */
.em-sidebar-folder {
  margin: 1px 6px;
  padding: 7px 10px;
  min-height: 32px;
  gap: 11px;
  border-radius: 6px;
  font-size: 13.5px;
  color: #201f1e;
  box-shadow: none;
  transition: background 0.1s, color 0.1s;
}
.em-sidebar-folder:hover { background: #f0efee; }
.em-sidebar-folder-active,
.em-sidebar-folder-active:hover {
  background: #eaf1fb !important;
  box-shadow: none;
  color: #0f6cbd;
  font-weight: 600;
}
.em-sidebar-folder-icon { color: #605e5c; display: inline-flex; align-items: center; }
.em-sidebar-folder-active .em-sidebar-folder-icon { color: #0f6cbd; }
.em-sidebar-folder-count { margin-left: auto; font-size: 12px; color: #797775; font-weight: 500; }
.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 700; }

/* More */
.em-sidebar-more-btn {
  margin: 2px 6px 0;
  padding: 6px 10px 6px 34px;
  border-radius: 6px;
  font-size: 12.5px;
  color: #605e5c;
  gap: 6px;
}
.em-sidebar-more-btn:hover { background: #f0efee; }

/* ===================== GROUPED OUTLOOK RIBBON ===================== */
.em-rb-content {
  display: flex;
  align-items: stretch;
  padding: 4px 4px 2px;
  background: #fff;
  overflow-x: auto;
  min-height: 90px;
  border-bottom: 1px solid var(--em-ribbon-border, #e1dfdd);
}
.em-rb-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #e8e6e4;
  padding: 2px 6px 0;
  flex-shrink: 0;
}
.em-rb-group:last-child { border-right: none; }
.em-rb-buttons { display: flex; align-items: stretch; gap: 1px; flex: 1 1; }
.em-rb-group-label {
  font-size: 10px;
  color: #8a8886;
  text-align: center;
  padding: 3px 0 3px;
  white-space: nowrap;
}
.em-rb-big {
  display: flex; flex-direction: column; align-items: center; justify-content: flex-start;
  gap: 3px;
  min-width: 44px; max-width: 68px;
  padding: 4px 5px;
  background: transparent; border: 1px solid transparent; border-radius: 3px;
  cursor: pointer; color: #201f1e; font-family: inherit;
}
.em-rb-big:hover { background: #eef4fb; border-color: #d6e4f5; }
.em-rb-big:disabled { opacity: 0.4; cursor: default; }
.em-rb-big:disabled:hover { background: transparent; border-color: transparent; }
.em-rb-big-label { font-size: 10.5px; line-height: 1.15; text-align: center; }
.em-rb-stack { display: flex; flex-direction: column; justify-content: center; gap: 1px; padding: 0 2px; }
.em-rb-small {
  display: flex; align-items: center; gap: 5px;
  padding: 2px 6px 2px 4px; border-radius: 3px;
  background: transparent; border: 1px solid transparent; cursor: pointer;
  color: #201f1e; font-family: inherit; font-size: 11px; white-space: nowrap;
}
.em-rb-small:hover { background: #eef4fb; border-color: #d6e4f5; }
.em-rb-small span { flex: 1 1; text-align: left; }
.em-rb-small:disabled { opacity: 0.4; cursor: default; }
.em-rb-people {
  display: flex; align-items: center; gap: 4px;
  border: 1px solid #d0d0d0; border-radius: 3px; padding: 1px 6px; background: #fff; margin-bottom: 2px;
}
.em-rb-people input { border: none; outline: none; font-size: 11px; width: 96px; background: transparent; }

/* ===================== NEW-MAIL DESKTOP TOAST ===================== */
.em-nmt {
  position: fixed; right: 18px; bottom: 44px; z-index: 4000;
  width: 344px; background: #fff; border: 1px solid #e1dfdd; border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0,0,0,0.22); overflow: hidden;
  font-family: 'Segoe UI', Arial, sans-serif;
  animation: em-nmt-in 0.25s ease;
}
@keyframes em-nmt-in { from { transform: translateY(14px); opacity: 0; } to { transform: none; opacity: 1; } }
.em-nmt-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; border-bottom: 1px solid #f0f0f0; }
.em-nmt-brand { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: #444; font-weight: 500; }
.em-nmt-logo { width: 18px; height: 18px; border-radius: 3px; background: #0f6cbd; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; }
.em-nmt-count { font-size: 11px; color: #0f6cbd; margin-left: 2px; }
.em-nmt-head-actions { display: flex; align-items: center; gap: 2px; }
.em-nmt-head-actions button { background: none; border: none; cursor: pointer; color: #666; padding: 3px; border-radius: 4px; display: inline-flex; }
.em-nmt-head-actions button:hover { background: #f0f0f0; }
.em-nmt-body { display: flex; gap: 12px; padding: 12px 14px; cursor: pointer; }
.em-nmt-body:hover { background: #f7fafd; }
.em-nmt-avatar { width: 44px; height: 44px; border-radius: 50%; background: #b3b0ad; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0; }
.em-nmt-text { min-width: 0; flex: 1 1; }
.em-nmt-sender { font-size: 14px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-nmt-subject { font-size: 12.5px; color: #605e5c; margin: 1px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-nmt-preview { font-size: 12px; color: #797775; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.em-nmt-foot { display: flex; border-top: 1px solid #f0f0f0; }
.em-nmt-foot button { flex: 1 1; padding: 9px 0; background: #f7f6f5; border: none; border-right: 1px solid #eaeaea; cursor: pointer; color: #444; display: inline-flex; align-items: center; justify-content: center; }
.em-nmt-foot button:last-child { border-right: none; }
.em-nmt-foot button:hover { background: #eaeaea; }

/* ===================== RULES MODAL ===================== */
.em-rules {
  width: 580px; max-width: calc(100vw - 40px); max-height: 84vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
}
.em-rules-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-rules-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-rules-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-rules-x:hover { background: #f0f0f0; }
.em-rules-body { padding: 16px 18px; overflow-y: auto; }
.em-rules-hint { font-size: 12.5px; color: #605e5c; margin: 0 0 14px; line-height: 1.5; }
.em-rules-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }
.em-rules-empty { font-size: 13px; color: #999; padding: 14px; text-align: center; border: 1px dashed #ddd; border-radius: 8px; }
.em-rules-item { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border: 1px solid #ececec; border-radius: 8px; background: #fbfbfa; }
.em-rules-item-off { opacity: 0.55; }
.em-rules-item-text { flex: 1 1; min-width: 0; }
.em-rules-item-name { font-size: 13.5px; font-weight: 600; color: #201f1e; }
.em-rules-item-desc { font-size: 12px; color: #605e5c; margin-top: 2px; }
.em-rules-del { background: none; border: none; cursor: pointer; color: #b0413e; padding: 5px; border-radius: 5px; }
.em-rules-del:hover { background: #fde7e6; }
.em-rules-toggle { position: relative; display: inline-flex; cursor: pointer; flex-shrink: 0; }
.em-rules-toggle input { position: absolute; opacity: 0; width: 34px; height: 18px; margin: 0; cursor: pointer; }
.em-rules-check { width: 34px; height: 18px; border-radius: 10px; background: #c8c6c4; position: relative; transition: background .15s; }
.em-rules-check::after { content: ''; position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: #fff; transition: left .15s; }
.em-rules-toggle input:checked + .em-rules-check { background: #0f6cbd; }
.em-rules-toggle input:checked + .em-rules-check::after { left: 18px; }
.em-rules-new { border: 1px solid #ececec; border-radius: 8px; padding: 14px; background: #fafafa; }
.em-rules-new-title { font-size: 13px; font-weight: 600; color: #201f1e; margin-bottom: 10px; }
.em-rules-row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.em-rules-lbl { font-size: 12.5px; color: #444; width: 56px; flex-shrink: 0; }
.em-rules-input, .em-rules-select { border: 1px solid #d0d0d0; border-radius: 6px; padding: 7px 9px; font-size: 13px; font-family: inherit; outline: none; }
.em-rules-input { width: 100%; }
.em-rules-input:focus, .em-rules-select:focus { border-color: #0f6cbd; }
.em-rules-input-value { flex: 1 1; width: auto; }
.em-rules-select { background: #fff; }
.em-rules-add { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 7px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-rules-add:disabled { opacity: 0.5; cursor: default; }
.em-rules-foot { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-top: 1px solid #ececec; }
.em-rules-run { display: inline-flex; align-items: center; gap: 6px; background: #107c10; color: #fff; border: none; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-rules-run:hover { background: #0e6b0e; }
.em-rules-close { background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 8px 16px; font-size: 13px; cursor: pointer; }
.em-rules-close:hover { background: #e8e6e4; }

/* Give bulleted/numbered lists in HTML email templates proper indentation. */
.em-viewer-html-body ul,
.em-viewer-html-body ol { padding-left: 2rem; }

/* Folder deep-sync progress strip (shown while a folder's messages download). */
.em-list-syncbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  font-size: 12px;
  color: #0f6cbd;
  background: #eef4fb;
  border-bottom: 1px solid #dbe7f5;
  flex-shrink: 0;
}
.em-list-syncbar .em-spinner {
  width: 13px; height: 13px;
  border: 2px solid #bcd4ef;
  border-top-color: #0f6cbd;
  border-radius: 50%;
  display: inline-block;
  animation: em-spin 0.7s linear infinite;
}
@keyframes em-spin { to { transform: rotate(360deg); } }

/* Sender initial-avatar in front of each message row (space in front of emails). */
.em-mail-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 1px;
  margin-right: 4px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;
}
/* Center the avatar against the 3-line message body. */
.em-mail-item { align-items: center; }

/* ===================== VIEW: density / preview / active toggles ===================== */
/* Compact ("Use Tighter Spacing") — tighter rows, smaller avatar, no preview line. */
.em-list-compact .em-mail-item { padding-top: 5px; padding-bottom: 5px; gap: 8px; }
.em-list-compact .em-mail-avatar { width: 26px; height: 26px; font-size: 11px; }
.em-list-compact .em-mail-preview-line { display: none; }
.em-list-compact .em-mail-subject-line { font-size: 12.5px; }

/* Message Preview off — hide the preview line. */
.em-list-nopreview .em-mail-preview-line { display: none; }

/* Active/toggled ribbon command (Reading Pane on, Work Offline on, current sort…). */
.em-rb-active { background: #dbeafe !important; border-color: #a9c9f0 !important; }
.em-rb-big.em-rb-active { color: #0f6cbd; }
.em-rb-small.em-rb-active { color: #0f6cbd; font-weight: 600; }

/* ===================== READ ALOUD CONTROL BAR ===================== */
.em-ra {
  position: fixed;
  top: 132px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5000;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-ra-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #e1dfdd;
  border-radius: 10px;
  box-shadow: 0 6px 22px rgba(0,0,0,0.18);
  padding: 6px 8px;
}
.em-ra-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  border-radius: 7px;
  color: #333;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.em-ra-btn:hover { background: #f0f0f0; }
.em-ra-btn-active { background: #eaf1fb; color: #0f6cbd; }
.em-ra-play { color: #0f6cbd; }
.em-ra-close:hover { background: #fde7e6; color: #d13438; }

.em-ra-panel {
  margin-top: 8px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  box-shadow: 0 6px 22px rgba(0,0,0,0.18);
  padding: 14px 16px;
  width: 240px;
}
.em-ra-field { margin-bottom: 12px; }
.em-ra-field:last-child { margin-bottom: 0; }
.em-ra-field label {
  display: block;
  font-size: 13px;
  color: #201f1e;
  margin-bottom: 6px;
}
.em-ra-field input[type="range"] { width: 78%; vertical-align: middle; accent-color: #0f6cbd; }
.em-ra-rate { font-size: 12px; color: #605e5c; margin-left: 8px; }
.em-ra-field select {
  width: 100%;
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  background: #fff;
  font-family: inherit;
  color: #201f1e;
}

/* ===================== SCHEDULE MEETING MODAL ===================== */
.em-meeting {
  width: 460px; max-width: calc(100vw - 40px); max-height: 86vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-meeting-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-meeting-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-meeting-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-meeting-x:hover { background: #f0f0f0; }
.em-meeting-body { padding: 16px 18px; overflow-y: auto; }
.em-meeting-body label { display: block; font-size: 12.5px; color: #444; margin: 10px 0 4px; }
.em-meeting-body input, .em-meeting-body select, .em-meeting-body textarea {
  width: 100%; padding: 8px 10px; font-size: 13.5px; border: 1px solid #d0d0d0; border-radius: 6px;
  font-family: inherit; outline: none; box-sizing: border-box;
}
.em-meeting-body input:focus, .em-meeting-body select:focus, .em-meeting-body textarea:focus { border-color: #0f6cbd; }
.em-meeting-row { display: flex; gap: 10px; }
.em-meeting-row > div { flex: 1 1; }
.em-meeting-foot { display: flex; align-items: center; gap: 8px; padding: 12px 18px; border-top: 1px solid #ececec; }
.em-meeting-google { display: inline-flex; align-items: center; gap: 7px; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 9px 14px; font-size: 13.5px; font-weight: 600; cursor: pointer; }
.em-meeting-google:hover { background: #0c5aa0; }
.em-meeting-ics { display: inline-flex; align-items: center; gap: 5px; background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 12px; font-size: 13px; cursor: pointer; }
.em-meeting-ics:hover { background: #e8e6e4; }
.em-meeting-cancel { margin-left: auto; background: none; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 16px; font-size: 13px; cursor: pointer; }
.em-meeting-cancel:hover { background: #f3f2f1; }

/* ===================== REMINDERS WINDOW ===================== */
.em-reminders {
  width: 420px; max-width: calc(100vw - 40px); max-height: 80vh;
  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-reminders-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }
.em-reminders-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }
.em-reminders-count { background: #d13438; color: #fff; border-radius: 10px; font-size: 11px; font-weight: 700; padding: 1px 7px; }
.em-reminders-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }
.em-reminders-x:hover { background: #f0f0f0; }
.em-reminders-body { padding: 8px 0; overflow-y: auto; }
.em-reminders-empty { text-align: center; color: #888; padding: 30px 20px; display: flex; flex-direction: column; align-items: center; gap: 6px; }
.em-reminders-empty p { margin: 4px 0 0; font-size: 15px; color: #555; }
.em-reminders-empty span { font-size: 12.5px; }
.em-reminder-item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 18px; border-bottom: 1px solid #f2f2f2; }
.em-reminder-item:hover { background: #faf9f8; }
.em-reminder-icon { margin-top: 2px; flex-shrink: 0; }
.em-reminder-text { flex: 1 1; min-width: 0; cursor: pointer; }
.em-reminder-title { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-reminder-sub { font-size: 12px; color: #605e5c; margin: 2px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-reminder-when { font-size: 12px; color: #0f6cbd; font-weight: 500; }
.em-reminder-dismiss { align-self: center; background: #f3f2f1; border: 1px solid #d8d8d8; border-radius: 5px; padding: 5px 10px; font-size: 12px; cursor: pointer; flex-shrink: 0; }
.em-reminder-dismiss:hover { background: #e8e6e4; }
.em-reminders-foot { padding: 10px 18px; border-top: 1px solid #ececec; text-align: right; }
.em-reminders-dismissall { background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; }
.em-reminders-dismissall:hover { background: #0c5aa0; }

/* ===================== RIBBON: COLOURED, SPACED, CLEANER ===================== */
/* Left space so the toolbar isn't cluttered against the edge. */
.em-ribbon-tabs { padding: 0 8px 0 22px; }
.em-rb-content { padding: 7px 14px 3px 22px; gap: 2px; }

/* More horizontal breathing room + softer separators between groups. */
.em-rb-group { padding: 2px 15px 0; border-right: 1px solid #eef0f2; }
.em-rb-group:last-child { border-right: none; }
.em-rb-buttons { gap: 4px; }
.em-rb-big { min-width: 48px; max-width: 74px; padding: 5px 7px; gap: 4px; }
.em-rb-small { padding: 3px 7px 3px 5px; }
.em-rb-stack { gap: 2px; padding: 0 3px; }
.em-rb-group-label { color: #9aa0a6; padding-top: 5px; font-size: 10px; }

/* Softer hover (keep the coloured icons visible). */
.em-rb-big:hover, .em-rb-small:hover { background: #f2f5f9; border-color: #e2e8f0; }

/* Active/toggled command — light rounded blue chip. */
.em-rb-active { background: #eaf1fb !important; border-color: #cfe0f5 !important; border-radius: 6px; }
.em-rb-big.em-rb-active .em-rb-big-label,
.em-rb-small.em-rb-active span { color: #1a5fbf; font-weight: 600; }

/* Search-people pill spacing. */
.em-rb-people { margin-bottom: 3px; }

/* ===================== NO SCROLLBARS — SHOW EVERYTHING ===================== */
/* Ribbon: never scroll horizontally — wrap groups onto a second row instead. */
.em-rb-content {
  overflow-x: hidden;
  flex-wrap: wrap;
  align-content: flex-start;
  row-gap: 2px;
}

/* Folder pane: compact rows so all folders fit without a scrollbar. */
.em-sidebar { overflow-y: auto; }
.em-sidebar-newmail { margin: 5px 6px 6px; padding: 7px 12px; }
.em-sidebar-search-btn { min-height: 26px; padding: 4px 10px; margin: 0 6px; }
.em-sidebar-section { margin-top: 3px; padding: 1px 0 3px; border-top-color: #f0f0f0; }
.em-sidebar-section-title { padding: 5px 12px 2px; }
.em-sidebar-folder { min-height: 26px; padding: 4px 10px 4px 24px; margin: 0 6px; }
.em-sidebar-more-btn { padding-top: 3px; padding-bottom: 3px; }

/* Slim, unobtrusive scrollbar if content still just barely overflows. */
.em-sidebar::-webkit-scrollbar { width: 6px; }
.em-sidebar::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }
.em-sidebar::-webkit-scrollbar-track { background: transparent; }

/* ===================== COMPACT SINGLE-ROW OUTLOOK RIBBON (match reference) ===================== */
.em-rb-content {
  flex-wrap: nowrap;          /* single row like classic Outlook */
  overflow-x: auto;
  overflow-y: hidden;
  align-content: stretch;
  padding: 5px 8px 2px 12px;
  gap: 0;
  min-height: 82px;
  row-gap: 0;
}
.em-rb-group { padding: 2px 8px 0; }
.em-rb-buttons { gap: 1px; }
.em-rb-stack { gap: 0; padding: 0 2px; }
.em-rb-big { min-width: 40px; max-width: 64px; padding: 3px 5px; gap: 2px; }
.em-rb-big svg { width: 17px; height: 17px; }
.em-rb-big-label { font-size: 10px; line-height: 1.1; }
.em-rb-small { padding: 2px 5px 2px 4px; font-size: 10.5px; gap: 4px; }
.em-rb-small svg { width: 13px; height: 13px; }
.em-rb-group-label { font-size: 9px; padding-top: 3px; }
.em-rb-people { padding: 1px 6px; margin-bottom: 2px; }
.em-rb-people input { width: 84px; font-size: 10.5px; }

/* If it can't fit (very narrow window) the scrollbar is slim, not a big grey bar. */
.em-rb-content::-webkit-scrollbar { height: 6px; }
.em-rb-content::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }
.em-rb-content::-webkit-scrollbar-track { background: transparent; }

/* ===================== CLEAN STRUCTURED EMAIL / TEMPLATE RENDERING ===================== */
/* Reading pane = soft canvas; the email sits on a centered white "sheet". */
.em-viewer-body {
  background: #f3f4f6;
  padding: 22px 18px;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  max-width: 840px;
  margin: 0 auto;                 /* centered, not floating left */
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;               /* clip full-width headers to the rounded card */
  padding: 0;
}
.em-viewer-html-body {
  padding: 30px 36px;
  text-align: left;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;
  color: #242424;
  line-height: 1.6;
  overflow-x: auto;
}
.em-viewer-html-body img { max-width: 100%; height: auto; }
.em-viewer-html-body table { max-width: 100%; }
/* Centre the template's top-level blocks so headers/logos sit balanced. */
.em-viewer-html-body > table,
.em-viewer-html-body > div,
.em-viewer-html-body > center,
.em-viewer-html-body > center > table {
  margin-left: auto !important;
  margin-right: auto !important;
}
.em-viewer-html-body p { margin: 0 0 12px; }
.em-viewer-html-body ul,
.em-viewer-html-body ol { padding-left: 1.5rem; margin: 10px 0; }
.em-viewer-html-body a { color: #0f6cbd; }
.em-viewer-text-body {
  padding: 30px 36px;
  max-width: none;
  font-size: 14px;
  line-height: 1.6;
}

/* ===================== IFRAME EMAIL RENDERING (clean, isolated) ===================== */
.em-viewer-body {
  background: #f3f4f6;
  padding: 22px 18px;
  overflow: auto;
  flex: 1 1;
}
.em-viewer-paper {
  max-width: 880px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;
  padding: 0;
}
.em-viewer-frame {
  width: 100%;
  border: none;
  display: block;
  background: #ffffff;
  min-height: 180px;
}
.em-viewer-text-body {
  padding: 26px 30px;
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

/* ===================== ACCOUNT AVATAR + POPOVER (ribbon top-right) ===================== */
.em-ribbon-tabs { position: relative; }
.em-ribbon-account { margin-left: auto; position: relative; display: flex; align-items: center; padding-right: 12px; }
.em-ribbon-avatar-btn { background: none; border: none; cursor: pointer; padding: 3px; border-radius: 50%; display: inline-flex; }
.em-ribbon-avatar-btn:hover { background: #e5e7eb; }
.em-ribbon-avatar {
  width: 28px; height: 28px; border-radius: 50%; background: #4b7c72; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600;
}
.em-account-backdrop { position: fixed; inset: 0; z-index: 6000; }
.em-account-pop {
  position: absolute; top: 40px; right: 8px; z-index: 6001; width: 330px;
  background: #fff; border: 1px solid #e1dfdd; border-radius: 10px;
  box-shadow: 0 12px 36px rgba(0,0,0,0.22); overflow: hidden;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-account-pop-main { display: flex; gap: 16px; padding: 20px; }
.em-account-pop-avatar {
  width: 58px; height: 58px; border-radius: 50%; background: #4b7c72; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 600; flex-shrink: 0;
}
.em-account-pop-info { min-width: 0; }
.em-account-pop-name { font-size: 16px; font-weight: 700; color: #201f1e; word-break: break-word; line-height: 1.3; }
.em-account-pop-email { font-size: 13px; color: #605e5c; margin: 2px 0 6px; word-break: break-word; }
.em-account-pop-view { background: none; border: none; color: #0f6cbd; font-size: 13px; cursor: pointer; padding: 0; font-family: inherit; }
.em-account-pop-view:hover { text-decoration: underline; }
.em-account-pop-add {
  display: flex; align-items: center; gap: 12px; width: 100%; padding: 14px 20px;
  background: #fff; border: none; border-top: 1px solid #ececec; cursor: pointer;
  font-size: 14px; color: #201f1e; font-family: inherit; text-align: left;
}
.em-account-pop-add svg { color: #605e5c; }
.em-account-pop-add:hover { background: #f5f5f5; }

/* ===================== SIDEBAR: MORE BREATHING ROOM (top actions) ===================== */
.em-sidebar-newmail { margin: 10px 8px 8px; padding: 10px 14px; gap: 9px; }
.em-sidebar-search-btn { min-height: 34px; padding: 8px 12px; margin: 2px 8px; gap: 12px; }
.em-sidebar-search-btn:last-of-type { margin-bottom: 10px; }

/* Account button now shows the name next to the avatar. */
.em-ribbon-avatar-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 3px 6px 3px 10px;
  border-radius: 18px;
}
.em-ribbon-username {
  font-size: 12.5px;
  font-weight: 600;
  color: #201f1e;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.em-ribbon-avatar-caret { color: #605e5c; flex-shrink: 0; }

/* ===================== SIDEBAR COLLAPSE TOGGLE ===================== */
.em-sidebar-collapsehdr { display: flex; justify-content: flex-end; padding: 4px 6px 0; }
.em-sidebar-collapse-btn {
  background: none; border: none; cursor: pointer; color: #605e5c;
  padding: 4px; border-radius: 5px; display: inline-flex;
}
.em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }

/* Narrow rail shown when the folder pane is collapsed — click to expand. */
.em-collapsed-rail {
  width: 34px; min-width: 34px; flex-shrink: 0;
  background: #fbfbfa; border-right: 1px solid #ececec;
  display: flex; flex-direction: column; align-items: center; padding-top: 8px;
}
.em-collapsed-expand {
  background: none; border: none; cursor: pointer; color: #605e5c;
  padding: 5px; border-radius: 5px; display: inline-flex;
}
.em-collapsed-expand:hover { background: #eceff2; color: #0f6cbd; }

/* ===================== COMPACT ICON-ONLY MODULE RAIL (bottom-left) ===================== */
.em-nav-rail-top { display: flex; flex-direction: row; align-items: center; gap: 2px; }
.em-nav-rail-btn {
  flex-direction: row; min-width: auto; padding: 6px 9px; gap: 0;
}
.em-nav-rail-label { display: none; }
.em-nav-rail-more svg { color: #605e5c; }

/* New mail button + collapse toggle on one row (no separate top row/space). */
.em-sidebar-collapsehdr { display: none; }
.em-sidebar-newmail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 8px 6px;
}
.em-sidebar-newmail-row .em-sidebar-newmail { flex: 1 1; margin: 0; }
.em-sidebar-newmail-row .em-sidebar-collapse-btn {
  flex-shrink: 0;
  color: #605e5c;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
}
.em-sidebar-newmail-row .em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }

/* ===================== OUTLOOK-WEB READING PANE TOOLBAR ===================== */
.em-viewer-toolbar {
  display: flex;
  align-items: center;
  gap: 1px;
  padding: 6px 12px;
  border-bottom: 1px solid #eaeaea;
  background: #ffffff;
  flex-shrink: 0;
  overflow-x: auto;
}
.em-vt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: none;
  background: transparent;
  border-radius: 5px;
  cursor: pointer;
  color: #3b3a39;
  font-size: 13px;
  font-family: inherit;
  white-space: nowrap;
}
.em-vt-btn:hover { background: #f3f2f1; }
.em-vt-btn svg { color: #605e5c; }
.em-vt-icon { padding: 6px 8px; }
.em-vt-sep { width: 1px; height: 20px; background: #e6e6e6; margin: 0 6px; flex-shrink: 0; }
.em-vt-spacer { flex: 1 1; min-width: 8px; }

/* Slim the sender row now that actions live in the top toolbar. */
.em-viewer-header-right { text-align: right; }

/* ===================== CRM / INSIGHTS RIGHT PANE ===================== */
.em-crm {
  width: 210px;
  min-width: 210px;
  flex-shrink: 0;
  border-left: 1px solid #eaeaea;
  background: #faf9f8;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.em-crm-head { padding: 12px 16px; font-size: 13px; font-weight: 600; color: #605e5c; border-bottom: 1px solid #ededed; }
.em-crm-body { padding: 14px 16px; }
.em-crm-contact { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.em-crm-avatar {
  width: 40px; height: 40px; border-radius: 50%; background: #8764b8; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0;
}
.em-crm-info { min-width: 0; }
.em-crm-name { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-crm-email { font-size: 12px; color: #605e5c; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.em-crm-note {
  display: flex; gap: 8px; align-items: flex-start;
  font-size: 12.5px; color: #605e5c; line-height: 1.45;
  background: #fff; border: 1px solid #ededed; border-radius: 8px; padding: 10px 12px;
}
.em-crm-note svg { color: #0f6cbd; flex-shrink: 0; margin-top: 1px; }
.em-crm-note strong { color: #201f1e; word-break: break-all; }
.interview-booking-page{min-height:100vh;background:#f3f5f8;border-top:12px solid #294348;padding:28px 0}.interview-booking-shell{max-width:980px;margin:0 0 0 55px;background:#fff;border-radius:0 8px 8px 0;box-shadow:0 5px 18px rgba(15,23,42,.08);overflow:hidden}.interview-booking-progress{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;padding:14px 28px 0}.booking-step{border-top:3px solid #dfe4ea;padding:8px 0;color:#9aa4b2;font-size:11px;font-weight:700;letter-spacing:.04em}.booking-step.active{border-color:#6178ee;color:#536fee}.interview-booking-content{display:grid;grid-template-columns:365px 1fr}.booking-calendar-panel{padding:18px 24px 28px;border-right:1px solid #dfe4ea}.booking-time-panel{position:relative;padding:18px 24px}.booking-kicker,.booking-date-kicker{color:#8995a8;font-size:11px;font-weight:700;letter-spacing:.08em}.booking-month-row{display:flex;align-items:center;justify-content:space-between;margin:14px 0 22px}.booking-month-row strong{background:#f0f4f8;border-radius:9px;padding:11px 16px;color:#102a43;font-size:15px}.booking-month-row button{width:38px;height:38px;margin-left:8px;border:1px solid #dce4ed;border-radius:8px;background:#fff;color:#60758f;font-size:25px;line-height:1}.booking-weekdays,.booking-days{display:grid;grid-template-columns:repeat(7,1fr);gap:6px}.booking-weekdays{margin-bottom:8px;color:#52657d;font-size:13px;text-align:center}.booking-days button{position:relative;height:42px;border:1px solid #f2f4f7;border-radius:10px;background:#fff;color:#1e293b;font-size:14px}.booking-days button:hover{border-color:#6178ee}.booking-days button.muted{color:#e2e7ed;background:#fafbfc}.booking-days button.selected{background:#5275e8;color:#fff;border-color:#ffb300;box-shadow:0 2px 5px rgba(82,117,232,.25)}.booking-days button i{position:absolute;bottom:5px;left:50%;width:4px;height:4px;border-radius:50%;background:#6178ee;transform:translateX(-50%)}.booking-days button.selected i{background:#fff}.booking-legend{display:flex;flex-wrap:wrap;gap:18px;border-top:1px solid #e5eaf0;margin-top:30px;padding-top:18px;color:#65778d;font-size:11px;font-weight:700;letter-spacing:.06em}.dot{display:inline-block;width:10px;height:10px;margin-right:6px;border-radius:50%;background:#fff;border:2px solid #dce4ed}.selected-dot{background:#6178ee;border-color:#6178ee}.unavailable-dot{background:#f0f3f7;border-color:#f0f3f7}.booking-back{float:right;border:0;border-radius:9px;background:#ffb21b;color:#fff;padding:9px 15px;font-weight:700}.booking-date-kicker{margin-top:18px}.booking-time-panel h1{margin:6px 0 16px;color:#111827;font-size:18px}.booking-timezone{color:#8995a8;font-size:13px}.booking-slots{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:18px}.booking-slots button{height:44px;border:1px solid #cbd5e1;border-radius:7px;background:#fff;color:#526ff0;font-weight:600}.booking-slots button:hover,.booking-slots button.chosen{border-color:#5275e8;background:#eef2ff}@media(max-width:760px){.interview-booking-shell{margin:0 12px}.interview-booking-content{grid-template-columns:1fr}.booking-calendar-panel{border-right:0;border-bottom:1px solid #dfe4ea}.booking-slots{grid-template-columns:1fr 1fr}}@media(max-width:420px){.interview-booking-progress{padding-left:16px;padding-right:16px}.booking-calendar-panel,.booking-time-panel{padding-left:16px;padding-right:16px}.booking-legend{gap:10px}.booking-slots{grid-template-columns:1fr}}
.interview-booking-page{position:fixed;inset:0;z-index:9999;overflow:auto;padding-top:27px}.interview-booking-shell{min-height:858px}
.booking-info-panel{padding:18px 24px;border-left:1px solid #dfe4ea;background:#fbfcfe}.booking-info-panel h2{margin:18px 0 24px;color:#102a43;font-size:18px}.booking-info-panel label{display:block;margin:0 0 6px;color:#52657d;font-size:12px;font-weight:700}.booking-info-panel input{width:100%;height:42px;margin-bottom:18px;padding:0 11px;border:1px solid #cbd5e1;border-radius:7px;color:#243b53;font-size:13px;outline:none}.booking-info-panel input:focus{border-color:#5275e8;box-shadow:0 0 0 2px #eef2ff}.booking-continue{width:100%;height:42px;margin-top:8px;border:0;border-radius:7px;background:#5275e8;color:#fff;font-weight:700}.booking-continue:disabled{cursor:not-allowed;background:#cbd5e1}@media(max-width:900px){.interview-booking-content{grid-template-columns:365px 1fr}.booking-info-panel{grid-column:1/-1;border-top:1px solid #dfe4ea;border-left:0}}
.interview-booking-content{grid-template-columns:220px 267px minmax(430px,1fr)}@media(max-width:900px){.interview-booking-content{grid-template-columns:267px 1fr}.booking-profile-panel{grid-column:1/-1;border-right:0;border-bottom:1px solid #dfe4ea}}
.interview-booking-shell{width:calc(100vw - 110px);max-width:none;min-height:calc(100vh - 54px)}.interview-booking-content{grid-template-columns:260px 350px minmax(500px,1fr)}.booking-calendar-panel{padding-left:28px;padding-right:28px}.booking-time-panel{padding-left:30px;padding-right:30px}.booking-profile-panel{padding-left:24px;padding-right:24px}@media(max-width:900px){.interview-booking-shell{width:calc(100vw - 24px);margin-left:12px}.interview-booking-content{grid-template-columns:267px 1fr}}
.booking-profile-panel{padding:22px 16px;border-right:1px solid #dfe4ea;color:#64748b}.booking-avatar{display:flex;align-items:center;justify-content:center;width:50px;height:50px;border-radius:50%;background:#5275e8;color:#fff;font-size:17px;font-weight:700;margin-bottom:14px}.booking-profile-label{font-size:12px;margin-bottom:3px}.booking-profile-panel h2{margin:0 0 10px;color:#102a43;font-size:16px}.booking-profile-detail{display:flex;gap:6px;align-items:flex-start;margin:8px 0;font-size:12px;line-height:1.35}.booking-profile-zone{border-top:1px solid #edf0f4;padding-top:12px;margin-top:365px;font-size:12px;line-height:1.5}.booking-profile-zone small{display:block;color:#8995a8;font-size:10px;font-weight:700;letter-spacing:.08em;margin-bottom:5px}.booking-profile-time{padding-left:15px}.booking-profile-time span{float:right;font-size:15px}.booking-info-panel{display:none}.booking-month-row strong{font-size:16px}.booking-weekdays{font-size:14px}.booking-days button{font-size:15px}.booking-kicker,.booking-date-kicker{font-size:12px}.booking-time-panel h1{font-size:20px}.booking-timezone{font-size:14px}.booking-slots button{font-size:14px}
.interview-booking-page,.interview-booking-page button,.interview-booking-page input{font-family:"Plus Jakarta Sans",sans-serif}.interview-booking-shell{border:1px solid #e5eaf0}.booking-calendar-panel{background:#fff}.booking-time-panel{background:#fff}.booking-info-panel{background:linear-gradient(180deg,#fbfcff 0%,#f7fafc 100%)}.booking-month-row strong{font-weight:700}.booking-month-row button{transition:all .2s ease}.booking-month-row button:hover{background:#eef2ff;color:#5275e8;transform:translateY(-1px)}.booking-days button{font-weight:600;transition:all .18s ease}.booking-days button:not(.muted):hover{background:#f1f4ff;transform:translateY(-1px)}.booking-days button.selected{font-weight:700}.booking-slots button{font-family:inherit;font-size:13px;transition:all .2s ease}.booking-slots button:hover,.booking-slots button.chosen{box-shadow:0 3px 8px rgba(82,117,232,.16);transform:translateY(-1px)}.booking-back{font-family:inherit;font-size:12px;box-shadow:0 3px 8px rgba(255,178,27,.2);transition:transform .2s ease}.booking-back:hover{transform:translateY(-1px)}.booking-info-panel h2{font-weight:700;letter-spacing:-.01em}.booking-continue{font-family:inherit;font-size:13px;box-shadow:0 4px 10px rgba(82,117,232,.2);transition:all .2s ease}.booking-continue:not(:disabled):hover{background:#405ed8;transform:translateY(-1px)}
.interview-booking-page{border-top:0!important;padding:40px 0 28px!important}.interview-booking-shell{width:calc(100vw - 120px);max-width:1800px!important;margin:0 auto!important;min-height:858px;border-radius:8px!important}.booking-calendar-panel{padding-top:26px!important;padding-bottom:36px!important}.booking-month-row{margin-top:16px!important;margin-bottom:26px!important}.booking-weekdays,.booking-days{gap:8px!important}.booking-days button{height:46px!important}.booking-month-row button{width:40px!important;height:40px!important}
.swal2-container{z-index:20000!important}
.interview-booking-content{grid-template-columns:300px 390px minmax(460px,1fr)!important}.booking-calendar-panel{padding-left:28px!important;padding-right:28px!important}.booking-weekdays,.booking-days{gap:10px!important}.booking-days button{height:48px!important}.booking-slots{max-width:820px;gap:8px 10px}.booking-slots button{height:42px}
.booking-save{position:absolute;right:30px;bottom:28px;border:0;border-radius:8px;background:#5275e8;color:#fff;padding:10px 26px;font-family:inherit;font-size:13px;font-weight:700;box-shadow:0 4px 10px rgba(82,117,232,.2)}.booking-save:disabled{cursor:not-allowed;background:#cbd5e1;box-shadow:none}
.booking-profile-panel{display:flex;flex-direction:column;min-height:858px}.booking-profile-zone{margin-top:auto!important}
.booking-slots{width:100%;max-width:none;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:14px}.booking-time-panel{padding-right:34px}
.booking-profile-zone select{width:100%;margin:2px 0;padding:0;border:0;background:transparent;color:#60758f;font-family:inherit;font-size:12px;outline:0;cursor:pointer}.booking-profile-zone select option{color:#243b53}
.booking-profile-zone-row{display:flex;align-items:center;gap:8px}.booking-profile-zone-row select{flex:1 1;min-width:0}.booking-profile-zone-row .booking-profile-time{padding-left:0;white-space:nowrap;color:#60758f}
.booking-save-spinner{display:inline-block;width:14px;height:14px;margin-right:7px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;vertical-align:-2px;animation:booking-save-spin .7s linear infinite}@keyframes booking-save-spin{to{transform:rotate(360deg)}}
.booking-confirmation-card{width:min(560px,calc(100vw - 32px));margin:12vh auto 0;padding:48px 36px;text-align:center;background:#fff;border:1px solid #e5eaf0;border-radius:12px;box-shadow:0 8px 28px rgba(15,23,42,.1);font-family:"Plus Jakarta Sans",sans-serif}.booking-confirmation-icon{width:56px;height:56px;margin:0 auto 18px;border-radius:50%;background:#5275e8;color:#fff;font-size:34px;line-height:56px}.booking-confirmation-card h1{margin:0 0 10px;color:#102a43;font-size:24px}.booking-confirmation-type{color:#5275e8;font-weight:700}.booking-confirmation-details{display:flex;flex-direction:column;gap:8px;margin:24px 0;padding:18px;border:1px solid #dfe6f3;border-radius:8px;background:#f7f9ff;color:#334e68}.booking-confirmation-details span{color:#627d98}

.schedule-review-modal {
  max-width: min(1180px, calc(100vw - 42px)) !important;
  width: 94% !important;
}

.schedule-review-modal .modal-content {
  border: 0;
  border-radius: 14px;
  overflow: hidden;
  background: #f8fafc;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.22);
}

.schedule-review-header {
  padding: 18px 22px !important;
  border-bottom: 1px solid #dbe5f0 !important;
  background: linear-gradient(135deg, #12385f 0%, #1f5f8f 100%) !important;
  color: #ffffff !important;
}

.schedule-review-header .btn-close {
  filter: invert(1) grayscale(1) brightness(1.8);
  opacity: 0.9;
}

.schedule-review-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.schedule-review-title-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 19px;
  flex: 0 0 auto;
}

.schedule-review-title {
  color: #ffffff;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.2;
}

.schedule-review-subtitle {
  margin-top: 3px;
  color: #d8eaff;
  font-size: 12px;
  font-weight: 500;
}

.schedule-review-body {
  padding: 18px 20px 12px !important;
  background: #f4f7fb !important;
}

.schedule-review-summary {
  display: grid;
  grid-template-columns: 150px minmax(220px, 1fr) 230px;
  gap: 10px;
  margin-bottom: 14px;
}

.schedule-review-summary > div {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dbe5f0;
  border-radius: 9px;
  background: #ffffff;
}

.schedule-review-summary-label {
  display: block;
  margin-bottom: 3px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.schedule-review-summary strong {
  display: block;
  min-width: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-review-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border: 1px solid #fecdd3;
  border-radius: 9px;
  background: #fff1f2;
  color: #be123c;
  font-size: 13px;
  font-weight: 700;
}

.schedule-review-list {
  max-height: 62vh;
  overflow: auto;
  padding-right: 4px;
}

.schedule-review-card {
  margin-bottom: 14px;
  padding: 16px;
  border: 1px solid #d9e3ef;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.schedule-review-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef2f7;
}

.schedule-review-candidate-meta {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.schedule-review-avatar {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bfdbfe;
  border-radius: 50%;
  background: #eaf4ff;
  color: #0f4f82;
  font-size: 15px;
  font-weight: 900;
  flex: 0 0 auto;
}

.schedule-review-candidate-title {
  color: #0f3f6e;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.2;
}

.schedule-review-candidate-email {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  min-width: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.schedule-review-candidate-email span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-review-job-pill {
  max-width: 360px;
  overflow: hidden;
  padding: 6px 10px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #f8fbff;
  color: #1e4f78;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
}

.schedule-review-label {
  display: block;
  margin: 0 0 6px;
  color: #1f2937;
  font-size: 12px;
  font-weight: 800;
}

.schedule-review-label span {
  color: #dc2626;
}

.schedule-review-input.form-control {
  height: 38px;
  border: 1px solid #d5deea;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
  box-shadow: none;
}

.schedule-review-input.form-control:focus {
  border-color: #1a5fa8;
  box-shadow: 0 0 0 3px rgba(26, 95, 168, 0.12);
}

.schedule-review-input.form-control:disabled {
  background: #f8fafc;
  color: #64748b;
}

.schedule-review-footer {
  display: flex;
  justify-content: center !important;
  gap: 10px;
  padding: 14px 20px !important;
  border-top: 1px solid #dbe5f0 !important;
  background: #ffffff !important;
}

.schedule-review-cancel.btn {
  min-width: 92px;
  height: 38px;
  border-color: #cbd5e1;
  border-radius: 8px;
  color: #334155;
  font-weight: 700;
}

.schedule-review-primary.btn {
  min-width: 210px;
  height: 38px;
  border: 0;
  border-radius: 8px;
  background: #126fb3;
  color: #ffffff;
  font-weight: 800;
  box-shadow: 0 9px 18px rgba(18, 111, 179, 0.22);
}

.schedule-review-primary.btn:hover,
.schedule-review-primary.btn:focus {
  background: #0f5f9b;
  color: #ffffff;
}

@media (max-width: 900px) {
  .schedule-review-summary {
    grid-template-columns: 1fr;
  }

  .schedule-review-card-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .schedule-review-job-pill {
    max-width: 100%;
  }
}
.schedule-history-panel { margin-top:18px; padding:16px; border:1px solid #d9e7f5; border-radius:10px; background:#fff; }
.schedule-history-title { color:#0b3f75; font-size:15px; font-weight:700; margin-bottom:12px; }
.schedule-history-timeline { border-left:2px solid #cfe0f2; padding-left:16px; display:grid; gap:12px; }
.schedule-history-item { position:relative; padding:11px 13px; border:1px solid #e1eaf3; border-radius:8px; background:#f8fbff; color:#52677d; font-size:12px; line-height:1.6; }
.schedule-history-item::before { content:""; position:absolute; width:9px; height:9px; border-radius:50%; background:#1a5fa8; left:-22px; top:16px; border:2px solid #fff; box-shadow:0 0 0 1px #9fc2df; }
.schedule-history-badge { display:inline-block; padding:3px 8px; margin-bottom:5px; border-radius:999px; background:#eaf4ff; color:#1a5fa8; font-size:11px; font-weight:700; }
.schedule-history-badge.is-deleted { background:#fff1f1; color:#b42318; }
.schedule-history-summary { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:6px 18px; margin:8px 0 10px; padding:10px 12px; border:1px solid #e1eaf3; border-radius:8px; background:#fff; }
.schedule-history-summary-row { display:grid; grid-template-columns:72px minmax(0, 1fr); gap:8px; align-items:start; min-width:0; font-size:12px; line-height:1.45; }
.schedule-history-summary-row span { color:#728399; font-weight:600; }
.schedule-history-summary-row strong { color:#25435f; font-weight:600; overflow-wrap:anywhere; }
.schedule-history-summary-row.is-new strong { color:#16794a; }
.schedule-history-summary-row.full-width { grid-column:1 / -1; }
.schedule-history-multiline { display:flex; flex-direction:column; gap:2px; }
.archive-reason { display:flex; align-items:center; gap:8px; min-width:220px; line-height:1.4; }
.deleted-badge, .archived-badge { display:inline-block; flex:0 0 auto; border-radius:6px; padding:3px 8px; font-size:12px; font-weight:600; }
.deleted-badge { color:#b91c1c; background:#fee2e2; }
.archived-badge { color:#92400e; background:#fef3c7; }
@media (max-width: 640px) {
  .schedule-history-summary { grid-template-columns:1fr; gap:6px; }
  .schedule-history-summary-row.full-width { grid-column:auto; }
}
.schedule-history-details { margin-top:9px; border-top:1px solid #e1eaf3; padding-top:8px; }
.schedule-history-details summary { cursor:pointer; color:#1a5fa8; font-weight:700; font-size:12px; }
.schedule-history-detail-grid { display:grid; grid-template-columns:minmax(100px, .8fr) minmax(120px, 1fr) minmax(120px, 1fr); margin-top:8px; border:1px solid #e1eaf3; border-radius:6px; overflow:hidden; font-size:11px; }
.schedule-history-detail-grid > div { padding:6px 7px; border-bottom:1px solid #edf2f7; overflow-wrap:anywhere; }
.schedule-history-detail-grid > div:nth-child(3n+1) { background:#f8fbff; font-weight:600; color:#52677d; }
.schedule-history-detail-header { background:#eef5fc !important; color:#214c76 !important; font-weight:700 !important; }
.salary-missing-alert { text-align:left; width:100%; box-sizing:border-box; }
.salary-missing-intro { margin:0 0 12px; color:#5d6875; font-size:14px; }
.salary-missing-table-wrap { max-height:220px; overflow:auto; border:1px solid #e4e9ef; border-radius:7px; }
.salary-missing-table { width:100%; min-width:390px; table-layout:fixed; border-collapse:collapse; font-size:13px; }
.salary-missing-table th { position:sticky; top:0; background:#f5f8fb; color:#52606d; font-weight:700; text-align:left; }
.salary-missing-table th, .salary-missing-table td { padding:9px 10px; border:1px solid #dbe3ec; word-break:normal; overflow-wrap:break-word; }
.salary-missing-table tbody tr:last-child td { border-bottom:0; }
.salary-missing-table th:first-child, .salary-missing-table td:first-child { width:58px; min-width:58px; white-space:nowrap; color:#52606d; }
.salary-missing-table th:nth-child(2), .salary-missing-table td:nth-child(2) { width:58%; }
.salary-missing-table th:nth-child(3), .salary-missing-table td:nth-child(3) { width:27%; }
.salary-missing-status { display:inline-block; padding:3px 8px; border-radius:999px; background:#fff1f0; color:#b42318; font-size:11px; font-weight:700; }

/* Job action logs use a compact timeline so the modal stays easy to scan. */
.action-timeline-modal .modal-dialog { width:calc(100% - 24px); max-width:860px; }
.action-timeline-modal .modal-content { overflow:hidden; border:0; border-radius:16px; box-shadow:0 24px 60px rgba(16, 42, 67, .24); }
.action-timeline-header { padding:18px 22px; border:0; background:linear-gradient(120deg, #0d4770, #087c83); color:#fff; }
.action-timeline-header .btn-close { filter:brightness(0) invert(1); opacity:.9; }
.action-timeline-heading { display:flex; align-items:center; gap:12px; padding-right:28px; }
.action-timeline-heading-icon { display:grid; place-items:center; width:40px; height:40px; flex:0 0 40px; border:1px solid rgba(255,255,255,.28); border-radius:12px; background:rgba(255,255,255,.14); font-size:18px; }
.action-timeline-title, .action-timeline-subtitle { display:block; }
.action-timeline-title { font-size:18px; font-weight:750; line-height:1.25; }
.action-timeline-subtitle { margin-top:3px; color:rgba(255,255,255,.76); font-size:12px; font-weight:500; }
.action-timeline-count { margin-left:auto; padding:6px 10px; border:1px solid rgba(255,255,255,.24); border-radius:999px; background:rgba(255,255,255,.12); color:#fff; font-size:12px; font-weight:700; white-space:nowrap; }
.action-timeline-body { max-height:min(68vh, 650px); overflow-y:auto; padding:20px 22px; background:#f4f8fb; }
.action-timeline-list { display:grid; gap:14px; }
.action-timeline-item { position:relative; display:grid; grid-template-columns:26px minmax(0, 1fr); gap:10px; }
.action-timeline-rail { position:relative; display:flex; justify-content:center; }
.action-timeline-rail::after { content:""; position:absolute; top:28px; bottom:-20px; width:2px; background:#d8e6ef; }
.action-timeline-item:last-child .action-timeline-rail::after { display:none; }
.action-timeline-dot { z-index:1; display:grid; place-items:center; width:26px; height:26px; border:4px solid #f4f8fb; border-radius:50%; background:#0e7381; color:#fff; box-shadow:0 0 0 1px #b7d9df; font-size:10px; }
.action-timeline-card { min-width:0; padding:15px 16px; border:1px solid #dce7ef; border-radius:12px; background:#fff; box-shadow:0 4px 12px rgba(31, 71, 98, .05); }
.action-timeline-card-top { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.action-timeline-badge { display:inline-flex; max-width:70%; padding:5px 9px; border-radius:7px; background:#e8f5f3; color:#08726f; font-size:12px; font-weight:750; line-height:1.25; }
.action-timeline-card time { color:#6a7e90; font-size:12px; white-space:nowrap; }
.action-timeline-card time i { margin-right:4px; color:#0e7381; }
.action-timeline-description { margin:11px 0 10px; color:#334d63; font-size:14px; line-height:1.55; }
.action-timeline-meta { display:flex; flex-wrap:wrap; gap:8px 16px; color:#718497; font-size:11px; }
.action-timeline-meta i { margin-right:4px; color:#0e7381; }
.action-timeline-change-box { margin-top:13px; padding:12px; border:1px solid #d8e8ef; border-radius:9px; background:#f7fbfc; }
.action-timeline-change-title { margin-bottom:9px; color:#0d5e70; font-size:11px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }
.action-timeline-change-title i { margin-right:5px; }
.action-timeline-change-box .activity-change-list { display:grid; gap:7px; }
.action-timeline-change-box .activity-change-item { padding:9px 11px; border:1px solid #e0ebf0; border-radius:7px; background:#fff; font-size:12px; line-height:1.5; }
.action-timeline-change-box .activity-change-item strong { display:block; margin-bottom:3px; color:#0c527d; font-size:12px; }
.activity-detail-sections { display:grid; gap:12px; }
.activity-detail-section { padding:12px; border:1px solid #dce9ef; border-radius:10px; background:#fbfdfe; }
.activity-detail-section h6 { display:flex; align-items:center; gap:7px; margin:0 0 10px; color:#0d5e70; font-size:11px; font-weight:800; letter-spacing:.04em; text-transform:uppercase; }
.activity-detail-section h6::before { content:""; width:5px; height:16px; border-radius:4px; background:#0e8790; }
.activity-field-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:8px; }
.activity-before-after-table { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.activity-table-header, .activity-table-row { display:grid; grid-template-columns:minmax(150px, 1.15fr) minmax(130px, 1fr) minmax(130px, 1fr); gap:10px; align-items:start; padding:9px 10px; }
.activity-table-header { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }
.activity-table-row { border-top:1px solid #edf3f6; color:#38556b; font-size:12px; }
.activity-table-row strong { color:#294a61; font-weight:700; overflow-wrap:anywhere; }
.activity-table-row > span { overflow-wrap:anywhere; }
.activity-table-row > span:last-child { color:#08726f; }
.activity-html-text, .activity-html-details { display:block; white-space:pre-wrap; line-height:1.45; }
.activity-html-details summary { cursor:pointer; color:#0e7381; font-size:11px; font-weight:700; }
.activity-html-details > span { display:block; max-height:220px; margin-top:5px; overflow:auto; white-space:pre-wrap; }
.skill-change-table .activity-table-header, .skill-change-table .activity-table-row { grid-template-columns:minmax(100px, .85fr) minmax(130px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr); }
.recruiter-change-table .activity-table-header, .recruiter-change-table .activity-table-row { grid-template-columns:130px minmax(0, 1fr); }
.permission-change-table .activity-table-header, .permission-change-table .activity-table-row { grid-template-columns:minmax(130px, 1.1fr) minmax(130px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr); }
.talent-change-table .activity-table-header, .talent-change-table .activity-table-row { grid-template-columns:minmax(170px, 1fr) minmax(0, 1.4fr) minmax(0, 1.4fr); }
.activity-field-card { padding:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.activity-field-card > strong { display:block; margin-bottom:7px; color:#294a61; font-size:12px; }
.activity-field-card > div, .activity-permission > div { display:grid; grid-template-columns:52px minmax(0, 1fr); gap:8px; padding-top:4px; color:#708497; font-size:11px; }
.activity-field-card > div b, .activity-permission > div b { overflow-wrap:anywhere; color:#38556b; font-weight:600; }
.activity-field-card > div:last-child b { color:#08726f; }
.activity-person-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:10px; }
.activity-person-grid > div { display:flex; flex-direction:column; gap:5px; }
.activity-person-grid > div > span, .activity-question-content span { color:#788d9d; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }
.activity-person { display:block; padding:6px 9px; border-radius:7px; background:#eaf7f1; color:#16794a; font-size:12px; }
.activity-person.removed { background:#fff1f0; color:#b42318; }
.activity-permission-list, .activity-question-list { display:grid; gap:8px; }
.activity-permission { padding:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.activity-permission > strong { display:block; margin-bottom:5px; color:#294a61; font-size:13px; }
.activity-question { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.activity-question summary { cursor:pointer; padding:10px 12px; color:#294a61; font-size:12px; font-weight:650; line-height:1.45; }
.activity-question summary::marker { color:#0e7381; }
.activity-question-content { display:grid; gap:6px; padding:0 12px 11px; border-top:1px solid #edf3f6; }
.activity-question-content > div { display:grid; grid-template-columns:145px minmax(0, 1fr); gap:8px; padding-top:8px; }
.activity-question-content strong { overflow-wrap:anywhere; color:#38556b; font-size:12px; font-weight:600; }
.activity-detail-empty { padding:14px; border:1px dashed #cbdce5; border-radius:9px; background:#f8fbfc; color:#7890a2; font-size:13px; text-align:center; }
.activity-event-table, .activity-update-table { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.activity-event-table > div { display:grid; grid-template-columns:150px minmax(0, 1fr); gap:12px; padding:8px 10px; border-bottom:1px solid #edf3f6; }
.activity-event-table > div:last-child, .activity-update-table > div:last-child { border-bottom:0; }
.activity-event-table span, .activity-update-table span { color:#788d9d; font-size:11px; }
.activity-event-table strong { overflow-wrap:anywhere; color:#294a61; font-size:12px; font-weight:650; }
.activity-update-table { margin-top:10px; }
.activity-update-table > div { display:grid; grid-template-columns:minmax(130px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr); gap:10px; padding:8px 10px; border-bottom:1px solid #edf3f6; }
.activity-update-header { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }
.activity-update-table strong { color:#294a61; font-size:11px; }
.activity-update-table > div:not(.activity-update-header) span:last-child { color:#08726f; }
.activity-inline-details summary { cursor:pointer; color:#0e7381; font-size:11px; font-weight:700; }
.activity-inline-details > span { display:block; margin-top:5px; white-space:pre-wrap; }
.question-activity-details { margin-top:14px; padding:18px; border:1px solid #d7e8ed; border-radius:14px; background:linear-gradient(180deg, #f7fcfd 0%, #f4f8fb 100%); }
.question-activity-title-row { display:flex; align-items:center; gap:10px; margin-bottom:15px; }
.question-activity-icon { display:grid; place-items:center; width:34px; height:34px; border-radius:10px; background:#dff3ef; color:#08726f; }
.question-activity-title-row h5 { margin:0; color:#16475d; font-size:14px; font-weight:800; }
.question-activity-title-row span:not(.question-activity-icon) { color:#7890a2; font-size:11px; }
.question-activity-stats { display:grid; grid-template-columns:repeat(4, minmax(0, 1fr)); gap:9px; margin-bottom:14px; }
.question-activity-stats > div { display:flex; min-height:72px; flex-direction:column; justify-content:center; padding:10px 12px; border:1px solid #dce9ef; border-radius:10px; background:#fff; }
.question-activity-stats span { color:#7890a2; font-size:10px; font-weight:800; letter-spacing:.04em; text-transform:uppercase; }
.question-activity-stats strong { margin-top:2px; color:#23465d; font-size:23px; line-height:1.1; }
.question-activity-stats small { color:#7890a2; font-size:10px; }
.question-activity-stats .is-positive { border-color:#bde3d5; background:#f5fffa; }
.question-activity-stats .is-positive strong { color:#08794d; }
.question-activity-stats .is-accent { border-color:#c7dff0; background:#f5faff; }
.question-activity-stats .is-accent strong { color:#116da2; }
.question-activity-panel { padding:14px; border:1px solid #dce9ef; border-radius:11px; background:#fff; box-shadow:0 3px 10px rgba(31, 71, 98, .04); }
.question-activity-panel + .question-activity-panel { margin-top:10px; }
.question-activity-panel h6 { display:flex; align-items:center; justify-content:space-between; margin:0 0 10px; color:#174b62; font-size:13px; font-weight:800; letter-spacing:0; text-transform:none; }
.question-activity-panel h6::after { content:""; width:32px; height:3px; border-radius:4px; background:#8bc9c7; }
.question-activity-panel.after { border-color:#bfe3d7; background:#fbfffd; }
.question-activity-table { overflow:auto; border:1px solid #e2edf1; border-radius:7px; }
.question-activity-table-head, .question-activity-table-row { display:grid; grid-template-columns:1.35fr .7fr 1fr .8fr .8fr .7fr; min-width:620px; gap:8px; padding:8px; font-size:11px; }
.question-activity-table-head { background:#f2f8fa; color:#0d5e70; font-size:9px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }
.question-activity-table-row { border-top:1px solid #edf3f6; color:#38556b; }
.question-activity-table-row strong { color:#294a61; }
.question-activity-setting { display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid #edf3f6; color:#788d9d; font-size:11px; }
.question-activity-setting strong { color:#38556b; }
.question-activity-question-list { margin-top:10px; color:#38556b; font-size:12px; line-height:1.5; }
.question-activity-label { display:block; margin-bottom:5px; color:#0d5e70; font-size:10px; font-weight:800; text-transform:uppercase; }
.question-activity-question-list div { padding:7px 8px; border-top:1px solid #edf3f6; }
.question-activity-generated-list { display:grid; gap:8px; }
.question-activity-generated { overflow:hidden; border:1px solid #dce9ef; border-radius:8px; background:#fff; }
.question-activity-generated summary { cursor:pointer; padding:9px 10px; color:#294a61; font-size:12px; font-weight:700; line-height:1.45; }
.question-activity-generated > div { display:grid; grid-template-columns:130px minmax(0, 1fr); gap:8px; padding:7px 10px; border-top:1px solid #edf3f6; font-size:11px; }
.question-activity-generated > div span { color:#788d9d; font-weight:700; text-transform:uppercase; }
.question-activity-generated > div strong { overflow-wrap:anywhere; color:#38556b; }
.question-activity-empty { margin-top:14px; padding:14px; border:1px dashed #cbdce5; border-radius:9px; background:#f8fbfc; color:#7890a2; font-size:12px; text-align:center; }
.question-activity-preview { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-top:14px; padding:12px 14px; border:1px solid #cfe5ea; border-radius:10px; background:#f4fbfc; }
.question-activity-preview > div { display:flex; align-items:center; gap:8px; color:#0d5e70; font-size:12px; font-weight:700; }
.question-activity-preview > div i { color:#0e8790; }
.question-activity-preview .btn { display:inline-flex; align-items:center; gap:7px; border:0; border-radius:8px; background:#0c6e9f; font-size:11px; font-weight:700; }
.question-activity-modal .modal-dialog { width:calc(100% - 24px); max-width:1100px; }
.question-activity-modal .modal-content { overflow:hidden; border:0; border-radius:16px; box-shadow:0 24px 70px rgba(16, 42, 67, .28); }
.question-activity-modal-header { padding:18px 22px; border:0; background:linear-gradient(120deg, #0d4770, #087c83); color:#fff; }
.question-activity-modal-header .btn-close { filter:brightness(0) invert(1); }
.question-activity-modal-heading { display:flex; align-items:center; gap:12px; padding-right:28px; }
.question-activity-modal-icon { display:grid; place-items:center; width:40px; height:40px; border:1px solid rgba(255,255,255,.28); border-radius:12px; background:rgba(255,255,255,.14); font-size:18px; }
.question-activity-modal-heading strong, .question-activity-modal-heading span { display:block; }
.question-activity-modal-heading strong { font-size:18px; }
.question-activity-modal-heading span { margin-top:3px; color:rgba(255,255,255,.76); font-size:12px; }
.question-activity-modal-body { max-height:calc(100vh - 150px); overflow-y:auto; padding:20px 22px; background:#f4f8fb; }
.question-activity-modal-body .question-activity-details { margin-top:0; padding:16px; background:transparent; border:0; }
.question-activity-count-table { overflow:hidden; margin-bottom:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }
.question-activity-count-table > div { display:grid; grid-template-columns:minmax(170px, 1fr) repeat(4, minmax(70px, 100px)); gap:10px; padding:10px 12px; border-bottom:1px solid #edf3f6; font-size:12px; }
.question-activity-count-table.activity-before-after-table > div { grid-template-columns:minmax(150px, 1fr) minmax(130px, 1fr) repeat(2, minmax(90px, 1fr)); }
.question-activity-count-table > div:last-child { border-bottom:0; }
.question-activity-count-table > div:first-child { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; text-transform:uppercase; }
.question-activity-count-table strong { color:#294a61; }
.question-activity-group { margin-top:9px; border:1px solid #dce9ef; border-radius:9px; background:#fbfdfe; }
.question-activity-group summary { cursor:pointer; padding:10px 12px; color:#0d5e70; font-size:12px; font-weight:800; }
.question-activity-list { display:grid; gap:8px; margin:0; padding:0 12px 12px 30px; }
.question-activity-list li { padding:10px 11px; border:1px solid #e4edf1; border-radius:8px; background:#fff; color:#294a61; font-size:12px; line-height:1.5; }
.question-activity-list li strong, .question-activity-list li span { display:block; }
.question-activity-list li span { margin-top:3px; color:#788d9d; font-size:11px; }
.action-timeline-detail-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:7px; margin-top:12px; }
.action-timeline-detail { display:flex; min-width:0; flex-direction:column; gap:3px; padding:8px 10px; border:1px solid #e5edf2; border-radius:7px; background:#f9fbfc; }
.action-timeline-detail span { color:#7890a2; font-size:10px; font-weight:700; text-transform:uppercase; }
.action-timeline-detail strong { overflow-wrap:anywhere; color:#38556b; font-size:12px; font-weight:600; }
.action-timeline-empty { display:flex; min-height:240px; align-items:center; justify-content:center; flex-direction:column; gap:7px; color:#7890a2; text-align:center; }
.action-timeline-empty strong { color:#294a61; font-size:16px; }
.action-timeline-empty-icon { display:grid; place-items:center; width:48px; height:48px; margin-bottom:4px; border-radius:14px; background:#e6f1f5; color:#0e7381; font-size:21px; }
.action-timeline-footer { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:13px 22px; border-top:1px solid #e2ebf1; background:#fff; color:#718497; font-size:12px; }
.action-timeline-next { display:inline-flex; align-items:center; gap:7px; border:0; border-radius:8px; background:#0c6e9f; font-size:12px; font-weight:700; }
.action-timeline-next:hover, .action-timeline-next:focus { background:#095b84; }
@media (max-width:640px) {
  .action-timeline-header, .action-timeline-body, .action-timeline-footer { padding-left:14px; padding-right:14px; }
  .action-timeline-count { display:none; }
  .action-timeline-card-top { align-items:flex-start; flex-direction:column; gap:8px; }
  .action-timeline-badge { max-width:100%; }
  .action-timeline-card time { font-size:11px; }
  .action-timeline-detail-grid { grid-template-columns:1fr; }
  .activity-field-grid, .activity-person-grid { grid-template-columns:1fr; }
  .activity-table-header, .activity-table-row, .skill-change-table .activity-table-header, .skill-change-table .activity-table-row, .permission-change-table .activity-table-header, .permission-change-table .activity-table-row { grid-template-columns:repeat(4, minmax(90px, 1fr)); font-size:10px; gap:6px; padding:8px 6px; }
  .recruiter-change-table .activity-table-header, .recruiter-change-table .activity-table-row { grid-template-columns:90px minmax(0, 1fr); }
  .talent-change-table .activity-table-header, .talent-change-table .activity-table-row { grid-template-columns:120px minmax(0, 1fr) minmax(0, 1fr); }
  .activity-question-content > div { grid-template-columns:1fr; gap:3px; }
  .activity-event-table > div, .activity-update-table > div { grid-template-columns:1fr; gap:3px; }
  .question-activity-generated > div { grid-template-columns:1fr; gap:3px; }
  .question-activity-preview { align-items:flex-start; flex-direction:column; }
  .question-activity-stats { grid-template-columns:repeat(2, minmax(0, 1fr)); }
  .question-activity-count-table > div { grid-template-columns:minmax(110px, 1fr) repeat(4, minmax(52px, 72px)); gap:6px; font-size:10px; }
  .question-activity-count-table.activity-before-after-table > div { grid-template-columns:minmax(90px, 1fr) minmax(90px, 1fr) repeat(2, minmax(62px, 1fr)); }
}

/* Recruiter activity report polish */
.recruiter-report-page {
  padding: 18px 20px 34px;
  background: radial-gradient(circle at 92% 0%, rgba(14, 165, 233, 0.1), transparent 26%),
    linear-gradient(180deg, #f7fbff 0%, #eef4fa 100%);
}

.recruiter-report-hero {
  min-height: 142px;
  border-radius: 24px;
  background: linear-gradient(118deg, #10224f 0%, #1f4da7 48%, #0b9fda 100%);
  box-shadow: 0 18px 38px rgba(15, 52, 96, 0.2);
}

.recruiter-report-hero::after {
  content: "";
  position: absolute;
  width: 320px;
  height: 320px;
  right: 12%;
  top: -210px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.recruiter-report-summary-grid {
  gap: 12px;
  margin-bottom: 20px;
}

.recruiter-summary-card {
  min-height: 88px;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(15, 52, 96, 0.08);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.recruiter-summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(15, 52, 96, 0.14);
}

.recruiter-breakdown-panel {
  border-radius: 20px;
  border-color: #d7e5f2;
  box-shadow: 0 14px 32px rgba(15, 52, 96, 0.08);
}

.recruiter-breakdown-header {
  padding: 20px 22px 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-bottom: 1px solid #e3edf6;
}

.recruiter-breakdown-table-wrap {
  margin: 0 12px 12px !important;
  border: 1px solid #dbe7f3;
  border-radius: 14px;
  overflow: auto;
  background: #fff;
}

.recruiter-breakdown-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f1f7fd;
  color: #234a73;
  border-bottom: 1px solid #cfe0ef;
}

.recruiter-breakdown-table tbody tr:nth-child(even) td {
  background: #fbfdff;
}

@media (max-width: 900px) {
  .recruiter-report-page {
    padding: 12px 10px 24px;
  }

  .recruiter-report-hero {
    border-radius: 18px;
  }

  .recruiter-breakdown-header {
    padding: 16px;
  }
}

@media (min-width: 901px) {
  .recruiter-report-hero {
    padding: 24px 28px !important;
  }
}

.recruiter-report-hero-orb {
  display: none;
}

.recruiter-report-hero .recruiter-report-filter-label {
  color: #dbeafe !important;
  font-size: 10px;
  letter-spacing: 0.08em;
}

.recruiter-report-hero .recruiter-report-filter-input,
.recruiter-report-hero .form-select {
  min-height: 40px;
  border-radius: 10px;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.recruiter-report-hero .recruiter-report-filter-reset {
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.78);
  color: #fff;
  transition: background 160ms ease, transform 160ms ease;
}

.recruiter-report-hero .recruiter-report-filter-reset:hover {
  background: rgba(15, 23, 42, 0.96);
  color: #fff;
  transform: translateY(-1px);
}

.recruiter-breakdown-header .form-control {
  min-height: 38px;
  border: 1px solid #d6e3ef;
  border-radius: 9px;
  color: #243b53;
  font-size: 13px;
  background: #fff;
}

.recruiter-breakdown-header .form-control:focus {
  border-color: #4b8bd8;
  box-shadow: 0 0 0 3px rgba(75, 139, 216, 0.14);
}

.recruiter-breakdown-header .btn {
  min-height: 38px;
  border-radius: 9px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-breakdown-table td {
  padding: 13px 16px;
  border-color: #e8f0f7;
}

.recruiter-table-name {
  font-weight: 700 !important;
  color: #174a7c;
}

@media (max-width: 640px) {
  .recruiter-report-hero {
    padding: 18px 16px !important;
  }

  .recruiter-report-hero > div:last-child {
    width: 100%;
    flex-wrap: wrap !important;
  }

  .recruiter-report-hero > div:last-child > div {
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }

  .recruiter-breakdown-table-wrap {
    margin: 0 8px 8px !important;
  }
}

/* KPI card finish */
.recruiter-summary-card {
  position: relative;
  min-height: 96px;
  padding: 16px 18px !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(20, 51, 84, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;
}

.recruiter-summary-card::before {
  content: "";
  position: absolute;
  width: 90px;
  height: 90px;
  right: -34px;
  bottom: -40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.46);
  pointer-events: none;
}

.recruiter-summary-card-inner {
  position: relative;
  z-index: 1;
  min-height: 64px;
  align-items: center !important;
}

.recruiter-summary-value {
  font-size: 28px !important;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1 !important;
}

.recruiter-summary-label {
  margin-top: 9px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.01em;
}

.recruiter-summary-accent {
  width: 44px !important;
  height: 44px !important;
  border-radius: 14px !important;
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.07);
}

@media (max-width: 640px) {
  .recruiter-summary-card {
    min-height: 86px;
    padding: 14px !important;
  }

  .recruiter-summary-value {
    font-size: 24px !important;
  }
}

/* Upload JD modal */
.upload-jd-modal {
  width: min(100% - 32px, 560px);
  max-width: 560px;
  margin: 0 auto;
}

.upload-jd-modal .modal-content {
  overflow: hidden;
  border: 1px solid #d8e6f3;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(15, 42, 72, 0.2);
}

.upload-jd-modal .modal-header {
  min-height: 62px;
  padding: 16px 20px !important;
  background: linear-gradient(135deg, #0f557f 0%, #1687c2 100%);
  border: 0 !important;
  color: #fff;
}

.upload-jd-modal .modal-header .modal-title {
  font-size: 19px;
  font-weight: 800;
}

.upload-jd-modal .modal-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.9;
}

.upload-jd-modal .modal-body {
  padding: 20px !important;
  background: #fbfdff;
}

.upload-jd-modal .upload-jd-dropzone {
  min-height: 172px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 24px !important;
  border: 1.5px dashed #9fbdd7 !important;
  border-radius: 12px !important;
  background: linear-gradient(180deg, #ffffff 0%, #f4f9fe 100%) !important;
  color: #334e68;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.upload-jd-modal .upload-jd-dropzone:hover {
  border-color: #2381bd !important;
  background: #f1f8ff !important;
  box-shadow: 0 8px 20px rgba(26, 95, 168, 0.08);
}

.upload-jd-modal .chooseFileSpan {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.upload-jd-modal .chooseFileSpan span {
  color: #126fba !important;
  font-weight: 800;
}

.upload-jd-modal .hintText {
  margin: 8px 0 0;
  color: #718096;
  font-size: 12.5px;
}

.upload-jd-modal .upload-jd-file {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px;
  margin-top: 12px !important;
  padding: 11px 13px !important;
  border: 1px solid #dbe8f4;
  border-radius: 9px !important;
  background: #fff !important;
  box-shadow: 0 4px 12px rgba(15, 42, 72, 0.05);
}

.upload-jd-modal .upload-jd-file > div:first-child {
  min-width: 0;
  flex: 1 1 auto;
}

.upload-jd-modal .upload-jd-file > div:first-child > div {
  min-width: 0;
}

.upload-jd-modal .upload-jd-file p:first-child {
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.upload-jd-modal .upload-jd-file > img,
.upload-jd-modal .upload-jd-file > div:last-child img {
  flex: 0 0 auto;
}

.upload-jd-modal .modal-footer {
  padding: 14px 20px 18px !important;
  background: #f7fbff;
  border-top: 1px solid #e0ebf5;
}

.upload-jd-modal .modal-footer .btn {
  min-width: 98px;
  min-height: 38px;
  border-radius: 8px;
  font-weight: 700;
}

.recruiter-table-email {
  max-width: 230px;
  margin-top: 4px;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recruiter-breakdown-table th:first-child,
.recruiter-breakdown-table td:first-child {
  min-width: 240px;
}

.recruiter-breakdown-table .btn.btn-link {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 0 !important;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: transparent;
  font-size: 0;
  cursor: pointer;
  text-decoration: none !important;
  opacity: 0;
}

.recruiter-breakdown-table .btn.btn-link::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 7px;
  width: 7px;
  height: 7px;
  border-top: 2px solid #4b7da7;
  border-right: 2px solid #4b7da7;
  transform: translateY(-50%) rotate(45deg);
  opacity: 0;
  transition: opacity 150ms ease, right 150ms ease;
}

.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link) {
  position: relative;
  min-height: 30px;
  cursor: pointer;
}

.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > span {
  filter: brightness(0.94);
  transform: scale(1.04);
}

.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > .btn.btn-link {
  opacity: 1;
}

.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > .btn.btn-link::after {
  right: 5px;
  opacity: 1;
}

.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link) > span {
  position: relative;
  z-index: 1;
  transition: filter 150ms ease, transform 150ms ease;
}

/* Detail modal: keep one scroll region for the records table */
.recruiter-detail-modal .modal-dialog {
  width: min(96vw, 1600px) !important;
  max-width: min(96vw, 1600px) !important;
  height: calc(100vh - 24px);
  margin: 12px auto;
}

.recruiter-detail-modal .modal-content {
  height: 100%;
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
}

.recruiter-detail-modal .modal-header {
  flex: 0 0 auto;
}

.recruiter-detail-modal .recruiter-detail-modal-body {
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
}

.recruiter-detail-modal .recruiter-detail-modal-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none !important;
  overflow: auto !important;
}

@media (max-width: 575px) {
  .recruiter-detail-modal .modal-dialog {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    height: calc(100vh - 16px);
    margin: 8px auto;
  }

  .recruiter-detail-modal .modal-content {
    max-height: calc(100vh - 16px);
  }
}
/* Ticket management */
.ticket-page{padding:24px;min-height:calc(100vh - 80px);background:#f5f8fc;color:#172b4d}.ticket-hero{display:flex;align-items:center;gap:16px;padding:24px 28px;background:linear-gradient(110deg,#0c4a6e,#126e88);border-radius:12px;color:#fff;box-shadow:0 10px 24px rgba(12,74,110,.16)}.ticket-hero-icon{width:52px;height:52px;display:grid;place-items:center;border-radius:12px;background:rgba(255,255,255,.15);font-size:24px}.ticket-kicker{font-size:11px;font-weight:700;letter-spacing:.08em;opacity:.8}.ticket-hero h1,.ticket-detail-header h1{margin:3px 0 4px;font-size:26px;font-weight:700}.ticket-hero p,.ticket-detail-header p{margin:0;color:rgba(255,255,255,.78)}.ticket-company{margin-left:auto;min-width:220px}.ticket-company label{display:block;font-size:11px;text-transform:uppercase;font-weight:700;margin-bottom:5px}.ticket-company .form-control{background:#fff}.ticket-raise{margin-left:4px;white-space:nowrap}.ticket-raise svg,.ticket-empty button svg{margin-right:7px}.ticket-status-strip{display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin:20px 0}.ticket-count{padding:15px 18px;background:#fff;border:1px solid #dce7f3;border-top:3px solid #2563eb;border-radius:10px;box-shadow:0 4px 12px rgba(23,43,77,.05)}.ticket-count span{display:block;color:#718096;font-size:12px}.ticket-count strong{display:block;margin-top:4px;font-size:24px}.ticket-count.in-progress{border-top-color:#f59e0b}.ticket-count.resolved{border-top-color:#10b981}.ticket-count.closed{border-top-color:#64748b}.ticket-filter-bar{display:grid;grid-template-columns:1.25fr repeat(4,1fr) .8fr .8fr;gap:10px;align-items:center;padding:14px 16px;background:#fff;border:1px solid #dce7f3;border-radius:10px;margin-bottom:16px}.ticket-filter-heading{display:flex;gap:8px;align-items:center;color:#0c4a6e}.ticket-filter-bar .form-control{min-width:0}.ticket-list-panel,.ticket-panel{background:#fff;border:1px solid #dce7f3;border-radius:12px;box-shadow:0 4px 16px rgba(23,43,77,.05)}.ticket-list-heading{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #e5edf6}.ticket-list-heading h2{margin:0;font-size:18px}.ticket-list-heading span{color:#718096;font-size:12px}.ticket-heading-icon{color:#7b8ea8}.ticket-table-wrap{overflow:auto}.ticket-table{width:100%;border-collapse:collapse;min-width:900px}.ticket-table th{padding:12px 16px;background:#f7fafd;color:#5c6f89;font-size:11px;text-transform:uppercase;letter-spacing:.03em;text-align:left;white-space:nowrap}.ticket-table td{padding:15px 16px;border-top:1px solid #edf2f7;font-size:13px;vertical-align:middle}.ticket-table tbody tr{cursor:pointer;transition:background .15s}.ticket-table tbody tr:hover{background:#f7fbff}.ticket-table td strong{display:block}.ticket-table td small{color:#8291a7}.ticket-number-link{border:0;background:none;color:#1264c4;font-weight:700;padding:0;cursor:pointer}.ticket-module-pill,.ticket-priority,.ticket-status{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600}.ticket-module-pill{padding:5px 9px;border-radius:6px;background:#eef5ff;color:#2864a7}.ticket-priority{padding:4px 9px;border-radius:20px;background:#f1f5f9;color:#475569}.priority-low{background:#ecfdf5;color:#047857}.priority-medium{background:#eff6ff;color:#2563eb}.priority-high{background:#fff7ed;color:#c2410c}.priority-urgent{background:#fff1f2;color:#be123c}.ticket-status svg{font-size:11px}.status-open{color:#2563eb}.status-in-progress{color:#d97706}.status-resolved{color:#059669}.status-closed{color:#64748b}.ticket-loading,.ticket-empty{padding:70px 20px;text-align:center;color:#718096}.ticket-empty svg{font-size:28px;color:#8aa2be}.ticket-empty h3{margin:12px 0 5px;color:#334155}.ticket-empty p{margin-bottom:18px}.ticket-detail-header{display:flex;align-items:flex-start;gap:18px;margin-bottom:18px;padding:18px 0}.ticket-detail-header .ticket-back{padding:4px 0;color:#1264c4;white-space:nowrap}.ticket-detail-header p{color:#718096}.ticket-detail-grid{display:grid;grid-template-columns:minmax(0,1.2fr) minmax(320px,1fr);gap:16px}.ticket-panel{padding:22px}.ticket-description{grid-row:span 2}.ticket-panel-title{display:flex;align-items:center;gap:8px;margin-bottom:16px;font-weight:700;color:#0c4a6e}.ticket-description>p{line-height:1.7;color:#4a5c73;white-space:pre-wrap}.ticket-meta-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding-top:18px;margin-top:20px;border-top:1px solid #e5edf6}.ticket-meta-grid small{display:block;color:#8291a7;font-size:11px;margin-bottom:5px}.ticket-meta-grid strong{font-size:13px}.ticket-comments{max-height:340px;overflow:auto}.ticket-comment{display:flex;gap:10px;padding:12px 0;border-bottom:1px solid #edf2f7}.ticket-comment-avatar{width:30px;height:30px;display:grid;place-items:center;flex:0 0 30px;border-radius:50%;background:#e8f1fb;color:#1767ae;font-size:12px}.ticket-comment strong{font-size:13px}.ticket-comment small{margin-left:8px;color:#94a3b8;font-size:11px}.ticket-comment p{margin:5px 0 0;color:#52667f;white-space:pre-wrap}.ticket-empty-inline,.ticket-muted{padding:25px 0;color:#8795a8;text-align:center;font-size:13px}.ticket-comment-form{display:flex;gap:10px;align-items:flex-end;margin-top:16px}.ticket-comment-form .form-control{flex:1 1}.ticket-admin-controls{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;align-self:start}.ticket-admin-controls .ticket-panel-title{grid-column:1/-1;margin-bottom:0}.ticket-admin-controls label,.ticket-create-modal label{display:block;font-size:12px;font-weight:600;color:#53657d}.ticket-admin-controls .form-control,.ticket-create-modal .form-control{margin-top:6px;font-weight:400}.ticket-create-modal .modal-header{background:#0c6284;color:#fff}.ticket-create-modal .modal-header .close{color:#fff;opacity:1}.ticket-create-modal .modal-body{display:grid;gap:15px}.ticket-create-modal .modal-footer{border-top:1px solid #e5edf6}.ticket-create-modal .alert{margin:0}.ticket-back svg{margin-right:6px}@media(max-width:1100px){.ticket-filter-bar{grid-template-columns:repeat(3,1fr)}.ticket-filter-heading{grid-column:1/-1}.ticket-company{min-width:180px}}@media(max-width:760px){.ticket-page{padding:14px}.ticket-hero{align-items:flex-start;flex-wrap:wrap;padding:18px}.ticket-company{width:100%;margin-left:68px}.ticket-raise{margin-left:auto}.ticket-status-strip{grid-template-columns:repeat(2,1fr)}.ticket-filter-bar{grid-template-columns:1fr 1fr}.ticket-detail-grid{grid-template-columns:1fr}.ticket-description{grid-row:auto}.ticket-admin-controls{grid-template-columns:1fr}.ticket-detail-header{flex-direction:column;gap:6px}.ticket-detail-header h1{font-size:22px}}
.ticket-page { margin-top: 70px; }
.ticket-upload-area{display:flex;flex-direction:column;align-items:center;gap:6px;padding:22px 16px;border:1.5px dashed #9bb8d5;border-radius:10px;background:#f8fbff;color:#7186a0;text-align:center;transition:.15s}.ticket-upload-area.is-dragging{border-color:#1475c9;background:#edf7ff;box-shadow:0 0 0 3px rgba(20,117,201,.1)}.ticket-upload-area>svg{font-size:28px;color:#1874bb;margin-bottom:3px}.ticket-upload-area strong{color:#28445f;font-size:14px}.ticket-upload-area span{font-size:12px}.ticket-upload-area small{font-size:11px}.ticket-browse-button{display:inline-flex!important;align-items:center;justify-content:center;margin:2px 0 3px;padding:7px 13px;background:#1264a0;border-radius:6px;color:#fff!important;font-size:12px!important;font-weight:600!important;cursor:pointer}.ticket-browse-button input{display:none}.ticket-selected-files{display:grid;gap:8px;padding:12px;border:1px solid #e0e9f3;border-radius:8px;background:#fbfdff}.ticket-selected-files-heading{display:flex;justify-content:space-between;color:#4d6580;font-size:12px}.ticket-selected-files-heading span{color:#8797aa}.ticket-selected-file{display:flex;align-items:center;gap:10px;padding:8px 10px;background:#fff;border:1px solid #e5edf5;border-radius:7px;min-width:0}.ticket-selected-file img{width:38px;height:38px;object-fit:cover;border-radius:5px}.ticket-selected-file-icon{width:38px;height:38px;padding:10px;color:#2274b5;background:#edf5fd;border-radius:5px}.ticket-selected-file>div{min-width:0;flex:1 1}.ticket-selected-file strong,.ticket-selected-file small{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-selected-file strong{font-size:12px;color:#304a66}.ticket-selected-file small{margin-top:3px;color:#8b9aad;font-size:10px}.ticket-selected-file button,.ticket-attachment-delete,.ticket-attachment-download{border:0;background:none;color:#7890aa;cursor:pointer;padding:5px}.ticket-selected-file button:hover,.ticket-attachment-delete:hover{color:#d03e50}.ticket-upload-progress{position:relative;height:25px;overflow:hidden;border-radius:5px;background:#e7eff8;color:#456783}.ticket-upload-progress span{position:absolute;inset:0 auto 0 0;background:#2184c7;transition:width .2s}.ticket-upload-progress small{position:relative;z-index:1;display:block;padding:5px 8px;font-size:10px}.ticket-attachments-panel{grid-column:2}.ticket-attachment-list{display:grid;gap:8px}.ticket-attachment-item{display:flex;align-items:center;gap:10px;padding:8px;border:1px solid #e5edf5;border-radius:7px;min-width:0}.ticket-attachment-preview{width:42px;height:42px;padding:0;border:0;border-radius:5px;overflow:hidden;background:#edf5fd;cursor:pointer;flex:0 0 42px}.ticket-attachment-preview img{width:100%;height:100%;object-fit:cover}.ticket-attachment-file-icon{width:42px;height:42px;display:grid;place-items:center;flex:0 0 42px;border-radius:5px;background:#edf5fd;color:#2375b5;font-size:18px}.ticket-attachment-info{min-width:0;flex:1 1}.ticket-attachment-info strong,.ticket-attachment-info small{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-attachment-info strong{font-size:12px;color:#304a66}.ticket-attachment-info small{margin-top:3px;color:#8999ab;font-size:10px}.ticket-attachment-download{color:#2274b5}.ticket-attachment-download:hover{color:#0d4e83}.ticket-image-preview-modal .modal-body{display:flex;justify-content:center;padding:12px;background:#f5f8fc}.ticket-image-preview{display:block;max-width:100%;max-height:70vh;object-fit:contain;border-radius:5px}.ticket-image-preview-modal .modal-header{padding:12px 16px}.ticket-image-preview-modal .modal-title{font-size:14px}@media(max-width:760px){.ticket-attachments-panel{grid-column:auto}}
.ticket-create-modal .modal-dialog{max-width:720px;width:calc(100% - 28px)}.ticket-create-modal .modal-content{max-height:90vh;overflow:hidden}.ticket-create-modal .modal-body{max-height:calc(90vh - 138px);overflow-y:auto}.ticket-selected-files{grid-template-columns:repeat(2,minmax(0,1fr));max-height:245px;overflow-y:auto}.ticket-selected-files-heading{grid-column:1/-1}.ticket-selected-file{min-width:0;display:grid;grid-template-columns:48px minmax(0,1fr) auto;align-items:center}.ticket-selected-file img,.ticket-selected-file-icon{width:48px;height:48px}.ticket-selected-file strong{font-size:11px}.ticket-selected-file small{font-size:9px}@media(max-width:620px){.ticket-create-modal .modal-dialog{width:calc(100% - 16px);margin:8px auto}.ticket-selected-files{grid-template-columns:1fr}}
.ticket-create-modal .modal-footer{justify-content:center;gap:10px}
.ticket-table th,.ticket-table td{border-right:1px solid #e5edf5}.ticket-table th:last-child,.ticket-table td:last-child{border-right:0}.ticket-table thead th{border-top:1px solid #d9e5f1;border-bottom:1px solid #d9e5f1}.ticket-table tbody tr:last-child td{border-bottom:1px solid #e5edf5}
.ticket-detail-header{display:grid;grid-template-columns:auto 48px minmax(0,1fr) auto;align-items:center;gap:16px;margin-bottom:18px;padding:20px 24px;background:#fff;border:1px solid #dce7f3;border-radius:12px;box-shadow:0 5px 16px rgba(23,43,77,.05)}.ticket-detail-heading-icon{width:48px;height:48px;display:grid;place-items:center;border-radius:12px;background:#eaf4ff;color:#1768ad;font-size:20px}.ticket-detail-heading-content{min-width:0}.ticket-detail-reference-row{display:flex;align-items:center;gap:9px;margin-bottom:4px}.ticket-detail-reference-row .ticket-module-pill{font-size:10px;padding:3px 7px}.ticket-detail-heading-content h1{margin:0 0 4px;color:#172b4d;font-size:22px;line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-detail-heading-content p{margin:0;color:#7890aa;font-size:12px}.ticket-detail-header-status{display:flex;align-items:center;gap:10px}.ticket-detail-header-status .ticket-status,.ticket-detail-header-status .ticket-priority{white-space:nowrap}.ticket-detail-header .ticket-back{padding:4px 0}@media(max-width:760px){.ticket-detail-header{grid-template-columns:auto 42px minmax(0,1fr);gap:10px;padding:16px}.ticket-detail-heading-icon{width:42px;height:42px}.ticket-detail-header-status{grid-column:2/-1}.ticket-detail-heading-content h1{font-size:19px}.ticket-detail-header .ticket-back{grid-column:1/-1}.ticket-detail-header .ticket-back svg{margin-right:4px}}
.ticket-detail-header{position:relative;overflow:hidden;grid-template-columns:auto 52px minmax(0,1fr) auto;padding:22px 26px;background:linear-gradient(115deg,#103f70 0%,#126b86 58%,#128b82 100%);border:0;color:#fff;box-shadow:0 12px 28px rgba(16,63,112,.2)}.ticket-detail-header:after{content:"";position:absolute;right:12%;top:-90px;width:240px;height:240px;border:1px solid rgba(255,255,255,.12);border-radius:50%;box-shadow:0 0 0 28px rgba(255,255,255,.035),0 0 0 56px rgba(255,255,255,.025);pointer-events:none}.ticket-detail-header>*{position:relative;z-index:1}.ticket-detail-header .ticket-back{color:#fff;text-decoration:none;font-weight:600}.ticket-detail-header .ticket-back:hover{color:#d9f4ff}.ticket-detail-heading-icon{width:52px;height:52px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.14);color:#fff}.ticket-detail-reference-row{margin-bottom:6px}.ticket-detail-header .ticket-kicker{color:rgba(255,255,255,.82);letter-spacing:.1em}.ticket-detail-header .ticket-module-pill{background:rgba(255,255,255,.16);color:#fff;border:1px solid rgba(255,255,255,.18)}.ticket-detail-heading-content h1{color:#fff;font-size:25px;letter-spacing:0}.ticket-detail-heading-content p{color:rgba(255,255,255,.72)}.ticket-detail-header-status{padding-left:14px}.ticket-detail-header-status .ticket-status{padding:7px 11px;border-radius:20px;background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.2)}.ticket-detail-header-status .ticket-priority{padding:7px 11px}.ticket-detail-header .ticket-back svg{color:#a9e2ff}@media(max-width:760px){.ticket-detail-header{grid-template-columns:auto 44px minmax(0,1fr);padding:18px}.ticket-detail-heading-icon{width:44px;height:44px}.ticket-detail-heading-content h1{font-size:21px}.ticket-detail-header-status{padding-left:0}}
.ticket-resolution-panel{grid-column:2;background:#fafdff;border-color:#cfe3f3}.ticket-resolution-copy{margin:-6px 0 14px;color:#647b93;font-size:13px}.ticket-resolution-options{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px}.ticket-resolution-option{padding:8px 12px;border:1px solid #c8d8e8;border-radius:7px;background:#fff;color:#3d5871;font-size:12px;font-weight:600;cursor:pointer;transition:.15s}.ticket-resolution-option:hover{border-color:#2180c4;color:#1768a5}.ticket-resolution-option.is-selected{border-color:#1475c9;background:#eaf5ff;color:#1165a4;box-shadow:0 0 0 2px rgba(20,117,201,.1)}.ticket-resolution-panel textarea{margin-bottom:10px}.ticket-resolution-panel .btn{font-size:12px}@media(max-width:760px){.ticket-resolution-panel{grid-column:auto}}
.ticket-feedback-badge{display:inline-flex;align-items:center;padding:5px 9px;border-radius:999px;font-size:11px;font-weight:700;white-space:nowrap}.feedback-completed{background:#e9f9f0;color:#087443}.feedback-pending{background:#fff6df;color:#a66500}.feedback-not_completed{background:#fff0f1;color:#bb3047}.ticket-feedback-summary{margin:0 0 14px;padding:11px 12px;border:1px solid #dce8f2;border-radius:8px;background:#fff}.ticket-feedback-summary p{margin:8px 0 3px;color:#4d637b;font-size:13px;white-space:pre-wrap}.ticket-feedback-summary small{color:#8b9bad;font-size:10px}.ticket-resolution-option:disabled{cursor:not-allowed;opacity:.58}.ticket-count-cell{display:inline-flex;align-items:center;gap:5px;color:#607893;font-size:12px}.ticket-count-cell svg{color:#6e99bc;font-size:11px}.ticket-muted-cell{color:#a0adbb}.ticket-table{min-width:1200px}.ticket-filter-bar{grid-template-columns:1.1fr repeat(5,1fr) .8fr .8fr}.ticket-meta-grid{grid-template-columns:repeat(3,minmax(0,1fr))}@media(max-width:1100px){.ticket-filter-bar{grid-template-columns:repeat(3,1fr)}}
.ticket-attachment-item.is-clickable{cursor:pointer}.ticket-attachment-item.is-clickable:hover{border-color:#70a9d4;background:#f7fbff;box-shadow:0 2px 8px rgba(20,117,201,.08)}.ticket-attachment-item.is-clickable:focus{outline:2px solid #2184c7;outline-offset:1px}
.ticket-admin-controls {
  display: block;
  padding: 20px;
  border: 1px solid #d9e6f2;
  border-top: 3px solid #126e88;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.ticket-admin-controls-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 15px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e5edf6;
}

.ticket-admin-controls-heading .ticket-panel-title {
  margin: 0;
  font-size: 15px;
}

.ticket-admin-controls-heading p {
  margin: 2px 0 0;
  color: #8191a7;
  font-size: 12px;
  text-align: right;
}

.ticket-admin-control-field {
  display: block;
  color: #53657d;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.ticket-admin-control-field + .ticket-admin-control-field {
  margin-top: 14px;
}

.ticket-admin-control-field .form-control {
  height: 42px;
  margin-top: 7px;
  border: 1px solid #c9d9e8;
  border-radius: 8px;
  background: #fff;
  color: #172b4d;
  font-size: 14px;
  box-shadow: 0 2px 5px rgba(23, 43, 77, .04);
}

.ticket-admin-control-field .form-control:focus {
  border-color: #2583c5;
  box-shadow: 0 0 0 3px rgba(37, 131, 197, .13);
}

@media (min-width: 761px) {
  .ticket-admin-controls {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 14px;
  }

  .ticket-admin-controls-heading {
    grid-column: 1 / -1;
  }

  .ticket-admin-control-field + .ticket-admin-control-field {
    margin-top: 0;
  }
}

@media (max-width: 760px) {
  .ticket-admin-controls-heading {
    display: block;
  }

  .ticket-admin-controls-heading p {
    margin-top: 5px;
    text-align: left;
  }
}

@media (min-width: 761px) {
  .ticket-status-strip {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .ticket-detail-grid {
    align-items: start;
    grid-template-areas:
      "description attachments"
      "conversation resolution"
      "conversation admin";
  }

  .ticket-description {
    grid-area: description;
    grid-row: auto;
  }

  .ticket-attachments-panel {
    grid-area: attachments;
    height: auto;
    overflow-y: visible;
  }

  .ticket-conversation-panel {
    grid-area: conversation;
    height: 390px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ticket-conversation-panel .ticket-comments {
    flex: 1 1;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
  }

  .ticket-resolution-panel {
    grid-area: resolution;
  }

  .ticket-admin-controls {
    grid-area: admin;
  }
}

@media (max-width: 760px) {
  .ticket-detail-grid {
    grid-template-areas: none;
  }

  .ticket-attachments-panel,
  .ticket-conversation-panel {
    height: auto;
    max-height: 360px;
  }

  .ticket-conversation-panel {
    display: block;
  }

  .ticket-conversation-panel .ticket-comments {
    max-height: 250px;
  }
}

.ticket-count-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin: 0 auto;
}

.modal-dialog.ticket-image-preview-modal {
  width: calc(100vw - 48px);
  max-width: 1100px;
  margin: 24px auto;
}

.ticket-image-preview-modal .modal-content {
  overflow: hidden;
}

.ticket-image-preview-modal .modal-body {
  min-height: 180px;
  max-height: calc(100vh - 130px);
}

@media (max-width: 1100px) and (min-width: 761px) {
  .ticket-status-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.modal-dialog.ticket-create-modal {
  width: calc(100vw - 48px);
  max-width: 820px;
  margin: 24px auto;
}

.ticket-create-modal .modal-content {
  border: 0;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(15, 39, 66, .25);
}

.ticket-create-modal .modal-header {
  padding: 20px 24px;
  border: 0;
  background: linear-gradient(115deg, #0d5879, #147e96);
}

.ticket-create-modal .modal-title {
  font-size: 20px;
  font-weight: 700;
}

.ticket-create-modal .modal-body {
  padding: 24px;
}

.ticket-create-modal .modal-footer {
  padding: 16px 24px;
  background: #f8fbfe;
}

.ticket-hero-actions {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-left: auto;
}

.ticket-company:empty {
  display: none;
}

.ticket-hero-actions .ticket-refresh,
.ticket-hero-actions .ticket-raise {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 40px;
  margin-left: 0;
  white-space: nowrap;
}

.ticket-hero-actions .ticket-refresh {
  width: 40px;
  justify-content: center;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, .28);
  background: rgba(255, 255, 255, .12);
  color: #fff;
}

.ticket-hero-actions .ticket-refresh:hover:not(:disabled) {
  background: rgba(255, 255, 255, .2);
  color: #fff;
}

.ticket-hero-actions .ticket-refresh:disabled {
  opacity: .7;
}

.ticket-hero-actions .is-spinning {
  animation: ticket-refresh-spin .8s linear infinite;
}

@keyframes ticket-refresh-spin {
  to { transform: rotate(360deg); }
}

@media (min-width: 761px) {
  .ticket-create-modal .modal-body {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 18px;
    align-items: start;
  }

  .ticket-create-modal .modal-body > label:nth-child(3),
  .ticket-create-modal .ticket-create-priority-field,
  .ticket-create-modal .ticket-upload-area,
  .ticket-create-modal .ticket-selected-files,
  .ticket-create-modal .ticket-upload-progress,
  .ticket-create-modal .alert {
    grid-column: 1 / -1;
  }

  .ticket-create-modal .ticket-create-priority-field .form-control {
    width: 100%;
  }
}

@media (max-width: 760px) {
  .ticket-hero-actions {
    width: 100%;
    margin-left: 68px;
  }

  .modal-dialog.ticket-create-modal {
    width: calc(100vw - 20px);
    margin: 10px auto;
  }
}

.ticket-description-cell {
  display: block;
  max-width: 220px;
  overflow: hidden;
  color: #52667f;
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-search-filter-bar {
  grid-template-columns: 1.1fr repeat(4, minmax(0, 1fr)) .9fr;
}

.ticket-search-filter-bar .btn {
  min-height: 38px;
  white-space: nowrap;
}

.ticket-sort-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  text-transform: inherit;
  letter-spacing: inherit;
  cursor: pointer;
}

.ticket-sort-button svg {
  color: #8aa1b8;
  font-size: 10px;
}

.ticket-sort-button:hover,
.ticket-sort-button:focus-visible {
  color: #1264a0;
}

.ticket-sort-button:focus-visible {
  outline: 2px solid #5ea8d7;
  outline-offset: 3px;
  border-radius: 3px;
}

.ticket-feedback-summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 8px 10px;
  padding: 12px 14px;
  border: 1px solid #d5e5f2;
  border-left: 3px solid #16a06d;
  border-radius: 10px;
  background: #f8fcff;
}

.ticket-feedback-summary p {
  grid-column: 1 / -1;
  margin: 0;
  padding-top: 8px;
  border-top: 1px solid #e3edf5;
  color: #36536e;
  font-size: 13px;
  line-height: 1.45;
}

.ticket-feedback-summary small {
  justify-self: end;
  color: #8799aa;
  font-size: 10px;
}

.ticket-resolution-owner {
  margin-left: auto;
  padding: 4px 8px;
  border: 1px solid #cfe3f1;
  border-radius: 999px;
  color: #6e879e;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
}

@media (min-width: 761px) {
  .ticket-detail-heading-content {
    display: block;
  }

  .ticket-detail-reference-row {
    margin-bottom: 6px;
  }

  .ticket-detail-heading-content h1 {
    display: block;
    margin: 0;
  }

  .ticket-detail-heading-content p {
    display: block;
    margin: 4px 0 0;
  }
}

@media (max-width: 760px) {
  .ticket-detail-heading-content {
    display: block;
  }
}

.ticket-empty {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: radial-gradient(circle at 50% 30%, #f7fbff 0, #fff 52%);
}

.ticket-empty-icon {
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  margin-bottom: 14px;
  border: 1px solid #cfe2f2;
  border-radius: 16px;
  background: #edf6fd;
  color: #4b86b4;
  font-size: 24px;
  box-shadow: 0 8px 18px rgba(47, 105, 150, .1);
}

.ticket-empty-kicker {
  color: #7890aa;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .12em;
}

.ticket-empty h3 {
  margin: 8px 0 5px;
  color: #183b5d;
  font-size: 23px;
}

.ticket-empty p {
  max-width: 420px;
  margin: 0 0 20px;
  color: #7186a0;
  font-size: 13px;
  text-align: center;
}

.ticket-empty .btn {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 6px 14px rgba(22, 100, 164, .16);
}

.ticket-page {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.ticket-detail-grid,
.ticket-panel {
  min-width: 0;
}

.ticket-table-wrap {
  overflow-x: hidden;
}

.ticket-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
}

.ticket-table th,
.ticket-table td {
  overflow-wrap: anywhere;
  white-space: normal;
}

.ticket-table th {
  vertical-align: middle;
}

.ticket-table .ticket-sort-button {
  max-width: 100%;
  white-space: normal;
}

/* Keep New Mail full-screen after all email-module style bundles load. */
.em-compose-overlay.em-compose-fullscreen {
  inset: 0;
  top: 0;
  left: 0;
  transform: none;
  width: 100vw;
  max-width: none;
  height: 100vh;
  max-height: none;
  border: 0;
  border-radius: 0;
  z-index: 11000;
}

.em-compose-overlay.em-compose-fullscreen .em-compose-body {
  flex: 1 1;
  max-height: none;
  min-height: 0;
}

.em-folder-modal-overlay {
  align-items: center;
  padding-top: 0;
}

.em-folder-modal-overlay .em-cal-modal {
  width: min(460px, calc(100vw - 32px));
  max-width: none;
  align-self: center;
}

.em-folder-context-menu {
  width: 220px;
  padding: 5px 0;
  background: #fff;
  border: 1px solid #cfd8e3;
  border-radius: 3px;
  box-shadow: 0 8px 22px rgba(15, 35, 55, 0.22);
}

.em-folder-context-menu .em-context-menu-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  min-height: 30px;
  padding: 5px 10px;
  border: 0;
  background: transparent;
  color: #263746;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
}

.em-folder-context-menu .em-context-menu-item:hover:not(:disabled) {
  background: #eaf3fb;
  color: #075b93;
}

.em-folder-context-menu .em-context-menu-item:disabled {
  color: #9aa6b2;
  cursor: not-allowed;
}

.em-folder-context-menu .em-context-menu-divider {
  height: 1px;
  margin: 4px 0;
  background: #e2e7ec;
}

.em-folder-properties {
  width: min(520px, calc(100vw - 32px));
}

.em-folder-property-row {
  display: grid;
  grid-template-columns: minmax(120px, 0.7fr) minmax(0, 1.3fr);
  gap: 16px;
  padding: 9px 0;
  border-bottom: 1px solid #e8edf2;
  color: #68798b;
  font-size: 12px;
}

.em-folder-property-row:last-child {
  border-bottom: 0;
}

.em-folder-property-row strong {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #1f3447;
  font-weight: 500;
}

.job-round-config-summary {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  padding: 12px 16px;
  border: 1px solid #d7e3ec;
  border-top: 0;
  background: #f7fafc;
  color: #35536d;
  font-size: 13px;
}

.job-round-config-summary span {
  white-space: nowrap;
}

.job-round-config-summary strong {
  color: #173d5c;
}

/* Compact Outlook-style compose window. */
.em-compose-overlay {
  width: min(600px, calc(100vw - 32px));
  max-width: none;
  max-height: min(78vh, 640px);
  border: 1px solid #d7e0ea;
  border-radius: 9px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 35, 55, 0.28), 0 2px 8px rgba(15, 35, 55, 0.12);
}

.em-compose-header {
  min-height: 44px;
  padding: 8px 12px;
  background: #0864a2;
  border-radius: 0;
}

.em-compose-header h3 {
  font-size: 14px;
  font-weight: 600;
}

.em-compose-header-btn {
  width: 26px;
  height: 26px;
}

.em-compose-body {
  max-height: min(520px, calc(78vh - 100px));
  overflow-y: auto;
  background: #fff;
}

.em-compose-field {
  min-height: 40px;
  padding: 0 10px;
  border-bottom: 1px solid #e5ebf1;
}

.em-compose-field-label {
  width: 40px;
  padding: 10px 0;
  color: #526579;
  font-size: 12px;
}

.em-compose-tag-container {
  min-height: 40px;
  padding: 5px 0;
  gap: 5px;
}

.em-compose-tag {
  max-width: 100%;
  padding: 5px 8px;
  border: 1px solid #b9d5eb;
  border-radius: 5px;
  background: #f3f8fc;
  color: #174c75;
  font-size: 12px;
}

.em-compose-tag-input,
.em-compose-subject-field input {
  min-height: 28px;
  font-size: 13px;
}

.em-compose-toggle-cc {
  padding: 4px 7px;
  border: 1px solid #9aaaba;
  background: #f8fafc;
  color: #1261a0;
  font-size: 12px;
  cursor: pointer;
}

.em-compose-toolbar {
  min-height: 36px;
  padding: 4px 10px;
  border-bottom: 1px solid #e5ebf1;
  background: #f8fafc;
}

.em-compose-tool-btn {
  width: 28px;
  height: 28px;
  color: #526579;
}

.em-compose-editor {
  min-height: 260px;
  padding: 0;
  background: #fff;
}

.em-compose-editor textarea {
  min-height: 260px;
  padding: 14px 12px;
  color: #1c2d3d;
  font-size: 13px;
  line-height: 1.55;
  resize: vertical;
}

.em-compose-footer {
  min-height: 54px;
  padding: 9px 12px;
  border-top: 1px solid #dfe7ef;
  background: #fff;
}

.em-compose-send-btn {
  min-height: 36px;
  padding: 8px 16px;
  border-radius: 4px;
  background: #0864a2;
  font-size: 13px;
}

.em-compose-attach-btn,
.em-compose-trash-btn {
  width: 34px;
  height: 34px;
  color: #526579;
}

@media (max-width: 640px) {
  .em-compose-overlay {
    width: calc(100vw - 16px);
    max-height: calc(100vh - 24px);
  }

  .em-compose-body {
    max-height: calc(100vh - 110px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;AAEH;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,8CAA8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,0BAA0B;;EAE1B,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,kEAAkE;EAClE,6CAA6C;EAC7C,gEAAgE;EAChE,+DAA+D;EAC/D;;;;GAIC;EACD;;;;GAIC;EACD,6DAA6D;EAC7D,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uGAAuG;AACzG;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,6DAA6D;EAC7D,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oDAAoD;AACtD;AACA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kDAAkD;EAClD,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,4EAA4E;AAC9E;AACA;;EAEE,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0CAA0C;EAC1C,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE;;IAEE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;AACA;;;;;GAKG;;AAEH;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C;kCACgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kFAAkF;AAClF,kFAAkF;AAClF;;;;;;;;;;;EAWE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;EAcE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;AACH,wBAAwB;;AAExB;;;;;;GAMG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;;GAIG;AACH;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;;EAEE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,sDAAsD;EACtD,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;uCACuC,UAAU,EAAE;AACnD;uCACuC,UAAU,EAAE;AACnD;uCACuC,SAAS,EAAE;AAClD;uCACuC,UAAU,EAAE;AACnD;uCACuC,UAAU,EAAE;AACnD;uCACuC,UAAU,EAAE;AACnD;uCACuC,UAAU,EAAE;AACnD;uCACuC,SAAS,EAAE;AAClD;uCACuC,SAAS,EAAE;;AAElD;;EAEE,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,UAAU,EAAE;AACtD;0CAC0C,SAAS,EAAE;AACrD;0CAC0C,UAAU,EAAE;;AAEtD;;EAEE,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qEAAqE;EACrE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC;EACpC,oEAA4P;EAC5P,uCAAuC;EACvC,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oEAA4P;EAC5P,uCAAuC;EACvC,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;EACrC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA,6BAA6B,YAAY,EAAE,eAAe,EAAE;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA,qCAAqC,gBAAgB,EAAE,eAAe,EAAE;AACxE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2DAA2D;EAC3D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,2CAA2C;EAC3C,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,sDAAsD;EACtD,6BAA6B;EAC7B,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;;IAEE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kDAAkD;EAClD,gDAAgD;EAChD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;EAIE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,6CAA6C;EAC7C,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;IAClC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;;;EAGE,uBAAuB;AACzB;;AAEA,0CAA0C,mBAAmB,EAAE,mBAAmB,EAAE;AACpF,0BAA0B,aAAa,EAAE;AACzC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,6DAA6D;AAC/D;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA,+BAA+B,SAAS,EAAE,WAAW,EAAE;AACvD,+BAA+B,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC9E;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA,0BAA0B,WAAW,EAAE,eAAe,EAAE,cAAc,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzI,yBAAyB,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC1F,8CAA8C,iBAAiB,EAAE,qBAAqB,EAAE,oBAAoB,EAAE,oBAAoB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;AACjN,yBAAyB,8BAA8B,EAAE;AACzD,sBAAsB,wCAAwC,EAAE;AAChE,qCAAqC,8BAA8B,EAAE;AACrE,0DAA0D,kBAAkB,EAAE,+BAA+B,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE;AAChO,gFAAgF,eAAe,EAAE;AACjG,+BAA+B,0BAA0B,EAAE,4BAA4B,EAAE;AACzF,mCAAmC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC/E,qCAAqC,WAAW,EAAE;AAClD,0BAA0B,aAAa,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAChK,iCAAiC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpF,gCAAgC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnF,8BAA8B,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACzH,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;AAC7E,qCAAqC,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,2CAA2C,EAAE;AAC7K,2BAA2B,6BAA6B,EAAE,4BAA4B,EAAE,0BAA0B,EAAE;AACpH,0CAA0C,wBAAwB,EAAE,gCAAgC,EAAE,6BAA6B,EAAE,uBAAuB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAChN,4CAA4C,cAAc,EAAE,WAAW,EAAE,WAAW,EAAE,sCAAsC,EAAE;AAC9H,iCAAiC,eAAe,EAAE;AAClD,2CAA2C,cAAc,EAAE,WAAW,EAAE,0BAA0B,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,6BAA6B,EAAE;AAC7L,oDAAoD,yBAAyB,EAAE,8BAA8B,EAAE,qBAAqB,EAAE;AACtI,wDAAwD,yBAAyB,EAAE,8BAA8B,EAAE,qBAAqB,EAAE;AAC1I,oDAAoD,yBAAyB,EAAE,8BAA8B,EAAE,qBAAqB,EAAE;AACtI,8BAA8B,mBAAmB,EAAE,WAAW,EAAE,sBAAsB,EAAE,WAAW,EAAE,eAAe,EAAE;AACtH,qCAAqC,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACpG,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACpH,0BAA0B,eAAe,EAAE,cAAc,EAAE;AAC3D,6BAA6B,eAAe,EAAE,gBAAgB,EAAE;AAChE,6BAA6B,eAAe,EAAE,gBAAgB,EAAE;AAChE,2BAA2B,0BAA0B,EAAE,kCAAkC,EAAE,eAAe,EAAE;AAC5G,mBAAmB,mBAAmB,EAAE,YAAY,EAAE,eAAe,EAAE;AACvE,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AAC1I,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAClI,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,wCAAwC,mBAAmB,EAAE,cAAc,EAAE;AAC7E,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,gDAAgD,oBAAoB,EAAE,6BAA6B,EAAE,6BAA6B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC3K,gCAAgC,8BAA8B,EAAE,gCAAgC,EAAE,yBAAyB,EAAE;AAC7H,4CAA4C,8BAA8B,EAAE,gBAAgB,EAAE;AAC9F,wCAAwC,kCAAkC,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/H,yCAAyC,kCAAkC,EAAE,kBAAkB,EAAE;AACjG,qDAAqD,kCAAkC,EAAE;AACzF,iEAAiE,YAAY,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,UAAU,EAAE,SAAS,EAAE;AACrK,uEAAuE,WAAW,EAAE,SAAS,EAAE,cAAc,EAAE;AAC/G,uEAAuE,SAAS,EAAE,gBAAgB,EAAE;AACpG,wDAAwD,mBAAmB,EAAE;AAC7E,uDAAuD,kBAAkB,EAAE,YAAY,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACvK,iDAAiD,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AACnG,sBAAsB,uBAAuB,EAAE;AAC/C,qCAAqC,kBAAkB,EAAE;AACzD,wCAAwC,kBAAkB,EAAE,gBAAgB,EAAE;AAC9E,6CAA6C,WAAW,EAAE,YAAY,EAAE;AACxE,4BAA4B,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAC5H,gDAAgD,aAAa,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,QAAQ,EAAE,YAAY,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACzL,gDAAgD,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE,eAAe,EAAE;AAChN,+BAA+B,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC7H,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9Q,4BAA4B,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AAC7E,6BAA6B,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,UAAU,EAAE,SAAS,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACvM,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,iCAAiC,eAAe,EAAE;AAClD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,yBAAyB,eAAe,EAAE;AAC1C,qDAAqD,gBAAgB,EAAE,WAAW,EAAE,YAAY,EAAE;AAClG,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,eAAe,EAAE,SAAS,EAAE;AAC7H,+BAA+B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC5M,oCAAoC,yBAAyB,EAAE,mBAAmB,EAAE,SAAS,EAAE,6BAA6B,EAAE;AAC9H,kEAAkE,sBAAsB,EAAE,oBAAsB,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACpJ,oDAAoD,SAAS,EAAE;AAC/D,oCAAoC,4BAA4B,EAAE;AAClE,sEAAsE,aAAa,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,SAAS,EAAE,WAAW,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAClN,4CAA4C,oBAAoB,EAAE,eAAe,EAAE,yBAAyB,EAAE,6BAA6B,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,8BAA8B,EAAE;AAC9Q,8CAA8C,oBAAoB,EAAE,cAAc,EAAE;AACpF,iDAAiD,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACpJ,sDAAsD,sBAAsB,EAAE,oBAAoB,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACpL,sDAAsD,oBAAoB,EAAE;AAC5E;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,4BAA4B,sEAAsE,eAAe,EAAE,EAAE;AACrH;;;;;;;+BAO+B,0BAA0B,EAAE;AAC3D,wBAAwB,0BAA0B,EAAE;AACpD;;mDAEmD,0BAA0B,EAAE;AAC/E;;;iCAGiC,0BAA0B,EAAE;AAC7D,oDAAoD,mBAAmB,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACpJ;iCACiC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,oBAAoB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,6BAA6B,EAAE,eAAe,EAAE;AAC9P;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,6GAA6G;AAC/G;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA,8DAA8D,eAAe,EAAE;AAC/E;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA,0DAA0D,4BAA4B,EAAE,qBAAqB,EAAE;AAC/G,yCAAyC,yBAAyB,EAAE;AACpE,oCAAoC,2BAA2B,EAAE,aAAa,EAAE;AAChF,wDAAwD,yBAAyB,EAAE,wBAAwB,EAAE,6BAA6B,EAAE;AAC5I,4BAA4B,oBAAoB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE;AACpG,4BAA4B,sBAAsB,EAAE;AACpD,kCAAkC,8BAA8B,EAAE,sCAAsC,EAAE,eAAe,EAAE,SAAS,EAAE,sBAAsB,EAAE,0BAA0B,EAAE,2BAA2B,EAAE;AACvN;EACE,sBAAsB,kBAAkB,EAAE;EAC1C,iDAAiD,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;EAClH,0EAA0E,SAAO,EAAE,YAAY,EAAE;EACjG,gEAAgE,iBAAiB,EAAE;EACnF,qEAAqE,kBAAkB,EAAE,eAAe,EAAE,mBAAmB,EAAE;EAC/H;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,gBAAgB;EAClB;EACA,sDAAsD,UAAU,EAAE,iBAAiB,EAAE;EACrF,mDAAmD,iBAAiB,EAAE,QAAQ,EAAE;EAChF,yDAAyD,uBAAuB,EAAE;EAClF,sDAAsD,QAAQ,EAAE;EAChE,yDAAyD,mBAAmB,EAAE;AAChF;AACA,+BAA+B,uBAAuB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,QAAQ,EAAE;AAC7G;iCACiC,kBAAkB,EAAE;AACrD,qCAAqC,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9G,2DAA2D,oBAAoB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtJ,iCAAiC,oBAAoB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC5F,0CAA0C,cAAc,EAAE,eAAe,EAAE,2BAA2B,EAAE,6BAA6B,EAAE;AACvI,sBAAsB,kBAAkB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACtM,kCAAkC,yBAAyB,EAAE,2BAA2B,EAAE;AAC1F,4BAA4B,aAAa,EAAE;AAC3C,kEAAkE,4BAA4B,EAAE;AAChG;;;6CAG6C,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7I,oDAAoD,qBAAqB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClI,kDAAkD,qBAAqB,EAAE,6CAA6C,EAAE;AACxH,0CAA0C,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3G,sDAAsD,mBAAmB,EAAE,aAAa,EAAE,gCAAgC,EAAE;AAC5H,kDAAkD,kBAAkB,EAAE;AACtE,+DAA+D,kBAAkB,EAAE,yCAAyC,EAAE,0BAA0B,EAAE,4BAA4B,EAAE,cAAc,EAAE;AACxM,iEAAiE,gBAAgB,EAAE;AACnF;kEACkE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC1H,kEAAkE,eAAe,EAAE,kBAAkB,EAAE;AACvG,kEAAkE,kBAAkB,EAAE;AACtF,8CAA8C,wBAAwB,EAAE;AACxE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,0BAA0B,aAAa,EAAE,oCAAoC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACnI,0BAA0B,mBAAmB,EAAE,4CAA4C,EAAE;AAC7F,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,gCAAgC,EAAE;AAC5J,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE;AAC9H,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACtL,0BAA0B,8BAA8B,EAAE;AAC1D,mCAAmC,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,iFAAiF,EAAE;AACjR,yCAAyC,qBAAqB,EAAE,mBAAmB,EAAE;AACrF,yCAAyC,qBAAqB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE,aAAa,EAAE;AACnJ,gDAAgD,WAAW,EAAE,eAAe,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,8BAA8B,EAAE,yBAAyB,EAAE,oCAAoC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAChQ,sDAAsD,8BAA8B,EAAE,gCAAgC,EAAE,2BAA2B,EAAE;AACrJ;+CAC+C,gBAAgB,EAAE,eAAe,EAAE,6BAA6B,EAAE,iBAAiB,EAAE,8BAA8B,EAAE,gCAAgC,EAAE,6CAA6C,EAAE;AACrP;qDACqD,8BAA8B,EAAE,gCAAgC,EAAE,6CAA6C,EAAE;AACtK,4BAA4B,4BAA4B,0BAA0B,EAAE,EAAE;AACtF,sBAAsB,iBAAiB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AAChG,iCAAiC,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACjF,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/I,8BAA8B,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC1G,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC5I,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACrK,mDAAmD,gBAAgB,EAAE,6BAA6B,EAAE,8BAA8B,EAAE,yBAAyB,EAAE,oCAAoC,EAAE,6BAA6B,EAAE,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpS,yDAAyD,8BAA8B,EAAE,gCAAgC,EAAE;AAC3H,mFAAmF,8BAA8B,EAAE,yBAAyB,EAAE;AAC9I,mDAAmD,SAAO,EAAE,YAAY,EAAE;AAC1E,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,WAAW,EAAE;AACrH,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACnL,+CAA+C,qBAAqB,EAAE,aAAa,EAAE,gBAAgB,EAAE;AACvG,qCAAqC,2BAA2B,EAAE;AAClE,wBAAwB,mBAAmB,EAAE,eAAe,EAAE,mBAAmB,EAAE,aAAa,EAAE;AAClG,8DAA8D,oBAAoB,EAAE,gBAAgB,EAAE,6BAA6B,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACpL;;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;EAC3C,qGAAqG;AACvG;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,iDAAiD;EACjD,iFAAiF;AACnF;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,wDAAwD;EACxD,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnI,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACnK,4BAA4B,yBAAyB,EAAE,kBAAkB,EAAE,UAAU,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC3H,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE,WAAW,EAAE;AACjG,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3N,mBAAmB,YAAY,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AAC1L,oEAAoE,8BAA8B,EAAE,gBAAgB,EAAE;AACtH,gEAAgE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnH;yEACyE,kCAAkC,EAAE,6BAA6B,EAAE;AAC5I,+EAA+E,8BAA8B,EAAE,4BAA4B,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACnN,gEAAgE,gBAAgB,EAAE,gCAAgC,EAAE;AACpH,gFAAgF,mBAAmB,EAAE;AACrG,sEAAsE,mBAAmB,EAAE;AAC3F,mFAAmF,uBAAuB,EAAE;AAC5G,6EAA6E,2BAA2B,EAAE;AAC1G,yEAAyE,sBAAsB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAClK,kFAAkF,mBAAmB,EAAE,WAAW,EAAE;AACpH,4BAA4B,uCAAuC,gBAAgB,EAAE,EAAE;;AAEvF;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;EAIE,sBAAsB;AACxB;AACA;;GAEG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0KE,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;;;;;;;;;;;EAWE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;EAEE,wCAAwC;EACxC,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;EAeE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,oEAA4P;EAC5P,uCAAuC;EACvC,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,kCAAkC;EAClC,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,oEAA4P;EAC5P,uCAAuC;EACvC,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;EAEE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;;;;;IAME,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;AACpB;;;;AAIA;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;;;;EAIE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;EAWE,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;;;;;;;;EAUE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;;EAiBE,+BAA+B;AACjC;AACA;;;;;;;;;;;EAWE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,+BAA+B;AACjC;;AAEA;;;GAGG;;AAEH;;;;;;;;;;EAUE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgZE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;;2DAE2D;AAC3D,4DAA4D;AAC5D;;;GAGG;AACH;;;;;EAKE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;;AAEF;;;;;EAKE,uBAAuB;AACzB;AACA;;;;;;;;;;;;;;;EAeE,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;EAeE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;EAIE,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wEAAwE;EACxE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;;EAGE,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,iDAAiD;EACjD,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;AAC/D;AACA;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;;;;EAME,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,mFAAmF;AACnF;EACE,QAAQ;EACR,MAAM;EACN,OAAO;EACP,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,yFAAyF;AACzF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,gCAAgC,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC5F,gCAAgC,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC5F,+BAA+B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3F;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0CAA0C,kCAAkC,EAAE;EAC9E;iCAC+B,0BAA0B,EAAE;AAC7D;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;;;;EAIE,6BAA6B;AAC/B;AACA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;GAGG;AACH;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;EAME,6BAA6B;AAC/B;AACA;;;;EAIE;AACF;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA,2BAA2B;AAC3B;4CAC4C;AAC5C,OAAO;AACP;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;;;;;EAKE,YAAY;AACd;AACA,8DAA8D;AAC9D;;;;;;;;EAQE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;EAME,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;;GAGG;AACH;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiEE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuGE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,uDAAuD;;AAEvD,gBAAgB;AAChB;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,oDAAoD;EACpD,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gEAAgE;EAChE,oCAAoC;EACpC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gEAAgE;EAChE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;AACF;AACA,iDAAiD;;AAEjD;EACE,6BAA6B;EAC7B;oBACkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,6DAA6D;AAC/D;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;AAC/D;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;AAC/D;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;AAChD;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;;;IAGE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;IACrB,kCAAkC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;IACd,uCAAuC;EACzC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,0EAA0E;EAC1E,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+CAA+C;AACjD;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,4BAA4B;EAC5B,6DAA6D;EAC7D,WAAW;AACb;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE,0BAA0B,EAAE,oBAAoB;EAChD,gBAAgB,EAAE,yBAAyB;EAC3C,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,2TAA2T;EAC3T,4BAA4B;EAC5B,sCAAsC,EAAE,kBAAkB;EAC1D,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA,qBAAqB;AACrB;EACE,uBAAuB;EACvB;;;;;qDAKmD;EACnD,+BAA+B;AACjC;;AAEA;EACE;;;;;kEAKgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB;;;;;;;;;;qDAUmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;;UAGQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb;;;;GAIC;AACH;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB;;;;GAIC;EACD,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB;;;;;qDAKmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0EAA0E;EAC1E,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,2CAA2C;EAC3C,8CAA8C;EAC9C,UAAU;EACV;+BAC6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,+CAA+C;EAC/C,2EAA2E;EAC3E,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,uBAAuB;;EAEvB,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;;;;;;;GAOG;AACH;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA,kEAAkE;AAClE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE;;IAEE,oDAAoD;IACpD,aAAa;EACf;EACA;IACE,uDAAuD;IACvD,UAAU;EACZ;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyCG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;cACY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;EACV;EACA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,gBAAgB,EAAE,iBAAiB;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA,gEAAgE;AAChE;;;;EAIE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2CAA2C;EAC3C,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,oBAAoB;EACpB,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb;;;KAGG;EACH,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb;;;sBAGoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;AACA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;EAEE;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;;IAGE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,6BAA6B;AAC/B;EACE;IACE,2BAA2B;IAC3B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,UAAU;EACZ;AACF;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,wEAAwE;EACxE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;EAGE,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;AAEA;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,+FAA+F;AAC/F;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,gCAAgC;EAChC,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oHAAoH;EACpH,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,0CAA0C;EAC1C,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,2BAA2B;EAC3B,QAAQ;EACR,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,kDAAkD;EAClD,gDAAgD;EAChD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;;EAKE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE,uCAAuC;EACvC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,sCAAsC;EACtC,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,0CAA0C;EAC1C,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;EAIE,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,2BAA2B;AAC7B;;AAEA;;;;EAIE,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,yCAAyC;EACzC,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;;;;;;;;EASE,+BAA+B;AACjC;;AAEA;;;;EAIE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;;0EAE0E;;AAE1E,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB;wEACsE;EACtE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,iHAAiH;EACjH,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,+BAA+B;EAC/B,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;;AAEpB;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sEAAsE;AACtE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,yBAAyB,cAAc,EAAE;;AAEzC,wBAAwB;AACxB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,oEAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,SAAO;EACP,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4CAA4C;EAC5C,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B,EAAE,wDAAwD;EACzF,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,2DAA2D;AAC3D;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;;;;EAIE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;0EAE0E;AAC1E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;0EAE0E;AAC1E;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,2BAA2B,eAAe,EAAE,eAAe,EAAE,+BAA+B,EAAE;AAC9F,8BAA8B,eAAe,EAAE,gBAAgB,EAAE;;AAEjE,YAAY,2BAA2B,EAAE,eAAe,EAAE;;AAE1D;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;;AAGA,4DAA4D;AAC5D,kBAAkB,kBAAkB,EAAE,oBAAoB,EAAE;AAC5D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;EACnD,cAAc,EAAE,mBAAmB,EAAE,yBAAyB;EAC9D,kBAAkB,EAAE,eAAe,EAAE,mBAAmB;AAC1D;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,eAAe,EAAE;AAC7D;EACE;iCAC+B;EAC/B,aAAa;EACb,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB;EAC7D,kBAAkB,EAAE,uCAAuC,EAAE,YAAY;AAC3E;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW;EACzD,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB;EACjE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;AACrE;AACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,WAAW,uCAAuC,EAAE;AACpD,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,eAAe,EAAE,QAAQ,EAAE,4BAA4B;EACvD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC7E;AACA;EACE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB;EACtF,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC,EAAE,gBAAgB;AACnG;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB;AACzF;AACA,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,eAAe,EAAE,aAAa,EAAE;AAC7F,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,sBAAsB,EAAE;AAC7F,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC7F,6BAA6B,SAAO,EAAE,iBAAiB,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAC1J,qBAAqB,qBAAqB,EAAE,iBAAiB,EAAE,WAAW,EAAE;AAC5E,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,WAAW,EAAE;AACnI,2BAA2B,SAAO,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa,EAAE;AACtI,wBAAwB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACnK,mBAAmB,SAAO,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACnF,oBAAoB,kBAAkB,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC1F,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3I,yBAAyB,mBAAmB,EAAE;AAC9C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,SAAO,EAAE;AAChC,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE,WAAW,EAAE;AACzK,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACtM,oCAAoC,aAAa,EAAE,mBAAmB,EAAE;AACxE,mBAAmB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACxH,qBAAqB,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC3I,kBAAkB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC7J,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;;AAE/D;gCACgC;AAChC;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;AACxC;AACA,UAAU,kBAAkB,EAAE;;AAE9B,sBAAsB,gBAAgB,EAAE;;AAExC,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;AACA,yBAAyB,eAAe,EAAE;AAC1C,mDAAmD,cAAc,EAAE,0BAA0B,EAAE;AAC/F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,iBAAiB;EACxD,2CAA2C,EAAE,kBAAkB;EAC/D,gBAAgB,EAAE,cAAc,EAAE,eAAe;AACnD;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,eAAe,EAAE,QAAQ,EAAE,4BAA4B;EACvD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa;AAC5E;AACA;EACE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB;EACvD,aAAa,EAAE,sBAAsB,EAAE,wCAAwC;AACjF;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,cAAc;AACtE;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB;EAC/E,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACxF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,kBAAkB;EAC3D,kCAAkC,EAAE,WAAW,EAAE,eAAe;AAClE;AACA,4BAA4B,kCAAkC,EAAE;AAChE,uBAAuB,SAAO,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;AACpF,wBAAwB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;AACjE,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC5F;EACE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,aAAa;EAC/D,sBAAsB,EAAE,mBAAmB,EAAE,SAAS,EAAE,aAAa;AACvE;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,WAAW,EAAE,kBAAkB;EACvE,qBAAqB,EAAE,eAAe,EAAE,gBAAgB;AAC1D;;AAEA,qEAAqE;AACrE;EACE,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,0BAA0B,kBAAkB,EAAE,oBAAoB,EAAE;AACpE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA,wCAAwC,WAAW,EAAE;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;AACA,0BAA0B,mBAAmB,EAAE,2BAA2B,EAAE;AAC5E;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,8BAA8B,mBAAmB,EAAE,WAAW,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,2CAA2C,mBAAmB,EAAE;AAChE,+BAA+B,YAAY,EAAE,eAAe,EAAE;;AAE9D,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,eAAe,EAAE;;AAE7D,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;AACA,mBAAmB,aAAa,EAAE,SAAS,EAAE;AAC7C;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,YAAY;EAC/B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB;AACA,mBAAmB,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE;;AAE/D;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,yCAAyC,mBAAmB,EAAE;AAC9D;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxF,gBAAgB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAChG;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,kCAAkC,gBAAgB,EAAE;AACpD,gBAAgB,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACnF,gCAAgC,cAAc,EAAE,gBAAgB,EAAE;AAClE;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,wCAAwC,cAAc,EAAE,gBAAgB,EAAE;AAC1E;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;AACA,gBAAgB,oBAAoB,EAAE,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE;AAC/F,oCAAoC,UAAU,EAAE;AAChD,uBAAuB,WAAW,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA,oBAAoB,aAAa,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAErF,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,6BAA6B,WAAW,EAAE;AAC1C;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA,qBAAqB,cAAc,EAAE;;AAErC,0EAA0E;AAC1E,cAAc,mBAAmB,EAAE;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;AACA,8BAA8B,WAAW,EAAE,cAAc,EAAE;AAC3D,4BAA4B,cAAc,EAAE;AAC5C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE;AAChD,4BAA4B,8BAA8B,EAAE,iCAAiC,EAAE;AAC/F,2BAA2B,SAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpG;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;AACA,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;AACrE,uBAAuB,kBAAkB,EAAE;;AAE3C,8CAA8C;AAC9C,yBAAyB,WAAW,EAAE;AACtC,+BAA+B,mBAAmB,EAAE;;AAEpD,4CAA4C;AAC5C,yCAAyC,mBAAmB,EAAE,iCAAiC,EAAE;;AAEjG,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE,aAAa,gBAAgB,EAAE;AAC/B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA,uBAAuB,gBAAgB,EAAE,cAAc,EAAE;AACzD,uBAAuB,cAAc,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA,2BAA2B,cAAc,EAAE,cAAc,EAAE;AAC3D;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD;EACE,gBAAgB,aAAa,kCAAkC;EAC/D,UAAU;EACV,cAAc;EACd,SAAO;AACT;AACA;EACE,uBAAuB,KAAK,uCAAuC;EACnE,gBAAgB;EAChB,SAAS,mBAAmB,+BAA+B;EAC3D,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB,YAAY,2DAA2D;AACzF;AACA,kFAAkF;AAClF,2BAA2B,eAAe,EAAE,YAAY,EAAE;AAC1D,6BAA6B,eAAe,EAAE,yBAAyB,EAAE;AACzE,0DAA0D;AAC1D;;wCAEwC,yBAAyB,EAAE,6BAA6B,EAAE;AAClG,yBAAyB,cAAc,EAAE;;AAEzC,oEAAoE;AACpE;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,gCAAgC,uBAAuB,EAAE,yBAAyB,EAAE;AACpF,qBAAqB,eAAe,EAAE;;AAEtC,6DAA6D;AAC7D,mCAAmC,eAAe,EAAE,kBAAkB,EAAE;AACxE,yCAAyC,mBAAmB,EAAE;AAC9D,+DAA+D,2BAA2B,EAAE;;AAE5F,mFAAmF;AACnF;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA,4BAA4B,mBAAmB,EAAE;AACjD,6BAA6B,mBAAmB,EAAE;;AAElD,+CAA+C;AAC/C;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,6BAA6B,cAAc,EAAE;AAC7C,+BAA+B,mBAAmB,EAAE;;AAEpD,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA,mCAAmC,aAAa,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACzF,yCAAyC,mBAAmB,EAAE;AAC9D,iCAAiC,cAAc,EAAE,gBAAgB,EAAE;;AAEnE,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;AACzC;AACA,2BAA2B,mBAAmB,EAAE;AAChD;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA,0BAA0B,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACrF,oDAAoD,cAAc,EAAE;AACpE,2BAA2B,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjG,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;;AAErE,SAAS;AACT;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,QAAQ;AACV;AACA,6BAA6B,mBAAmB,EAAE;;AAElD,uEAAuE;AACvE;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;AACA,0BAA0B,kBAAkB,EAAE;AAC9C,iBAAiB,aAAa,EAAE,oBAAoB,EAAE,QAAQ,EAAE,SAAO,EAAE;AACzE;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,2BAA2B;EACvF,QAAQ;EACR,eAAe,EAAE,eAAe;EAChC,gBAAgB;EAChB,uBAAuB,EAAE,6BAA6B,EAAE,kBAAkB;EAC1E,eAAe,EAAE,cAAc,EAAE,oBAAoB;AACvD;AACA,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;AAC/D,sBAAsB,YAAY,EAAE,eAAe,EAAE;AACrD,4BAA4B,uBAAuB,EAAE,yBAAyB,EAAE;AAChF,mBAAmB,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7E,eAAe,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACzG;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,wBAAwB,EAAE,kBAAkB;EAC5C,uBAAuB,EAAE,6BAA6B,EAAE,eAAe;EACvE,cAAc,EAAE,oBAAoB,EAAE,eAAe,EAAE,mBAAmB;AAC5E;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE;AACjE,oBAAoB,SAAO,EAAE,gBAAgB,EAAE;AAC/C,wBAAwB,YAAY,EAAE,eAAe,EAAE;AACvD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB;AACvG;AACA,sBAAsB,YAAY,EAAE,aAAa,EAAE,eAAe,EAAE,WAAW,EAAE,uBAAuB,EAAE;;AAE1G,uEAAuE;AACvE;EACE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa;EACzD,YAAY,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;EAC7E,uCAAuC,EAAE,gBAAgB;EACzD,0CAA0C;EAC1C,+BAA+B;AACjC;AACA,uBAAuB,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,eAAe,EAAE,UAAU,EAAE,EAAE;AAC7G,eAAe,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,gCAAgC,EAAE;AACxI,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAChH,eAAe,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvM,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnE,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,8BAA8B,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AACpJ,oCAAoC,mBAAmB,EAAE;AACzD,eAAe,aAAa,EAAE,SAAS,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC9E,qBAAqB,mBAAmB,EAAE;AAC1C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzN,eAAe,YAAY,EAAE,SAAO,EAAE;AACtC,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,kBAAkB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACnK,eAAe,aAAa,EAAE,6BAA6B,EAAE;AAC7D,sBAAsB,SAAO,EAAE,cAAc,EAAE,mBAAmB,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACrN,iCAAiC,kBAAkB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE;;AAEjD,4DAA4D;AAC5D;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;AACjF;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC3I,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnH,cAAc,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC9G,oBAAoB,mBAAmB,EAAE;AACzC,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE;AACvD,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxF,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACvF,kBAAkB,eAAe,EAAE,WAAW,EAAE,aAAa,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAChI,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACxJ,qBAAqB,aAAa,EAAE;AACpC,sBAAsB,SAAO,EAAE,YAAY,EAAE;AAC7C,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E,sBAAsB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACxE,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACnH,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE,oBAAoB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9F,yBAAyB,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,eAAe,EAAE;AAChH,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AACxI,yBAAyB,WAAW,EAAE,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACvK,mDAAmD,mBAAmB,EAAE;AACxE,0DAA0D,UAAU,EAAE;AACtE,gBAAgB,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACnG,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC/E,gBAAgB,iBAAiB,EAAE,WAAW,EAAE,WAAW,EAAE,cAAc,EAAE;AAC7E,oCAAoC,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE,aAAa,EAAE;AAC3J,kBAAkB,WAAW,EAAE;AAC/B,gDAAgD,qBAAqB,EAAE;AACvE,wBAAwB,SAAO,EAAE,WAAW,EAAE;AAC9C,mBAAmB,gBAAgB,EAAE;AACrC,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnO,yBAAyB,YAAY,EAAE,eAAe,EAAE;AACxD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AACxI,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAChN,sBAAsB,mBAAmB,EAAE;AAC3C,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3I,wBAAwB,mBAAmB,EAAE;;AAE7C,6EAA6E;AAC7E;0BAC0B,kBAAkB,EAAE;;AAE9C,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,mFAAmF;AACnF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,uDAAuD;AACvD,gBAAgB,mBAAmB,EAAE;;AAErC,yFAAyF;AACzF,qFAAqF;AACrF,iCAAiC,gBAAgB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClF,mCAAmC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC/E,yCAAyC,aAAa,EAAE;AACxD,yCAAyC,iBAAiB,EAAE;;AAE5D,iDAAiD;AACjD,2CAA2C,aAAa,EAAE;;AAE1D,qFAAqF;AACrF,gBAAgB,8BAA8B,EAAE,gCAAgC,EAAE;AAClF,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;;AAE9D,uEAAuE;AACvE;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,cAAc,cAAc,EAAE;AAC9B,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;AACd;AACA,eAAe,mBAAmB,EAAE;AACpC,0BAA0B,gBAAgB,EAAE;AAC5C;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA,mCAAmC,UAAU,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AAC9F,cAAc,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjE;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;EAC/E,0CAA0C;AAC5C;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC7I,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrH,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAChH,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE;AACzD,yBAAyB,cAAc,EAAE,iBAAiB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC7F;EACE,WAAW,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB;EAChG,oBAAoB,EAAE,aAAa,EAAE,sBAAsB;AAC7D;AACA,+FAA+F,qBAAqB,EAAE;AACtH,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,wBAAwB,SAAO,EAAE;AACjC,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AACpH,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACvN,2BAA2B,mBAAmB,EAAE;AAChD,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAChM,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC9J,2BAA2B,mBAAmB,EAAE;;AAEhD,iEAAiE;AACjE;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;EAC/E,0CAA0C;AAC5C;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC/I,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvH,sBAAsB,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClI,kBAAkB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAClH,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,sBAAsB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACjJ,wBAAwB,eAAe,EAAE,eAAe,EAAE,WAAW,EAAE;AACvE,2BAA2B,iBAAiB,EAAE;AAC9C,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC7H,0BAA0B,mBAAmB,EAAE;AAC/C,oBAAoB,eAAe,EAAE,cAAc,EAAE;AACrD,oBAAoB,SAAO,EAAE,YAAY,EAAE,eAAe,EAAE;AAC5D,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1I,mBAAmB,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnI,oBAAoB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AACpL,6BAA6B,mBAAmB,EAAE;AAClD,qBAAqB,kBAAkB,EAAE,6BAA6B,EAAE,iBAAiB,EAAE;AAC3F,2BAA2B,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtK,iCAAiC,mBAAmB,EAAE;;AAEtD,kFAAkF;AAClF,gEAAgE;AAChE,kBAAkB,qBAAqB,EAAE;AACzC,iBAAiB,0BAA0B,EAAE,QAAQ,EAAE;;AAEvD,uEAAuE;AACvE,eAAe,mBAAmB,EAAE,+BAA+B,EAAE;AACrE,0BAA0B,kBAAkB,EAAE;AAC9C,iBAAiB,QAAQ,EAAE;AAC3B,aAAa,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AAC3E,eAAe,wBAAwB,EAAE;AACzC,eAAe,QAAQ,EAAE,cAAc,EAAE;AACzC,qBAAqB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAExE,oDAAoD;AACpD,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnF,sDAAsD;AACtD,gBAAgB,8BAA8B,EAAE,gCAAgC,EAAE,kBAAkB,EAAE;AACtG;iCACiC,cAAc,EAAE,gBAAgB,EAAE;;AAEnE,gCAAgC;AAChC,gBAAgB,kBAAkB,EAAE;;AAEpC,gFAAgF;AAChF,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA,sEAAsE;AACtE,cAAc,gBAAgB,EAAE;AAChC,sBAAsB,mBAAmB,EAAE,iBAAiB,EAAE;AAC9D,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE,aAAa,EAAE;AAC7E,sBAAsB,eAAe,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACtF,4BAA4B,qBAAqB,EAAE;AACnD,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,aAAa,EAAE;AAClF,uBAAuB,gBAAgB,EAAE,mBAAmB,EAAE;;AAE9D,wEAAwE;AACxE,iCAAiC,UAAU,EAAE;AAC7C,uCAAuC,mBAAmB,EAAE,kBAAkB,EAAE;AAChF,uCAAuC,uBAAuB,EAAE;;AAEhE,oGAAoG;AACpG;EACE,iBAAiB,WAAW,oCAAoC;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;AACA,eAAe,kBAAkB,EAAE;AACnC,iBAAiB,QAAQ,EAAE;AAC3B,eAAe,MAAM,EAAE,cAAc,EAAE;AACvC,aAAa,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AAC3E,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,eAAe,wBAAwB,EAAE,iBAAiB,EAAE,QAAQ,EAAE;AACtE,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE;AACtD,sBAAsB,WAAW,EAAE,iBAAiB,EAAE;;AAEtD,oFAAoF;AACpF,oCAAoC,WAAW,EAAE;AACjD,0CAA0C,mBAAmB,EAAE,kBAAkB,EAAE;AACnF,0CAA0C,uBAAuB,EAAE;;AAEnE,4FAA4F;AAC5F,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,cAAc,kBAAkB,gCAAgC;EAChE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB,gBAAgB,gDAAgD;EAChF,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA,2BAA2B,eAAe,EAAE,YAAY,EAAE;AAC1D,6BAA6B,eAAe,EAAE;AAC9C,0EAA0E;AAC1E;;;;EAIE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;0BAC0B,oBAAoB,EAAE,cAAc,EAAE;AAChE,yBAAyB,cAAc,EAAE;AACzC;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,4FAA4F;AAC5F,kBAAkB,kBAAkB,EAAE;AACtC,qBAAqB,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACrH,wBAAwB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AACjI,8BAA8B,mBAAmB,EAAE;AACnD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB;AACvG;AACA,uBAAuB,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE;AACjE;EACE,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,YAAY;EACtE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB;EAChE,wCAAwC,EAAE,gBAAgB;EAC1D,0CAA0C;AAC5C;AACA,uBAAuB,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE;AAChE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACvH;AACA,uBAAuB,YAAY,EAAE;AACrC,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACpH,wBAAwB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AACpG,uBAAuB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE,oBAAoB,EAAE;AAC3I,6BAA6B,0BAA0B,EAAE;AACzD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,WAAW,EAAE,kBAAkB;EAC9E,gBAAgB,EAAE,YAAY,EAAE,6BAA6B,EAAE,eAAe;EAC9E,eAAe,EAAE,cAAc,EAAE,oBAAoB,EAAE,gBAAgB;AACzE;AACA,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,mBAAmB,EAAE;;AAEjD,2FAA2F;AAC3F,sBAAsB,oBAAoB,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AAC1E,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE,SAAS,EAAE;AAC1F,sCAAsC,mBAAmB,EAAE;;AAE3D,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,0BAA0B,cAAc,EAAE,cAAc,EAAE;;AAE1D,wEAAwE;AACxE,0BAA0B,aAAa,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACxF;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc;EAC/D,YAAY,EAAE,kBAAkB,EAAE,oBAAoB;AACxD;AACA,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE,2EAA2E;AAC3E;EACE,WAAW,EAAE,eAAe,EAAE,cAAc;EAC5C,mBAAmB,EAAE,+BAA+B;EACpD,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB;AAC9E;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc;EAC/D,YAAY,EAAE,kBAAkB,EAAE,oBAAoB;AACxD;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,4FAA4F;AAC5F,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtF;EACE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,MAAM;AAChE;AACA,qBAAqB,aAAa,EAAE;AACpC,wBAAwB,cAAc,EAAE;;AAExC,8EAA8E;AAC9E,0BAA0B,aAAa,EAAE;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,8CAA8C,SAAO,EAAE,SAAS,EAAE;AAClE;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;AACA,yDAAyD,mBAAmB,EAAE,cAAc,EAAE;;AAE9F,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,iBAAiB,cAAc,EAAE;AACjC,cAAc,gBAAgB,EAAE;AAChC,aAAa,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE;AAC3F,gBAAgB,SAAO,EAAE,cAAc,EAAE;;AAEzC,kEAAkE;AAClE,0BAA0B,iBAAiB,EAAE;;AAE7C,0EAA0E;AAC1E;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,eAAe,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gCAAgC,EAAE;AACxH,eAAe,kBAAkB,EAAE;AACnC,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtF;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACvH;AACA,eAAe,YAAY,EAAE;AAC7B,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACjH;EACE,aAAa,EAAE,QAAQ,EAAE,uBAAuB;EAChD,iBAAiB,EAAE,cAAc,EAAE,iBAAiB;EACpD,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,kBAAkB;AACrF;AACA,mBAAmB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;;AAE7D,8CAA8C;AAC9C;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,0CAA0C;EAC1C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;;EAEE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,uCAAuC;EACvC;;gEAE8D;AAChE;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;EAC3B,yDAAyD;EACzD,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;gEAC8D;AAChE;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;EACpC,wBAAwB;EACxB,uCAAuC;EACvC,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,0CAA0C;EAC1C,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,uEAAuE;EACvE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,+DAA+D;EAC/D,oBAAoB;EACpB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,qDAAqD;EACrD,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;;EAGE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;EAGE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,0CAA0C;EAC1C,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,6CAA6C;EAC7C,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,MAAM;IACN,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,MAAM;IACN,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,UAAU;IACV,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,UAAU;IACV,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;;0EAE0E;;AAE1E,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB;wEACsE;EACtE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,iHAAiH;EACjH,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,+BAA+B;EAC/B,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;;AAEpB;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sEAAsE;AACtE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,yBAAyB,cAAc,EAAE;;AAEzC,wBAAwB;AACxB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,oEAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,SAAO;EACP,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;yEACyE;AACzE;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4CAA4C;EAC5C,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B,EAAE,wDAAwD;EACzF,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,2DAA2D;AAC3D;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;;;;EAIE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;0EAE0E;AAC1E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;0EAE0E;AAC1E;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,2BAA2B,eAAe,EAAE,eAAe,EAAE,+BAA+B,EAAE;AAC9F,8BAA8B,eAAe,EAAE,gBAAgB,EAAE;;AAEjE,YAAY,2BAA2B,EAAE,eAAe,EAAE;;AAE1D;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;;AAGA,4DAA4D;AAC5D,kBAAkB,kBAAkB,EAAE,oBAAoB,EAAE;AAC5D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;EACnD,cAAc,EAAE,mBAAmB,EAAE,yBAAyB;EAC9D,kBAAkB,EAAE,eAAe,EAAE,mBAAmB;AAC1D;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,eAAe,EAAE;AAC7D;EACE;iCAC+B;EAC/B,aAAa;EACb,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB;EAC7D,kBAAkB,EAAE,uCAAuC,EAAE,YAAY;AAC3E;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW;EACzD,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB;EACjE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;AACrE;AACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,WAAW,uCAAuC,EAAE;AACpD,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,eAAe,EAAE,QAAQ,EAAE,4BAA4B;EACvD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc;AAC7E;AACA;EACE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB;EACtF,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC,EAAE,gBAAgB;AACnG;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB;AACzF;AACA,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,eAAe,EAAE,aAAa,EAAE;AAC7F,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,sBAAsB,EAAE;AAC7F,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC7F,6BAA6B,SAAO,EAAE,iBAAiB,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAC1J,qBAAqB,qBAAqB,EAAE,iBAAiB,EAAE,WAAW,EAAE;AAC5E,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,WAAW,EAAE;AACnI,2BAA2B,SAAO,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa,EAAE;AACtI,wBAAwB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACnK,mBAAmB,SAAO,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACnF,oBAAoB,kBAAkB,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC1F,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3I,yBAAyB,mBAAmB,EAAE;AAC9C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,SAAO,EAAE;AAChC,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE,WAAW,EAAE;AACzK,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACtM,oCAAoC,aAAa,EAAE,mBAAmB,EAAE;AACxE,mBAAmB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACxH,qBAAqB,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC3I,kBAAkB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC7J,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;;AAE/D,iFAAiF;AACjF;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;AACxC;AACA,UAAU,kBAAkB,EAAE;;AAE9B,sBAAsB,gBAAgB,EAAE;;AAExC,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;AACA,yBAAyB,eAAe,EAAE;AAC1C,mDAAmD,cAAc,EAAE,0BAA0B,EAAE;AAC/F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,iBAAiB;EACxD,2CAA2C,EAAE,kBAAkB;EAC/D,gBAAgB,EAAE,cAAc,EAAE,eAAe;AACnD;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,eAAe,EAAE,QAAQ,EAAE,4BAA4B;EACvD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa;AAC5E;AACA;EACE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB;EACvD,aAAa,EAAE,sBAAsB,EAAE,wCAAwC;AACjF;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,cAAc;AACtE;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB;EAC/E,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACxF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,kBAAkB;EAC3D,kCAAkC,EAAE,WAAW,EAAE,eAAe;AAClE;AACA,4BAA4B,kCAAkC,EAAE;AAChE,uBAAuB,SAAO,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;AACpF,wBAAwB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;AACjE,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC5F;EACE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,aAAa;EAC/D,sBAAsB,EAAE,mBAAmB,EAAE,SAAS,EAAE,aAAa;AACvE;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,WAAW,EAAE,kBAAkB;EACvE,qBAAqB,EAAE,eAAe,EAAE,gBAAgB;AAC1D;;AAEA,qEAAqE;AACrE;EACE,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,0BAA0B,kBAAkB,EAAE,oBAAoB,EAAE;AACpE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA,wCAAwC,WAAW,EAAE;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;AACA,0BAA0B,mBAAmB,EAAE,2BAA2B,EAAE;AAC5E;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,8BAA8B,mBAAmB,EAAE,WAAW,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,2CAA2C,mBAAmB,EAAE;AAChE,+BAA+B,YAAY,EAAE,eAAe,EAAE;;AAE9D,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,eAAe,EAAE;;AAE7D,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;AACA,mBAAmB,aAAa,EAAE,SAAS,EAAE;AAC7C;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,YAAY;EAC/B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB;AACA,mBAAmB,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE;;AAE/D;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,yCAAyC,mBAAmB,EAAE;AAC9D;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxF,gBAAgB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAChG;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,kCAAkC,gBAAgB,EAAE;AACpD,gBAAgB,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACnF,gCAAgC,cAAc,EAAE,gBAAgB,EAAE;AAClE;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,wCAAwC,cAAc,EAAE,gBAAgB,EAAE;AAC1E;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;AACA,gBAAgB,oBAAoB,EAAE,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE;AAC/F,oCAAoC,UAAU,EAAE;AAChD,uBAAuB,WAAW,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA,oBAAoB,aAAa,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAErF,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,6BAA6B,WAAW,EAAE;AAC1C;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA,qBAAqB,cAAc,EAAE;;AAErC,0EAA0E;AAC1E,cAAc,mBAAmB,EAAE;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;AACA,8BAA8B,WAAW,EAAE,cAAc,EAAE;AAC3D,4BAA4B,cAAc,EAAE;AAC5C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE;AAChD,4BAA4B,8BAA8B,EAAE,iCAAiC,EAAE;AAC/F,2BAA2B,SAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpG;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;AACA,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;AACrE,uBAAuB,kBAAkB,EAAE;;AAE3C,8CAA8C;AAC9C,yBAAyB,WAAW,EAAE;AACtC,+BAA+B,mBAAmB,EAAE;;AAEpD,4CAA4C;AAC5C,yCAAyC,mBAAmB,EAAE,iCAAiC,EAAE;;AAEjG,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE,aAAa,gBAAgB,EAAE;AAC/B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA,uBAAuB,gBAAgB,EAAE,cAAc,EAAE;AACzD,uBAAuB,cAAc,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA,2BAA2B,cAAc,EAAE,cAAc,EAAE;AAC3D;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD;EACE,gBAAgB,aAAa,kCAAkC;EAC/D,UAAU;EACV,cAAc;EACd,SAAO;AACT;AACA;EACE,uBAAuB,KAAK,uCAAuC;EACnE,gBAAgB;EAChB,SAAS,mBAAmB,+BAA+B;EAC3D,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB,YAAY,2DAA2D;AACzF;AACA,kFAAkF;AAClF,2BAA2B,eAAe,EAAE,YAAY,EAAE;AAC1D,6BAA6B,eAAe,EAAE,yBAAyB,EAAE;AACzE,0DAA0D;AAC1D;;wCAEwC,yBAAyB,EAAE,6BAA6B,EAAE;AAClG,yBAAyB,cAAc,EAAE;;AAEzC,oEAAoE;AACpE;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,gCAAgC,uBAAuB,EAAE,yBAAyB,EAAE;AACpF,qBAAqB,eAAe,EAAE;;AAEtC,6DAA6D;AAC7D,mCAAmC,eAAe,EAAE,kBAAkB,EAAE;AACxE,yCAAyC,mBAAmB,EAAE;AAC9D,+DAA+D,2BAA2B,EAAE;;AAE5F,mFAAmF;AACnF;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA,4BAA4B,mBAAmB,EAAE;AACjD,6BAA6B,mBAAmB,EAAE;;AAElD,+CAA+C;AAC/C;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,6BAA6B,cAAc,EAAE;AAC7C,+BAA+B,mBAAmB,EAAE;;AAEpD,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA,mCAAmC,aAAa,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACzF,yCAAyC,mBAAmB,EAAE;AAC9D,iCAAiC,cAAc,EAAE,gBAAgB,EAAE;;AAEnE,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;AACzC;AACA,2BAA2B,mBAAmB,EAAE;AAChD;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA,0BAA0B,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACrF,oDAAoD,cAAc,EAAE;AACpE,2BAA2B,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjG,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;;AAErE,SAAS;AACT;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,QAAQ;AACV;AACA,6BAA6B,mBAAmB,EAAE;;AAElD,uEAAuE;AACvE;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;AACA,0BAA0B,kBAAkB,EAAE;AAC9C,iBAAiB,aAAa,EAAE,oBAAoB,EAAE,QAAQ,EAAE,SAAO,EAAE;AACzE;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,2BAA2B;EACvF,QAAQ;EACR,eAAe,EAAE,eAAe;EAChC,gBAAgB;EAChB,uBAAuB,EAAE,6BAA6B,EAAE,kBAAkB;EAC1E,eAAe,EAAE,cAAc,EAAE,oBAAoB;AACvD;AACA,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;AAC/D,sBAAsB,YAAY,EAAE,eAAe,EAAE;AACrD,4BAA4B,uBAAuB,EAAE,yBAAyB,EAAE;AAChF,mBAAmB,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7E,eAAe,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACzG;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,wBAAwB,EAAE,kBAAkB;EAC5C,uBAAuB,EAAE,6BAA6B,EAAE,eAAe;EACvE,cAAc,EAAE,oBAAoB,EAAE,eAAe,EAAE,mBAAmB;AAC5E;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE;AACjE,oBAAoB,SAAO,EAAE,gBAAgB,EAAE;AAC/C,wBAAwB,YAAY,EAAE,eAAe,EAAE;AACvD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB;AACvG;AACA,sBAAsB,YAAY,EAAE,aAAa,EAAE,eAAe,EAAE,WAAW,EAAE,uBAAuB,EAAE;;AAE1G,uEAAuE;AACvE;EACE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa;EACzD,YAAY,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;EAC7E,uCAAuC,EAAE,gBAAgB;EACzD,0CAA0C;EAC1C,+BAA+B;AACjC;AACA,uBAAuB,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,eAAe,EAAE,UAAU,EAAE,EAAE;AAC7G,eAAe,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,gCAAgC,EAAE;AACxI,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAChH,eAAe,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvM,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnE,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,8BAA8B,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AACpJ,oCAAoC,mBAAmB,EAAE;AACzD,eAAe,aAAa,EAAE,SAAS,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC9E,qBAAqB,mBAAmB,EAAE;AAC1C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzN,eAAe,YAAY,EAAE,SAAO,EAAE;AACtC,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,kBAAkB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACnK,eAAe,aAAa,EAAE,6BAA6B,EAAE;AAC7D,sBAAsB,SAAO,EAAE,cAAc,EAAE,mBAAmB,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,WAAW,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACrN,iCAAiC,kBAAkB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE;;AAEjD,4DAA4D;AAC5D;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;AACjF;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC3I,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnH,cAAc,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC9G,oBAAoB,mBAAmB,EAAE;AACzC,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE;AACvD,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxF,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACvF,kBAAkB,eAAe,EAAE,WAAW,EAAE,aAAa,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAChI,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACxJ,qBAAqB,aAAa,EAAE;AACpC,sBAAsB,SAAO,EAAE,YAAY,EAAE;AAC7C,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E,sBAAsB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACxE,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACnH,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE,oBAAoB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9F,yBAAyB,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,eAAe,EAAE;AAChH,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AACxI,yBAAyB,WAAW,EAAE,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACvK,mDAAmD,mBAAmB,EAAE;AACxE,0DAA0D,UAAU,EAAE;AACtE,gBAAgB,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACnG,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC/E,gBAAgB,iBAAiB,EAAE,WAAW,EAAE,WAAW,EAAE,cAAc,EAAE;AAC7E,oCAAoC,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE,aAAa,EAAE;AAC3J,kBAAkB,WAAW,EAAE;AAC/B,gDAAgD,qBAAqB,EAAE;AACvE,wBAAwB,SAAO,EAAE,WAAW,EAAE;AAC9C,mBAAmB,gBAAgB,EAAE;AACrC,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnO,yBAAyB,YAAY,EAAE,eAAe,EAAE;AACxD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AACxI,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAChN,sBAAsB,mBAAmB,EAAE;AAC3C,kBAAkB,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3I,wBAAwB,mBAAmB,EAAE;;AAE7C,6EAA6E;AAC7E;0BAC0B,kBAAkB,EAAE;;AAE9C,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,mFAAmF;AACnF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,uDAAuD;AACvD,gBAAgB,mBAAmB,EAAE;;AAErC,yFAAyF;AACzF,qFAAqF;AACrF,iCAAiC,gBAAgB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClF,mCAAmC,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC/E,yCAAyC,aAAa,EAAE;AACxD,yCAAyC,iBAAiB,EAAE;;AAE5D,iDAAiD;AACjD,2CAA2C,aAAa,EAAE;;AAE1D,qFAAqF;AACrF,gBAAgB,8BAA8B,EAAE,gCAAgC,EAAE;AAClF,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;;AAE9D,uEAAuE;AACvE;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,cAAc,cAAc,EAAE;AAC9B,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;AACd;AACA,eAAe,mBAAmB,EAAE;AACpC,0BAA0B,gBAAgB,EAAE;AAC5C;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA,mCAAmC,UAAU,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AAC9F,cAAc,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjE;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;EAC/E,0CAA0C;AAC5C;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC7I,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrH,gBAAgB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAChH,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE;AACzD,yBAAyB,cAAc,EAAE,iBAAiB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC7F;EACE,WAAW,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB;EAChG,oBAAoB,EAAE,aAAa,EAAE,sBAAsB;AAC7D;AACA,+FAA+F,qBAAqB,EAAE;AACtH,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,wBAAwB,SAAO,EAAE;AACjC,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AACpH,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACvN,2BAA2B,mBAAmB,EAAE;AAChD,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAChM,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC9J,2BAA2B,mBAAmB,EAAE;;AAEhD,iEAAiE;AACjE;EACE,YAAY,EAAE,6BAA6B,EAAE,gBAAgB;EAC7D,gBAAgB,EAAE,mBAAmB,EAAE,wCAAwC;EAC/E,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB;EAC/E,0CAA0C;AAC5C;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC/I,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvH,sBAAsB,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClI,kBAAkB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAClH,wBAAwB,mBAAmB,EAAE;AAC7C,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,sBAAsB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACjJ,wBAAwB,eAAe,EAAE,eAAe,EAAE,WAAW,EAAE;AACvE,2BAA2B,iBAAiB,EAAE;AAC9C,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gCAAgC,EAAE;AAC7H,0BAA0B,mBAAmB,EAAE;AAC/C,oBAAoB,eAAe,EAAE,cAAc,EAAE;AACrD,oBAAoB,SAAO,EAAE,YAAY,EAAE,eAAe,EAAE;AAC5D,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1I,mBAAmB,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnI,oBAAoB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AACpL,6BAA6B,mBAAmB,EAAE;AAClD,qBAAqB,kBAAkB,EAAE,6BAA6B,EAAE,iBAAiB,EAAE;AAC3F,2BAA2B,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtK,iCAAiC,mBAAmB,EAAE;;AAEtD,kFAAkF;AAClF,gEAAgE;AAChE,kBAAkB,qBAAqB,EAAE;AACzC,iBAAiB,0BAA0B,EAAE,QAAQ,EAAE;;AAEvD,uEAAuE;AACvE,eAAe,mBAAmB,EAAE,+BAA+B,EAAE;AACrE,0BAA0B,kBAAkB,EAAE;AAC9C,iBAAiB,QAAQ,EAAE;AAC3B,aAAa,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AAC3E,eAAe,wBAAwB,EAAE;AACzC,eAAe,QAAQ,EAAE,cAAc,EAAE;AACzC,qBAAqB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAExE,oDAAoD;AACpD,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnF,sDAAsD;AACtD,gBAAgB,8BAA8B,EAAE,gCAAgC,EAAE,kBAAkB,EAAE;AACtG;iCACiC,cAAc,EAAE,gBAAgB,EAAE;;AAEnE,gCAAgC;AAChC,gBAAgB,kBAAkB,EAAE;;AAEpC,gFAAgF;AAChF,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA,sEAAsE;AACtE,cAAc,gBAAgB,EAAE;AAChC,sBAAsB,mBAAmB,EAAE,iBAAiB,EAAE;AAC9D,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE,aAAa,EAAE;AAC7E,sBAAsB,eAAe,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACtF,4BAA4B,qBAAqB,EAAE;AACnD,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,aAAa,EAAE;AAClF,uBAAuB,gBAAgB,EAAE,mBAAmB,EAAE;;AAE9D,wEAAwE;AACxE,iCAAiC,UAAU,EAAE;AAC7C,uCAAuC,mBAAmB,EAAE,kBAAkB,EAAE;AAChF,uCAAuC,uBAAuB,EAAE;;AAEhE,oGAAoG;AACpG;EACE,iBAAiB,WAAW,oCAAoC;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;AACA,eAAe,kBAAkB,EAAE;AACnC,iBAAiB,QAAQ,EAAE;AAC3B,eAAe,MAAM,EAAE,cAAc,EAAE;AACvC,aAAa,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AAC3E,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,eAAe,wBAAwB,EAAE,iBAAiB,EAAE,QAAQ,EAAE;AACtE,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE;AACtD,sBAAsB,WAAW,EAAE,iBAAiB,EAAE;;AAEtD,oFAAoF;AACpF,oCAAoC,WAAW,EAAE;AACjD,0CAA0C,mBAAmB,EAAE,kBAAkB,EAAE;AACnF,0CAA0C,uBAAuB,EAAE;;AAEnE,4FAA4F;AAC5F,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,cAAc,kBAAkB,gCAAgC;EAChE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB,gBAAgB,gDAAgD;EAChF,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA,2BAA2B,eAAe,EAAE,YAAY,EAAE;AAC1D,6BAA6B,eAAe,EAAE;AAC9C,0EAA0E;AAC1E;;;;EAIE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;0BAC0B,oBAAoB,EAAE,cAAc,EAAE;AAChE,yBAAyB,cAAc,EAAE;AACzC;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,4FAA4F;AAC5F,kBAAkB,kBAAkB,EAAE;AACtC,qBAAqB,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACrH,wBAAwB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AACjI,8BAA8B,mBAAmB,EAAE;AACnD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB;AACvG;AACA,uBAAuB,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE;AACjE;EACE,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,YAAY;EACtE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB;EAChE,wCAAwC,EAAE,gBAAgB;EAC1D,0CAA0C;AAC5C;AACA,uBAAuB,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE;AAChE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACvH;AACA,uBAAuB,YAAY,EAAE;AACrC,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACpH,wBAAwB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AACpG,uBAAuB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE,oBAAoB,EAAE;AAC3I,6BAA6B,0BAA0B,EAAE;AACzD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,WAAW,EAAE,kBAAkB;EAC9E,gBAAgB,EAAE,YAAY,EAAE,6BAA6B,EAAE,eAAe;EAC9E,eAAe,EAAE,cAAc,EAAE,oBAAoB,EAAE,gBAAgB;AACzE;AACA,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,mBAAmB,EAAE;;AAEjD,2FAA2F;AAC3F,sBAAsB,oBAAoB,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AAC1E,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE,SAAS,EAAE;AAC1F,sCAAsC,mBAAmB,EAAE;;AAE3D,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,0BAA0B,cAAc,EAAE,cAAc,EAAE;;AAE1D,wEAAwE;AACxE,0BAA0B,aAAa,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACxF;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc;EAC/D,YAAY,EAAE,kBAAkB,EAAE,oBAAoB;AACxD;AACA,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE,2EAA2E;AAC3E;EACE,WAAW,EAAE,eAAe,EAAE,cAAc;EAC5C,mBAAmB,EAAE,+BAA+B;EACpD,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB;AAC9E;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc;EAC/D,YAAY,EAAE,kBAAkB,EAAE,oBAAoB;AACxD;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,4FAA4F;AAC5F,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtF;EACE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,MAAM;AAChE;AACA,qBAAqB,aAAa,EAAE;AACpC,wBAAwB,cAAc,EAAE;;AAExC,8EAA8E;AAC9E,0BAA0B,aAAa,EAAE;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,8CAA8C,SAAO,EAAE,SAAS,EAAE;AAClE;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;AACA,yDAAyD,mBAAmB,EAAE,cAAc,EAAE;;AAE9F,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,iBAAiB,cAAc,EAAE;AACjC,cAAc,gBAAgB,EAAE;AAChC,aAAa,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE;AAC3F,gBAAgB,SAAO,EAAE,cAAc,EAAE;;AAEzC,kEAAkE;AAClE,0BAA0B,iBAAiB,EAAE;;AAE7C,0EAA0E;AAC1E;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,eAAe,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gCAAgC,EAAE;AACxH,eAAe,kBAAkB,EAAE;AACnC,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtF;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW;EAC/E,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACvH;AACA,eAAe,YAAY,EAAE;AAC7B,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpI,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACjH;EACE,aAAa,EAAE,QAAQ,EAAE,uBAAuB;EAChD,iBAAiB,EAAE,cAAc,EAAE,iBAAiB;EACpD,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,kBAAkB;AACrF;AACA,mBAAmB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,wBAAwB,gBAAgB,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,cAAc,CAAC,yBAAyB,eAAe,CAAC,iBAAiB,CAAC,eAAe,CAAC,yBAAyB,CAAC,wCAAwC,CAAC,eAAe,CAAC,4BAA4B,YAAY,CAAC,mCAAmC,CAAC,OAAO,CAAC,mBAAmB,CAAC,cAAc,4BAA4B,CAAC,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,qBAAqB,oBAAoB,CAAC,aAAa,CAAC,2BAA2B,YAAY,CAAC,+BAA+B,CAAC,wBAAwB,sBAAsB,CAAC,8BAA8B,CAAC,oBAAoB,iBAAiB,CAAC,iBAAiB,CAAC,qCAAqC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,mBAAmB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,0BAA0B,kBAAkB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,0BAA0B,UAAU,CAAC,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,gCAAgC,YAAY,CAAC,mCAAmC,CAAC,OAAO,CAAC,kBAAkB,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,iBAAiB,CAAC,qBAAqB,iBAAiB,CAAC,WAAW,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,2BAA2B,oBAAoB,CAAC,2BAA2B,aAAa,CAAC,kBAAkB,CAAC,8BAA8B,kBAAkB,CAAC,UAAU,CAAC,oBAAoB,CAAC,yCAAyC,CAAC,uBAAuB,iBAAiB,CAAC,UAAU,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,0BAA0B,CAAC,gCAAgC,eAAe,CAAC,gBAAgB,YAAY,CAAC,cAAc,CAAC,QAAQ,CAAC,4BAA4B,CAAC,eAAe,CAAC,gBAAgB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,KAAK,oBAAoB,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,cAAc,kBAAkB,CAAC,oBAAoB,CAAC,iBAAiB,kBAAkB,CAAC,oBAAoB,CAAC,cAAc,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,gBAAgB,CAAC,eAAe,CAAC,qBAAqB,eAAe,CAAC,uBAAuB,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,kBAAkB,aAAa,CAAC,cAAc,CAAC,eAAe,YAAY,CAAC,6CAA6C,CAAC,OAAO,CAAC,eAAe,CAAC,sBAAsB,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe,CAAC,yDAAyD,oBAAoB,CAAC,kBAAkB,CAAC,wBAAwB,yBAAyB,aAAa,CAAC,2BAA2B,yBAAyB,CAAC,wBAAwB,cAAc,CAAC,+BAA+B,CAAC,eAAe,6BAA6B,CAAC,CAAC,wBAAwB,4BAA4B,iBAAiB,CAAC,kBAAkB,CAAC,4CAA4C,iBAAiB,CAAC,kBAAkB,CAAC,gBAAgB,QAAQ,CAAC,eAAe,yBAAyB,CAAC;AACp3G,wBAAwB,cAAc,CAAC,OAAO,CAAC,YAAY,CAAC,aAAa,CAAC,gBAAgB,CAAC,yBAAyB,gBAAgB;AACpI,oBAAoB,iBAAiB,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,uBAAuB,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,0BAA0B,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,0BAA0B,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,cAAc,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,YAAY,CAAC,gCAAgC,oBAAoB,CAAC,4BAA4B,CAAC,kBAAkB,UAAU,CAAC,WAAW,CAAC,cAAc,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,eAAe,CAAC,2BAA2B,kBAAkB,CAAC,kBAAkB,CAAC,wBAAwB,2BAA2B,+BAA+B,CAAC,oBAAoB,gBAAgB,CAAC,4BAA4B,CAAC,aAAa,CAAC;AACj2B,2BAA2B,mDAAmD,CAAC,wBAAwB,2BAA2B,+BAA+B,CAAC,uBAAuB,gBAAgB,CAAC,cAAc,CAAC,+BAA+B,CAAC;AACzP,yBAAyB,yBAAyB,CAAC,cAAc,CAAC,6BAA6B,CAAC,2BAA2B,mDAAmD,CAAC,wBAAwB,iBAAiB,CAAC,kBAAkB,CAAC,oBAAoB,iBAAiB,CAAC,kBAAkB,CAAC,uBAAuB,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB,yBAAyB,wBAAwB,CAAC,gBAAgB,CAAC,2BAA2B,+BAA+B,CAAC;AACvf,uBAAuB,iBAAiB,CAAC,8BAA8B,CAAC,aAAa,CAAC,gBAAgB,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,eAAe,CAAC,kBAAkB,CAAC,uBAAuB,cAAc,CAAC,iBAAiB,CAAC,0BAA0B,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,wBAAwB,YAAY,CAAC,OAAO,CAAC,sBAAsB,CAAC,YAAY,CAAC,cAAc,CAAC,gBAAgB,CAAC,sBAAsB,4BAA4B,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,cAAc,CAAC,eAAe,CAAC,4BAA4B,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,iBAAiB,CAAC,sBAAsB,iBAAiB,CAAC,2BAA2B,WAAW,CAAC,cAAc,CAAC,oBAAoB,YAAY,CAAC,0BAA0B,cAAc,CAAC,kBAAkB,cAAc,CAAC,qBAAqB,cAAc,CAAC,qCAAqC,cAAc,CAAC,uBAAuB,cAAc,CAAC,kBAAkB,cAAc,CAAC,sBAAsB,cAAc;AACpoC,qFAAqF,0CAA0C,CAAC,yBAAyB,wBAAwB,CAAC,wBAAwB,eAAe,CAAC,oBAAoB,eAAe,CAAC,oBAAoB,0DAA0D,CAAC,0BAA0B,eAAe,CAAC,0BAA0B,uBAAuB,CAAC,gCAAgC,kBAAkB,CAAC,aAAa,CAAC,0BAA0B,CAAC,qBAAqB,eAAe,CAAC,wBAAwB,CAAC,uCAAuC,kBAAkB,CAAC,0BAA0B,CAAC,8BAA8B,eAAe,CAAC,sBAAsB,mBAAmB,CAAC,cAAc,CAAC,uBAAuB,CAAC,yDAAyD,yCAAyC,CAAC,0BAA0B,CAAC,cAAc,mBAAmB,CAAC,cAAc,CAAC,wCAAwC,CAAC,6BAA6B,CAAC,oBAAoB,0BAA0B,CAAC,uBAAuB,eAAe,CAAC,qBAAqB,CAAC,kBAAkB,mBAAmB,CAAC,cAAc,CAAC,yCAAyC,CAAC,uBAAuB,CAAC,uCAAuC,kBAAkB,CAAC,0BAA0B;AACp0C,wBAAwB,sBAAsB,CAAC,6BAA6B,CAAC,yBAAyB,yBAAyB,CAAC,0BAA0B,CAAC,uBAAuB,CAAC,gBAAgB,CAAC,2BAA2B,CAAC,wBAAwB,0BAA0B,CAAC,6BAA6B,CAAC,mBAAmB,yBAAyB,CAAC,4BAA4B,CAAC,gCAAgC,iBAAiB,CAAC,qBAAqB,qBAAqB,CAAC,0BAA0B,oBAAoB,CAAC,qBAAqB;AAC5hB,iBAAiB,uBAAuB;AACxC,2BAA2B,6DAA6D,CAAC,wBAAwB,2BAA2B,CAAC,4BAA4B,CAAC,gCAAgC,kBAAkB,CAAC,qBAAqB,qBAAqB,CAAC,eAAe,eAAe,CAAC,YAAY,CAAC,sBAAsB,WAAW;AACrV,cAAc,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,iBAAiB,CAAC,mBAAmB,CAAC,cAAc,CAAC,eAAe,CAAC,yCAAyC,CAAC,uBAAuB,kBAAkB,CAAC,kBAAkB,CAAC,eAAe;AAC3S,uBAAuB,YAAY,CAAC,qBAAqB,CAAC,gBAAgB,CAAC,sBAAsB,yBAAyB;AAC1H,eAAe,UAAU,CAAC,cAAc,CAAC,6CAA6C,CAAC,eAAe,CAAC,oBAAoB,kBAAkB;AAC7I,6BAA6B,UAAU,CAAC,YAAY,CAAC,SAAS,CAAC,QAAQ,CAAC,sBAAsB,CAAC,aAAa,CAAC,mBAAmB,CAAC,cAAc,CAAC,SAAS,CAAC,cAAc,CAAC,oCAAoC,aAAa;AAC1N,0BAA0B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,iCAAiC,QAAM,CAAC,WAAW,CAAC,gDAAgD,cAAc,CAAC,kBAAkB,CAAC,aAAa;AACrN,sBAAsB,oBAAoB,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,sCAAsC,CAAC,qBAAqB,CAAC,iBAAiB,CAAC,mBAAmB,CAAC,+CAA+C,CAAC,6BAA6B,GAAG,wBAAwB,CAAC;AAC/R,2BAA2B,mCAAmC,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,uCAAuC,CAAC,0CAA0C,CAAC,2BAA2B,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,8BAA8B,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,2BAA2B,aAAa,CAAC,eAAe,CAAC,8BAA8B,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,aAAa,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,mCAAmC,aAAa;;AAE9vB;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,wEAAwE;EACxE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,6BAA6B;EAC7B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,0BAA0B,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACxH,0BAA0B,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC9F,6BAA6B,6BAA6B,EAAE,iBAAiB,EAAE,YAAY,EAAE,QAAQ,EAAE;AACvG,yBAAyB,iBAAiB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAChL,iCAAiC,UAAU,EAAE,iBAAiB,EAAE,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,qBAAqB,EAAE,4BAA4B,EAAE;AACzM,0BAA0B,oBAAoB,EAAE,eAAe,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7K,qCAAqC,kBAAkB,EAAE,aAAa,EAAE;AACxE,4BAA4B,YAAY,EAAE,+CAA+C,EAAE,YAAY,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC7M,gCAAgC,YAAY,EAAE,yCAAyC,EAAE,OAAO,EAAE,iBAAiB,EAAE,WAAW,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpK,qCAAqC,aAAa,EAAE,eAAe,EAAE;AACrE,uCAAuC,aAAa,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC/F,8CAA8C,aAAa,EAAE;AAC7D,2CAA2C,kBAAkB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,qBAAqB,EAAE,OAAO,EAAE;AAC5E,kBAAkB,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,eAAe,EAAE,eAAe,EAAE;AAC/F,kCAAkC,oBAAoB,EAAE,aAAa,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5I,iBAAiB,aAAa,EAAE,kBAAkB,EAAE;AACpD,kBAAkB,aAAa,EAAE,kBAAkB,EAAE;AACrD;EACE,4BAA4B,yBAAyB,EAAE,OAAO,EAAE;EAChE,2CAA2C,gBAAgB,EAAE;AAC/D;AACA,4BAA4B,cAAc,EAAE,4BAA4B,EAAE,eAAe,EAAE;AAC3F,oCAAoC,cAAc,EAAE,aAAa,EAAE,eAAe,EAAE,cAAc,EAAE;AACpG,gCAAgC,YAAY,EAAE,+EAA+E,EAAE,cAAc,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC7N,sCAAsC,eAAe,EAAE,+BAA+B,EAAE,sBAAsB,EAAE;AAChH,sDAAsD,kBAAkB,EAAE,eAAe,EAAE,aAAa,EAAE;AAC1G,kCAAkC,6BAA6B,EAAE,wBAAwB,EAAE,0BAA0B,EAAE;AACvH,wBAAwB,eAAe,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC5E,wBAAwB,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AACxE,6BAA6B,gBAAgB,EAAE,aAAa,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;AAC3G,wBAAwB,UAAU,EAAE,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,cAAc,EAAE;AACnH,2BAA2B,eAAe,EAAE,KAAK,EAAE,kBAAkB,EAAE,aAAa,EAAE,eAAe,EAAE,eAAe,EAAE;AACxH,qDAAqD,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE;AAC9I,+CAA+C,eAAe,EAAE;AAChE,6EAA6E,UAAU,EAAE,cAAc,EAAE,kBAAkB,EAAE,aAAa,EAAE;AAC5I,+EAA+E,SAAS,EAAE;AAC1F,+EAA+E,SAAS,EAAE;AAC1F,yBAAyB,oBAAoB,EAAE,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEzJ,4EAA4E;AAC5E,uCAAuC,uBAAuB,EAAE,eAAe,EAAE;AACjF,wCAAwC,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE,4CAA4C,EAAE;AACrI,0BAA0B,iBAAiB,EAAE,QAAQ,EAAE,oDAAoD,EAAE,UAAU,EAAE;AACzH,qCAAqC,8BAA8B,EAAE,UAAU,EAAE;AACjF,2BAA2B,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC3F,gCAAgC,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,aAAa,EAAE,sCAAsC,EAAE,kBAAkB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACxN,oDAAoD,aAAa,EAAE;AACnE,yBAAyB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5E,4BAA4B,cAAc,EAAE,2BAA2B,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1G,yBAAyB,gBAAgB,EAAE,gBAAgB,EAAE,sCAAsC,EAAE,mBAAmB,EAAE,gCAAgC,EAAE,UAAU,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC7N,wBAAwB,2BAA2B,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7G,wBAAwB,YAAY,EAAE,QAAQ,EAAE;AAChD,wBAAwB,iBAAiB,EAAE,YAAY,EAAE,yCAAyC,EAAE,QAAQ,EAAE;AAC9G,wBAAwB,iBAAiB,EAAE,YAAY,EAAE,sBAAsB,EAAE;AACjF,+BAA+B,UAAU,EAAE,iBAAiB,EAAE,QAAQ,EAAE,YAAY,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACrH,gEAAgE,YAAY,EAAE;AAC9E,uBAAuB,SAAS,EAAE,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,EAAE,4BAA4B,EAAE,cAAc,EAAE;AACxN,wBAAwB,WAAW,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,eAAe,EAAE,2CAA2C,EAAE;AACpK,4BAA4B,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,QAAQ,EAAE;AACvG,yBAAyB,mBAAmB,EAAE,aAAa,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvL,6BAA6B,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAChF,+BAA+B,gBAAgB,EAAE,aAAa,EAAE;AAChE,+BAA+B,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpG,wBAAwB,YAAY,EAAE,cAAc,EAAE,YAAY,EAAE,aAAa,EAAE,cAAc,EAAE;AACnG,0BAA0B,gBAAgB,EAAE,aAAa,EAAE;AAC3D,8BAA8B,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC9H,gCAAgC,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AACnJ,kCAAkC,gBAAgB,EAAE;AACpD,oDAAoD,YAAY,EAAE,OAAO,EAAE;AAC3E,oDAAoD,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACrK,2DAA2D,aAAa,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE;AAC5H,4BAA4B,YAAY,EAAE,QAAQ,EAAE;AACpD,2BAA2B,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3G,8BAA8B,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AAC1L,sCAAsC,UAAU,EAAE,SAAS,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACjH,uBAAuB,YAAY,EAAE,+CAA+C,EAAE,OAAO,EAAE;AAC/F,+BAA+B,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC9G,8CAA8C,YAAY,EAAE,iFAAiF,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC9L,yBAAyB,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AAC7I,sBAAsB,4BAA4B,EAAE,aAAa,EAAE,cAAc,EAAE;AACnF,6BAA6B,aAAa,EAAE,eAAe,EAAE,sBAAsB,EAAE;AACrF,6BAA6B,sBAAsB,EAAE;AACrD,wCAAwC,aAAa,EAAE;AACvD,8CAA8C,aAAa,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AACrG,iCAAiC,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACjG,gCAAgC,aAAa,EAAE,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE,oBAAoB,EAAE;AACtH,sFAAsF,mGAAmG,EAAE;AAC3L,8FAA8F,0CAA0C,EAAE;AAC1I,gGAAgG,mGAAmG,EAAE;AACrM,wFAAwF,0EAA0E,EAAE;AACpK,uBAAuB,YAAY,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACnG,gCAAgC,aAAa,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE;AACjG,yDAAyD,YAAY,EAAE,yCAAyC,EAAE,OAAO,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AAC3K,6DAA6D,sBAAsB,EAAE,aAAa,EAAE,eAAe,EAAE;AACrH,0CAA0C,aAAa,EAAE;AACzD,wBAAwB,YAAY,EAAE,+CAA+C,EAAE,QAAQ,EAAE;AACjG,8BAA8B,YAAY,EAAE,qBAAqB,EAAE,OAAO,EAAE;AAC5E,sEAAsE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AACtK,mBAAmB,aAAa,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE;AACzH,2BAA2B,kBAAkB,EAAE,aAAa,EAAE;AAC9D,qDAAqD,YAAY,EAAE,OAAO,EAAE;AAC5E,uBAAuB,YAAY,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACnG,gCAAgC,aAAa,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE;AACjG,qBAAqB,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACpG,6BAA6B,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClI,qCAAqC,aAAa,EAAE;AACpD,6BAA6B,YAAY,EAAE,OAAO,EAAE,mBAAmB,EAAE,4BAA4B,EAAE;AACvG,mCAAmC,YAAY,EAAE,0CAA0C,EAAE,OAAO,EAAE,eAAe,EAAE;AACvH,oCAAoC,sBAAsB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5G,yBAAyB,YAAY,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC3J,gDAAgD,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC/H,8BAA8B,YAAY,EAAE,0CAA0C,EAAE,QAAQ,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;AACrJ,kFAAkF,eAAe,EAAE;AACnG,0DAA0D,aAAa,EAAE,cAAc,EAAE;AACzF,+BAA+B,sBAAsB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACvG,yBAAyB,eAAe,EAAE;AAC1C,+BAA+B,YAAY,EAAE,8EAA8E,EAAE,QAAQ,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;AAC1L,0BAA0B,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AAC9I,gCAAgC,aAAa,EAAE,cAAc,EAAE;AAC/D,4EAA4E,aAAa,EAAE;AAC3F,mCAAmC,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACnG,kCAAkC,aAAa,EAAE,cAAc,EAAE,oBAAoB,EAAE;AACvF,6BAA6B,eAAe,EAAE,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,4DAA4D,EAAE;AACxK,+BAA+B,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC/F,0BAA0B,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,aAAa,EAAE;AAC5I,kCAAkC,QAAQ,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5F,iEAAiE,aAAa,EAAE,cAAc,EAAE;AAChG,2BAA2B,YAAY,EAAE,+CAA+C,EAAE,OAAO,EAAE,kBAAkB,EAAE;AACvH,iCAAiC,YAAY,EAAE,eAAe,EAAE,qBAAqB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACjM,gCAAgC,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AAChI,kCAAkC,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAClG,iCAAiC,aAAa,EAAE,cAAc,EAAE;AAChE,wCAAwC,oBAAoB,EAAE,kBAAkB,EAAE;AAClF,+CAA+C,aAAa,EAAE;AAC9D,sCAAsC,oBAAoB,EAAE,kBAAkB,EAAE;AAChF,6CAA6C,aAAa,EAAE;AAC5D,2BAA2B,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,eAAe,EAAE,2CAA2C,EAAE;AACrJ,sDAAsD,eAAe,EAAE;AACvE,8BAA8B,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACvM,qCAAqC,UAAU,EAAE,UAAU,EAAE,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAChH,iCAAiC,oBAAoB,EAAE,kBAAkB,EAAE;AAC3E,2BAA2B,aAAa,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;AACvF,8DAA8D,YAAY,EAAE,oDAAoD,EAAE,eAAe,EAAE,OAAO,EAAE,WAAW,EAAE,cAAc,EAAE;AACzL,gCAAgC,kBAAkB,EAAE,aAAa,EAAE,aAAa,EAAE,eAAe,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AACnJ,+BAA+B,4BAA4B,EAAE,aAAa,EAAE;AAC5E,sCAAsC,aAAa,EAAE;AACrD,6BAA6B,YAAY,EAAE,6BAA6B,EAAE,QAAQ,EAAE,aAAa,EAAE,+BAA+B,EAAE,aAAa,EAAE,cAAc,EAAE;AACnK,oCAAoC,aAAa,EAAE;AACnD,mCAAmC,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACpG,2BAA2B,aAAa,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACvI,uCAAuC,eAAe,EAAE,4BAA4B,EAAE;AACtF,oCAAoC,YAAY,EAAE,OAAO,EAAE;AAC3D,+BAA+B,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC9G,uCAAuC,cAAc,EAAE,gBAAgB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3I,qCAAqC,YAAY,EAAE,0CAA0C,EAAE,OAAO,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,cAAc,EAAE;AACxK,0CAA0C,aAAa,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACpG,4CAA4C,sBAAsB,EAAE,aAAa,EAAE;AACnF,2BAA2B,eAAe,EAAE,YAAY,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC9K,6BAA6B,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,QAAQ,EAAE,eAAe,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC9M,mCAAmC,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9H,qCAAqC,aAAa,EAAE;AACpD,kCAAkC,mBAAmB,EAAE,kBAAkB,EAAE,OAAO,EAAE,QAAQ,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AACtK,yCAAyC,uBAAuB,EAAE,gBAAgB,EAAE;AACpF,0CAA0C,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE,4CAA4C,EAAE;AACvI,kCAAkC,iBAAiB,EAAE,QAAQ,EAAE,oDAAoD,EAAE,UAAU,EAAE;AACjI,6CAA6C,8BAA8B,EAAE;AAC7E,mCAAmC,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnG,gCAAgC,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,sCAAsC,EAAE,kBAAkB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACzM,iFAAiF,aAAa,EAAE;AAChG,0CAA0C,cAAc,EAAE;AAC1D,wCAAwC,cAAc,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACrG,gCAAgC,8BAA8B,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACxH,2DAA2D,YAAY,EAAE,YAAY,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzH,iCAAiC,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACpI,uCAAuC,YAAY,EAAE,uEAAuE,EAAE,QAAQ,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,cAAc,EAAE;AAC5M,mEAAmE,wFAAwF,EAAE;AAC7J,kDAAkD,eAAe,EAAE;AACnE,mDAAmD,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACjJ,wCAAwC,aAAa,EAAE;AACvD,2BAA2B,cAAc,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC5G,mCAAmC,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACtH,0BAA0B,YAAY,EAAE,OAAO,EAAE,QAAQ,EAAE,wBAAwB,EAAE;AACrF,6BAA6B,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9J,qEAAqE,aAAa,EAAE;AACpF,kCAAkC,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE;AACjF,+BAA+B,YAAY,EAAE,+CAA+C,EAAE,OAAO,EAAE,eAAe,EAAE;AACxH,0BAA0B,YAAY,EAAE,WAAW,EAAE,qBAAqB,EAAE,OAAO,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACxK,+BAA+B,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACzG,iCAAiC,sBAAsB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACzG,yBAAyB,YAAY,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,OAAO,EAAE,aAAa,EAAE,iBAAiB,EAAE;AACvK,gCAAgC,aAAa,EAAE,cAAc,EAAE;AAC/D,8BAA8B,YAAY,EAAE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE;AACnL,0BAA0B,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,QAAQ,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AACtM,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE,OAAO,EAAE,QAAQ,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5J,2DAA2D,kBAAkB,EAAE;AAC/E;EACE,0EAA0E,iBAAiB,EAAE,kBAAkB,EAAE;EACjH,yBAAyB,YAAY,EAAE;EACvC,4BAA4B,sBAAsB,EAAE,qBAAqB,EAAE,OAAO,EAAE;EACpF,yBAAyB,cAAc,EAAE;EACzC,6BAA6B,cAAc,EAAE;EAC7C,+BAA+B,yBAAyB,EAAE;EAC1D,8CAA8C,yBAAyB,EAAE;EACzE,kOAAkO,kDAAkD,EAAE,cAAc,EAAE,OAAO,EAAE,eAAe,EAAE;EAChU,8FAA8F,yCAAyC,EAAE;EACzI,wFAAwF,yDAAyD,EAAE;EACnJ,mCAAmC,yBAAyB,EAAE,OAAO,EAAE;EACvE,4DAA4D,yBAAyB,EAAE,OAAO,EAAE;EAChG,qCAAqC,yBAAyB,EAAE,OAAO,EAAE;EACzE,6BAA6B,sBAAsB,EAAE,qBAAqB,EAAE;EAC5E,2BAA2B,+CAA+C,EAAE;EAC5E,uCAAuC,sEAAsE,EAAE,OAAO,EAAE,cAAc,EAAE;EACxI,mEAAmE,sFAAsF,EAAE;AAC7J;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB;qDACmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0EAA0E;EAC1E,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,6DAA6D;EAC7D,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,uCAAuC;EACvC,8BAA8B;EAC9B,wEAAwE;EACxE,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;EAC/B,yCAAyC;EACzC,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;;AAEA,+DAA+D;AAC/D;EACE,mCAAmC;EACnC,uCAAuC;EACvC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE;IACE,oCAAoC;IACpC,wCAAwC;IACxC,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA,sBAAsB;AACtB,aAAa,YAAY,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,aAAa,CAAC,aAAa,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kDAAkD,CAAC,kBAAkB,CAAC,UAAU,CAAC,0CAA0C,CAAC,kBAAkB,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,gCAAgC,CAAC,cAAc,CAAC,eAAe,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,UAAU,CAAC,yCAAyC,gBAAgB,CAAC,cAAc,CAAC,eAAe,CAAC,uCAAuC,QAAQ,CAAC,2BAA2B,CAAC,gBAAgB,gBAAgB,CAAC,eAAe,CAAC,sBAAsB,aAAa,CAAC,cAAc,CAAC,wBAAwB,CAAC,eAAe,CAAC,iBAAiB,CAAC,8BAA8B,eAAe,CAAC,cAAc,eAAe,CAAC,kBAAkB,CAAC,2CAA2C,gBAAgB,CAAC,qBAAqB,YAAY,CAAC,mCAAmC,CAAC,QAAQ,CAAC,aAAa,CAAC,cAAc,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,mBAAmB,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,qBAAqB,aAAa,CAAC,cAAc,CAAC,cAAc,CAAC,0BAA0B,wBAAwB,CAAC,uBAAuB,wBAAwB,CAAC,qBAAqB,wBAAwB,CAAC,mBAAmB,YAAY,CAAC,oDAAoD,CAAC,QAAQ,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,uBAAuB,YAAY,CAAC,OAAO,CAAC,kBAAkB,CAAC,aAAa,CAAC,iCAAiC,WAAW,CAAC,iCAAiC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,wBAAwB,QAAQ,CAAC,cAAc,CAAC,0BAA0B,aAAa,CAAC,cAAc,CAAC,qBAAqB,aAAa,CAAC,mBAAmB,aAAa,CAAC,cAAc,UAAU,CAAC,wBAAwB,CAAC,eAAe,CAAC,iBAAiB,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,eAAe,CAAC,kBAAkB,CAAC,iBAAiB,iBAAiB,CAAC,4BAA4B,CAAC,cAAc,CAAC,qBAAqB,CAAC,uBAAuB,cAAc,CAAC,0BAA0B,CAAC,6BAA6B,kBAAkB,CAAC,wBAAwB,aAAa,CAAC,uBAAuB,aAAa,CAAC,oBAAoB,QAAQ,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe,CAAC,SAAS,CAAC,cAAc,CAAC,oDAAoD,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,eAAe,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,kBAAkB,CAAC,aAAa,CAAC,eAAe,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,kBAAkB,CAAC,aAAa,CAAC,mBAAmB,cAAc,CAAC,aAAa,aAAa,CAAC,oBAAoB,aAAa,CAAC,iBAAiB,aAAa,CAAC,eAAe,aAAa,CAAC,8BAA8B,iBAAiB,CAAC,iBAAiB,CAAC,aAAa,CAAC,kBAAkB,cAAc,CAAC,aAAa,CAAC,iBAAiB,iBAAiB,CAAC,aAAa,CAAC,gBAAgB,kBAAkB,CAAC,sBAAsB,YAAY,CAAC,sBAAsB,CAAC,QAAQ,CAAC,kBAAkB,CAAC,cAAc,CAAC,mCAAmC,aAAa,CAAC,aAAa,CAAC,kBAAkB,CAAC,wBAAwB,aAAa,CAAC,oBAAoB,YAAY,CAAC,uDAAuD,CAAC,QAAQ,CAAC,cAAc,YAAY,CAAC,oBAAoB,eAAe,CAAC,oBAAoB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,kBAAkB,CAAC,eAAe,CAAC,aAAa,CAAC,sBAAsB,eAAe,CAAC,aAAa,CAAC,oBAAoB,CAAC,kBAAkB,YAAY,CAAC,mCAAmC,CAAC,QAAQ,CAAC,gBAAgB,CAAC,eAAe,CAAC,4BAA4B,CAAC,wBAAwB,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,iBAAiB,CAAC,yBAAyB,cAAc,CAAC,iBAAiB,gBAAgB,CAAC,aAAa,CAAC,gBAAgB,YAAY,CAAC,QAAQ,CAAC,cAAc,CAAC,+BAA+B,CAAC,uBAAuB,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,uBAAuB,cAAc,CAAC,sBAAsB,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,kBAAkB,cAAc,CAAC,aAAa,CAAC,oBAAoB,CAAC,mCAAmC,cAAc,CAAC,aAAa,CAAC,iBAAiB,CAAC,cAAc,CAAC,qBAAqB,YAAY,CAAC,QAAQ,CAAC,oBAAoB,CAAC,eAAe,CAAC,mCAAmC,QAAM,CAAC,uBAAuB,YAAY,CAAC,mCAAmC,CAAC,QAAQ,CAAC,gBAAgB,CAAC,2CAA2C,gBAAgB,CAAC,eAAe,CAAC,wDAAwD,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,wEAAwE,cAAc,CAAC,eAAe,CAAC,mCAAmC,kBAAkB,CAAC,UAAU,CAAC,0CAA0C,UAAU,CAAC,SAAS,CAAC,iCAAiC,YAAY,CAAC,QAAQ,CAAC,mCAAmC,4BAA4B,CAAC,4BAA4B,QAAQ,CAAC,iBAAiB,gBAAgB,CAAC,yBAAyB,mBAAmB,mCAAmC,CAAC,uBAAuB,gBAAgB,CAAC,gBAAgB,eAAe,CAAC,CAAC,wBAAwB,aAAa,YAAY,CAAC,aAAa,sBAAsB,CAAC,cAAc,CAAC,YAAY,CAAC,gBAAgB,UAAU,CAAC,gBAAgB,CAAC,cAAc,gBAAgB,CAAC,qBAAqB,mCAAmC,CAAC,mBAAmB,6BAA6B,CAAC,oBAAoB,yBAAyB,CAAC,oBAAoB,aAAa,CAAC,uBAAuB,yBAAyB,CAAC,sBAAsB,qBAAqB,CAAC,OAAO,CAAC,yBAAyB,cAAc,CAAC;AAC1/M,eAAe,gBAAgB,EAAE;AACjC,oBAAoB,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,OAAO,CAAC,iBAAiB,CAAC,2BAA2B,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,CAAC,eAAe,CAAC,gCAAgC,oBAAoB,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,wBAAwB,cAAc,CAAC,aAAa,CAAC,iBAAiB,CAAC,2BAA2B,aAAa,CAAC,cAAc,CAAC,yBAAyB,cAAc,CAAC,0BAA0B,cAAc,CAAC,sBAAsB,6BAA6B,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,oBAAoB,CAAC,wBAAwB,CAAC,yBAAyB,CAAC,cAAc,CAAC,4BAA4B,YAAY,CAAC,uBAAuB,YAAY,CAAC,OAAO,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,+BAA+B,YAAY,CAAC,6BAA6B,CAAC,aAAa,CAAC,cAAc,CAAC,oCAAoC,aAAa,CAAC,sBAAsB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,gBAAgB,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,WAAW,CAAC,0BAA0B,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,2BAA2B,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,aAAa,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,0BAA0B,WAAW,CAAC,QAAM,CAAC,yDAAyD,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,6BAA6B,cAAc,CAAC,aAAa,CAAC,4BAA4B,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,mFAAmF,QAAQ,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,WAAW,CAAC,mEAAmE,aAAa,CAAC,wBAAwB,iBAAiB,CAAC,WAAW,CAAC,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,6BAA6B,iBAAiB,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,8BAA8B,iBAAiB,CAAC,SAAS,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc,CAAC,0BAA0B,aAAa,CAAC,wBAAwB,YAAY,CAAC,OAAO,CAAC,wBAAwB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,WAAW,CAAC,2BAA2B,UAAU,CAAC,WAAW,CAAC,SAAS,CAAC,QAAQ,CAAC,iBAAiB,CAAC,eAAe,CAAC,kBAAkB,CAAC,cAAc,CAAC,aAAa,CAAC,+BAA+B,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,6BAA6B,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,wBAAwB,WAAW,CAAC,QAAM,CAAC,6DAA6D,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,+BAA+B,cAAc,CAAC,aAAa,CAAC,8BAA8B,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,4BAA4B,aAAa,CAAC,kCAAkC,aAAa,CAAC,wCAAwC,YAAY,CAAC,sBAAsB,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,0CAA0C,iBAAiB,CAAC,yCAAyC,cAAc,CAAC,wBAAwB,0BAA0B,gBAAgB,CAAC;AAC7nH,mCAAmC,eAAe,CAAC,uBAAuB,CAAC,oCAAoC,eAAe,CAAC,eAAe,CAAC,iCAAiC,6BAA6B,CAAC,eAAe,CAAC,uBAAuB,6CAA6C,CAAC,gBAAgB,CAAC,eAAe,CAAC,+BAA+B,gBAAgB,CAAC,sBAAsB,WAAW,CAAC,YAAY,CAAC,6CAA6C,CAAC,kBAAkB,CAAC,qDAAqD,UAAU,CAAC,WAAW,CAAC,6BAA6B,cAAc,CAAC,4BAA4B,aAAa,CAAC,wBAAwB,mCAAmC,uBAAuB,CAAC,eAAe,CAAC,uBAAuB,yBAAyB,CAAC;AAC1xB,mCAAmC,sBAAsB,CAAC,QAAQ;AAClE,kCAAkC,8BAA8B,CAAC,wDAAwD,cAAc,CAAC,uBAAuB,4BAA4B,CAAC,+BAA+B,CAAC,qCAAqC,+BAA+B;AAChS,sBAAsB,YAAY,CAAC,kDAAkD,CAAC,kBAAkB,CAAC,QAAQ,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,4BAA4B,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,+BAA+B,WAAW,CAAC,6BAA6B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,iBAAiB,CAAC,iDAAiD,cAAc,CAAC,eAAe,CAAC,kCAAkC,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,iCAAiC,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,6BAA6B,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,0FAA0F,kBAAkB,CAAC,mCAAmC,aAAa,CAAC,wBAAwB,sBAAsB,6CAA6C,CAAC,QAAQ,CAAC,YAAY,CAAC,4BAA4B,UAAU,CAAC,WAAW,CAAC,6BAA6B,gBAAgB,CAAC,kCAAkC,cAAc,CAAC,mCAAmC,gBAAgB,CAAC,uCAAuC,gBAAgB,CAAC;AACv5C,sBAAsB,iBAAiB,CAAC,eAAe,CAAC,kDAAkD,CAAC,iBAAiB,CAAC,sEAAsE,CAAC,QAAQ,CAAC,UAAU,CAAC,yCAAyC,CAAC,4BAA4B,UAAU,CAAC,iBAAiB,CAAC,SAAS,CAAC,SAAS,CAAC,WAAW,CAAC,YAAY,CAAC,sCAAsC,CAAC,iBAAiB,CAAC,8EAA8E,CAAC,mBAAmB,CAAC,wBAAwB,iBAAiB,CAAC,SAAS,CAAC,mCAAmC,UAAU,CAAC,oBAAoB,CAAC,eAAe,CAAC,yCAAyC,aAAa,CAAC,4BAA4B,UAAU,CAAC,WAAW,CAAC,sCAAsC,CAAC,gCAAgC,CAAC,UAAU,CAAC,6BAA6B,iBAAiB,CAAC,qCAAqC,2BAA2B,CAAC,mBAAmB,CAAC,0CAA0C,gCAAgC,CAAC,UAAU,CAAC,sCAAsC,CAAC,kCAAkC,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,iCAAiC,2BAA2B,CAAC,6BAA6B,iBAAiB,CAAC,4CAA4C,gBAAgB,CAAC,kBAAkB,CAAC,gCAAgC,CAAC,UAAU,CAAC,qCAAqC,CAAC,8CAA8C,gBAAgB,CAAC,uCAAuC,aAAa,CAAC,wBAAwB,sBAAsB,6CAA6C,CAAC,YAAY,CAAC,4BAA4B,UAAU,CAAC,WAAW,CAAC,kCAAkC,cAAc,CAAC,6BAA6B,cAAc,CAAC;AACjxD,yBAAyB,aAAa,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,wBAAwB,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,2BAA2B,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,kBAAkB,CAAC,0BAA0B,gBAAgB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc,CAAC,eAAe,CAAC,gCAAgC,oBAAoB,CAAC,aAAa,CAAC,sCAAsC,oBAAoB,CAAC,kBAAkB,CAAC,aAAa,CAAC,wCAAwC,CAAC,kCAAkC,kBAAkB,CAAC,8BAA8B,cAAc,CAAC,wBAAwB,yBAAyB,gBAAgB,CAAC;AACvwB,uBAAuB,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,mBAAmB,CAAC,cAAc,CAAC,eAAe,CAAC,kBAAkB,CAAC,oBAAoB,kBAAkB,CAAC,aAAa,CAAC,kBAAkB,kBAAkB,CAAC,aAAa,CAAC,wBAAwB,kBAAkB,CAAC,aAAa,CAAC,yBAAyB,eAAe,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,2BAA2B,gBAAgB,CAAC,aAAa,CAAC,cAAc,CAAC,oBAAoB,CAAC,+BAA+B,aAAa,CAAC,cAAc,CAAC,mCAAmC,kBAAkB,CAAC,WAAW,CAAC,mBAAmB,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,aAAa,CAAC,cAAc,CAAC,uBAAuB,aAAa,CAAC,cAAc,CAAC,mBAAmB,aAAa,CAAC,cAAc,gBAAgB,CAAC,mBAAmB,mDAAmD,CAAC,kBAAkB,6CAA6C,CAAC,yBAAyB,mBAAmB,mCAAmC,CAAC;AACjjC,qCAAqC,cAAc,CAAC,2CAA2C,oBAAoB,CAAC,kBAAkB,CAAC,yCAAyC,CAAC,2CAA2C,yBAAyB,CAAC,kBAAkB;AACxQ;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;IAClB;;;0BAGsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,gDAAgD;IAChD,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,QAAQ;EACR,MAAM;EACN,OAAO;EACP,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["/* .MyMarginCls{\n    margin-top: 100px;\n} */\n @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n:root {\n  /* --oragne-color: #d37c1d; */\n  /* --orange: #fe7f3c; */\n  --font-family: \"Plus Jakarta Sans\", sans-serif;\n  --orange-color: #cd601d;\n  /* --green-color: #49bf2b; */\n  --green-color: #63a211;\n  --red: #ff4d62;\n  --half-red: #d37881;\n  --green: #33c18d;\n  --white: #fff;\n  --black: #000;\n  --primary-black: rgba(0, 0, 0, 0.12);\n  --secondary-black: #212529;\n\n  --primary-blue-color: #293b83;\n  --secondary-blue-color: #3e56bf;\n  --dark-blue: #0e527d;\n  --border-lines: #e1e6e9;\n  --light-blue: #1a87cb;\n  --very-dark-blue: #24397a;\n  --very-dark-elephant-gray: #8f7777;\n  --elephant-dark-grey: #aaa;\n  --light-eleph-light-grey: #e5f0ff;\n  --disabled-light-grey: #e9ecef;\n  --very-light-grey: #d1d1d1;\n  --v-grey-light: #eee;\n  --table-row-bg-light-grey: #fafafa;\n  --box-shadow-color: #8b8084;\n  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);\n  /* linear-gradient(90deg, #031978, #3e56bf) */\n  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);\n  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);\n  --light-blue-gradient-angle: linear-gradient(\n    90deg,\n    #46a4cf 8%,\n    #2f324f 86.9%\n  );\n  --green-gradient: linear-gradient(\n    73.1deg,\n    rgba(34, 126, 34, 1) 8%,\n    rgba(99, 162, 17, 1) 86.9%\n  );\n  /* --roboto-font-family: \"Roboto\", 'Halvetica', sans-serif; */\n  --stickyBackground: #f5f5f5;\n  --borderColor: #c9d1dc;\n}\n\n.OrganizationTableView thead th,\n.CandidateListTableView thead th,\n.DepartmentTableView thead th,\n.JobTableView thead th {\n  background-color: #e6f3ff;\n}\nbody {\n  font-family: var(--font-family);\n}\n\n.CandidateListTableView tbody td {\n  background-color: white;\n}\n\n.job-candidate-table thead th {\n  background-color: #afd6ee !important;\n}\n\n.CandidateTestTablewView thead th {\n  background-color: #4a94da !important;\n  color: #fff !important;\n}\n\n#CreateJobOrder .p-tabmenu-nav.p-reset {\n  border: 0;\n}\n\n#CreateJobOrder .p-tabmenuitem.p-highlight {\n  border-bottom: 2px solid #1a87cb;\n}\n\n#CreateJobOrder .p-tabmenuitem .p-menuitem-link {\n  color: #1a87cb;\n}\n\n.create-job-candidate-panel {\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView {\n  padding: 0 12px 12px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_Table {\n  border: 1px solid #e3ecf7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableHeadRow {\n  background: #eef7ff;\n  border-bottom: 1px solid #d8e8f7;\n  min-height: 44px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableRow {\n  min-height: 52px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableBody {\n  background: #fff;\n}\n\n.create-job-candidate-panel .form-control,\n.create-job-candidate-panel .form-select,\n.create-job-candidate-panel select {\n  min-height: 34px;\n  border-color: #d7e3ef;\n  font-size: 13px;\n}\n\n.create-job-candidate-panel .btn-sm {\n  min-height: 32px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.create-job-candidate-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e6edf8;\n  background: #f8fbff;\n}\n\n.create-job-candidate-count {\n  min-width: 34px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #145b84;\n  background: #e6f3ff;\n  border: 1px solid #b9ddf4;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.create-job-candidate-search {\n  padding: 12px;\n  border-bottom: 1px solid #eef3f8;\n}\n\n.create-job-candidate-search .input-group-text {\n  color: #1a87cb;\n  background: #fff;\n  border-color: #d7e3ef;\n}\n\n.create-job-candidate-search .form-control {\n  border-color: #d7e3ef;\n  font-size: 13px;\n}\n\n.create-job-candidate-list {\n  max-height: 560px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  min-width: 0;\n  padding: 8px;\n  background: #f8fafc;\n}\n\n.create-job-candidate-list > .row {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.create-job-candidate-item {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid #e1e8f0;\n  border-radius: 8px;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;\n}\n\n.create-job-candidate-item:hover,\n.create-job-candidate-item:focus {\n  border-color: #1a87cb;\n  background: #f3f9ff;\n  box-shadow: 0 8px 18px rgba(26, 135, 203, 0.12);\n  transform: translateY(-1px);\n  outline: none;\n}\n\n.create-job-candidate-item.is-selected {\n  border-color: #1a87cb;\n  background: #eaf6ff;\n  box-shadow: inset 4px 0 0 #1a87cb, 0 8px 18px rgba(26, 135, 203, 0.12);\n}\n\n.create-job-candidate-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: #fff;\n  background: #1a87cb;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.create-job-candidate-summary {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.create-job-candidate-name {\n  color: #172033;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.create-job-candidate-meta {\n  color: #6c757d;\n  font-size: 12px;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.create-job-candidate-preview {\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);\n}\n\n.create-job-candidate-preview-header {\n  padding: 14px 16px;\n  background: #f8fbff;\n  border-bottom: 1px solid #e6edf8;\n}\n\n.create-job-candidate-preview-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: #145b84;\n  background: #e6f3ff;\n  border: 1px solid #b9ddf4;\n  font-weight: 700;\n}\n\n.create-job-candidate-preview-meta {\n  color: #6c757d;\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.create-job-candidate-detail-card {\n  background: #fff;\n}\n\n.create-job-candidate-detail-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e6edf8;\n  background: #fff;\n}\n\n.create-job-candidate-detail-tabs .btn {\n  margin: 0;\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n.create-job-candidate-detail-body {\n  padding: 16px;\n}\n\n.create-job-candidate-detail-body .badge {\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px 9px;\n  white-space: normal;\n  text-align: left;\n}\n\n.create-job-candidate-detail-body iframe {\n  min-height: 620px;\n}\n\n.ats-candidate-detail-side {\n  padding: 1rem;\n  border-right: 1px solid #e2e8f0;\n  overflow: hidden;\n  height: 100%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ats-candidate-detail-switch {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 4px;\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #f8fbff;\n  flex: 0 0 auto;\n}\n\n.ats-candidate-detail-switch button {\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.ats-candidate-detail-switch button.active {\n  background: #1a87cb;\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(26, 135, 203, 0.18);\n}\n\n.ats-candidate-detail-content {\n  overflow-y: auto;\n  padding-right: 4px;\n  min-height: 0;\n}\n\n.ats-candidate-detail-fields {\n  display: grid;\n  gap: 8px;\n}\n\n.ats-candidate-detail-field {\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 8px;\n  align-items: flex-start;\n  padding: 9px 10px;\n  border: 1px solid #edf2f7;\n  border-radius: 8px;\n  background: #fbfdff;\n}\n\n.ats-candidate-detail-field i {\n  color: #1a87cb;\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.candidate-modal .candidate-contact-icon,\n.candidate-modal .candidate-contact-icon * {\n  color: #4f46e5 !important;\n  stroke: #4f46e5 !important;\n}\n\n.ats-candidate-detail-field span {\n  display: block;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.2;\n  margin-bottom: 2px;\n}\n\n.ats-candidate-detail-field strong {\n  display: block;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.ats-candidate-detail-content section {\n  font-size: 13px;\n}\n\n.ats-candidate-detail-content section > p {\n  font-size: 11.5px !important;\n  letter-spacing: 0.02em;\n  margin-bottom: 9px !important;\n}\n\n.ats-candidate-detail-content .candidate-contact-icon {\n  width: 14px !important;\n  height: 14px !important;\n  min-width: 14px !important;\n}\n\n.ats-candidate-detail-content .d-flex.align-items-start span,\n.ats-candidate-detail-content .d-flex.align-items-center span {\n  font-size: 13px !important;\n  line-height: 1.4;\n}\n\n.ats-candidate-history-item {\n  font-size: 13px !important;\n  line-height: 1.4;\n}\n\n.ats-candidate-history-item .fw-semibold {\n  font-size: 13.5px !important;\n  line-height: 1.35;\n}\n\n.ats-candidate-history-item .text-muted,\n.ats-candidate-history-item .small {\n  font-size: 12.5px !important;\n  line-height: 1.4;\n}\n\n.expander-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  font-size: 50px;\n  font-weight: bold;\n  user-select: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.expander-bubble:hover {\n  background-color: #e0e0e0;\n  border-radius: 50%;\n  background-color: #f4f4f4;\n  border: 1px solid #d0d0d0;\n}\n\n.CDV_Container {\n  position: relative;\n  width: 70px;\n  height: 70px;\n  border-radius: 12px;\n}\n\n.CDV_Icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n/* #JobOrder_DataTableView .rdt_Table {\n    min-width: 100%;\n} */\n\n#CandidateTest_DataTableView .rdt_Table {\n  /* min-width: 190%; */\n  /* border: 2px solid red; */\n}\n.closeBtn,\n.addBtn {\n  padding: 8px 18px;\n  margin-bottom: 8px;\n  /* font-size: 16px; */\n  font-weight: 700;\n  background: var(--green-gradient);\n  /* box-shadow: 5px 5px 10px var(--very-dark-elephant-gray); */\n  /* text-transform: uppercase; */\n  color: var(--white) !important;\n  /* border: 0; */\n  /* font-family: 'Mukta', sans-serif; */\n}\n\n.addBtn:hover {\n  box-shadow: -1px 1px 5px 5px var(--box-shadow-color);\n}\n.blueBtn {\n  background: var(--blue-gradient-right) !important;\n  color: var(--white) !important;\n  font-weight: 700;\n  margin: 10px;\n}\n.candidate-status-modal-header .btn-close {\n  filter: invert(1) grayscale(100%) brightness(200%);\n  opacity: 0.95;\n}\n.candidate-status-modal-header .btn-close:hover {\n  opacity: 1;\n}\n.talent-scan-view-result-btn {\n  min-width: 82px;\n  height: 34px;\n  margin: 0;\n  white-space: nowrap;\n  line-height: 1.2;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.talent-scan-view-result-btn:hover,\n.talent-scan-view-result-btn:focus {\n  font-size: 15px;\n}\n.searchIconBtn {\n  background: var(--blue-gradient-right) !important;\n  color: var(--white) !important;\n  font-weight: 700;\n}\n\n.candidate-name-with-initials {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  min-height: 44px;\n  padding: 4px 0;\n}\n\n.candidate-name-initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  flex: 0 0 30px;\n  margin-top: 0;\n  padding: 0;\n  box-sizing: border-box;\n  border-radius: 50%;\n  background: #f3e8ff;\n  color: #7e22ce;\n  border: 0;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0;\n  text-decoration: none;\n}\n\n.candidate-name-with-initials > span:last-child {\n  flex: 1 1 auto;\n  min-width: 0;\n  line-height: 1.25;\n  white-space: normal;\n  overflow-wrap: break-word;\n  font-size: 14px;\n}\n\n.expander-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  font-size: 50px;\n  font-weight: bold;\n  user-select: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.expander-bubble:hover {\n  background-color: #e0e0e0;\n  border-radius: 50%;\n  background-color: #f4f4f4;\n  border: 1px solid #d0d0d0;\n}\n#JobOrderTableView .rdt_TableCol:nth-child(1),\n#JobOrderTableView .rdt_TableCol:nth-child(3),\n#JobOrderTableView .rdt_TableCol:nth-child(5) {\n  justify-content: initial;\n  text-align: center;\n}\n#JobOrderTableView .sc-hJRrWL .rdt_TableCell,\n#JobOrderTableView .sc-hJRrWL .rdt_TableCell span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#JobOrderTableView,\n#JobOrderTableView .rdt_Table,\n#JobOrderTableView .rdt_TableHead,\n#JobOrderTableView .rdt_TableBody,\n#JobOrderTableView .rdt_TableRow {\n  width: 100% !important;\n}\n\n#JobOrderTableView .rdt_Table,\n#JobOrderTableView .rdt_TableBody {\n  overflow-x: hidden !important;\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol {\n  padding: 8px 8px !important;\n}\n\n#JobOrderTableView a.job-order-title-link,\n#JobOrderTableView a.job-order-title-link > span {\n  text-decoration-line: underline !important;\n  text-decoration-thickness: 1px !important;\n  text-underline-offset: 2px !important;\n}\n\n@media (min-width: 1200px) {\n  #JobOrderTableView .rdt_TableHeadRow > .rdt_TableCol,\n  #JobOrderTableView .rdt_TableRow > .rdt_TableCell {\n    flex-shrink: 1 !important;\n    min-width: 0 !important;\n  }\n\n  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > div,\n  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > a {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  #JobOrderTableView .rdt_TableRow > .rdt_TableCell > a {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol,\n#JobOrderTableView .rdt_TableHead .rdt_TableCol > div {\n  min-width: 0;\n  justify-content: center;\n  overflow: visible;\n  white-space: normal;\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol .fs-6 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  font-size: 14px !important;\n  line-height: 1.2;\n  text-align: center;\n  white-space: normal;\n}\n\n#JobOrderTableView .addCandidateHeaderBtn {\n  width: 100%;\n  min-width: 0;\n  padding: 0 !important;\n  justify-content: center;\n  white-space: normal;\n  line-height: 1.2;\n}\n\n#JobOrderTableView .addCandidateHeaderBtn .ms-1 {\n  margin-left: 0 !important;\n}\n\n#JobOrderTableView .job-order-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 28px;\n  width: 100%;\n}\n\n#JobOrderTableView .job-order-actions-cell .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0 !important;\n}\n/* #JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM{\n        padding-left: 8px;\n    padding-right: 4px;\n    border-right: 1px solid var(--border-lines);\n    border-bottom: 1px solid var(--border-lines);\n} */\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  border-right: 1px solid var(--border-lines);\n  border-bottom: 1px solid var(--border-lines);\n  /* border-right: 1px solid blue;\n  border-bottom: 1px solid blue; */\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell span {\n  /* width: 90%; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM:first-child {\n  border-left: 1px solid var(--border-lines);\n}\n\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11), */\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10), */\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(12),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2){\n  justify-content: center;\n}\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {\n  font-weight: 500;\n}\n\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) span {\n  font-weight: 500;\n  background-color: #ebe9e9;\n  border-radius: 0.375rem;\n} */\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) {\n  font-weight: 500;\n}\n\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(6),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(8),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(15),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(17),\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13), */\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(16),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(9) {\n  justify-content: center;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5) {\n  justify-content: center;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(16),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(14),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(17),\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15), */\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6) {\n  justify-content: center;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {\n  justify-content: start !important;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div {\n  width: 95%;\n  /* border: 2px solid red; */\n}\n\n/* \n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div > span {\n  border: 2px solid red;\n} */\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div span {\n  width: 180px;\n}\n\n#CalendarScheduled_TableView tbody tr td:nth-child(2) {\n  text-align: center !important;\n}\n\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9) {\n  border: 2px solid red;\n} */\n/* MobilePhoneContaier */\n\n/* #CalendarScheduled_TableView tbody tr td:nth-child(4) {\n  border: 2px solid red;\n  white-space: nowrap;\n  width: 150px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n} */\n\n#CandidateTest_DataTableView {\n  /* Chandu */\n}\n\n#CandidateTest_DataTableView .rdt_TableHeadRow {\n  min-height: 52px;\n}\n\n#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol {\n  align-items: center;\n  justify-content: center;\n  padding: 8px 8px !important;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol > div {\n  min-width: 0;\n  justify-content: center;\n  white-space: normal;\n}\n\n#CandidateTest_DataTableView .ColumnTitle,\n#CandidateTest_DataTableView .font_15 {\n  font-size: 14px !important;\n  line-height: 1.15;\n  text-align: center;\n  white-space: normal;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableRow {\n  min-height: 40px;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell {\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 5px 8px !important;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell > div {\n  min-width: 0;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(2),\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(3),\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(4) {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(9) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(10) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(11) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(12) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(13) > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n#CandidateTest_DataTableView .job-candidate-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n}\n\n#CandidateTest_DataTableView .job-candidate-actions-cell .btn,\n#CandidateTest_DataTableView .job-candidate-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0 !important;\n  margin: 0 !important;\n  line-height: 1;\n}\n\n#CandidateTest_DataTableView .job-candidate-actions-cell svg,\n#CandidateTest_DataTableView .job-candidate-action-btn svg {\n  display: block;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-sent {\n  margin: 0 !important;\n  min-width: 42px;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-history {\n  display: block;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: #333;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-resend {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1a5fa8;\n  cursor: pointer;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-resend:hover {\n  color: #0c447c;\n}\n\n#CandidateTest_DataTableView .job-candidate-hrms-resend:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.candidate-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n}\n.candidate-modal .modal-header {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.bg-light-subtle {\n  background-color: #f8f9fa !important;\n}\n\n.candidate-modal .border {\n  border-color: #dee2e6 !important;\n}\n\n.candidate-modal strong {\n  /* min-width: 160px; */\n  display: inline-block;\n}\n\n.candidate-modal .badge {\n  font-size: 0.85rem;\n  padding: 0.4em 0.8em;\n  border-radius: 12px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.modal-content {\n  background: white;\n  /* padding: 20px; */\n  border-radius: 8px;\n  width: 400px;\n  /* max-width: 90%; */\n  border: 0px !important;\n}\n.modal-content h3 {\n  margin-top: 0;\n}\n.modal-content textarea {\n  width: 100%;\n  margin: 10px 0;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.modal-buttons button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.modal-buttons button:first-child {\n  background: #ccc;\n}\n.modal-buttons button:last-child {\n  background: #3b82f6;\n  color: white;\n}\n\n#ExistingCandidate_MultiSel .searchWrapper {\n  display: flex;\n  overflow-x: auto;\n  padding: 0.1375rem 0.75rem !important;\n  border-radius: 0.375rem !important;\n  font-size: 0.875rem;\n  height: 34px;\n}\n\n#ExistingCandidate_MultiSel .chip {\n  position: absolute;\n  left: 10px;\n  cursor: pointer;\n}\n\n#ExistingCandidate_MultiSel input::placeholder {\n  position: absolute;\n  bottom: 1px;\n  left: 0px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--secondary-black);\n}\n\n.JobTimeLineContainer {\n  position: relative;\n  border-left: 2px solid #1a87cb;\n}\n\n.JobTimeLineBlock {\n  position: relative;\n}\n\n.JobTimeLineBlock::before {\n  position: absolute;\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background-color: #1a87cb;\n  border-radius: 50%;\n}\n.JobTimeLineBlock::after {\n  position: absolute;\n  top: 8px;\n  /* right: 98%; */\n  right: 97.7%;\n  content: \"\";\n  width: 18px;\n  height: 2px;\n  border: 2px solid #1a87cb;\n}\n\n.CandyTimeLine_ActionType,\n.JobTimeLine_ActionType {\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.CandyTimeLine_CreaedBy,\n.CandyTimeLine_ActionDateTime,\n.JobTimeLine_CreaedBy,\n.JobTimeLine_ActionDateTime {\n  font-weight: 500;\n  font-size: 0.75rem !important;\n  color: #b1b0b0;\n}\n\n.CandyTimeLine_Actioned_By,\n.JobTimeLine_Actioned_By {\n  font-weight: 400;\n  font-size: 0.75rem !important;\n}\n\n.TimeStamp {\n  position: absolute;\n  right: 0;\n  top: 0;\n  text-align: center;\n  background-color: #1a87cb;\n  color: #fff;\n}\n\n#JobOrderTableView header {\n  min-height: 1px;\n}\n\n.bg_blue {\n  background-color: #1a87cb;\n}\n.skill-tag {\n  background-color: #e9ecef;\n  padding: 0.35rem 0.75rem;\n  border-radius: 8px;\n  display: inline-block;\n  margin-right: 0.5rem;\n  margin-bottom: 0.4rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n.skill-box {\n  border: 1px solid #dee2e6;\n  padding: 0.9rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  background-color: #fdfdfd;\n}\n\ninput::-ms-reveal {\n  display: none;\n}\n.section-title {\n  color: #0e527d;\n  font-weight: 600;\n}\n.calendar-container {\n  height: 650px;\n}\n.calendar-cell {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  padding: 3px;\n  border-right: 1px solid #ddd;\n}\n.event-block {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  padding: 6px;\n  border-radius: 4px;\n  margin-top: 20px;\n  height: 80px;\n  overflow-y: auto;\n}\n.event-item {\n  background: white;\n  border: 1px solid #b6d4fe;\n  padding: 4px;\n  margin-bottom: 4px;\n  border-radius: 3px;\n}\n\n.event-item div {\n  font-size: 12px;\n}\n.event-join-link {\n  font-size: 12px;\n  color: #0d6efd;\n}\n.event-no-link {\n  font-size: 11px;\n  color: #888;\n}\n\n/* .event-more-btn {\n  font-size: 11px !important;\n  padding: 0 !important;\n  text-decoration: underline;\n} */\n.event-box {\n  max-height: 80px;\n  overflow-y: auto;\n}\n.rbc-day-cell {\n  padding: 4px;\n}\n\n.rbc-time-view .rbc-row {\n  min-height: initial;\n  height: 80px;\n  overflow-y: visible;\n}\n\n/* Calendar container height */\n.calendar-container {\n  height: 80vh;\n}\n\n/* Enable scrolling in Week & Day view */\n.rbc-time-view,\n.rbc-time-content {\n  overflow-y: auto !important;\n}\n\n/* Fix pointer events */\n.calendar-cell,\n.rbc-date-cell,\n.rbc-event,\n.rbc-timeslot-group,\n.rbc-time-slot {\n  pointer-events: auto !important;\n}\n\n.rbc-row-segment {\n  display: block;\n}\n\n.outlook-calendar-page {\n  background: #f4f7fb;\n  min-height: calc(100vh - 80px);\n}\n\n.calendar-modern-page {\n  padding: 20px 24px !important;\n}\n\n.calendar-hero {\n  min-height: 106px;\n  align-items: center;\n  padding-top: 18px;\n  padding-bottom: 18px;\n  margin-bottom: 16px;\n}\n\n.calendar-hero-actions {\n  align-items: flex-end !important;\n  flex-shrink: 0;\n}\n\n.calendar-hero-actions label {\n  margin-bottom: 6px !important;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700 !important;\n}\n\n.calendar-hero-actions .form-select,\n.calendar-hero-actions .ats-company-selector {\n  height: 38px !important;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background-color: #ffffff !important;\n  color: #1f2937 !important;\n  box-shadow: none !important;\n}\n\n.calendar-hero-actions > div {\n  align-items: stretch !important;\n}\n\n.calendar-hero .agent-list-title {\n  align-items: center;\n}\n\n.calendar-hero .agent-list-title h1 {\n  margin-bottom: 2px;\n}\n\n.telephonic-tests-hero {\n  align-items: flex-start;\n  margin-bottom: 14px;\n}\n\n.telephonic-hero-actions {\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  min-width: 0;\n  max-width: none;\n}\n\n.telephonic-tests-hero .telephonic-filter-bar {\n  justify-content: flex-end;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n  flex-wrap: nowrap;\n}\n\n.telephonic-tests-hero .telephonic-filter-group {\n  min-width: 0;\n}\n\n.telephonic-tests-hero .telephonic-filter-group:first-child {\n  flex: 0 1 170px;\n}\n\n.telephonic-tests-hero .telephonic-filter-group:nth-child(2) {\n  flex: 1 1 200px;\n}\n\n.telephonic-tests-hero .job-order-filter-dropdown {\n  min-width: 0;\n}\n\n.telephonic-tests-hero .job-order-filter-dropdown .p-dropdown-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.telephonic-tests-hero .telephonic-filter-group label {\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.telephonic-tests-hero .telephonic-filter-group .form-select,\n.telephonic-tests-hero .telephonic-filter-group .form-control,\n.telephonic-tests-hero .telephonic-filter-group .p-dropdown {\n  height: 36px;\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background-color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.telephonic-tests-hero .telephonic-filter-search-wrap .form-control {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.telephonic-tests-hero .telephonic-filter-reset-btn {\n  height: 36px;\n  border-color: rgba(255, 255, 255, 0.5) !important;\n  background: #ffffff !important;\n  color: #334155 !important;\n  border-radius: 8px !important;\n}\n\n.telephonic-date-error {\n  margin: -6px 0 10px;\n}\n\n.outlook-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 46px 0 16px;\n  padding: 16px 18px;\n  background: #fff;\n  border: 1px solid #dbe5f1;\n  border-radius: 10px;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.outlook-page-title {\n  color: #0f4c81;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.outlook-page-subtitle {\n  color: #64748b;\n  font-size: 13px;\n  margin: 4px 0 0;\n}\n\n.outlook-company-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.outlook-calendar-note {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex: 0 1 auto;\n  max-width: 620px;\n  margin-left: auto;\n  padding: 9px 12px;\n  color: #315b7d;\n  font-size: 12px;\n  line-height: 1.4;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid #cfe0f2;\n  border-left: 3px solid #1a5fa8;\n  border-radius: 7px;\n}\n\n.outlook-calendar-note svg {\n  flex: 0 0 auto;\n  color: #1a5fa8;\n  font-size: 14px;\n}\n\n.outlook-calendar-note strong {\n  color: #0f4c81;\n  font-weight: 700;\n}\n\n.outlook-calendar-container {\n  background: #fff;\n  border: 1px solid #dbe5f1;\n  border-radius: 10px;\n  padding: 14px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);\n}\n\n.calendar-list-table {\n  table-layout: fixed;\n}\n\n.calendar-list-table th:nth-child(1),\n.calendar-list-table td:nth-child(1) { width: 11%; }\n.calendar-list-table th:nth-child(2),\n.calendar-list-table td:nth-child(2) { width: 10%; }\n.calendar-list-table th:nth-child(3),\n.calendar-list-table td:nth-child(3) { width: 9%; }\n.calendar-list-table th:nth-child(4),\n.calendar-list-table td:nth-child(4) { width: 18%; }\n.calendar-list-table th:nth-child(5),\n.calendar-list-table td:nth-child(5) { width: 11%; }\n.calendar-list-table th:nth-child(6),\n.calendar-list-table td:nth-child(6) { width: 11%; }\n.calendar-list-table th:nth-child(7),\n.calendar-list-table td:nth-child(7) { width: 12%; }\n.calendar-list-table th:nth-child(8),\n.calendar-list-table td:nth-child(8) { width: 9%; }\n.calendar-list-table th:nth-child(9),\n.calendar-list-table td:nth-child(9) { width: 9%; }\n\n.calendar-list-table th,\n.calendar-list-table td {\n  min-width: 0 !important;\n  max-width: none;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.calendar-list-table td:nth-child(9) {\n  overflow: visible;\n  white-space: nowrap;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.calendar-archive-table {\n  width: 100%;\n  min-width: 0 !important;\n  table-layout: fixed;\n}\n\n.calendar-archive-table th:nth-child(1),\n.calendar-archive-table td:nth-child(1) { width: 10%; }\n.calendar-archive-table th:nth-child(2),\n.calendar-archive-table td:nth-child(2) { width: 18%; }\n.calendar-archive-table th:nth-child(3),\n.calendar-archive-table td:nth-child(3) { width: 10%; }\n.calendar-archive-table th:nth-child(4),\n.calendar-archive-table td:nth-child(4) { width: 10%; }\n.calendar-archive-table th:nth-child(5),\n.calendar-archive-table td:nth-child(5) { width: 10%; }\n.calendar-archive-table th:nth-child(6),\n.calendar-archive-table td:nth-child(6) { width: 10%; }\n.calendar-archive-table th:nth-child(7),\n.calendar-archive-table td:nth-child(7) { width: 12%; }\n.calendar-archive-table th:nth-child(8),\n.calendar-archive-table td:nth-child(8) { width: 8%; }\n.calendar-archive-table th:nth-child(9),\n.calendar-archive-table td:nth-child(9) { width: 12%; }\n\n.calendar-archive-table th,\n.calendar-archive-table td {\n  min-width: 0 !important;\n  max-width: none;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  vertical-align: middle;\n}\n\n.calendar-archive-table th {\n  white-space: normal !important;\n  line-height: 1.25;\n}\n\n.calendar-archive-table th:first-child,\n.calendar-archive-table td:first-child {\n  padding-left: 16px !important;\n  text-align: left !important;\n}\n\n.outlook-calendar-page {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.outlook-calendar-page .outlook-calendar-container {\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.calendar-archive-table th:nth-child(9),\n.calendar-archive-table td:nth-child(9) {\n  min-width: 0 !important;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  white-space: normal !important;\n}\n\n.calendar-archive-table .archive-reason {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  line-height: 1.45;\n  white-space: normal;\n}\n\n.calendar-archive-table .archive-reason span {\n  display: block;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.calendar-archive-job-cell {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  line-height: 1.45;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.outlook-calendar-toolbar {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 12px;\n  padding: 0 0 14px;\n}\n\n.outlook-calendar-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.outlook-calendar-title-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  background: #e0f2fe;\n  color: #0369a1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.outlook-calendar-title-main {\n  color: #0f172a;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.outlook-calendar-title-sub {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.outlook-calendar-nav,\n.outlook-calendar-views {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.outlook-calendar-nav button,\n.outlook-calendar-views button {\n  height: 34px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 6px;\n  padding: 0 12px;\n  font-weight: 600;\n}\n\n.outlook-calendar-nav button:hover,\n.outlook-calendar-views button:hover,\n.outlook-calendar-views button.active {\n  background: #0f77b4;\n  border-color: #0f77b4;\n  color: #fff;\n}\n\n.outlook-calendar-nav button.today {\n  color: #0f77b4;\n  border-color: #93c5fd;\n  background: #eff6ff;\n}\n\n.outlook-calendar-nav button.today:hover {\n  color: #fff;\n  background: #0f77b4;\n}\n\n.outlook-calendar-container .rbc-header {\n  padding: 9px 6px;\n  background: #f8fafc;\n  color: #334155;\n  font-weight: 700;\n  border-color: #dbe5f1;\n}\n\n.outlook-calendar-container .rbc-month-view,\n.outlook-calendar-container .rbc-time-view {\n  border-color: #dbe5f1;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.outlook-calendar-container .rbc-today {\n  background: #eff6ff;\n}\n\n.outlook-calendar-container .rbc-event {\n  cursor: pointer;\n  margin: 1px 2px;\n  width: calc(100% - 4px);\n}\n\n.outlook-calendar-container .rbc-month-row {\n  overflow: visible;\n}\n\n.outlook-calendar-container .rbc-row-content {\n  z-index: 2;\n}\n\n.outlook-calendar-container .rbc-date-cell {\n  color: #0f172a;\n  font-weight: 600;\n  padding: 3px 6px 2px;\n}\n\n.outlook-calendar-container .rbc-month-view .rbc-day-bg,\n.outlook-calendar-container .rbc-date-cell,\n.outlook-calendar-container .rbc-time-slot,\n.outlook-calendar-container .rbc-timeslot-group {\n  cursor: pointer;\n}\n\n.outlook-calendar-event {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  min-height: 18px;\n  padding: 1px 5px;\n  background: #dbeafe;\n  border: 1px solid #60a5fa;\n  color: #0f172a;\n  font-size: 11px;\n  line-height: 1.25;\n  white-space: normal;\n  overflow: visible;\n  overflow-wrap: anywhere;\n}\n\n.outlook-calendar-event:hover {\n  background: #bfdbfe;\n  border-color: #0f77b4;\n}\n\n.outlook-calendar-event.cancelled {\n  background: #f8fafc;\n  border-color: #94a3b8;\n  color: #475569;\n}\n\n.outlook-calendar-event-time {\n  color: #075985;\n  font-weight: 800;\n  flex: 0 0 auto;\n}\n\n.outlook-calendar-event-text {\n  min-width: 0;\n  overflow: visible;\n  overflow-wrap: anywhere;\n}\n\n.outlook-calendar-container .rbc-event,\n.outlook-calendar-container .rbc-event-content {\n  overflow: visible;\n  white-space: normal;\n}\n\n.outlook-calendar-container .rbc-time-header .rbc-allday-cell {\n  min-height: 28px;\n  max-height: 48px;\n}\n\n.outlook-calendar-container .rbc-time-view .rbc-event-label {\n  display: none;\n}\n\n.outlook-calendar-container .rbc-time-view .rbc-timeslot-group {\n  min-height: 160px;\n}\n\n.outlook-calendar-container .rbc-time-view .rbc-event-content {\n  height: 100%;\n  min-height: 0;\n}\n\n.outlook-calendar-container .rbc-time-view .rbc-event,\n.outlook-calendar-container .rbc-time-view .rbc-event-content {\n  overflow: hidden;\n}\n\n.outlook-calendar-container .rbc-time-view .outlook-calendar-event {\n  height: 100%;\n  min-height: 0;\n  flex-direction: row;\n  gap: 4px;\n  padding: 4px 6px;\n  border-radius: 4px;\n  border-left: 3px solid #087f8c;\n  background: #e4f3f2;\n  font-size: 12px;\n  line-height: 1.3;\n  overflow: hidden;\n}\n\n.outlook-calendar-container .rbc-time-view .outlook-calendar-event.cancelled {\n  background: #f1f3f5;\n  border-left-color: #7b8794;\n}\n\n.outlook-calendar-container .rbc-time-view .outlook-calendar-event-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: break-word;\n}\n\n.outlook-calendar-container .rbc-time-view .outlook-calendar-event-time {\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.calendar-interviews-table-scroll {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden !important;\n}\n\n.calendar-event-actions {\n  min-width: 112px;\n  white-space: nowrap;\n}\n\n.calendar-event-actions > button {\n  flex: 0 0 32px;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calendar-interviews-table {\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  table-layout: fixed !important;\n}\n\n.calendar-interviews-table th,\n.calendar-interviews-table td {\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: 0;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  vertical-align: top;\n  overflow: hidden;\n}\n\n.calendar-interviews-table td > * {\n  max-width: 100%;\n}\n\n.calendar-interviews-table td span {\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n}\n\n.outlook-calendar-container .rbc-today .rbc-date-cell {\n  background: #0f77b4;\n  color: #fff;\n}\n\n.calendar-interview-details-dialog.modal-dialog {\n  width: calc(100vw - 32px);\n  max-width: 1800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.calendar-interview-details-dialog .calendar-interviews-table-scroll {\n  overflow-x: auto !important;\n}\n\n.calendar-interview-details-dialog .calendar-interviews-table {\n  min-width: 1400px !important;\n  table-layout: auto !important;\n}\n\n.calendar-interview-details-dialog .calendar-interviews-table th,\n.calendar-interview-details-dialog .calendar-interviews-table td {\n  max-width: none;\n  white-space: nowrap !important;\n  overflow-wrap: normal;\n  word-break: normal;\n  overflow: visible;\n  padding: 12px 14px;\n}\n\n.calendar-interview-details-dialog .calendar-interviews-table td span {\n  white-space: nowrap !important;\n  overflow-wrap: normal;\n}\n\n.calendar-interview-details-dialog .calendar-interviews-table td:last-child > div {\n  flex-wrap: nowrap !important;\n}\n\n.outlook-agenda-card {\n  border: 1px solid #dbe5f1 !important;\n  border-radius: 10px !important;\n}\n\n.outlook-agenda-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.outlook-summary-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid #dbe5f1;\n  border-radius: 10px;\n  padding: 14px;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);\n}\n\n.outlook-summary-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #e0f2fe;\n  color: #0369a1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.outlook-summary-icon.video {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.outlook-summary-icon.priority {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.outlook-summary-value {\n  color: #0f172a;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.outlook-summary-label {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\n.outlook-agenda-card .p-datatable-thead > tr > th {\n  background: #f8fafc;\n  color: #334155;\n  font-weight: 700;\n  border-color: #dbe5f1;\n}\n\n.outlook-agenda-card .p-datatable-tbody > tr > td {\n  vertical-align: middle;\n  border-color: #e2e8f0;\n}\n\n.outlook-join-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-weight: 700;\n}\n\n#ScreeningConfigTab .p-tabview-nav {\n  display: none;\n}\n\n#CreateJobOrderTabs .p-tabview-nav {\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n  margin-bottom: 4px !important;\n}\n\n#CreateJobOrderTabs .job-tab-header {\n  align-items: center;\n  display: inline-flex;\n  gap: 7px;\n  white-space: nowrap;\n}\n\n#CreateJobOrderTabs .job-tab-header .pi {\n  font-size: 13px;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link,\n#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  align-items: center;\n  background: #ffffff !important;\n  background-image: none !important;\n  border: 1px solid #d8d8d8 !important;\n  border-radius: 4px !important;\n  box-shadow: none !important;\n  color: #171717 !important;\n  margin: 0 0 0 0 !important;\n  padding: 10px 14px !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link:hover,\n#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link:hover {\n  background: #f8fafc !important;\n  border-color: #bfc8d0 !important;\n  color: #171717 !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li .p-tabview-nav-link span,\n#CreateJobOrderTabs .p-tabview-nav li.p-highlight .p-tabview-nav-link span {\n  color: #171717 !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li.p-highlight:not(:first-child) .p-tabview-nav-link {\n  background: #0e527d !important;\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb) !important;\n  border-color: transparent !important;\n  color: #ffffff !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li.p-highlight:not(:first-child) .p-tabview-nav-link span {\n  color: #ffffff !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li:first-child .p-tabview-nav-link {\n  background: #ffffff !important;\n  background-image: none !important;\n  border-color: #d8d8d8 !important;\n  color: #171717 !important;\n}\n\n#CreateJobOrderTabs .p-tabview-nav li.screening-agent-tab-header {\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.create-job-order-page {\n  min-height: calc(100vh - 80px);\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n#CreateJobOrderTabs > .p-tabview-nav-container {\n  position: sticky;\n  top: 69px;\n  z-index: 20;\n  background: #fff;\n  padding-top: 4px;\n}\n\n#CreateJobOrderTabs > .p-tabview-panels {\n  overflow: visible;\n  padding-top: 16px;\n}\n\n#SkillsAndQuestionsBlock .p-accordion-header-text {\n  color: #1a87cb;\n}\n\n#AgentList_TableView {\n  overflow-x: hidden;\n}\n\n#AgentList_TableView .rdt_TableWrapper,\n#AgentList_TableView .rdt_Table,\n#AgentList_TableView .rdt_TableHead,\n#AgentList_TableView .rdt_TableBody {\n  overflow-x: hidden !important;\n}\n\n#AgentList_TableView .rdt_Table,\n#AgentList_TableView .rdt_TableHead,\n#AgentList_TableView .rdt_TableBody,\n#AgentList_TableView .rdt_TableRow {\n  width: 100% !important;\n}\n\n#AgentList_TableView .rdt_TableCol,\n#AgentList_TableView .rdt_TableCell {\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n  border-right: 1px solid #e0e0e0;\n}\n\n#AgentList_TableView .rdt_TableCol > div,\n#AgentList_TableView .rdt_TableCell > div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n#AgentList_TableView .rdt_TableCol > div {\n  justify-content: center !important;\n  text-align: center !important;\n}\n\n#AgentList_TableView .rdt_TableCol .fs-6 {\n  font-size: 14px !important;\n  line-height: 1.15;\n  white-space: normal;\n  text-align: center;\n}\n\n#AgentList_TableView .rdt_TableCell span,\n#AgentList_TableView .rdt_TableCell a {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#AgentList_TableView .rdt_Table,\n#AgentList_TableView .rdt_TableBody {\n  overflow-x: hidden !important;\n}\n\n#AgentList_TableView .rdt_TableHeadRow {\n  min-height: 50px;\n  border-bottom: 1px solid #d7dfe7;\n}\n\n#AgentList_TableView .rdt_TableRow {\n  min-height: 48px;\n  border-bottom: 1px solid #e6e6e6 !important;\n}\n\n#AgentList_TableView .rdt_TableCol:last-child,\n#AgentList_TableView .rdt_TableCell:last-child {\n  justify-content: center;\n  text-align: center;\n  border-right: 0;\n}\n\n#AgentList_TableView .rdt_TableCol:last-child > div,\n#AgentList_TableView .rdt_TableCell:last-child > div {\n  justify-content: center;\n  text-align: center;\n}\n\n#AgentList_TableView .rdt_TableHeadRow .rdt_TableCol:nth-child(11),\n#AgentList_TableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11) {\n  justify-content: center !important;\n  text-align: center !important;\n}\n\n#AgentList_TableView .rdt_TableHeadRow .rdt_TableCol:nth-child(11) > div,\n#AgentList_TableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11) > div {\n  justify-content: center !important;\n  text-align: center !important;\n}\n\n#AgentList_TableView .rdt_Pagination {\n  border-top: 1px solid #e6e6e6;\n}\n\n.agent-page {\n  background: #f4f8fb;\n}\n\n.agent-list-hero,\n.agent-create-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n  border: 1px solid #cfe1f1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);\n  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);\n}\n\n.agent-list-title {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.agent-list-hero-icon {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n}\n\n.agent-list-title h1 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.agent-list-title p {\n  margin: 3px 0 0;\n  color: #dceef8;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.agent-list-count-card {\n  min-width: 132px;\n  padding: 10px 13px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n}\n\n.agent-list-count-card span {\n  display: block;\n  color: #dceef8;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  line-height: 1.2;\n}\n\n.agent-list-count-card strong {\n  display: block;\n  margin-top: 4px;\n  font-size: 21px;\n  line-height: 1;\n}\n\n.agent-list-hero-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agent-list-hero-controls {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  min-width: 0;\n}\n\n.agent-list-hero-controls .agent-list-filter,\n.agent-list-hero-controls .agent-list-search {\n  min-width: 0;\n}\n\n.agent-list-hero-controls .agent-list-filter {\n  width: 260px;\n}\n\n.agent-list-hero-controls .agent-list-search {\n  width: 420px;\n}\n\n.agent-list-hero-controls .agent-list-filter label,\n.agent-list-hero-controls .agent-list-search label {\n  color: #ffffff;\n}\n\n.agent-list-hero-controls .agent-list-create-btn {\n  justify-self: auto;\n}\n\n.agent-list-hero-actions .agent-list-count-card {\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 132px;\n  white-space: nowrap;\n}\n\n.agent-list-hero-actions .agent-list-count-card span,\n.agent-list-hero-actions .agent-list-count-card strong {\n  margin: 0;\n}\n\n.candidate-outcome-page {\n  background: #f4f8fb;\n}\n\n.candidate-outcome-hero {\n  margin-bottom: 18px;\n}\n\n.candidate-outcome-hero-selected {\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);\n}\n\n.candidate-outcome-hero-rejected {\n  background: linear-gradient(100deg, #0f4c81 0%, #7f1d1d 100%);\n}\n\n.candidate-outcome-hero-actions {\n  display: flex;\n  align-items: end;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.candidate-outcome-company {\n  min-width: 270px;\n}\n\n.candidate-outcome-job {\n  min-width: 240px;\n}\n\n.candidate-outcome-company label {\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.candidate-outcome-job label {\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.candidate-outcome-company .form-select,\n.candidate-outcome-company .p-dropdown,\n.candidate-outcome-company select {\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.ats-company-selector.form-select,\n.ats-company-selector {\n  padding-right: 36px !important;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: #ffffff !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23334155' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 12px center !important;\n  background-size: 12px 12px !important;\n}\n\n.candidate-outcome-job .p-dropdown {\n  width: 100%;\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.candidate-outcome-job .p-dropdown-label {\n  display: flex;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n  color: #1f2937;\n  font-size: 13px;\n}\n\n.candidate-outcome-hero .agent-list-count-card {\n  width: 190px;\n  min-width: 190px;\n  min-height: 36px;\n  align-self: center;\n  height: 36px;\n  padding: 6px 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.candidate-outcome-hero .agent-list-count-card span {\n  font-size: 10px;\n  line-height: 1.1;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.candidate-outcome-hero .agent-list-count-card strong {\n  margin-top: 0;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.candidate-all-hero-actions {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.candidate-all-field label {\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.candidate-all-company {\n  width: 270px;\n}\n\n.candidate-all-company .form-select,\n.candidate-all-company .p-dropdown,\n.candidate-all-company select {\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background-color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.candidate-all-company .ats-company-selector.form-select {\n  padding-right: 36px !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23334155' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 12px center !important;\n  background-size: 12px 12px !important;\n}\n\n.candidate-all-search {\n  width: 310px;\n}\n\n.candidate-all-search .input-group {\n  min-height: 36px;\n}\n\n.candidate-all-search .form-control {\n  min-height: 36px;\n  border-radius: 8px 0 0 8px;\n  font-size: 13px;\n}\n\n.candidate-all-search .input-group-text {\n  min-height: 36px;\n  background: #ffffff !important;\n}\n\n.candidate-all-search .searchIconBtn {\n  min-height: 36px;\n  border-radius: 0 8px 8px 0;\n}\n\n.candidate-all-count-card {\n  align-self: flex-end !important;\n  margin-top: 0 !important;\n}\n\n.job-orders-toolbar {\n  display: flex;\n  align-items: end;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 0 8px 10px;\n}\n\n.job-orders-header-field label {\n  margin-bottom: 5px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.job-orders-company {\n  width: 220px;\n}\n\n.job-orders-search {\n  width: 280px;\n}\n\n.job-orders-search .input-group,\n.job-orders-search .form-control,\n.job-orders-search .input-group-text,\n.job-orders-search .searchIconBtn {\n  min-height: 36px;\n}\n\n.job-orders-total-card {\n  min-height: 36px;\n  min-width: 176px;\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 1px solid #cfe1f1;\n  border-radius: 8px;\n  background: #f1f7fc;\n  color: #0f4c81;\n}\n\n.job-orders-total-card span {\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1.1;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.job-orders-total-card strong {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.job-orders-create-btn {\n  min-height: 36px;\n  padding: 7px 14px;\n  white-space: nowrap;\n}\n\n.job-orders-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 0 8px 12px;\n}\n\n.job-orders-filter-bar > div {\n  width: 190px;\n}\n\n.job-orders-filter-strip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 14px 16px;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);\n  border: 1px solid #cfe1f1;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);\n}\n\n.job-orders-filter-left {\n  width: 190px;\n  flex: 0 0 190px;\n}\n\n.job-orders-filter-select.form-select {\n  height: 38px;\n  min-height: 38px;\n  border: 1px solid #d1d9e6 !important;\n  border-radius: 6px !important;\n  background-color: #ffffff !important;\n  color: #1f2937;\n  font-size: 14px;\n  box-shadow: none !important;\n}\n\n.job-orders-filter-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.job-orders-company-inline {\n  flex: 0 0 auto;\n}\n\n.job-orders-company-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.job-orders-company-control label {\n  margin: 0;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.job-orders-company-select {\n  width: 170px;\n}\n\n.job-orders-company-select .ats-company-selector.form-select {\n  height: 38px;\n  min-height: 38px;\n  border: 1px solid #d1d9e6 !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n}\n\n.job-orders-search-inline {\n  width: 220px;\n  flex: 0 0 220px;\n}\n\n.job-orders-search-group {\n  height: 38px;\n  flex-wrap: nowrap;\n}\n\n.job-orders-search-input.form-control {\n  height: 38px;\n  min-height: 38px;\n  border: 1px solid #d1d9e6 !important;\n  border-right: 0 !important;\n  border-radius: 6px 0 0 6px !important;\n  font-size: 14px;\n  box-shadow: none !important;\n}\n\n.job-orders-search-clear.input-group-text {\n  height: 38px;\n  border-color: #d1d9e6 !important;\n  border-left: 0 !important;\n  background: #ffffff !important;\n}\n\n.job-orders-search-btn {\n  width: 42px;\n  height: 38px;\n  min-height: 38px;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  padding: 0 !important;\n  border-radius: 0 6px 6px 0 !important;\n  background: #0f6fa8 !important;\n  color: #ffffff !important;\n}\n\n.job-orders-create-inline {\n  height: 38px;\n  min-height: 38px;\n  padding: 0 16px !important;\n  border-radius: 6px !important;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.job-candidate-filter-row .job-candidate-filter-controls {\n  display: contents !important;\n}\n\n@media (min-width: 1200px) {\n  body.vertical-collpsed .job-candidate-filter-row,\n  body[data-sidebar-size=\"small\"] .job-candidate-filter-row {\n    flex: 0 1 auto !important;\n  }\n  body.vertical-collpsed .job-candidate-send-email,\n  body[data-sidebar-size=\"small\"] .job-candidate-send-email {\n    order: 1 !important;\n    flex-shrink: 0;\n  }\n}\n\n.job-candidate-date-picker { width: 170px; flex: 0 0 170px; }\n.job-website-applicant-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 11px;\n  border: 1px solid #e4d38b;\n  border-radius: 999px;\n  background: #fff9df;\n  color: #705619;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.job-website-applicant-count > span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #80631e;\n  color: #fff;\n  font-size: 12px;\n}\n.job-website-applicant-count small { font-weight: 400; font-size: 11px; }\n.job-candidate-date-picker .job-candidate-date-input {\n  width: 100%;\n  height: 34px;\n  font-size: 12px;\n  color: #1a5fa8;\n  border: 1px solid #1a5fa8;\n  background: #f8fbff;\n}\n\n.job-candidate-filter-row > div:first-child {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.job-candidate-filter-controls > input,\n.job-candidate-filter-controls > select {\n  flex-shrink: 0;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.job-details-redesign {\n  max-width: 960px;\n  width: calc(100% - 32px);\n}\n\n.job-details-redesign .modal-content {\n  border: 1px solid #dce2e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.job-details-redesign .job-info-hero {\n  background: #fff;\n  color: #202b33;\n  padding: 24px 28px;\n  border-bottom: 1px solid #e3e7eb;\n}\n\n.job-details-redesign .job-info-kicker {\n  color: #687580;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0;\n}\n\n.job-details-redesign .job-info-title {\n  color: #202b33;\n  font-size: 23px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.job-details-redesign .job-info-chips {\n  gap: 8px 20px;\n}\n\n.job-details-redesign .job-info-chips span {\n  background: none;\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n  color: #53616b;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.job-details-redesign .job-details-content {\n  padding: 0 28px 16px !important;\n}\n\n.job-details-redesign .job-details-facts {\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  gap: 0 28px !important;\n  margin-bottom: 0 !important;\n}\n\n.job-details-redesign .job-details-fact {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 16px;\n  border: 0 !important;\n  border-bottom: 1px solid #e3e7eb !important;\n  border-radius: 0 !important;\n  padding: 16px 0 !important;\n}\n\n.job-details-redesign .job-details-fact > div:first-child {\n  text-transform: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  margin: 0 !important;\n}\n\n.job-details-redesign .job-details-fact > div:last-child {\n  white-space: normal !important;\n  text-align: right;\n  overflow-wrap: anywhere;\n  font-weight: 600 !important;\n}\n\n.job-details-redesign .job-details-section {\n  border: 0 !important;\n  border-bottom: 1px solid #e3e7eb !important;\n  border-radius: 0 !important;\n  padding: 22px 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.job-details-redesign .job-details-section-title {\n  color: #24343e !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  margin-bottom: 12px !important;\n}\n\n.job-details-redesign .job-details-skill {\n  background: #eef5f2 !important;\n  border: 1px solid #d8e7de !important;\n  color: #315f4c !important;\n  border-radius: 4px !important;\n  font-weight: 500 !important;\n}\n\n.job-details-redesign .job-details-rich-text {\n  font-size: 14px !important;\n  color: #45535d !important;\n  line-height: 1.7 !important;\n  overflow-wrap: anywhere;\n}\n\n.job-details-redesign .job-details-rich-text > :first-child {\n  margin-top: 0;\n}\n\n.job-details-redesign .job-details-rich-text img,\n.job-details-redesign .job-details-rich-text table {\n  max-width: 100%;\n}\n\n.job-details-redesign .job-details-footer {\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 14px 28px;\n}\n\n@media (max-width: 600px) {\n  .job-details-redesign .job-details-facts {\n    grid-template-columns: 1fr !important;\n  }\n  .job-details-redesign .job-info-hero {\n    padding: 20px 16px;\n  }\n  .job-details-redesign .job-details-content {\n    padding: 0 16px 12px !important;\n  }\n  .job-details-redesign .job-info-title {\n    font-size: 20px;\n  }\n  .job-details-redesign .job-details-footer {\n    padding: 12px 16px;\n  }\n}\n\n.job-info-modal-header {\n  min-height: 54px;\n  padding: 14px 20px !important;\n  border-bottom: 1px solid #dbe4f0 !important;\n  background: #ffffff !important;\n  color: #0f172a !important;\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.job-info-modal-header .btn-close {\n  width: 30px;\n  height: 30px;\n  padding: 0 !important;\n  border-radius: 8px;\n  background-color: #eef2f7;\n  opacity: 0.9;\n  background-size: 12px;\n}\n\n.job-info-modal-header .btn-close:hover {\n  background-color: #dbeafe;\n  opacity: 1;\n}\n\n.job-info-hero {\n  padding: 18px 24px 20px;\n  background: linear-gradient(105deg, #0f4c81 0%, #0f766e 100%);\n  color: #ffffff;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.job-info-kicker {\n  margin-bottom: 7px;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.job-info-title {\n  margin: 0;\n  color: #ffffff;\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: 0;\n}\n\n.job-info-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 13px;\n}\n\n.job-info-chips span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 4px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.34);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n@media (max-width: 991px) {\n  .job-orders-filter-strip,\n  .job-orders-filter-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .job-orders-filter-left,\n  .job-orders-company-inline,\n  .job-orders-search-inline,\n  .job-orders-company-select,\n  .job-orders-create-inline {\n    width: 100%;\n    flex: 1 1 auto;\n  }\n\n  .job-orders-company-control {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 6px;\n  }\n}\n\n.org-master-page {\n  background: #f4f8fb;\n}\n\n.org-master-hero {\n  margin-bottom: 16px;\n}\n\n.org-master-actions {\n  display: flex;\n  align-items: end;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n  max-width: none;\n}\n\n.org-master-field {\n  min-width: 190px;\n}\n\n.org-master-company {\n  min-width: 210px;\n}\n\n.org-master-search {\n  min-width: 220px;\n}\n\n.org-master-field label {\n  display: block;\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.org-master-field .form-control,\n.org-master-field .form-select,\n.org-master-field .p-dropdown,\n.org-master-field select {\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 13px;\n}\n\n.org-master-create-btn {\n  min-height: 36px;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 7px 13px !important;\n  border: 1px solid rgba(255, 255, 255, 0.32) !important;\n  border-radius: 8px !important;\n  background: rgba(255, 255, 255, 0.16) !important;\n  color: #ffffff !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  box-shadow: none !important;\n  white-space: nowrap;\n}\n\n.org-master-create-btn:hover {\n  background: rgba(255, 255, 255, 0.24) !important;\n  border-color: rgba(255, 255, 255, 0.46) !important;\n}\n\n.org-master-hero .agent-list-count-card {\n  width: 168px;\n  min-width: 168px;\n  min-height: 36px;\n  height: 36px;\n  padding: 6px 12px;\n  align-self: flex-end;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.org-master-hero .agent-list-count-card span {\n  font-size: 9px;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.org-master-hero .agent-list-count-card strong {\n  margin-top: 0;\n  font-size: 18px;\n  line-height: 1;\n}\n\n@media (max-width: 992px) {\n  .candidate-outcome-hero,\n  .candidate-outcome-hero-actions {\n    align-items: stretch;\n  }\n\n  .candidate-outcome-hero-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .candidate-outcome-company {\n    flex: 1 1 260px;\n  }\n\n  .candidate-all-company,\n  .candidate-all-search {\n    flex: 1 1 260px;\n    width: auto;\n  }\n\n  .job-orders-search,\n  .job-orders-company {\n    flex: 1 1 260px;\n    width: auto;\n  }\n\n  .job-orders-filter-bar > div {\n    flex: 1 1 190px;\n    width: auto;\n  }\n\n  .org-master-hero,\n  .org-master-actions {\n    align-items: stretch;\n  }\n\n  .org-master-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .org-master-field {\n    flex: 1 1 220px;\n  }\n}\n\n.agent-list-toolbar {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 260px 420px auto;\n  align-items: end;\n  gap: 14px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  border: 1px solid #d6e2ee;\n  border-left: 4px solid #0f766e;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.agent-list-toolbar::before {\n  content: \"\";\n  display: block;\n}\n\n.agent-list-filter label,\n.agent-list-search label,\n.agent-create-company label,\n.agent-form-section .form-label {\n  display: block;\n  margin-bottom: 6px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.agent-list-search .form-control,\n.agent-list-filter .form-select,\n.agent-list-filter .p-dropdown,\n.agent-create-company .form-select,\n.agent-create-company .p-dropdown,\n.agent-form-section .form-control,\n.agent-form-section .form-select {\n  min-height: 38px;\n  border-color: #cbd5e1;\n  border-radius: 7px;\n  color: #0f172a;\n  font-size: 14px;\n}\n\n.agent-list-search .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 42px;\n  border-color: #0f766e;\n  background: #0f766e;\n  color: #ffffff;\n}\n\n.agent-list-create-btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  justify-self: end;\n  min-height: 38px;\n  min-width: 178px;\n  padding: 0 18px !important;\n  border-color: #0f4c81 !important;\n  background: #0f4c81 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  white-space: nowrap;\n}\n\n.agent-list-table-card {\n  overflow: hidden;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n}\n\n.agent-list-table-card .rdt_Table {\n  table-layout: fixed;\n}\n\n.agent-list-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.agent-list-avatar {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 1px solid #bde6ff;\n  border-radius: 50%;\n  background: #e8f5ff;\n  color: #075985;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.agent-list-main-name,\n.agent-list-ellipsis,\n.agent-list-link {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 12px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-list-main-name {\n  font-weight: 800;\n}\n\n.agent-list-link {\n  color: #075985;\n  text-decoration: none;\n}\n\n.agent-list-link:hover {\n  color: #0f4c81;\n  text-decoration: underline;\n}\n\n.agent-list-time-pill,\n.agent-list-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  min-width: 76px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.agent-list-time-pill {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #075985;\n}\n\n.agent-list-status-active {\n  border: 1px solid #86efac;\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.agent-list-status-inactive {\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.agent-list-action {\n  width: 31px;\n  height: 31px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d7e3f0;\n  border-radius: 7px;\n  background: #ffffff;\n  cursor: pointer;\n}\n\n.agent-list-action-edit {\n  color: #0f766e;\n}\n\n.agent-list-action-delete {\n  color: #dc2626;\n}\n\n.agent-list-action:hover {\n  background: #edf7ff;\n  border-color: #b7d8f4;\n}\n\n.agent-list-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 160px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.agent-create-hero-actions {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex: 0 0 auto;\n}\n\n.agent-create-company {\n  width: 230px;\n}\n\n.agent-create-company label {\n  color: #e7f3fb;\n}\n\n.agent-create-back-btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 38px;\n  border-color: rgba(255, 255, 255, 0.42) !important;\n  background: rgba(255, 255, 255, 0.14) !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n}\n\n.agent-form-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.agent-form-section {\n  padding: 16px;\n  border: 1px solid #d6e2ee;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);\n}\n\n.agent-form-section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  color: #0f4c81;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.agent-template-textarea {\n  resize: vertical;\n  min-height: 220px;\n  font-family: Consolas, \"Courier New\", monospace;\n  font-size: 12px !important;\n  line-height: 1.45;\n}\n\n.agent-voice-preview {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.agent-form-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  padding: 8px 0 20px;\n}\n\n.agent-form-actions .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 118px;\n  min-height: 38px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n@media (max-width: 991.98px) {\n  .agent-list-hero,\n  .agent-create-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .agent-list-toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .agent-list-create-btn {\n    width: 100%;\n  }\n\n  .agent-list-hero-actions,\n  .agent-list-hero-controls {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .agent-list-hero-controls .agent-list-filter,\n  .agent-list-hero-controls .agent-list-search {\n    width: 100%;\n  }\n\n  .agent-list-hero-actions .agent-list-count-card {\n    width: 100%;\n  }\n\n  .agent-create-hero-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .agent-create-company {\n    width: 100%;\n  }\n}\n\n.candidate-bulk-stage-trigger.btn,\n.candidate-bulk-stage-trigger.btn:hover,\n.candidate-bulk-stage-trigger.btn:focus,\n.candidate-bulk-stage-trigger.btn:active {\n  min-width: 158px;\n  height: 34px;\n  padding: 6px 12px;\n  border: 1px solid #1a5fa8;\n  background: #1a5fa8;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n  white-space: nowrap;\n  transform: none;\n  animation: none;\n  transition: none;\n}\n\n.candidate-bulk-stage-trigger.btn:focus-visible {\n  outline: 2px solid #1a5fa8;\n  outline-offset: 2px;\n}\n\n.settings-option-grid {\n  row-gap: 16px;\n}\n\n.settings-page-shell {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n.settings-page-loader {\n  min-height: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #0f4c81;\n  font-size: 14px;\n  font-weight: 600;\n  background: #ffffff;\n  border: 1px solid #dbe5f1;\n  border-radius: 10px;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);\n}\n\n.settings-page-loader .spinner-border {\n  width: 1.35rem;\n  height: 1.35rem;\n  border-width: 0.18em;\n}\n\n.settings-success-modal .modal-header {\n  position: relative;\n  justify-content: center;\n  text-align: center;\n}\n\n.settings-success-modal .modal-header .modal-title {\n  width: 100%;\n  margin: 0;\n  text-align: center;\n}\n\n.settings-success-modal .modal-header .btn-close {\n  position: absolute;\n  right: 1rem;\n}\n\n.roles-form-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n  padding-bottom: 4px;\n}\n\n.roles-form-actions .p-button {\n  min-width: 110px;\n  justify-content: center;\n}\n\n.link-contacts-select__value-container,\n.interviewer-select__value-container {\n  flex-wrap: nowrap !important;\n  overflow-x: auto !important;\n  overflow-y: hidden !important;\n  scrollbar-width: none;\n}\n\n.link-contacts-select__value-container::-webkit-scrollbar,\n.interviewer-select__value-container::-webkit-scrollbar {\n  display: none;\n}\n\n.link-contacts-select__multi-value,\n.interviewer-select__multi-value {\n  flex: 0 0 auto;\n  max-width: none;\n}\n\n.link-contacts-select__multi-value__label,\n.interviewer-select__multi-value__label {\n  overflow: visible;\n  white-space: nowrap;\n}\n\n.roles-permission-dialog .p-dialog-content {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.role-permission-grid {\n  display: grid !important;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  align-items: start;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.role-permission-item {\n  width: auto !important;\n  max-width: none !important;\n  min-width: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.role-permission-item > .mb-3 {\n  height: auto;\n  margin-bottom: 0 !important;\n  padding: 0 !important;\n  background: #ffffff;\n  border: 1px solid #d7e2ec !important;\n  border-radius: 9px !important;\n  box-shadow: 0 3px 10px rgba(20, 58, 90, 0.06);\n  overflow: hidden;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.role-permission-item > .role-permission-card:hover {\n  border-color: #9fc4df !important;\n  box-shadow: 0 7px 16px rgba(20, 58, 90, 0.11);\n  transform: translateY(-1px);\n}\n\n.role-permission-item .mt-3 {\n  margin-top: 0 !important;\n}\n\n.role-permission-card > .row > div {\n  width: 100%;\n}\n\n.role-permission-card-title {\n  display: flex !important;\n  align-items: center;\n  min-height: 44px;\n  padding: 11px 14px;\n  color: #16496b;\n  font-weight: 700;\n  background: #f2f8fc;\n  border-bottom: 1px solid #dceaf3;\n}\n\n.role-permission-card-title .form-check-input {\n  margin: 0 7px 0 0;\n}\n\n.role-permission-children-wrap {\n  display: block !important;\n  margin: 0 !important;\n  padding: 12px 14px 14px;\n}\n\n.role-permission-children {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 7px 14px;\n  min-width: 0;\n  margin: 0 0 0 18px !important;\n}\n\n.role-permission-child {\n  min-width: 0;\n  margin-top: 0 !important;\n}\n\n.role-permission-child label,\n.role-permission-item > .mb-3 > .row label {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0;\n  min-width: 0;\n  line-height: 1.35;\n  white-space: normal;\n}\n\n.role-permission-child .ms-2,\n.role-permission-item > .mb-3 > .row .ms-2 {\n  margin-left: 0 !important;\n}\n\n@media (max-width: 1200px) {\n  .role-permission-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  .role-permission-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .role-permission-children {\n    grid-template-columns: 1fr;\n  }\n}\n\n.interview-email-audit {\n  flex: 0 0 245px;\n  padding: 9px 12px;\n  border-left: 3px solid #d8e8f6;\n  border-radius: 0 6px 6px 0;\n  background: #f7fbff;\n  color: #6b7a90;\n  font-size: 11px;\n  line-height: 1.6;\n}\n\n.interview-email-audit strong {\n  color: #263442;\n  font-weight: 600;\n}\n\n@media (max-width: 720px) {\n  .interview-email-setting-row {\n    align-items: flex-start !important;\n    flex-wrap: wrap;\n    gap: 12px !important;\n  }\n\n  .interview-email-setting-copy {\n    flex: 1 1 100%;\n  }\n\n  .interview-email-audit {\n    flex: 1 1 100%;\n    width: 100%;\n    border-left: 0;\n    border-top: 3px solid #d8e8f6;\n    border-radius: 0 0 6px 6px;\n  }\n}\n\n.settings-page-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 18px;\n  padding: 18px 20px;\n  border: 1px solid #cfe1f1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);\n  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);\n}\n\n.settings-page-header-icon {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  font-size: 20px;\n}\n\n.settings-page-header h1 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.settings-page-header p {\n  margin: 3px 0 0;\n  color: #dceef8;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.settings-option-card {\n  min-height: 82px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 18px 20px;\n  border: 1px solid #d7dfe7;\n  border-radius: 8px;\n  background: #fff;\n  color: #10263f;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(16, 38, 63, 0.05);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.settings-option-card:hover {\n  border-color: #0d6efd;\n  box-shadow: 0 6px 16px rgba(16, 38, 63, 0.1);\n  transform: translateY(-1px);\n}\n\n.settings-option-icon {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #eaf4ff;\n  color: #0b6fb3;\n  border: 1px solid #cbe4fb;\n  flex: 0 0 auto;\n}\n\n.settings-option-title {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n#CalendarScheduled_TableView {\n  overflow-x: hidden;\n  border-bottom: 0 !important;\n  box-shadow: none !important;\n}\n\n#CalendarScheduled_TableView::after,\n#CalendarScheduled_TableView::before {\n  display: none !important;\n  content: none !important;\n}\n\n#CalendarScheduled_TableView .p-datatable-wrapper {\n  overflow-x: hidden !important;\n  border-bottom: 0 !important;\n  box-shadow: none !important;\n}\n\n#CalendarScheduled_TableView .p-datatable-table {\n  width: 100% !important;\n  table-layout: fixed;\n}\n\n#CalendarScheduled_TableView .p-datatable-thead > tr > th,\n#CalendarScheduled_TableView .p-datatable-tbody > tr > td {\n  text-align: center;\n  vertical-align: middle;\n  padding: 10px 8px;\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#CalendarScheduled_TableView .p-datatable-tbody > tr > td {\n  height: 76px;\n}\n\n#CalendarScheduled_TableView .p-datatable-tbody > tr > td * {\n  max-width: 100%;\n}\n\n#CalendarScheduled_TableView .p-paginator-bottom {\n  border: 0 !important;\n  border-top: 0 !important;\n  border-bottom: 0 !important;\n  box-shadow: none;\n}\n\n#CalendarScheduled_TableView .p-datatable,\n#CalendarScheduled_TableView .p-datatable-wrapper,\n#CalendarScheduled_TableView .p-datatable-scrollable-wrapper,\n#CalendarScheduled_TableView .p-datatable-scrollable-view,\n#CalendarScheduled_TableView .p-datatable-scrollable-body,\n#CalendarScheduled_TableView .p-datatable-footer,\n#CalendarScheduled_TableView .p-paginator,\n#CalendarScheduled_TableView .p-datatable .p-paginator-bottom {\n  border: 0 !important;\n  border-bottom: 0 !important;\n  box-shadow: none !important;\n}\n\n#CalendarScheduled_TableView .icons-btn {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n/* Remove hover background */\n.p-dropdown:not(.p-disabled):hover {\n  box-shadow: none !important;\n  border-color: #ced4da !important;\n}\n\n/* Remove blue focus outline */\n.p-dropdown:focus,\n.p-dropdown:focus-visible,\n.p-dropdown.p-focus {\n  box-shadow: none !important;\n  outline: none !important;\n  border-color: #ced4da !important;\n}\n.p-multiselect .p-multiselect-label {\n  transition: none;\n}\n.p-dropdown-label.p-inputtext.p-placeholder:hover {\n  border-color: inherit !important;\n  box-shadow: none !important;\n  cursor: pointer !important;\n}\n.p-dropdown-label.p-inputtext.p-placeholder {\n  color: black !important ;\n}\n.p-dropdown:not(.p-disabled):hover .p-dropdown-label.p-inputtext.p-placeholder {\n  color: white !important;\n}\n\n/* Default icon color = black */\n.p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon {\n  color: black !important;\n}\n\n/* On hover of the dropdown, icon color = white */\n.p-dropdown:not(.p-disabled):hover\n  .p-dropdown-trigger\n  .p-dropdown-trigger-icon {\n  color: white !important;\n}\n\n.job-access-section .job-access-toolbar { align-items: center; margin-bottom: 16px; }\n.job-question-workspace { row-gap: 16px; }\n.job-questions-empty-state {\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 28px 24px;\n  text-align: center;\n  border: 1px dashed #c9d9df;\n  border-radius: 10px;\n  background: linear-gradient(180deg, #fbfefe 0%, #f1f8f7 100%);\n}\n.job-questions-empty-art {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 64px;\n  height: 64px;\n  margin-bottom: 14px;\n  border-radius: 20px;\n  background: #e3f2ef;\n  color: #197666;\n  font-size: 26px;\n  box-shadow: 0 8px 18px rgba(25, 118, 102, 0.12);\n}\n.job-questions-empty-dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #62b6a6;\n}\n.job-questions-empty-dot-one { top: 10px; right: 12px; }\n.job-questions-empty-dot-two { bottom: 12px; left: 10px; background: #f0b35b; }\n.job-questions-empty-state h6 {\n  margin: 0 0 6px;\n  color: #203b47;\n  font-size: 15px;\n  font-weight: 700;\n}\n.job-questions-empty-state p {\n  max-width: 310px;\n  margin: 0;\n  color: #71858d;\n  font-size: 12px;\n  line-height: 1.55;\n}\n.job-round-config-table { width: 100%; max-width: none; margin: 20px 0; border: 1px solid #dce5eb; border-radius: 6px; overflow: hidden; }\n.job-skill-config-grid { border: 1px solid #cddbe4; border-radius: 6px; overflow-x: auto; }\n.job-skill-grid-header, .job-skill-grid-row { gap: 0 !important; padding: 0 !important; margin: 0 !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; min-width: 1100px; }\n.job-skill-grid-header { background: #eef4f7 !important; }\n.job-skill-grid-row { border-top: 1px solid #dce5eb !important; }\n.job-skill-grid-row:nth-child(odd) { background: #f9fbfc !important; }\n.job-skill-grid-header > div, .job-skill-grid-row > div { padding: 14px 12px; border-right: 1px solid #dce5eb; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 0; }\n.job-skill-grid-header > div:last-child, .job-skill-grid-row > div:last-child { border-right: 0; }\n.job-skill-grid-header > div { font-size: 12px !important; letter-spacing: 0 !important; }\n.job-skill-grid-row .p-inputtext { width: 100%; min-width: 0; font-size: 13px; }\n.job-skill-grid-row .p-inputnumber { width: 100%; }\n.job-skill-rating-scale { display: flex; justify-content: space-between; align-items: baseline; width: 140px; max-width: 100%; color: #82929d; font-size: 10px; }\n.job-skill-rating-scale strong { color: #294b5b; font-size: 16px; font-weight: 600; }\n.job-skill-rating-scale small { color: #82929d; font-size: 11px; font-weight: 400; }\n.job-skill-rating .p-slider { height: 6px; border-radius: 4px; background: #e0e8ed; margin: 8px 0 10px; max-width: 100%; }\n.job-skill-rating .p-slider-range { background: #168575; border-radius: 4px; }\n.job-skill-rating .p-slider-handle { width: 20px; height: 20px; margin-top: -10px; border: 2px solid #168575; background: #fff; box-shadow: 0 1px 4px rgba(29, 64, 75, .15); }\n.job-skill-rating > span { border-radius: 4px !important; padding: 4px 10px !important; font-size: 11px !important; }\n.job-skill-grid-row > .job-skill-rating { display: grid !important; grid-template-columns: auto auto; grid-template-rows: auto auto; justify-content: center; align-content: center; gap: 14px 16px !important; }\n.job-skill-rating .job-skill-rating-scale { grid-column: 1; grid-row: 1; width: auto; justify-content: flex-start !important; }\n.job-skill-rating-scale strong { font-size: 15px; }\n.job-skill-rating .job-skill-proficiency { grid-column: 2; grid-row: 1; font-size: 11px !important; font-weight: 500 !important; padding: 3px 7px !important; border: 1px solid transparent; }\n.job-skill-rating .job-skill-proficiency.beginner { color: #336b9a !important; background: #edf4fd !important; border-color: #d6e5f5; }\n.job-skill-rating .job-skill-proficiency.intermediate { color: #876620 !important; background: #fff5dc !important; border-color: #ede0b6; }\n.job-skill-rating .job-skill-proficiency.advanced { color: #327252 !important; background: #e8f6ee !important; border-color: #cde7d8; }\n.job-skill-rating .p-slider { grid-column: 1 / -1; grid-row: 2; width: 100% !important; height: 4px; margin: 0 0 4px; }\n.job-skill-rating .p-slider-handle { width: 16px; height: 16px; margin-top: -8px; box-shadow: none; }\n.job-skill-duration { display: inline-flex; align-items: center; justify-content: center; gap: 6px; color: #345d72; }\n.job-skill-duration .pi { font-size: 15px; color: #5f8b9f; }\n.job-skill-duration strong { font-size: 18px; font-weight: 600; }\n.job-skill-duration > span { font-size: 12px; font-weight: 400; }\n.job-skill-duration-time { font-size: 11px !important; font-variant-numeric: tabular-nums; margin-top: 3px; }\n.job-skill-ratio { gap: 5px !important; width: 145px; max-width: 100%; }\n.job-skill-ratio > span { display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 12px; color: #516976; }\n.job-skill-ratio strong { display: grid; place-items: center; min-width: 25px; height: 22px; border-radius: 4px; font-size: 11px; }\n.job-skill-ratio .beginner strong { background: #edf4fd; color: #336b9a; }\n.job-skill-ratio .intermediate strong { background: #fff5dc; color: #927029; }\n.job-skill-ratio .advanced strong { background: #e8f6ee; color: #327252; }\n.job-skill-config-grid .job-skill-grid-footer { margin: 0 !important; padding: 12px 16px !important; border-top: 1px solid #cddbe4; background: #f4f8fa; min-height: 52px; }\n.job-skill-grid-footer > span { background: #eaf3f8 !important; border-color: #c7dbe6 !important; color: #235c77 !important; }\n.job-round-config-table .rdt_TableHeadRow { background: #eef4f7 !important; min-height: 48px; }\n.job-round-config-table .rdt_TableCol { justify-content: center !important; color: #395665; font-size: 13px; font-weight: 600; }\n.job-round-config-table .rdt_TableCell { justify-content: center !important; padding: 10px 16px; }\n.job-round-config-table .rdt_TableCell:first-child { justify-content: center !important; }\n.job-round-config-table .rdt_TableCell:first-child .form-check { width: 200px; max-width: 100%; display: flex; align-items: center; gap: 8px; padding: 0; margin: 0; }\n.job-round-config-table .rdt_TableCell:first-child .form-check-input { float: none; margin: 0; flex: 0 0 17px; }\n.job-round-config-table .rdt_TableCell:first-child .form-check-label { margin: 0; text-align: left; }\n.job-round-config-table .rdt_TableRow:nth-child(even) { background: #f9fbfc; }\n.job-round-config-table input:not([type=\"checkbox\"]) { text-align: center; height: 38px; max-width: 180px; border-color: #cedbe3; border-radius: 4px; font-size: 14px; }\n.job-round-config-table input[type=\"checkbox\"] { width: 17px; height: 17px; accent-color: #147d70; }\n#CreateJobOrderTabs { scroll-margin-top: 90px; }\n.job-generation-dialog .modal-body { padding: 28px 24px; }\n.job-generation-dialog .modal-content { border-radius: 8px; overflow: hidden; }\n.job-generation-dialog .p-progress-spinner { width: 52px; height: 52px; }\n.job-screening-categories { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px; align-items: start; }\n.job-recruiter-selection .p-multiselect-label { display: flex; align-items: center; flex-wrap: nowrap; gap: 6px; min-width: 0; overflow: hidden; padding: 8px 10px; white-space: nowrap; }\n.job-recruiter-selection .p-multiselect-token { flex: 0 1 auto; min-width: 0; background: #eaf4f2; color: #246454; border: 1px solid #cbe2db; border-radius: 4px; padding: 5px 8px; margin: 0; font-size: 13px; }\n.job-recruiter-selected-name { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.job-recruiter-chip { display: inline-flex; align-items: center; gap: 7px; min-width: 0; max-width: 180px; overflow: hidden; background: #edf5f3; border: 1px solid #c9e0d9; border-radius: 4px; padding: 5px 7px 5px 9px; color: #285f51; font-size: 13px; line-height: 1.4; }\n.job-recruiter-chip > .pi { font-size: 12px; flex-shrink: 0; color: #548777; }\n.job-recruiter-chip-remove { display: inline-grid; place-items: center; width: 22px; height: 22px; flex-shrink: 0; padding: 0; border: 0; border-radius: 3px; background: transparent; color: #548777; }\n.job-recruiter-chip-remove:hover { background: #d9eae4; color: #214d42; }\n.job-recruiter-chip-remove .pi { font-size: 10px; }\n.lookup-add-option {\n  position: sticky;\n  bottom: 0;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 40px;\n  padding: 9px 12px;\n  border-top: 1px solid #d7e5ef;\n  background: #ffffff;\n  color: #0b6eaa;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  box-shadow: 0 -2px 6px rgba(18, 61, 91, 0.08);\n}\n.lookup-add-option:hover { background: #edf7fc; color: #095985; }\n.lookup-add-option .pi { font-size: 12px; }\n.job-recruiter-selection .p-multiselect-token-icon { margin-left: 8px; width: 14px; height: 14px; }\n.job-candidate-heading-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }\n.job-screening-reviewed-note { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; color: #26705c; background: #edf8f3; border: 1px solid #cfe7dc; border-radius: 4px; padding: 8px 10px; }\n.job-screening-automation-toolbar { justify-content: flex-end; align-items: center; gap: 12px; margin-bottom: 8px !important; }\n.job-screening-automation-toolbar > .job-screening-header-title { width: auto !important; flex: 1 1 0 !important; min-width: 0; margin-right: auto; }\n.job-screening-header-title .job-question-heading { margin: 0; }\n.job-screening-automation-toolbar { flex-wrap: nowrap !important; }\n.job-screening-automation-toolbar .job-screening-automation-control { display: flex; align-items: center; justify-content: flex-end; gap: 16px; width: auto; max-width: 100%; flex: 0 0 auto; padding: 10px 16px; }\n.job-screening-automation-control > label { margin: 0 !important; font-size: 15px; flex: 0 0 auto !important; width: max-content !important; min-width: 175px; max-width: none !important; white-space: nowrap; overflow: visible !important; text-overflow: clip !important; }\n.job-screening-automation-control > .d-flex { margin: 0 !important; flex: 0 0 auto; }\n.job-screening-automation-control .form-switch { display: flex; align-items: center; gap: 10px; padding: 0 !important; min-height: 28px; margin: 0; }\n.job-screening-automation-control .form-check-input { float: none !important; margin: 0 !important; position: static !important; flex: 0 0 48px !important; width: 48px !important; }\n.job-screening-automation-control .form-check-label { margin: 0 !important; }\n.job-screening-percentage-control {\n  display: flex;\n  flex: 0 0 230px;\n  flex-direction: column;\n  gap: 6px;\n  width: 230px;\n  max-width: 230px;\n  padding: 0 !important;\n}\n.job-screening-percentage-control .form-label {\n  margin: 0 !important;\n  color: #31586d;\n  font-size: 13px;\n  line-height: 1.2;\n}\n.job-screening-percentage-control .form-control {\n  min-height: 40px;\n  border: 1px solid #c7d8e3;\n  border-radius: 8px;\n  padding: 8px 12px;\n  color: #173f63;\n  background: #ffffff;\n}\n.job-screening-percentage-control .form-control:focus {\n  border-color: #1765a5;\n  box-shadow: 0 0 0 3px rgba(23, 101, 165, .12);\n}\n@media (max-width: 600px) { .job-screening-automation-toolbar .job-screening-automation-control { flex-wrap: wrap; } }\n.job-details-form-workspace .form-label,\n.job-details-form-workspace input.form-control,\n.job-details-form-workspace select.form-control,\n.job-details-form-workspace textarea.form-control,\n.job-details-form-workspace .p-dropdown-label,\n.job-details-form-workspace .p-multiselect-label,\n.job-screening-question textarea,\n.job-question-level textarea { font-size: 15px !important; }\n.job-question-heading { font-size: 18px !important; }\n.job-screening-category > h6,\n.job-question-level h6,\n.job-question-workspace .p-accordion-header-link { font-size: 15px !important; }\n.job-screening-actions .p-button,\n.job-question-actions .p-button,\n.job-details-form-actions .btn,\n.job-details-form-toolbar .btn { font-size: 14px !important; }\n.job-screening-actions, .job-details-form-actions { align-items: center; flex-wrap: wrap; gap: 10px !important; padding: 20px 0 8px; border-top: 0; }\n.job-screening-actions .p-button, .job-screening-actions .btn,\n.job-details-form-actions .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; margin: 0 !important; height: 40px !important; min-height: 40px; padding: 8px 16px !important; border-radius: 4px !important; font-size: 13px; }\n.job-screening-actions .job-screening-action {\n  min-height: 42px;\n  height: 42px !important;\n  padding: 10px 17px !important;\n  border-radius: 9px !important;\n  border: 1px solid transparent !important;\n  font-size: 13px !important;\n  font-weight: 600;\n  letter-spacing: 0;\n  box-shadow: 0 2px 5px rgba(18, 61, 91, 0.12);\n  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n.job-screening-actions .job-screening-action:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 5px 12px rgba(18, 61, 91, 0.18);\n}\n.job-screening-actions .job-screening-action:focus-visible {\n  outline: 3px solid rgba(31, 126, 190, 0.22);\n  outline-offset: 2px;\n}\n.job-screening-actions .job-screening-action .p-button-icon { font-size: 14px; }\n.job-screening-actions .job-screening-back-button {\n  color: #12649b !important;\n  background: #ffffff !important;\n  border-color: #8db9d5 !important;\n}\n.job-screening-actions .job-screening-back-button:hover:not(:disabled) {\n  color: #0d4f7c !important;\n  background: #edf7fc !important;\n  border-color: #5d9fc8 !important;\n}\n.job-screening-actions .job-screening-save-button {\n  color: #ffffff !important;\n  background: #3b8f3b !important;\n  border-color: #3b8f3b !important;\n}\n.job-screening-actions .job-screening-save-button:hover:not(:disabled) {\n  background: #2e7530 !important;\n  border-color: #2e7530 !important;\n}\n.job-screening-actions .job-screening-download-button {\n  color: #ffffff !important;\n  background: #137eaa !important;\n  border-color: #137eaa !important;\n}\n.job-screening-actions .job-screening-download-button:hover:not(:disabled) {\n  background: #0e6388 !important;\n  border-color: #0e6388 !important;\n}\n.job-screening-actions .job-screening-view-button {\n  color: #ffffff !important;\n  background: #6451b5 !important;\n  border-color: #6451b5 !important;\n}\n.job-screening-actions .job-screening-view-button:hover:not(:disabled) {\n  background: #4f3f95 !important;\n  border-color: #4f3f95 !important;\n}\n.job-details-form-workspace .job-website-posting-choice { margin: 8px 0 2px !important; padding: 0 !important; }\n.job-website-posting-choice .card-body { padding: 2px 0 !important; }\n.job-website-posting-choice .card { margin-bottom: 0 !important; min-height: 0; }\n.job-details-form-workspace .job-details-form-actions { padding: 4px 0 !important; margin-top: 0 !important; margin-bottom: 4px !important; }\n.job-details-form-toolbar { padding: 12px 0 20px; margin-bottom: 20px !important; border-bottom: 0; }\n.job-details-form-toolbar { width: auto !important; }\n.job-details-form-toolbar > div { align-items: center !important; justify-content: flex-start !important; flex-wrap: wrap; gap: 10px; width: auto !important; padding-left: 0 !important; padding-right: 0 !important; }\n@media (min-width: 1500px) {\n  #CreateJobOrderTabs { position: relative; }\n  #CreateJobOrderTabs > .p-tabview-nav-container { display: flex; align-items: center; gap: 16px; min-height: 54px; }\n  #CreateJobOrderTabs > .p-tabview-nav-container > .p-tabview-nav-content { flex: 1; min-width: 0; }\n  #CreateJobOrderTabs > .p-tabview-nav-container .p-tabview-nav { flex-wrap: nowrap; }\n  #CreateJobOrderTabs > .p-tabview-nav-container .p-tabview-nav-link { padding: 10px 12px; font-size: 13px; white-space: nowrap; }\n  #CreateJobOrderTabs .job-details-form-toolbar {\n    position: static;\n    flex: 0 0 auto;\n    width: auto;\n    padding: 0;\n    margin: 0 !important;\n    min-height: 44px;\n  }\n  #CreateJobOrderTabs .job-details-form-toolbar > div { padding: 0; flex-wrap: nowrap; }\n  #CreateJobOrderTabs .job-details-company-control { flex-wrap: nowrap; gap: 8px; }\n  #CreateJobOrderTabs .job-details-company-control > div { width: 150px !important; }\n  #CreateJobOrderTabs .job-details-form-toolbar > div { gap: 8px; }\n  #CreateJobOrderTabs .job-details-company-control label { white-space: nowrap; }\n}\n.job-details-company-control { align-items: flex-start; flex-direction: column; flex-wrap: nowrap; gap: 4px; }\n.job-details-form-toolbar .job-details-company-control,\n.job-details-form-toolbar .btn { align-self: center; }\n.job-details-company-control label { margin: 0 !important; font-size: 13px; font-weight: 500; color: #526a79; }\n.job-details-company-control .job-company-selector-label { margin: 0 !important; color: #526a79; font-size: 12px; font-weight: 600; line-height: 1.2; }\n.job-details-form-toolbar .btn { margin: 0 !important; border-radius: 4px; font-size: 13px; }\n.job-details-form-workspace .form-label { color: #4c6372; font-size: 12px; font-weight: 600 !important; margin-bottom: 7px !important; }\n.job-edit-mode-note { padding: 12px 16px; margin-bottom: 18px; background: #edf6fb; border: 1px solid #c9dfea; border-left: 3px solid #257ea5; border-radius: 4px; font-size: 13px; line-height: 1.5; }\n.job-edit-mode-note .text-muted { color: #285c75 !important; font-weight: 500 !important; }\n.job-edit-mode-note:empty { display: none; }\n#CreateJobOrderTabs .p-tabview-panel.job-details-form-workspace { padding-top: 18px !important; }\n.job-details-form-workspace input.form-control,\n.job-details-form-workspace select.form-control,\n.job-details-form-workspace .p-dropdown,\n.job-details-form-workspace .p-multiselect { min-height: 38px; border-color: #cedbe3; border-radius: 4px; font-size: 13px; background: #fff; }\n.job-details-form-workspace textarea.form-control { border-color: #cedbe3; border-radius: 4px; font-size: 13px; line-height: 1.6; }\n.job-details-form-workspace .form-control:focus { border-color: #368d9b; box-shadow: 0 0 0 3px rgba(54, 141, 155, .12); }\n.job-details-form-workspace .sun-editor { border: 1px solid #cedbe3; border-radius: 6px; overflow: hidden; }\n.job-details-form-workspace .sun-editor .se-toolbar { background: #f5f8fa; outline: none; border-bottom: 1px solid #dce5eb; }\n.job-details-form-workspace .sun-editor .se-btn { border-radius: 4px; }\n.job-details-form-workspace .sun-editor .sun-editor-editable { padding: 18px 20px; font-family: Arial, sans-serif !important; font-size: 15px !important; line-height: 1.65 !important; color: #283d49; }\n.job-details-form-workspace .sun-editor .sun-editor-editable p { margin: 0 0 12px; }\n.job-details-form-workspace .sun-editor .sun-editor-editable h1,\n.job-details-form-workspace .sun-editor .sun-editor-editable h2 { font-size: 20px; line-height: 1.4; margin: 16px 0 10px; }\n.job-details-form-workspace .sun-editor .sun-editor-editable h3 { font-size: 17px; margin: 14px 0 8px; }\n.job-details-form-workspace .sun-editor .sun-editor-editable li { margin-bottom: 8px; }\n.job-details-form-workspace fieldset > .row { row-gap: 20px !important; }\n.job-screening-workspace {\n  padding: 18px 18px 26px;\n  background: #f6fafc;\n  border: 1px solid #dce8ee;\n  border-radius: 10px;\n}\n.job-screening-automation-toolbar {\n  align-items: center;\n  margin: 0 0 22px !important;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #d9e6ed;\n  border-radius: 9px;\n  box-shadow: 0 3px 10px rgba(27, 71, 96, .06);\n}\n.job-screening-header-title .job-question-heading {\n  margin: 0;\n  color: #16496b;\n}\n.job-screening-automation-control {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.job-screening-automation-control .form-label {\n  margin: 0 !important;\n  color: #31586d;\n  font-size: 13px;\n}\n.job-screening-automation-control .form-switch {\n  padding-left: 2.8rem !important;\n}\n.job-screening-automation-control .form-check-input {\n  width: 2.45rem;\n  height: 1.3rem;\n  margin-top: 0;\n  border-color: #b8cbd7;\n  cursor: pointer;\n}\n.job-screening-automation-control .form-check-input:checked {\n  background-color: #167b70;\n  border-color: #167b70;\n}\n.job-screening-category { padding: 18px; border: 1px solid #dce5eb !important; border-radius: 6px; background: #fff; min-width: 0; }\n.job-screening-category { border-radius: 10px; box-shadow: 0 3px 12px rgba(27, 71, 96, .06); }\n.job-screening-category > h6 { font-size: 14px; font-weight: 600; color: #304c5b; margin: 0 0 16px; padding-bottom: 12px; border-bottom: 1px solid #e5ebef; }\n.job-screening-category > h6 { display: flex; align-items: center; justify-content: space-between; gap: 12px; color: #16496b; }\n.job-screening-number { display: grid; place-items: center; flex: 0 0 24px; height: 24px; margin-top: 10px; background: #edf3f6; color: #657c89; border-radius: 4px; font-size: 11px; }\n.job-screening-question { margin-bottom: 12px !important; }\n.job-screening-question textarea { min-height: 78px; font-size: 13px; line-height: 1.6; padding: 12px 14px; border-color: #cbdce6; border-radius: 8px; background: #fbfdff; resize: vertical; transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease; }\n.job-screening-question textarea:hover { border-color: #83abc2; background: #ffffff; }\n.job-screening-question textarea:focus { border-color: #1765a5; background: #ffffff; box-shadow: 0 0 0 3px rgba(23, 101, 165, .11); outline: none; }\n.job-screening-question .job-screening-delete { width: 32px; min-width: 32px; height: 32px; padding: 0; margin-top: 6px; background: #fff2f2 !important; color: #bf4850 !important; border: 1px solid #efd6d8 !important; border-radius: 4px; box-shadow: none; }\n.job-screening-question .job-screening-delete:hover { background: #ffe2e3 !important; border-color: #e8aeb2 !important; transform: translateY(-1px); }\n.job-screening-category > .p-button,\n.job-screening-category .question-add-button { min-height: 38px; font-size: 13px; border-radius: 8px !important; padding: 8px 14px; background: #0b6eaa !important; border-color: #0b6eaa !important; box-shadow: 0 2px 5px rgba(11, 110, 170, .16); }\n.job-screening-category > .p-button:hover,\n.job-screening-category .question-add-button:hover { background: #095985 !important; border-color: #095985 !important; box-shadow: 0 4px 8px rgba(11, 110, 170, .22); }\n@media (max-width: 900px) { .job-screening-categories { grid-template-columns: 1fr; } }\n.job-question-level { padding: 0 0 18px; margin-bottom: 18px; border-bottom: 1px solid #e1e8ed; }\n.job-question-level:last-child { border: 0; margin-bottom: 0; padding-bottom: 0; }\n.job-question-level h6 { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #405d6b; margin-bottom: 12px; }\n.job-question-level h6 span { padding: 2px 7px; background: #edf3f6; border-radius: 4px; font-size: 11px; }\n.job-question-heading { display: flex; align-items: center; gap: 10px; margin: 0 0 16px; font-size: 16px; font-weight: 600; color: #273f4c; }\n.job-question-heading .pi { display: grid; place-items: center; width: 32px; height: 32px; border-radius: 6px; background: #eaf4f2; color: #197666; font-size: 15px; }\n.job-question-workspace .p-accordion-header-link { min-height: 48px; padding: 12px 16px !important; background: #f8fafc !important; color: #304958 !important; border: 1px solid #dce5eb !important; border-radius: 4px !important; box-shadow: none !important; font-size: 13px; font-weight: 500; }\n.job-question-workspace .p-accordion-header-link:hover { background: #eef5f7 !important; border-color: #b9ced7 !important; }\n.job-question-workspace .p-accordion-header.p-highlight .p-accordion-header-link { background: #eaf4f2 !important; color: #166b5d !important; }\n.job-question-workspace .p-accordion-header-text { flex: 1; min-width: 0; }\n.job-question-category { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; }\n.job-question-count { display: grid; place-items: center; min-width: 26px; height: 24px; padding: 0 7px; border-radius: 4px; background: #e4edf2; color: #466171; font-size: 12px; }\n.job-question-workspace .p-accordion-content { border-color: #dce5eb; padding: 16px; background: #fff; }\n.job-question-workspace .shadow-sm { box-shadow: none !important; }\n.job-question-actions { align-items: center; flex-wrap: wrap; padding: 20px 0 8px; border-top: 0; }\n.job-question-actions .p-button, .job-question-actions .btn { margin: 0 !important; min-height: 40px; border-radius: 4px !important; padding: 8px 16px !important; font-size: 13px; }\n.job-question-workspace .question-add-button,\n.job-question-workspace .question-ai-button {\n  min-height: 40px;\n  border-radius: 8px !important;\n  padding: 9px 16px !important;\n  font-weight: 600;\n  box-shadow: 0 2px 5px rgba(18, 55, 86, .14);\n  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;\n}\n.job-question-workspace .question-add-button {\n  background: #0b6eaa !important;\n  border-color: #0b6eaa !important;\n}\n.job-question-workspace .question-add-button:hover {\n  background: #095985 !important;\n  border-color: #095985 !important;\n  box-shadow: 0 4px 9px rgba(11, 110, 170, .24);\n  transform: translateY(-1px);\n}\n.job-question-workspace .question-ai-button {\n  background: #6b4cc2 !important;\n  border-color: #6b4cc2 !important;\n}\n.job-question-workspace .question-ai-button:hover {\n  background: #5438a1 !important;\n  border-color: #5438a1 !important;\n  box-shadow: 0 4px 9px rgba(107, 76, 194, .24);\n  transform: translateY(-1px);\n}\n.job-question-workspace .job-question-textarea {\n  min-height: 64px;\n  border: 1px solid #cddbe7 !important;\n  border-radius: 8px !important;\n  background: #fbfdff !important;\n  color: #203b52;\n  font-size: 14px;\n  line-height: 1.5;\n  padding: 12px 14px !important;\n  resize: vertical;\n  box-shadow: inset 0 1px 2px rgba(19, 55, 82, .04);\n  transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;\n}\n.job-question-workspace .job-question-textarea:hover {\n  border-color: #8db6d2 !important;\n  background: #ffffff !important;\n}\n.job-question-workspace .job-question-textarea:focus {\n  border-color: #0b6eaa !important;\n  background: #ffffff !important;\n  box-shadow: 0 0 0 3px rgba(11, 110, 170, .12) !important;\n  outline: none;\n}\n.job-order-selector {\n  width: 240px;\n  min-width: 240px;\n}\n.job-order-selector .job-order-tab-select__control:hover {\n  border-color: #74a9cb !important;\n}\n.job-order-selector .job-order-tab-select__control--is-focused {\n  border-color: #1765a5 !important;\n  box-shadow: 0 0 0 3px rgba(23, 101, 165, .12) !important;\n}\n.job-order-selector .job-order-tab-select__menu {\n  border: 1px solid #cbddea;\n  border-radius: 8px;\n  box-shadow: 0 8px 22px rgba(20, 58, 90, .16);\n  overflow: hidden;\n}\n.job-access-heading { display: flex; align-items: center; gap: 10px; margin: 0; font-size: 18px; font-weight: 600; color: #263b48; }\n.job-access-heading .pi { display: grid; place-items: center; width: 36px; height: 36px; background: #e8f4f1; color: #167562; border-radius: 6px; font-size: 18px; }\n.job-access-section .card { border: 1px solid #dce5eb; border-radius: 6px; padding: 0; box-shadow: none; overflow: hidden; }\n.job-access-employee { display: flex; align-items: center; gap: 10px; min-width: 0; width: 100%; }\n.job-access-avatar { display: grid; place-items: center; width: 30px; height: 30px; flex: 0 0 30px; border: 1px solid #cbe2db; background: #eef7f3; color: #28634f; border-radius: 50%; font-size: 11px; font-weight: 600; }\n.job-access-name { min-width: 0; overflow: visible; text-overflow: clip; white-space: normal; overflow-wrap: anywhere; line-height: 1.5; padding: 8px 0; font-size: 13px; color: #293d49; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableHeadRow { background: #eef3f7 !important; min-height: 48px; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCol { color: #486171; font-size: 12px; font-weight: 600; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCol,\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCol_Sortable { justify-content: center !important; text-align: center !important; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCol_Sortable > div { white-space: normal !important; overflow: visible !important; text-overflow: clip !important; text-align: center; line-height: 1.4; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableRow { min-height: 48px; border-bottom: 1px solid #e5ebef; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableRow:nth-child(even) { background: #f9fbfc; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableRow:hover { background: #eef7f5; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCell:not(:first-child) { justify-content: center; }\n.job-access-section #AccessPrivileges_UserTable .rdt_TableCell:first-child { justify-content: flex-start; }\n.job-access-section #AccessPrivileges_UserTable input[type=\"checkbox\"] { width: 18px !important; height: 18px !important; accent-color: #147d70; cursor: pointer; }\n.job-access-section #AccessPrivileges_UserTable input[type=\"checkbox\"]:disabled { cursor: not-allowed; opacity: .5; }\n@media (max-width: 600px) { .job-access-toolbar > div:last-child { margin-top: 12px; } }\n\n#AccessPrivileges_UserTable .rdt_TableCell input[type=\"checkbox\"] {\n  margin: 0 auto;\n  display: block;\n}\n#AccessPrivileges_UserTable .rdt_TableCol_Sortable {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable .sc-jwIPbr,\n#AccessPrivileges_UserTable .bAhklE {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable .rdt_TableCol_Sortable .rdt_TableSortLabel {\n  display: inline-block;\n  margin: 0 auto;\n}\n\n#RoleDropdown div svg,\n#RoleDropdown div,\n#RoleDropdown span {\n  color: #000;\n  background: #e0e0ea !important;\n}\n\n#SubTypeDropdown div svg,\n#SubTypeDropdown span,\n#PriorityDropdown div svg,\n#PriorityDropdown span {\n  color: #000 !important;\n}\n/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  border: 2px solid red;\n} */\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(10),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(10),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(12),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1) {\n  /* border: 2px solid red; */\n  justify-content: center;\n  border-right: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {\n  border-left: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(5),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {\n  border-top: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6) {\n  border-right: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  border-left: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  border-right: 1px solid #e0e0e0;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  width: 90%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  /* padding-left: 20px; */\n}\n\n/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{\n  border: 2px solid blue;\n} */\n\n#UserManagement_TableView .p-dropdown:not(.p-disabled):hover,\n#UserManagement_TableView .p-dropdown:not(.p-disabled):hover {\n  background-color: transparent !important;\n  color: #000;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown span,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown span,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span,\n#LookupCustomize .p-paginator-bottom .p-dropdown span,\n#JobDatatable .p-paginator-bottom .p-dropdown span,\n#RolesList .p-paginator-bottom .p-dropdown span,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown span,\n#RecruiterReports_TableView .p-paginator-bottom .p-dropdown span,\n#JobTableView .p-paginator-bottom .p-dropdown span,\n#CandidateInfo .p-paginator-bottom .p-dropdown span,\n#ArchiveReasonTableView .p-paginator-bottom .p-dropdown span,\n#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown span,\n#PlacementReportTable .p-paginator-bottom .p-dropdown span,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown span {\n  background-color: white;\n  border-left: 1px solid #ddd;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown div,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown div,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown div,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown div,\n#LookupCustomize .p-paginator-bottom .p-dropdown div,\n#RolesList .p-paginator-bottom .p-dropdown div,\n#JobDatatable .p-paginator-bottom .p-dropdown div,\n#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown div,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown div,\n#PlacementReportTable .p-paginator-bottom .p-dropdown div,\n#JobTableView .p-paginator-bottom .p-dropdown div,\n#CandidateInfo .p-paginator-bottom .p-dropdown div,\n#ArchiveReasonTableView .p-paginator-bottom .p-dropdown div,\n#RecruiterReports_TableView .p-paginator-bottom .p-dropdown div,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown div {\n  border: 1px solid #ddd;\n  background-color: white;\n  color: black;\n  border-radius: 2px;\n}\n\n#All_Employees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#AllEmployees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#ActiveJobSummaryReport .p-paginator-bottom div .p-dropdown-trigger svg,\n#RecruiterPerformanceReport .p-paginator-bottom div .p-dropdown-trigger svg,\n#LookupCustomize .p-paginator-bottom div .p-dropdown-trigger svg,\n#RolesList .p-paginator-bottom div .p-dropdown-trigger svg,\n#JobDatatable .p-paginator-bottom div .p-dropdown-trigger svg,\n#JobTableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#MyPlaceMentReportTable .p-paginator-bottom div .p-dropdown-trigger svg,\n#PlacementReportTable .p-paginator-bottom div .p-dropdown-trigger svg,\n#RecruiterReports_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#AllCandidates_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#UserManagement_TableView .p-paginator-bottom div .p-dropdown-trigger svg {\n  color: black !important;\n  background-color: white;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown span:hover,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown span:hover,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span:hover,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span:hover,\n#LookupCustomize .p-paginator-bottom .p-dropdown span:hover,\n#RolesList .p-paginator-bottom .p-dropdown span:hover,\n#JobDatatable .p-paginator-bottom .p-dropdown span:hover,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown span:hover,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown span:hover {\n  background-color: white;\n  color: black;\n}\n\n.contacts-active-shell {\n  padding: 0;\n}\n\n.contacts-active-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 18px 20px;\n  margin-bottom: 14px;\n  border: 1px solid #cfe1f1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%);\n  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.12);\n}\n\n.contacts-active-title {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.contacts-active-icon {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  font-size: 20px;\n}\n\n.contacts-active-heading {\n  margin: 0;\n  color: #ffffff;\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.contacts-active-title p {\n  margin: 3px 0 0;\n  color: #dceef8;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.contacts-active-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 0 0 auto;\n}\n\n@media (max-width: 1200px) {\n  .telephonic-tests-hero .telephonic-filter-bar {\n    flex-wrap: wrap;\n  }\n}\n\n.contacts-active-controls {\n  width: auto;\n  gap: 10px;\n}\n\n.contacts-active-controls .contacts-search-filter {\n  width: 320px;\n}\n\n.contacts-active-controls .contacts-company-filter label {\n  color: #dceef8;\n}\n\n.contacts-active-controls .contacts-company-select {\n  width: 240px;\n}\n\n.contacts-active-stat {\n  min-width: 148px;\n  padding: 10px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.26);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  white-space: nowrap;\n  margin-top: 18px;\n}\n\n.contacts-active-stat span {\n  display: inline;\n  color: #dceef8;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 1.2;\n}\n\n.contacts-active-stat strong {\n  display: inline;\n  margin-top: 0;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.contacts-active-stat-selected {\n  border-color: rgba(251, 191, 36, 0.42);\n}\n\n.contacts-toolbar-card {\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  border: 1px solid #d6e2ee;\n  border-left: 4px solid #0f766e;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.contacts-toolbar-card .contacts-header-actions {\n  justify-content: flex-end;\n}\n\n.contacts-header-box .row {\n  row-gap: 12px;\n}\n\n.contacts-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 14px;\n  width: 100%;\n}\n\n.contacts-company-filter {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  min-width: 0;\n}\n\n.contacts-company-filter label {\n  margin: 0;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.contacts-company-select {\n  width: 240px;\n}\n\n.contacts-company-control,\n.contacts-search-input,\n.contacts-search-btn {\n  height: 38px;\n}\n\n.contacts-company-control {\n  font-size: 14px;\n}\n\n.contacts-search-filter {\n  width: min(420px, 100%);\n  align-self: flex-end;\n}\n\n.contacts-search-group {\n  flex-wrap: nowrap;\n  border-radius: 8px;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);\n}\n\n.contacts-search-input {\n  min-width: 0;\n  font-size: 14px !important;\n  border-color: #cbd5e1;\n}\n\n.contacts-search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  padding: 0;\n  border-color: #0f766e !important;\n  background: #0f766e !important;\n  color: #ffffff !important;\n}\n\n.contacts-table-card {\n  overflow: hidden;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n}\n\n.contacts-table-card .rdt_TableCell,\n.contacts-table-card .rdt_TableCol {\n  min-width: 0;\n}\n\n.contacts-table-card .rdt_Pagination select {\n  min-height: 30px;\n}\n\n.table-cell-ellipsis {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 13px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.contacts-status-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 74px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.contacts-status-active {\n  border-color: #86efac;\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.contacts-status-inactive,\n.contacts-status-in-active {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.contacts-status-dnd-do-not-disturb,\n.contacts-status-blacklisted {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.contacts-empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 160px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n@media (max-width: 991.98px) {\n  .contacts-active-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .contacts-active-meta {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .contacts-header-actions {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .contacts-company-select,\n  .contacts-search-filter {\n    width: 100%;\n  }\n\n  .contacts-active-meta {\n    width: 100%;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .contacts-active-stat {\n    margin-top: 0;\n  }\n\n  .contacts-active-controls {\n    width: 100%;\n  }\n\n  .contacts-active-controls .contacts-search-filter,\n  .contacts-active-controls .contacts-company-select {\n    width: 100%;\n  }\n}\n\n.roles-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.roles-header-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.roles-company-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 200px;\n}\n\n.roles-company-filter label {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.roles-company-control,\n.roles-add-action .p-button {\n  height: 38px;\n}\n\n.roles-company-control {\n  font-size: 14px;\n}\n\n.roles-add-action .p-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 767.98px) {\n  .roles-header-row,\n  .roles-header-actions {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.user-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.user-header-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.user-company-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 200px;\n}\n\n.user-company-filter label {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.user-company-control,\n.user-search-input,\n.user-search-btn {\n  height: 38px;\n}\n\n.user-company-control {\n  font-size: 14px;\n}\n\n.user-search-filter {\n  width: 260px;\n}\n\n.user-search-group {\n  flex-wrap: nowrap;\n}\n\n.user-search-input {\n  min-width: 0;\n  font-size: 14px !important;\n}\n\n.user-search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  padding: 0;\n}\n\n.admin-user-hero {\n  margin-bottom: 18px;\n}\n\n.admin-user-page-shell {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.admin-user-content-shell {\n  padding: 0 10px;\n}\n\n.admin-user-hero-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.admin-user-company {\n  width: 240px;\n}\n\n.admin-user-company .ats-company-selector.form-select {\n  padding-right: 36px !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23334155' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 12px center !important;\n  background-size: 12px 12px !important;\n}\n\n.admin-user-search-filter {\n  width: 300px;\n}\n\n.admin-user-search-filter label,\n.admin-user-company label {\n  margin-bottom: 6px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.admin-user-search-filter .user-search-group {\n  height: 38px;\n  flex-wrap: nowrap;\n}\n\n.admin-user-search-filter .user-search-input {\n  height: 38px;\n  border: 1px solid rgba(255, 255, 255, 0.38) !important;\n  border-right: 0 !important;\n  border-radius: 8px 0 0 8px !important;\n  box-shadow: none !important;\n}\n\n.admin-user-search-filter .input-group-text {\n  height: 38px;\n  border-color: rgba(255, 255, 255, 0.38) !important;\n  border-left: 0 !important;\n  background: #ffffff !important;\n}\n\n.admin-user-search-filter .user-search-btn {\n  height: 38px;\n  width: 42px;\n  border: 1px solid #0f6fa8 !important;\n  border-radius: 0 8px 8px 0 !important;\n  background: #0f6fa8 !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.admin-user-count-card {\n  align-self: flex-end !important;\n  margin-top: 0 !important;\n}\n\n#UserManagement_TableView {\n  overflow: hidden;\n  border: 1px solid #dfe7ef;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);\n}\n\n#UserManagement_TableView .p-datatable-wrapper {\n  border-radius: 10px 10px 0 0;\n}\n\n#UserManagement_TableView .p-datatable-thead > tr > th {\n  padding: 12px 16px !important;\n  border-color: #dfe7ef !important;\n  background: #f8fafc !important;\n  color: #334155 !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  text-align: left !important;\n}\n\n#UserManagement_TableView .p-datatable-tbody > tr > td {\n  padding: 9px 16px !important;\n  border-color: #e5eaf0 !important;\n  color: #24364b;\n  font-size: 13px;\n  text-align: left !important;\n  vertical-align: middle;\n}\n\n#UserManagement_TableView .p-datatable-thead > tr > th:nth-child(3),\n#UserManagement_TableView .p-datatable-thead > tr > th:nth-child(4),\n#UserManagement_TableView .p-datatable-tbody > tr > td:nth-child(3),\n#UserManagement_TableView .p-datatable-tbody > tr > td:nth-child(4),\n#UserManagement_TableView .admin-user-role-pill,\n#UserManagement_TableView .admin-user-date-cell {\n  font-size: 12px !important;\n}\n\n#UserManagement_TableView .p-datatable-thead > tr > th:first-child,\n#UserManagement_TableView .p-datatable-tbody > tr > td:first-child {\n  text-align: center !important;\n}\n\n#UserManagement_TableView .p-datatable-thead > tr > th:first-child .p-column-header-content {\n  justify-content: center;\n}\n\n#UserManagement_TableView .p-datatable-tbody > tr:hover {\n  background: #f8fbff;\n}\n\n#UserManagement_TableView .p-paginator {\n  padding: 10px 12px !important;\n  border-top: 1px solid #e5eaf0 !important;\n  background: #ffffff !important;\n}\n\n.admin-user-name-cell {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  width: 280px;\n  max-width: 100%;\n  margin-inline: auto;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n}\n\n.admin-user-avatar {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 28px;\n  border: 1px solid;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.admin-user-name-text {\n  min-width: 0;\n  text-align: left;\n  overflow: hidden;\n  color: #0758a8;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-user-role-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #eef6ff;\n  color: #0f4c81;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.admin-user-date-cell {\n  color: #475569;\n  font-weight: 600;\n}\n\n.admin-user-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.admin-user-details-btn.p-button {\n  width: 32px;\n  height: 32px;\n  padding: 0 !important;\n  border: 1px solid #b9e1df !important;\n  border-radius: 8px !important;\n  background: #ecfdfb !important;\n  color: #0f766e !important;\n  box-shadow: none !important;\n}\n\n.admin-user-details-btn.p-button:hover {\n  background: #d5f5f1 !important;\n  border-color: #7dd3ca !important;\n}\n\n.admin-user-edit-btn.p-button {\n  width: 32px;\n  height: 32px;\n  padding: 0 !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 8px !important;\n  background: #f1f5f9 !important;\n  color: #0f4c81 !important;\n  box-shadow: none !important;\n}\n\n.admin-user-edit-btn.p-button:hover {\n  background: #e0f2fe !important;\n  border-color: #bae6fd !important;\n}\n\n.admin-user-edit-form {\n  margin: 0 0 14px;\n  padding: 14px 16px;\n  border: 1px solid #dfe7ef;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);\n}\n\n.admin-user-edit-form .field {\n  margin-bottom: 12px !important;\n}\n\n.admin-user-edit-form label {\n  margin-bottom: 6px;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.admin-user-hero .text-danger,\n.admin-role-hero .text-danger,\n.admin-user-edit-form label .text-danger {\n  background: transparent !important;\n  background-color: transparent !important;\n  color: #dc2626 !important;\n  box-shadow: none !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: inline !important;\n}\n\n.admin-user-edit-form .p-inputtext,\n.admin-user-edit-form .p-dropdown {\n  min-height: 38px;\n  border: 1px solid #cfd8e3 !important;\n  border-radius: 7px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.admin-user-edit-form .admin-user-role-dropdown .p-dropdown-label {\n  display: flex;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.admin-role-hero {\n  margin-bottom: 18px;\n}\n\n.admin-role-hero-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.admin-role-company {\n  width: 240px;\n}\n\n.admin-role-company .ats-company-selector.form-select {\n  padding-right: 36px !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23334155' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 12px center !important;\n  background-size: 12px 12px !important;\n}\n\n.admin-role-hero .roles-add-action .p-button {\n  min-height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.32) !important;\n  border-radius: 8px !important;\n  background: #0f6fa8 !important;\n  color: #ffffff !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  box-shadow: none !important;\n}\n\n.admin-role-count-card {\n  align-self: flex-end !important;\n  margin-top: 0 !important;\n}\n\n.usermanagement-tab--header-tabs-hidden > .p-tabview-nav-container {\n  display: none;\n}\n\n.usermanagement-tab--header-tabs-hidden > .p-tabview-panels {\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n}\n\n.admin-user-section-tabs {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.admin-user-hero-actions .admin-user-section-tabs,\n.admin-role-hero-actions .admin-user-section-tabs {\n  align-self: flex-end;\n  margin-top: 0;\n}\n\n.admin-user-section-tab {\n  min-width: 74px;\n  min-height: 32px;\n  padding: 6px 14px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  background: transparent;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.admin-user-section-tab.active {\n  border-color: rgba(255, 255, 255, 0.36);\n  background: #ffffff;\n  color: #0f4c81;\n}\n\n.roles-header-row .admin-user-section-tabs {\n  margin-top: 8px;\n  border-color: #d9e4ef;\n  background: #f3f6fb;\n}\n\n.roles-header-row .admin-user-section-tab {\n  color: #0f4c81;\n}\n\n.roles-header-row .admin-user-section-tab.active {\n  border-color: #0f6fa8;\n  background: #0f6fa8;\n  color: #ffffff;\n}\n\n@media (max-width: 767.98px) {\n  .user-header-row,\n  .user-header-actions,\n  .admin-user-hero,\n  .admin-user-hero-actions,\n  .admin-role-hero,\n  .admin-role-hero-actions {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .admin-user-hero-actions,\n  .admin-user-company,\n  .admin-user-search-filter,\n  .admin-role-hero-actions,\n  .admin-role-company {\n    width: 100%;\n  }\n}\n\n#CandidateFinishTable table thead tr th:nth-child(5) {\n  text-align: center;\n}\n\n#CandidateFinishTable table tbody tr td:nth-child(5) {\n  text-align: center;\n}\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  font-size: 0.85rem;\n}\n\n\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#AllCandidates_TableView table tr td:nth-child(7),\n#AllCandidates_TableView table tr td:nth-child(6),\n#AllCandidates_TableView table tr td:nth-child(5),\n#AllCandidates_TableView table tr td:nth-child(4),\n#AllCandidates_TableView table tr td:nth-child(3),\n#AllCandidates_TableView table tr td:nth-child(2),\n#AllCandidates_TableView table tr td:nth-child(1) {\n  width: 150px !important;\n}\n\n.JobCreateBy_AllCandidates,\n.JobName_AllCandidates,\n.JobEmail_AllCandidates,\n.JobTitle_AllCandidates {\n  width: 140px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView #AllCandidates_TableView .p-datatable-wrapper {\n  overflow-x: hidden !important;\n}\n\n#CandidateList_CardView #AllCandidates_TableView table {\n  width: 100% !important;\n  table-layout: fixed;\n}\n\n#AllCandidates_TableView table tr th:nth-child(1),\n#AllCandidates_TableView table tr td:nth-child(1) {\n  width: 44px !important;\n  min-width: 56px !important;\n  max-width: 44px !important;\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n  text-align: center !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(6),\n#AllCandidates_TableView table tr td:nth-child(6) {\n  width: 230px !important;\n  min-width: 230px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(2),\n#AllCandidates_TableView table tr td:nth-child(2) {\n  width: 200px !important;\n  min-width: 200px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(3),\n#AllCandidates_TableView table tr td:nth-child(3) {\n  width: 185px !important;\n  min-width: 185px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(4),\n#AllCandidates_TableView table tr td:nth-child(4) {\n  width: 145px !important;\n  min-width: 145px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(5),\n#AllCandidates_TableView table tr td:nth-child(5) {\n  width: 95px !important;\n  min-width: 95px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(8),\n#AllCandidates_TableView table tr td:nth-child(8) {\n  width: 190px !important;\n  min-width: 190px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(9),\n#AllCandidates_TableView table tr td:nth-child(9) {\n  width: 155px !important;\n  min-width: 155px !important;\n}\n\n#CandidateList_CardView .JobName_AllCandidates,\n#CandidateList_CardView .JobTitle_AllCandidates,\n#CandidateList_CardView .JobCreateBy_AllCandidates {\n  width: auto !important;\n  max-width: 100%;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n#CandidateList_CardView .JobName_AllCandidates {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .JobName_AllCandidates > span:first-child {\n  flex: 0 0 30px;\n}\n\n#CandidateList_CardView .JobName_AllCandidates > span:last-child {\n  display: inline-block;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .candidate-name-with-initials > span:last-child {\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .JobEmail_AllCandidates,\n#CandidateList_CardView .JobPhone_AllCandidates {\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .JobEmail_AllCandidates span,\n#CandidateList_CardView .JobPhone_AllCandidates span {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .JobTitle_AllCandidates span,\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {\n  display: block;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {\n  margin-bottom: 4px;\n}\n\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:last-child {\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-cell {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 28px;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 34px;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-cell.no-history {\n  display: flex;\n  justify-content: center;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-text {\n  display: block;\n  min-width: 0;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .candidate-pipeline-history-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  color: #111827;\n  background: #f8fafc;\n  box-shadow: none;\n}\n\n#CandidateList_CardView .candidate-pipeline-history-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n#CandidateList_CardView .stage-filter-dropdown {\n  height: 31px;\n  font-size: 12px;\n}\n\n#CandidateList_CardView .stage-filter-dropdown .p-dropdown-label {\n  padding: 5px 8px;\n  font-size: 12px;\n  line-height: 19px;\n}\n\n#CandidateList_CardView .stage-filter-dropdown .p-dropdown-trigger,\n#CandidateList_CardView .stage-filter-dropdown .p-dropdown-clear-icon {\n  width: 28px;\n  font-size: 12px;\n}\n\n.stage-filter-dropdown-panel .p-dropdown-items .p-dropdown-item {\n  padding: 7px 10px;\n  font-size: 12px;\n}\n\n#CandidateList_CardView .CandidateListTableView .p-radiobutton,\n#CandidateList_CardView .CandidateListTableView .p-radiobutton .p-radiobutton-box {\n  width: 18px;\n  height: 18px;\n}\n\n#CandidateList_CardView .candidate-actions-main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n#CandidateList_CardView .candidate-action-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  padding: 0 !important;\n  margin: 0;\n  border-radius: 6px;\n  line-height: 1;\n}\n\n#CandidateList_CardView .candidate-action-icon-btn svg,\n#CandidateList_CardView .candidate-action-icon-btn i {\n  display: block;\n  margin: 0;\n  font-size: 14px;\n}\n\n#CandidateList_CardView .candidate-actions-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n#CandidateList_CardView .candidate-actions-approval {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .candidate-approval-btn {\n  border: 1px solid transparent;\n  border-radius: 6px;\n  width: 28px;\n  min-width: 28px;\n  height: 26px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  background: #fff;\n}\n\n#CandidateList_CardView .candidate-approval-btn svg {\n  display: block;\n  margin: 0;\n}\n\n#CandidateList_CardView .candidate-approval-btn--approve {\n  color: #047857;\n  border-color: #a7f3d0;\n  background: #ecfdf5;\n}\n\n#CandidateList_CardView .candidate-approval-btn--reject {\n  color: #dc2626;\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n#CandidateList_CardView .candidate-approval-btn--view {\n  color: #0369a1;\n  border-color: #bae6fd;\n  background: #f0f9ff;\n}\n\n.approve-reject-modal .modal-content {\n  border: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.24);\n}\n\n.approve-reject-modal-header {\n  border: 0;\n  padding: 18px 22px;\n  color: #fff;\n}\n\n.approve-reject-modal-header.approve {\n  background: linear-gradient(135deg, #047857, #10b981);\n}\n\n.approve-reject-modal-header.reject {\n  background: linear-gradient(135deg, #b91c1c, #ef4444);\n}\n\n.approve-reject-modal-header .btn-close {\n  filter: brightness(0) invert(1);\n  opacity: 0.95;\n}\n\n.approve-reject-modal-title {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.approve-reject-modal-title span {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.approve-reject-modal-body {\n  padding: 20px 22px 18px;\n  background: #f8fafc;\n}\n\n.approve-reject-field {\n  margin-bottom: 14px;\n}\n\n.approve-reject-field .form-label {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.approve-reject-field .form-control:disabled {\n  background: #eef2f7;\n  border-color: #dbe3ec;\n  color: #334155;\n  opacity: 1;\n}\n\n.approve-reject-field textarea.form-control {\n  min-height: 96px;\n  resize: vertical;\n}\n\n.approve-reject-modal-footer {\n  display: flex;\n  justify-content: center !important;\n  align-items: center;\n  gap: 10px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 16px 22px;\n}\n\n.approve-reject-cancel-btn,\n.approve-reject-submit-btn {\n  min-width: 96px;\n  height: 38px;\n  border-radius: 8px;\n  font-weight: 700;\n}\n\n.approve-reject-submit-btn.approve {\n  background: #059669;\n  border-color: #059669;\n}\n\n.approve-reject-submit-btn.reject {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#JobOrderTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #e6f3ff;\n}\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n#CandidateTest_DataTableView .rdt_Table .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  background-color: #f8f8f8;\n}\n#JobOrderTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#UserManagement_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  font-size: 0.85rem;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#TelephonicTest_Table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#TalentScanResultView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #e6f3ff;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#ExtensionLogs_Datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#TelephonicTest_Table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n\n/* #CandidateViewSummaryTable .rdt_Table .rdt_TableBody,\n#CandidateViewSummaryTable .rdt_Table .rdt_TableHead {\n  border-left: 1px solid #e0e0e0;\n} */\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  text-align: center;\n  justify-content: center;\n}\n\n/* #CandidateViewSummaryTable .rdt_Table {\n  border: 1px solid #e0e0e0;\n  \n} */\n\n#CandidateViewSummaryTable .rdt_ExpanderRow {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable .rdt_Table .rdt_TableHead .bGNKtt:first-child,\n#JobOrderTableView .rdt_Table .rdt_TableHead .bGNKtt:first-child {\n  border-right: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable .rdt_Table .rdt_TableRow .gOAnHZ:first-child,\n#JobOrderTableView .rdt_Table .rdt_TableRow .gOAnHZ:first-child {\n  border-right: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  /* border-right: 2px solid red; */\n}\n\n#TalentScanResultView.rdt_Table .rdt_TableRow div:first-child {\n  border-right: 2px solid blue;\n}\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(12),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1) {\n  justify-content: center;\n}\n\n.font_12 {\n  font-size: 12px;\n}\n\n.font_15,\n.ColumnTitle {\n  font-size: 0.85rem;\n}\n\n#CandidateApprovalTable table thead tr th {\n  text-align: center;\n}\n\n#CandidateApprovalTable table tbody tr td:nth-child(2) div,\n#CandidateApprovalTable table tbody tr td:nth-child(4) div,\n#CandidateApprovalTable table tbody tr td:nth-child(3) div {\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n/* #UserManagement_TableView table tbody tr td:nth-child(4),\n#UserManagement_TableView table tbody tr td:nth-child(3),\n#UserManagement_TableView table tbody tr td:nth-child(2), */\n/* #CandidateApprovalTable table tbody tr td:nth-child(3), */\n/* #CandidateApprovalTable table tbody tr td:nth-child(2) {\n  text-align: center;\n   \n} */\n#UserManagement_TableView table tbody tr td:nth-child(1),\n#UserManagement_TableView table tbody tr td:nth-child(2),\n#UserManagement_TableView table tbody tr td:nth-child(3),\n#UserManagement_TableView table tbody tr td:nth-child(4),\n#UserManagement_TableView table tbody tr td:nth-child(5) {\n  text-align: center !important;\n  border-right: 1px solid #e0e0e0;\n}\n\n#VitelMeetLink .p-datatable table {\n  border-top: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n}\n\n#VitelMeetLink .p-datatable table thead tr th,\n#VitelMeetLink .p-datatable table tbody tr td {\n  text-align: center !important;\n  vertical-align: middle;\n  border-right: 1px solid #e0e0e0 !important;\n  border-bottom: 1px solid #e0e0e0 !important;\n}\n\n#VitelMeetLink .p-datatable table thead tr th .p-column-header-content {\n  justify-content: center;\n}\n\n#VitelMeetLink .p-datatable table tbody tr td > span:not(.p-button-icon):not(.pi) {\n  display: block;\n  max-width: 180px;\n  margin: 0 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#VitelMeetLink .p-button .p-button-icon,\n#VitelMeetLink .p-button .pi {\n  display: inline-flex !important;\n  max-width: none !important;\n  margin: 0 !important;\n  overflow: visible !important;\n  text-overflow: clip !important;\n  white-space: normal !important;\n}\n\n#UserManagement_TableView table tbody tr td:nth-child(5) div {\n  justify-content: center;\n}\n\n#UserManagement_TableView table thead tr th div span {\n  width: 100%;\n  text-align: center !important;\n}\n\n#CandidateTest_DataTableView .rdt_Table {\n  border-top: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n}\n\n#All_Employees_TableView table tbody tr td {\n  border-right: 1px solid #e0e0e0;\n}\n\n#All_Employees_TableView table tbody tr td span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(3) {\n  width: 150px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(2) {\n  width: 150px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(3) span,\n#All_Employees_TableView table tbody tr td:nth-child(2) span {\n  display: block;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* #All_Employees_TableView table thead tr th:nth-child(3) div,\n */\n\n#All_Employees_TableView table thead tr th:nth-child(6) div,\n#All_Employees_TableView table thead tr th:nth-child(5) div,\n#All_Employees_TableView table thead tr th:nth-child(4) div,\n#All_Employees_TableView table thead tr th:nth-child(2) div,\n#All_Employees_TableView table thead tr th:nth-child(1) div {\n  justify-content: center;\n}\n#recentAactivityTable table thead tr th:nth-child(1) div,\n#recentAactivityTable table thead tr th:nth-child(2) div,\n#recentAactivityTable table thead tr th:nth-child(3) div,\n#recentAactivityTable table thead tr th:nth-child(4) div,\n\n#Smtp_table table thead tr th:nth-child(1) div,\n#Smtp_table table thead tr th:nth-child(2) div,\n#Smtp_table table thead tr th:nth-child(3) div,\n#Smtp_table table thead tr th:nth-child(4) div,\n#Smtp_table table thead tr th:nth-child(5) div,\n#Smtp_table table thead tr th:nth-child(6) div,\n#Smtp_table table thead tr th:nth-child(7) div,\n#Smtp_table table thead tr th:nth-child(8) div,\n#Smtp_table table thead tr th:nth-child(9) div,\n#Smtp_table table thead tr th:nth-child(10) div{\n  /* text-align: center !important; */\n  /* text-align: center !important; */\n  justify-content: center;\n}\n\n#recentAactivityTable table thead tr th:nth-child(1),\n#recentAactivityTable table tbody tr td:nth-child(2),\n#recentAactivityTable table tbody tr td:nth-child(3),\n#recentAactivityTable table tbody tr td:nth-child(4),\n#recentAactivityTable table tbody tr td:nth-child(5),\n#Smtp_table table tbody tr td:nth-child(1),\n#Smtp_table table tbody tr td:nth-child(2),\n#Smtp_table table tbody tr td:nth-child(3),\n#Smtp_table table tbody tr td:nth-child(4),\n#Smtp_table table tbody tr td:nth-child(5),\n#Smtp_table table tbody tr td:nth-child(6),\n#Smtp_table table tbody tr td:nth-child(7),\n#Smtp_table table tbody tr td:nth-child(8),\n#Smtp_table table tbody tr td:nth-child(9),\n#Smtp_table table tbody tr td:nth-child(10){\n  text-align: center !important;\n  border-left: 1px solid #e0e0e0;\n}\n\n#Smtp_table table tbody tr td:nth-child(6) div {\n  justify-content: space-evenly;\n}\n\n#Smtp_table,\n#Vitel_table {\n  width: 100%;\n  overflow: visible;\n}\n\n#Smtp_table .p-datatable-table,\n#Vitel_table .p-datatable-table {\n  width: 100%;\n  table-layout: fixed;\n}\n\n#Smtp_table .p-datatable-thead > tr > th,\n#Smtp_table .p-datatable-tbody > tr > td,\n#Vitel_table .p-datatable-thead > tr > th,\n#Vitel_table .p-datatable-tbody > tr > td {\n  padding: 10px 8px !important;\n  font-size: 14px;\n  overflow-wrap: anywhere;\n}\n\n#Smtp_table .p-datatable-thead > tr > th,\n#Vitel_table .p-datatable-thead > tr > th {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.smtp-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.smtp-actions-cell .p-button {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  padding: 0 !important;\n  border: 1px solid #d7e0eb !important;\n  border-radius: 6px !important;\n  background: #f8fafc !important;\n  color: #174f79 !important;\n  box-shadow: none !important;\n}\n\n.smtp-actions-cell .p-button:hover {\n  background: #eaf3fb !important;\n  border-color: #9fc4e2 !important;\n}\n\n.smtp-actions-cell .p-button-danger {\n  color: #b42318 !important;\n}\n\n.smtp-actions-cell .p-button-info {\n  color: #0f6f9f !important;\n}\n\n.advanced-search-dialog.p-dialog {\n  width: min(680px, calc(100vw - 32px)) !important;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);\n}\n\n.advanced-search-dialog .p-dialog-header {\n  min-height: 54px;\n  padding: 14px 20px;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%) !important;\n  color: #ffffff !important;\n  border: 0;\n}\n\n.advanced-search-dialog .p-dialog-title {\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.advanced-search-dialog .p-dialog-header-icons button,\n.advanced-search-dialog .p-dialog-header-close {\n  color: #ffffff !important;\n  width: 34px;\n  height: 34px;\n}\n\n.advanced-search-dialog .p-dialog-content {\n  padding: 18px 20px 20px !important;\n  background: #f8fafc !important;\n}\n\n.advanced-search-dialog .advan-modal,\n.advanced-search-dialog .popoup-clr,\n.advanced-search-dialog .card {\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.advanced-search-dialog .card-body {\n  padding: 0 !important;\n}\n\n.advanced-search-dialog .advan-modal > .card,\n.advanced-search-dialog .popoup-clr {\n  padding: 0 !important;\n}\n\n.advanced-search-dialog .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.advanced-search-dialog .col-xl-12 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.advanced-search-dialog label {\n  margin-bottom: 6px;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.advanced-search-dialog .p-dropdown,\n.advanced-search-dialog .p-inputtext {\n  width: 100%;\n  min-height: 38px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 13px;\n  box-shadow: none !important;\n}\n\n.advanced-search-dialog .p-dropdown-label {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.advanced-search-dialog .p-error {\n  display: block;\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 7px;\n  background: #fef2f2;\n  color: #dc2626;\n  font-size: 12px;\n}\n\n.advanced-search-dialog .d-flex.justify-content-center {\n  justify-content: flex-end !important;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.advanced-search-dialog .addfield-pop {\n  min-width: 92px;\n  height: 36px;\n  margin: 0 !important;\n  border: 0 !important;\n  border-radius: 7px !important;\n  background: var(--blue-gradient-right) !important;\n  color: #ffffff !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.advanced-search-dialog .addfield-pop:nth-child(2),\n.advanced-search-dialog .addfield-pop:nth-child(3) {\n  background: #ffffff !important;\n  color: #0f4c81 !important;\n  border: 1px solid #bfdbfe !important;\n}\n\n.manager-dashboard-activity-table,\n.manager-dashboard-recent-table,\n.manager-dashboard-interviews-table {\n  font-size: 12px;\n}\n\n.manager-dashboard-activity-table .p-datatable-thead > tr > th,\n.manager-dashboard-recent-table .p-datatable-thead > tr > th,\n.manager-dashboard-interviews-table .p-datatable-thead > tr > th {\n  padding: 9px 10px !important;\n  background: #f8fafc !important;\n  color: #334155 !important;\n  font-size: 11.5px;\n  font-weight: 800;\n  line-height: 1.25;\n  text-transform: none;\n  vertical-align: middle;\n}\n\n.manager-dashboard-activity-table .p-datatable-tbody > tr > td,\n.manager-dashboard-recent-table .p-datatable-tbody > tr > td,\n.manager-dashboard-interviews-table .p-datatable-tbody > tr > td {\n  padding: 8px 10px !important;\n  color: #334155;\n  font-size: 12px;\n  line-height: 1.25;\n  vertical-align: middle;\n}\n\n.candidate-empty-state {\n  min-height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #64748b;\n  text-align: center;\n}\n\n.candidate-empty-state i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: #176ea8;\n  font-size: 18px;\n}\n\n.candidate-empty-state strong {\n  color: #173f63;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.candidate-empty-state span {\n  font-size: 12px;\n}\n\n.job-order-empty-state {\n  min-height: 180px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #64748b;\n  text-align: center;\n}\n\n.job-order-empty-state i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: #176ea8;\n  font-size: 19px;\n}\n\n.job-order-empty-state strong {\n  color: #173f63;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.job-order-empty-state span {\n  font-size: 12px;\n}\n\n.org-master-empty-state {\n  min-height: 150px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #64748b;\n  text-align: center;\n}\n\n.org-master-empty-state i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: #176ea8;\n  font-size: 18px;\n}\n\n.org-master-empty-state strong {\n  color: #173f63;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.org-master-empty-state span {\n  font-size: 12px;\n}\n\n.schedule-timezone-summary {\n  width: 100%;\n}\n\n.candidate-detail-name {\n  font-size: 16px !important;\n  line-height: 1.25;\n}\n\n.interview-popup .p-dialog-header {\n  padding: 16px 22px;\n  border-bottom: 1px solid #dbe7f3;\n  background: linear-gradient(135deg, #f7fbff 0%, #edf6ff 100%);\n}\n.interview-popup .p-fileupload-choose,\n.interview-popup .p-fileupload-choose:hover,\n.interview-popup .p-fileupload-choose:focus,\n.interview-popup .p-fileupload-choose:active {\n  background: #e9edf3 !important;\n  border-color: #e9edf3 !important;\n  box-shadow: none !important;\n  color: #1f2937 !important;\n  transform: none !important;\n}\n\n.interview-popup .p-dialog-title {\n  color: #123f68 !important;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.schedule-date-picker {\n  width: 100%;\n}\n\n.schedule-date-picker .react-date-picker__wrapper {\n  min-height: 38px;\n  border: 1px solid #cbd9e6;\n  border-radius: 7px;\n  background: #fff;\n}\n\n.schedule-date-picker .react-date-picker__inputGroup {\n  padding: 0 10px;\n}\n\n.schedule-date-picker .react-date-picker__button {\n  padding: 7px 10px;\n}\n\n.schedule-date-picker .react-date-picker__button:enabled:hover,\n.schedule-date-picker .react-date-picker__button:enabled:focus {\n  background: #f1f5f9;\n}\n\n.interview-popup .p-dialog-header .p-dialog-header-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 7px;\n  color: #31536e !important;\n  background: transparent !important;\n  opacity: 1;\n}\n\n.interview-popup .p-dialog-header .p-dialog-header-icon:hover,\n.interview-popup .p-dialog-header .p-dialog-header-icon:focus {\n  color: #123f68 !important;\n  background: #dcecf9 !important;\n}\n\n.interview-popup .p-dialog-content {\n  padding: 0;\n  background: #f6f9fc;\n}\n\n.schedule-dialog-header {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  color: #123f68;\n}\n\n.schedule-dialog-header-icon,\n.schedule-section-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: #0d6efd;\n  color: #fff;\n  font-size: 15px;\n}\n\n.schedule-dialog-header strong,\n.schedule-dialog-header small,\n.schedule-section-heading strong,\n.schedule-section-heading small {\n  display: block;\n}\n\n.schedule-dialog-header strong {\n  font-size: 17px;\n  line-height: 1.2;\n}\n\n.schedule-dialog-header small,\n.schedule-section-heading small {\n  margin-top: 3px;\n  color: #6b7f93;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.schedule-interview-form {\n  padding: 8px 22px 20px;\n}\n\n.schedule-form-section {\n  margin-bottom: 14px;\n  padding: 15px;\n  border: 1px solid #dbe7f3;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(26, 74, 112, .05);\n}\n\n.schedule-section-heading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n  color: #173f63;\n}\n\n.schedule-section-heading strong {\n  font-size: 13px;\n}\n\n.schedule-section-number {\n  width: 27px;\n  height: 27px;\n  border-radius: 50%;\n  font-size: 12px;\n}\n\n.schedule-form-section .row {\n  row-gap: 12px;\n}\n\n.schedule-form-section label {\n  margin-bottom: 6px;\n  color: #294b68;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.schedule-form-section .p-inputtext,\n.schedule-form-section .p-dropdown,\n.schedule-form-section .p-calendar,\n.schedule-form-section .p-calendar .p-inputtext {\n  min-height: 38px;\n  border-color: #cbd9e6;\n  border-radius: 7px;\n}\n\n.schedule-form-section .p-inputtext:enabled:focus,\n.schedule-form-section .p-dropdown:not(.p-disabled).p-focus,\n.schedule-form-section .p-calendar:not(.p-disabled).p-focus > .p-inputtext {\n  border-color: #2684c7;\n  box-shadow: 0 0 0 3px rgba(38, 132, 199, .12);\n}\n\n.interview-popup .p-dropdown,\n.interview-popup .p-dropdown:hover,\n.interview-popup .p-dropdown.p-focus,\n.interview-popup .p-dropdown .p-dropdown-trigger,\n.interview-popup .p-dropdown .p-dropdown-trigger:hover,\n.interview-popup .p-dropdown .p-dropdown-trigger:focus {\n  background: #fff !important;\n  background-image: none !important;\n  color: #294b68 !important;\n}\n\n.interview-popup .p-dropdown .p-dropdown-trigger {\n  width: 2.5rem;\n  border-left: 1px solid #d5e1ec;\n}\n\n.schedule-panel-timezones {\n  margin-top: 15px !important;\n  padding: 14px !important;\n  border-color: #c9def1 !important;\n  background: #f5faff !important;\n}\n\n.schedule-timezone-heading-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.schedule-timezone-heading-row small {\n  color: #6b7f93;\n  font-size: 11px;\n}\n\n.schedule-timezone-heading {\n  margin-bottom: 0;\n}\n\n.schedule-timezone-field {\n  padding: 10px;\n  border: 1px solid #d7e5f1;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.schedule-form-actions {\n  margin-top: 4px;\n  padding-top: 14px;\n  border-top: 1px solid #dbe7f3;\n}\n\n.schedule-form-actions button {\n  min-width: 112px;\n  border-radius: 7px;\n  font-weight: 700;\n}\n\n@media (max-width: 640px) {\n  .schedule-interview-form {\n    padding: 14px 12px 16px;\n  }\n\n  .schedule-form-section {\n    padding: 12px;\n  }\n\n  .schedule-timezone-heading-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 3px;\n  }\n}\n\n/* New Mail uses the full compose workspace; replies and forwards remain compact. */\n.em-compose-fullscreen {\n  inset: 0;\n  top: 0;\n  left: 0;\n  transform: none;\n  width: 100vw;\n  max-width: none;\n  height: 100vh;\n  max-height: none;\n  border: 0;\n  border-radius: 0;\n  z-index: 11000;\n  box-shadow: none;\n}\n\n.em-compose-fullscreen .em-compose-header {\n  min-height: 52px;\n  padding: 10px 18px;\n  border-radius: 0;\n}\n\n.em-compose-fullscreen .em-compose-body {\n  flex: 1;\n  max-height: none;\n  min-height: 0;\n}\n\n.em-compose-fullscreen .em-compose-field {\n  min-height: 48px;\n  padding: 0 18px;\n}\n\n.em-compose-fullscreen .em-compose-field-label {\n  width: 52px;\n  font-size: 13px;\n}\n\n.em-compose-fullscreen .em-compose-toolbar {\n  padding: 7px 18px;\n}\n\n.em-compose-fullscreen .em-compose-editor {\n  flex: 1;\n  min-height: 0;\n}\n\n.em-compose-fullscreen .em-compose-editor textarea {\n  height: 100%;\n  min-height: 320px;\n  resize: none;\n  padding: 22px 18px;\n  font-size: 14px;\n}\n\n.em-compose-fullscreen .em-compose-footer {\n  min-height: 64px;\n  padding: 12px 18px;\n}\n\n.schedule-timezone-heading {\n  display: block;\n  margin-bottom: 10px;\n  color: #173f63;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.schedule-timezone-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 18px;\n}\n\n.schedule-timezone-field {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  min-width: 0;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.schedule-timezone-name-row {\n  display: block;\n  line-height: 1.35;\n  min-width: 0;\n}\n\n.schedule-timezone-name {\n  color: #1e293b;\n}\n\n.schedule-timezone-preview {\n  display: block;\n  margin-top: 3px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.schedule-timezone-dropdown {\n  width: 100%;\n  min-height: 38px;\n  border: 1px solid #cbd9e6 !important;\n  border-radius: 7px !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.schedule-timezone-dropdown .p-dropdown-label {\n  padding: 9px 12px !important;\n  color: #294b68 !important;\n  font-size: 13px;\n}\n\n.schedule-timezone-dropdown .p-dropdown-trigger {\n  width: 2.5rem !important;\n  border-left: 1px solid #d5e1ec !important;\n  border-radius: 0 7px 7px 0 !important;\n  background: #fff !important;\n  color: #294b68 !important;\n}\n\n.schedule-timezone-dropdown:not(.p-disabled):hover,\n.schedule-timezone-dropdown.p-focus {\n  background: #fff !important;\n  background-image: none !important;\n  color: #1f2937 !important;\n  border-color: #94a3b8 !important;\n  box-shadow: none !important;\n}\n\n.schedule-timezone-dropdown:not(.p-disabled):hover .p-dropdown-trigger,\n.schedule-timezone-dropdown.p-focus .p-dropdown-trigger {\n  background: #fff !important;\n  background-image: none !important;\n  color: #1f2937 !important;\n}\n\n.schedule-timezone-dropdown .p-dropdown-trigger,\n.schedule-timezone-dropdown .p-dropdown-trigger:hover,\n.schedule-timezone-dropdown .p-dropdown-trigger:focus {\n  background: #fff !important;\n  background-image: none !important;\n  color: #1f2937 !important;\n}\n\n.schedule-timezone-preview {\n  display: inline-block;\n  color: #52677d;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  white-space: normal;\n  margin-left: 2px;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 640px) {\n  .schedule-timezone-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Keep SweetAlert overlays from toggling the document scrollbar and shifting the page. */\nhtml {\n  scrollbar-gutter: stable;\n}\n\nhtml.swal2-shown,\nbody.swal2-shown {\n  overflow-y: auto !important;\n}\n\nbody.swal2-shown {\n  padding-right: 0 !important;\n}\n\nbody.modal-open {\n  padding-right: 0 !important;\n}\n\n.modal {\n  padding-right: 0 !important;\n}\n\n.manager-dashboard-page .manager-dashboard-activity-table .manager-table-strong,\n.manager-dashboard-page .manager-dashboard-recent-table .manager-table-strong {\n  font-size: 11px !important;\n  line-height: 1.2;\n}\n\n.resume-upload-result-modal .modal-content {\n  border: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 18px 50px rgba(15, 23, 42, .18);\n}\n\n.resume-upload-result-modal .modal-body {\n  padding: 24px 28px 18px !important;\n  background: #f8fafc;\n}\n\n.resume-upload-invite-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.resume-upload-summary-section {\n  padding: 0;\n}\n\n.resume-upload-summary-title {\n  margin: 0 0 10px;\n  color: #164e73;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: .02em;\n  text-transform: uppercase;\n}\n\n.resume-upload-metric,\n.resume-upload-total-summary > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 54px;\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.resume-upload-metric strong,\n.resume-upload-total-summary strong {\n  font-size: 18px;\n}\n\n.resume-upload-metric-success { color: #168457; background: #f0fdf7; border-color: #c6f0dc; }\n.resume-upload-metric-warning { color: #a66a00; background: #fffaf0; border-color: #f9dfaa; }\n.resume-upload-metric-danger { color: #c53030; background: #fff5f5; border-color: #f3c5c5; }\n\n.resume-upload-total-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.resume-upload-total-summary > div {\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 74px;\n  color: #334155;\n}\n\n.resume-upload-result-modal table {\n  margin-bottom: 0;\n  background: #fff;\n  border-color: #dbe3ec;\n}\n\n.resume-upload-result-modal table thead th {\n  padding: 11px 13px;\n  color: #1e3a56;\n  background: #eaf4fb;\n  border-color: #dbe3ec;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: .02em;\n}\n\n.resume-upload-result-modal table tbody td {\n  padding: 12px 13px;\n  color: #334155;\n  vertical-align: middle;\n}\n\n@media (max-width: 576px) {\n  .resume-upload-result-modal .modal-body { padding: 18px 14px 12px !important; }\n  .resume-upload-invite-summary,\n  .resume-upload-total-summary { grid-template-columns: 1fr; }\n}\n\n.manager-dashboard-activity-table .p-paginator {\n  min-height: 42px;\n  padding: 5px 8px !important;\n  border-top: 1px solid #dbe3ef;\n  gap: 4px;\n  justify-content: center;\n}\n\n.manager-dashboard-activity-table .p-paginator .p-dropdown {\n  width: 64px !important;\n  height: 30px !important;\n  min-height: 30px !important;\n}\n\n.manager-dashboard-activity-table .p-paginator .p-dropdown-label {\n  padding: 5px 8px !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n}\n\n.manager-dashboard-activity-table .p-paginator .p-dropdown-trigger {\n  width: 26px !important;\n}\n\n.manager-dashboard-activity-table .p-paginator .p-paginator-first,\n.manager-dashboard-activity-table .p-paginator .p-paginator-prev,\n.manager-dashboard-activity-table .p-paginator .p-paginator-next,\n.manager-dashboard-activity-table .p-paginator .p-paginator-last {\n  width: 28px !important;\n  min-width: 28px !important;\n  height: 28px !important;\n  margin: 0 1px !important;\n}\n\n.manager-dashboard-activity-table .p-paginator .p-paginator-current {\n  font-size: 12px;\n  color: #64748b;\n  margin: 0 8px !important;\n  min-width: auto;\n}\n\n.manager-role-application-row {\n  gap: 12px;\n}\n\n.manager-role-application-title {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.manager-role-application-count {\n  flex: 0 0 auto;\n}\n#All_Employees_TableView table tbody tr td:nth-child(5),\n#All_Employees_TableView table tbody tr td:nth-child(4),\n#All_Employees_TableView table tbody tr td:nth-child(2),\n#All_Employees_TableView table tbody tr td:nth-child(1) {\n  text-align: center !important;\n}\n/* Modal */\n.notification-modal .modal-content {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Header */\n.notification-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 12px 16px;\n}\n\n/* Body */\n.notification-body {\n  max-height: 420px;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n/* Notification Item */\n.notification-item {\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 6px;\n  transition: background 0.2s ease;\n}\n\n.notification-item.unread {\n  background: #f1f7ff;\n}\n\n.notification-item.read {\n  background: #ffffff;\n  opacity: 0.8;\n}\n\n.notification-item:hover {\n  background: #eef4ff;\n}\n\n/* Icon */\n.notification-icon {\n  width: 40px;\n  height: 40px;\n  background: #e7f0ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0d6efd;\n  font-size: 16px;\n}\n\n/* Content */\n.notification-content {\n  flex: 1;\n  padding-left: 12px;\n}\n\n.notification-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.notification-message {\n  font-size: 13px;\n  color: #495057;\n  margin-top: 2px;\n}\n\n/* Footer */\n.notification-footer {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #6c757d;\n}\n\n/* Date */\n.notification-date {\n  font-size: 11px;\n}\n\n/* Mark Read Button */\n.mark-read-btn {\n  background: none;\n  border: none;\n  color: #0d6efd;\n  font-size: 11px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.mark-read-btn:hover {\n  text-decoration: underline;\n}\n\n/* Empty State */\n.no-notification {\n  text-align: center;\n  padding: 30px;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n/* #All_Employees_TableView table thead tr th:nth-child(2) {\n  border: 2px solid red;\n  width: 120px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(2) span {\n  border: 2px solid red;\n  width: 120px;\n} */\n\n.CandidateAprRejReason {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 200px;\n}\n\n#AdminModule_Tabs .p-tabview-panels {\n  display: none;\n}\n\n.admin-dashboard-workspace #AdminModule_Tabs > .p-tabview {\n  flex: 1 1 480px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.admin-dashboard-workspace #AdminModule_Tabs > button {\n  flex: 0 0 auto;\n  max-width: 100%;\n}\n\n#PreviewJobPortalCards ul {\n}\n\n#All_Notifications_Modal .btn-close {\n  margin-left: 3px;\n  filter: invert(1);\n  opacity: 1;\n}\n.tab-btn {\n  background: none;\n  border: none;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #6b7280;\n  position: relative;\n  cursor: pointer;\n}\n\n.tab-btn.active {\n  color: #3a85f7;\n  font-weight: 600;\n}\n\n.tab-btn.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #4c8cec;\n  border-radius: 2px;\n}\n\n/* #RecentOpenJobs_TableView table tr td { \n  border: 2px solid red;\n   \n} */\n#RecentOpenJobs_TableView table tbody tr td {\n  border-right: 1px solid #ddd;\n}\n\n#RecentOpenJobs_TableView table tbody tr td:last-child {\n  border-right: initial;\n}\n\n#RecentOpenJobs_TableView table tr td:nth-child(10) span,\n#RecentOpenJobs_TableView table tr td:nth-child(9) span,\n#RecentOpenJobs_TableView table tr td:nth-child(6) span,\n#RecentOpenJobs_TableView table tr td:nth-child(5) span,\n#RecentOpenJobs_TableView table tr td:nth-child(2) span {\n  display: inline-block;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#RecentOpenJobs_TableView table tr th:nth-child(12) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(11) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(10) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(9) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(8) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(7) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(6) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(5) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(4) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(3) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(2) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(1) span:first-child {\n  width: 100%;\n  justify-content: center !important;\n  display: inline-block;\n  text-align: center;\n}\n\n#RecentOpenJobs_TableView table tr td:nth-child(12),\n#RecentOpenJobs_TableView table tr td:nth-child(11),\n#RecentOpenJobs_TableView table tr td:nth-child(7),\n#RecentOpenJobs_TableView table tr td:nth-child(4),\n#RecentOpenJobs_TableView table tr td:nth-child(3),\n#RecentOpenJobs_TableView table tr td:nth-child(1) {\n  text-align: center !important;\n}\n/* \nwhite-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n */\n#JObInfoModal .btn-close {\n  /* border: 2px solid red; */\n  /* display: none; */\n}\n#BulkUploadModal .btn-close {\n  border: 2px solid red;\n  display: none;\n}\n/* highlight today's cell */\n/* .rbc-month-view .rbc-day-bg.today-highlight {\n  background-color: #eaf6ff; /* light blue */\n/* }  */\n.today-highlight {\n  /* border: 2px solid #0d6efd; */\n  background-color: #eaf6ff;\n  /* border-radius: 6px;   */\n}\n\n.Selected_BgColor {\n  /* background-color: lightblue; */\n  background-color: #e0f2f7;\n}\n#AllEmployees_TableView table th:nth-child(1),\n#AllEmployees_TableView table th:nth-child(2),\n#AllEmployees_TableView table th:nth-child(3),\n#AllEmployees_TableView table th:nth-child(4),\n#AllEmployees_TableView table th:nth-child(5) {\n  width: 260px;\n}\n/* #AllEmployees_TableView table tbody td:nth-child(3) span, */\n#AllEmployees_TableView\n  table\n  tbody\n  td:nth-child(2)\n  #AllEmployees_TableView\n  table\n  tbody\n  td:nth-child(5) {\n  border: 2px solid red;\n  width: 200px;\n}\n.sun-editor-wrapper .sun-editor {\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n}\n\n.sun-editor-wrapper.sun-error .sun-editor {\n  border: 2px solid #dc3545 !important;\n}\n\n.RecruiterNamesListContainer {\n  height: 50vh;\n  overflow: auto;\n}\n#SectioScoreDatatable table tbody td:nth-child(1),\n#SectioScoreDatatable table tbody td:nth-child(2),\n#SectioScoreDatatable table tbody td:nth-child(3),\n#SectioScoreDatatable table tbody td:nth-child(4),\n#SectioScoreDatatable table tbody td:nth-child(5),\n#SectioScoreDatatable table tbody td:nth-child(6) {\n  text-align: center !important;\n  border-right: 1px solid #eaf6ff;\n}\n#SectioScoreDatatable table th:nth-child(1) div,\n#SectioScoreDatatable table th:nth-child(2) div,\n#SectioScoreDatatable table th:nth-child(3) div,\n#SectioScoreDatatable table th:nth-child(4) div,\n#SectioScoreDatatable table th:nth-child(5) div,\n#SectioScoreDatatable table th:nth-child(6) div {\n  justify-content: center !important;\n}\n\n/* #LinkCandidates_DataTableView table tbody {\n  height: 60vh;\n  overflow: auto;\n} */\n#ArchiveReasonTableView table tr td:nth-child(10) div {\n  width: 150px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(4) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(3) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(2) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.MobilePhoneContaier {\n  display: inline-block;\n  /* width: 80px !important; */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#RecruiterReports_TableView table thead tr th:nth-child(6) div,\n#RecruiterReports_TableView table thead tr th:nth-child(5) div,\n#RecruiterReports_TableView table thead tr th:nth-child(4) div,\n#MyPipelineReportTable table thead tr th:nth-child(6) div,\n#MyPipelineReportTable table thead tr th:nth-child(5) div,\n#MyPipelineReportTable table thead tr th:nth-child(4) div,\n#MyPipelineReportTable table thead tr th:nth-child(3) div,\n#MyPipelineReportTable table thead tr th:nth-child(2) div,\n#MyPipelineReportTable table thead tr th:nth-child(1) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(11) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(10) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(9) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(8) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(7) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(6) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(5) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(4) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(3) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(2) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(1) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(9) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(8) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(7) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(6) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(5) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(4) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(3) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(2) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(1) div,\n#JobTableView table thead tr th:nth-child(1) div,\n#JobTableView table thead tr th:nth-child(2) div,\n#JobTableView table thead tr th:nth-child(3) div,\n#JobTableView table thead tr th:nth-child(1) div,\n#CandidateInfo table thead tr th:nth-child(2) div,\n#CandidateInfo table thead tr th:nth-child(3) div,\n#CandidateInfo table thead tr th:nth-child(4) div,\n#ArchiveReasonTableView table thead tr th:nth-child(1) div,\n#ArchiveReasonTableView table thead tr th:nth-child(2) div,\n#ArchiveReasonTableView table thead tr th:nth-child(3) div,\n#ArchiveReasonTableView table thead tr th:nth-child(4) div,\n#ArchiveReasonTableView table thead tr th:nth-child(5) div,\n#ArchiveReasonTableView table thead tr th:nth-child(6) div,\n#ArchiveReasonTableView table thead tr th:nth-child(7) div,\n#ArchiveReasonTableView table thead tr th:nth-child(8) div,\n#ArchiveReasonTableView table thead tr th:nth-child(9) div,\n#ArchiveReasonTableView table thead tr th:nth-child(10) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(11) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(12) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(10) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(9) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(8) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(7) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(6) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(5) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(4) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(3) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(2) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(1) div,\n#RecruiterReports_TableView table thead tr th:nth-child(3) div,\n#RecruiterReports_TableView table thead tr th:nth-child(2) div,\n#RecruiterReports_TableView table thead tr th:nth-child(1) div,\n#RolesList table thead tr th:nth-child(1) div,\n#RolesList table thead tr th:nth-child(2) div,\n#RolesList table thead tr th:nth-child(3) div,\n#RolesList table thead tr th:nth-child(4) div {\n  justify-content: center;\n  border-right: 1px solid #eaf6ff;\n}\n\n#RecruiterReports_TableView table tbody tr td:nth-child(15),\n#RecruiterReports_TableView table tbody tr td:nth-child(14),\n#RecruiterReports_TableView table tbody tr td:nth-child(13),\n#RecruiterReports_TableView table tbody tr td:nth-child(12),\n#RecruiterReports_TableView table tbody tr td:nth-child(11),\n#RecruiterReports_TableView table tbody tr td:nth-child(10),\n#RecruiterReports_TableView table tbody tr td:nth-child(9),\n#RecruiterReports_TableView table tbody tr td:nth-child(8),\n#RecruiterReports_TableView table tbody tr td:nth-child(7),\n#RecruiterReports_TableView table tbody tr td:nth-child(6),\n#RecruiterReports_TableView table tbody tr td:nth-child(5),\n#RecruiterReports_TableView table tbody tr td:nth-child(4),\n#RecruiterReports_TableView table tbody tr td:nth-child(3),\n#RecruiterReports_TableView table tbody tr td:nth-child(2),\n#RecruiterReports_TableView table tbody tr td:nth-child(1),\n#JobTableView table tbody tr td:nth-child(3),\n#JobTableView table tbody tr td:nth-child(2),\n#JobTableView table tbody tr td:nth-child(1),\n#CandidateInfo table tbody tr td:nth-child(1),\n#CandidateInfo table tbody tr td:nth-child(2),\n#CandidateInfo table tbody tr td:nth-child(3),\n#CandidateInfo table tbody tr td:nth-child(4),\n#ArchiveReasonTableView table tbody tr td:nth-child(1),\n#ArchiveReasonTableView table tbody tr td:nth-child(2),\n#ArchiveReasonTableView table tbody tr td:nth-child(3),\n#ArchiveReasonTableView table tbody tr td:nth-child(4),\n#ArchiveReasonTableView table tbody tr td:nth-child(5),\n#ArchiveReasonTableView table tbody tr td:nth-child(6),\n#ArchiveReasonTableView table tbody tr td:nth-child(7),\n#ArchiveReasonTableView table tbody tr td:nth-child(8),\n#ArchiveReasonTableView table tbody tr td:nth-child(9),\n#ArchiveReasonTableView table tbody tr td:nth-child(10),\n#ArchiveReasonTableView table tbody tr td:nth-child(11),\n#RecruiterReports_TableView table tbody tr td:nth-child(2),\n#RecruiterPerformanceReport table tbody tr td:nth-child(14),\n#RecruiterPerformanceReport table tbody tr td:nth-child(13),\n#RecruiterPerformanceReport table tbody tr td:nth-child(12),\n#RecruiterPerformanceReport table tbody tr td:nth-child(11),\n#RecruiterPerformanceReport table tbody tr td:nth-child(10),\n#RecruiterPerformanceReport table tbody tr td:nth-child(9),\n#RecruiterPerformanceReport table tbody tr td:nth-child(8),\n#RecruiterPerformanceReport table tbody tr td:nth-child(7),\n#RecruiterPerformanceReport table tbody tr td:nth-child(6),\n#RecruiterPerformanceReport table tbody tr td:nth-child(5),\n#RecruiterPerformanceReport table tbody tr td:nth-child(4),\n#RecruiterPerformanceReport table tbody tr td:nth-child(3),\n#RecruiterPerformanceReport table tbody tr td:nth-child(2),\n#RecruiterPerformanceReport table tbody tr td:nth-child(1),\n#ActiveJobSummaryReport table tbody tr td:nth-child(12),\n#ActiveJobSummaryReport table tbody tr td:nth-child(11),\n#ActiveJobSummaryReport table tbody tr td:nth-child(10),\n#ActiveJobSummaryReport table tbody tr td:nth-child(9),\n#ActiveJobSummaryReport table tbody tr td:nth-child(8),\n#ActiveJobSummaryReport table tbody tr td:nth-child(7),\n#ActiveJobSummaryReport table tbody tr td:nth-child(6),\n#ActiveJobSummaryReport table tbody tr td:nth-child(5),\n#ActiveJobSummaryReport table tbody tr td:nth-child(4),\n#ActiveJobSummaryReport table tbody tr td:nth-child(3),\n#ActiveJobSummaryReport table tbody tr td:nth-child(2),\n#ActiveJobSummaryReport table tbody tr td:nth-child(1),\n#TimeToHireReport table tbody tr td:nth-child(13),\n#TimeToHireReport table tbody tr td:nth-child(12),\n#TimeToHireReport table tbody tr td:nth-child(11),\n#TimeToHireReport table tbody tr td:nth-child(10),\n#TimeToHireReport table tbody tr td:nth-child(9),\n#TimeToHireReport table tbody tr td:nth-child(8),\n#TimeToHireReport table tbody tr td:nth-child(7),\n#TimeToHireReport table tbody tr td:nth-child(6),\n#TimeToHireReport table tbody tr td:nth-child(5),\n#TimeToHireReport table tbody tr td:nth-child(4),\n#TimeToHireReport table tbody tr td:nth-child(3),\n#TimeToHireReport table tbody tr td:nth-child(2),\n#TimeToHireReport table tbody tr td:nth-child(1),\n#PlacementReportTable table tbody tr td:nth-child(7),\n#PlacementReportTable table tbody tr td:nth-child(6),\n#PlacementReportTable table tbody tr td:nth-child(5),\n#PlacementReportTable table tbody tr td:nth-child(4),\n#PlacementReportTable table tbody tr td:nth-child(3),\n#PlacementReportTable table tbody tr td:nth-child(2),\n#PlacementReportTable table tbody tr td:nth-child(1),\n#MyPlaceMentReportTable table tbody tr td:nth-child(9),\n#MyPlaceMentReportTable table tbody tr td:nth-child(8),\n#MyPlaceMentReportTable table tbody tr td:nth-child(7),\n#MyPlaceMentReportTable table tbody tr td:nth-child(6),\n#MyPlaceMentReportTable table tbody tr td:nth-child(5),\n#MyPlaceMentReportTable table tbody tr td:nth-child(4),\n#MyPlaceMentReportTable table tbody tr td:nth-child(3),\n#MyPlaceMentReportTable table tbody tr td:nth-child(2),\n#MyPlaceMentReportTable table tbody tr td:nth-child(1),\n#AllEmployees_TableView table tbody tr td:nth-child(10),\n#AllEmployees_TableView table tbody tr td:nth-child(9),\n#AllEmployees_TableView table tbody tr td:nth-child(7),\n#MyPipelineReportTable table tbody tr td:nth-child(7),\n#MyPipelineReportTable table tbody tr td:nth-child(6),\n#MyPipelineReportTable table tbody tr td:nth-child(5),\n#MyPipelineReportTable table tbody tr td:nth-child(4),\n#MyPipelineReportTable table tbody tr td:nth-child(3),\n#MyPipelineReportTable table tbody tr td:nth-child(2),\n#MyPipelineReportTable table tbody tr td:nth-child(1),\n#RolesList table tbody tr td:nth-child(1),\n#RolesList table tbody tr td:nth-child(2),\n#RolesList table tbody tr td:nth-child(3),\n#RolesList table tbody tr td:nth-child(4) {\n  text-align: center !important;\n  border-right: 1px solid #dbe1e6;\n}\n\n#RolesList table tbody tr td:nth-child(4) > div {\n  justify-content: center !important;\n  align-items: center;\n}\n#RecruiterReports_TableView table tbody tr td:nth-child(2) div {\n  width: 240px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  div\n  #TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  div {\n  font-size: 14px;\n}\n\n/* ========== Candidate View Modal - Clean UI ========== */\n.cv-modal .modal-content {\n  border: none;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.cv-modal .modal-body {\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 0 !important;\n}\n\n/* Profile Header */\n.cv-profile-header {\n  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 100%);\n  padding: 2rem 2rem 1.8rem;\n  text-align: center;\n  position: relative;\n}\n\n.cv-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cv-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.cv-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  border: 3px solid rgba(255, 255, 255, 0.4);\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 0.75rem;\n  letter-spacing: 2px;\n}\n\n.cv-profile-name {\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n}\n\n.cv-profile-company {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.9rem;\n  margin-bottom: 0.2rem;\n}\n\n.cv-profile-exp {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n/* Sections */\n.cv-section {\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.cv-section--last {\n  border-bottom: none;\n  padding-bottom: 1.75rem;\n}\n\n.cv-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #0e527d;\n  margin-bottom: 1rem;\n}\n\n/* Info Items */\n.cv-info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  background: #f8fafb;\n  transition: background 0.2s;\n}\n\n.cv-info-item:hover {\n  background: #eef4f8;\n}\n\n.cv-info-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n}\n\n.cv-info-label {\n  font-size: 0.75rem;\n  color: #8a9bae;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.cv-info-value {\n  font-size: 0.95rem;\n  color: #212529;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n/* Skills Section */\n.cv-skills-section {\n  margin-bottom: 0.85rem;\n}\n\n.cv-skills-section:last-child {\n  margin-bottom: 0;\n}\n\n.cv-skills-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #8a9bae;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.4rem;\n}\n\n.cv-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.cv-skill-badge {\n  padding: 0.3rem 0.7rem;\n  border-radius: 20px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  display: inline-block;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.cv-skill-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.cv-skill-badge--primary {\n  background: #e3f2fd;\n  color: #0d47a1;\n  border: 1px solid #bbdefb;\n}\n\n.cv-skill-badge--secondary {\n  background: #e8f5e9;\n  color: #1b5e20;\n  border: 1px solid #c8e6c9;\n}\n\n.cv-skill-badge--other {\n  background: #fff3e0;\n  color: #e65100;\n  border: 1px solid #ffe0b2;\n}\n\n/* Resume Button */\n.cv-resume-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.6rem 1.25rem;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-decoration: none;\n  transition: opacity 0.2s, transform 0.15s;\n}\n\n.cv-resume-btn:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n  color: #fff;\n  text-decoration: none;\n}\n\n.cv-resume-ext {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n/* ========== Candidates Page - Premium UI ========== */\n\n/* Hero Banner */\n.cd-hero {\n  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 50%, #46a4cf 100%);\n  border-radius: 16px;\n  padding: 1.5rem 2rem;\n  margin-bottom: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.cd-hero::before {\n  content: \"\";\n  position: absolute;\n  top: -40%;\n  right: -5%;\n  width: 250px;\n  height: 250px;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 50%;\n}\n\n.cd-hero::after {\n  content: \"\";\n  position: absolute;\n  bottom: -60%;\n  right: 10%;\n  width: 180px;\n  height: 180px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 50%;\n}\n\n.cd-hero-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1;\n}\n\n.cd-hero-title {\n  color: #fff;\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.cd-hero-subtitle {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.85rem;\n  margin: 0.2rem 0 0;\n}\n\n.cd-hero-right {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.cd-hero-stat {\n  text-align: center;\n}\n\n.cd-hero-stat-number {\n  display: block;\n  color: #fff;\n  font-size: 1.75rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.cd-hero-stat-label {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 600;\n}\n\n/* Controls Bar */\n.cd-controls {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);\n  border: 1px solid #f0f0f0;\n}\n\n.cd-controls-top {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.cd-search-wrapper {\n  flex: 1;\n  max-width: 400px;\n  position: relative;\n}\n\n.cd-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 0.85rem;\n  z-index: 2;\n}\n\n.cd-search-wrapper .cd-search-input {\n  padding-left: 36px !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 10px !important;\n  height: 40px;\n  font-size: 0.88rem;\n  background: #f9fafb !important;\n  transition: all 0.2s;\n}\n\n.cd-search-wrapper .cd-search-input:focus {\n  border-color: #1a87cb !important;\n  background: #fff !important;\n  box-shadow: 0 0 0 3px rgba(26, 135, 203, 0.1) !important;\n}\n\n.cd-search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 11px;\n  z-index: 2;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cd-search-clear:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.cd-controls-right-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.cd-company-select {\n  width: 185px;\n}\n\n/* Filter Chips */\n.cd-controls-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.cd-filters {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cd-filter-chip-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.cd-filter-chip {\n  display: flex;\n  align-items: center;\n  background: #f4f7fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\n.cd-filter-chip:focus-within {\n  border-color: #1a87cb;\n  box-shadow: 0 0 0 2px rgba(26, 135, 203, 0.1);\n}\n\n.cd-filter-chip-icon {\n  padding: 0 0.6rem;\n  color: #6b7280;\n  font-size: 0.8rem;\n  border-right: 1px solid #e5e7eb;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  background: #eef1f5;\n}\n\n.cd-filter-chip-select {\n  border: none !important;\n  background: transparent !important;\n  font-size: 0.84rem;\n  color: #374151;\n  padding: 0.35rem 1.75rem 0.35rem 0.6rem;\n  cursor: pointer;\n  outline: none;\n  min-width: 120px;\n  appearance: auto;\n}\n\n.cd-clear-filters {\n  display: flex;\n  align-items: center;\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cd-clear-filters:hover {\n  background: #fee2e2;\n  border-color: #f87171;\n}\n\n/* Action Buttons */\n.cd-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.cd-action-btn {\n  border-radius: 8px !important;\n  font-size: 0.82rem !important;\n  font-weight: 600 !important;\n  padding: 0.42rem 0.85rem !important;\n  transition: all 0.2s !important;\n  white-space: nowrap;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 0.15rem;\n}\n\n.cd-action-btn--outline {\n  background: #fff !important;\n  color: #374151 !important;\n  border: 1px solid #d1d5db !important;\n}\n\n.cd-action-btn--outline:hover {\n  background: #f9fafb !important;\n  border-color: #9ca3af !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n.cd-action-btn--outline:disabled {\n  opacity: 0.5 !important;\n  transform: none !important;\n}\n\n.cd-action-btn--primary {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  color: #fff !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.25);\n}\n\n.cd-action-btn--primary:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(14, 82, 125, 0.35) !important;\n}\n\n/* Data Card */\n.cd-data-card {\n  border: none !important;\n  border-radius: 14px !important;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04) !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  background: #fff !important;\n  border: 1px solid #f0f0f0 !important;\n}\n\n.cd-table-wrapper {\n  overflow: hidden;\n}\n\n.cd-loading-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 250px;\n  background: #fafbfc;\n}\n\n/* ===== DataTable Cell Styles ===== */\n\n/* Name Cell - Avatar + Name + Email */\n.cd-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.cd-name-avatar {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 1px;\n}\n\n.cd-name-text {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 0.88rem;\n  line-height: 1.3;\n  max-width: 160px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cd-name-email {\n  font-size: 0.73rem;\n  color: #94a3b8;\n  max-width: 160px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Job Tag */\n.cd-job-tag {\n  background: #eff6ff;\n  color: #1d4ed8;\n  padding: 0.25rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: inline-block;\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: 1px solid #dbeafe;\n}\n\n/* Phone */\n.cd-phone-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.cd-phone-icon {\n  color: #10b981;\n  font-size: 0.7rem;\n}\n\n/* Source Badge */\n.cd-source-badge {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* Cell Primary / Meta */\n.cd-cell-primary {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 0.85rem;\n}\n\n.cd-cell-meta {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n}\n\n/* Pipeline Badge */\n.cd-pipeline-badge {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* HRMS Badge */\n.cd-hrms-badge {\n  background: #fae8ff;\n  color: #86198f;\n  border: 1px solid #f0abfc;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* Talent Scan Button */\n.cd-scan-btn {\n  border: none;\n  border-radius: 8px;\n  padding: 0.3rem 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.2s;\n}\n\n.cd-scan-btn--ready {\n  background: #ecfdf5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.cd-scan-btn--ready:hover {\n  background: #d1fae5;\n  transform: translateY(-1px);\n}\n\n.cd-scan-btn--pending {\n  background: #f1f5f9;\n  color: #94a3b8;\n  border: 1px solid #e2e8f0;\n  cursor: not-allowed;\n}\n\n/* Actions Cell */\n.cd-actions-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.cd-actions-main {\n  display: flex;\n  gap: 0.3rem;\n}\n\n.cd-icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.82rem;\n  transition: all 0.2s;\n  color: #64748b;\n}\n\n.cd-icon-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.cd-icon-btn--edit:hover {\n  background: #eff6ff;\n  color: #2563eb;\n  border-color: #bfdbfe;\n}\n\n.cd-icon-btn--view:hover {\n  background: #f0fdf4;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.cd-icon-btn--logs:hover {\n  background: #fefce8;\n  color: #ca8a04;\n  border-color: #fde68a;\n}\n\n/* Approval Buttons */\n.cd-actions-approval {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.cd-approval-btn {\n  border: none;\n  border-radius: 6px;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.15s;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.cd-approval-btn--approve {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.cd-approval-btn--approve:hover {\n  background: #bbf7d0;\n}\n\n.cd-approval-btn--reject {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.cd-approval-btn--reject:hover {\n  background: #fecaca;\n}\n\n.cd-approval-btn--info {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.cd-approval-btn--info:hover {\n  background: #bae6fd;\n}\n\n/* Empty State */\n.cd-empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n}\n\n.cd-empty-icon {\n  font-size: 2.5rem;\n  color: #cbd5e1;\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.cd-empty-text {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #475569;\n  margin: 0;\n}\n\n.cd-empty-sub {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  margin: 0.25rem 0 0;\n}\n\n/* ===== DataTable Overrides ===== */\n#CandidateList_CardView .cd-datatable .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  border-bottom: 2px solid #e2e8f0 !important;\n  border-top: none !important;\n  padding: 0.9rem 0.75rem;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr {\n  transition: all 0.15s ease;\n  border-left: 3px solid transparent;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:nth-child(even) {\n  background: #fafbfc;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:hover {\n  background: #eff6ff !important;\n  border-left-color: #1a87cb;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr > td {\n  padding: 0.7rem 0.75rem;\n  font-size: 0.86rem;\n  color: #374151;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n/* Paginator */\n#CandidateList_CardView .cd-datatable .p-paginator {\n  border: none !important;\n  background: #f8fafc !important;\n  padding: 0.75rem 1rem !important;\n  border-top: 2px solid #e2e8f0 !important;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page {\n  border-radius: 8px;\n  min-width: 34px;\n  height: 34px;\n  margin: 0 2px;\n  font-weight: 600;\n  font-size: 0.82rem;\n  transition: all 0.15s;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page.p-highlight {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  border-color: transparent !important;\n  color: #fff !important;\n  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.3);\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page:not(.p-highlight):hover {\n  background: #eff6ff !important;\n}\n\n/* Checkbox */\n#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box {\n  border-radius: 6px;\n  border: 2px solid #cbd5e1;\n  width: 20px;\n  height: 20px;\n  transition: all 0.15s;\n}\n\n#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box.p-highlight {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  border-color: #0e527d !important;\n}\n\n/* Scrollbar */\n#CandidateList_CardView .cd-datatable .p-datatable-wrapper::-webkit-scrollbar {\n  height: 6px;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .cd-hero-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .cd-hero-right {\n    align-self: flex-start;\n  }\n  .cd-controls-top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .cd-search-wrapper {\n    max-width: 100%;\n  }\n  .cd-controls-right-group {\n    margin-left: 0;\n  }\n  .cd-controls-bottom {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .cd-actions {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 576px) {\n  .cd-hero {\n    padding: 1.25rem;\n    border-radius: 12px;\n  }\n  .cd-hero-title {\n    font-size: 1.25rem;\n  }\n  .cd-filter-chip-group {\n    flex-direction: column;\n  }\n  .cd-actions {\n    flex-direction: column;\n  }\n  .cd-action-btn {\n    width: 100% !important;\n    justify-content: center !important;\n  }\n}\n\n#SecondScreeningContainer {\n  height: 500px;\n  overflow-y: scroll;\n}\n\n/* Telephonic Test Table Sticky Columns Starting */\n#TelephonicTest_Table {\n  position: relative;\n}\n\n#TelephonicTest_Table .rdt_Table,\n#TelephonicTest_Table .sc-fLlhyt {\n  position: relative;\n}\n\n#TelephonicTest_Table .rdt_TableBody {\n  position: sticky;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(1) {\n  position: sticky;\n  left: 0;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(2) {\n  position: sticky;\n  left: 180px;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(3) {\n  position: sticky;\n  left: 380px;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  position: sticky;\n  left: 0;\n  top: 0;\n  background-color: var(--white);\n  z-index: 1;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n  position: sticky;\n  left: 180px;\n  top: 0;\n  z-index: 1;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n  position: sticky;\n  left: 380px;\n  top: 0;\n  z-index: 1;\n  justify-content: initial;\n}\n\n#TelephonicTest_Table .rdt_TableRow:nth-child(even) .rdt_TableCell {\n  background-color: var(--white);\n}\n\n#TelephonicTest_Table .rdt_TableRow:nth-child(odd) .rdt_TableCell {\n  background-color: var(--table-row-bg-light-grey);\n}\n\n@media screen and (min-width: 100px) and (max-width: 991px) {\n  #TelephonicTest_Table .rdt_TableBody {\n    position: relative;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(1) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(2) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(3) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n}\n/* /Telephonic Test Table Sticky Columns Ending */\n\n#SkillLevelConfiguration_TableView .rdt_Table .rdt_TableBody .rdt_TableRow {\n  /* border: 2px solid white; */\n  /* margin-bottom: 8px;\n  margin-top: 8px; */\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n/* ── Bulk Outreach Modal ─────────────────────────────────────── */\n.bo-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n}\n.bo-modal .modal-header {\n  padding: 20px 24px 0;\n  border: none;\n}\n.bo-modal .modal-body {\n  padding: 0 24px 14px;\n  background: linear-gradient(180deg, #f8fbff 0%, #f4f8ff 100%);\n}\n.bo-modal .modal-footer {\n  padding: 18px 24px 22px;\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n.bo-modal .modal-content {\n  border: 0;\n  border-radius: 22px;\n  overflow: hidden;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);\n}\n.bo-modal .modal-header {\n  padding: 22px 24px 10px;\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n}\n\n.bo-colored-header .btn-close {\n  filter: brightness(0) invert(1);\n  opacity: 0.95;\n}\n\n.bo-colored-header .btn-close:hover {\n  opacity: 1;\n}\n\n.sent-email-modal .modal-content {\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);\n}\n\n.sent-email-modal-header {\n  padding: 18px 22px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.sent-email-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.4;\n}\n\n.sent-email-modal-body {\n  padding: 16px;\n  max-height: 78vh;\n  overflow-y: auto;\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);\n}\n\n.sent-email-modal-footer {\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.sent-email-preview-shell {\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #f8fafc;\n}\n\n.email-body-content {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 32px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.email-body-content img {\n  max-width: 100% !important;\n  height: auto !important;\n}\n\n.email-body-content table {\n  max-width: 100% !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.email-body-content td,\n.email-body-content th {\n  word-break: break-word;\n  vertical-align: top;\n}\n\n.email-body-content a {\n  color: #2563eb;\n}\n\n.email-body-content p,\n.email-body-content div,\n.email-body-content li,\n.email-body-content span {\n  line-height: 1.55;\n}\n\n.email-body-content ul,\n.email-body-content ol {\n  padding-left: 24px;\n  margin-bottom: 1rem;\n}\n\n.email-body-content * {\n  max-width: 100%;\n}\n\n.email-body-content > * {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.email-body-content > table,\n.email-body-content > div,\n.email-body-content > section {\n  width: 100%;\n}\n.bo-tabs {\n  display: flex;\n  gap: 10px;\n  margin: 14px 0 22px;\n  border-bottom: 0;\n}\n.bo-tab {\n  flex: 1;\n  text-align: center;\n  padding: 11px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #64748b;\n  border: 1px solid #dbe7f5;\n  border-radius: 12px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n.bo-tab.active {\n  color: #1d4ed8;\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);\n}\n.bo-tab.done {\n  color: #15803d;\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n.bo-channel-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  background: #fff;\n  font-size: 0;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.15s ease;\n}\n.bo-channel-btn::after {\n  content: \"Email\";\n  font-size: 13px;\n  line-height: 1;\n}\n.bo-channel-btn.wp::after {\n  content: \"WhatsApp\";\n}\n.bo-channel-btn.active {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #2563eb;\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);\n}\n.bo-channel-btn.active.wp {\n  border-color: #16a34a;\n  background: #f0fdf4;\n  color: #16a34a;\n  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.12);\n}\n.bo-channel-btn svg {\n  font-size: 15px;\n  flex-shrink: 0;\n}\n.bo-channel-btn input {\n  flex-shrink: 0;\n}\n\n.bo-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n.bo-input {\n  width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 11px 14px;\n  font-size: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  outline: none;\n  transition: 0.15s ease;\n}\n.bo-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);\n}\n.bo-textarea {\n  resize: vertical;\n  min-height: 190px;\n  font-family: inherit;\n}\n.bo-input-subject {\n  min-height: 48px;\n  border-width: 1.5px;\n  font-weight: 600;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n}\n.bo-input-message {\n  min-height: 220px;\n  line-height: 1.65;\n  border-width: 1.5px;\n  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 100%);\n}\n.bo-input-subject::placeholder,\n.bo-input-message::placeholder {\n  color: #94a3b8;\n}\n.bo-review-list {\n  height: auto;\n  min-height: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.bo-review-list::-webkit-scrollbar {\n  width: 8px;\n}\n.bo-review-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 999px;\n}\n.bo-review-list::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n.bo-panel {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n.bo-section-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.bo-section-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #2563eb;\n  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);\n  flex-shrink: 0;\n}\n.bo-section-title {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: #0f172a;\n}\n.bo-section-subtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.bo-vars {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n.bo-var {\n  background: #f1f5f9;\n  color: #475569;\n  border-radius: 6px;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-family: monospace;\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n  transition: 0.15s;\n}\n.bo-var:hover {\n  background: #e2e8f0;\n}\n\n.bo-hint {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #9a3412;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-top: 16px;\n}\n\n.bo-alert {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #1d4ed8;\n  margin-bottom: 18px;\n}\n\n.bo-info-row {\n  display: flex;\n  align-items: baseline;\n  padding: 6px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 14px;\n}\n.bo-info-row:last-child {\n  border: none;\n}\n.bo-info-label {\n  width: 110px;\n  color: #64748b;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.bo-card {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px 20px;\n  height: 300px;\n  overflow: auto;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n.bo-card-1 {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px 20px;\n  /* height: 300px; */\n  /* overflow: auto; */\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n\n.bo-candidate-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n.bo-candidate-item:last-child {\n  border: none;\n}\n.bo-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.bo-check-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  font-size: 14px;\n  cursor: pointer;\n}\n.bo-check-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2563eb;\n  cursor: pointer;\n}\n\n.bo-btn-primary {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);\n}\n.bo-btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24);\n}\n.bo-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.bo-btn-secondary {\n  background: #fff;\n  color: #374151;\n  border: 1px solid #d6deeb;\n  border-radius: 12px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.15s ease;\n}\n.bo-btn-secondary:hover {\n  background: #f8fafc;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n@media (max-width: 767px) {\n  .bo-tabs {\n    flex-direction: column;\n  }\n  .bo-modal .modal-body {\n    padding: 0 16px 14px;\n  }\n  .bo-modal .modal-footer {\n    padding: 16px;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .bo-card,\n  .bo-card-1,\n  .bo-panel {\n    padding: 16px;\n  }\n}\n.cs-root {\n  min-height: 100vh;\n  background: #eef0f5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 32px 16px 48px;\n    font-family: 'DM Sans', sans-serif;\n}\n\n.cs-card {\n  background: #fff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 420px;\n    box-shadow: 0 8px 40px rgba(0,0,0,0.10);\n  overflow: hidden;\n}\n\n/* ── Header Banner ── */\n.cs-header {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 60%, #6366f1 100%);\n  padding: 28px 24px 32px;\n  position: relative;\n  overflow: hidden;\n}\n.cs-header::before {\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  right: -40px;\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.07);\n}\n.cs-header::after {\n  content: \"\";\n  position: absolute;\n  bottom: -30px;\n  left: -20px;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.05);\n}\n.cs-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n.cs-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.cs-logo {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n.cs-company-name {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n.cs-company-sub {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 11px;\n  font-weight: 400;\n}\n.cs-expires {\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n.cs-job-title {\n  font-family: \"Fraunces\", serif;\n  font-size: 26px;\n  font-weight: 900;\n  color: #fff;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n.cs-greeting {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.cs-greeting strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n/* ── Body ── */\n.cs-body {\n  padding: 24px;\n}\n\n/* Info grid */\n.cs-info-grid {\n  display: grid;\n  /* grid-template-columns: 2fr 2fr; */\n  gap: 10px;\n  margin-bottom: 22px;\n}\n.cs-info-box {\n  background: #f7f8fc;\n  border: 1px solid #ebebf0;\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n.cs-info-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: #9399a6;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.cs-info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1d23;\n  line-height: 1.3;\n}\n\n/* Section label */\n.cs-section-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9399a6;\n  margin-bottom: 10px;\n}\n\n/* About the role */\n.cs-about {\n  margin-bottom: 22px;\n}\n.cs-about-text {\n  font-size: 13.5px;\n  color: #444b5a;\n  line-height: 1.65;\n  margin-bottom: 10px;\n}\n.cs-bullet {\n  font-size: 13px;\n  color: #555e6e;\n  line-height: 1.6;\n  padding-left: 14px;\n  position: relative;\n}\n.cs-bullet::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #7c3aed;\n  font-weight: 700;\n}\n\n/* Skills */\n.cs-skills {\n  margin-bottom: 22px;\n}\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.cs-skill-chip {\n  background: #f0f0f8;\n  border: 1px solid #ddddf5;\n  color: #3d3d8f;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 12px;\n  border-radius: 20px;\n}\n\n/* Interview process */\n.cs-process {\n  margin-bottom: 26px;\n}\n.cs-round {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #f7f8fc;\n  border: 1px solid #ebebf0;\n  border-radius: 12px;\n  margin-bottom: 8px;\n}\n.cs-round:last-child {\n  margin-bottom: 0;\n}\n.cs-round-num {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #7c3aed;\n  color: #7c3aed;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.cs-round-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #1a1d23;\n  margin-bottom: 2px;\n}\n.cs-round-sub {\n  font-size: 12px;\n  color: #8b93a4;\n}\n\n/* Divider */\n.cs-divider {\n  border: none;\n  border-top: 1px solid #ebebf0;\n  margin: 6px 0 22px;\n}\n\n/* CTA section */\n.cs-cta-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #1a1d23;\n  text-align: center;\n  margin-bottom: 5px;\n}\n.cs-cta-sub {\n  font-size: 13px;\n  color: #9399a6;\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n/* Response buttons */\n.cs-btn-interested {\n  width: 100%;\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: all 0.18s ease;\n  text-align: left;\n}\n.cs-btn-interested:hover {\n  background: #dcfce7;\n  border-color: #4ade80;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.15);\n}\n.cs-btn-interested.selected {\n  background: #dcfce7;\n  border-color: #22c55e;\n}\n.cs-btn-decline {\n  width: 100%;\n  background: #fff;\n  border: 1.5px solid #fecaca;\n  border-radius: 14px;\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  text-align: left;\n}\n.cs-btn-decline:hover {\n  background: #fef2f2;\n  border-color: #f87171;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.12);\n}\n.cs-btn-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n.cs-btn-icon.green {\n  background: #22c55e;\n}\n.cs-btn-icon.red {\n  background: #ef4444;\n}\n.cs-btn-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1d23;\n  margin-bottom: 2px;\n}\n.cs-btn-label.green {\n  color: #15803d;\n}\n.cs-btn-label.red {\n  color: #dc2626;\n}\n.cs-btn-sublabel {\n  font-size: 12px;\n  color: #8b93a4;\n}\n.cs-btn-arrow {\n  margin-left: auto;\n  color: #22c55e;\n  font-size: 18px;\n  font-weight: 300;\n}\n\n/* Schedule slot picker */\n.cs-schedule-box {\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 16px;\n  margin-bottom: 10px;\n  animation: fadeSlideIn 0.25s ease;\n}\n@keyframes fadeSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.cs-schedule-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.cs-schedule-icon {\n  width: 28px;\n  height: 28px;\n  background: #22c55e;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n.cs-schedule-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #15803d;\n}\n.cs-schedule-sub {\n  font-size: 12px;\n  color: #4ade80;\n}\n.cs-slot-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.cs-slot-field label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.cs-slot-field input {\n  width: 100%;\n  padding: 9px 12px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 13px;\n  font-family: \"DM Sans\", sans-serif;\n  color: #1a1d23;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.cs-slot-field input:focus {\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n}\n.cs-slot-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.cs-back-btn {\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n.cs-back-btn:hover {\n  background: #f9fafb;\n}\n.cs-confirm-btn {\n  flex: 1;\n  background: linear-gradient(135deg, #6366f1, #7c3aed);\n  border: none;\n  border-radius: 10px;\n  padding: 11px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.18s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-shadow: 0 3px 12px rgba(124, 58, 237, 0.35);\n}\n.cs-confirm-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);\n}\n.cs-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n.cs-slot-error {\n  font-size: 12px;\n  color: #f59e0b;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Declined state */\n.cs-declined-box {\n  background: #fef2f2;\n  border: 1.5px solid #fecaca;\n  border-radius: 14px;\n  padding: 16px;\n  text-align: center;\n  animation: fadeSlideIn 0.25s ease;\n}\n.cs-declined-icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n.cs-declined-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #dc2626;\n  margin-bottom: 4px;\n}\n.cs-declined-sub {\n  font-size: 13px;\n  color: #9399a6;\n}\n\n/* Confirmed state */\n.cs-confirmed-box {\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 20px;\n  text-align: center;\n  animation: fadeSlideIn 0.25s ease;\n}\n.cs-confirmed-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n.cs-confirmed-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #15803d;\n  margin-bottom: 4px;\n}\n.cs-confirmed-sub {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Privacy note */\n.cs-privacy {\n  text-align: center;\n  font-size: 12px;\n  color: #9399a6;\n  margin-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n/* Footer */\n.cs-footer {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 12px;\n  color: #9399a6;\n}\n.cs-footer a {\n  color: #6366f1;\n  font-weight: 600;\n  text-decoration: none;\n}\n.cs-root {\n  min-height: 100vh;\n  background: linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px 40px;\n  font-family: \"Segoe UI\", sans-serif;\n}\n.cs-card {\n  width: 100%;\n  max-width: 820px;\n  background: #fff;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 16px 50px rgba(15, 23, 42, 0.12);\n}\n.cs-header {\n  padding: 20px 20px 10px 20px;\n  background: linear-gradient(135deg, #0f766e 0%, #155e75 100%);\n  color: #fff;\n}\n.cs-kicker {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.8;\n  margin-bottom: 8px;\n}\n.cs-company-name {\n  font-size: 15px;\n  font-weight: 600;\n  opacity: 0.92;\n  margin-bottom: 8px;\n}\n.cs-job-title {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 10px;\n}\n.cs-greeting {\n  font-size: 14px;\n  line-height: 1.6;\n  opacity: 0.95;\n  max-width: 680px;\n}\n.cs-body {\n  padding: 28px;\n}\n.cs-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n.cs-info-box {\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n.cs-info-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n.cs-info-value {\n  font-size: 14px;\n  color: #0f172a;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.cs-section {\n  margin-bottom: 24px;\n}\n.cs-section-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n.cs-about-text {\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.7;\n  margin: 0 0 10px;\n}\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.cs-skill-chip {\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: #ecfeff;\n  border: 1px solid #a5f3fc;\n  color: #155e75;\n  font-size: 13px;\n  font-weight: 600;\n}\n.cs-divider {\n  border: 0;\n  border-top: 1px solid #e2e8f0;\n  margin: 24px 0;\n}\n.cs-cta-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 6px;\n}\n.cs-cta-sub {\n  text-align: center;\n  color: #64748b;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.cs-btn-interested,\n.cs-btn-decline {\n  width: 100%;\n  border-radius: 16px;\n  padding: 16px 18px;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: 0.2s ease;\n}\n.cs-btn-interested {\n  border: 1px solid #86efac;\n  background: #f0fdf4;\n  margin-bottom: 12px;\n}\n.cs-btn-decline {\n  border: 1px solid #fecaca;\n  background: #fff7f7;\n}\n.cs-btn-interested.selected {\n  background: #dcfce7;\n}\n.cs-btn-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.cs-btn-icon.green {\n  background: #16a34a;\n}\n.cs-btn-icon.red {\n  background: #dc2626;\n}\n.cs-btn-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n.cs-btn-sublabel {\n  font-size: 13px;\n  color: #64748b;\n}\n.cs-btn-arrow {\n  margin-left: auto;\n  color: #16a34a;\n  font-size: 20px;\n}\n.cs-schedule-box,\n.cs-declined-box,\n.cs-confirmed-box {\n  border-radius: 16px;\n  padding: 18px;\n}\n.cs-schedule-box {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n}\n.cs-slot-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n.cs-slot-field label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  margin-bottom: 6px;\n}\n.cs-slot-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n}\n.cs-slot-actions {\n  display: flex;\n  gap: 10px;\n}\n.cs-back-btn,\n.cs-confirm-btn {\n  border-radius: 10px;\n  padding: 11px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.cs-back-btn {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.cs-confirm-btn {\n  border: 0;\n  background: #0f766e;\n  color: #fff;\n  flex: 1;\n}\n\n#TemplateForJobOpportunity .btn-success {\n  border: 0;\n  background: #0f766e !important;\n  color: #fff;\n}\n\n.cs-slot-error {\n  margin-top: 10px;\n  color: #b45309;\n  font-size: 13px;\n  font-weight: 600;\n}\n.cs-declined-box {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  text-align: center;\n}\n.cs-confirmed-box {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  text-align: center;\n}\n.cs-state-title {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.cs-state-sub {\n  font-size: 14px;\n  color: #475569;\n  line-height: 1.6;\n}\n.cs-privacy {\n  text-align: center;\n  margin-top: 18px;\n  color: #64748b;\n  font-size: 13px;\n}\n.cs-footer {\n  margin-top: 16px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n}\n@media (max-width: 640px) {\n  .cs-header,\n  .cs-body {\n    padding: 20px;\n  }\n  .cs-job-title {\n    font-size: 26px;\n  }\n  .cs-info-grid,\n  .cs-slot-row {\n    grid-template-columns: 1fr;\n  }\n}\n.bo-input {\n  padding: 6px 30px 6px 10px; /* space for arrow */\n  appearance: none; /* remove default arrow */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: #fff;\n  border: 1px solid #d4dce7;\n  border-radius: 6px;\n  font-size: 14px;\n  height: 36px;\n  /* background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='14' viewBox='0 0 20 20' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.148l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.041a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>\"); */\n  background-repeat: no-repeat;\n  background-position: right 10px center; /* arrow aligned */\n  cursor: pointer;\n}\n.react-select__menu {\n  z-index: 99999 !important;\n}\n\n.react-select__menu-list {\n  z-index: 99999 !important;\n}\n/* Recruiter Report */\n.recruiter-report-page {\n  padding: 16px 12px 28px;\n  background: radial-gradient(\n      circle at top right,\n      rgba(59, 130, 246, 0.08),\n      transparent 22%\n    ),\n    linear-gradient(180deg, #f6f9fc 0%, #eef4fb 100%);\n  min-height: calc(100vh - 110px);\n}\n\n.recruiter-report-hero {\n  background: radial-gradient(\n      circle at top left,\n      rgba(255, 255, 255, 0.22),\n      transparent 18%\n    ),\n    linear-gradient(135deg, #163b8c 0%, #155e75 45%, #0f172a 100%);\n  border-radius: 28px;\n  padding: 22px 24px;\n  color: #fff;\n  margin-bottom: 18px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.18);\n}\n\n.recruiter-report-hero-copy {\n  flex: 1 1 560px;\n}\n\n.recruiter-report-eyebrow {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.78;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.recruiter-report-title {\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1.05;\n}\n\n.recruiter-report-subtitle {\n  font-size: 14px;\n  opacity: 0.92;\n  line-height: 1.55;\n  max-width: 760px;\n}\n\n.recruiter-report-company-card {\n  min-width: 250px;\n  max-width: 300px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 20px;\n  padding: 12px;\n  backdrop-filter: blur(10px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.recruiter-report-company-label {\n  font-size: 11px;\n  margin-bottom: 6px;\n  display: block;\n  opacity: 0.92;\n  font-weight: 700;\n}\n\n.recruiter-report-loading,\n.recruiter-report-error {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #dbe7f5;\n  border-radius: 22px;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-report-loading {\n  padding: 40px 18px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.recruiter-report-loading-text {\n  margin-top: 12px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.recruiter-report-error {\n  color: #be123c;\n  padding: 16px;\n}\n\n.recruiter-report-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.recruiter-summary-card {\n  border-radius: 22px;\n  padding: 18px 16px;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.recruiter-summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);\n}\n\n.recruiter-summary-card-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.recruiter-summary-value {\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.recruiter-summary-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  margin-top: 8px;\n}\n\n.recruiter-summary-accent {\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n}\n\n.recruiter-panel,\n.recruiter-breakdown-panel {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid #dbe7f5;\n  border-radius: 24px;\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-panel {\n  padding: 18px;\n  height: 100%;\n}\n\n.recruiter-panel-header,\n.recruiter-breakdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recruiter-panel-header {\n  margin-bottom: 16px;\n}\n\n.recruiter-panel-title {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-panel-kicker,\n.recruiter-breakdown-count {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.recruiter-snapshot-list,\n.recruiter-metrics-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-snapshot-card {\n  display: grid;\n  grid-template-columns: 48px 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: 16px 18px;\n  border-radius: 20px;\n  border: 1px solid #e5edf8;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.03);\n}\n\n.recruiter-avatar,\n.recruiter-table-avatar {\n  background: linear-gradient(135deg, #2563eb 0%, #0f766e 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.recruiter-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.recruiter-snapshot-name {\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-snapshot-meta {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 3px;\n}\n\n.recruiter-progress-track,\n.recruiter-table-bartrack {\n  margin-top: 9px;\n  height: 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.recruiter-progress-bar {\n  height: 100%;\n  border-radius: 999px;\n}\n\n.recruiter-snapshot-side {\n  text-align: right;\n}\n\n.recruiter-snapshot-score {\n  font-size: 20px;\n  font-weight: 800;\n  color: #2563eb;\n  line-height: 1;\n}\n\n.recruiter-snapshot-side-label,\n.recruiter-table-subtext,\n.recruiter-breakdown-subtitle,\n.recruiter-empty-state {\n  font-size: 10px;\n  color: #64748b;\n}\n\n.recruiter-snapshot-side-label {\n  margin-top: 4px;\n}\n\n.recruiter-metric-card {\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);\n  border: 1px solid #e5edf8;\n  border-radius: 16px;\n  padding: 14px 15px;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.02);\n}\n\n.recruiter-metric-title {\n  font-size: 12px;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.recruiter-metric-desc {\n  font-size: 12px;\n  color: #475569;\n}\n\n.recruiter-breakdown-panel {\n  overflow: hidden;\n}\n\n.recruiter-breakdown-header {\n  padding: 18px;\n  border-bottom: 1px solid #e5edf8;\n}\n\n.recruiter-breakdown-subtitle {\n  margin-top: 4px;\n}\n\n.recruiter-breakdown-table-wrap {\n  overflow-x: auto;\n}\n\n.recruiter-breakdown-table {\n  width: 100%;\n}\n\n.recruiter-breakdown-table thead {\n  background: #f8fbff;\n}\n\n.recruiter-breakdown-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #64748b;\n  border-bottom: 1px solid #e5edf8;\n  white-space: nowrap;\n}\n\n.recruiter-breakdown-table tbody tr.is-alt td {\n  background: #fcfdff !important;\n}\n\n.recruiter-table-person {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.recruiter-table-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 13px;\n}\n\n.recruiter-table-name {\n  color: #0f172a;\n  font-weight: 200;\n}\n\n.recruiter-table-barcell {\n  min-width: 90px;\n}\n\n.recruiter-table-barvalue {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.recruiter-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 38px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.recruiter-chip-warn {\n  color: #b45309;\n  background: #fff7ed;\n}\n\n.recruiter-chip-pink {\n  color: #be185d;\n  background: #fdf2f8;\n}\n\n.recruiter-chip-blue {\n  color: #1d4ed8;\n  background: #eff6ff;\n}\n\n.recruiter-chip-teal {\n  color: #0f766e;\n  background: #ecfeff;\n}\n\n.recruiter-chip-green {\n  color: #15803d;\n  background: #f0fdf4;\n}\n\n.recruiter-empty-table {\n  padding: 24px;\n  text-align: center;\n  color: #64748b;\n}\n\n@media (max-width: 991px) {\n  .recruiter-report-hero {\n    border-radius: 22px;\n    padding: 18px 16px;\n  }\n\n  .recruiter-report-title {\n    font-size: 26px;\n  }\n\n  .recruiter-report-company-card {\n    width: 100%;\n    max-width: none;\n  }\n\n  .recruiter-panel,\n  .recruiter-breakdown-panel {\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .recruiter-report-page {\n    padding: 12px 6px 24px;\n  }\n\n  .recruiter-report-title {\n    font-size: 22px;\n  }\n\n  .recruiter-summary-card,\n  .recruiter-panel {\n    border-radius: 18px;\n  }\n\n  .recruiter-snapshot-card {\n    grid-template-columns: 44px 1fr;\n  }\n\n  .recruiter-snapshot-side {\n    grid-column: 2;\n    text-align: left;\n  }\n}\n\n/* Recruiter Report Refinements */\n.recruiter-report-page {\n  padding: 14px 14px 28px;\n  background: radial-gradient(\n      circle at top left,\n      rgba(14, 165, 233, 0.08),\n      transparent 24%\n    ),\n    radial-gradient(\n      circle at right 20%,\n      rgba(37, 99, 235, 0.07),\n      transparent 18%\n    ),\n    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);\n}\n\n.recruiter-report-hero {\n  position: relative;\n  overflow: hidden;\n  /* min-height: 152px; */\n  margin-bottom: 14px;\n  padding: 20px 22px 16px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.12);\n}\n\n.recruiter-report-hero-copy,\n.recruiter-report-company-card {\n  position: relative;\n  z-index: 2;\n}\n\n.recruiter-report-hero-copy {\n  max-width: 820px;\n}\n\n.recruiter-report-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  letter-spacing: 0.16em;\n}\n\n.recruiter-report-title {\n  margin-top: 12px;\n  margin-bottom: 6px !important;\n  font-size: 28px;\n  line-height: 1.1;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.recruiter-report-subtitle {\n  max-width: 720px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.recruiter-report-hero-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.recruiter-report-hero-pill {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 118px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: rgba(255, 255, 255, 0.84);\n  backdrop-filter: blur(10px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.recruiter-report-hero-pill-highlight {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.14) 0%,\n    rgba(59, 130, 246, 0.18) 100%\n  );\n}\n\n.recruiter-report-hero-pill-value {\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #ffffff;\n}\n\n.recruiter-report-company-card {\n  min-width: 260px;\n  max-width: 290px;\n  padding: 14px;\n  border-radius: 18px;\n  background: rgba(15, 23, 42, 0.28);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(12px);\n}\n\n.recruiter-report-company-label {\n  margin-bottom: 4px;\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.recruiter-report-company-title {\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.recruiter-report-company-footnote {\n  margin-top: 10px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.74);\n}\n\n.recruiter-report-company-card .form-select,\n.recruiter-report-company-card select,\n.recruiter-report-company-card .form-control {\n  min-height: 46px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  box-shadow: none;\n}\n\n.recruiter-report-filter-bar {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1.2fr) repeat(\n      2,\n      minmax(160px, 0.8fr)\n    ) auto;\n  gap: 12px;\n  align-items: end;\n  margin-bottom: 14px;\n  padding: 14px 16px;\n  border-radius: 20px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);\n}\n\n.recruiter-report-filter-summary {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 90px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #f8fbff 0%, #f2f7fd 100%);\n  border: 1px solid #dbe7f3;\n}\n\n.recruiter-report-filter-summary-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-report-filter-summary-value {\n  margin-top: 5px;\n  font-size: 20px;\n  line-height: 1.15;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-report-filter-summary-meta {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.recruiter-report-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.recruiter-report-filter-group-wide {\n  min-width: 0;\n}\n\n.recruiter-report-filter-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-report-filter-input {\n  min-height: 40px;\n  border-radius: 12px;\n  border: 1px solid #d7e3f1;\n  background: #f8fbff;\n  color: #0f172a;\n  box-shadow: none;\n}\n\n.recruiter-report-filter-input:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);\n  background: #ffffff;\n}\n\n.recruiter-report-filter-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recruiter-report-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-report-filter-chip-soft {\n  background: #f8fafc;\n  color: #475569;\n}\n\n.recruiter-report-filter-reset {\n  min-height: 38px;\n  padding: 8px 14px;\n  border-radius: 12px;\n  border: 1px solid #d7e3f1;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-report-filter-reset:hover {\n  background: #f8fbff;\n  border-color: #bfd3ea;\n}\n\n.recruiter-report-hero-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(2px);\n  opacity: 0.55;\n}\n\n.recruiter-report-hero-orb-one {\n  top: -40px;\n  right: 220px;\n  width: 160px;\n  height: 160px;\n  background: radial-gradient(\n    circle,\n    rgba(14, 165, 233, 0.42) 0%,\n    rgba(14, 165, 233, 0) 72%\n  );\n}\n\n.recruiter-report-hero-orb-two {\n  right: -20px;\n  bottom: -36px;\n  width: 220px;\n  height: 220px;\n  background: radial-gradient(\n    circle,\n    rgba(37, 99, 235, 0.34) 0%,\n    rgba(37, 99, 235, 0) 72%\n  );\n}\n\n.recruiter-report-loading,\n.recruiter-report-error {\n  min-height: 180px;\n  border-radius: 22px;\n  border: 1px solid #dce8f5;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.96) 0%,\n    rgba(246, 250, 255, 0.98) 100%\n  );\n  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-report-loading {\n  gap: 14px;\n}\n\n.recruiter-report-loading-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: #47617d;\n}\n\n.recruiter-report-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.recruiter-summary-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-summary-card::after {\n  content: \"\";\n  position: absolute;\n  inset: auto -18px -18px auto;\n  width: 88px;\n  height: 88px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.recruiter-summary-card-inner {\n  position: relative;\n  z-index: 1;\n  min-height: 74px;\n}\n\n.recruiter-summary-value {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.recruiter-summary-label {\n  margin-top: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #47617d;\n}\n\n.recruiter-summary-accent {\n  width: 38px;\n  height: 38px;\n  border-radius: 14px;\n}\n\n.recruiter-insight-strip {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.recruiter-insight-item {\n  padding: 14px 16px;\n  border-radius: 18px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\n}\n\n.recruiter-insight-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-insight-value {\n  margin-top: 8px;\n  font-size: 20px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-insight-value-small {\n  font-size: 15px;\n}\n\n.recruiter-panel,\n.recruiter-breakdown-panel {\n  border-radius: 20px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);\n  backdrop-filter: blur(12px);\n}\n\n.recruiter-panel-header,\n.recruiter-breakdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px 12px;\n}\n\n.recruiter-panel-title {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.recruiter-panel-subtitle,\n.recruiter-breakdown-subtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.recruiter-panel-kicker,\n.recruiter-breakdown-count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-snapshot-list,\n.recruiter-metrics-list {\n  padding: 0 18px 18px;\n}\n\n.recruiter-snapshot-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-snapshot-card {\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: 14px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.recruiter-rank-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #e8f1ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.recruiter-snapshot-main {\n  min-width: 0;\n}\n\n.recruiter-snapshot-card:hover,\n.recruiter-metric-card:hover,\n.recruiter-summary-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);\n}\n\n.recruiter-avatar,\n.recruiter-table-avatar {\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);\n}\n\n.recruiter-progress-track,\n.recruiter-table-bartrack {\n  height: 8px;\n  background: #e8eef7;\n}\n\n.recruiter-snapshot-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.recruiter-inline-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.recruiter-inline-chip-violet {\n  background: #f5f3ff;\n  color: #7c3aed;\n}\n\n.recruiter-inline-chip-blue {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.recruiter-snapshot-score {\n  font-size: 26px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-snapshot-side {\n  min-width: 110px;\n  text-align: right;\n}\n\n.recruiter-snapshot-side-label {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.recruiter-metrics-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-metrics-list-tight {\n  gap: 10px;\n}\n\n.recruiter-scope-card {\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid #dbe7f3;\n  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);\n}\n\n.recruiter-scope-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-scope-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.recruiter-scope-k {\n  display: block;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-scope-v {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.recruiter-metric-card {\n  position: relative;\n  overflow: hidden;\n  padding: 12px 14px 12px;\n  border-radius: 14px;\n}\n\n.recruiter-metric-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(180deg, #2563eb 0%, #0f766e 100%);\n}\n\n.recruiter-breakdown-header {\n  padding-bottom: 18px;\n}\n\n.recruiter-breakdown-table thead {\n  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fd 100%);\n}\n\n.recruiter-breakdown-table th {\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n}\n\n.recruiter-breakdown-table td {\n  font-size: 13px;\n}\n\n.recruiter-breakdown-table tbody td {\n  vertical-align: middle;\n}\n\n.recruiter-breakdown-table tbody tr:hover td {\n  background: #f8fbff !important;\n}\n\n.recruiter-chip {\n  min-width: 44px;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);\n}\n\n.recruiter-detail-modal .modal-content {\n  overflow: hidden;\n  border: 1px solid rgba(191, 219, 254, 0.8);\n  border-radius: 24px;\n  background: radial-gradient(\n      circle at top right,\n      rgba(59, 130, 246, 0.12),\n      transparent 28%\n    ),\n    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);\n}\n\n.recruiter-detail-modal .modal-dialog {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.recruiter-detail-modal-header {\n  position: relative;\n  padding: 22px 24px 14px !important;\n  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 56%, #f0fdf4 100%);\n  border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;\n}\n\n.recruiter-detail-modal-header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-right: 64px;\n}\n\n.recruiter-detail-modal-header::after {\n  content: \"\";\n  position: absolute;\n  inset: auto 24px 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    rgba(37, 99, 235, 0.2),\n    rgba(16, 185, 129, 0.16)\n  );\n}\n\n.recruiter-detail-modal-heading {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.recruiter-detail-modal-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n}\n\n.recruiter-detail-modal-title {\n  font-size: 1.12rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.recruiter-detail-modal-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  font-size: 0;\n  color: #64748b;\n}\n\n.recruiter-detail-modal-meta > span {\n  font-size: 0.9rem;\n}\n\n.recruiter-detail-modal-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: #94a3b8;\n}\n\n.recruiter-detail-modal-count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(37, 99, 235, 0.08);\n  color: #1d4ed8;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.recruiter-detail-modal .btn-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 34px;\n  height: 34px;\n  margin: 0 !important;\n  border-radius: 999px;\n  background-color: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n  opacity: 1;\n  transition: transform 0.18s ease, box-shadow 0.18s ease,\n    background-color 0.18s ease;\n}\n\n.recruiter-detail-modal .btn-close:hover {\n  transform: rotate(90deg);\n  background-color: #ffffff;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);\n}\n\n.recruiter-detail-modal-export {\n  min-height: 42px;\n  padding: 10px 16px;\n  border: 1px solid rgba(37, 99, 235, 0.18);\n  border-radius: 12px;\n  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);\n  color: #fff;\n  font-size: 0.9rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.22);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.recruiter-detail-modal-export:hover {\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(29, 78, 216, 0.28);\n}\n\n.recruiter-detail-modal-export:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.recruiter-detail-modal-body {\n  padding: 18px 24px 24px !important;\n  max-height: 68vh;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.7) transparent;\n}\n\n.recruiter-detail-modal-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.recruiter-detail-modal-body::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.65);\n  background-clip: padding-box;\n}\n\n.recruiter-detail-modal-table-wrap {\n  overflow: hidden;\n  border: 1px solid #dbe7f3;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.recruiter-detail-modal-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);\n  white-space: nowrap;\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: #334155;\n  border-bottom: 1px solid #dbeafe;\n  border-right: 1px solid #e2e8f0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.recruiter-detail-modal-table tbody td {\n  border-color: #edf2f7;\n  transition: background-color 0.18s ease;\n}\n\n.recruiter-detail-modal-table tbody tr:nth-child(even) td {\n  background: rgba(248, 251, 255, 0.72);\n}\n\n.recruiter-detail-modal-table tbody tr:hover td {\n  background: #eff6ff;\n}\n\n.recruiter-detail-modal-empty {\n  padding: 42px 20px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);\n  text-align: center;\n  color: #64748b;\n  font-weight: 600;\n}\n\n@media (max-width: 991px) {\n  .recruiter-report-page {\n    padding: 16px 10px 28px;\n  }\n\n  .recruiter-report-filter-bar {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .recruiter-report-filter-summary {\n    grid-column: 1 / -1;\n  }\n\n  .recruiter-report-filter-actions {\n    grid-column: 1 / -1;\n    justify-content: flex-start;\n  }\n\n  .recruiter-report-hero {\n    min-height: auto;\n    padding: 20px 18px 18px;\n  }\n\n  .recruiter-report-title {\n    font-size: 28px;\n  }\n\n  .recruiter-report-hero-meta {\n    gap: 10px;\n  }\n\n  .recruiter-report-hero-pill {\n    min-width: calc(50% - 10px);\n  }\n\n  .recruiter-insight-strip {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .recruiter-detail-modal-body {\n    padding: 16px 16px 18px !important;\n  }\n\n  .recruiter-detail-modal-header-row {\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: 56px;\n  }\n\n  .recruiter-detail-modal-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 640px) {\n  .recruiter-report-page {\n    padding: 12px 4px 24px;\n  }\n\n  .recruiter-report-hero {\n    border-radius: 24px;\n    padding: 18px 14px 16px;\n  }\n\n  .recruiter-report-title {\n    font-size: 24px;\n  }\n\n  .recruiter-report-subtitle {\n    font-size: 13px;\n  }\n\n  .recruiter-report-hero-pill,\n  .recruiter-report-company-card {\n    width: 100%;\n    max-width: none;\n  }\n\n  .recruiter-report-filter-bar {\n    grid-template-columns: 1fr;\n    padding: 12px;\n  }\n\n  .recruiter-insight-strip,\n  .recruiter-scope-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .recruiter-panel-header,\n  .recruiter-breakdown-header,\n  .recruiter-snapshot-list,\n  .recruiter-metrics-list {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .recruiter-snapshot-card {\n    grid-template-columns: 1fr;\n  }\n\n  .recruiter-snapshot-side {\n    text-align: left;\n  }\n\n  .recruiter-rank-badge {\n    position: static;\n    width: fit-content;\n    margin-bottom: 8px;\n  }\n\n  .recruiter-detail-modal .modal-content {\n    border-radius: 18px;\n  }\n\n  .recruiter-detail-modal-header {\n    padding: 18px 16px 12px !important;\n  }\n\n  .recruiter-detail-modal-heading {\n    width: 100%;\n  }\n\n  .recruiter-detail-modal-title {\n    font-size: 1rem;\n  }\n\n  .recruiter-detail-modal-meta {\n    gap: 8px;\n    font-size: 0.82rem;\n  }\n\n  .recruiter-detail-modal .btn-close {\n    top: 14px;\n    right: 14px;\n  }\n}\n.recruiter-report-filter-summary-value {\n  min-height: 22px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.ModalStickyTabs {\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n}\n\n.activeBorder {\n  border-bottom: 3px solid #2563eb !important;\n}\n\n.inActiveBorder {\n  border: 1px solid #dbe7f3 !important;\n}\n.addCandidateBtn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  border: none;\n  background: transparent;\n\n  color: #1976d2;\n  font-size: 14px;\n  font-weight: 600;\n\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n\n  transition: all 0.2s ease;\n}\n\n.addCandidateBtn:hover {\n  background-color: rgba(25, 118, 210, 0.08);\n}\n\n.addCandidateHeaderBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  border: none;\n  background: transparent;\n  color: inherit;\n}\n.manager-pipeline-panel .p-card-body,\n.manager-pipeline-panel .p-card-content {\n  overflow: hidden !important;\n  padding: 12px !important;\n  height: 100%;\n  box-sizing: border-box;\n}\n.candidate-modal .modal-content {\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n}\n.candidate-modal .modal-body {\n  overflow: hidden;\n}\n.candidate-modal .modal-dialog {\n  display: flex;\n  align-items: center;\n  min-height: 100vh;\n  margin: 0 auto;\n}\n.candidate-modal .modal-content {\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n}\n#ExpandBtn {\n  position: absolute;\n  right: 40px;\n  top: 10px;\n  z-index: 1050;\n}\n\n/* .CreateJobOrderFooter {\n  position: absolute;\n  top:80px;\n  right: 0;\n  z-index: 1050;\n  background: red;\n  width: 100px;\n} */\n.cs-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.cs-tabs button {\n  padding: 8px 14px;\n  border: 1px solid #ddd;\n  background: #f8fafc;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cs-tabs button.active {\n  background: #103d63;\n  color: #fff;\n  border-color: #103d63;\n  border-radius: 40px;\n}\n/* Full-screen initial loader shown before the React app mounts. */\n#global-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #f7fbff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.loader-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.loader-logo {\n  width: 150px;\n  height: 150px;\n  max-width: 46vw;\n  max-height: 46vw;\n  object-fit: contain;\n  animation: loader-logo-float 1.35s ease-in-out infinite;\n}\n\n@keyframes loader-logo-float {\n  0%,\n  100% {\n    transform: translateY(0) rotateY(360deg) scale(0.96);\n    opacity: 0.78;\n  }\n  50% {\n    transform: translateY(-8px) rotateY(180deg) scale(1.04);\n    opacity: 1;\n  }\n}\n\n/* .calendar-container {\n  display: flex;\n  height: 500px;\n}\n\n.calendar-left {\n  width: 40%;\n  padding: 20px;\n  border-right: 1px solid #eee;\n}\n\n.calendar-right {\n  width: 60%;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.slots {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.slot-btn {\n  border: 1px solid #0d6efd;\n  background: white;\n  color: #0d6efd;\n  padding: 10px;\n  border-radius: 6px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.slot-btn:hover {\n  background: #e7f1ff;\n}\n\n.slot-btn.active {\n  background: #0d6efd;\n  color: white;\n} */\n\n.cs-root {\n  min-height: 100vh;\n  background: #f0f4f8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px 40px;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n}\n\n.cs-card {\n  width: 100%;\n  max-width: 640px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.cs-header {\n  background: linear-gradient(135deg, #103d63 0%, #1a5a90 100%);\n  padding: 24px 24px 20px;\n}\n\n.cs-kicker {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.cs-body {\n  padding: 20px 20px 24px;\n}\n\n@media (min-width: 480px) {\n  .cs-body {\n    padding: 24px 28px 28px;\n  }\n  .cs-header {\n    padding: 20px 28px 6px;\n  }\n}\n\n.cs-section {\n  margin-bottom: 16px;\n}\n\n.cs-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #3e4b5f;\n  margin-bottom: 6px;\n}\n\n.cs-about-text {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.65;\n  margin: 0 0 6px;\n}\n\n.cs-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n  border-bottom: 2px solid #f1f5f9;\n  padding-bottom: 0;\n}\n\n.cs-tabs button {\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 0;\n  transition: color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n\n.cs-tabs button.active {\n  border-bottom-color: #103d63;\n}\n\n.cs-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n@media (min-width: 480px) {\n  .cs-info-grid {\n    /* grid-template-columns: repeat(4, 1fr); gap: 12px; */\n  }\n}\n\n.cs-info-box {\n  background: #f8fafc;\n  border: 1px solid #e9eef4;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.cs-info-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #94a3b8;\n  margin-bottom: 3px;\n}\n\n.cs-info-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  word-break: break-word;\n}\n\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cs-skill-chip {\n  background: #e8f4fd;\n  color: #0e5fa3;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.cs-divider {\n  border: none;\n  border-top: 1px solid #f1f5f9;\n  margin: 16px 0;\n}\n\n.cs-cta-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.cs-cta-sub {\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.cs-btn-interested,\n.cs-btn-decline {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1.5px solid;\n  cursor: pointer;\n  transition: transform 0.1s, box-shadow 0.1s;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #fff;\n}\n\n.cs-btn-interested {\n  border-color: #22c55e;\n}\n.cs-btn-interested:hover {\n  background: #f0fdf4;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);\n}\n\n.cs-btn-decline {\n  border-color: #f87171;\n}\n.cs-btn-decline:hover {\n  background: #fff5f5;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(248, 113, 113, 0.15);\n}\n\n.cs-btn-icon {\n  width: 38px;\n  height: 38px;\n  min-width: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n.cs-btn-icon.green {\n  background: #22c55e;\n}\n.cs-btn-icon.red {\n  background: #f87171;\n}\n\n.cs-btn-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n.cs-btn-sublabel {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.cs-btn-arrow {\n  margin-left: auto;\n  font-size: 22px;\n  color: #cbd5e1;\n}\n\n.cs-declined-box,\n.cs-confirmed-box {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 18px;\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.cs-state-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #103d63;\n  margin-bottom: 6px;\n}\n\n.cs-state-sub {\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.cs-privacy {\n  font-size: 11px;\n  color: #cbd5e1;\n  text-align: center;\n  margin-top: 12px;\n}\n\n.cs-footer {\n  margin-top: 20px;\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n/* ── Schedule Modal ── */\n.sched-modal .modal-dialog {\n  margin: 0 auto;\n  max-width: 860px;\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  .sched-modal .modal-dialog {\n    margin: 0;\n    max-width: 100%;\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n  .sched-modal .modal-content {\n    border-radius: 20px 20px 0 0 !important;\n    max-height: 92vh;\n    overflow-y: auto;\n  }\n}\n\n.sched-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.sched-avatar {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 50%;\n  background: #e8f4fd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0069ff;\n}\n\n.sched-company {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 2px;\n}\n.sched-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n@media (min-width: 480px) {\n  .sched-title {\n    max-width: 340px;\n  }\n}\n\n.sched-close {\n  margin-left: auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 22px;\n  color: #9ca3af;\n  line-height: 1;\n  padding: 4px 6px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sched-subheader {\n  padding: 14px 20px 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.sched-body {\n  display: flex;\n  flex-direction: column;\n  padding: 14px 20px 20px;\n  gap: 20px;\n}\n\n@media (min-width: 640px) {\n  .sched-body {\n    flex-direction: row;\n    gap: 24px;\n  }\n}\n\n.sched-calendar {\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .sched-calendar {\n    width: 280px;\n    min-width: 280px;\n  }\n}\n\n.sched-divider-v {\n  display: none;\n}\n@media (min-width: 640px) {\n  .sched-divider-v {\n    display: block;\n    width: 1px;\n    background: #f1f5f9;\n    flex-shrink: 0;\n  }\n}\n\n.sched-divider-h {\n  display: block;\n  height: 1px;\n  background: #f1f5f9;\n  width: 100%;\n}\n@media (min-width: 640px) {\n  .sched-divider-h {\n    display: none;\n  }\n}\n\n.sched-slots {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.sched-slots-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 10px;\n}\n\n.sched-slots-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  overflow-y: auto;\n  max-height: 260px;\n  padding-right: 2px;\n}\n\n@media (min-width: 640px) {\n  .sched-slots-grid {\n    grid-template-columns: 1fr;\n    max-height: 300px;\n  }\n}\n\n.sched-slot-btn {\n  padding: 11px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.1s, background 0.1s;\n  white-space: nowrap;\n}\n\n.sched-footer {\n  padding: 14px 20px;\n  border-top: 1px solid #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sched-footer-btns {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.sched-footer-btns button {\n  flex: 1;\n  max-width: 200px;\n  padding: 11px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  min-height: 44px;\n}\n\n.sched-btn-cancel {\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n}\n\n.sched-btn-confirm {\n  border: none;\n  background: #0069ff;\n  color: #fff;\n}\n.sched-btn-confirm:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n.sched-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #b91c1c;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Cal nav */\n.cal-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.cal-nav-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  cursor: pointer;\n  font-size: 18px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  min-width: 44px;\n}\n\n.cal-month-label {\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n}\n\n.cal-days-header {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 6px;\n}\n\n.cal-day-name {\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.04em;\n  padding: 3px 0;\n}\n\n.cal-days-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px 0;\n}\n\n.cal-day-btn {\n  width: 36px;\n  height: 36px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 13px;\n  cursor: pointer;\n  min-height: 36px;\n  min-width: 36px;\n}\n.offer-letter-modal .modal-dialog {\n  max-width: 1200px; /* Increase width */\n  margin-top: 30px; /* Distance from top */\n}\n\n.offer-letter-modal .modal-content {\n  min-height: 85vh; /* Taller modal */\n}\n\n.offer-letter-modal .modal-body {\n  max-height: calc(85vh - 140px);\n  overflow-y: auto;\n}\n.sun-editor-editable[contenteditable=\"true\"] .se-component {\n  outline: \"\" !important;\n}\n#OfferLetterModal .btn-close {\n  color: white !important;\n}\n.offer-letter-modal .modal-header .btn-close {\n  filter: invert(1) brightness(2);\n}\n.sun-editor-editable p {\n  border: none !important;\n}\n.table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.nav-tabs .nav-link.active {\n  font-weight: 600;\n  color: #12395c !important;\n}\n\n.card {\n  border-radius: 12px;\n}\n\n.modal-content {\n  border-radius: 12px;\n}\n/* Remove SunEditor's default dashed border on inserted images */\n.sun-editor-editable img,\n.sun-editor img,\n#OfferLetterModal .sun-editor-editable img,\n#OfferLetterModal .sun-editor img {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n.jor-page {\n  --bg: #f6f7f9;\n  --surface: #ffffff;\n  --line: #e4e7ec;\n  --line-soft: #eef0f3;\n  --text: #13202e;\n  --muted: #5f6b7a;\n  --faint: #98a2b1;\n  --navy: #000053;\n  --orange: #ee751d;\n  --orange-hover: #d4661a;\n  --orange-soft: #fdeedd;\n  --accent: #1f4fd8;\n  --accent-soft: #eef3fe;\n  --green: #0f9d58;\n  --green-soft: #e9f7ef;\n  --amber: #b97509;\n  --amber-soft: #fdf4e3;\n  --red: #d23b3b;\n  --red-soft: #fdeeee;\n  --radius: 10px;\n  --font-display: \"Manrope\", sans-serif;\n  --font-body: \"Inter\", sans-serif;\n  font-family: var(--font-body);\n  background: var(--bg);\n  color: var(--text);\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n}\n.jor-page * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.jor-page button {\n  font: inherit;\n  cursor: pointer;\n}\n\n.jor-page .content {\n  padding: 22px 24px 32px;\n  width: 100%;\n  margin: 0 auto;\n}\n.jor-page .page-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.jor-page .page-head h1 {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 22px;\n  letter-spacing: -0.01em;\n  color: var(--navy);\n}\n.jor-page .page-head .sub {\n  color: var(--muted);\n  font-size: 13.5px;\n  margin-top: 3px;\n}\n\n.jor-page .selbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 14px 16px;\n  margin-bottom: 18px;\n}\n.jor-page .selbar .lbl {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--faint);\n}\n.jor-page .selbar select {\n  height: 40px;\n  min-width: 280px;\n  padding: 0 12px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--navy);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .selbar select:focus {\n  outline: none;\n  border-color: var(--orange);\n  box-shadow: 0 0 0 3px var(--orange-soft);\n}\n.jor-page .selbar .meta {\n  font-size: 13px;\n  color: var(--muted);\n}\n.jor-page .selbar .meta b {\n  color: var(--navy);\n}\n\n.jor-page .stat-groups {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 18px;\n}\n.jor-page .stat-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n.jor-page .stat-card .sc-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--line-soft);\n}\n.jor-page .stat-card .sc-head .ico {\n  width: 40px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n}\n.jor-page .stat-card .sc-head .ico.blue {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.jor-page .stat-card .sc-head .ico.orange {\n  background: var(--orange-soft);\n  color: var(--orange);\n}\n.jor-page .stat-card .sc-head .ico.green-ico {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .stat-card .sc-head h3 {\n  font-family: var(--font-display);\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--navy);\n}\n.jor-page .stat-card .sc-body {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n.jor-page .stat-card .sc-item {\n  padding: 14px 16px;\n  border-right: 1px solid var(--line-soft);\n}\n.jor-page .stat-card .sc-item:last-child {\n  border-right: none;\n}\n.jor-page .stat-card .sc-item .v {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 22px;\n  letter-spacing: -0.02em;\n}\n.jor-page .stat-card .sc-item .v.green {\n  color: var(--green);\n}\n.jor-page .stat-card .sc-item .v.amber {\n  color: var(--amber);\n}\n.jor-page .stat-card .sc-item .v.gray {\n  color: var(--faint);\n}\n.jor-page .stat-card .sc-item .l {\n  font-size: 12px;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.jor-page .panel {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n}\n.jor-page .toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--line-soft);\n}\n.jor-page .toolbar .lbl {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--faint);\n}\n.jor-page .toolbar select {\n  height: 36px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13.5px;\n  color: var(--text);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .toolbar input[type=\"date\"] {\n  height: 36px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13px;\n  color: var(--text);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .toolbar select:focus,\n.jor-page .toolbar input[type=\"date\"]:focus {\n  outline: none;\n  border-color: var(--orange);\n}\n.jor-page .toolbar .reset {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--muted);\n  font-weight: 500;\n  font-size: 13px;\n}\n.jor-page .toolbar .reset:hover {\n  background: var(--bg);\n  color: var(--text);\n}\n.jor-page .toolbar .right {\n  margin-left: auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.jor-page .t-search {\n  position: relative;\n}\n.jor-page .t-search svg {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--faint);\n}\n.jor-page .t-search input {\n  height: 36px;\n  width: 220px;\n  padding: 0 10px 0 32px;\n  font: inherit;\n  font-size: 13.5px;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--text);\n}\n.jor-page .t-search input:focus {\n  outline: none;\n  border-color: var(--orange);\n  box-shadow: 0 0 0 3px var(--orange-soft);\n}\n.jor-page .btn-export {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--muted);\n  font-weight: 500;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.jor-page .btn-export:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.jor-page table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n.jor-page thead th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--faint);\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--line-soft);\n  white-space: nowrap;\n  user-select: none;\n  background: #fcfcfd;\n  vertical-align: bottom;\n}\n.jor-page thead th.sortable {\n  cursor: pointer;\n}\n.jor-page thead th.sortable:hover {\n  color: var(--muted);\n}\n.jor-page thead th .arrow {\n  font-size: 10px;\n  margin-left: 3px;\n}\n.jor-page thead tr.grouprow th {\n  font-size: 10px;\n  text-align: left;\n  color: var(--navy);\n  border-bottom: none;\n  padding-bottom: 2px;\n  letter-spacing: 0.05em;\n}\n.jor-page thead tr.grouprow th.gsep {\n  border-left: 1px solid var(--line-soft);\n}\n.jor-page tbody td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--line-soft);\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.jor-page tbody tr:last-child td {\n  border-bottom: none;\n}\n.jor-page tbody tr:hover td {\n  background: #fafbfc;\n}\n.jor-page td.gsep,\n.jor-page th.gsep {\n  border-left: 1px solid var(--line-soft);\n}\n\n.jor-page .person {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.jor-page .person .avatar {\n  width: 30px;\n  height: 30px;\n  font-size: 11.5px;\n}\n.jor-page .person .p-name {\n  font-weight: 600;\n}\n.jor-page .person .p-sub {\n  font-size: 12px;\n  color: var(--faint);\n}\n.jor-page .jobtag {\n  font-size: 12px;\n  color: var(--faint);\n}\n.jor-page .avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--accent-soft);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  flex: none;\n}\n\n.jor-page .badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 9px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.jor-page .badge::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.jor-page .badge.green {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .badge.amber {\n  background: var(--amber-soft);\n  color: var(--amber);\n}\n.jor-page .badge.blue {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.jor-page .badge.gray {\n  background: var(--line-soft);\n  color: var(--muted);\n}\n.jor-page .badge.red {\n  background: var(--red-soft);\n  color: var(--red);\n}\n.jor-page .badge.navy {\n  background: #e6e6f2;\n  color: var(--navy);\n}\n\n.jor-page .tl {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 210px;\n}\n.jor-page .tl .step {\n  display: grid;\n  grid-template-columns: 8px 78px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n}\n.jor-page .tl .step .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex: none;\n  background: var(--line);\n  position: relative;\n}\n.jor-page .tl .step.done .dot {\n  background: var(--green);\n}\n.jor-page .tl .step.sched .dot {\n  background: var(--amber);\n}\n.jor-page .tl .step.sent .dot {\n  background: var(--accent);\n}\n.jor-page .tl .step .lab {\n  color: var(--muted);\n  white-space: nowrap;\n}\n.jor-page .tl .step .time {\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  color: var(--text);\n  white-space: nowrap;\n}\n.jor-page .tl .step.pending .lab,\n.jor-page .tl .step.pending .time {\n  color: var(--faint);\n  font-weight: 400;\n}\n.jor-page .tl .step .time.muted {\n  color: var(--faint);\n  font-weight: 400;\n}\n\n.jor-page .res-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 7px;\n  padding-top: 7px;\n  border-top: 1px dashed var(--line);\n}\n.jor-page .score {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--navy);\n  font-variant-numeric: tabular-nums;\n}\n.jor-page .score .den {\n  color: var(--faint);\n  font-weight: 600;\n  font-size: 12px;\n}\n.jor-page .res-chip {\n  font-size: 11.5px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n.jor-page .res-chip.pass {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .res-chip.fail {\n  background: var(--red-soft);\n  color: var(--red);\n}\n.jor-page .res-chip.pend {\n  background: var(--amber-soft);\n  color: var(--amber);\n}\n.jor-page .scorebar {\n  flex: 1;\n  height: 5px;\n  border-radius: 3px;\n  background: var(--line-soft);\n  overflow: hidden;\n  min-width: 40px;\n}\n.jor-page .scorebar i {\n  display: block;\n  height: 100%;\n  border-radius: 3px;\n}\n.jor-page .scorebar i.pass {\n  background: var(--green);\n}\n.jor-page .scorebar i.fail {\n  background: var(--red);\n}\n\n.jor-page .locked {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  color: var(--faint);\n  font-size: 12.5px;\n  line-height: 1.45;\n  padding: 2px 0;\n}\n.jor-page .locked svg {\n  flex: none;\n  margin-top: 1px;\n  color: var(--faint);\n}\n.jor-page .locked .lk-title {\n  font-weight: 600;\n  color: var(--muted);\n}\n.jor-page .badge.lock {\n  background: var(--line-soft);\n  color: var(--faint);\n}\n.jor-page .badge.lock::before {\n  display: none;\n}\n\n.jor-page .table-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid var(--line-soft);\n  font-size: 13px;\n  color: var(--muted);\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.jor-page .rows-per {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.jor-page .rows-per select {\n  height: 30px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  padding: 0 8px;\n  font: inherit;\n  font-size: 13px;\n}\n.jor-page .pager {\n  display: flex;\n  gap: 4px;\n}\n.jor-page .pager button {\n  min-width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--muted);\n  font-size: 13px;\n}\n.jor-page .pager button:hover:not(:disabled) {\n  background: var(--bg);\n}\n.jor-page .pager button.cur {\n  background: var(--navy);\n  color: #fff;\n  border-color: var(--navy);\n  font-weight: 600;\n}\n.jor-page .pager button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.jor-page .empty {\n  padding: 36px 18px;\n  text-align: center;\n  color: var(--faint);\n  font-size: 13.5px;\n}\n\n.jor-page .toast {\n  position: fixed;\n  bottom: 22px;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: var(--navy);\n  color: #fff;\n  font-size: 13.5px;\n  font-weight: 500;\n  padding: 10px 18px;\n  border-radius: 999px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s, transform 0.2s;\n  z-index: 60;\n}\n.jor-page .toast.show {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n\n@media (max-width: 1100px) {\n  .jor-page .stat-groups {\n    grid-template-columns: 1fr;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .jor-page * {\n    transition: none !important;\n  }\n}\n\n.test-result-modal .modal-content {\n  border: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #f6f8fb;\n}\n\n.talent-scan-result-dialog.p-dialog {\n  overflow: hidden;\n  border: 0;\n  border-radius: 16px;\n  background: #f6f8fb;\n}\n\n.talent-scan-result-dialog .p-dialog-header {\n  padding: 14px 18px;\n  border: 0;\n  color: #fff;\n  background: #1976ad;\n}\n\n.talent-scan-result-dialog .p-dialog-title {\n  min-width: 0;\n}\n\n.talent-scan-result-dialog .p-dialog-header-icons {\n  flex: 0 0 auto;\n}\n\n.talent-scan-result-dialog .p-dialog-header-close {\n  color: #fff;\n}\n\n.talent-scan-result-dialog .p-dialog-content {\n  max-height: 75vh;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.test-result-modal-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  align-items: center;\n  padding: 14px 18px;\n  border: 0;\n  color: #fff;\n  background: #1976ad;\n}\n\n.test-result-modal-header .modal-title {\n  min-width: 0;\n}\n\n.test-result-modal-header .btn-close {\n  flex: 0 0 auto;\n  margin: 0;\n  opacity: 0.85;\n  filter: brightness(0) invert(1);\n}\n\n.test-result-modal-header .btn-close:hover {\n  opacity: 1;\n}\n\n.test-result-modal-heading {\n  min-width: 0;\n}\n\n.test-result-modal-title {\n  overflow: hidden;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-result-modal-candidate-contact {\n  overflow: hidden;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-result-modal-body {\n  max-height: 75vh;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.test-result-modal-footer {\n  justify-content: center;\n  display: flex;\n  gap: 10px;\n  padding: 12px 20px;\n  border-top: 1px solid #d8e1eb;\n  background: #fff;\n}\n\n.ts-result-list,\n.ts-result-content,\n.ts-result-section-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ts-result-list {\n  gap: 16px;\n}\n\n.ts-result-shell {\n  border: 1px solid #d8e1eb;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #f6f8fb;\n}\n\n.ts-result-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #0c447c;\n}\n\n.ts-result-header-main {\n  min-width: 0;\n}\n\n.ts-result-title {\n  color: #e6f1fb;\n  font-size: 16px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.ts-result-subtitle {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-top: 5px;\n  color: #b7daf9;\n  font-size: 12px;\n}\n\n.ts-result-header-badges {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.ts-result-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.ts-result-badge.success,\n.ts-result-score-pill.good {\n  color: #27500a;\n  background: #eaf3de;\n}\n\n.ts-result-badge.danger,\n.ts-result-score-pill.low {\n  color: #791f1f;\n  background: #fcebeb;\n}\n\n.ts-result-badge.warning {\n  color: #633806;\n  background: #faeeda;\n}\n\n.ts-result-badge.info,\n.ts-result-score-pill.mid {\n  color: #0c447c;\n  background: #e6f1fb;\n}\n\n.ts-result-badge.neutral {\n  color: #444441;\n  background: #f1efe8;\n}\n\n.ts-result-content {\n  gap: 14px;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.ts-result-section-label {\n  margin-bottom: 8px;\n  /* color: #7b8794; */\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.ts-result-card {\n  padding: 14px 16px;\n  border: 1px solid #d8e1eb;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.ts-result-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0;\n}\n\n.ts-result-card.ts-result-grid-2 {\n  overflow: hidden;\n  padding: 0;\n  border-color: #c7d2df;\n}\n\n.ts-result-info-table {\n  overflow: hidden;\n  padding: 0;\n  border-color: #c7d2df;\n}\n\n.ts-result-info-table-heading {\n  padding: 8px 12px;\n  border-bottom: 1px solid #c7d2df;\n  color: #0c447c;\n  background: #edf5fc;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.ts-result-info-table .ts-result-grid-2 + .ts-result-info-table-heading {\n  border-top: 1px solid #c7d2df;\n}\n\n.ts-result-kv-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 30px;\n  padding: 8px 12px;\n  border-right: 1px solid #d8e1eb;\n  border-bottom: 1px solid #d8e1eb;\n}\n\n.ts-result-kv-row:nth-child(even) {\n  border-right: 0;\n}\n\n.ts-result-kv-row:nth-last-child(-n + 2) {\n  border-bottom: 0;\n}\n\n.ts-result-kv-key {\n  color: #667085;\n  font-size: 12px;\n}\n\n.ts-result-kv-val {\n  max-width: 58%;\n  color: #172033;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n\n.ts-result-kv-val.timeline {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 4px 9px;\n  border: 1px solid #b9d7ef;\n  border-radius: 999px;\n  color: #0c447c;\n  background: #eaf4fc;\n  box-shadow: 0 2px 5px rgba(24, 95, 165, 0.12);\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.ts-result-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ts-result-metrics.ts-result-metrics-four {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.ts-result-metric {\n  position: relative;\n  overflow: hidden;\n  min-height: 72px;\n  padding: 14px 16px 12px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n  box-shadow: 0 2px 7px rgba(23, 32, 51, 0.06);\n}\n\n.ts-result-metric::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 4px;\n  background: currentColor;\n  content: \"\";\n  opacity: 0.75;\n}\n\n.ts-result-metric.info,\n.ts-result-metric.mid {\n  color: #0c447c;\n  border-color: #b9d7ef;\n  background: #f0f7fd;\n}\n\n.ts-result-metric.good {\n  color: #27500a;\n  border-color: #b8d698;\n  background: #f2f8e9;\n}\n\n.ts-result-metric.low {\n  color: #991b1b;\n  border-color: #f0b8b8;\n  background: #fff3f3;\n}\n\n.ts-result-metric.advanced {\n  color: #26215c;\n  background: #eeedfe;\n}\n\n.ts-result-metric.neutral {\n  color: #172033;\n  background: #fff;\n  border: 1px solid #e5ebf1;\n}\n\n.ts-result-metric-val {\n  color: currentColor;\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.ts-result-metric-label {\n  margin-top: 5px;\n  color: #475467;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ts-result-dict-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 160px) 1fr minmax(82px, auto) minmax(\n      66px,\n      auto\n    );\n  align-items: center;\n  gap: 10px;\n  min-height: 34px;\n  padding: 7px 0;\n  border-bottom: 1px solid #e5ebf1;\n}\n\n.ts-result-dict-row:last-child {\n  border-bottom: 0;\n}\n\n.ts-result-dict-name {\n  color: #172033;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ts-result-bar,\n.ts-result-level-bar {\n  overflow: hidden;\n  border: 1px solid #d8e1eb;\n  border-radius: 999px;\n  background: #eef2f6;\n}\n\n.ts-result-bar {\n  height: 6px;\n}\n\n.ts-result-bar-fill {\n  height: 100%;\n  border-radius: inherit;\n}\n\n.ts-result-bar-fill.good {\n  background: #639922;\n}\n\n.ts-result-bar-fill.mid {\n  background: #185fa5;\n}\n\n.ts-result-bar-fill.low {\n  background: #e24b4a;\n}\n\n.ts-result-score-pill {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ts-result-legend {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n  /* color: #7b8794; */\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ts-result-legend-item,\n.ts-result-level-head {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ts-result-legend-item {\n  color: #667085;\n  font-weight: 500;\n}\n\n.ts-result-legend-item span,\n.ts-result-level-head span {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  flex: 0 0 auto;\n}\n\n.ts-result-legend-item.beginner span,\n.ts-result-level.beginner .ts-result-level-head span,\n.ts-result-level.beginner .ts-result-level-bar div {\n  background: #639922;\n}\n\n.ts-result-legend-item.intermediate span,\n.ts-result-level.intermediate .ts-result-level-head span,\n.ts-result-level.intermediate .ts-result-level-bar div {\n  background: #185fa5;\n}\n\n.ts-result-legend-item.advanced span,\n.ts-result-level.advanced .ts-result-level-head span,\n.ts-result-level.advanced .ts-result-level-bar div {\n  background: #534ab7;\n}\n\n.ts-result-section-list {\n  gap: 8px;\n}\n\n.ts-result-section-card {\n  display: grid;\n  grid-template-columns:\n    minmax(260px, 300px)\n    minmax(180px, 240px)\n    minmax(360px, 1fr);\n  align-items: stretch;\n  overflow: hidden;\n  border: 1px solid #cbd7e4;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(23, 32, 51, 0.05);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ts-result-section-card:hover {\n  border-color: #aebdcd;\n  box-shadow: 0 4px 12px rgba(23, 32, 51, 0.08);\n}\n\n.ts-result-section-card.cheated {\n  border: 2px solid #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.ts-result-section-card.cheated .ts-result-section-name-col,\n.ts-result-section-card.cheated .ts-result-section-score-col,\n.ts-result-section-card.cheated .ts-result-level {\n  background: #fff7f7;\n}\n\n.ts-result-section-top {\n  display: contents;\n}\n\n.ts-result-section-name-col {\n  padding: 12px 14px;\n  border-right: 1px solid #d8e1eb;\n  background: #fbfcfe;\n}\n\n.ts-result-section-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: #101828;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.ts-result-cheated-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  color: #fff;\n  background: #dc2626;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.ts-result-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.ts-result-chip-row > span:not(.ts-result-badge) {\n  padding: 3px 8px;\n  border: 1px solid #d6e0eb;\n  border-radius: 999px;\n  color: #344054;\n  background: #f8fafc;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.ts-result-chip-row.status {\n  margin-top: 7px;\n}\n\n\n.ts-result-level-head {\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.ts-result-section-score-col {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  border-right: 1px solid #d8e1eb;\n  height: 100%;\n  background: #f8fbff;\n}\n\n.ts-result-big-score {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-items: flex-start;\n}\n\n.ts-result-big-score span {\n  color: #475467;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.ts-result-big-score strong {\n  color: #12639a;\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  margin: 1px 0;\n}\n\n.ts-result-big-score small {\n  color: #344054;\n  font-size: 11px;\n  line-height: 1.3;\n  margin: 0;\n}\n.ts-result-section-bar-wrap {\n  flex: 1 1 auto;\n  min-width: 110px;\n}\n\n.ts-result-section-bar-label {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n  /* color: #7b8794; */\n  font-size: 11px;\n}\n\n.ts-result-section-bar-label .good {\n  color: #27500a;\n}\n\n.ts-result-section-bar-label .mid {\n  color: #0c447c;\n}\n\n.ts-result-section-bar-label .low {\n  color: #791f1f;\n}\n\n.ts-result-levels {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  align-items: stretch;\n}\n\n.ts-result-level {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding: 12px 14px;\n  border-right: 1px solid #d8e1eb;\n  border-top: 3px solid transparent;\n}\n\n.ts-result-level:last-child {\n  border-right: 0;\n}\n\n.ts-result-level-head {\n  margin-bottom: 7px;\n  color: #344054;\n  font-size: 9px;\n}\n\n.ts-result-level-score-label {\n  margin-bottom: 3px;\n  color: #667085;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.ts-result-level-score {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.ts-result-level-score strong {\n  font-size: 17px;\n  line-height: 1;\n}\n\n.ts-result-level.beginner {\n  border-top-color: #639922;\n  background: #fbfdf8;\n}\n\n.ts-result-level.intermediate {\n  border-top-color: #185fa5;\n  background: #f8fbff;\n}\n\n.ts-result-level.advanced {\n  border-top-color: #534ab7;\n  background: #faf9ff;\n}\n\n.ts-result-level > small {\n  color: #475467;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ts-result-level.beginner .ts-result-level-score strong {\n  color: #639922;\n}\n\n.ts-result-level.intermediate .ts-result-level-score strong {\n  color: #185fa5;\n}\n\n.ts-result-level.advanced .ts-result-level-score strong {\n  color: #534ab7;\n}\n\n.ts-result-level-score span {\n  /* color: #7b8794; */\n  font-size: 11px;\n}\n\n.ts-result-level-bar {\n  height: 4px;\n}\n\n.ts-result-level-bar div {\n  height: 100%;\n}\n\n.ts-result-level-empty {\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n.ts-result-section-extra {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  border-top: 1px solid #d8e1eb;\n}\n\n.ts-result-section-extra div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  border-right: 1px solid #d8e1eb;\n}\n\n.ts-result-section-extra div:last-child {\n  border-right: 0;\n}\n\n.ts-result-section-extra span {\n  color: #7b8794;\n  font-size: 10px;\n}\n\n.ts-result-section-extra strong {\n  color: #172033;\n  font-size: 11px;\n}\n\n.ts-result-cheated-note {\n  grid-column: 1 / -1;\n  padding: 9px 14px;\n  border-top: 1px solid #dc2626;\n  color: #991b1b;\n  background: #fee2e2;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ts-result-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.ts-result-detail-btn,\n.ts-result-close-btn {\n  min-height: 34px;\n  padding: 7px 20px;\n  border: 1px solid #185fa5 !important;\n  border-radius: 8px !important;\n  color: #0c447c !important;\n  background: #e6f1fb !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ts-result-close-btn {\n  border-color: #cbd5e1 !important;\n  color: #172033 !important;\n  background: #f8fafc !important;\n}\n\n.ts-result-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 260px;\n  padding: 48px 24px;\n  color: #667085;\n  text-align: center;\n}\n\n.ts-result-empty-icon {\n  width: 56px;\n  height: 56px;\n  border: 2px solid #d8e1eb;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0c447c;\n  background: #e6f1fb;\n  font-size: 24px;\n  font-weight: 800;\n  font-family: Georgia, serif;\n}\n\n.ts-result-empty-title {\n  color: #172033;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.ts-result-empty-copy {\n  max-width: 300px;\n  font-size: 14px;\n}\n\n@media (max-width: 991.98px) {\n.ts-result-grid-2,\n.ts-result-levels,\n.ts-result-section-extra {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.ts-result-metrics {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n  .ts-result-kv-row:nth-last-child(-n + 2) {\n    border-bottom: 1px solid #e5ebf1;\n  }\n\n  .ts-result-kv-row:last-child {\n    border-bottom: 0;\n  }\n\n  .ts-result-section-top {\n    display: contents;\n  }\n\n  .ts-result-section-card {\n    grid-template-columns: 1fr;\n  }\n\n  .ts-result-section-name-col,\n  .ts-result-section-score-col,\n  .ts-result-level,\n  .ts-result-section-extra div {\n    border-right: 0;\n  }\n\n  .ts-result-section-name-col,\n  .ts-result-section-score-col,\n  .ts-result-level {\n    border-bottom: 1px solid #d8e1eb;\n  }\n\n  .ts-result-dict-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .test-result-modal-body,\n  .ts-result-content {\n    padding: 12px;\n  }\n\n  .ts-result-header,\n  .ts-result-section-score-col {\n    flex-direction: column;\n  }\n\n  .ts-result-header-badges {\n    justify-content: flex-start;\n  }\n\n  .ts-result-kv-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .ts-result-kv-val {\n    max-width: 100%;\n    text-align: left;\n  }\n}\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box .search-icon {\n  position: absolute;\n  left: 12px;\n  color: #667085;\n  font-size: 14px;\n}\n\n.search-box input[type=\"search\"] {\n  width: 300px;\n  padding: 10px 14px 10px 36px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  transition: all 0.3s ease;\n}\n\n.search-box input[type=\"search\"]:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n  outline: none;\n}\n.right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.right input[type=\"search\"] {\n  width: 280px;\n  padding: 10px 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.3s ease;\n  background: #fff;\n}\n\n.right input[type=\"search\"]:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n}\n\n.right input[type=\"search\"]::placeholder {\n  color: #98a2b3;\n}\n.count-bubble {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--navy, #000053);\n  background: #eef1f6;\n  border: 1px solid var(--line, #e4e7ec);\n  border-radius: 999px;\n  padding: 4px 12px;\n  white-space: nowrap;\n}\n.count-bubble b {\n  color: var(--orange, #ee751d);\n  font-weight: 700;\n}\n.cutoff-bubble {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--orange, #ee751d);\n  background: #fff4e6;\n  border: 1px solid #ffd9b3;\n  border-radius: 999px;\n  padding: 2px 10px;\n  margin-left: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.cutoff-bubble b {\n  color: var(--orange, #ee751d);\n}\n  .job-title-filter-dropdown.p-dropdown {\n    background: #fff !important;\n    border: 1px solid #ced4da !important;\n    box-shadow: none !important;\n    min-height: 31px;\n  }\n  .job-title-filter-dropdown .p-dropdown-label {\n    background: transparent !important;\n    color: #212529 !important;\n    font-weight: 400 !important;\n    padding: 4px 8px !important;\n    text-shadow: none !important;\n  }\n  .job-title-filter-dropdown .p-dropdown-label.p-placeholder {\n    color: #6c757d !important;\n  }\n  .job-title-filter-dropdown .p-dropdown-clear-icon {\n    color: #6c757d !important;\n    right: 2rem;\n  }\n  .job-title-filter-dropdown .p-dropdown-trigger {\n    color: #6c757d !important;\n  }\n  .job-title-filter-dropdown:not(.p-disabled):hover {\n    border-color: #adb5bd !important;\n  }\n  .job-title-filter-dropdown:not(.p-disabled).p-focus {\n    border-color: #86b7fe !important;\n    box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25) !important;\n  }\n\n  #TelephonicTest_Table .rdt_TableHead {\n    z-index: 1;\n  }\n.swal-on-top {\n  z-index: 99999 !important;\n}\n\n.swal2-popup .ats-swal-title {\n  font-size: 18px !important;\n  line-height: 1.3 !important;\n}\n\n.swal2-popup .ats-swal-text {\n  font-size: 16px !important;\n  line-height: 1.45 !important;\n}\n\n.import-step-card {\n  border: 1px solid #dbe4f0;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 14px 34px rgba(15, 76, 129, 0.08);\n  padding: 18px;\n}\n\n.import-step-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  padding-bottom: 14px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.import-step-header h6 {\n  margin: 0 0 4px;\n  color: #0f4c81;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.import-step-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.import-duplicate-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.import-option-card {\n  display: grid;\n  grid-template-columns: 22px minmax(0, 1fr);\n  gap: 10px;\n  align-items: flex-start;\n  min-height: 104px;\n  padding: 14px;\n  border: 1px solid #dbe4f0;\n  border-radius: 9px;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.import-option-card.active {\n  border-color: #0f6fa8;\n  background: #eff6ff;\n  box-shadow: 0 10px 22px rgba(15, 111, 168, 0.12);\n}\n\n.import-option-card strong {\n  display: block;\n  color: #0f172a;\n  font-size: 13.5px;\n  margin-bottom: 4px;\n}\n\n.import-option-card small {\n  display: block;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.import-step-field {\n  display: grid;\n  gap: 7px;\n  max-width: 520px;\n}\n\n.import-step-field label {\n  margin: 0;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.import-step-field small {\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.import-step-field .form-select,\n.import-step-field .p-treeselect,\n.import-step-field .p-inputtext {\n  min-height: 38px;\n  border-radius: 7px;\n  font-size: 13px;\n}\n\n.import-tag-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.import-step-field-full {\n  max-width: none;\n  grid-column: 1 / -1;\n}\n\n.import-stage-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.import-stage-pills label {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 32px;\n  padding: 6px 10px;\n  border: 1px solid #dbe4f0;\n  border-radius: 999px;\n  background: #f8fafc;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.import-stage-pills label.active {\n  border-color: #0f6fa8;\n  background: #eff6ff;\n  color: #0f4c81;\n}\n\n.import-step-field .p-inputgroup {\n  max-width: 520px;\n}\n\n.edit-profile-dialog.p-dialog {\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22);\n}\n\n.edit-profile-dialog .p-dialog-header {\n  min-height: 54px;\n  padding: 15px 20px !important;\n  background: linear-gradient(100deg, #0f4c81 0%, #0f766e 100%) !important;\n  color: #ffffff !important;\n  border: 0 !important;\n}\n\n.edit-profile-dialog .p-dialog-title {\n  color: #ffffff !important;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.edit-profile-dialog .p-dialog-header-icon,\n.edit-profile-dialog .p-dialog-header-close {\n  color: #ffffff !important;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n}\n\n.edit-profile-dialog .p-dialog-header-icon:hover,\n.edit-profile-dialog .p-dialog-header-close:hover {\n  background: rgba(255, 255, 255, 0.14) !important;\n}\n\n.edit-profile-dialog .p-dialog-content {\n  padding: 0 !important;\n  overflow-x: hidden !important;\n  background: #f8fafc !important;\n}\n\n.edit-profile-body {\n  padding: 20px;\n  overflow-x: hidden;\n}\n\n.edit-profile-dialog .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.edit-profile-dialog [class*=\"col-\"] {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.edit-profile-form {\n  display: grid;\n  gap: 16px;\n}\n\n.edit-profile-form > .flex.flex-wrap {\n  display: grid !important;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px !important;\n  margin-bottom: 0 !important;\n}\n\n.edit-profile-form > .flex.flex-wrap:nth-of-type(3) {\n  grid-template-columns: 1fr;\n}\n\n.edit-profile-form .flex-auto {\n  min-width: 0;\n  width: 100%;\n}\n\n.edit-profile-form label {\n  margin-bottom: 6px !important;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.edit-profile-form .p-inputtext,\n.edit-profile-form .p-dropdown,\n.edit-profile-form .p-multiselect {\n  width: 100%;\n  min-height: 38px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 13px;\n  box-shadow: none !important;\n}\n\n.edit-profile-form .p-inputtext:enabled:focus,\n.edit-profile-form .p-dropdown:not(.p-disabled).p-focus,\n.edit-profile-form .p-multiselect:not(.p-disabled).p-focus {\n  border-color: #0f6fa8;\n  box-shadow: 0 0 0 3px rgba(15, 111, 168, 0.12) !important;\n}\n\n.edit-profile-form .p-dropdown-label,\n.edit-profile-form .p-multiselect-label {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.edit-profile-form .p-multiselect-label {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  white-space: normal;\n  line-height: 1.3;\n}\n\n.edit-profile-form .p-multiselect-token {\n  max-width: 100%;\n  margin: 0;\n  border-radius: 999px;\n  background: #e8eef5;\n  color: #334155;\n  font-size: 12px;\n}\n\n.edit-profile-form .p-multiselect-token-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edit-profile-dialog .p-dialog-footer {\n  padding: 12px 20px !important;\n  border-top: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  overflow-x: hidden !important;\n}\n\n.edit-profile-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  width: 100%;\n}\n\n.edit-profile-footer .p-button {\n  min-width: 96px;\n  height: 36px;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.edit-profile-footer .p-button-text {\n  color: #0f4c81 !important;\n  background: #ffffff !important;\n  border: 1px solid #bfdbfe !important;\n}\n\n.edit-profile-footer .p-button-raised {\n  border: 0 !important;\n  background: var(--blue-gradient-right) !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 900px) {\n  .edit-profile-form > .flex.flex-wrap {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 992px) {\n  .import-duplicate-grid,\n  .import-tag-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n#VitelMeetLink{\n\n}\n\n.interview-popup .from-width .p-dropdown-trigger {\n  display: none !important;\n}\n\n.interview-popup .from-width.p-dropdown {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: #fff !important;\n}\n\n.interview-popup .from-width.p-dropdown:hover,\n.interview-popup .from-width.p-dropdown.p-focus {\n  background: #fff !important;\n  border-color: #ced4da !important;\n  box-shadow: none !important;\n}\n\n.interview-popup .from-width .p-dropdown-label {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding-right: 8px !important;\n  color: #111827 !important;\n  text-align: center !important;\n}\n\n.interview-popup .from-width.p-dropdown:hover .p-dropdown-label,\n.interview-popup .from-width.p-dropdown.p-focus .p-dropdown-label {\n  color: #111827 !important;\n  background: transparent !important;\n}\n\n.interview-popup label[for=\"interview\"] {\n  display: block !important;\n  width: auto;\n  min-height: 0;\n  margin: 0 0 6px !important;\n  text-align: left !important;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  column-gap: 34px;\n  row-gap: 12px;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row {\n  display: grid;\n  grid-template-columns: 104px minmax(0, 1fr);\n  column-gap: 12px;\n  align-items: flex-start;\n  margin: 0;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-1,\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-11 {\n  flex: initial;\n  max-width: none;\n  width: auto;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row > .col-xl-11 {\n  min-width: 0;\n  padding-left: 0;\n}\n\n.interview-popup .label-input {\n  width: 100%;\n}\n\n.interview-popup .label-input .p-dropdown,\n.interview-popup .label-input label {\n  width: 100%;\n}\n\n.interview-popup .label-input .p-dropdown,\n.interview-popup .label-input label,\n.interview-popup label[for=\"interview\"] {\n  border-radius: 6px !important;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row.size-mail.mt-2 {\n  grid-column: 1 / -1;\n  margin-top: 0 !important;\n  align-items: center !important;\n  column-gap: 8px;\n}\n\n.interview-popup .form-insidepop p:empty {\n  display: none !important;\n  margin: 0 !important;\n}\n\n.interview-popup .form-insidepop > .mb-2 > .col-xl-12 > .row.size-mail.mt-2 > .col-xl-11 > div > div {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.interview-popup .form-insidepop > .row:not(.mb-2) {\n  margin-top: 4px;\n}\n\n.interview-popup .form-insidepop > .row:not(.mb-2) > .col-xl-12 {\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.interview-popup .popup-header-bg {\n  margin: 0 0 12px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border-bottom: 1px solid #dbe4f0;\n  background: #f4f7fb;\n}\n\n.interview-popup .bg-form.form-insidepop {\n  padding: 18px 14px 14px;\n  border: 1px solid #dbe4f0;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: none;\n}\n\n.interview-popup .email-inline-fields {\n  width: 100%;\n}\n\n.interview-popup .email-inline-fields .from-width.p-dropdown,\n.interview-popup .email-inline-fields label[for=\"interview\"] {\n  min-height: 38px !important;\n  border: 1px solid #7db7e8 !important;\n  background: #e8f3ff !important;\n  color: #0f4e7a !important;\n  font-weight: 700 !important;\n  box-shadow: inset 0 0 0 1px rgba(15, 78, 122, 0.04) !important;\n}\n\n.interview-popup .email-inline-fields .from-width .p-dropdown-label {\n  color: #0f4e7a !important;\n  font-weight: 700 !important;\n}\n\n.interview-popup .email-inline-fields .p-chips,\n.interview-popup .email-inline-fields .p-inputtext {\n  width: 100% !important;\n  min-width: 0 !important;\n}\n\n.interview-popup .email-inline-fields .to-recipient-chips .p-chips-multiple-container,\n.interview-popup .email-inline-fields .email-recipient-chips .p-chips-multiple-container {\n  width: 100% !important;\n  min-height: 38px !important;\n  height: 38px !important;\n  resize: none !important;\n  overflow-y: hidden !important;\n  flex-wrap: nowrap !important;\n  align-items: center !important;\n  align-content: center !important;\n  border-color: #b7d6f0 !important;\n  background: #f8fbff !important;\n}\n\n.interview-popup .email-inline-fields .to-recipient-chips .p-chips-token,\n.interview-popup .email-inline-fields .email-recipient-chips .p-chips-token {\n  max-width: 100% !important;\n  background: #dff0ff !important;\n  color: #0f4e7a !important;\n  border: 1px solid #a7d0f2 !important;\n}\n\n.interview-popup .email-inline-fields .p-inputtext {\n  height: 38px !important;\n  border-color: #b7d6f0 !important;\n  background: #ffffff !important;\n  color: #111827 !important;\n}\n\n.interview-popup .to-recipient-chips .p-chips-multiple-container,\n.interview-popup .email-recipient-chips .p-chips-multiple-container {\n  min-height: 38px;\n  height: 38px;\n  max-height: 180px;\n  padding: 6px 8px !important;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  align-items: flex-start;\n  gap: 5px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  cursor: pointer;\n  resize: vertical;\n}\n\n.interview-popup .to-recipient-chips .p-chips-multiple-container {\n  height: 62px;\n  max-height: 180px;\n}\n\n.interview-popup .to-recipient-chips .p-chips-token,\n.interview-popup .email-recipient-chips .p-chips-token {\n  max-width: 235px;\n  min-height: 24px;\n  margin: 0 !important;\n  padding: 2px 8px !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border-radius: 999px;\n  background: #eef3f7;\n  color: #1f2937;\n  cursor: pointer;\n}\n\n.interview-popup .to-recipient-chips .p-chips-token span,\n.interview-popup .to-recipient-chips .p-chips-token .p-chips-token-label,\n.interview-popup .email-recipient-chips .p-chips-token span,\n.interview-popup .email-recipient-chips .p-chips-token .p-chips-token-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.interview-popup .to-recipient-chips .p-chips-input-token,\n.interview-popup .email-recipient-chips .p-chips-input-token {\n  flex: 1 0 120px;\n  min-width: 120px;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.interview-popup .to-recipient-chips .p-chips-input-token input,\n.interview-popup .email-recipient-chips .p-chips-input-token input {\n  width: 100% !important;\n  min-height: 24px;\n  padding: 0 !important;\n}\n\n/* Keep every recipient visible in the email composer, including the legacy size-mail fields. */\n.interview-popup .size-mail.p-chips .p-chips-multiple-container {\n  width: 100% !important;\n  min-height: 38px !important;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  align-content: center !important;\n  gap: 5px;\n  padding: 6px 8px !important;\n}\n\n.interview-popup .size-mail.p-chips .p-chips-token {\n  max-width: calc(100% - 12px) !important;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n}\n\n.interview-popup .editorpage,\n.interview-popup .jobsall-editor {\n  margin-top: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.interview-popup .editorpage .p-editor-container,\n.interview-popup .jobsall-editor .p-editor-container {\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.interview-popup .editorpage .p-editor-toolbar,\n.interview-popup .jobsall-editor .p-editor-toolbar {\n  border-color: #dbe4f0 !important;\n  border-radius: 8px 8px 0 0 !important;\n  background: #f8fafc !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box;\n}\n\n.interview-popup .editorpage .p-editor-content,\n.interview-popup .jobsall-editor .p-editor-content {\n  border-color: #dbe4f0 !important;\n  border-radius: 0 0 8px 8px !important;\n  background: #ffffff !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.interview-popup .editorpage .ql-editor,\n.interview-popup .jobsall-editor .ql-editor {\n  min-height: 220px;\n  max-height: 310px;\n  overflow-y: auto;\n  padding: 14px 16px !important;\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.interview-popup .email-signature-block {\n  display: block !important;\n  clear: both;\n  margin-top: 10px;\n  padding-top: 4px;\n  max-width: 360px;\n}\n\n.interview-popup .email-signature-block img {\n  max-width: 180px !important;\n  max-height: 70px !important;\n  width: auto !important;\n  height: auto !important;\n  object-fit: contain;\n  display: block !important;\n  margin: 6px 0 !important;\n}\n\n.interview-popup .email-signature-block table {\n  width: auto !important;\n  max-width: 100% !important;\n}\n\n.interview-popup .signature-dropdown {\n  min-width: 280px !important;\n  width: 280px !important;\n}\n\n.email-dialog-host {\n  display: contents;\n}\n\n.email-compose-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.42);\n  backdrop-filter: blur(2px);\n}\n\n.email-compose-modal {\n  width: min(1160px, calc(100vw - 48px));\n  height: min(820px, calc(100vh - 48px));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #d6dee8;\n  border-radius: 14px;\n  background: #f8fafc;\n  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.24);\n}\n\n.email-compose-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #dbe3ee;\n  background: #ffffff;\n}\n\n.email-compose-modal-header h2 {\n  margin: 0;\n  color: #12385f;\n  font-size: 20px;\n  font-weight: 750;\n  letter-spacing: 0;\n}\n\n.email-compose-modal-header p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.email-compose-header-actions {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.email-compose-header-actions .signature-dropdown {\n  width: 240px !important;\n  min-width: 220px !important;\n}\n\n.email-compose-header-actions .signature-dropdown.p-dropdown {\n  height: 38px !important;\n  border-color: #cbd5e1 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-header-actions .signature-dropdown.p-dropdown:hover,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-inputwrapper-focus {\n  border-color: #94a3b8 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-header-actions .signature-dropdown .p-dropdown-label,\n.email-compose-header-actions .signature-dropdown.p-dropdown:hover .p-dropdown-label,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus .p-dropdown-label {\n  color: #1f2937 !important;\n  background: transparent !important;\n}\n\n.email-compose-header-actions .p-fileupload-choose {\n  height: 38px !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  color: #12385f !important;\n  font-weight: 700 !important;\n  box-shadow: none !important;\n}\n\n.email-compose-header-actions .p-fileupload-choose:hover {\n  background: #f8fafc !important;\n  border-color: #94a3b8 !important;\n}\n\n.email-compose-close {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d1dae6;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n}\n\n.email-compose-close:hover {\n  background: #eef4fb;\n  color: #12385f;\n}\n\n.email-compose-modal-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px 16px;\n}\n\n.email-compose-modal-footer {\n  padding: 14px 20px;\n  border-top: 1px solid #d9e6f2;\n  background: #ffffff;\n}\n\n.email-compose-dialog .p-dialog-header {\n  background: linear-gradient(90deg, #eaf4ff 0%, #f7fbff 100%) !important;\n  border-bottom: 1px solid #cfe1f4 !important;\n  padding: 16px 20px !important;\n}\n\n.email-compose-dialog .p-dialog-title {\n  color: #0f3f6e !important;\n  font-size: 20px !important;\n  font-weight: 700 !important;\n}\n\n.email-compose-dialog .p-dialog-content {\n  background: #f4f8fc !important;\n  padding: 18px !important;\n}\n\n.email-compose-dialog .p-dialog-footer {\n  padding: 14px 20px !important;\n  border-top: 1px solid #d9e6f2 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .preview-btn {\n  min-width: 112px !important;\n  height: 40px !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  background: #126fb3 !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  box-shadow: 0 8px 18px rgba(18, 111, 179, 0.22) !important;\n}\n\n.email-compose-dialog .email-compose-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 100%;\n}\n\n.email-compose-dialog .email-compose-toolbar {\n  width: 100%;\n  margin: 0 !important;\n  padding: 10px 12px !important;\n  border: 1px solid #d9e2ec !important;\n  border-radius: 10px !important;\n  background: #ffffff !important;\n  box-shadow: none;\n}\n\n.email-compose-dialog .email-compose-toolbar .p-fileupload-choose {\n  height: 38px !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 8px !important;\n  background: #f8fafc !important;\n  color: #12385f !important;\n  font-weight: 700 !important;\n}\n\n.email-compose-dialog .signature-dropdown {\n  min-width: 260px !important;\n  width: 280px !important;\n}\n\n.email-compose-dialog .bg-form.form-insidepop {\n  padding: 12px !important;\n  border: 1px solid #d9e2ec !important;\n  border-radius: 12px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-dialog .email-inline-fields {\n  grid-template-columns: minmax(240px, 0.9fr) minmax(260px, 1fr) minmax(220px, 0.8fr) minmax(300px, 1.15fr) !important;\n  gap: 12px !important;\n  overflow-x: visible !important;\n  padding: 0 0 8px !important;\n}\n\n.email-compose-dialog .email-inline-fields > div {\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-inline-fields .from-width.p-dropdown,\n.email-compose-dialog .email-inline-fields label[for=\"interview\"] {\n  border-color: #cbd5e1 !important;\n  background: #f1f5f9 !important;\n  color: #12385f !important;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  border-color: #cbd5e1 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-attachment-panel {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 10px;\n  padding: 8px 10px;\n  border: 1px solid #d9e2ec;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-attachment-label {\n  margin: 0;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-attachment-list {\n  display: flex;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-attachment-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  max-width: min(100%, 520px);\n  padding: 6px 10px;\n  border: 1px solid #d1dae6;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #12385f;\n  box-shadow: inset 0 0 0 1px rgba(15, 78, 122, 0.03);\n}\n\n.email-compose-dialog .email-attachment-chip .pi-file {\n  color: #12385f;\n}\n\n.email-compose-dialog .email-attachment-chip .pi-times {\n  color: #dc2626;\n  cursor: pointer;\n}\n\n.email-compose-dialog .email-no-attachments {\n  flex: 1;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.email-compose-dialog .email-include-jd {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-left: auto;\n  padding: 5px 9px;\n  border: 1px solid #d1dae6;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #12385f;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-include-jd label {\n  margin: 0;\n  cursor: pointer;\n}\n\n.email-compose-dialog .email-compose-editor-row {\n  margin-top: 10px;\n}\n\n.email-compose-dialog .editorpage .p-editor-toolbar {\n  background: #ffffff !important;\n  border-color: #d9e2ec !important;\n}\n\n.email-compose-dialog .editorpage .p-editor-content {\n  border-color: #d9e2ec !important;\n}\n\n.email-compose-dialog .editorpage .ql-editor {\n  min-height: 250px !important;\n  max-height: 340px !important;\n  color: #1f2937 !important;\n}\n\n.email-compose-modal {\n  width: min(1080px, calc(100vw - 56px));\n  background: #ffffff;\n}\n\n.email-compose-modal-body {\n  background: #f8fafc;\n}\n\n.email-compose-dialog .email-compose-shell {\n  gap: 12px;\n}\n\n.email-compose-dialog .email-compose-toolbar {\n  padding: 10px 12px !important;\n  border-color: #e2e8f0 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .bg-form.form-insidepop {\n  padding: 0 !important;\n  border-color: #d8e0ea !important;\n  background: #ffffff !important;\n  overflow: hidden;\n}\n\n.email-compose-dialog .form-insidepop > .mb-2 {\n  margin: 0 !important;\n}\n\n.email-compose-dialog .form-insidepop > .mb-2 > .col-xl-12 {\n  display: block !important;\n}\n\n.email-compose-dialog .email-inline-fields {\n  display: grid !important;\n  grid-template-columns: 1fr !important;\n  gap: 0 !important;\n  padding: 0 !important;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.email-compose-dialog .email-inline-fields > div {\n  padding: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid #eef2f7 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-inline-fields > div:last-child {\n  border-bottom: 0 !important;\n}\n\n.email-compose-dialog .email-inline-fields > div > div {\n  min-height: 46px;\n  align-items: center;\n  gap: 0 !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width.p-dropdown,\n.email-compose-dialog .email-inline-fields label[for=\"interview\"] {\n  width: 104px !important;\n  flex: 0 0 104px !important;\n  height: 46px !important;\n  min-height: 46px !important;\n  border: 0 !important;\n  border-right: 1px solid #e2e8f0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  color: #334155 !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  justify-content: flex-start !important;\n  padding-left: 16px !important;\n  box-shadow: none !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {\n  justify-content: flex-start !important;\n  color: #334155 !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  padding-left: 0 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips,\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  flex: 1 1 auto !important;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  height: 46px !important;\n  min-height: 46px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  padding: 0 16px !important;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container {\n  padding: 9px 12px !important;\n  overflow-x: hidden !important;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-token,\n.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-token {\n  max-width: min(100%, 380px) !important;\n  min-height: 30px;\n  padding: 5px 9px !important;\n  gap: 8px;\n  border: 1px solid #bcd6e8 !important;\n  border-radius: 6px !important;\n  background: #eef7fc !important;\n  color: #164c6c !important;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-icon {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 0;\n  color: #52758c;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips-token .p-chips-token-icon:hover {\n  color: #b42318;\n  background: #fee4e2;\n}\n\n.email-compose-dialog .email-attachment-panel {\n  margin: 0;\n  padding: 10px 16px;\n  border: 0;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 0;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-attachment-label {\n  width: 94px;\n  color: #334155;\n}\n\n.email-compose-dialog .email-include-jd {\n  border-color: #cbd5e1;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-attachment-panel,\n.email-compose-dialog .email-attachment-label,\n.email-compose-dialog .email-include-jd {\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-compose-editor-row {\n  margin: 0;\n}\n\n.email-compose-dialog .email-compose-editor-row > .col-xl-12 {\n  padding: 0;\n}\n\n.email-compose-dialog .editorpage {\n  border-radius: 0;\n}\n\n.email-compose-dialog .editorpage .p-editor-toolbar {\n  border: 0 !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .editorpage .p-editor-content {\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.email-compose-dialog .editorpage .ql-editor {\n  min-height: 300px !important;\n  max-height: 420px !important;\n  padding: 18px 20px !important;\n}\n\n.email-compose-modal {\n  width: min(1380px, calc(100vw - 32px));\n  height: min(920px, calc(100vh - 24px));\n  height: min(830px, calc(100vh - 48px));\n  border: 0;\n  border-radius: 16px;\n  background: #f3f6fa;\n}\n\n.email-compose-modal-header {\n  padding: 20px 24px;\n  border-bottom: 3px solid #f97316;\n  background: #164c78;\n}\n\n.email-compose-modal-header h2 {\n  color: #ffffff;\n}\n\n.email-compose-modal-header p {\n  color: #dcecff;\n}\n\n.email-compose-header-actions .signature-dropdown.p-dropdown,\n.email-compose-header-actions .signature-dropdown.p-dropdown:hover,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-inputwrapper-focus,\n.email-compose-header-actions .p-fileupload-choose,\n.email-compose-header-actions .p-fileupload-choose:hover {\n  border-color: rgba(255, 255, 255, 0.42) !important;\n  background: rgba(255, 255, 255, 0.12) !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-header-actions .signature-dropdown .p-dropdown-label,\n.email-compose-header-actions .signature-dropdown.p-dropdown:hover .p-dropdown-label,\n.email-compose-header-actions .signature-dropdown.p-dropdown.p-focus .p-dropdown-label,\n.email-compose-header-actions .signature-dropdown .p-dropdown-trigger,\n.email-compose-header-actions .signature-dropdown .p-dropdown-trigger-icon {\n  color: #ffffff !important;\n  background: transparent !important;\n}\n\n.email-compose-close,\n.email-compose-close:hover {\n  border-color: rgba(255, 255, 255, 0.45);\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.email-compose-modal-body {\n  padding: 18px 22px 0;\n  background: #ffffff;\n}\n\n.email-compose-modal-footer {\n  padding: 20px 24px;\n}\n\n.email-compose-dialog .email-compose-shell,\n.email-compose-dialog .email-compose-main,\n.email-compose-dialog .email-compose-left-panel {\n  min-height: 0;\n}\n\n.email-compose-dialog .email-compose-main {\n  display: grid;\n  grid-template-columns: minmax(720px, 1.45fr) minmax(320px, 0.75fr);\n  gap: 26px;\n  min-height: 100%;\n}\n\n.email-compose-dialog .email-compose-left-panel {\n  min-width: 0;\n}\n\n.email-compose-dialog .bg-form.form-insidepop {\n  width: 100%;\n  border: 1px solid #d8e0ea !important;\n  border-radius: 12px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-dialog .form-insidepop > .mb-2 {\n  flex: 0 0 auto;\n}\n\n.email-compose-dialog .email-compose-editor-row {\n  min-height: 0;\n}\n\n.email-compose-dialog .email-compose-editor-row > .col-xl-12,\n.email-compose-dialog .editorpage,\n.email-compose-dialog .editorpage .p-editor-container {\n  min-height: 0;\n}\n\n.email-compose-dialog .editorpage .p-editor-container {\n  display: block;\n}\n\n.email-compose-dialog .editorpage .p-editor-content {\n  min-height: 0;\n}\n\n.email-compose-dialog .email-attachment-panel {\n  background: #fbfdff;\n}\n\n.email-compose-dialog .editorpage .ql-editor {\n  min-height: 620px !important;\n  max-height: 760px !important;\n  height: auto !important;\n}\n\n.email-compose-dialog .email-preview-label {\n  margin: 0 0 8px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.email-compose-dialog .email-preview-card {\n  min-height: 280px;\n  padding: 16px;\n  border: 1px solid #d8e0ea;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.08);\n}\n\n.email-compose-dialog .email-preview-subject {\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.35;\n}\n\n.email-compose-dialog .email-preview-meta {\n  margin-top: 5px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.email-compose-dialog .email-preview-divider {\n  height: 1px;\n  margin: 14px 0;\n  background: #e2e8f0;\n}\n\n.email-compose-dialog .email-preview-body {\n  height: 560px;\n  max-height: max(360px, calc(100vh - 230px));\n  overflow: auto;\n  color: #1f2937;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.email-compose-dialog .email-preview-body img {\n  max-width: 180px;\n  height: auto;\n}\n\n/* Final selected-candidate email composer layout */\n.email-compose-modal {\n  width: min(1360px, calc(100vw - 32px));\n  height: auto;\n  max-height: calc(100vh - 28px);\n  background: #ffffff;\n}\n\n.email-compose-modal-body {\n  padding: 18px;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-compose-main {\n  display: grid;\n  grid-template-columns: minmax(760px, 1.55fr) minmax(360px, 0.8fr);\n  gap: 24px;\n  min-height: 0;\n}\n\n.email-compose-dialog .email-compose-left-panel {\n  width: 100%;\n}\n\n.email-compose-dialog .email-compose-preview-panel {\n  display: block;\n  min-width: 0;\n}\n\n.email-compose-dialog .bg-form.form-insidepop {\n  border: 1px solid #d4dee9 !important;\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n.email-compose-dialog .email-inline-fields {\n  display: grid !important;\n  grid-template-columns: 1fr !important;\n  gap: 0 !important;\n  padding: 0 !important;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.email-compose-dialog .email-inline-fields > div {\n  border: 0 !important;\n  border-bottom: 1px solid #e9eef5 !important;\n  border-radius: 0 !important;\n}\n\n.email-compose-dialog .email-inline-fields > div:last-child {\n  border-bottom: 0 !important;\n}\n\n.email-compose-dialog .email-inline-fields > div > div {\n  min-height: 62px;\n  gap: 0 !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width.p-dropdown,\n.email-compose-dialog .email-inline-fields label[for=\"interview\"] {\n  width: 116px !important;\n  flex: 0 0 116px !important;\n  height: 48px !important;\n  min-height: 48px !important;\n  padding-left: 16px !important;\n  border: 0 !important;\n  border-right: 1px solid #e2e8f0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  color: #1f2a44 !important;\n  font-weight: 700 !important;\n  justify-content: flex-start !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {\n  justify-content: flex-start !important;\n  padding-left: 0 !important;\n  color: #1f2a44 !important;\n}\n\n.email-compose-dialog .email-inline-fields .p-chips,\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  flex: 1 1 auto !important;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  height: 48px !important;\n  min-height: 48px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.email-compose-dialog .email-inline-fields .p-inputtext {\n  padding: 0 16px !important;\n}\n\n.email-compose-dialog .email-attachment-panel {\n  margin: 0;\n  padding: 10px 14px;\n  border: 0;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 0;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-attachment-label {\n  width: 100px;\n  margin: 0;\n  color: #1f2a44;\n  font-weight: 500;\n}\n\n.email-compose-dialog .email-attachment-list {\n  flex: 1;\n  min-width: 0;\n}\n\n.email-compose-dialog .email-attachment-chip {\n  max-width: min(100%, 520px);\n  border-radius: 4px;\n  background: #ffffff;\n}\n\n.email-compose-dialog .email-include-jd {\n  margin-left: 12px;\n  border: 0;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .email-compose-editor-row {\n  margin: 0;\n}\n\n.email-compose-dialog .email-compose-editor-row > .col-xl-12 {\n  padding: 0;\n}\n\n.email-compose-dialog .editorpage .p-editor-toolbar {\n  border: 0 !important;\n  border-bottom: 1px solid #d4dee9 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n}\n\n.email-compose-dialog .editorpage .p-editor-content {\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.email-compose-dialog .editorpage .ql-editor {\n  min-height: 190px !important;\n  max-height: 320px !important;\n  height: auto !important;\n}\n\n.email-compose-dialog .email-preview-body table {\n  width: 100% !important;\n  border-collapse: collapse !important;\n  table-layout: fixed;\n}\n\n.email-compose-dialog .email-preview-body td,\n.email-compose-dialog .email-preview-body th {\n  padding: 8px 10px !important;\n  border: 1px solid #cbd5e1 !important;\n  vertical-align: top !important;\n  word-break: normal !important;\n  overflow-wrap: break-word;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor {\n  width: 100% !important;\n  border: 0;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor-editable table {\n  width: 100% !important;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor-editable td,\n.email-compose-dialog .email-html-editor .sun-editor-editable th {\n  vertical-align: top !important;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor-editable .se-component,\n.email-compose-dialog .email-html-editor .sun-editor-editable figure,\n.email-compose-dialog .email-preview-body .se-component,\n.email-compose-dialog .email-preview-body figure {\n  border: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n  margin: 6px 0 !important;\n  padding: 0 !important;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor-editable p,\n.email-compose-dialog .email-preview-body .email-signature-block p {\n  margin: 0 0 4px;\n  line-height: 1.5;\n}\n\n.email-compose-dialog .email-html-editor .sun-editor-editable .se-image-container {\n  width: fit-content !important;\n  max-width: 100%;\n}\n\n.email-compose-dialog .email-preview-body table td:last-child {\n  width: 70% !important;\n}\n\n.email-compose-dialog .email-preview-body td:first-child,\n.email-compose-dialog .email-preview-body th:first-child {\n  width: 30% !important;\n  background: #f8fafc !important;\n  color: #0f3f6e !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.email-compose-dialog .email-preview-body td:first-child strong,\n.email-compose-dialog .email-preview-body th:first-child strong {\n  font-family: inherit;\n  font-weight: inherit;\n}\n\n.email-compose-dialog .preview-btn {\n  background: #f97316 !important;\n  box-shadow: 0 8px 18px rgba(249, 115, 22, 0.24) !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width.p-dropdown,\n.email-compose-dialog .email-inline-fields label[for=\"interview\"] {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding-left: 0 !important;\n  text-align: center !important;\n}\n\n.email-compose-dialog .email-inline-fields .from-width .p-dropdown-label {\n  justify-content: center !important;\n  text-align: center !important;\n}\n\n.email-compose-dialog .email-compose-attachments,\n.email-compose-dialog .email-compose-attachments > .col-xl-12 {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0;\n  flex: 0 0 100% !important;\n  grid-column: 1 / -1;\n}\n\n.email-compose-dialog .email-attachment-panel {\n  display: grid !important;\n  grid-template-columns: 70px minmax(0, 1fr) auto;\n  align-items: center !important;\n  gap: 10px !important;\n  width: 100% !important;\n}\n\n.email-compose-dialog .email-attachment-label {\n  flex: 0 0 auto;\n  margin: 0 !important;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-attachment-list {\n  display: grid !important;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  flex: none !important;\n  max-width: 100%;\n  min-width: 0;\n  width: 100% !important;\n  max-height: 220px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 2px 6px 2px 0;\n}\n\n.email-compose-dialog .email-attachment-list:has(> .email-attachment-chip:only-child) {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.email-compose-dialog .email-attachment-chip {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 7px !important;\n  min-width: 0;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cbdbea;\n  border-radius: 6px;\n  background: #f8fbff;\n}\n\n.email-compose-dialog .email-attachment-list:has(> .email-attachment-chip:only-child) .email-attachment-chip {\n  width: 100% !important;\n  max-width: none !important;\n}\n\n.email-compose-dialog .email-attachment-chip a,\n.email-compose-dialog .email-attachment-chip > span {\n  min-width: 0;\n  flex: 1;\n  overflow: visible;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.email-compose-dialog .email-include-jd {\n  display: inline-flex !important;\n  align-items: center;\n  flex: 0 0 auto;\n  margin: 0 !important;\n  white-space: nowrap;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips,\n.email-compose-dialog .email-inline-fields .email-recipient-chips {\n  height: auto !important;\n  min-height: 48px !important;\n  max-height: 150px !important;\n  min-width: 0;\n}\n\n.email-compose-dialog .email-inline-fields .to-recipient-chips .p-chips-multiple-container,\n.email-compose-dialog .email-inline-fields .email-recipient-chips .p-chips-multiple-container {\n  height: auto !important;\n  min-height: 48px !important;\n  max-height: 150px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  flex-wrap: wrap !important;\n  align-content: flex-start !important;\n}\n\n@media (max-width: 1200px) {\n  .interview-popup .form-insidepop > .mb-2 > .col-xl-12 {\n    grid-template-columns: 1fr;\n  }\n\n  .email-compose-dialog .email-attachment-panel {\n    align-items: flex-start !important;\n    grid-template-columns: 70px minmax(0, 1fr);\n  }\n\n  .email-compose-dialog .email-include-jd {\n    grid-column: 2;\n  }\n\n  .email-compose-dialog .email-attachment-list {\n    grid-template-columns: 1fr;\n  }\n\n  .email-compose-dialog .email-inline-fields {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n}\n\n.interview-popup .schedule-interview-form .row {\n  align-items: flex-start;\n  row-gap: 12px;\n}\n\n.interview-popup .schedule-interview-form label,\n.interview-popup .schedule-interview-form label[for=\"interview\"] {\n  display: block !important;\n  width: auto;\n  min-height: 0;\n  margin: 0 0 6px !important;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.25;\n  text-align: left !important;\n}\n\n.interview-popup .schedule-interview-form .p-inputtext,\n.interview-popup .schedule-interview-form .p-dropdown,\n.interview-popup .schedule-interview-form .p-calendar,\n.interview-popup .schedule-interview-form .p-calendar .p-inputtext {\n  width: 100%;\n}\n\n.interview-popup .schedule-interview-form .p-inputtext,\n.interview-popup .schedule-interview-form .p-dropdown {\n  min-height: 38px;\n}\n\n.interview-popup .schedule-interview-form .p-dropdown {\n  display: flex;\n  align-items: center;\n  background: #fff !important;\n}\n\n.interview-popup .schedule-interview-form .p-dropdown-label {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  line-height: 1.2;\n  background: #fff !important;\n  color: #111827 !important;\n}\n\n.interview-popup .schedule-interview-form .p-dropdown-trigger,\n.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown,\n.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown-label,\n.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown-trigger,\n.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown,\n.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown-label,\n.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown-trigger {\n  background: #fff !important;\n}\n\n.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown:hover,\n.interview-popup .schedule-interview-form #SubTypeDropdown .p-dropdown.p-focus,\n.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown:hover,\n.interview-popup .schedule-interview-form #PriorityDropdown .p-dropdown.p-focus {\n  background: #fff !important;\n  border-color: #ced4da !important;\n  box-shadow: none !important;\n}\n\n.interview-popup .schedule-interview-form .p-calendar .p-button {\n  flex: 0 0 38px;\n  width: 38px;\n  height: 38px;\n  margin: 0;\n  border: 0 !important;\n  border-left: 1px solid #d9dee7 !important;\n  border-radius: 0 !important;\n  background: #eef0f5 !important;\n  color: #111827 !important;\n}\n\n.interview-popup .schedule-interview-form .p-calendar {\n  display: flex;\n  align-items: stretch;\n  overflow: hidden;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.interview-popup .schedule-interview-form .p-calendar .p-inputtext {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.job-candidate-toolbar {\n  justify-content: flex-start !important;\n  column-gap: 10px !important;\n  row-gap: 10px !important;\n}\n\n.job-candidate-toolbar .job-candidate-action-row {\n  display: contents !important;\n}\n\n.interview-popup .schedule-interview-form .field,\n.interview-popup .schedule-interview-form .p-field {\n  margin-bottom: 0;\n}\n\n.interview-popup .schedule-interview-form .schedule-priority-col {\n  flex: 0 0 auto;\n  max-width: 230px;\n}\n\n.interview-popup .calendar-event-edit-form label {\n  display: block !important;\n  margin: 0 0 6px !important;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left !important;\n}\n\n.interview-popup .calendar-event-edit-form .p-inputtext,\n.interview-popup .calendar-event-edit-form textarea,\n.interview-popup .calendar-event-edit-form .p-dropdown,\n.interview-popup .calendar-event-edit-form .p-calendar,\n.interview-popup .calendar-event-edit-form .p-checkbox,\n.interview-popup .calendar-event-edit-form .pi-chevron-down {\n  pointer-events: none !important;\n}\n\n.interview-popup .calendar-event-edit-form .p-inputtext,\n.interview-popup .calendar-event-edit-form textarea,\n.interview-popup .calendar-event-edit-form .p-dropdown {\n  background: #f8fafc !important;\n  color: #6b7280 !important;\n}\n\n.interview-popup .calendar-schedule-readonly-form label {\n  display: block !important;\n  margin: 0 0 6px !important;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left !important;\n}\n\n.interview-popup .calendar-schedule-readonly-form .p-inputtext,\n.interview-popup .calendar-schedule-readonly-form textarea,\n.interview-popup .calendar-schedule-readonly-form .p-dropdown,\n.interview-popup .calendar-schedule-readonly-form .p-calendar,\n.interview-popup .calendar-schedule-readonly-form .p-checkbox,\n.interview-popup .calendar-schedule-readonly-form .p-multiselect,\n.interview-popup .calendar-schedule-readonly-form .pi-chevron-down,\n.interview-popup .calendar-schedule-readonly-form .inline-link-selector,\n.interview-popup .calendar-schedule-readonly-form [role=\"button\"] {\n  pointer-events: none !important;\n}\n\n.interview-popup .calendar-schedule-readonly-form .p-inputtext,\n.interview-popup .calendar-schedule-readonly-form textarea,\n.interview-popup .calendar-schedule-readonly-form .p-dropdown,\n.interview-popup .calendar-schedule-readonly-form .p-multiselect {\n  background: #f8fafc !important;\n  color: #6b7280 !important;\n}\n\n#SendForApprovalBtn,\n#SentForApprovalBtn {\n  font-size: 0.68rem !important;\n}\n\n.feedback-panel-modal-header {\n  align-items: center !important;\n  gap: 12px;\n}\n\n.feedback-panel-modal-header .modal-title {\n  min-width: 0 !important;\n  width: calc(100% - 44px) !important;\n  max-width: calc(100% - 44px) !important;\n}\n\n.feedback-panel-modal-header .btn-close {\n  flex: 0 0 auto;\n  margin-left: auto;\n  filter: invert(1) grayscale(100%) brightness(200%);\n  opacity: 1;\n}\n\n.feedback-panel-modal-header .btn-close:hover {\n  opacity: 0.85;\n}\n\n.feedback-panel-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.extension-logs-modern-page {\n  padding-top: 28px !important;\n}\n\n.extension-logs-modern-page .page-title-box {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Table,\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead,\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody,\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableRow {\n  width: 100% !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Table,\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody {\n  max-height: none !important;\n  height: auto !important;\n  overflow-x: hidden !important;\n  overflow-y: visible !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody::-webkit-scrollbar {\n  display: none !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHeadRow {\n  background: #eaf4ff !important;\n  border-bottom: 1px solid #c4d8ea !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol,\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol > div {\n  color: #0b3a5d !important;\n  justify-content: flex-start !important;\n  text-align: left !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableHead .rdt_TableCol {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  justify-content: flex-start !important;\n  text-align: left !important;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.extension-logs-modern-page #ExtensionLogs_Datatable .rdt_Pagination {\n  position: relative !important;\n  z-index: 1;\n  border-top: 1px solid #e7edf3 !important;\n  background: #fff !important;\n}\n/* =====================================================================\n   EMAIL MODULE — Outlook-style CSS\n   ===================================================================== */\n\n/* --- Layout --- */\n.em-module {\n  display: flex;\n  flex-direction: column;\n  /* Offset the fixed 70px app header so the ribbon is never clipped,\n     and fill the remaining viewport height so panels lay out cleanly. */\n  margin-top: 70px;\n  height: calc(100vh - 70px);\n  background: #f3f3f3;\n  font-family: \"Segoe UI\", \"San Francisco\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif;\n  font-size: 13px;\n  color: #1a1a1a;\n  overflow: hidden;\n  --em-accent: #2563eb;\n  --em-accent-hover: #1d4ed8;\n  --em-bg: #ffffff;\n  --em-bg-secondary: #fafafa;\n  --em-bg-tertiary: #f0f0f0;\n  --em-border: #e0e0e0;\n  --em-border-light: #ebebeb;\n  --em-text: #1a1a1a;\n  --em-text-secondary: #616161;\n  --em-text-muted: #999;\n  --em-hover: #eaeaea;\n  --em-active: #cce4ff;\n  --em-ribbon-bg: #f8f9fa;\n  --em-ribbon-border: #d0d0d0;\n  --em-sidebar-bg: #fafafa;\n  --em-unread-bg: #f5f7fa;\n  --em-reading-pane-bg: #fff;\n}\n\n/* --- Main Layout --- */\n.em-module-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* ===================== RIBBON ===================== */\n.em-ribbon {\n  background: var(--em-ribbon-bg);\n  border-bottom: 1px solid var(--em-ribbon-border);\n  user-select: none;\n  z-index: 10;\n}\n\n.em-ribbon-tabs {\n  display: flex;\n  align-items: stretch;\n  height: 32px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n  padding: 0 8px;\n}\n\n.em-ribbon-tab {\n  padding: 0 8px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  background: transparent;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  font-family: inherit;\n  transition: none;\n}\n\n.em-ribbon-tab:hover {\n  background: #eaeaea;\n}\n\n.em-ribbon-tab-active {\n  color: var(--em-text);\n  background: #f8f9fa;\n  border-bottom-color: var(--em-accent);\n  font-weight: 500;\n}\n\n.em-ribbon-content {\n  background: var(--em-ribbon-bg);\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 56px;\n}\n\n.em-ribbon-group {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 8px;\n  border-right: 1px solid var(--em-border);\n}\n\n.em-ribbon-group:last-child {\n  border-right: none;\n}\n\n.em-ribbon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1px;\n  padding: 3px 8px;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  color: var(--em-text);\n  font-family: inherit;\n  font-size: 11px;\n  min-width: 44px;\n  text-align: center;\n  transition: none;\n}\n\n.em-ribbon-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-ribbon-btn:active {\n  background: #ccc;\n}\n\n.em-ribbon-btn svg {\n  display: block;\n}\n\n.em-ribbon-btn-label {\n  font-size: 10px;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.em-ribbon-new-btn {\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  padding: 4px 16px 4px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.em-ribbon-new-btn:hover {\n  background: #004578;\n}\n\n.em-ribbon-search {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 2px;\n  padding: 0 6px;\n  height: 24px;\n  margin-left: auto;\n  min-width: 180px;\n}\n\n.em-ribbon-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 0 4px;\n  flex: 1;\n  color: var(--em-text);\n}\n\n.em-ribbon-search input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-ribbon-quickbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n  padding: 2px 8px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-ribbon-quickbar em {\n  font-style: normal;\n  font-weight: 600;\n  margin: 0 2px;\n}\n\n/* ===================== SIDEBAR ===================== */\n.em-sidebar {\n  width: 200px;\n  min-width: 200px;\n  background: var(--em-sidebar-bg);\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.em-sidebar-newmail {\n  margin: 8px 8px 4px;\n  padding: 6px 12px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: none;\n}\n\n.em-sidebar-newmail:hover {\n  background: #004578;\n}\n\n.em-sidebar-search-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 28px;\n  padding: 5px 12px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-size: 12.5px;\n  margin: 1px 6px;\n  border-radius: 4px;\n}\n\n.em-sidebar-search-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-section {\n  padding: 6px 0;\n  margin-top: 4px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-sidebar-section-title {\n  padding: 4px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.em-sidebar-folder {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 28px;\n  padding: 5px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin: 1px 6px;\n  position: relative;\n  color: var(--em-text);\n  font-size: 13px;\n}\n\n.em-sidebar-folder:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-folder-active {\n  background: var(--em-active) !important;\n  font-weight: 600;\n  box-shadow: inset 3px 0 0 #0e527d;\n}\n\n.em-sidebar-folder-icon {\n  width: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n}\n\n.em-sidebar-folder-active .em-sidebar-folder-icon {\n  color: var(--em-accent);\n}\n\n.em-sidebar-folder-label {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-sidebar-folder-count {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  margin-left: auto;\n  padding-left: 4px;\n}\n\n.em-sidebar-folder-count-primary {\n  color: #005a9e;\n  font-weight: 600;\n}\n\n.em-sidebar-more-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 16px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-size: 11px;\n  margin: 0 4px;\n  border-radius: 3px;\n}\n\n.em-sidebar-more-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-labels {\n  padding: 2px 0;\n}\n\n.em-sidebar-label-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 16px;\n  cursor: pointer;\n  border-radius: 3px;\n  margin: 0 4px;\n}\n\n.em-sidebar-label-item:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-label-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.em-sidebar-footer {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--em-border);\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n/* ===================== EMAIL LIST ===================== */\n.em-list {\n  width: 360px;\n  min-width: 300px;\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-list-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n  min-height: 28px;\n}\n\n.em-list-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-list-toolbar-left input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.em-list-toolbar-label {\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.em-list-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n.em-list-range {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  white-space: nowrap;\n}\n\n.em-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 4px;\n  background: #fff;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n.em-page-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n  color: var(--em-text-primary, #111);\n}\n\n.em-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.em-list-column-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n}\n\n.em-list-col-sort {\n  font-weight: 500;\n}\n\n.em-list-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.em-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--em-text-muted);\n  gap: 4px;\n}\n\n.em-list-empty h3 {\n  margin: 8px 0 0;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--em-text-secondary);\n}\n\n.em-list-empty p {\n  margin: 0;\n  font-size: 13px;\n}\n\n/* --- Mail Item --- */\n.em-mail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  cursor: pointer;\n  transition: none;\n}\n\n.em-mail-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-mail-active {\n  background: var(--em-active) !important;\n}\n\n.em-mail-unread {\n  background: var(--em-unread-bg);\n}\n\n.em-mail-unread .em-mail-sender {\n  font-weight: 700;\n}\n\n.em-mail-unread .em-mail-subject {\n  font-weight: 600;\n}\n\n.em-mail-chk {\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.em-mail-star {\n  flex-shrink: 0;\n  margin-top: 3px;\n  cursor: pointer;\n  line-height: 0;\n  min-width: 15px;\n}\n\n.em-mail-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.em-mail-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-mail-row1 {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  line-height: 1.3;\n}\n\n.em-mail-sender {\n  font-size: 13px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n.em-mail-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.em-mail-row2 {\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n  line-height: 1.3;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.em-mail-subject {\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n  max-width: 50%;\n}\n\n.em-mail-preview {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--em-text-muted);\n}\n\n.em-mail-flags {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.em-mail-attach-icon {\n  color: var(--em-text-secondary);\n}\n\n.em-mail-unread-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2563eb;\n  display: inline-block;\n}\n\n/* --- Skeleton --- */\n.em-mail-item-skeleton {\n  cursor: default;\n}\n\n.em-skeleton {\n  background: #e8e8e8;\n  border-radius: 3px;\n  animation: skeleton-pulse 1.2s ease-in-out infinite;\n}\n\n.em-skeleton-check {\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.em-skeleton-star {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n\n.em-skeleton-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.em-skeleton-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 2px 0;\n}\n\n.em-skeleton-line {\n  height: 12px;\n}\n\n.w-50 { width: 50%; }\n.w-80 { width: 80%; }\n\n@keyframes skeleton-pulse {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.em-loading-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n}\n\n.em-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--em-border);\n  border-top-color: var(--em-accent);\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ===================== VIEWER (Reading Pane) ===================== */\n.em-viewer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--em-reading-pane-bg);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-viewer-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-viewer-empty-content {\n  text-align: center;\n  color: var(--em-text-muted);\n}\n\n.em-viewer-empty-content h3 {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--em-text-secondary);\n  margin: 8px 0 4px;\n}\n\n.em-viewer-empty-content p {\n  margin: 0;\n  font-size: 12px;\n}\n\n/* --- Viewer Toolbar --- */\n.em-viewer-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n  flex-wrap: wrap;\n  min-height: 32px;\n}\n\n.em-vtb-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  font-family: inherit;\n  border-radius: 3px;\n  height: 26px;\n  transition: none;\n}\n\n.em-vtb-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-vtb-btn span {\n  font-size: 11px;\n}\n\n.em-vtb-divider {\n  width: 1px;\n  height: 20px;\n  background: var(--em-border);\n  margin: 0 2px;\n}\n\n.em-vtb-right {\n  margin-left: auto;\n}\n\n.em-vtb-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-vtb-close-btn:hover {\n  background: #e5e5e5;\n}\n\n/* --- Viewer Header --- */\n.em-viewer-header {\n  padding: 12px 16px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-viewer-subject-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.em-viewer-subject {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.em-viewer-thread-badge {\n  background: var(--em-bg-tertiary);\n  padding: 0 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-viewer-from-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.em-viewer-avatar-lg {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-viewer-from-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-viewer-from-name {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.em-viewer-from-addr {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-viewer-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n/* Reply / Reply All / Forward moved into the header (top-right, Outlook style) */\n.em-viewer-header-right {\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.em-viewer-header-actions {\n  display: flex;\n  gap: 6px;\n}\n.em-viewer-hdr-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0e527d;\n  background: #fff;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.em-viewer-hdr-btn:hover {\n  background: #eaf3f9;\n  border-color: #cfe3ef;\n}\n.em-viewer-hdr-btn svg { color: #0e527d; }\n\n/* --- Viewer Body --- */\n.em-viewer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.em-viewer-html-body {\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.em-viewer-html-body blockquote {\n  margin: 8px 0;\n  padding: 0 0 0 8px;\n  border-left: 2px solid #ccc;\n  color: #666;\n}\n\n.em-viewer-text-body {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* --- Attachments --- */\n.em-viewer-attachments {\n  border-top: 1px solid var(--em-border-light);\n  padding: 8px 16px;\n}\n\n.em-viewer-att-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.em-viewer-att-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.em-viewer-att-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  background: var(--em-bg-secondary);\n  min-width: 160px;\n}\n\n.em-viewer-att-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-viewer-att-name {\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-viewer-att-size {\n  font-size: 10px;\n  color: var(--em-text-muted);\n}\n\n.em-viewer-att-dl {\n  color: var(--em-accent);\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n/* --- Actions Bar --- */\n.em-viewer-actions-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 16px;\n  border-top: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-viewer-act-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text);\n  font-family: inherit;\n  border-radius: 3px;\n}\n\n.em-viewer-act-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-viewer-act-primary {\n  font-weight: 600;\n}\n\n/* ===================== COMPOSE ===================== */\n.em-compose-overlay {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 600px;\n  max-width: calc(100vw - 80px);\n  max-height: 90vh;\n  z-index: 1000;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.08);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.em-compose-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #005a9e;\n  color: #fff;\n  border-radius: 8px 8px 0 0;\n  cursor: move;\n  user-select: none;\n}\n\n.em-compose-header h3 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.em-compose-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.em-compose-header-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: rgba(255,255,255,0.8);\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.em-compose-header-btn:hover {\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n}\n\n.em-compose-body {\n  display: flex;\n  flex-direction: column;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.em-compose-field {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--em-border-light);\n  padding: 0 4px;\n}\n\n.em-compose-field-label {\n  width: 44px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n  padding: 6px 4px;\n}\n\n.em-compose-field-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 6px 4px;\n  color: var(--em-text);\n  background: transparent;\n}\n\n.em-compose-field-input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-compose-to-field {\n  position: relative;\n}\n\n.em-compose-candidate-list {\n  position: absolute;\n  top: 100%;\n  left: 44px;\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n  max-height: 180px;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.em-compose-candidate-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.em-compose-candidate-item:hover {\n  background: var(--em-active);\n}\n\n.em-compose-candidate-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--em-accent);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.em-compose-candidate-info {\n  flex: 1;\n}\n\n.em-compose-candidate-name {\n  font-size: 12px;\n  color: var(--em-text);\n}\n\n.em-compose-candidate-email {\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n.em-compose-tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 0;\n  flex: 1;\n}\n\n.em-compose-tag {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: #e8effa;\n  border-radius: 3px;\n  padding: 2px 6px;\n  font-size: 11px;\n  color: var(--em-accent);\n}\n\n.em-compose-tag-remove {\n  cursor: pointer;\n  opacity: 0.6;\n  display: flex;\n  align-items: center;\n}\n\n.em-compose-tag-remove:hover {\n  opacity: 1;\n}\n\n.em-compose-tag-input {\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 2px;\n  flex: 1;\n  min-width: 60px;\n  background: transparent;\n}\n\n.em-compose-cc-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 4px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-compose-toggle-cc {\n  font-size: 11px;\n  color: var(--em-accent);\n  cursor: pointer;\n  padding: 4px;\n  user-select: none;\n}\n\n.em-compose-toggle-cc:hover {\n  text-decoration: underline;\n}\n\n.em-compose-subject-field input {\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 6px 8px;\n  width: 100%;\n  color: var(--em-text);\n  background: transparent;\n}\n\n.em-compose-subject-field input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-compose-editor {\n  padding: 8px;\n  min-height: 180px;\n  flex: 1;\n}\n\n.em-compose-editor textarea {\n  width: 100%;\n  height: 100%;\n  min-height: 180px;\n  border: none;\n  outline: none;\n  resize: vertical;\n  font-family: \"Segoe UI\", sans-serif;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--em-text);\n}\n\n.em-compose-editor textarea::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-compose-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-top: 1px solid var(--em-border-light);\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-compose-tool-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-tool-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-tool-btn-active {\n  background: #cce4ff;\n  border-color: #a8cff5;\n}\n\n.em-compose-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-compose-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.em-compose-send-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 20px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.em-compose-send-btn:hover {\n  background: #004578;\n}\n\n.em-compose-send-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.em-compose-attach-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-attach-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-trash-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-trash-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n/* ===================== SEARCH OVERLAY ===================== */\n.em-search-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.08); /* light scrim — keep the page bright, don't darken it */\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  padding-top: 80px;\n}\n\n.em-search-panel {\n  width: 600px;\n  max-width: calc(100vw - 40px);\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  max-height: 400px;\n  overflow: hidden;\n}\n\n.em-search-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-search-header input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--em-text);\n}\n\n.em-search-header input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-search-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-search-close:hover {\n  background: #e5e5e5;\n}\n\n.em-search-results {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.em-search-result-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.em-search-result-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-search-result-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--em-accent);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.em-search-result-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-search-result-sender {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.em-search-result-subject {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-search-result-preview {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-search-result-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.em-search-empty {\n  padding: 24px;\n  text-align: center;\n  color: var(--em-text-muted);\n  font-size: 13px;\n}\n\n/* ===================== CONTEXT MENU ===================== */\n.em-context-menu {\n  position: fixed;\n  z-index: 2000;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  padding: 4px 0;\n  min-width: 160px;\n}\n\n.em-context-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text);\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n}\n\n.em-context-menu-item:hover {\n  background: var(--em-active);\n}\n\n.em-context-menu-divider {\n  height: 1px;\n  background: var(--em-border);\n  margin: 4px 0;\n}\n\n/* ===================== RESPONSIVE ===================== */\n@media (max-width: 768px) {\n  .em-module-body {\n    flex-direction: column;\n  }\n\n  .em-sidebar {\n    width: 100%;\n    min-width: unset;\n    max-height: 200px;\n    border-right: none;\n    border-bottom: 1px solid var(--em-border);\n  }\n\n  .em-list {\n    width: 100%;\n    min-width: unset;\n    border-right: none;\n    border-bottom: 1px solid var(--em-border);\n  }\n\n  .em-compose-overlay {\n    right: 0;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 0;\n  }\n\n  .em-ribbon-content {\n    flex-wrap: wrap;\n    min-height: 40px;\n  }\n\n  .em-ribbon-search {\n    min-width: 120px;\n  }\n}\n\n/* ===================== SCROLLBARS ===================== */\n.em-list-body::-webkit-scrollbar,\n.em-sidebar::-webkit-scrollbar,\n.em-viewer-body::-webkit-scrollbar,\n.em-compose-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.em-list-body::-webkit-scrollbar-track,\n.em-sidebar::-webkit-scrollbar-track,\n.em-viewer-body::-webkit-scrollbar-track,\n.em-compose-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.em-list-body::-webkit-scrollbar-thumb,\n.em-sidebar::-webkit-scrollbar-thumb,\n.em-viewer-body::-webkit-scrollbar-thumb,\n.em-compose-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.em-list-body::-webkit-scrollbar-thumb:hover,\n.em-sidebar::-webkit-scrollbar-thumb:hover,\n.em-viewer-body::-webkit-scrollbar-thumb:hover,\n.em-compose-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Firefox */\n.em-list-body,\n.em-sidebar,\n.em-viewer-body,\n.em-compose-body {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 transparent;\n}\n\n/* ===================== TOAST ===================== */\n.em-toast {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-size: 13px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  animation: em-toast-in 0.25s ease-out;\n  background: #323130;\n  color: #fff;\n}\n\n.em-toast-success {\n  background: #005a9e;\n  color: #fff;\n}\n\n.em-toast-error {\n  background: #d32f2f;\n  color: #fff;\n}\n\n.em-toast-warning {\n  background: #b26a00;\n  color: #fff;\n}\n\n.em-toast-info {\n  background: #323130;\n  color: #fff;\n}\n\n@keyframes em-toast-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ===================== SEARCH FILTERS ===================== */\n.em-search-filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-search-filter-btn:hover {\n  background: #e5e5e5;\n}\n\n.em-search-filters {\n  padding: 12px 16px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-search-filters-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.em-search-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.em-search-filter-field label {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-search-filter-field input {\n  padding: 4px 8px;\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  outline: none;\n  color: var(--em-text);\n  background: var(--em-bg);\n}\n\n.em-search-filter-field input:focus {\n  border-color: var(--em-accent);\n}\n\n.em-search-filter-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.em-search-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.em-search-toggle input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.em-search-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.em-search-apply-btn {\n  padding: 4px 16px;\n  background: var(--em-accent);\n  color: #fff;\n  border: 1px solid var(--em-accent-hover);\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.em-search-apply-btn:hover {\n  background: var(--em-accent-hover);\n}\n\n.em-search-clear-btn {\n  padding: 4px 16px;\n  background: transparent;\n  color: var(--em-text-secondary);\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.em-search-clear-btn:hover {\n  background: var(--em-bg-tertiary);\n}\n\n/* =====================================================================\n   RIBBON POLISH (alignment)\n   ===================================================================== */\n.em-ribbon-content {\n  min-height: 60px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n}\n\n.em-ribbon-content::-webkit-scrollbar {\n  height: 6px;\n}\n\n.em-ribbon-content::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.em-ribbon-quickbar-btn {\n  border: none;\n  background: transparent;\n  font-size: 11px;\n  padding: 0 4px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  font-family: inherit;\n  border-radius: 3px;\n}\n\n.em-ribbon-quickbar-btn:hover {\n  background: #e5e5e5;\n  color: var(--em-text);\n}\n\n.em-ribbon-search {\n  cursor: pointer;\n}\n\n.em-ribbon-search input {\n  cursor: pointer;\n}\n\n.em-ribbon-view-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--em-accent);\n  padding: 0 4px;\n}\n\n/* =====================================================================\n   OUTLOOK TOP BAR (Row 1: quick-access / title bar)\n   ===================================================================== */\n.em-topbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 8px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n}\n\n.em-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.em-topbar-logo {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  background: linear-gradient(135deg, #0364b8, #0a2767);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 4px;\n  flex-shrink: 0;\n}\n\n.em-topbar-icon {\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #444;\n}\n\n.em-topbar-icon:hover {\n  background: #e5e5e5;\n}\n\n.em-topbar-people {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  border: 1px solid var(--em-border);\n  background: #fff;\n  border-radius: 3px;\n  padding: 0 4px;\n  height: 24px;\n  margin-left: 6px;\n  color: var(--em-text-muted);\n}\n\n.em-topbar-people input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 12px;\n  font-family: inherit;\n  width: 96px;\n  color: var(--em-text);\n  cursor: pointer;\n}\n\n.em-topbar-search {\n  flex: 1;\n  max-width: 620px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 26px;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 0 10px;\n  color: var(--em-text-muted);\n  cursor: pointer;\n}\n\n.em-topbar-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13px;\n  font-family: inherit;\n  flex: 1;\n  color: var(--em-text);\n  cursor: pointer;\n}\n\n.em-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: auto;\n}\n\n.em-topbar-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #0a8577;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.em-topbar-win {\n  width: 32px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #444;\n}\n\n.em-topbar-win:hover {\n  background: #e5e5e5;\n}\n\n.em-topbar-win-close:hover {\n  background: #d13438;\n  color: #fff;\n}\n\n/* Ribbon: quick steps + small buttons + people search */\n.em-ribbon-new-btn .em-ribbon-btn-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.em-ribbon-btn-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  justify-content: center;\n}\n\n.em-ribbon-btn-sm {\n  min-width: 0;\n  flex-direction: row;\n  gap: 1px;\n  padding: 3px 5px;\n}\n\n.em-ribbon-group-quicksteps {\n  gap: 0;\n}\n\n.em-ribbon-step {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 11px;\n  color: var(--em-text);\n  max-width: 130px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.em-ribbon-step + .em-ribbon-step {\n  border-left: none;\n}\n\n.em-ribbon-step:hover {\n  background: #eaf2fb;\n  border-color: #a8cff5;\n}\n\n.em-ribbon-step span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-ribbon-search-people {\n  min-width: 130px;\n  height: 22px;\n}\n\n.em-ribbon-search-people input {\n  cursor: pointer;\n}\n\n.em-ribbon-group-last {\n  border-right: none;\n}\n\n@media (max-width: 1100px) {\n  .em-ribbon-group-quicksteps,\n  .em-ribbon-search-people {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .em-topbar-people {\n    display: none;\n  }\n  .em-topbar-search {\n    max-width: none;\n  }\n}\n\n/* =====================================================================\n   MODULE NAV RAIL (Outlook module switcher)\n   ===================================================================== */\n.em-nav-rail {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  background: transparent;\n  border: none;\n  flex-shrink: 0;\n}\n\n/* The visible bar wraps only the icons, so it can never stretch full-width. */\n.em-nav-rail-top,\n.em-nav-rail-bottom {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: auto;\n  background: #f0f2f5;\n  border-top: 1px solid var(--em-border);\n  border-right: 1px solid var(--em-border);\n  border-top-right-radius: 8px;\n  padding: 5px 14px;\n}\n\n.em-nav-rail-btn {\n  width: auto;\n  height: auto;\n  padding: 6px 9px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-family: inherit;\n  position: relative;\n}\n\n.em-nav-rail-btn:hover {\n  background: #e2e6ea;\n  color: var(--em-text);\n}\n\n.em-nav-rail-btn-active {\n  background: #dbe7ff;\n  color: var(--em-accent);\n}\n\n.em-nav-rail-btn-active::before {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: -5px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--em-accent);\n}\n\n.em-nav-rail-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.em-nav-rail-label {\n  display: none;\n}\n\n.em-nav-rail-badge {\n  position: absolute;\n  top: -6px;\n  right: -10px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  border-radius: 9px;\n  padding: 1px 4px;\n  min-width: 16px;\n  text-align: center;\n  line-height: 1.3;\n}\n\n/* =====================================================================\n   CALENDAR\n   ===================================================================== */\n.em-cal {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-cal-sidebar {\n  width: 240px;\n  min-width: 240px;\n  border-right: 1px solid var(--em-border);\n  background: var(--em-sidebar-bg);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding-bottom: 12px;\n}\n\n.em-cal-new-btn {\n  justify-content: center;\n}\n\n.em-cal-mini {\n  padding: 8px 12px;\n}\n\n.em-cal-mini-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--em-text);\n  margin-bottom: 6px;\n}\n\n.em-cal-mini-nav {\n  display: flex;\n  gap: 2px;\n}\n\n.em-cal-mini-nav button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-cal-mini-nav button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-mini-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1px;\n}\n\n.em-cal-mini-dow {\n  text-align: center;\n  font-size: 10px;\n  color: var(--em-text-muted);\n  padding: 2px 0;\n  font-weight: 600;\n}\n\n.em-cal-mini-day {\n  position: relative;\n  aspect-ratio: 1;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 11px;\n  color: var(--em-text);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n\n.em-cal-mini-day:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-mini-day-muted {\n  color: var(--em-text-muted);\n}\n\n.em-cal-mini-day-today {\n  background: var(--em-accent);\n  color: #fff;\n  font-weight: 600;\n}\n\n.em-cal-mini-day-today:hover {\n  background: var(--em-accent-hover);\n}\n\n.em-cal-mini-day-sel {\n  outline: 1px solid var(--em-accent);\n}\n\n.em-cal-mini-dot {\n  position: absolute;\n  bottom: 2px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.em-cal-upcoming {\n  padding: 4px 4px 0;\n}\n\n.em-cal-upcoming-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 6px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin: 0 4px;\n}\n\n.em-cal-upcoming-item:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-upcoming-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.em-cal-upcoming-info {\n  min-width: 0;\n}\n\n.em-cal-upcoming-title {\n  font-size: 12px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-cal-upcoming-time {\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n.em-cal-upcoming-empty {\n  padding: 8px 16px;\n  font-size: 12px;\n  color: var(--em-text-muted);\n}\n\n/* Calendar main */\n.em-cal-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-cal-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n}\n\n.em-cal-today-btn {\n  padding: 5px 14px;\n  border: 1px solid var(--em-border);\n  background: var(--em-bg);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text);\n  font-weight: 500;\n}\n\n.em-cal-today-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-nav {\n  display: flex;\n  gap: 2px;\n}\n\n.em-cal-nav button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-cal-nav button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--em-text);\n  flex: 1;\n}\n\n.em-cal-view-switch {\n  display: flex;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.em-cal-view-switch button {\n  border: none;\n  background: var(--em-bg);\n  padding: 5px 14px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text-secondary);\n  border-right: 1px solid var(--em-border);\n}\n\n.em-cal-view-switch button:last-child {\n  border-right: none;\n}\n\n.em-cal-view-switch button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-view-active {\n  background: var(--em-accent) !important;\n  color: #fff !important;\n}\n\n/* Month grid */\n.em-cal-month {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.em-cal-month-dow {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-cal-month-dow-cell {\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  text-align: right;\n  text-transform: uppercase;\n}\n\n.em-cal-month-grid {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-auto-rows: 1fr;\n  overflow-y: auto;\n}\n\n.em-cal-cell {\n  border-right: 1px solid var(--em-border-light);\n  border-bottom: 1px solid var(--em-border-light);\n  padding: 4px;\n  min-height: 92px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n}\n\n.em-cal-cell:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-cell-muted {\n  background: #fafafa;\n}\n\n.em-cal-cell-muted .em-cal-cell-date {\n  color: var(--em-text-muted);\n}\n\n.em-cal-cell-date {\n  font-size: 12px;\n  color: var(--em-text);\n  text-align: right;\n  padding: 2px 4px;\n}\n\n.em-cal-cell-month {\n  font-weight: 600;\n  color: var(--em-accent);\n}\n\n.em-cal-cell-today-num {\n  background: var(--em-accent);\n  color: #fff;\n  border-radius: 50%;\n  padding: 1px 6px;\n  font-weight: 600;\n}\n\n.em-cal-cell-events {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n}\n\n.em-cal-event-chip {\n  color: #fff;\n  font-size: 11px;\n  padding: 1px 6px;\n  border-radius: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.em-cal-event-time {\n  font-weight: 700;\n  opacity: 0.9;\n}\n\n.em-cal-event-more {\n  font-size: 10px;\n  color: var(--em-text-secondary);\n  padding-left: 4px;\n}\n\n/* Week view */\n.em-cal-week {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  overflow-y: auto;\n}\n\n.em-cal-week-col {\n  border-right: 1px solid var(--em-border-light);\n  display: flex;\n  flex-direction: column;\n}\n\n.em-cal-week-col-today {\n  background: #f5f9ff;\n}\n\n.em-cal-week-head {\n  text-align: center;\n  padding: 8px 4px;\n  border-bottom: 1px solid var(--em-border-light);\n  cursor: pointer;\n}\n\n.em-cal-week-head:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-week-dow {\n  display: block;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  text-transform: uppercase;\n}\n\n.em-cal-week-num {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.em-cal-week-body {\n  flex: 1;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 200px;\n  cursor: pointer;\n}\n\n.em-cal-week-event {\n  background: var(--em-bg-secondary);\n  border-left: 3px solid var(--em-accent);\n  border-radius: 3px;\n  padding: 4px 6px;\n  cursor: pointer;\n}\n\n.em-cal-week-event:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-week-event-time {\n  font-size: 10px;\n  color: var(--em-text-secondary);\n}\n\n.em-cal-week-event-title {\n  font-size: 12px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-cal-week-empty {\n  color: var(--em-text-muted);\n  font-size: 11px;\n  opacity: 0;\n}\n\n.em-cal-week-body:hover .em-cal-week-empty {\n  opacity: 1;\n}\n\n/* Day view */\n.em-cal-day {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 24px;\n}\n\n.em-cal-day-add {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--em-accent);\n  font-size: 13px;\n  cursor: pointer;\n  padding: 8px;\n  border: 1px dashed var(--em-border);\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.em-cal-day-add:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-day-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--em-text-muted);\n  padding: 48px;\n  gap: 8px;\n}\n\n.em-cal-day-event {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  align-items: stretch;\n}\n\n.em-cal-day-event:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-day-event-time {\n  width: 60px;\n  flex-shrink: 0;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n}\n\n.em-cal-day-event-end {\n  color: var(--em-text-muted);\n  font-size: 11px;\n}\n\n.em-cal-day-event-bar {\n  width: 4px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.em-cal-day-event-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--em-text);\n}\n\n.em-cal-day-event-loc,\n.em-cal-day-event-desc {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n/* Event / contact modal */\n.em-cal-modal {\n  width: 460px;\n  max-width: calc(100vw - 40px);\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  align-self: flex-start;\n}\n\n.em-cal-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #005a9e;\n  color: #fff;\n}\n\n.em-cal-modal-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.em-cal-modal-header .em-search-close {\n  color: rgba(255,255,255,0.85);\n}\n\n.em-cal-modal-header .em-search-close:hover {\n  background: rgba(255,255,255,0.15);\n}\n\n.em-cal-modal-body {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.em-cal-modal-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--em-text-secondary);\n  border-bottom: 1px solid var(--em-border-light);\n  padding-bottom: 8px;\n}\n\n.em-cal-modal-field-top {\n  align-items: flex-start;\n}\n\n.em-cal-modal-field input,\n.em-cal-modal-field textarea {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--em-text);\n  background: transparent;\n  flex: 1;\n  min-width: 0;\n}\n\n.em-cal-modal-field input[type=\"date\"],\n.em-cal-modal-field input[type=\"time\"] {\n  flex: 0 0 auto;\n}\n\n.em-cal-modal-field textarea {\n  resize: vertical;\n}\n\n.em-cal-modal-dash {\n  color: var(--em-text-muted);\n}\n\n.em-cal-modal-allday {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  padding-left: 26px;\n}\n\n.em-cal-modal-colors {\n  display: flex;\n  gap: 6px;\n}\n\n.em-cal-color-swatch {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.em-cal-color-swatch-active {\n  border-color: #1a1a1a;\n  outline: 1px solid #fff;\n  outline-offset: -3px;\n}\n\n.em-cal-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-modal-footer-right {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.em-cal-modal-delete {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #dc2626;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  border-radius: 3px;\n  padding: 4px 10px;\n}\n\n.em-cal-modal-delete:hover {\n  background: #fdecec;\n}\n\n/* =====================================================================\n   PEOPLE / CONTACTS\n   ===================================================================== */\n.em-people {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-people-list {\n  width: 320px;\n  min-width: 280px;\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  background: var(--em-bg);\n}\n\n.em-people-toolbar {\n  padding: 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.em-people-new {\n  margin: 0;\n  justify-content: center;\n}\n\n.em-people-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 5px 8px;\n  color: var(--em-text-muted);\n}\n\n.em-people-search input {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  flex: 1;\n  background: transparent;\n  color: var(--em-text);\n}\n\n.em-people-scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.em-people-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-people-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-people-item-active {\n  background: var(--em-active) !important;\n}\n\n.em-people-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-people-item-info {\n  min-width: 0;\n}\n\n.em-people-item-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-people-item-email {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-people-empty,\n.em-tasks-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 48px 24px;\n  color: var(--em-text-muted);\n  text-align: center;\n}\n\n.em-people-empty p,\n.em-tasks-empty p {\n  margin: 8px 0 0;\n  font-size: 15px;\n  color: var(--em-text-secondary);\n}\n\n.em-people-empty span,\n.em-tasks-empty span {\n  font-size: 12px;\n}\n\n.em-people-detail {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  background: var(--em-bg-secondary);\n}\n\n.em-people-detail-empty {\n  color: var(--em-text-muted);\n}\n\n.em-people-card {\n  align-self: flex-start;\n  width: 100%;\n  max-width: 560px;\n  margin: 32px auto;\n  background: #fff;\n  border: 1px solid var(--em-border-light);\n  border-radius: 8px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\n.em-people-card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 24px;\n  background: linear-gradient(180deg, #eaf1fb, #fff);\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-people-card-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-people-card-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.em-people-card-title {\n  font-size: 13px;\n  color: var(--em-text-secondary);\n}\n\n.em-people-card-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 4px;\n}\n\n.em-people-card-actions button,\n.em-people-card-actions a {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--em-border);\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.em-people-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 100%;\n  padding: 48px 24px;\n  color: var(--em-text-muted);\n  text-align: center;\n}\n.em-people-empty-state p { margin: 8px 0 0; font-size: 15px; color: var(--em-text-secondary); }\n.em-people-empty-state span { font-size: 12px; max-width: 320px; }\n\n.em-muted { color: var(--em-text-muted); font-size: 12px; }\n\n.em-people-card-actions button:hover,\n.em-people-card-actions a:hover {\n  background: var(--em-hover);\n}\n\n.em-people-card-body {\n  padding: 16px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.em-people-card-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: var(--em-text);\n}\n\n.em-people-card-row svg {\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n}\n\n.em-people-card-row a,\n.em-people-link-btn {\n  color: var(--em-accent);\n  text-decoration: none;\n}\n\n.em-people-card-row a:hover,\n.em-people-link-btn:hover {\n  text-decoration: underline;\n}\n\n.em-people-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n/* =====================================================================\n   TASKS / TO DO\n   ===================================================================== */\n.em-tasks {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-tasks-sidebar {\n  width: 220px;\n  min-width: 200px;\n  border-right: 1px solid var(--em-border);\n  background: var(--em-sidebar-bg);\n  padding-bottom: 8px;\n  overflow-y: auto;\n}\n\n.em-tasks-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: linear-gradient(180deg, #eef3fb, #fff 220px);\n}\n\n.em-tasks-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 20px 24px 12px;\n  color: var(--em-accent);\n}\n\n.em-tasks-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--em-text);\n}\n\n.em-tasks-add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 24px 12px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  color: var(--em-text-secondary);\n}\n\n.em-tasks-add > input:first-of-type {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: inherit;\n  background: transparent;\n  color: var(--em-text);\n}\n\n.em-tasks-add-due {\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 4px 6px;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text-secondary);\n  outline: none;\n}\n\n.em-tasks-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 24px 24px;\n}\n\n.em-tasks-done-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  margin: 16px 0 8px;\n}\n\n.em-task-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid var(--em-border-light);\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 6px;\n}\n\n.em-task-row:hover {\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n}\n\n.em-task-check {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-accent);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.em-task-row-done .em-task-check {\n  color: #059669;\n}\n\n.em-task-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-task-title {\n  font-size: 14px;\n  color: var(--em-text);\n}\n\n.em-task-row-done .em-task-title {\n  text-decoration: line-through;\n  color: var(--em-text-muted);\n}\n\n.em-task-due {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.em-task-star,\n.em-task-delete {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-muted);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 3px;\n  padding: 4px;\n}\n\n.em-task-star:hover,\n.em-task-delete:hover {\n  background: var(--em-hover);\n}\n\n.em-task-star-on {\n  color: #f59e0b;\n}\n\n.em-task-delete:hover {\n  color: #dc2626;\n}\n\n/* =====================================================================\n   MAILBOX ACCOUNT SETTINGS MODAL\n   ===================================================================== */\n.em-acct-modal {\n  width: 560px;\n  max-width: calc(100vw - 40px);\n  align-self: flex-start;\n}\n\n.em-acct-body {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.em-acct-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #eef4ff;\n  border: 1px solid #d3e2ff;\n  color: #274b8f;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.em-acct-hint svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.em-acct-section-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--em-text-secondary);\n  margin-top: 4px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-acct-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.em-acct-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.em-acct-col2 {\n  grid-column: 1 / -1;\n}\n\n.em-acct-field > span {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  font-weight: 500;\n}\n\n.em-acct-field input:not([type=\"checkbox\"]) {\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--em-text);\n  outline: none;\n  background: var(--em-bg);\n}\n\n.em-acct-field input:not([type=\"checkbox\"]):focus {\n  border-color: var(--em-accent);\n}\n\n.em-acct-password-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.em-acct-password-wrap input {\n  width: 100%;\n  padding-right: 32px !important;\n}\n\n.em-acct-password-toggle {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.em-acct-password-toggle:hover {\n  color: var(--em-text);\n  background: var(--em-hover);\n}\n\n.em-acct-check {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  grid-column: 1 / -1;\n}\n\n.em-acct-check span {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n/* Calendar/People/Tasks responsive */\n@media (max-width: 900px) {\n  .em-cal-sidebar,\n  .em-tasks-sidebar {\n    display: none;\n  }\n  .em-people-list {\n    width: 100%;\n  }\n  .em-people-detail {\n    display: none;\n  }\n}\n\n\n/* ── Resume attachment actions (Add to Job / Database) ── */\n.em-att-actions { position: relative; display: inline-flex; }\n.em-att-action-btn {\n  display: inline-flex; align-items: center; gap: 4px;\n  padding: 4px 8px; font-size: 12px; font-weight: 600;\n  color: #0e527d; background: #eaf3f9; border: 1px solid #cfe3ef;\n  border-radius: 5px; cursor: pointer; white-space: nowrap;\n}\n.em-att-action-btn:hover:not(:disabled) { background: #dcecf6; }\n.em-att-action-btn:disabled { opacity: 0.6; cursor: default; }\n.em-att-menu {\n  /* position/top/left are set inline (fixed) so the menu is never clipped by\n     the reading-pane overflow. */\n  z-index: 2000;\n  min-width: 220px; background: #fff; border: 1px solid #e0e0e0;\n  border-radius: 6px; box-shadow: 0 6px 20px rgba(0,0,0,0.18); padding: 4px;\n}\n.em-att-menu-item {\n  display: flex; align-items: center; gap: 8px; width: 100%;\n  padding: 8px 10px; font-size: 13px; color: #222; background: none;\n  border: none; border-radius: 4px; cursor: pointer; text-align: left;\n}\n.em-att-menu-item:hover { background: #f2f6f9; color: #0e527d; }\n.em-spin { animation: em-spin 0.8s linear infinite; }\n@keyframes em-spin { to { transform: rotate(360deg); } }\n\n.em-jobpick-overlay {\n  position: fixed; inset: 0; background: rgba(0,0,0,0.35);\n  display: flex; align-items: center; justify-content: center; z-index: 10000;\n}\n.em-jobpick {\n  width: 460px; max-width: 92vw; max-height: 80vh; display: flex; flex-direction: column;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25); overflow: hidden;\n}\n.em-jobpick-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 14px 16px; font-size: 14px; font-weight: 700; color: #fff; background: #0e527d;\n}\n.em-jobpick-x { background: none; border: none; color: #fff; cursor: pointer; display: flex; }\n.em-jobpick-company { display: flex; align-items: center; gap: 10px; padding: 12px 16px 6px; }\n.em-jobpick-company label { font-size: 12px; font-weight: 600; color: #555; min-width: 62px; }\n.em-jobpick-company select { flex: 1; padding: 7px 10px; font-size: 13px; border: 1px solid #dcdcdc; border-radius: 6px; background: #fff; outline: none; }\n.em-jobpick-dbnote { padding: 8px 16px 4px; font-size: 12.5px; color: #666; }\n.em-jobpick-search { display: flex; align-items: center; gap: 8px; padding: 10px 16px; border-bottom: 1px solid #eee; color: #888; }\n.em-jobpick-search input { flex: 1; border: 1px solid #dcdcdc; border-radius: 6px; padding: 7px 10px; font-size: 13px; outline: none; }\n.em-jobpick-searchbtn { padding: 7px 12px; font-size: 12px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }\n.em-jobpick-list { flex: 1; overflow-y: auto; padding: 6px 8px; min-height: 160px; }\n.em-jobpick-empty { padding: 30px 12px; text-align: center; color: #999; font-size: 13px; }\n.em-jobpick-item { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 6px; cursor: pointer; font-size: 13px; }\n.em-jobpick-item:hover { background: #f2f6f9; }\n.em-jobpick-item-sel { background: #eaf3f9; }\n.em-jobpick-item-txt { flex: 1; }\n.em-jobpick-pager { display: flex; align-items: center; justify-content: center; gap: 14px; padding: 8px 16px; border-top: 1px solid #eee; font-size: 12px; color: #666; }\n.em-jobpick-pager button { display: inline-flex; align-items: center; gap: 3px; padding: 5px 10px; font-size: 12px; background: #fff; border: 1px solid #dcdcdc; border-radius: 5px; cursor: pointer; }\n.em-jobpick-pager button:disabled { opacity: 0.45; cursor: not-allowed; }\n.em-jobpick-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 16px; border-top: 1px solid #eee; }\n.em-jobpick-cancel { padding: 8px 16px; font-size: 13px; background: #f2f2f2; border: 1px solid #ddd; border-radius: 6px; cursor: pointer; }\n.em-jobpick-add { padding: 8px 18px; font-size: 13px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }\n.em-jobpick-add:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* Attachment destination modal: keep long filenames readable without crowding\n   the title or close control. */\n.em-jobpick {\n  width: min(560px, calc(100vw - 32px));\n  max-height: min(80vh, 620px);\n}\n\n.em-jobpick-head {\n  gap: 16px;\n  padding: 16px 18px;\n}\n\n.em-jobpick-title {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.em-jobpick-title-main {\n  font-size: 15px;\n  line-height: 1.25;\n}\n\n.em-jobpick-title-file {\n  min-width: 0;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-jobpick-x {\n  flex: 0 0 auto;\n  padding: 6px;\n  border-radius: 6px;\n}\n\n.em-jobpick-company {\n  gap: 12px;\n  padding: 18px 18px 8px;\n}\n\n.em-jobpick-company label {\n  flex: 0 0 64px;\n  min-width: 0;\n  color: #334155;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.em-jobpick-company select {\n  min-width: 0;\n  min-height: 38px;\n  border-color: #cbd5e1;\n  color: #1e293b;\n}\n\n.em-jobpick-dbnote {\n  margin: 8px 18px 14px;\n  padding: 12px 14px;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  background: #f8fbff;\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.em-jobpick-foot {\n  gap: 8px;\n  padding: 14px 18px;\n  background: #f8fafc;\n}\n\n.em-jobpick-cancel,\n.em-jobpick-add {\n  min-height: 38px;\n  padding: 8px 16px;\n}\n\n@media (max-width: 520px) {\n  .em-jobpick-company {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .em-jobpick-company select {\n    width: 100%;\n  }\n}\n\n/* ── Calendar sync loader ── */\n.em-cal-syncing {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #0e527d;\n  background: #eaf3f9;\n  border: 1px solid #cfe3ef;\n  border-radius: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n.em-cal { position: relative; }\n\n.em-viewer-hdr-icon { padding: 6px 8px; }\n\n/* ── Attachment click-to-preview ── */\n.em-viewer-att-clickable {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n.em-viewer-att-preview { cursor: pointer; }\n.em-viewer-att-preview:hover .em-viewer-att-name { color: #0e527d; text-decoration: underline; }\n.em-viewer-att-eye {\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 26px; height: 26px; padding: 0; margin-right: 4px;\n  border: 1px solid var(--em-border, #e0e0e0); border-radius: 4px;\n  background: #fff; color: #0e527d; cursor: pointer;\n}\n.em-viewer-att-eye:hover { background: #eaf3f9; }\n\n.em-att-preview-overlay {\n  position: fixed; inset: 0; background: rgba(0,0,0,0.55);\n  display: flex; align-items: center; justify-content: center; z-index: 2000;\n}\n.em-att-preview {\n  width: 860px; max-width: 94vw; height: 88vh; max-height: 92vh;\n  background: #fff; border-radius: 10px; overflow: hidden;\n  display: flex; flex-direction: column; box-shadow: 0 16px 50px rgba(0,0,0,0.35);\n}\n.em-att-preview-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 10px 14px; background: #0e527d; color: #fff; flex-shrink: 0;\n}\n.em-att-preview-title {\n  display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600;\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.em-att-preview-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }\n.em-att-preview-btn {\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 30px; height: 30px; border: none; border-radius: 5px;\n  background: rgba(255,255,255,0.15); color: #fff; cursor: pointer;\n}\n.em-att-preview-btn:hover { background: rgba(255,255,255,0.28); }\n.em-att-preview-body { flex: 1; background: #f4f6f8; overflow: auto; display: flex; }\n.em-att-preview-frame { width: 100%; height: 100%; border: none; }\n.em-att-preview-img { max-width: 100%; max-height: 100%; margin: auto; object-fit: contain; }\n.em-att-preview-none {\n  margin: auto; text-align: center; color: #6b7280; display: flex;\n  flex-direction: column; align-items: center; gap: 10px; padding: 30px;\n}\n.em-att-preview-dl {\n  padding: 8px 16px; background: #0e527d; color: #fff; border-radius: 6px;\n  text-decoration: none; font-size: 13px; font-weight: 600;\n}\n\n/* ── Sidebar module switcher (Mail / Calendar / People / To Do) ── */\n.em-sidebar-modules {\n  gap: 6px;\n  padding: 8px 12px;\n  cursor: default;\n  justify-content: flex-start;\n}\n.em-sidebar-module-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  color: var(--em-text-secondary, #555);\n  cursor: pointer;\n}\n.em-sidebar-module-btn:hover { background: #e6ebf1; color: #0e527d; }\n.em-sidebar-module-active { background: #dcecf6; color: #0e527d; }\n.em-sidebar-module-icon { position: relative; display: inline-flex; }\n.em-sidebar-module-badge {\n  position: absolute;\n  top: -7px;\n  right: -9px;\n  min-width: 15px;\n  height: 15px;\n  padding: 0 3px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 15px;\n  text-align: center;\n  color: #fff;\n  background: #d13438;\n  border-radius: 8px;\n}\n\n/* ── Mail view: folder bar on top, list + reading pane below ── */\n.em-mailview {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n.em-mailview-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.em-folderbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 7px 16px;\n  background: #fafafa;\n  border-bottom: 1px solid var(--em-border);\n  flex-shrink: 0;\n}\n.em-folderbar-newmail {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.em-folderbar-newmail:hover { background: #00437a; }\n\n.em-folderbar-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n.em-folderbar-tabs::-webkit-scrollbar { height: 4px; }\n.em-folderbar-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--em-text-secondary, #555);\n  white-space: nowrap;\n}\n.em-folderbar-tab:hover { background: #ececec; color: var(--em-text, #222); }\n.em-folderbar-tab-active {\n  background: #dcecf6;\n  color: #0e527d;\n  font-weight: 600;\n}\n.em-folderbar-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n  background: #e2e6ea;\n  border-radius: 9px;\n  padding: 0 6px;\n  min-width: 16px;\n  text-align: center;\n}\n.em-folderbar-count-primary { background: #005a9e; color: #fff; }\n\n.em-folderbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.em-folderbar-account {\n  max-width: 200px;\n  padding: 5px 8px;\n  font-size: 12px;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 5px;\n  background: #fff;\n  color: #333;\n  margin-right: 4px;\n}\n.em-folderbar-ibtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  color: var(--em-text-secondary, #555);\n  cursor: pointer;\n}\n.em-folderbar-ibtn:hover { background: #ececec; color: #0e527d; }\n\n/* ── Mailbox settings: centered footer + logout ── */\n.em-cal-modal-footer-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n.em-acct-logout-row {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--em-border-light, #ebebeb);\n  display: flex;\n  justify-content: center;\n}\n.em-acct-logout-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #b42318;\n  background: #fff;\n  border: 1px solid #f0c6c0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.em-acct-logout-btn:hover:not(:disabled) { background: #fdecea; }\n.em-acct-logout-btn:disabled { opacity: 0.6; cursor: default; }\n\n/* ── In-app confirm modal (logout) ── */\n.em-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n}\n.em-confirm-modal {\n  width: 360px;\n  max-width: 90%;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.28);\n  overflow: hidden;\n}\n.em-confirm-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 18px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #b42318;\n  border-bottom: 1px solid #f0e0de;\n}\n.em-confirm-body {\n  padding: 16px 18px;\n  font-size: 13px;\n  color: #444;\n  line-height: 1.6;\n}\n.em-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px 18px 16px;\n}\n.em-confirm-danger {\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: #d13438;\n  border: 1px solid #b42318;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.em-confirm-danger:hover:not(:disabled) { background: #b42318; }\n.em-confirm-danger:disabled { opacity: 0.6; cursor: default; }\n\n/* ===================== OUTLOOK-STYLE MESSAGE LIST ===================== */\n.em-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--em-border);\n  flex-shrink: 0;\n  background: #fff;\n}\n.em-list-filters { display: flex; gap: 16px; }\n.em-list-filter {\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: var(--em-text-secondary, #666);\n  cursor: pointer;\n  padding: 2px 0;\n  position: relative;\n  font-family: inherit;\n}\n.em-list-filter-active { color: #0f6cbd; font-weight: 600; }\n.em-list-filter-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0; right: 0; bottom: -8px;\n  height: 2px;\n  background: #0f6cbd;\n}\n.em-list-sort {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.5px;\n  color: var(--em-text-secondary, #666);\n  cursor: pointer;\n}\n.em-list-loading { font-size: 12px; color: #888; padding: 4px; }\n\n.em-mail-group {\n  padding: 6px 14px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f6cbd;\n  background: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* Message row — no avatar, three lines (sender/time, subject, preview). */\n.em-mail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 14px 8px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #f2f2f2;\n  position: relative;\n  background: #fff;\n}\n.em-mail-item:hover { background: #f5f8fb; }\n.em-mail-active, .em-mail-active:hover { background: #eaf2fb; }\n.em-mail-unread::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 6px; bottom: 6px;\n  width: 3px;\n  border-radius: 2px;\n  background: #0f6cbd;\n}\n.em-mail-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.em-mail-row1 { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }\n.em-mail-sender {\n  font-size: 13.5px;\n  color: #1a1a1a;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-unread .em-mail-sender { font-weight: 700; }\n.em-mail-date { font-size: 12px; color: #888; white-space: nowrap; flex-shrink: 0; }\n.em-mail-unread .em-mail-date { color: #0f6cbd; font-weight: 600; }\n.em-mail-subject-line {\n  font-size: 13px;\n  color: #444;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-unread .em-mail-subject-line { color: #0f6cbd; font-weight: 600; }\n.em-mail-preview-line {\n  font-size: 12.5px;\n  color: #888;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-side {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n.em-mail-star { display: inline-flex; cursor: pointer; opacity: 0.4; transition: opacity 0.1s; }\n.em-mail-item:hover .em-mail-star { opacity: 1; }\n.em-mail-attach-icon { color: #888; }\n\n.em-list-pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 6px 14px;\n  border-top: 1px solid var(--em-border);\n  font-size: 12px;\n  color: #666;\n  flex-shrink: 0;\n  background: #fff;\n}\n.em-list-nounread { padding: 24px; text-align: center; color: #999; font-size: 13px; }\n\n/* ===================== BOTTOM STATUS BAR ===================== */\n.em-statusbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--em-border);\n  background: #f3f3f3;\n  padding: 0 16px 0 0;\n  flex-shrink: 0;\n  min-height: 30px;\n}\n.em-statusbar .em-nav-rail { width: auto; }\n.em-statusbar .em-nav-rail-top {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 3px 8px;\n}\n.em-statusbar-info {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  font-size: 12px;\n  color: #555;\n  white-space: nowrap;\n}\n.em-statusbar-conn { color: #107c10; }\n\n/* ===================== OUTLOOK-MATCH FOLDER PANE ===================== */\n.em-sidebar { background: #faf9f8; }\n.em-sidebar-section-title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 10px 3px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.em-sidebar-section-chevron { color: #888; flex-shrink: 0; }\n.em-sidebar-account-title { color: #201f1e; }\n.em-sidebar-account-title span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.em-sidebar-folder {\n  padding: 4px 10px 4px 24px;\n  margin: 0;\n  border-radius: 0;\n  min-height: 26px;\n  font-size: 13px;\n  color: #201f1e;\n}\n.em-sidebar-folder:hover { background: #f0eeed; }\n.em-sidebar-folder-active { background: #dcecf6 !important; box-shadow: inset 3px 0 0 #0f6cbd; }\n.em-sidebar-folder-label { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-sidebar-folder-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #605e5c;\n  background: transparent;\n  padding: 0;\n}\n.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 600; }\n.em-sidebar-more-btn { padding-left: 24px; }\n\n/* Action buttons row — subtler, Outlook-ish */\n.em-sidebar-search-btn { color: #444; }\n.em-sidebar-search-btn:hover { background: #f0eeed; }\n\n/* Message list selected-row: Outlook look */\n.em-mail-active, .em-mail-active:hover { background: #eaf1fb; box-shadow: inset 2px 0 0 #0f6cbd; }\n\n/* Date group header: subtle Outlook style */\n.em-mail-group {\n  background: #faf9f8;\n  color: #444;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* ===================== OUTLOOK READING PANE ===================== */\n.em-viewer { background: #fff; }\n.em-viewer-header {\n  background: #fff;\n  padding: 14px 20px 10px;\n  border-bottom: 1px solid #edebe9;\n}\n.em-viewer-subject {\n  font-size: 18px;\n  font-weight: 600;\n  color: #242424;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n.em-viewer-from-name { font-weight: 600; color: #242424; }\n.em-viewer-from-addr { color: #605e5c; }\n\n.em-viewer-webbanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 20px;\n  font-size: 12px;\n  color: #605e5c;\n  background: #fff;\n  border-bottom: 1px solid #edebe9;\n}\n.em-viewer-webbanner svg { color: #0f6cbd; flex-shrink: 0; }\n.em-viewer-weblink {\n  background: none;\n  border: none;\n  color: #0f6cbd;\n  cursor: pointer;\n  padding: 0;\n  font-size: 12px;\n  font-family: inherit;\n}\n.em-viewer-weblink:hover { text-decoration: underline; }\n\n.em-viewer-body {\n  background: #fff;            /* no grey backdrop / white card */\n  padding: 0;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  background: transparent;    /* no card — plain white reading area */\n  max-width: 900px;\n  margin: 0;                  /* left-aligned, not centered */\n  padding: 0;\n  border-radius: 0;\n  overflow: visible;\n  box-shadow: none;\n}\n\n/* Message content: left-aligned with comfortable padding (Gmail-style). */\n.em-viewer-html-body {\n  background: transparent;\n  padding: 18px 26px;\n  text-align: left;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 14px;\n  color: #242424;\n  line-height: 1.5;\n  overflow-x: auto;           /* never let a wide fixed-width template break the layout */\n}\n/* Normalize legacy / arbitrary templates so nothing overflows and images scale. */\n.em-viewer-html-body img { max-width: 100%; height: auto; }\n.em-viewer-html-body table { max-width: 100%; border-collapse: collapse; }\n/* Left-align top-level content instead of centering it. */\n.em-viewer-html-body > table,\n.em-viewer-html-body > div,\n.em-viewer-html-body > center > table { margin-left: 0 !important; margin-right: auto !important; }\n.em-viewer-html-body a { color: #0f6cbd; }\n\n/* Plain-text emails keep readable padding (no template to bleed). */\n.em-viewer-text-body {\n  background: transparent;\n  margin: 0;\n  padding: 24px 28px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 13.5px;\n  color: #242424;\n  line-height: 1.5;\n}\n\n/* ===================== RIBBON / SIDEBAR TWEAKS (tabbed ribbon) ===================== */\n.em-ribbon-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n  background: transparent;\n  border-color: transparent;\n}\n.em-ribbon-btn:disabled:hover { background: transparent; border-color: transparent; }\n.em-ribbon-content { flex-wrap: wrap; }\n\n/* Clickable collapsible section headers in the folder pane */\n.em-sidebar-section-title-toggle { cursor: pointer; border-radius: 3px; }\n.em-sidebar-section-title-toggle:hover { background: #f0eeed; }\n.em-sidebar-section-title-toggle .em-sidebar-section-chevron { transition: transform 0.15s; }\n\n/* ===================== CLEAN & BEAUTIFUL SIDEBAR (polish) ===================== */\n.em-sidebar {\n  width: 214px;\n  min-width: 214px;\n  background: #fbfbfa;\n  border-right: 1px solid #ececec;\n  padding: 4px 4px 12px;\n}\n\n/* New mail button */\n.em-sidebar-newmail {\n  margin: 6px 6px 10px;\n  padding: 9px 14px;\n  background: #0f6cbd;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  gap: 9px;\n  box-shadow: 0 1px 2px rgba(15, 108, 189, 0.25);\n  transition: background 0.12s;\n}\n.em-sidebar-newmail:hover { background: #0c5aa0; }\n.em-sidebar-newmail:active { background: #0a4e8c; }\n\n/* Action rows: Sync / Settings / Add mailbox */\n.em-sidebar-search-btn {\n  margin: 1px 6px;\n  padding: 7px 10px;\n  min-height: 32px;\n  gap: 11px;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #3b3a39;\n}\n.em-sidebar-search-btn svg { color: #605e5c; }\n.em-sidebar-search-btn:hover { background: #f0efee; }\n\n/* Sections */\n.em-sidebar-section {\n  padding: 2px 0 6px;\n  margin-top: 6px;\n  border-top: 1px solid #ededed;\n}\n.em-sidebar-section-title {\n  padding: 9px 12px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #605e5c;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.em-sidebar-section-title-toggle { margin: 0 6px; padding-left: 6px; border-radius: 6px; }\n.em-sidebar-section-title-toggle:hover { background: #f0efee; }\n.em-sidebar-account-title span { color: #201f1e; font-weight: 600; }\n\n/* Folder rows — soft rounded pills */\n.em-sidebar-folder {\n  margin: 1px 6px;\n  padding: 7px 10px;\n  min-height: 32px;\n  gap: 11px;\n  border-radius: 6px;\n  font-size: 13.5px;\n  color: #201f1e;\n  box-shadow: none;\n  transition: background 0.1s, color 0.1s;\n}\n.em-sidebar-folder:hover { background: #f0efee; }\n.em-sidebar-folder-active,\n.em-sidebar-folder-active:hover {\n  background: #eaf1fb !important;\n  box-shadow: none;\n  color: #0f6cbd;\n  font-weight: 600;\n}\n.em-sidebar-folder-icon { color: #605e5c; display: inline-flex; align-items: center; }\n.em-sidebar-folder-active .em-sidebar-folder-icon { color: #0f6cbd; }\n.em-sidebar-folder-count { margin-left: auto; font-size: 12px; color: #797775; font-weight: 500; }\n.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 700; }\n\n/* More */\n.em-sidebar-more-btn {\n  margin: 2px 6px 0;\n  padding: 6px 10px 6px 34px;\n  border-radius: 6px;\n  font-size: 12.5px;\n  color: #605e5c;\n  gap: 6px;\n}\n.em-sidebar-more-btn:hover { background: #f0efee; }\n\n/* ===================== GROUPED OUTLOOK RIBBON ===================== */\n.em-rb-content {\n  display: flex;\n  align-items: stretch;\n  padding: 4px 4px 2px;\n  background: #fff;\n  overflow-x: auto;\n  min-height: 90px;\n  border-bottom: 1px solid var(--em-ribbon-border, #e1dfdd);\n}\n.em-rb-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-right: 1px solid #e8e6e4;\n  padding: 2px 6px 0;\n  flex-shrink: 0;\n}\n.em-rb-group:last-child { border-right: none; }\n.em-rb-buttons { display: flex; align-items: stretch; gap: 1px; flex: 1; }\n.em-rb-group-label {\n  font-size: 10px;\n  color: #8a8886;\n  text-align: center;\n  padding: 3px 0 3px;\n  white-space: nowrap;\n}\n.em-rb-big {\n  display: flex; flex-direction: column; align-items: center; justify-content: flex-start;\n  gap: 3px;\n  min-width: 44px; max-width: 68px;\n  padding: 4px 5px;\n  background: transparent; border: 1px solid transparent; border-radius: 3px;\n  cursor: pointer; color: #201f1e; font-family: inherit;\n}\n.em-rb-big:hover { background: #eef4fb; border-color: #d6e4f5; }\n.em-rb-big:disabled { opacity: 0.4; cursor: default; }\n.em-rb-big:disabled:hover { background: transparent; border-color: transparent; }\n.em-rb-big-label { font-size: 10.5px; line-height: 1.15; text-align: center; }\n.em-rb-stack { display: flex; flex-direction: column; justify-content: center; gap: 1px; padding: 0 2px; }\n.em-rb-small {\n  display: flex; align-items: center; gap: 5px;\n  padding: 2px 6px 2px 4px; border-radius: 3px;\n  background: transparent; border: 1px solid transparent; cursor: pointer;\n  color: #201f1e; font-family: inherit; font-size: 11px; white-space: nowrap;\n}\n.em-rb-small:hover { background: #eef4fb; border-color: #d6e4f5; }\n.em-rb-small span { flex: 1; text-align: left; }\n.em-rb-small:disabled { opacity: 0.4; cursor: default; }\n.em-rb-people {\n  display: flex; align-items: center; gap: 4px;\n  border: 1px solid #d0d0d0; border-radius: 3px; padding: 1px 6px; background: #fff; margin-bottom: 2px;\n}\n.em-rb-people input { border: none; outline: none; font-size: 11px; width: 96px; background: transparent; }\n\n/* ===================== NEW-MAIL DESKTOP TOAST ===================== */\n.em-nmt {\n  position: fixed; right: 18px; bottom: 44px; z-index: 4000;\n  width: 344px; background: #fff; border: 1px solid #e1dfdd; border-radius: 8px;\n  box-shadow: 0 8px 28px rgba(0,0,0,0.22); overflow: hidden;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  animation: em-nmt-in 0.25s ease;\n}\n@keyframes em-nmt-in { from { transform: translateY(14px); opacity: 0; } to { transform: none; opacity: 1; } }\n.em-nmt-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; border-bottom: 1px solid #f0f0f0; }\n.em-nmt-brand { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: #444; font-weight: 500; }\n.em-nmt-logo { width: 18px; height: 18px; border-radius: 3px; background: #0f6cbd; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; }\n.em-nmt-count { font-size: 11px; color: #0f6cbd; margin-left: 2px; }\n.em-nmt-head-actions { display: flex; align-items: center; gap: 2px; }\n.em-nmt-head-actions button { background: none; border: none; cursor: pointer; color: #666; padding: 3px; border-radius: 4px; display: inline-flex; }\n.em-nmt-head-actions button:hover { background: #f0f0f0; }\n.em-nmt-body { display: flex; gap: 12px; padding: 12px 14px; cursor: pointer; }\n.em-nmt-body:hover { background: #f7fafd; }\n.em-nmt-avatar { width: 44px; height: 44px; border-radius: 50%; background: #b3b0ad; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0; }\n.em-nmt-text { min-width: 0; flex: 1; }\n.em-nmt-sender { font-size: 14px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-nmt-subject { font-size: 12.5px; color: #605e5c; margin: 1px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-nmt-preview { font-size: 12px; color: #797775; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }\n.em-nmt-foot { display: flex; border-top: 1px solid #f0f0f0; }\n.em-nmt-foot button { flex: 1; padding: 9px 0; background: #f7f6f5; border: none; border-right: 1px solid #eaeaea; cursor: pointer; color: #444; display: inline-flex; align-items: center; justify-content: center; }\n.em-nmt-foot button:last-child { border-right: none; }\n.em-nmt-foot button:hover { background: #eaeaea; }\n\n/* ===================== RULES MODAL ===================== */\n.em-rules {\n  width: 580px; max-width: calc(100vw - 40px); max-height: 84vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n}\n.em-rules-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-rules-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-rules-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-rules-x:hover { background: #f0f0f0; }\n.em-rules-body { padding: 16px 18px; overflow-y: auto; }\n.em-rules-hint { font-size: 12.5px; color: #605e5c; margin: 0 0 14px; line-height: 1.5; }\n.em-rules-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }\n.em-rules-empty { font-size: 13px; color: #999; padding: 14px; text-align: center; border: 1px dashed #ddd; border-radius: 8px; }\n.em-rules-item { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border: 1px solid #ececec; border-radius: 8px; background: #fbfbfa; }\n.em-rules-item-off { opacity: 0.55; }\n.em-rules-item-text { flex: 1; min-width: 0; }\n.em-rules-item-name { font-size: 13.5px; font-weight: 600; color: #201f1e; }\n.em-rules-item-desc { font-size: 12px; color: #605e5c; margin-top: 2px; }\n.em-rules-del { background: none; border: none; cursor: pointer; color: #b0413e; padding: 5px; border-radius: 5px; }\n.em-rules-del:hover { background: #fde7e6; }\n.em-rules-toggle { position: relative; display: inline-flex; cursor: pointer; flex-shrink: 0; }\n.em-rules-toggle input { position: absolute; opacity: 0; width: 34px; height: 18px; margin: 0; cursor: pointer; }\n.em-rules-check { width: 34px; height: 18px; border-radius: 10px; background: #c8c6c4; position: relative; transition: background .15s; }\n.em-rules-check::after { content: ''; position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: #fff; transition: left .15s; }\n.em-rules-toggle input:checked + .em-rules-check { background: #0f6cbd; }\n.em-rules-toggle input:checked + .em-rules-check::after { left: 18px; }\n.em-rules-new { border: 1px solid #ececec; border-radius: 8px; padding: 14px; background: #fafafa; }\n.em-rules-new-title { font-size: 13px; font-weight: 600; color: #201f1e; margin-bottom: 10px; }\n.em-rules-row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }\n.em-rules-lbl { font-size: 12.5px; color: #444; width: 56px; flex-shrink: 0; }\n.em-rules-input, .em-rules-select { border: 1px solid #d0d0d0; border-radius: 6px; padding: 7px 9px; font-size: 13px; font-family: inherit; outline: none; }\n.em-rules-input { width: 100%; }\n.em-rules-input:focus, .em-rules-select:focus { border-color: #0f6cbd; }\n.em-rules-input-value { flex: 1; width: auto; }\n.em-rules-select { background: #fff; }\n.em-rules-add { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 7px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-rules-add:disabled { opacity: 0.5; cursor: default; }\n.em-rules-foot { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-top: 1px solid #ececec; }\n.em-rules-run { display: inline-flex; align-items: center; gap: 6px; background: #107c10; color: #fff; border: none; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-rules-run:hover { background: #0e6b0e; }\n.em-rules-close { background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 8px 16px; font-size: 13px; cursor: pointer; }\n.em-rules-close:hover { background: #e8e6e4; }\n\n/* Give bulleted/numbered lists in HTML email templates proper indentation. */\n.em-viewer-html-body ul,\n.em-viewer-html-body ol { padding-left: 2rem; }\n\n/* Folder deep-sync progress strip (shown while a folder's messages download). */\n.em-list-syncbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  font-size: 12px;\n  color: #0f6cbd;\n  background: #eef4fb;\n  border-bottom: 1px solid #dbe7f5;\n  flex-shrink: 0;\n}\n.em-list-syncbar .em-spinner {\n  width: 13px; height: 13px;\n  border: 2px solid #bcd4ef;\n  border-top-color: #0f6cbd;\n  border-radius: 50%;\n  display: inline-block;\n  animation: em-spin 0.7s linear infinite;\n}\n@keyframes em-spin { to { transform: rotate(360deg); } }\n\n/* Sender initial-avatar in front of each message row (space in front of emails). */\n.em-mail-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  margin-top: 1px;\n  margin-right: 4px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  user-select: none;\n}\n/* Center the avatar against the 3-line message body. */\n.em-mail-item { align-items: center; }\n\n/* ===================== VIEW: density / preview / active toggles ===================== */\n/* Compact (\"Use Tighter Spacing\") — tighter rows, smaller avatar, no preview line. */\n.em-list-compact .em-mail-item { padding-top: 5px; padding-bottom: 5px; gap: 8px; }\n.em-list-compact .em-mail-avatar { width: 26px; height: 26px; font-size: 11px; }\n.em-list-compact .em-mail-preview-line { display: none; }\n.em-list-compact .em-mail-subject-line { font-size: 12.5px; }\n\n/* Message Preview off — hide the preview line. */\n.em-list-nopreview .em-mail-preview-line { display: none; }\n\n/* Active/toggled ribbon command (Reading Pane on, Work Offline on, current sort…). */\n.em-rb-active { background: #dbeafe !important; border-color: #a9c9f0 !important; }\n.em-rb-big.em-rb-active { color: #0f6cbd; }\n.em-rb-small.em-rb-active { color: #0f6cbd; font-weight: 600; }\n\n/* ===================== READ ALOUD CONTROL BAR ===================== */\n.em-ra {\n  position: fixed;\n  top: 132px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 5000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-ra-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #ffffff;\n  border: 1px solid #e1dfdd;\n  border-radius: 10px;\n  box-shadow: 0 6px 22px rgba(0,0,0,0.18);\n  padding: 6px 8px;\n}\n.em-ra-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  color: #333;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.em-ra-btn:hover { background: #f0f0f0; }\n.em-ra-btn-active { background: #eaf1fb; color: #0f6cbd; }\n.em-ra-play { color: #0f6cbd; }\n.em-ra-close:hover { background: #fde7e6; color: #d13438; }\n\n.em-ra-panel {\n  margin-top: 8px;\n  background: #ffffff;\n  border: 1px solid #d8d8d8;\n  border-radius: 8px;\n  box-shadow: 0 6px 22px rgba(0,0,0,0.18);\n  padding: 14px 16px;\n  width: 240px;\n}\n.em-ra-field { margin-bottom: 12px; }\n.em-ra-field:last-child { margin-bottom: 0; }\n.em-ra-field label {\n  display: block;\n  font-size: 13px;\n  color: #201f1e;\n  margin-bottom: 6px;\n}\n.em-ra-field input[type=\"range\"] { width: 78%; vertical-align: middle; accent-color: #0f6cbd; }\n.em-ra-rate { font-size: 12px; color: #605e5c; margin-left: 8px; }\n.em-ra-field select {\n  width: 100%;\n  padding: 6px 8px;\n  font-size: 13px;\n  border: 1px solid #c8c8c8;\n  border-radius: 5px;\n  background: #fff;\n  font-family: inherit;\n  color: #201f1e;\n}\n\n/* ===================== SCHEDULE MEETING MODAL ===================== */\n.em-meeting {\n  width: 460px; max-width: calc(100vw - 40px); max-height: 86vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-meeting-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-meeting-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-meeting-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-meeting-x:hover { background: #f0f0f0; }\n.em-meeting-body { padding: 16px 18px; overflow-y: auto; }\n.em-meeting-body label { display: block; font-size: 12.5px; color: #444; margin: 10px 0 4px; }\n.em-meeting-body input, .em-meeting-body select, .em-meeting-body textarea {\n  width: 100%; padding: 8px 10px; font-size: 13.5px; border: 1px solid #d0d0d0; border-radius: 6px;\n  font-family: inherit; outline: none; box-sizing: border-box;\n}\n.em-meeting-body input:focus, .em-meeting-body select:focus, .em-meeting-body textarea:focus { border-color: #0f6cbd; }\n.em-meeting-row { display: flex; gap: 10px; }\n.em-meeting-row > div { flex: 1; }\n.em-meeting-foot { display: flex; align-items: center; gap: 8px; padding: 12px 18px; border-top: 1px solid #ececec; }\n.em-meeting-google { display: inline-flex; align-items: center; gap: 7px; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 9px 14px; font-size: 13.5px; font-weight: 600; cursor: pointer; }\n.em-meeting-google:hover { background: #0c5aa0; }\n.em-meeting-ics { display: inline-flex; align-items: center; gap: 5px; background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 12px; font-size: 13px; cursor: pointer; }\n.em-meeting-ics:hover { background: #e8e6e4; }\n.em-meeting-cancel { margin-left: auto; background: none; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 16px; font-size: 13px; cursor: pointer; }\n.em-meeting-cancel:hover { background: #f3f2f1; }\n\n/* ===================== REMINDERS WINDOW ===================== */\n.em-reminders {\n  width: 420px; max-width: calc(100vw - 40px); max-height: 80vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-reminders-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-reminders-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-reminders-count { background: #d13438; color: #fff; border-radius: 10px; font-size: 11px; font-weight: 700; padding: 1px 7px; }\n.em-reminders-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-reminders-x:hover { background: #f0f0f0; }\n.em-reminders-body { padding: 8px 0; overflow-y: auto; }\n.em-reminders-empty { text-align: center; color: #888; padding: 30px 20px; display: flex; flex-direction: column; align-items: center; gap: 6px; }\n.em-reminders-empty p { margin: 4px 0 0; font-size: 15px; color: #555; }\n.em-reminders-empty span { font-size: 12.5px; }\n.em-reminder-item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 18px; border-bottom: 1px solid #f2f2f2; }\n.em-reminder-item:hover { background: #faf9f8; }\n.em-reminder-icon { margin-top: 2px; flex-shrink: 0; }\n.em-reminder-text { flex: 1; min-width: 0; cursor: pointer; }\n.em-reminder-title { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-reminder-sub { font-size: 12px; color: #605e5c; margin: 2px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-reminder-when { font-size: 12px; color: #0f6cbd; font-weight: 500; }\n.em-reminder-dismiss { align-self: center; background: #f3f2f1; border: 1px solid #d8d8d8; border-radius: 5px; padding: 5px 10px; font-size: 12px; cursor: pointer; flex-shrink: 0; }\n.em-reminder-dismiss:hover { background: #e8e6e4; }\n.em-reminders-foot { padding: 10px 18px; border-top: 1px solid #ececec; text-align: right; }\n.em-reminders-dismissall { background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-reminders-dismissall:hover { background: #0c5aa0; }\n\n/* ===================== RIBBON: COLOURED, SPACED, CLEANER ===================== */\n/* Left space so the toolbar isn't cluttered against the edge. */\n.em-ribbon-tabs { padding: 0 8px 0 22px; }\n.em-rb-content { padding: 7px 14px 3px 22px; gap: 2px; }\n\n/* More horizontal breathing room + softer separators between groups. */\n.em-rb-group { padding: 2px 15px 0; border-right: 1px solid #eef0f2; }\n.em-rb-group:last-child { border-right: none; }\n.em-rb-buttons { gap: 4px; }\n.em-rb-big { min-width: 48px; max-width: 74px; padding: 5px 7px; gap: 4px; }\n.em-rb-small { padding: 3px 7px 3px 5px; }\n.em-rb-stack { gap: 2px; padding: 0 3px; }\n.em-rb-group-label { color: #9aa0a6; padding-top: 5px; font-size: 10px; }\n\n/* Softer hover (keep the coloured icons visible). */\n.em-rb-big:hover, .em-rb-small:hover { background: #f2f5f9; border-color: #e2e8f0; }\n\n/* Active/toggled command — light rounded blue chip. */\n.em-rb-active { background: #eaf1fb !important; border-color: #cfe0f5 !important; border-radius: 6px; }\n.em-rb-big.em-rb-active .em-rb-big-label,\n.em-rb-small.em-rb-active span { color: #1a5fbf; font-weight: 600; }\n\n/* Search-people pill spacing. */\n.em-rb-people { margin-bottom: 3px; }\n\n/* ===================== NO SCROLLBARS — SHOW EVERYTHING ===================== */\n/* Ribbon: never scroll horizontally — wrap groups onto a second row instead. */\n.em-rb-content {\n  overflow-x: hidden;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  row-gap: 2px;\n}\n\n/* Folder pane: compact rows so all folders fit without a scrollbar. */\n.em-sidebar { overflow-y: auto; }\n.em-sidebar-newmail { margin: 5px 6px 6px; padding: 7px 12px; }\n.em-sidebar-search-btn { min-height: 26px; padding: 4px 10px; margin: 0 6px; }\n.em-sidebar-section { margin-top: 3px; padding: 1px 0 3px; border-top-color: #f0f0f0; }\n.em-sidebar-section-title { padding: 5px 12px 2px; }\n.em-sidebar-folder { min-height: 26px; padding: 4px 10px 4px 24px; margin: 0 6px; }\n.em-sidebar-more-btn { padding-top: 3px; padding-bottom: 3px; }\n\n/* Slim, unobtrusive scrollbar if content still just barely overflows. */\n.em-sidebar::-webkit-scrollbar { width: 6px; }\n.em-sidebar::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }\n.em-sidebar::-webkit-scrollbar-track { background: transparent; }\n\n/* ===================== COMPACT SINGLE-ROW OUTLOOK RIBBON (match reference) ===================== */\n.em-rb-content {\n  flex-wrap: nowrap;          /* single row like classic Outlook */\n  overflow-x: auto;\n  overflow-y: hidden;\n  align-content: stretch;\n  padding: 5px 8px 2px 12px;\n  gap: 0;\n  min-height: 82px;\n  row-gap: 0;\n}\n.em-rb-group { padding: 2px 8px 0; }\n.em-rb-buttons { gap: 1px; }\n.em-rb-stack { gap: 0; padding: 0 2px; }\n.em-rb-big { min-width: 40px; max-width: 64px; padding: 3px 5px; gap: 2px; }\n.em-rb-big svg { width: 17px; height: 17px; }\n.em-rb-big-label { font-size: 10px; line-height: 1.1; }\n.em-rb-small { padding: 2px 5px 2px 4px; font-size: 10.5px; gap: 4px; }\n.em-rb-small svg { width: 13px; height: 13px; }\n.em-rb-group-label { font-size: 9px; padding-top: 3px; }\n.em-rb-people { padding: 1px 6px; margin-bottom: 2px; }\n.em-rb-people input { width: 84px; font-size: 10.5px; }\n\n/* If it can't fit (very narrow window) the scrollbar is slim, not a big grey bar. */\n.em-rb-content::-webkit-scrollbar { height: 6px; }\n.em-rb-content::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }\n.em-rb-content::-webkit-scrollbar-track { background: transparent; }\n\n/* ===================== CLEAN STRUCTURED EMAIL / TEMPLATE RENDERING ===================== */\n/* Reading pane = soft canvas; the email sits on a centered white \"sheet\". */\n.em-viewer-body {\n  background: #f3f4f6;\n  padding: 22px 18px;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  max-width: 840px;\n  margin: 0 auto;                 /* centered, not floating left */\n  background: #ffffff;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;               /* clip full-width headers to the rounded card */\n  padding: 0;\n}\n.em-viewer-html-body {\n  padding: 30px 36px;\n  text-align: left;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 14px;\n  color: #242424;\n  line-height: 1.6;\n  overflow-x: auto;\n}\n.em-viewer-html-body img { max-width: 100%; height: auto; }\n.em-viewer-html-body table { max-width: 100%; }\n/* Centre the template's top-level blocks so headers/logos sit balanced. */\n.em-viewer-html-body > table,\n.em-viewer-html-body > div,\n.em-viewer-html-body > center,\n.em-viewer-html-body > center > table {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n.em-viewer-html-body p { margin: 0 0 12px; }\n.em-viewer-html-body ul,\n.em-viewer-html-body ol { padding-left: 1.5rem; margin: 10px 0; }\n.em-viewer-html-body a { color: #0f6cbd; }\n.em-viewer-text-body {\n  padding: 30px 36px;\n  max-width: none;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* ===================== IFRAME EMAIL RENDERING (clean, isolated) ===================== */\n.em-viewer-body {\n  background: #f3f4f6;\n  padding: 22px 18px;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  max-width: 880px;\n  margin: 0 auto;\n  background: #ffffff;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;\n  padding: 0;\n}\n.em-viewer-frame {\n  width: 100%;\n  border: none;\n  display: block;\n  background: #ffffff;\n  min-height: 180px;\n}\n.em-viewer-text-body {\n  padding: 26px 30px;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* ===================== ACCOUNT AVATAR + POPOVER (ribbon top-right) ===================== */\n.em-ribbon-tabs { position: relative; }\n.em-ribbon-account { margin-left: auto; position: relative; display: flex; align-items: center; padding-right: 12px; }\n.em-ribbon-avatar-btn { background: none; border: none; cursor: pointer; padding: 3px; border-radius: 50%; display: inline-flex; }\n.em-ribbon-avatar-btn:hover { background: #e5e7eb; }\n.em-ribbon-avatar {\n  width: 28px; height: 28px; border-radius: 50%; background: #4b7c72; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600;\n}\n.em-account-backdrop { position: fixed; inset: 0; z-index: 6000; }\n.em-account-pop {\n  position: absolute; top: 40px; right: 8px; z-index: 6001; width: 330px;\n  background: #fff; border: 1px solid #e1dfdd; border-radius: 10px;\n  box-shadow: 0 12px 36px rgba(0,0,0,0.22); overflow: hidden;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-account-pop-main { display: flex; gap: 16px; padding: 20px; }\n.em-account-pop-avatar {\n  width: 58px; height: 58px; border-radius: 50%; background: #4b7c72; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 600; flex-shrink: 0;\n}\n.em-account-pop-info { min-width: 0; }\n.em-account-pop-name { font-size: 16px; font-weight: 700; color: #201f1e; word-break: break-word; line-height: 1.3; }\n.em-account-pop-email { font-size: 13px; color: #605e5c; margin: 2px 0 6px; word-break: break-word; }\n.em-account-pop-view { background: none; border: none; color: #0f6cbd; font-size: 13px; cursor: pointer; padding: 0; font-family: inherit; }\n.em-account-pop-view:hover { text-decoration: underline; }\n.em-account-pop-add {\n  display: flex; align-items: center; gap: 12px; width: 100%; padding: 14px 20px;\n  background: #fff; border: none; border-top: 1px solid #ececec; cursor: pointer;\n  font-size: 14px; color: #201f1e; font-family: inherit; text-align: left;\n}\n.em-account-pop-add svg { color: #605e5c; }\n.em-account-pop-add:hover { background: #f5f5f5; }\n\n/* ===================== SIDEBAR: MORE BREATHING ROOM (top actions) ===================== */\n.em-sidebar-newmail { margin: 10px 8px 8px; padding: 10px 14px; gap: 9px; }\n.em-sidebar-search-btn { min-height: 34px; padding: 8px 12px; margin: 2px 8px; gap: 12px; }\n.em-sidebar-search-btn:last-of-type { margin-bottom: 10px; }\n\n/* Account button now shows the name next to the avatar. */\n.em-ribbon-avatar-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 6px 3px 10px;\n  border-radius: 18px;\n}\n.em-ribbon-username {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #201f1e;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.em-ribbon-avatar-caret { color: #605e5c; flex-shrink: 0; }\n\n/* ===================== SIDEBAR COLLAPSE TOGGLE ===================== */\n.em-sidebar-collapsehdr { display: flex; justify-content: flex-end; padding: 4px 6px 0; }\n.em-sidebar-collapse-btn {\n  background: none; border: none; cursor: pointer; color: #605e5c;\n  padding: 4px; border-radius: 5px; display: inline-flex;\n}\n.em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }\n\n/* Narrow rail shown when the folder pane is collapsed — click to expand. */\n.em-collapsed-rail {\n  width: 34px; min-width: 34px; flex-shrink: 0;\n  background: #fbfbfa; border-right: 1px solid #ececec;\n  display: flex; flex-direction: column; align-items: center; padding-top: 8px;\n}\n.em-collapsed-expand {\n  background: none; border: none; cursor: pointer; color: #605e5c;\n  padding: 5px; border-radius: 5px; display: inline-flex;\n}\n.em-collapsed-expand:hover { background: #eceff2; color: #0f6cbd; }\n\n/* ===================== COMPACT ICON-ONLY MODULE RAIL (bottom-left) ===================== */\n.em-nav-rail-top { display: flex; flex-direction: row; align-items: center; gap: 2px; }\n.em-nav-rail-btn {\n  flex-direction: row; min-width: auto; padding: 6px 9px; gap: 0;\n}\n.em-nav-rail-label { display: none; }\n.em-nav-rail-more svg { color: #605e5c; }\n\n/* New mail button + collapse toggle on one row (no separate top row/space). */\n.em-sidebar-collapsehdr { display: none; }\n.em-sidebar-newmail-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 8px 8px 6px;\n}\n.em-sidebar-newmail-row .em-sidebar-newmail { flex: 1; margin: 0; }\n.em-sidebar-newmail-row .em-sidebar-collapse-btn {\n  flex-shrink: 0;\n  color: #605e5c;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: inline-flex;\n}\n.em-sidebar-newmail-row .em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }\n\n/* ===================== OUTLOOK-WEB READING PANE TOOLBAR ===================== */\n.em-viewer-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  padding: 6px 12px;\n  border-bottom: 1px solid #eaeaea;\n  background: #ffffff;\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n.em-vt-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: none;\n  background: transparent;\n  border-radius: 5px;\n  cursor: pointer;\n  color: #3b3a39;\n  font-size: 13px;\n  font-family: inherit;\n  white-space: nowrap;\n}\n.em-vt-btn:hover { background: #f3f2f1; }\n.em-vt-btn svg { color: #605e5c; }\n.em-vt-icon { padding: 6px 8px; }\n.em-vt-sep { width: 1px; height: 20px; background: #e6e6e6; margin: 0 6px; flex-shrink: 0; }\n.em-vt-spacer { flex: 1; min-width: 8px; }\n\n/* Slim the sender row now that actions live in the top toolbar. */\n.em-viewer-header-right { text-align: right; }\n\n/* ===================== CRM / INSIGHTS RIGHT PANE ===================== */\n.em-crm {\n  width: 210px;\n  min-width: 210px;\n  flex-shrink: 0;\n  border-left: 1px solid #eaeaea;\n  background: #faf9f8;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-crm-head { padding: 12px 16px; font-size: 13px; font-weight: 600; color: #605e5c; border-bottom: 1px solid #ededed; }\n.em-crm-body { padding: 14px 16px; }\n.em-crm-contact { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }\n.em-crm-avatar {\n  width: 40px; height: 40px; border-radius: 50%; background: #8764b8; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0;\n}\n.em-crm-info { min-width: 0; }\n.em-crm-name { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-crm-email { font-size: 12px; color: #605e5c; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-crm-note {\n  display: flex; gap: 8px; align-items: flex-start;\n  font-size: 12.5px; color: #605e5c; line-height: 1.45;\n  background: #fff; border: 1px solid #ededed; border-radius: 8px; padding: 10px 12px;\n}\n.em-crm-note svg { color: #0f6cbd; flex-shrink: 0; margin-top: 1px; }\n.em-crm-note strong { color: #201f1e; word-break: break-all; }\n\n/* Final email preview subject size override */\n.em-module .em-viewer .em-viewer-header .em-viewer-subject-row .em-viewer-subject,\n.em-module.em-ribbon-collapsed .em-viewer .em-viewer-header .em-viewer-subject-row .em-viewer-subject {\n  font-size: 14px !important;\n  line-height: 1.28 !important;\n  font-weight: 600 !important;\n}\n\n/* Final email preview action alignment override */\n.em-module .em-viewer .em-viewer-header .em-viewer-subject-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  width: 100% !important;\n  margin: 0 0 12px 0 !important;\n}\n\n.em-module .em-viewer .em-viewer-header .em-preview-head-actions {\n  margin-left: auto !important;\n  margin-top: 0 !important;\n  align-self: center !important;\n  transform: none !important;\n}\n\n.em-module .em-viewer .em-viewer-header .em-preview-action-btn {\n  height: 30px !important;\n  min-height: 30px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Final Outlook-clean frame and folder pane */\n.em-module {\n  padding: 10px 14px 10px 14px !important;\n  background: #f3f6fa !important;\n}\n\n.em-module .em-ribbon,\n.em-module .em-module-body,\n.em-module .em-statusbar {\n  width: 100% !important;\n  box-sizing: border-box !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.em-module .em-ribbon {\n  border: 1px solid #cfd8e3 !important;\n  border-bottom: 0 !important;\n  border-radius: 10px 10px 0 0 !important;\n  box-shadow: none !important;\n}\n\n.em-module .em-module-body {\n  border: 1px solid #cfd8e3 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.em-module .em-statusbar {\n  border: 1px solid #cfd8e3 !important;\n  border-top: 0 !important;\n  border-radius: 0 0 10px 10px !important;\n  box-shadow: none !important;\n}\n\n.em-module .em-sidebar {\n  width: 228px !important;\n  min-width: 228px !important;\n  background: #f3f3f3 !important;\n  border-right: 1px solid #d9d9d9 !important;\n  border-radius: 0 !important;\n  padding: 4px 0 8px 0 !important;\n}\n\n.em-module .em-sidebar-newmail-row {\n  min-height: 0 !important;\n  height: 18px !important;\n  margin: 0 4px 0 4px !important;\n  justify-content: flex-end !important;\n}\n\n.em-module .em-sidebar-newmail-row .em-sidebar-newmail {\n  display: none !important;\n}\n\n.em-module .em-sidebar-newmail-row .em-sidebar-collapse-btn {\n  width: 20px !important;\n  height: 18px !important;\n  padding: 0 !important;\n  justify-content: center !important;\n  color: #4b5563 !important;\n  border-radius: 3px !important;\n}\n\n.em-module .em-sidebar-search-btn {\n  min-height: 25px !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n  margin: 0 !important;\n  padding: 6px 14px 6px 28px !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  color: #242424 !important;\n  font-size: 12px !important;\n  gap: 8px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.em-module .em-sidebar-search-btn:hover {\n  background: #e8e8e8 !important;\n}\n\n.em-module .em-sidebar-section {\n  margin: 6px 8px 0 8px !important;\n  padding: 0 0 7px 0 !important;\n  border-top: 1px solid #dedede !important;\n}\n\n.em-module .em-sidebar-section:first-of-type {\n  border-top: 0 !important;\n}\n\n.em-module .em-sidebar-section-title {\n  min-height: 24px !important;\n  padding: 5px 4px 3px 0 !important;\n  margin: 0 !important;\n  color: #242424 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0 !important;\n  text-transform: none !important;\n}\n\n.em-module .em-sidebar-account-title span {\n  font-weight: 600 !important;\n}\n\n.em-module .em-sidebar-section-chevron {\n  color: #3f3f46 !important;\n  width: 11px !important;\n  height: 11px !important;\n}\n\n.em-module .em-sidebar-folder,\n.em-module .em-sidebar-more-btn {\n  min-height: 24px !important;\n  margin: 0 !important;\n  padding: 3px 8px 3px 18px !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  color: #242424 !important;\n  font-size: 12px !important;\n  line-height: 1.2 !important;\n}\n\n.em-module .em-sidebar-folder:hover,\n.em-module .em-sidebar-more-btn:hover {\n  background: #e8e8e8 !important;\n}\n\n.em-module .em-sidebar-folder-active,\n.em-module .em-sidebar-folder-active:hover {\n  background: #dedede !important;\n  color: #111827 !important;\n  box-shadow: none !important;\n  border-left: 0 !important;\n}\n\n.em-module .em-sidebar-folder-icon {\n  display: none !important;\n}\n\n.em-module .em-sidebar-folder-label {\n  color: inherit !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n}\n\n.em-module .em-sidebar-folder-active .em-sidebar-folder-label {\n  font-weight: 600 !important;\n}\n\n.em-module .em-sidebar-folder-count {\n  margin-left: auto !important;\n  color: #005a9e !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n}\n\n.em-module .em-statusbar .em-nav-rail-top {\n  background: #f8fafc !important;\n  border: 1px solid #d6e1ec !important;\n  border-radius: 999px !important;\n}\n\n/* Attachment file type icons */\n.em-viewer-att-type-icon {\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 6px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n  border: 1px solid transparent !important;\n}\n\n.em-viewer-att-type-icon svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.em-att-icon-pdf {\n  color: #c2410c !important;\n  background: #fff1e8 !important;\n  border-color: #fed7aa !important;\n}\n\n.em-att-icon-word {\n  color: #1d4ed8 !important;\n  background: #eff6ff !important;\n  border-color: #bfdbfe !important;\n}\n\n.em-att-icon-excel {\n  color: #047857 !important;\n  background: #ecfdf5 !important;\n  border-color: #a7f3d0 !important;\n}\n\n.em-att-icon-image {\n  color: #7c3aed !important;\n  background: #f5f3ff !important;\n  border-color: #ddd6fe !important;\n}\n\n.em-att-icon-default {\n  color: #475569 !important;\n  background: #f8fafc !important;\n  border-color: #e2e8f0 !important;\n}\n\n/* Email list selected item: no blue fill, only Outlook-style left bar */\n.em-module .em-list .em-mail-item.em-mail-active,\n.em-module .em-list .em-mail-item.em-mail-active:hover {\n  background: #ffffff !important;\n  box-shadow: inset 3px 0 0 #0f6cbd !important;\n}\n\n.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-sender,\n.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-subject-line {\n  color: #111827 !important;\n}\n\n.em-module .em-list .em-mail-item.em-mail-active:not(.em-mail-unread) .em-mail-date {\n  color: #888 !important;\n}\n\n/* ===================== Email module rounded Outlook shell ===================== */\n.em-module {\n  padding: 14px 18px 14px 18px !important;\n  background:\n    radial-gradient(circle at top left, rgba(15, 108, 189, 0.08), transparent 34%),\n    linear-gradient(180deg, #eef5fb 0%, #f7f9fc 100%) !important;\n}\n\n.em-ribbon {\n  border-radius: 16px 16px 0 0 !important;\n  border: 1px solid #d7e3f1 !important;\n  border-bottom: 0 !important;\n  box-shadow: 0 10px 26px rgba(15, 52, 94, 0.08) !important;\n  overflow: visible !important;\n  position: relative !important;\n  z-index: 20 !important;\n}\n\n.em-ribbon-tabs {\n  overflow: visible !important;\n  border-radius: 16px 16px 0 0 !important;\n  position: relative !important;\n  z-index: 40 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.em-ribbon-account,\n.em-ribbon-avatar-btn {\n  position: relative !important;\n  z-index: 80 !important;\n}\n\n.em-account-pop {\n  top: calc(100% + 8px) !important;\n  right: 8px !important;\n  z-index: 9999 !important;\n  border-radius: 16px !important;\n  border: 1px solid #d8e3ef !important;\n  box-shadow: 0 18px 48px rgba(15, 52, 94, 0.22) !important;\n  overflow: hidden !important;\n}\n\n.em-module-body {\n  border-radius: 0 0 16px 16px !important;\n  border: 1px solid #d7e3f1 !important;\n  overflow: hidden !important;\n  box-shadow: 0 14px 32px rgba(15, 52, 94, 0.09) !important;\n}\n\n.em-sidebar {\n  border-radius: 0 0 0 16px !important;\n}\n\n.em-viewer {\n  border-radius: 0 0 16px 0 !important;\n}\n\n.em-viewer-body {\n  background:\n    linear-gradient(180deg, #f8fbff 0%, #f4f6f9 100%) !important;\n}\n\n.em-viewer-paper {\n  border-radius: 14px !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: 0 14px 34px rgba(15, 52, 94, 0.10) !important;\n}\n\n.em-statusbar {\n  min-height: 40px !important;\n  margin-top: 0 !important;\n  padding: 5px 14px 6px 10px !important;\n  border: 1px solid #d7e3f1 !important;\n  border-top: 0 !important;\n  border-radius: 0 0 16px 16px !important;\n  background: rgba(255, 255, 255, 0.92) !important;\n  box-shadow: 0 12px 26px rgba(15, 52, 94, 0.08) !important;\n}\n\n.em-statusbar .em-nav-rail-top {\n  gap: 7px !important;\n  padding: 4px 8px !important;\n  border: 1px solid #dce8f4 !important;\n  border-radius: 999px !important;\n  background: #f7fbff !important;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;\n}\n\n.em-statusbar .em-nav-rail-btn {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  color: #4b647a !important;\n}\n\n.em-statusbar .em-nav-rail-btn:hover {\n  background: #e6f2ff !important;\n  color: #0f6cbd !important;\n}\n\n.em-statusbar .em-nav-rail-btn-active {\n  background: linear-gradient(135deg, #0f6cbd, #0b7f74) !important;\n  color: #fff !important;\n  box-shadow: 0 6px 14px rgba(15, 108, 189, 0.24) !important;\n}\n\n.em-nav-rail-badge {\n  border: 2px solid #fff !important;\n  box-shadow: 0 3px 8px rgba(220, 38, 38, 0.24) !important;\n}\n\n.em-statusbar-info {\n  padding: 6px 12px !important;\n  border-radius: 999px !important;\n  background: #f8fafc !important;\n  border: 1px solid #e1e8f0 !important;\n}\n\n/* Compact email message action toolbar */\n.em-viewer-toolbar {\n  min-height: 30px !important;\n  padding: 3px 8px !important;\n  gap: 2px !important;\n}\n\n.em-vt-btn {\n  min-height: 22px !important;\n  padding: 3px 6px !important;\n  gap: 4px !important;\n  font-size: 11px !important;\n  line-height: 1.1 !important;\n}\n\n.em-vt-btn span {\n  font-size: 11px !important;\n}\n\n.em-vt-btn svg {\n  width: 12px !important;\n  height: 12px !important;\n}\n\n/* Ribbon collapse toggle for a larger reading preview */\n.em-ribbon-toggle {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  width: 28px !important;\n  height: 24px !important;\n  border: 1px solid #cfe0f2 !important;\n  border-radius: 999px !important;\n  background: #f7fbff !important;\n  color: #0f6cbd !important;\n  line-height: 1 !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  align-self: center !important;\n  flex-shrink: 0 !important;\n  box-shadow: 0 2px 7px rgba(15, 108, 189, 0.12) !important;\n}\n\n.em-ribbon-toggle svg {\n  display: block !important;\n  margin: 0 !important;\n  stroke-width: 2.4 !important;\n}\n\n.em-ribbon-toggle:hover {\n  background: #e7f2ff !important;\n  border-color: #8fc0ef !important;\n}\n\n.em-ribbon-mini .em-rb-content {\n  display: none !important;\n}\n\n.em-ribbon-mini {\n  min-height: 36px !important;\n  border-bottom: 1px solid #d7e3f1 !important;\n}\n\n.em-ribbon-mini .em-ribbon-tabs {\n  min-height: 34px !important;\n}\n\n.em-ribbon-collapsed .em-module-body {\n  height: calc(100vh - 92px) !important;\n  min-height: 610px !important;\n}\n\n.em-viewer-subject,\n.em-ribbon-collapsed .em-viewer-subject {\n  font-size: 16px !important;\n  line-height: 1.25 !important;\n  font-weight: 600 !important;\n}\n\n/* Compact Outlook preview header with inline reply controls */\n.em-viewer > .em-viewer-toolbar {\n  display: none !important;\n}\n\n.em-viewer-header {\n  padding: 13px 24px 11px 24px !important;\n  border-bottom: 1px solid #e5e7eb !important;\n  background: #fff !important;\n}\n\n.em-viewer-subject-row {\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 12px !important;\n  margin-bottom: 12px !important;\n}\n\n.em-viewer-subject {\n  flex: 1 1 auto !important;\n  margin: 0 !important;\n  color: #0f172a !important;\n}\n\n.em-preview-head-actions {\n  display: inline-flex !important;\n  align-items: center !important;\n  flex-shrink: 0 !important;\n  border: 1px solid #bfc7d1 !important;\n  border-radius: 3px !important;\n  background: #fff !important;\n  overflow: hidden !important;\n}\n\n.em-preview-action-btn {\n  height: 30px !important;\n  padding: 0 10px !important;\n  border: 0 !important;\n  border-right: 1px solid #bfc7d1 !important;\n  background: #fff !important;\n  color: #1f2937 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  font-size: 12px !important;\n  line-height: 1 !important;\n  cursor: pointer !important;\n  font-family: inherit !important;\n}\n\n.em-preview-action-btn:last-child {\n  border-right: 0 !important;\n}\n\n.em-preview-action-btn:hover {\n  background: #f3f7fb !important;\n}\n\n.em-preview-action-btn svg {\n  color: #0f6cbd !important;\n  stroke-width: 2 !important;\n}\n\n.em-preview-more-btn {\n  width: 32px !important;\n  padding: 0 !important;\n  justify-content: center !important;\n}\n\n.em-viewer-from-row {\n  align-items: center !important;\n  gap: 10px !important;\n}\n\n.em-viewer-avatar-lg {\n  width: 43px !important;\n  height: 43px !important;\n  font-size: 14px !important;\n  background: #008272 !important;\n  color: #fff !important;\n}\n\n.em-viewer-from-name {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #111827 !important;\n}\n\n.em-viewer-from-addr {\n  font-size: 11px !important;\n  line-height: 1.35 !important;\n  color: #334155 !important;\n}\n\n.em-viewer-date {\n  font-size: 11px !important;\n  color: #475569 !important;\n  white-space: nowrap !important;\n}\n\n.em-viewer-webbanner {\n  min-height: 25px !important;\n  padding: 4px 24px !important;\n  font-size: 11px !important;\n  background: #fff !important;\n}\n\n/* Email module final polish: ATS spacing + calmer blue/teal grading */\n.em-module {\n  padding-left: 16px;\n  padding-right: 14px;\n  background: #f4f8fb !important;\n  --em-accent: #0f766e;\n  --em-accent-hover: #0f4c81;\n  --em-ribbon-bg: #ffffff;\n  --em-ribbon-border: #d7e3f0;\n  --em-sidebar-bg: #ffffff;\n  --em-hover: #eef7f4;\n  --em-active: #e3f3ff;\n}\n\n.em-ribbon {\n  margin-top: 10px;\n  border: 1px solid #d7e3f0;\n  border-radius: 12px 12px 0 0;\n  overflow: hidden;\n  background: #ffffff !important;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n}\n\n.em-ribbon-tabs {\n  background: linear-gradient(90deg, #f8fbff 0%, #eef7f4 100%) !important;\n  border-bottom: 1px solid #d7e3f0 !important;\n}\n\n.em-ribbon-tab {\n  color: #334155 !important;\n}\n\n.em-ribbon-tab-active {\n  color: #0f4c81 !important;\n  background: #ffffff !important;\n  border-bottom-color: #0f766e !important;\n}\n\n.em-ribbon-content,\n.em-rb-content {\n  background: #ffffff !important;\n}\n\n.em-ribbon-btn:hover,\n.em-rb-big:hover,\n.em-rb-small:hover {\n  background: #eef7f4 !important;\n  border-color: #c8e7df !important;\n}\n\n.em-sidebar {\n  margin-left: 10px;\n  border: 1px solid #d7e3f0 !important;\n  border-top: 0 !important;\n  border-radius: 0 0 12px 12px;\n  background: #ffffff !important;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.07);\n}\n\n.em-sidebar-newmail {\n  background: linear-gradient(90deg, #0f4c81, #0f766e) !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 8px 18px rgba(15, 76, 129, 0.18);\n}\n\n.em-sidebar-newmail:hover {\n  background: linear-gradient(90deg, #0d426f, #0d665f) !important;\n}\n\n.em-sidebar-search-btn {\n  border-radius: 8px !important;\n  color: #334155 !important;\n}\n\n.em-sidebar-search-btn:hover {\n  background: #eef7f4 !important;\n  color: #0f4c81 !important;\n}\n\n.em-sidebar-section {\n  border-top-color: #e2e8f0 !important;\n}\n\n.em-sidebar-section-title {\n  color: #64748b !important;\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  text-transform: uppercase;\n}\n\n.em-sidebar-account-title span {\n  color: #0f172a !important;\n}\n\n.em-sidebar-folder {\n  border-radius: 8px !important;\n  color: #334155 !important;\n}\n\n.em-sidebar-folder:hover {\n  background: #f0fdfa !important;\n}\n\n.em-sidebar-folder-active,\n.em-sidebar-folder-active:hover {\n  background: #e0f2fe !important;\n  color: #0f4c81 !important;\n  box-shadow: inset 3px 0 0 #0f766e !important;\n}\n\n.em-sidebar-folder-active .em-sidebar-folder-icon,\n.em-sidebar-folder-count-primary {\n  color: #0f766e !important;\n}\n\n.em-sidebar-folder-count {\n  color: #64748b !important;\n}\n\n.em-sidebar-modules {\n  margin-left: 10px;\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid #d7e3f0;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n}\n\n.em-sidebar-module-active {\n  background: #e0f2fe !important;\n  color: #0f766e !important;\n}\n\n/* Email module Outlook preview style override */\n.em-module {\n  padding-left: 16px;\n  padding-right: 14px;\n  background: #f3f2f1 !important;\n  font-family: \"Segoe UI\", Arial, sans-serif !important;\n  --em-accent: #0f6cbd;\n  --em-accent-hover: #0c5aa0;\n  --em-ribbon-bg: #ffffff;\n  --em-ribbon-border: #e1dfdd;\n  --em-sidebar-bg: #faf9f8;\n  --em-hover: #f3f2f1;\n  --em-active: #eaf3ff;\n}\n\n.em-ribbon {\n  margin-top: 8px;\n  border: 1px solid #e1dfdd !important;\n  border-radius: 4px 4px 0 0 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.em-ribbon-tabs {\n  height: 34px !important;\n  background: #ffffff !important;\n  border-bottom: 1px solid #e1dfdd !important;\n}\n\n.em-ribbon-tab {\n  color: #323130 !important;\n  font-size: 13px !important;\n  border-bottom: 2px solid transparent !important;\n}\n\n.em-ribbon-tab:hover {\n  background: #f3f2f1 !important;\n}\n\n.em-ribbon-tab-active {\n  color: #0f6cbd !important;\n  background: #ffffff !important;\n  border-bottom-color: #0f6cbd !important;\n}\n\n.em-ribbon-content,\n.em-rb-content {\n  background: #ffffff !important;\n  border-bottom: 1px solid #d2d0ce !important;\n}\n\n.em-ribbon-group,\n.em-rb-group {\n  border-right-color: #edebe9 !important;\n}\n\n.em-ribbon-btn,\n.em-rb-big,\n.em-rb-small {\n  color: #323130 !important;\n  border-radius: 2px !important;\n}\n\n.em-ribbon-btn:hover,\n.em-rb-big:hover,\n.em-rb-small:hover {\n  background: #f3f2f1 !important;\n  border-color: #edebe9 !important;\n}\n\n.em-module-body {\n  background: #f3f2f1 !important;\n}\n\n.em-sidebar {\n  margin-left: 10px;\n  border: 1px solid #e1dfdd !important;\n  border-top: 0 !important;\n  border-radius: 0 !important;\n  background: #faf9f8 !important;\n  box-shadow: none !important;\n}\n\n.em-sidebar-newmail {\n  background: #0f6cbd !important;\n  border: 1px solid #0f6cbd !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n}\n\n.em-sidebar-newmail:hover {\n  background: #0c5aa0 !important;\n  border-color: #0c5aa0 !important;\n}\n\n.em-sidebar-search-btn,\n.em-sidebar-folder,\n.em-sidebar-more-btn {\n  border-radius: 4px !important;\n  color: #323130 !important;\n}\n\n.em-sidebar-search-btn:hover,\n.em-sidebar-folder:hover,\n.em-sidebar-more-btn:hover {\n  background: #f3f2f1 !important;\n}\n\n.em-sidebar-section {\n  border-top-color: #edebe9 !important;\n}\n\n.em-sidebar-section-title {\n  color: #605e5c !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n}\n\n.em-sidebar-folder-active,\n.em-sidebar-folder-active:hover {\n  background: #eaf3ff !important;\n  color: #0f6cbd !important;\n  box-shadow: inset 3px 0 0 #0f6cbd !important;\n}\n\n.em-sidebar-folder-active .em-sidebar-folder-icon,\n.em-sidebar-folder-count-primary {\n  color: #0f6cbd !important;\n}\n\n.em-sidebar-folder-count {\n  color: #605e5c !important;\n}\n\n.em-mail-list,\n.em-list-pane {\n  background: #ffffff !important;\n  border-color: #e1dfdd !important;\n}\n\n.em-mail-item,\n.em-list-item {\n  border-bottom-color: #edebe9 !important;\n}\n\n.em-mail-item:hover,\n.em-list-item:hover {\n  background: #f3f9ff !important;\n}\n\n.em-mail-item-active,\n.em-list-item-active {\n  background: #cfe8ff !important;\n}\n\n.em-viewer-body {\n  background: #f3f2f1 !important;\n}\n\n.em-viewer-paper {\n  border: 1px solid #e1dfdd !important;\n  border-radius: 2px !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) !important;\n}\n\n.em-viewer-toolbar {\n  background: #ffffff !important;\n  border-bottom: 1px solid #edebe9 !important;\n}\n\n.em-vt-btn:hover {\n  background: #f3f2f1 !important;\n}\n\n.em-sidebar-modules {\n  margin-left: 10px;\n  border: 1px solid #e1dfdd !important;\n  border-radius: 0 !important;\n  background: #faf9f8 !important;\n  box-shadow: none !important;\n}\n\n.em-sidebar-module-active {\n  background: #eaf3ff !important;\n  color: #0f6cbd !important;\n}\n\n/* Clean Outlook-like three-pane structure */\n.em-module {\n  padding: 10px 18px 0 18px !important;\n  background: #f5f6f8 !important;\n}\n\n.em-ribbon {\n  margin: 0 !important;\n  border: 1px solid #d9d9d9 !important;\n  border-bottom: 0 !important;\n  border-radius: 2px 2px 0 0 !important;\n  background: #ffffff !important;\n}\n\n.em-ribbon-tabs {\n  height: 34px !important;\n  padding-left: 22px !important;\n  background: #ffffff !important;\n}\n\n.em-ribbon-tab {\n  padding: 0 10px !important;\n  font-size: 13px !important;\n}\n\n.em-ribbon-content,\n.em-rb-content {\n  min-height: 82px !important;\n  max-height: 96px !important;\n  padding: 6px 12px 4px 22px !important;\n  overflow: hidden !important;\n  background: #ffffff !important;\n}\n\n.em-rb-group,\n.em-ribbon-group {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n\n.em-rb-big,\n.em-ribbon-btn {\n  min-width: 42px !important;\n}\n\n.em-module-body {\n  height: calc(100vh - 174px) !important;\n  min-height: 560px;\n  border: 1px solid #d9d9d9;\n  background: #ffffff !important;\n  overflow: hidden;\n}\n\n.em-sidebar {\n  width: 230px !important;\n  min-width: 230px !important;\n  margin: 0 !important;\n  border: 0 !important;\n  border-right: 1px solid #d9d9d9 !important;\n  border-radius: 0 !important;\n  background: #faf9f8 !important;\n  box-shadow: none !important;\n}\n\n.em-sidebar-newmail-row {\n  margin: 12px 12px 10px !important;\n}\n\n.em-sidebar-newmail {\n  height: 42px !important;\n  border-radius: 6px !important;\n  background: #0f6cbd !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.em-sidebar-search-btn {\n  min-height: 34px !important;\n  margin: 2px 12px !important;\n  padding: 7px 10px !important;\n  border-radius: 4px !important;\n  font-size: 13px !important;\n}\n\n.em-sidebar-section {\n  margin: 8px 12px 0 !important;\n  padding: 8px 0 !important;\n}\n\n.em-sidebar-section-title {\n  padding: 5px 8px !important;\n}\n\n.em-sidebar-folder {\n  min-height: 32px !important;\n  margin: 1px 0 !important;\n  padding: 6px 8px 6px 18px !important;\n  border-radius: 4px !important;\n  font-size: 13px !important;\n}\n\n.em-sidebar-folder-active,\n.em-sidebar-folder-active:hover {\n  background: #e7f1fb !important;\n  box-shadow: inset 3px 0 0 #0f6cbd !important;\n}\n\n.em-sidebar-modules {\n  margin: 0 !important;\n  border: 0 !important;\n  border-top: 1px solid #d9d9d9 !important;\n  border-radius: 0 !important;\n}\n\n.em-list {\n  width: 360px !important;\n  min-width: 360px !important;\n  border-right: 1px solid #d9d9d9 !important;\n  background: #ffffff !important;\n}\n\n.em-list-header {\n  height: 46px !important;\n  padding: 0 14px !important;\n  border-bottom: 1px solid #e1dfdd !important;\n  background: #ffffff !important;\n}\n\n.em-list-filters {\n  gap: 18px !important;\n}\n\n.em-list-filter {\n  height: 46px !important;\n  padding: 0 !important;\n  color: #323130 !important;\n  font-size: 14px !important;\n}\n\n.em-list-filter-active {\n  color: #0f6cbd !important;\n  font-weight: 600 !important;\n}\n\n.em-list-sort {\n  color: #605e5c !important;\n  font-size: 12px !important;\n}\n\n.em-mail-group {\n  padding: 8px 14px 5px !important;\n  color: #323130 !important;\n  background: #ffffff !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  border-bottom: 1px solid #edebe9 !important;\n}\n\n.em-mail-item {\n  min-height: 76px !important;\n  padding: 10px 10px 10px 14px !important;\n  border-left: 3px solid transparent !important;\n  border-bottom: 1px solid #edebe9 !important;\n  background: #ffffff !important;\n}\n\n.em-mail-item:hover {\n  background: #f8fbff !important;\n}\n\n.em-mail-active,\n.em-mail-active:hover {\n  background: #dbeeff !important;\n  border-left-color: #0f6cbd !important;\n}\n\n.em-mail-avatar {\n  width: 36px !important;\n  height: 36px !important;\n  font-size: 13px !important;\n}\n\n.em-mail-sender {\n  color: #111827 !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n\n.em-mail-date {\n  color: #0f6cbd !important;\n  font-size: 12px !important;\n}\n\n.em-mail-subject-line {\n  color: #0f6cbd !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n}\n\n.em-mail-preview-line {\n  color: #605e5c !important;\n  font-size: 12px !important;\n}\n\n.em-list-pager {\n  height: 38px !important;\n  border-top: 1px solid #e1dfdd !important;\n  background: #ffffff !important;\n}\n\n.em-viewer {\n  min-width: 0;\n  background: #ffffff !important;\n}\n\n.em-viewer-toolbar {\n  height: 44px !important;\n  padding: 0 16px !important;\n  border-bottom: 1px solid #e1dfdd !important;\n  background: #ffffff !important;\n}\n\n.em-vt-btn {\n  height: 32px !important;\n  padding: 0 9px !important;\n  border-radius: 4px !important;\n  color: #323130 !important;\n  font-size: 14px !important;\n}\n\n.em-vt-btn svg {\n  color: #605e5c !important;\n}\n\n.em-vt-btn:hover {\n  background: #f3f2f1 !important;\n}\n\n.em-viewer-header {\n  padding: 18px 22px 12px !important;\n  border-bottom: 1px solid #edebe9 !important;\n  background: #ffffff !important;\n}\n\n.em-viewer-subject {\n  margin: 0 0 14px !important;\n  color: #111827 !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 1.35 !important;\n}\n\n.em-viewer-avatar-lg {\n  width: 34px !important;\n  height: 34px !important;\n  background: #2563eb !important;\n  font-size: 12px !important;\n}\n\n.em-viewer-from-name {\n  color: #111827 !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n\n.em-viewer-from-addr,\n.em-viewer-date {\n  color: #605e5c !important;\n  font-size: 12px !important;\n}\n\n.em-viewer-webbanner {\n  min-height: 34px !important;\n  padding: 8px 22px !important;\n  border-bottom: 1px solid #edebe9 !important;\n  background: #ffffff !important;\n  color: #605e5c !important;\n  font-size: 12px !important;\n}\n\n.em-viewer-body {\n  padding: 26px 34px !important;\n  background: #f3f2f1 !important;\n}\n\n.em-viewer-paper {\n  max-width: 960px !important;\n  margin: 0 auto !important;\n  border: 1px solid #e1dfdd !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.em-viewer-frame {\n  background: #ffffff !important;\n}\n\n.em-crm {\n  border-left-color: #d9d9d9 !important;\n  background: #faf9f8 !important;\n}\n\n@media (max-width: 1200px) {\n  .em-list {\n    width: 330px !important;\n    min-width: 330px !important;\n  }\n\n  .em-sidebar {\n    width: 220px !important;\n    min-width: 220px !important;\n  }\n}\n\n#RecruiterTrackerReport_TableView {\n    position: relative;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableBody {\n    position: sticky;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {\n    position: sticky;\n    left: 0;\n    top: 0;\n    background-color: green;\n    z-index: 1008;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {\n    position: sticky;\n    left: 64px;\n    top: 0;\n    background-color: green;\n    z-index: 1008;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {\n    position: sticky;\n    left: 184px;\n    top: 0;\n    background-color: green;\n    z-index: 1008;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {\n    position: sticky;\n    left: 324px;\n    top: 0;\n    background-color: green;\n    z-index: 1008;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {\n    position: sticky;\n    left: 0;\n    top: 0;\n    background-color: #dfdfdf;\n    z-index: 1;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {\n    position: sticky;\n    left: 64px;\n    top: 0;\n    z-index: 1;\n    background-color: #dfdfdf;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {\n    position: sticky;\n    left: 184px;\n    top: 0;\n    z-index: 1;\n    justify-content: initial;\n    background-color: #dfdfdf;\n}\n\n#RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {\n    position: sticky;\n    left: 324px;\n    top: 0;\n    z-index: 1;\n    justify-content: initial;\n    background-color: #dfdfdf;\n}\n\n\n@media screen and (min-width: 100px) and (max-width: 768px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: 320%;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n}\n\n@media screen and (min-width: 769px) and (max-width: 1199px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(1) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(2) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(3) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableCol:nth-child(4) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(1) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(2) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(3) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n\n    #RecruiterTrackerReport_TableView .rdt_TableRow .rdt_TableCell:nth-child(4) {\n        position: initial;\n        left: initial;\n        top: initial;\n    }\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1399px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n}\n\n@media screen and (min-width: 1400px) and (max-width: 1599px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n}\n\n\n@media screen and (min-width: 1600px) and (max-width: 1799px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n}\n\n@media screen and (min-width: 1800px) and (max-width: 2099px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n}\n\n@media screen and (min-width: 2100px) and (max-width: 4099px) {\n    #RecruiterTrackerReport_TableView .rdt_Table {\n        min-width: initial;\n    }\n}\n/* =====================================================================\n   EMAIL MODULE — Outlook-style CSS\n   ===================================================================== */\n\n/* --- Layout --- */\n.em-module {\n  display: flex;\n  flex-direction: column;\n  /* Offset the fixed 70px app header so the ribbon is never clipped,\n     and fill the remaining viewport height so panels lay out cleanly. */\n  margin-top: 70px;\n  height: calc(100vh - 70px);\n  background: #f3f3f3;\n  font-family: \"Segoe UI\", \"San Francisco\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif;\n  font-size: 13px;\n  color: #1a1a1a;\n  overflow: hidden;\n  --em-accent: #2563eb;\n  --em-accent-hover: #1d4ed8;\n  --em-bg: #ffffff;\n  --em-bg-secondary: #fafafa;\n  --em-bg-tertiary: #f0f0f0;\n  --em-border: #e0e0e0;\n  --em-border-light: #ebebeb;\n  --em-text: #1a1a1a;\n  --em-text-secondary: #616161;\n  --em-text-muted: #999;\n  --em-hover: #eaeaea;\n  --em-active: #cce4ff;\n  --em-ribbon-bg: #f8f9fa;\n  --em-ribbon-border: #d0d0d0;\n  --em-sidebar-bg: #fafafa;\n  --em-unread-bg: #f5f7fa;\n  --em-reading-pane-bg: #fff;\n}\n\n/* --- Main Layout --- */\n.em-module-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* ===================== RIBBON ===================== */\n.em-ribbon {\n  background: var(--em-ribbon-bg);\n  border-bottom: 1px solid var(--em-ribbon-border);\n  user-select: none;\n  z-index: 10;\n}\n\n.em-ribbon-tabs {\n  display: flex;\n  align-items: stretch;\n  height: 32px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n  padding: 0 8px;\n}\n\n.em-ribbon-tab {\n  padding: 0 8px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  background: transparent;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  font-family: inherit;\n  transition: none;\n}\n\n.em-ribbon-tab:hover {\n  background: #eaeaea;\n}\n\n.em-ribbon-tab-active {\n  color: var(--em-text);\n  background: #f8f9fa;\n  border-bottom-color: var(--em-accent);\n  font-weight: 500;\n}\n\n.em-ribbon-content {\n  background: var(--em-ribbon-bg);\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 56px;\n}\n\n.em-ribbon-group {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 8px;\n  border-right: 1px solid var(--em-border);\n}\n\n.em-ribbon-group:last-child {\n  border-right: none;\n}\n\n.em-ribbon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1px;\n  padding: 3px 8px;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  color: var(--em-text);\n  font-family: inherit;\n  font-size: 11px;\n  min-width: 44px;\n  text-align: center;\n  transition: none;\n}\n\n.em-ribbon-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-ribbon-btn:active {\n  background: #ccc;\n}\n\n.em-ribbon-btn svg {\n  display: block;\n}\n\n.em-ribbon-btn-label {\n  font-size: 10px;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.em-ribbon-new-btn {\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  padding: 4px 16px 4px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.em-ribbon-new-btn:hover {\n  background: #004578;\n}\n\n.em-ribbon-search {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 2px;\n  padding: 0 6px;\n  height: 24px;\n  margin-left: auto;\n  min-width: 180px;\n}\n\n.em-ribbon-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 0 4px;\n  flex: 1;\n  color: var(--em-text);\n}\n\n.em-ribbon-search input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-ribbon-quickbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n  padding: 2px 8px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-ribbon-quickbar em {\n  font-style: normal;\n  font-weight: 600;\n  margin: 0 2px;\n}\n\n/* ===================== SIDEBAR ===================== */\n.em-sidebar {\n  width: 200px;\n  min-width: 200px;\n  background: var(--em-sidebar-bg);\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.em-sidebar-newmail {\n  margin: 8px 8px 4px;\n  padding: 6px 12px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: none;\n}\n\n.em-sidebar-newmail:hover {\n  background: #004578;\n}\n\n.em-sidebar-search-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 28px;\n  padding: 5px 12px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-size: 12.5px;\n  margin: 1px 6px;\n  border-radius: 4px;\n}\n\n.em-sidebar-search-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-section {\n  padding: 6px 0;\n  margin-top: 4px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-sidebar-section-title {\n  padding: 4px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.em-sidebar-folder {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 28px;\n  padding: 5px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin: 1px 6px;\n  position: relative;\n  color: var(--em-text);\n  font-size: 13px;\n}\n\n.em-sidebar-folder:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-folder-active {\n  background: var(--em-active) !important;\n  font-weight: 600;\n  box-shadow: inset 3px 0 0 #0e527d;\n}\n\n.em-sidebar-folder-icon {\n  width: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n}\n\n.em-sidebar-folder-active .em-sidebar-folder-icon {\n  color: var(--em-accent);\n}\n\n.em-sidebar-folder-label {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-sidebar-folder-count {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  margin-left: auto;\n  padding-left: 4px;\n}\n\n.em-sidebar-folder-count-primary {\n  color: #005a9e;\n  font-weight: 600;\n}\n\n.em-sidebar-more-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 16px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-size: 11px;\n  margin: 0 4px;\n  border-radius: 3px;\n}\n\n.em-sidebar-more-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-labels {\n  padding: 2px 0;\n}\n\n.em-sidebar-label-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 16px;\n  cursor: pointer;\n  border-radius: 3px;\n  margin: 0 4px;\n}\n\n.em-sidebar-label-item:hover {\n  background: var(--em-hover);\n}\n\n.em-sidebar-label-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.em-sidebar-footer {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--em-border);\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n/* ===================== EMAIL LIST ===================== */\n.em-list {\n  width: 360px;\n  min-width: 300px;\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-list-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n  min-height: 28px;\n}\n\n.em-list-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-list-toolbar-left input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.em-list-toolbar-label {\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.em-list-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n.em-list-range {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  white-space: nowrap;\n}\n\n.em-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 4px;\n  background: #fff;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n}\n\n.em-page-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n  color: var(--em-text-primary, #111);\n}\n\n.em-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.em-list-column-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n}\n\n.em-list-col-sort {\n  font-weight: 500;\n}\n\n.em-list-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.em-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--em-text-muted);\n  gap: 4px;\n}\n\n.em-list-empty h3 {\n  margin: 8px 0 0;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--em-text-secondary);\n}\n\n.em-list-empty p {\n  margin: 0;\n  font-size: 13px;\n}\n\n/* --- Mail Item --- */\n.em-mail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  cursor: pointer;\n  transition: none;\n}\n\n.em-mail-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-mail-active {\n  background: var(--em-active) !important;\n}\n\n.em-mail-unread {\n  background: var(--em-unread-bg);\n}\n\n.em-mail-unread .em-mail-sender {\n  font-weight: 700;\n}\n\n.em-mail-unread .em-mail-subject {\n  font-weight: 600;\n}\n\n.em-mail-chk {\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.em-mail-star {\n  flex-shrink: 0;\n  margin-top: 3px;\n  cursor: pointer;\n  line-height: 0;\n  min-width: 15px;\n}\n\n.em-mail-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.em-mail-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-mail-row1 {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  line-height: 1.3;\n}\n\n.em-mail-sender {\n  font-size: 13px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n.em-mail-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.em-mail-row2 {\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n  line-height: 1.3;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.em-mail-subject {\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n  max-width: 50%;\n}\n\n.em-mail-preview {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--em-text-muted);\n}\n\n.em-mail-flags {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.em-mail-attach-icon {\n  color: var(--em-text-secondary);\n}\n\n.em-mail-unread-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2563eb;\n  display: inline-block;\n}\n\n/* --- Skeleton --- */\n.em-mail-item-skeleton {\n  cursor: default;\n}\n\n.em-skeleton {\n  background: #e8e8e8;\n  border-radius: 3px;\n  animation: skeleton-pulse 1.2s ease-in-out infinite;\n}\n\n.em-skeleton-check {\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.em-skeleton-star {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n\n.em-skeleton-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.em-skeleton-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 2px 0;\n}\n\n.em-skeleton-line {\n  height: 12px;\n}\n\n.w-50 { width: 50%; }\n.w-80 { width: 80%; }\n\n@keyframes skeleton-pulse {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.em-loading-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n}\n\n.em-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--em-border);\n  border-top-color: var(--em-accent);\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ===================== VIEWER (Reading Pane) ===================== */\n.em-viewer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--em-reading-pane-bg);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-viewer-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-viewer-empty-content {\n  text-align: center;\n  color: var(--em-text-muted);\n}\n\n.em-viewer-empty-content h3 {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--em-text-secondary);\n  margin: 8px 0 4px;\n}\n\n.em-viewer-empty-content p {\n  margin: 0;\n  font-size: 12px;\n}\n\n/* --- Viewer Toolbar --- */\n.em-viewer-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n  flex-wrap: wrap;\n  min-height: 32px;\n}\n\n.em-vtb-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  font-family: inherit;\n  border-radius: 3px;\n  height: 26px;\n  transition: none;\n}\n\n.em-vtb-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-vtb-btn span {\n  font-size: 11px;\n}\n\n.em-vtb-divider {\n  width: 1px;\n  height: 20px;\n  background: var(--em-border);\n  margin: 0 2px;\n}\n\n.em-vtb-right {\n  margin-left: auto;\n}\n\n.em-vtb-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-vtb-close-btn:hover {\n  background: #e5e5e5;\n}\n\n/* --- Viewer Header --- */\n.em-viewer-header {\n  padding: 12px 16px 8px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-viewer-subject-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.em-viewer-subject {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.em-viewer-thread-badge {\n  background: var(--em-bg-tertiary);\n  padding: 0 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-viewer-from-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.em-viewer-avatar-lg {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-viewer-from-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-viewer-from-name {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.em-viewer-from-addr {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-viewer-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n/* Reply / Reply All / Forward moved into the header (top-right, Outlook style) */\n.em-viewer-header-right {\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.em-viewer-header-actions {\n  display: flex;\n  gap: 6px;\n}\n.em-viewer-hdr-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0e527d;\n  background: #fff;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.em-viewer-hdr-btn:hover {\n  background: #eaf3f9;\n  border-color: #cfe3ef;\n}\n.em-viewer-hdr-btn svg { color: #0e527d; }\n\n/* --- Viewer Body --- */\n.em-viewer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.em-viewer-html-body {\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.em-viewer-html-body blockquote {\n  margin: 8px 0;\n  padding: 0 0 0 8px;\n  border-left: 2px solid #ccc;\n  color: #666;\n}\n\n.em-viewer-text-body {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* --- Attachments --- */\n.em-viewer-attachments {\n  border-top: 1px solid var(--em-border-light);\n  padding: 8px 16px;\n}\n\n.em-viewer-att-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--em-text-secondary);\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.em-viewer-att-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.em-viewer-att-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  background: var(--em-bg-secondary);\n  min-width: 160px;\n}\n\n.em-viewer-att-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-viewer-att-name {\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-viewer-att-size {\n  font-size: 10px;\n  color: var(--em-text-muted);\n}\n\n.em-viewer-att-dl {\n  color: var(--em-accent);\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n/* --- Actions Bar --- */\n.em-viewer-actions-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 16px;\n  border-top: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-viewer-act-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text);\n  font-family: inherit;\n  border-radius: 3px;\n}\n\n.em-viewer-act-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-viewer-act-primary {\n  font-weight: 600;\n}\n\n/* ===================== COMPOSE ===================== */\n.em-compose-overlay {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 600px;\n  max-width: calc(100vw - 80px);\n  max-height: 90vh;\n  z-index: 1000;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.08);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.em-compose-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #005a9e;\n  color: #fff;\n  border-radius: 8px 8px 0 0;\n  cursor: move;\n  user-select: none;\n}\n\n.em-compose-header h3 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.em-compose-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.em-compose-header-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: rgba(255,255,255,0.8);\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.em-compose-header-btn:hover {\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n}\n\n.em-compose-body {\n  display: flex;\n  flex-direction: column;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.em-compose-field {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--em-border-light);\n  padding: 0 4px;\n}\n\n.em-compose-field-label {\n  width: 44px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n  padding: 6px 4px;\n}\n\n.em-compose-field-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 6px 4px;\n  color: var(--em-text);\n  background: transparent;\n}\n\n.em-compose-field-input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-compose-to-field {\n  position: relative;\n}\n\n.em-compose-candidate-list {\n  position: absolute;\n  top: 100%;\n  left: 44px;\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n  max-height: 180px;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.em-compose-candidate-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.em-compose-candidate-item:hover {\n  background: var(--em-active);\n}\n\n.em-compose-candidate-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--em-accent);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.em-compose-candidate-info {\n  flex: 1;\n}\n\n.em-compose-candidate-name {\n  font-size: 12px;\n  color: var(--em-text);\n}\n\n.em-compose-candidate-email {\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n.em-compose-tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 0;\n  flex: 1;\n}\n\n.em-compose-tag {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: #e8effa;\n  border-radius: 3px;\n  padding: 2px 6px;\n  font-size: 11px;\n  color: var(--em-accent);\n}\n\n.em-compose-tag-remove {\n  cursor: pointer;\n  opacity: 0.6;\n  display: flex;\n  align-items: center;\n}\n\n.em-compose-tag-remove:hover {\n  opacity: 1;\n}\n\n.em-compose-tag-input {\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 2px;\n  flex: 1;\n  min-width: 60px;\n  background: transparent;\n}\n\n.em-compose-cc-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 4px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-compose-toggle-cc {\n  font-size: 11px;\n  color: var(--em-accent);\n  cursor: pointer;\n  padding: 4px;\n  user-select: none;\n}\n\n.em-compose-toggle-cc:hover {\n  text-decoration: underline;\n}\n\n.em-compose-subject-field input {\n  border: none;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  padding: 6px 8px;\n  width: 100%;\n  color: var(--em-text);\n  background: transparent;\n}\n\n.em-compose-subject-field input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-compose-editor {\n  padding: 8px;\n  min-height: 180px;\n  flex: 1;\n}\n\n.em-compose-editor textarea {\n  width: 100%;\n  height: 100%;\n  min-height: 180px;\n  border: none;\n  outline: none;\n  resize: vertical;\n  font-family: \"Segoe UI\", sans-serif;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--em-text);\n}\n\n.em-compose-editor textarea::placeholder {\n  color: var(--em-text-muted);\n}\n\n/* Read-only \"Original Message\" / \"Forwarded Message\" block — kept visually\n   and structurally separate from the editable reply textarea above it. */\n.em-compose-quote {\n  margin: 0 8px 8px;\n  border-top: 1px solid var(--em-border-light);\n  padding-top: 10px;\n}\n\n.em-compose-quote-sep {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--em-text-muted);\n  letter-spacing: 0.02em;\n  margin-bottom: 8px;\n}\n\n.em-compose-quote-meta {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  line-height: 1.6;\n  margin-bottom: 8px;\n}\n\n.em-compose-quote-body {\n  border: 1px solid var(--em-border-light);\n  border-radius: 6px;\n  overflow: hidden;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.em-compose-quote-body .em-viewer-frame {\n  width: 100%;\n  border: none;\n  display: block;\n}\n\n.em-compose-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-top: 1px solid var(--em-border-light);\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-compose-tool-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-tool-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-tool-btn-active {\n  background: #cce4ff;\n  border-color: #a8cff5;\n}\n\n.em-compose-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-compose-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.em-compose-send-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 20px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.em-compose-send-btn:hover {\n  background: #004578;\n}\n\n.em-compose-send-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.em-compose-attach-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-attach-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-trash-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-compose-trash-btn:hover {\n  background: #e5e5e5;\n  border-color: #d0d0d0;\n}\n\n.em-compose-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n/* ===================== SEARCH OVERLAY ===================== */\n.em-search-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.08); /* light scrim — keep the page bright, don't darken it */\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  padding-top: 80px;\n}\n\n.em-search-panel {\n  width: 600px;\n  max-width: calc(100vw - 40px);\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  max-height: 400px;\n  overflow: hidden;\n}\n\n.em-search-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-search-header input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--em-text);\n}\n\n.em-search-header input::placeholder {\n  color: var(--em-text-muted);\n}\n\n.em-search-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-search-close:hover {\n  background: #e5e5e5;\n}\n\n.em-search-results {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.em-search-result-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.em-search-result-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-search-result-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--em-accent);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.em-search-result-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-search-result-sender {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.em-search-result-subject {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n.em-search-result-preview {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.em-search-result-date {\n  font-size: 11px;\n  color: var(--em-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.em-search-empty {\n  padding: 24px;\n  text-align: center;\n  color: var(--em-text-muted);\n  font-size: 13px;\n}\n\n/* ===================== CONTEXT MENU ===================== */\n.em-context-menu {\n  position: fixed;\n  z-index: 2000;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  padding: 4px 0;\n  min-width: 160px;\n}\n\n.em-context-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--em-text);\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n}\n\n.em-context-menu-item:hover {\n  background: var(--em-active);\n}\n\n.em-context-menu-divider {\n  height: 1px;\n  background: var(--em-border);\n  margin: 4px 0;\n}\n\n/* ===================== RESPONSIVE ===================== */\n@media (max-width: 768px) {\n  .em-module-body {\n    flex-direction: column;\n  }\n\n  .em-sidebar {\n    width: 100%;\n    min-width: unset;\n    max-height: 200px;\n    border-right: none;\n    border-bottom: 1px solid var(--em-border);\n  }\n\n  .em-list {\n    width: 100%;\n    min-width: unset;\n    border-right: none;\n    border-bottom: 1px solid var(--em-border);\n  }\n\n  .em-compose-overlay {\n    right: 0;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 0;\n  }\n\n  .em-ribbon-content {\n    flex-wrap: wrap;\n    min-height: 40px;\n  }\n\n  .em-ribbon-search {\n    min-width: 120px;\n  }\n}\n\n/* ===================== SCROLLBARS ===================== */\n.em-list-body::-webkit-scrollbar,\n.em-sidebar::-webkit-scrollbar,\n.em-viewer-body::-webkit-scrollbar,\n.em-compose-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.em-list-body::-webkit-scrollbar-track,\n.em-sidebar::-webkit-scrollbar-track,\n.em-viewer-body::-webkit-scrollbar-track,\n.em-compose-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.em-list-body::-webkit-scrollbar-thumb,\n.em-sidebar::-webkit-scrollbar-thumb,\n.em-viewer-body::-webkit-scrollbar-thumb,\n.em-compose-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.em-list-body::-webkit-scrollbar-thumb:hover,\n.em-sidebar::-webkit-scrollbar-thumb:hover,\n.em-viewer-body::-webkit-scrollbar-thumb:hover,\n.em-compose-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Firefox */\n.em-list-body,\n.em-sidebar,\n.em-viewer-body,\n.em-compose-body {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 transparent;\n}\n\n/* ===================== TOAST ===================== */\n.em-toast {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-size: 13px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  animation: em-toast-in 0.25s ease-out;\n  background: #323130;\n  color: #fff;\n}\n\n.em-toast-success {\n  background: #005a9e;\n  color: #fff;\n}\n\n.em-toast-error {\n  background: #d32f2f;\n  color: #fff;\n}\n\n.em-toast-warning {\n  background: #b26a00;\n  color: #fff;\n}\n\n.em-toast-info {\n  background: #323130;\n  color: #fff;\n}\n\n@keyframes em-toast-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ===================== SEARCH FILTERS ===================== */\n.em-search-filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n}\n\n.em-search-filter-btn:hover {\n  background: #e5e5e5;\n}\n\n.em-search-filters {\n  padding: 12px 16px;\n  border-top: 1px solid var(--em-border-light);\n}\n\n.em-search-filters-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.em-search-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.em-search-filter-field label {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n}\n\n.em-search-filter-field input {\n  padding: 4px 8px;\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  outline: none;\n  color: var(--em-text);\n  background: var(--em-bg);\n}\n\n.em-search-filter-field input:focus {\n  border-color: var(--em-accent);\n}\n\n.em-search-filter-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.em-search-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.em-search-toggle input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.em-search-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.em-search-apply-btn {\n  padding: 4px 16px;\n  background: var(--em-accent);\n  color: #fff;\n  border: 1px solid var(--em-accent-hover);\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.em-search-apply-btn:hover {\n  background: var(--em-accent-hover);\n}\n\n.em-search-clear-btn {\n  padding: 4px 16px;\n  background: transparent;\n  color: var(--em-text-secondary);\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.em-search-clear-btn:hover {\n  background: var(--em-bg-tertiary);\n}\n\n/* =====================================================================\n   RIBBON POLISH (alignment)\n   ===================================================================== */\n.em-ribbon-content {\n  min-height: 60px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n}\n\n.em-ribbon-content::-webkit-scrollbar {\n  height: 6px;\n}\n\n.em-ribbon-content::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.em-ribbon-quickbar-btn {\n  border: none;\n  background: transparent;\n  font-size: 11px;\n  padding: 0 4px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  font-family: inherit;\n  border-radius: 3px;\n}\n\n.em-ribbon-quickbar-btn:hover {\n  background: #e5e5e5;\n  color: var(--em-text);\n}\n\n.em-ribbon-search {\n  cursor: pointer;\n}\n\n.em-ribbon-search input {\n  cursor: pointer;\n}\n\n.em-ribbon-view-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--em-accent);\n  padding: 0 4px;\n}\n\n/* =====================================================================\n   OUTLOOK TOP BAR (Row 1: quick-access / title bar)\n   ===================================================================== */\n.em-topbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 8px;\n  background: #f3f3f3;\n  border-bottom: 1px solid var(--em-ribbon-border);\n}\n\n.em-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.em-topbar-logo {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  background: linear-gradient(135deg, #0364b8, #0a2767);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 4px;\n  flex-shrink: 0;\n}\n\n.em-topbar-icon {\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #444;\n}\n\n.em-topbar-icon:hover {\n  background: #e5e5e5;\n}\n\n.em-topbar-people {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  border: 1px solid var(--em-border);\n  background: #fff;\n  border-radius: 3px;\n  padding: 0 4px;\n  height: 24px;\n  margin-left: 6px;\n  color: var(--em-text-muted);\n}\n\n.em-topbar-people input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 12px;\n  font-family: inherit;\n  width: 96px;\n  color: var(--em-text);\n  cursor: pointer;\n}\n\n.em-topbar-search {\n  flex: 1;\n  max-width: 620px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 26px;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 0 10px;\n  color: var(--em-text-muted);\n  cursor: pointer;\n}\n\n.em-topbar-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13px;\n  font-family: inherit;\n  flex: 1;\n  color: var(--em-text);\n  cursor: pointer;\n}\n\n.em-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: auto;\n}\n\n.em-topbar-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #0a8577;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.em-topbar-win {\n  width: 32px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #444;\n}\n\n.em-topbar-win:hover {\n  background: #e5e5e5;\n}\n\n.em-topbar-win-close:hover {\n  background: #d13438;\n  color: #fff;\n}\n\n/* Ribbon: quick steps + small buttons + people search */\n.em-ribbon-new-btn .em-ribbon-btn-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.em-ribbon-btn-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  justify-content: center;\n}\n\n.em-ribbon-btn-sm {\n  min-width: 0;\n  flex-direction: row;\n  gap: 1px;\n  padding: 3px 5px;\n}\n\n.em-ribbon-group-quicksteps {\n  gap: 0;\n}\n\n.em-ribbon-step {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid var(--em-border);\n  border-radius: 3px;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 11px;\n  color: var(--em-text);\n  max-width: 130px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.em-ribbon-step + .em-ribbon-step {\n  border-left: none;\n}\n\n.em-ribbon-step:hover {\n  background: #eaf2fb;\n  border-color: #a8cff5;\n}\n\n.em-ribbon-step span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-ribbon-search-people {\n  min-width: 130px;\n  height: 22px;\n}\n\n.em-ribbon-search-people input {\n  cursor: pointer;\n}\n\n.em-ribbon-group-last {\n  border-right: none;\n}\n\n@media (max-width: 1100px) {\n  .em-ribbon-group-quicksteps,\n  .em-ribbon-search-people {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .em-topbar-people {\n    display: none;\n  }\n  .em-topbar-search {\n    max-width: none;\n  }\n}\n\n/* =====================================================================\n   MODULE NAV RAIL (Outlook module switcher)\n   ===================================================================== */\n.em-nav-rail {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  background: transparent;\n  border: none;\n  flex-shrink: 0;\n}\n\n/* The visible bar wraps only the icons, so it can never stretch full-width. */\n.em-nav-rail-top,\n.em-nav-rail-bottom {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: auto;\n  background: #f0f2f5;\n  border-top: 1px solid var(--em-border);\n  border-right: 1px solid var(--em-border);\n  border-top-right-radius: 8px;\n  padding: 5px 14px;\n}\n\n.em-nav-rail-btn {\n  width: auto;\n  height: auto;\n  padding: 6px 9px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  font-family: inherit;\n  position: relative;\n}\n\n.em-nav-rail-btn:hover {\n  background: #e2e6ea;\n  color: var(--em-text);\n}\n\n.em-nav-rail-btn-active {\n  background: #dbe7ff;\n  color: var(--em-accent);\n}\n\n.em-nav-rail-btn-active::before {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: -5px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--em-accent);\n}\n\n.em-nav-rail-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.em-nav-rail-label {\n  display: none;\n}\n\n.em-nav-rail-badge {\n  position: absolute;\n  top: -6px;\n  right: -10px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  border-radius: 9px;\n  padding: 1px 4px;\n  min-width: 16px;\n  text-align: center;\n  line-height: 1.3;\n}\n\n/* =====================================================================\n   CALENDAR\n   ===================================================================== */\n.em-cal {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-cal-sidebar {\n  width: 240px;\n  min-width: 240px;\n  border-right: 1px solid var(--em-border);\n  background: var(--em-sidebar-bg);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding-bottom: 12px;\n}\n\n.em-cal-new-btn {\n  justify-content: center;\n}\n\n.em-cal-mini {\n  padding: 8px 12px;\n}\n\n.em-cal-mini-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--em-text);\n  margin-bottom: 6px;\n}\n\n.em-cal-mini-nav {\n  display: flex;\n  gap: 2px;\n}\n\n.em-cal-mini-nav button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  border-radius: 3px;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-cal-mini-nav button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-mini-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1px;\n}\n\n.em-cal-mini-dow {\n  text-align: center;\n  font-size: 10px;\n  color: var(--em-text-muted);\n  padding: 2px 0;\n  font-weight: 600;\n}\n\n.em-cal-mini-day {\n  position: relative;\n  aspect-ratio: 1;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 11px;\n  color: var(--em-text);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n\n.em-cal-mini-day:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-mini-day-muted {\n  color: var(--em-text-muted);\n}\n\n.em-cal-mini-day-today {\n  background: var(--em-accent);\n  color: #fff;\n  font-weight: 600;\n}\n\n.em-cal-mini-day-today:hover {\n  background: var(--em-accent-hover);\n}\n\n.em-cal-mini-day-sel {\n  outline: 1px solid var(--em-accent);\n}\n\n.em-cal-mini-dot {\n  position: absolute;\n  bottom: 2px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.em-cal-upcoming {\n  padding: 4px 4px 0;\n}\n\n.em-cal-upcoming-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 6px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin: 0 4px;\n}\n\n.em-cal-upcoming-item:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-upcoming-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.em-cal-upcoming-info {\n  min-width: 0;\n}\n\n.em-cal-upcoming-title {\n  font-size: 12px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-cal-upcoming-time {\n  font-size: 11px;\n  color: var(--em-text-muted);\n}\n\n.em-cal-upcoming-empty {\n  padding: 8px 16px;\n  font-size: 12px;\n  color: var(--em-text-muted);\n}\n\n/* Calendar main */\n.em-cal-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.em-cal-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--em-border-light);\n  background: var(--em-bg);\n}\n\n.em-cal-today-btn {\n  padding: 5px 14px;\n  border: 1px solid var(--em-border);\n  background: var(--em-bg);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text);\n  font-weight: 500;\n}\n\n.em-cal-today-btn:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-nav {\n  display: flex;\n  gap: 2px;\n}\n\n.em-cal-nav button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.em-cal-nav button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--em-text);\n  flex: 1;\n}\n\n.em-cal-view-switch {\n  display: flex;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.em-cal-view-switch button {\n  border: none;\n  background: var(--em-bg);\n  padding: 5px 14px;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text-secondary);\n  border-right: 1px solid var(--em-border);\n}\n\n.em-cal-view-switch button:last-child {\n  border-right: none;\n}\n\n.em-cal-view-switch button:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-view-active {\n  background: var(--em-accent) !important;\n  color: #fff !important;\n}\n\n/* Month grid */\n.em-cal-month {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.em-cal-month-dow {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-cal-month-dow-cell {\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  text-align: right;\n  text-transform: uppercase;\n}\n\n.em-cal-month-grid {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-auto-rows: 1fr;\n  overflow-y: auto;\n}\n\n.em-cal-cell {\n  border-right: 1px solid var(--em-border-light);\n  border-bottom: 1px solid var(--em-border-light);\n  padding: 4px;\n  min-height: 92px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n}\n\n.em-cal-cell:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-cell-muted {\n  background: #fafafa;\n}\n\n.em-cal-cell-muted .em-cal-cell-date {\n  color: var(--em-text-muted);\n}\n\n.em-cal-cell-date {\n  font-size: 12px;\n  color: var(--em-text);\n  text-align: right;\n  padding: 2px 4px;\n}\n\n.em-cal-cell-month {\n  font-weight: 600;\n  color: var(--em-accent);\n}\n\n.em-cal-cell-today-num {\n  background: var(--em-accent);\n  color: #fff;\n  border-radius: 50%;\n  padding: 1px 6px;\n  font-weight: 600;\n}\n\n.em-cal-cell-events {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n}\n\n.em-cal-event-chip {\n  color: #fff;\n  font-size: 11px;\n  padding: 1px 6px;\n  border-radius: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.em-cal-event-time {\n  font-weight: 700;\n  opacity: 0.9;\n}\n\n.em-cal-event-more {\n  font-size: 10px;\n  color: var(--em-text-secondary);\n  padding-left: 4px;\n}\n\n/* Week view */\n.em-cal-week {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  overflow-y: auto;\n}\n\n.em-cal-week-col {\n  border-right: 1px solid var(--em-border-light);\n  display: flex;\n  flex-direction: column;\n}\n\n.em-cal-week-col-today {\n  background: #f5f9ff;\n}\n\n.em-cal-week-head {\n  text-align: center;\n  padding: 8px 4px;\n  border-bottom: 1px solid var(--em-border-light);\n  cursor: pointer;\n}\n\n.em-cal-week-head:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-week-dow {\n  display: block;\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  text-transform: uppercase;\n}\n\n.em-cal-week-num {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.em-cal-week-body {\n  flex: 1;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 200px;\n  cursor: pointer;\n}\n\n.em-cal-week-event {\n  background: var(--em-bg-secondary);\n  border-left: 3px solid var(--em-accent);\n  border-radius: 3px;\n  padding: 4px 6px;\n  cursor: pointer;\n}\n\n.em-cal-week-event:hover {\n  background: var(--em-hover);\n}\n\n.em-cal-week-event-time {\n  font-size: 10px;\n  color: var(--em-text-secondary);\n}\n\n.em-cal-week-event-title {\n  font-size: 12px;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-cal-week-empty {\n  color: var(--em-text-muted);\n  font-size: 11px;\n  opacity: 0;\n}\n\n.em-cal-week-body:hover .em-cal-week-empty {\n  opacity: 1;\n}\n\n/* Day view */\n.em-cal-day {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 24px;\n}\n\n.em-cal-day-add {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--em-accent);\n  font-size: 13px;\n  cursor: pointer;\n  padding: 8px;\n  border: 1px dashed var(--em-border);\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.em-cal-day-add:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-day-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--em-text-muted);\n  padding: 48px;\n  gap: 8px;\n}\n\n.em-cal-day-event {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  align-items: stretch;\n}\n\n.em-cal-day-event:hover {\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-day-event-time {\n  width: 60px;\n  flex-shrink: 0;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n}\n\n.em-cal-day-event-end {\n  color: var(--em-text-muted);\n  font-size: 11px;\n}\n\n.em-cal-day-event-bar {\n  width: 4px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.em-cal-day-event-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--em-text);\n}\n\n.em-cal-day-event-loc,\n.em-cal-day-event-desc {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n/* Event / contact modal */\n.em-cal-modal {\n  width: 460px;\n  max-width: calc(100vw - 40px);\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  align-self: flex-start;\n}\n\n.em-cal-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #005a9e;\n  color: #fff;\n}\n\n.em-cal-modal-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.em-cal-modal-header .em-search-close {\n  color: rgba(255,255,255,0.85);\n}\n\n.em-cal-modal-header .em-search-close:hover {\n  background: rgba(255,255,255,0.15);\n}\n\n.em-cal-modal-body {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.em-cal-modal-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--em-text-secondary);\n  border-bottom: 1px solid var(--em-border-light);\n  padding-bottom: 8px;\n}\n\n.em-cal-modal-field-top {\n  align-items: flex-start;\n}\n\n.em-cal-modal-field input,\n.em-cal-modal-field textarea {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--em-text);\n  background: transparent;\n  flex: 1;\n  min-width: 0;\n}\n\n.em-cal-modal-field input[type=\"date\"],\n.em-cal-modal-field input[type=\"time\"] {\n  flex: 0 0 auto;\n}\n\n.em-cal-modal-field textarea {\n  resize: vertical;\n}\n\n.em-cal-modal-dash {\n  color: var(--em-text-muted);\n}\n\n.em-cal-modal-allday {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  padding-left: 26px;\n}\n\n.em-cal-modal-colors {\n  display: flex;\n  gap: 6px;\n}\n\n.em-cal-color-swatch {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.em-cal-color-swatch-active {\n  border-color: #1a1a1a;\n  outline: 1px solid #fff;\n  outline-offset: -3px;\n}\n\n.em-cal-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid var(--em-border-light);\n  background: var(--em-bg-secondary);\n}\n\n.em-cal-modal-footer-right {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.em-cal-modal-delete {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #dc2626;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  border-radius: 3px;\n  padding: 4px 10px;\n}\n\n.em-cal-modal-delete:hover {\n  background: #fdecec;\n}\n\n/* =====================================================================\n   PEOPLE / CONTACTS\n   ===================================================================== */\n.em-people {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-people-list {\n  width: 320px;\n  min-width: 280px;\n  border-right: 1px solid var(--em-border);\n  display: flex;\n  flex-direction: column;\n  background: var(--em-bg);\n}\n\n.em-people-toolbar {\n  padding: 8px;\n  border-bottom: 1px solid var(--em-border-light);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.em-people-new {\n  margin: 0;\n  justify-content: center;\n}\n\n.em-people-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 5px 8px;\n  color: var(--em-text-muted);\n}\n\n.em-people-search input {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  flex: 1;\n  background: transparent;\n  color: var(--em-text);\n}\n\n.em-people-scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.em-people-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-people-item:hover {\n  background: var(--em-bg-tertiary);\n}\n\n.em-people-item-active {\n  background: var(--em-active) !important;\n}\n\n.em-people-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-people-item-info {\n  min-width: 0;\n}\n\n.em-people-item-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--em-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-people-item-email {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.em-people-empty,\n.em-tasks-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 48px 24px;\n  color: var(--em-text-muted);\n  text-align: center;\n}\n\n.em-people-empty p,\n.em-tasks-empty p {\n  margin: 8px 0 0;\n  font-size: 15px;\n  color: var(--em-text-secondary);\n}\n\n.em-people-empty span,\n.em-tasks-empty span {\n  font-size: 12px;\n}\n\n.em-people-detail {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  background: var(--em-bg-secondary);\n}\n\n.em-people-detail-empty {\n  color: var(--em-text-muted);\n}\n\n.em-people-card {\n  align-self: flex-start;\n  width: 100%;\n  max-width: 560px;\n  margin: 32px auto;\n  background: #fff;\n  border: 1px solid var(--em-border-light);\n  border-radius: 8px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\n.em-people-card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 24px;\n  background: linear-gradient(180deg, #eaf1fb, #fff);\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-people-card-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.em-people-card-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.em-people-card-title {\n  font-size: 13px;\n  color: var(--em-text-secondary);\n}\n\n.em-people-card-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 4px;\n}\n\n.em-people-card-actions button,\n.em-people-card-actions a {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--em-border);\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.em-people-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 100%;\n  padding: 48px 24px;\n  color: var(--em-text-muted);\n  text-align: center;\n}\n.em-people-empty-state p { margin: 8px 0 0; font-size: 15px; color: var(--em-text-secondary); }\n.em-people-empty-state span { font-size: 12px; max-width: 320px; }\n\n.em-muted { color: var(--em-text-muted); font-size: 12px; }\n\n.em-people-card-actions button:hover,\n.em-people-card-actions a:hover {\n  background: var(--em-hover);\n}\n\n.em-people-card-body {\n  padding: 16px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.em-people-card-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: var(--em-text);\n}\n\n.em-people-card-row svg {\n  color: var(--em-text-secondary);\n  flex-shrink: 0;\n}\n\n.em-people-card-row a,\n.em-people-link-btn {\n  color: var(--em-accent);\n  text-decoration: none;\n}\n\n.em-people-card-row a:hover,\n.em-people-link-btn:hover {\n  text-decoration: underline;\n}\n\n.em-people-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n/* =====================================================================\n   TASKS / TO DO\n   ===================================================================== */\n.em-tasks {\n  flex: 1;\n  display: flex;\n  min-width: 0;\n  background: var(--em-bg);\n  overflow: hidden;\n}\n\n.em-tasks-sidebar {\n  width: 220px;\n  min-width: 200px;\n  border-right: 1px solid var(--em-border);\n  background: var(--em-sidebar-bg);\n  padding-bottom: 8px;\n  overflow-y: auto;\n}\n\n.em-tasks-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: linear-gradient(180deg, #eef3fb, #fff 220px);\n}\n\n.em-tasks-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 20px 24px 12px;\n  color: var(--em-accent);\n}\n\n.em-tasks-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--em-text);\n}\n\n.em-tasks-add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 24px 12px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--em-border);\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  color: var(--em-text-secondary);\n}\n\n.em-tasks-add > input:first-of-type {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: inherit;\n  background: transparent;\n  color: var(--em-text);\n}\n\n.em-tasks-add-due {\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 4px 6px;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--em-text-secondary);\n  outline: none;\n}\n\n.em-tasks-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 24px 24px;\n}\n\n.em-tasks-done-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--em-text-secondary);\n  margin: 16px 0 8px;\n}\n\n.em-task-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid var(--em-border-light);\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 6px;\n}\n\n.em-task-row:hover {\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n}\n\n.em-task-check {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-accent);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.em-task-row-done .em-task-check {\n  color: #059669;\n}\n\n.em-task-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.em-task-title {\n  font-size: 14px;\n  color: var(--em-text);\n}\n\n.em-task-row-done .em-task-title {\n  text-decoration: line-through;\n  color: var(--em-text-muted);\n}\n\n.em-task-due {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.em-task-star,\n.em-task-delete {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--em-text-muted);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 3px;\n  padding: 4px;\n}\n\n.em-task-star:hover,\n.em-task-delete:hover {\n  background: var(--em-hover);\n}\n\n.em-task-star-on {\n  color: #f59e0b;\n}\n\n.em-task-delete:hover {\n  color: #dc2626;\n}\n\n/* =====================================================================\n   MAILBOX ACCOUNT SETTINGS MODAL\n   ===================================================================== */\n.em-acct-modal {\n  width: 560px;\n  max-width: calc(100vw - 40px);\n  align-self: flex-start;\n}\n\n.em-acct-body {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.em-acct-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: #eef4ff;\n  border: 1px solid #d3e2ff;\n  color: #274b8f;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.em-acct-hint svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.em-acct-section-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--em-text-secondary);\n  margin-top: 4px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--em-border-light);\n}\n\n.em-acct-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.em-acct-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.em-acct-col2 {\n  grid-column: 1 / -1;\n}\n\n.em-acct-field > span {\n  font-size: 11px;\n  color: var(--em-text-secondary);\n  font-weight: 500;\n}\n\n.em-acct-field input:not([type=\"checkbox\"]) {\n  border: 1px solid var(--em-border);\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--em-text);\n  outline: none;\n  background: var(--em-bg);\n}\n\n.em-acct-field input:not([type=\"checkbox\"]):focus {\n  border-color: var(--em-accent);\n}\n\n.em-acct-password-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.em-acct-password-wrap input {\n  width: 100%;\n  padding-right: 32px !important;\n}\n\n.em-acct-password-toggle {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--em-text-secondary);\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.em-acct-password-toggle:hover {\n  color: var(--em-text);\n  background: var(--em-hover);\n}\n\n.em-acct-check {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  grid-column: 1 / -1;\n}\n\n.em-acct-check span {\n  font-size: 12px;\n  color: var(--em-text-secondary);\n}\n\n/* Calendar/People/Tasks responsive */\n@media (max-width: 900px) {\n  .em-cal-sidebar,\n  .em-tasks-sidebar {\n    display: none;\n  }\n  .em-people-list {\n    width: 100%;\n  }\n  .em-people-detail {\n    display: none;\n  }\n}\n\n\n/* ── Resume attachment actions (Add to Job / Database) ── */\n.em-att-actions { position: relative; display: inline-flex; }\n.em-att-action-btn {\n  display: inline-flex; align-items: center; gap: 4px;\n  padding: 4px 8px; font-size: 12px; font-weight: 600;\n  color: #0e527d; background: #eaf3f9; border: 1px solid #cfe3ef;\n  border-radius: 5px; cursor: pointer; white-space: nowrap;\n}\n.em-att-action-btn:hover:not(:disabled) { background: #dcecf6; }\n.em-att-action-btn:disabled { opacity: 0.6; cursor: default; }\n.em-att-menu {\n  /* position/top/left are set inline (fixed) so the menu is never clipped by\n     the reading-pane overflow. */\n  z-index: 2000;\n  min-width: 220px; background: #fff; border: 1px solid #e0e0e0;\n  border-radius: 6px; box-shadow: 0 6px 20px rgba(0,0,0,0.18); padding: 4px;\n}\n.em-att-menu-item {\n  display: flex; align-items: center; gap: 8px; width: 100%;\n  padding: 8px 10px; font-size: 13px; color: #222; background: none;\n  border: none; border-radius: 4px; cursor: pointer; text-align: left;\n}\n.em-att-menu-item:hover { background: #f2f6f9; color: #0e527d; }\n.em-spin { animation: em-spin 0.8s linear infinite; }\n@keyframes em-spin { to { transform: rotate(360deg); } }\n\n.em-jobpick-overlay {\n  position: fixed; inset: 0; background: rgba(0,0,0,0.35);\n  display: flex; align-items: center; justify-content: center; z-index: 10000;\n}\n.em-jobpick {\n  width: 460px; max-width: 92vw; max-height: 80vh; display: flex; flex-direction: column;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25); overflow: hidden;\n}\n.em-jobpick-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 14px 16px; font-size: 14px; font-weight: 700; color: #fff; background: #0e527d;\n}\n.em-jobpick-x { background: none; border: none; color: #fff; cursor: pointer; display: flex; }\n.em-jobpick-company { display: flex; align-items: center; gap: 10px; padding: 12px 16px 6px; }\n.em-jobpick-company label { font-size: 12px; font-weight: 600; color: #555; min-width: 62px; }\n.em-jobpick-company select { flex: 1; padding: 7px 10px; font-size: 13px; border: 1px solid #dcdcdc; border-radius: 6px; background: #fff; outline: none; }\n.em-jobpick-dbnote { padding: 8px 16px 4px; font-size: 12.5px; color: #666; }\n.em-jobpick-search { display: flex; align-items: center; gap: 8px; padding: 10px 16px; border-bottom: 1px solid #eee; color: #888; }\n.em-jobpick-search input { flex: 1; border: 1px solid #dcdcdc; border-radius: 6px; padding: 7px 10px; font-size: 13px; outline: none; }\n.em-jobpick-searchbtn { padding: 7px 12px; font-size: 12px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }\n.em-jobpick-list { flex: 1; overflow-y: auto; padding: 6px 8px; min-height: 160px; }\n.em-jobpick-empty { padding: 30px 12px; text-align: center; color: #999; font-size: 13px; }\n.em-jobpick-item { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 6px; cursor: pointer; font-size: 13px; }\n.em-jobpick-item:hover { background: #f2f6f9; }\n.em-jobpick-item-sel { background: #eaf3f9; }\n.em-jobpick-item-txt { flex: 1; }\n.em-jobpick-pager { display: flex; align-items: center; justify-content: center; gap: 14px; padding: 8px 16px; border-top: 1px solid #eee; font-size: 12px; color: #666; }\n.em-jobpick-pager button { display: inline-flex; align-items: center; gap: 3px; padding: 5px 10px; font-size: 12px; background: #fff; border: 1px solid #dcdcdc; border-radius: 5px; cursor: pointer; }\n.em-jobpick-pager button:disabled { opacity: 0.45; cursor: not-allowed; }\n.em-jobpick-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 16px; border-top: 1px solid #eee; }\n.em-jobpick-cancel { padding: 8px 16px; font-size: 13px; background: #f2f2f2; border: 1px solid #ddd; border-radius: 6px; cursor: pointer; }\n.em-jobpick-add { padding: 8px 18px; font-size: 13px; font-weight: 600; color: #fff; background: #0e527d; border: none; border-radius: 6px; cursor: pointer; }\n.em-jobpick-add:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* Final modal overrides (the email module styles are declared in two bundles). */\n.em-jobpick {\n  width: min(560px, calc(100vw - 32px));\n  max-height: min(80vh, 620px);\n}\n\n.em-jobpick-head {\n  gap: 16px;\n  padding: 16px 18px;\n}\n\n.em-jobpick-x {\n  flex: 0 0 auto;\n  padding: 6px;\n  border-radius: 6px;\n}\n\n.em-jobpick-company {\n  gap: 12px;\n  padding: 18px 18px 8px;\n}\n\n.em-jobpick-company label {\n  flex: 0 0 64px;\n  min-width: 0;\n  color: #334155;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.em-jobpick-company select {\n  min-width: 0;\n  min-height: 38px;\n  border-color: #cbd5e1;\n  color: #1e293b;\n}\n\n.em-jobpick-dbnote {\n  margin: 8px 18px 14px;\n  padding: 12px 14px;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  background: #f8fbff;\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.em-jobpick-foot {\n  gap: 8px;\n  padding: 14px 18px;\n  background: #f8fafc;\n}\n\n.em-jobpick-cancel,\n.em-jobpick-add {\n  min-height: 38px;\n  padding: 8px 16px;\n}\n\n@media (max-width: 520px) {\n  .em-jobpick-company {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .em-jobpick-company select {\n    width: 100%;\n  }\n}\n\n/* ── Calendar sync loader ── */\n.em-cal-syncing {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #0e527d;\n  background: #eaf3f9;\n  border: 1px solid #cfe3ef;\n  border-radius: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n.em-cal { position: relative; }\n\n.em-viewer-hdr-icon { padding: 6px 8px; }\n\n/* ── Attachment click-to-preview ── */\n.em-viewer-att-clickable {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n.em-viewer-att-preview { cursor: pointer; }\n.em-viewer-att-preview:hover .em-viewer-att-name { color: #0e527d; text-decoration: underline; }\n.em-viewer-att-eye {\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 26px; height: 26px; padding: 0; margin-right: 4px;\n  border: 1px solid var(--em-border, #e0e0e0); border-radius: 4px;\n  background: #fff; color: #0e527d; cursor: pointer;\n}\n.em-viewer-att-eye:hover { background: #eaf3f9; }\n\n.em-att-preview-overlay {\n  position: fixed; inset: 0; background: rgba(0,0,0,0.55);\n  display: flex; align-items: center; justify-content: center; z-index: 2000;\n}\n.em-att-preview {\n  width: 860px; max-width: 94vw; height: 88vh; max-height: 92vh;\n  background: #fff; border-radius: 10px; overflow: hidden;\n  display: flex; flex-direction: column; box-shadow: 0 16px 50px rgba(0,0,0,0.35);\n}\n.em-att-preview-head {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 10px 14px; background: #0e527d; color: #fff; flex-shrink: 0;\n}\n.em-att-preview-title {\n  display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600;\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.em-att-preview-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }\n.em-att-preview-btn {\n  display: inline-flex; align-items: center; justify-content: center;\n  width: 30px; height: 30px; border: none; border-radius: 5px;\n  background: rgba(255,255,255,0.15); color: #fff; cursor: pointer;\n}\n.em-att-preview-btn:hover { background: rgba(255,255,255,0.28); }\n.em-att-preview-body { flex: 1; background: #f4f6f8; overflow: auto; display: flex; }\n.em-att-preview-frame { width: 100%; height: 100%; border: none; }\n.em-att-preview-img { max-width: 100%; max-height: 100%; margin: auto; object-fit: contain; }\n.em-att-preview-none {\n  margin: auto; text-align: center; color: #6b7280; display: flex;\n  flex-direction: column; align-items: center; gap: 10px; padding: 30px;\n}\n.em-att-preview-dl {\n  padding: 8px 16px; background: #0e527d; color: #fff; border-radius: 6px;\n  text-decoration: none; font-size: 13px; font-weight: 600;\n}\n\n/* ── Sidebar module switcher (Mail / Calendar / People / To Do) ── */\n.em-sidebar-modules {\n  gap: 6px;\n  padding: 8px 12px;\n  cursor: default;\n  justify-content: flex-start;\n}\n.em-sidebar-module-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  color: var(--em-text-secondary, #555);\n  cursor: pointer;\n}\n.em-sidebar-module-btn:hover { background: #e6ebf1; color: #0e527d; }\n.em-sidebar-module-active { background: #dcecf6; color: #0e527d; }\n.em-sidebar-module-icon { position: relative; display: inline-flex; }\n.em-sidebar-module-badge {\n  position: absolute;\n  top: -7px;\n  right: -9px;\n  min-width: 15px;\n  height: 15px;\n  padding: 0 3px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 15px;\n  text-align: center;\n  color: #fff;\n  background: #d13438;\n  border-radius: 8px;\n}\n\n/* ── Mail view: folder bar on top, list + reading pane below ── */\n.em-mailview {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n.em-mailview-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.em-folderbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 7px 16px;\n  background: #fafafa;\n  border-bottom: 1px solid var(--em-border);\n  flex-shrink: 0;\n}\n.em-folderbar-newmail {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  background: #005a9e;\n  color: #fff;\n  border: 1px solid #004578;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.em-folderbar-newmail:hover { background: #00437a; }\n\n.em-folderbar-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n.em-folderbar-tabs::-webkit-scrollbar { height: 4px; }\n.em-folderbar-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--em-text-secondary, #555);\n  white-space: nowrap;\n}\n.em-folderbar-tab:hover { background: #ececec; color: var(--em-text, #222); }\n.em-folderbar-tab-active {\n  background: #dcecf6;\n  color: #0e527d;\n  font-weight: 600;\n}\n.em-folderbar-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n  background: #e2e6ea;\n  border-radius: 9px;\n  padding: 0 6px;\n  min-width: 16px;\n  text-align: center;\n}\n.em-folderbar-count-primary { background: #005a9e; color: #fff; }\n\n.em-folderbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.em-folderbar-account {\n  max-width: 200px;\n  padding: 5px 8px;\n  font-size: 12px;\n  border: 1px solid var(--em-border, #e0e0e0);\n  border-radius: 5px;\n  background: #fff;\n  color: #333;\n  margin-right: 4px;\n}\n.em-folderbar-ibtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  color: var(--em-text-secondary, #555);\n  cursor: pointer;\n}\n.em-folderbar-ibtn:hover { background: #ececec; color: #0e527d; }\n\n/* ── Mailbox settings: centered footer + logout ── */\n.em-cal-modal-footer-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n.em-acct-logout-row {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--em-border-light, #ebebeb);\n  display: flex;\n  justify-content: center;\n}\n.em-acct-logout-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #b42318;\n  background: #fff;\n  border: 1px solid #f0c6c0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.em-acct-logout-btn:hover:not(:disabled) { background: #fdecea; }\n.em-acct-logout-btn:disabled { opacity: 0.6; cursor: default; }\n\n/* ── In-app confirm modal (logout) ── */\n.em-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n}\n.em-confirm-modal {\n  width: 360px;\n  max-width: 90%;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.28);\n  overflow: hidden;\n}\n.em-confirm-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 18px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #b42318;\n  border-bottom: 1px solid #f0e0de;\n}\n.em-confirm-body {\n  padding: 16px 18px;\n  font-size: 13px;\n  color: #444;\n  line-height: 1.6;\n}\n.em-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px 18px 16px;\n}\n.em-confirm-danger {\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: #d13438;\n  border: 1px solid #b42318;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.em-confirm-danger:hover:not(:disabled) { background: #b42318; }\n.em-confirm-danger:disabled { opacity: 0.6; cursor: default; }\n\n/* ===================== OUTLOOK-STYLE MESSAGE LIST ===================== */\n.em-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--em-border);\n  flex-shrink: 0;\n  background: #fff;\n}\n.em-list-filters { display: flex; gap: 16px; }\n.em-list-filter {\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: var(--em-text-secondary, #666);\n  cursor: pointer;\n  padding: 2px 0;\n  position: relative;\n  font-family: inherit;\n}\n.em-list-filter-active { color: #0f6cbd; font-weight: 600; }\n.em-list-filter-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0; right: 0; bottom: -8px;\n  height: 2px;\n  background: #0f6cbd;\n}\n.em-list-sort {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.5px;\n  color: var(--em-text-secondary, #666);\n  cursor: pointer;\n}\n.em-list-loading { font-size: 12px; color: #888; padding: 4px; }\n\n.em-mail-group {\n  padding: 6px 14px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f6cbd;\n  background: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* Message row — no avatar, three lines (sender/time, subject, preview). */\n.em-mail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 14px 8px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #f2f2f2;\n  position: relative;\n  background: #fff;\n}\n.em-mail-item:hover { background: #f5f8fb; }\n.em-mail-active, .em-mail-active:hover { background: #eaf2fb; }\n.em-mail-unread::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 6px; bottom: 6px;\n  width: 3px;\n  border-radius: 2px;\n  background: #0f6cbd;\n}\n.em-mail-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.em-mail-row1 { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }\n.em-mail-sender {\n  font-size: 13.5px;\n  color: #1a1a1a;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-unread .em-mail-sender { font-weight: 700; }\n.em-mail-date { font-size: 12px; color: #888; white-space: nowrap; flex-shrink: 0; }\n.em-mail-unread .em-mail-date { color: #0f6cbd; font-weight: 600; }\n.em-mail-subject-line {\n  font-size: 13px;\n  color: #444;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-unread .em-mail-subject-line { color: #0f6cbd; font-weight: 600; }\n.em-mail-preview-line {\n  font-size: 12.5px;\n  color: #888;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.em-mail-side {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n.em-mail-star { display: inline-flex; cursor: pointer; opacity: 0.4; transition: opacity 0.1s; }\n.em-mail-item:hover .em-mail-star { opacity: 1; }\n.em-mail-attach-icon { color: #888; }\n\n.em-list-pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 6px 14px;\n  border-top: 1px solid var(--em-border);\n  font-size: 12px;\n  color: #666;\n  flex-shrink: 0;\n  background: #fff;\n}\n.em-list-nounread { padding: 24px; text-align: center; color: #999; font-size: 13px; }\n\n/* ===================== BOTTOM STATUS BAR ===================== */\n.em-statusbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--em-border);\n  background: #f3f3f3;\n  padding: 0 16px 0 0;\n  flex-shrink: 0;\n  min-height: 30px;\n}\n.em-statusbar .em-nav-rail { width: auto; }\n.em-statusbar .em-nav-rail-top {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 3px 8px;\n}\n.em-statusbar-info {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  font-size: 12px;\n  color: #555;\n  white-space: nowrap;\n}\n.em-statusbar-conn { color: #107c10; }\n\n/* ===================== OUTLOOK-MATCH FOLDER PANE ===================== */\n.em-sidebar { background: #faf9f8; }\n.em-sidebar-section-title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 10px 3px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.em-sidebar-section-chevron { color: #888; flex-shrink: 0; }\n.em-sidebar-account-title { color: #201f1e; }\n.em-sidebar-account-title span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.em-sidebar-folder {\n  padding: 4px 10px 4px 24px;\n  margin: 0;\n  border-radius: 0;\n  min-height: 26px;\n  font-size: 13px;\n  color: #201f1e;\n}\n.em-sidebar-folder:hover { background: #f0eeed; }\n.em-sidebar-folder-active { background: #dcecf6 !important; box-shadow: inset 3px 0 0 #0f6cbd; }\n.em-sidebar-folder-label { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-sidebar-folder-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #605e5c;\n  background: transparent;\n  padding: 0;\n}\n.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 600; }\n.em-sidebar-more-btn { padding-left: 24px; }\n\n/* Action buttons row — subtler, Outlook-ish */\n.em-sidebar-search-btn { color: #444; }\n.em-sidebar-search-btn:hover { background: #f0eeed; }\n\n/* Message list selected-row: Outlook look */\n.em-mail-active, .em-mail-active:hover { background: #eaf1fb; box-shadow: inset 2px 0 0 #0f6cbd; }\n\n/* Date group header: subtle Outlook style */\n.em-mail-group {\n  background: #faf9f8;\n  color: #444;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* ===================== OUTLOOK READING PANE ===================== */\n.em-viewer { background: #fff; }\n.em-viewer-header {\n  background: #fff;\n  padding: 14px 20px 10px;\n  border-bottom: 1px solid #edebe9;\n}\n.em-viewer-subject {\n  font-size: 18px;\n  font-weight: 600;\n  color: #242424;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n.em-viewer-from-name { font-weight: 600; color: #242424; }\n.em-viewer-from-addr { color: #605e5c; }\n\n.em-viewer-webbanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 20px;\n  font-size: 12px;\n  color: #605e5c;\n  background: #fff;\n  border-bottom: 1px solid #edebe9;\n}\n.em-viewer-webbanner svg { color: #0f6cbd; flex-shrink: 0; }\n.em-viewer-weblink {\n  background: none;\n  border: none;\n  color: #0f6cbd;\n  cursor: pointer;\n  padding: 0;\n  font-size: 12px;\n  font-family: inherit;\n}\n.em-viewer-weblink:hover { text-decoration: underline; }\n\n.em-viewer-body {\n  background: #fff;            /* no grey backdrop / white card */\n  padding: 0;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  background: transparent;    /* no card — plain white reading area */\n  max-width: 900px;\n  margin: 0;                  /* left-aligned, not centered */\n  padding: 0;\n  border-radius: 0;\n  overflow: visible;\n  box-shadow: none;\n}\n\n/* Message content: left-aligned with comfortable padding (Gmail-style). */\n.em-viewer-html-body {\n  background: transparent;\n  padding: 18px 26px;\n  text-align: left;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 14px;\n  color: #242424;\n  line-height: 1.5;\n  overflow-x: auto;           /* never let a wide fixed-width template break the layout */\n}\n/* Normalize legacy / arbitrary templates so nothing overflows and images scale. */\n.em-viewer-html-body img { max-width: 100%; height: auto; }\n.em-viewer-html-body table { max-width: 100%; border-collapse: collapse; }\n/* Left-align top-level content instead of centering it. */\n.em-viewer-html-body > table,\n.em-viewer-html-body > div,\n.em-viewer-html-body > center > table { margin-left: 0 !important; margin-right: auto !important; }\n.em-viewer-html-body a { color: #0f6cbd; }\n\n/* Plain-text emails keep readable padding (no template to bleed). */\n.em-viewer-text-body {\n  background: transparent;\n  margin: 0;\n  padding: 24px 28px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 13.5px;\n  color: #242424;\n  line-height: 1.5;\n}\n\n/* ===================== RIBBON / SIDEBAR TWEAKS (tabbed ribbon) ===================== */\n.em-ribbon-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n  background: transparent;\n  border-color: transparent;\n}\n.em-ribbon-btn:disabled:hover { background: transparent; border-color: transparent; }\n.em-ribbon-content { flex-wrap: wrap; }\n\n/* Clickable collapsible section headers in the folder pane */\n.em-sidebar-section-title-toggle { cursor: pointer; border-radius: 3px; }\n.em-sidebar-section-title-toggle:hover { background: #f0eeed; }\n.em-sidebar-section-title-toggle .em-sidebar-section-chevron { transition: transform 0.15s; }\n\n/* ===================== CLEAN & BEAUTIFUL SIDEBAR (polish) ===================== */\n.em-sidebar {\n  width: 214px;\n  min-width: 214px;\n  background: #fbfbfa;\n  border-right: 1px solid #ececec;\n  padding: 4px 4px 12px;\n}\n\n/* New mail button */\n.em-sidebar-newmail {\n  margin: 6px 6px 10px;\n  padding: 9px 14px;\n  background: #0f6cbd;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  gap: 9px;\n  box-shadow: 0 1px 2px rgba(15, 108, 189, 0.25);\n  transition: background 0.12s;\n}\n.em-sidebar-newmail:hover { background: #0c5aa0; }\n.em-sidebar-newmail:active { background: #0a4e8c; }\n\n/* Action rows: Sync / Settings / Add mailbox */\n.em-sidebar-search-btn {\n  margin: 1px 6px;\n  padding: 7px 10px;\n  min-height: 32px;\n  gap: 11px;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #3b3a39;\n}\n.em-sidebar-search-btn svg { color: #605e5c; }\n.em-sidebar-search-btn:hover { background: #f0efee; }\n\n/* Sections */\n.em-sidebar-section {\n  padding: 2px 0 6px;\n  margin-top: 6px;\n  border-top: 1px solid #ededed;\n}\n.em-sidebar-section-title {\n  padding: 9px 12px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #605e5c;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.em-sidebar-section-title-toggle { margin: 0 6px; padding-left: 6px; border-radius: 6px; }\n.em-sidebar-section-title-toggle:hover { background: #f0efee; }\n.em-sidebar-account-title span { color: #201f1e; font-weight: 600; }\n\n/* Folder rows — soft rounded pills */\n.em-sidebar-folder {\n  margin: 1px 6px;\n  padding: 7px 10px;\n  min-height: 32px;\n  gap: 11px;\n  border-radius: 6px;\n  font-size: 13.5px;\n  color: #201f1e;\n  box-shadow: none;\n  transition: background 0.1s, color 0.1s;\n}\n.em-sidebar-folder:hover { background: #f0efee; }\n.em-sidebar-folder-active,\n.em-sidebar-folder-active:hover {\n  background: #eaf1fb !important;\n  box-shadow: none;\n  color: #0f6cbd;\n  font-weight: 600;\n}\n.em-sidebar-folder-icon { color: #605e5c; display: inline-flex; align-items: center; }\n.em-sidebar-folder-active .em-sidebar-folder-icon { color: #0f6cbd; }\n.em-sidebar-folder-count { margin-left: auto; font-size: 12px; color: #797775; font-weight: 500; }\n.em-sidebar-folder-count-primary { color: #0f6cbd; font-weight: 700; }\n\n/* More */\n.em-sidebar-more-btn {\n  margin: 2px 6px 0;\n  padding: 6px 10px 6px 34px;\n  border-radius: 6px;\n  font-size: 12.5px;\n  color: #605e5c;\n  gap: 6px;\n}\n.em-sidebar-more-btn:hover { background: #f0efee; }\n\n/* ===================== GROUPED OUTLOOK RIBBON ===================== */\n.em-rb-content {\n  display: flex;\n  align-items: stretch;\n  padding: 4px 4px 2px;\n  background: #fff;\n  overflow-x: auto;\n  min-height: 90px;\n  border-bottom: 1px solid var(--em-ribbon-border, #e1dfdd);\n}\n.em-rb-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-right: 1px solid #e8e6e4;\n  padding: 2px 6px 0;\n  flex-shrink: 0;\n}\n.em-rb-group:last-child { border-right: none; }\n.em-rb-buttons { display: flex; align-items: stretch; gap: 1px; flex: 1; }\n.em-rb-group-label {\n  font-size: 10px;\n  color: #8a8886;\n  text-align: center;\n  padding: 3px 0 3px;\n  white-space: nowrap;\n}\n.em-rb-big {\n  display: flex; flex-direction: column; align-items: center; justify-content: flex-start;\n  gap: 3px;\n  min-width: 44px; max-width: 68px;\n  padding: 4px 5px;\n  background: transparent; border: 1px solid transparent; border-radius: 3px;\n  cursor: pointer; color: #201f1e; font-family: inherit;\n}\n.em-rb-big:hover { background: #eef4fb; border-color: #d6e4f5; }\n.em-rb-big:disabled { opacity: 0.4; cursor: default; }\n.em-rb-big:disabled:hover { background: transparent; border-color: transparent; }\n.em-rb-big-label { font-size: 10.5px; line-height: 1.15; text-align: center; }\n.em-rb-stack { display: flex; flex-direction: column; justify-content: center; gap: 1px; padding: 0 2px; }\n.em-rb-small {\n  display: flex; align-items: center; gap: 5px;\n  padding: 2px 6px 2px 4px; border-radius: 3px;\n  background: transparent; border: 1px solid transparent; cursor: pointer;\n  color: #201f1e; font-family: inherit; font-size: 11px; white-space: nowrap;\n}\n.em-rb-small:hover { background: #eef4fb; border-color: #d6e4f5; }\n.em-rb-small span { flex: 1; text-align: left; }\n.em-rb-small:disabled { opacity: 0.4; cursor: default; }\n.em-rb-people {\n  display: flex; align-items: center; gap: 4px;\n  border: 1px solid #d0d0d0; border-radius: 3px; padding: 1px 6px; background: #fff; margin-bottom: 2px;\n}\n.em-rb-people input { border: none; outline: none; font-size: 11px; width: 96px; background: transparent; }\n\n/* ===================== NEW-MAIL DESKTOP TOAST ===================== */\n.em-nmt {\n  position: fixed; right: 18px; bottom: 44px; z-index: 4000;\n  width: 344px; background: #fff; border: 1px solid #e1dfdd; border-radius: 8px;\n  box-shadow: 0 8px 28px rgba(0,0,0,0.22); overflow: hidden;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  animation: em-nmt-in 0.25s ease;\n}\n@keyframes em-nmt-in { from { transform: translateY(14px); opacity: 0; } to { transform: none; opacity: 1; } }\n.em-nmt-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; border-bottom: 1px solid #f0f0f0; }\n.em-nmt-brand { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: #444; font-weight: 500; }\n.em-nmt-logo { width: 18px; height: 18px; border-radius: 3px; background: #0f6cbd; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; }\n.em-nmt-count { font-size: 11px; color: #0f6cbd; margin-left: 2px; }\n.em-nmt-head-actions { display: flex; align-items: center; gap: 2px; }\n.em-nmt-head-actions button { background: none; border: none; cursor: pointer; color: #666; padding: 3px; border-radius: 4px; display: inline-flex; }\n.em-nmt-head-actions button:hover { background: #f0f0f0; }\n.em-nmt-body { display: flex; gap: 12px; padding: 12px 14px; cursor: pointer; }\n.em-nmt-body:hover { background: #f7fafd; }\n.em-nmt-avatar { width: 44px; height: 44px; border-radius: 50%; background: #b3b0ad; color: #fff; display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0; }\n.em-nmt-text { min-width: 0; flex: 1; }\n.em-nmt-sender { font-size: 14px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-nmt-subject { font-size: 12.5px; color: #605e5c; margin: 1px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-nmt-preview { font-size: 12px; color: #797775; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }\n.em-nmt-foot { display: flex; border-top: 1px solid #f0f0f0; }\n.em-nmt-foot button { flex: 1; padding: 9px 0; background: #f7f6f5; border: none; border-right: 1px solid #eaeaea; cursor: pointer; color: #444; display: inline-flex; align-items: center; justify-content: center; }\n.em-nmt-foot button:last-child { border-right: none; }\n.em-nmt-foot button:hover { background: #eaeaea; }\n\n/* ===================== RULES MODAL ===================== */\n.em-rules {\n  width: 580px; max-width: calc(100vw - 40px); max-height: 84vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n}\n.em-rules-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-rules-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-rules-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-rules-x:hover { background: #f0f0f0; }\n.em-rules-body { padding: 16px 18px; overflow-y: auto; }\n.em-rules-hint { font-size: 12.5px; color: #605e5c; margin: 0 0 14px; line-height: 1.5; }\n.em-rules-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }\n.em-rules-empty { font-size: 13px; color: #999; padding: 14px; text-align: center; border: 1px dashed #ddd; border-radius: 8px; }\n.em-rules-item { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border: 1px solid #ececec; border-radius: 8px; background: #fbfbfa; }\n.em-rules-item-off { opacity: 0.55; }\n.em-rules-item-text { flex: 1; min-width: 0; }\n.em-rules-item-name { font-size: 13.5px; font-weight: 600; color: #201f1e; }\n.em-rules-item-desc { font-size: 12px; color: #605e5c; margin-top: 2px; }\n.em-rules-del { background: none; border: none; cursor: pointer; color: #b0413e; padding: 5px; border-radius: 5px; }\n.em-rules-del:hover { background: #fde7e6; }\n.em-rules-toggle { position: relative; display: inline-flex; cursor: pointer; flex-shrink: 0; }\n.em-rules-toggle input { position: absolute; opacity: 0; width: 34px; height: 18px; margin: 0; cursor: pointer; }\n.em-rules-check { width: 34px; height: 18px; border-radius: 10px; background: #c8c6c4; position: relative; transition: background .15s; }\n.em-rules-check::after { content: ''; position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: #fff; transition: left .15s; }\n.em-rules-toggle input:checked + .em-rules-check { background: #0f6cbd; }\n.em-rules-toggle input:checked + .em-rules-check::after { left: 18px; }\n.em-rules-new { border: 1px solid #ececec; border-radius: 8px; padding: 14px; background: #fafafa; }\n.em-rules-new-title { font-size: 13px; font-weight: 600; color: #201f1e; margin-bottom: 10px; }\n.em-rules-row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }\n.em-rules-lbl { font-size: 12.5px; color: #444; width: 56px; flex-shrink: 0; }\n.em-rules-input, .em-rules-select { border: 1px solid #d0d0d0; border-radius: 6px; padding: 7px 9px; font-size: 13px; font-family: inherit; outline: none; }\n.em-rules-input { width: 100%; }\n.em-rules-input:focus, .em-rules-select:focus { border-color: #0f6cbd; }\n.em-rules-input-value { flex: 1; width: auto; }\n.em-rules-select { background: #fff; }\n.em-rules-add { display: inline-flex; align-items: center; gap: 5px; margin-left: auto; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 7px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-rules-add:disabled { opacity: 0.5; cursor: default; }\n.em-rules-foot { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-top: 1px solid #ececec; }\n.em-rules-run { display: inline-flex; align-items: center; gap: 6px; background: #107c10; color: #fff; border: none; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-rules-run:hover { background: #0e6b0e; }\n.em-rules-close { background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 8px 16px; font-size: 13px; cursor: pointer; }\n.em-rules-close:hover { background: #e8e6e4; }\n\n/* Give bulleted/numbered lists in HTML email templates proper indentation. */\n.em-viewer-html-body ul,\n.em-viewer-html-body ol { padding-left: 2rem; }\n\n/* Folder deep-sync progress strip (shown while a folder's messages download). */\n.em-list-syncbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  font-size: 12px;\n  color: #0f6cbd;\n  background: #eef4fb;\n  border-bottom: 1px solid #dbe7f5;\n  flex-shrink: 0;\n}\n.em-list-syncbar .em-spinner {\n  width: 13px; height: 13px;\n  border: 2px solid #bcd4ef;\n  border-top-color: #0f6cbd;\n  border-radius: 50%;\n  display: inline-block;\n  animation: em-spin 0.7s linear infinite;\n}\n@keyframes em-spin { to { transform: rotate(360deg); } }\n\n/* Sender initial-avatar in front of each message row (space in front of emails). */\n.em-mail-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  margin-top: 1px;\n  margin-right: 4px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  user-select: none;\n}\n/* Center the avatar against the 3-line message body. */\n.em-mail-item { align-items: center; }\n\n/* ===================== VIEW: density / preview / active toggles ===================== */\n/* Compact (\"Use Tighter Spacing\") — tighter rows, smaller avatar, no preview line. */\n.em-list-compact .em-mail-item { padding-top: 5px; padding-bottom: 5px; gap: 8px; }\n.em-list-compact .em-mail-avatar { width: 26px; height: 26px; font-size: 11px; }\n.em-list-compact .em-mail-preview-line { display: none; }\n.em-list-compact .em-mail-subject-line { font-size: 12.5px; }\n\n/* Message Preview off — hide the preview line. */\n.em-list-nopreview .em-mail-preview-line { display: none; }\n\n/* Active/toggled ribbon command (Reading Pane on, Work Offline on, current sort…). */\n.em-rb-active { background: #dbeafe !important; border-color: #a9c9f0 !important; }\n.em-rb-big.em-rb-active { color: #0f6cbd; }\n.em-rb-small.em-rb-active { color: #0f6cbd; font-weight: 600; }\n\n/* ===================== READ ALOUD CONTROL BAR ===================== */\n.em-ra {\n  position: fixed;\n  top: 132px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 5000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-ra-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #ffffff;\n  border: 1px solid #e1dfdd;\n  border-radius: 10px;\n  box-shadow: 0 6px 22px rgba(0,0,0,0.18);\n  padding: 6px 8px;\n}\n.em-ra-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  color: #333;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.em-ra-btn:hover { background: #f0f0f0; }\n.em-ra-btn-active { background: #eaf1fb; color: #0f6cbd; }\n.em-ra-play { color: #0f6cbd; }\n.em-ra-close:hover { background: #fde7e6; color: #d13438; }\n\n.em-ra-panel {\n  margin-top: 8px;\n  background: #ffffff;\n  border: 1px solid #d8d8d8;\n  border-radius: 8px;\n  box-shadow: 0 6px 22px rgba(0,0,0,0.18);\n  padding: 14px 16px;\n  width: 240px;\n}\n.em-ra-field { margin-bottom: 12px; }\n.em-ra-field:last-child { margin-bottom: 0; }\n.em-ra-field label {\n  display: block;\n  font-size: 13px;\n  color: #201f1e;\n  margin-bottom: 6px;\n}\n.em-ra-field input[type=\"range\"] { width: 78%; vertical-align: middle; accent-color: #0f6cbd; }\n.em-ra-rate { font-size: 12px; color: #605e5c; margin-left: 8px; }\n.em-ra-field select {\n  width: 100%;\n  padding: 6px 8px;\n  font-size: 13px;\n  border: 1px solid #c8c8c8;\n  border-radius: 5px;\n  background: #fff;\n  font-family: inherit;\n  color: #201f1e;\n}\n\n/* ===================== SCHEDULE MEETING MODAL ===================== */\n.em-meeting {\n  width: 460px; max-width: calc(100vw - 40px); max-height: 86vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-meeting-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-meeting-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-meeting-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-meeting-x:hover { background: #f0f0f0; }\n.em-meeting-body { padding: 16px 18px; overflow-y: auto; }\n.em-meeting-body label { display: block; font-size: 12.5px; color: #444; margin: 10px 0 4px; }\n.em-meeting-body input, .em-meeting-body select, .em-meeting-body textarea {\n  width: 100%; padding: 8px 10px; font-size: 13.5px; border: 1px solid #d0d0d0; border-radius: 6px;\n  font-family: inherit; outline: none; box-sizing: border-box;\n}\n.em-meeting-body input:focus, .em-meeting-body select:focus, .em-meeting-body textarea:focus { border-color: #0f6cbd; }\n.em-meeting-row { display: flex; gap: 10px; }\n.em-meeting-row > div { flex: 1; }\n.em-meeting-foot { display: flex; align-items: center; gap: 8px; padding: 12px 18px; border-top: 1px solid #ececec; }\n.em-meeting-google { display: inline-flex; align-items: center; gap: 7px; background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 9px 14px; font-size: 13.5px; font-weight: 600; cursor: pointer; }\n.em-meeting-google:hover { background: #0c5aa0; }\n.em-meeting-ics { display: inline-flex; align-items: center; gap: 5px; background: #f3f2f1; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 12px; font-size: 13px; cursor: pointer; }\n.em-meeting-ics:hover { background: #e8e6e4; }\n.em-meeting-cancel { margin-left: auto; background: none; border: 1px solid #d0d0d0; border-radius: 6px; padding: 9px 16px; font-size: 13px; cursor: pointer; }\n.em-meeting-cancel:hover { background: #f3f2f1; }\n\n/* ===================== REMINDERS WINDOW ===================== */\n.em-reminders {\n  width: 420px; max-width: calc(100vw - 40px); max-height: 80vh;\n  background: #fff; border-radius: 10px; box-shadow: 0 12px 40px rgba(0,0,0,0.25);\n  display: flex; flex-direction: column; overflow: hidden; align-self: flex-start;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-reminders-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #ececec; }\n.em-reminders-title { display: flex; align-items: center; gap: 9px; font-size: 16px; font-weight: 600; color: #201f1e; }\n.em-reminders-count { background: #d13438; color: #fff; border-radius: 10px; font-size: 11px; font-weight: 700; padding: 1px 7px; }\n.em-reminders-x { background: none; border: none; cursor: pointer; color: #666; padding: 4px; border-radius: 4px; }\n.em-reminders-x:hover { background: #f0f0f0; }\n.em-reminders-body { padding: 8px 0; overflow-y: auto; }\n.em-reminders-empty { text-align: center; color: #888; padding: 30px 20px; display: flex; flex-direction: column; align-items: center; gap: 6px; }\n.em-reminders-empty p { margin: 4px 0 0; font-size: 15px; color: #555; }\n.em-reminders-empty span { font-size: 12.5px; }\n.em-reminder-item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 18px; border-bottom: 1px solid #f2f2f2; }\n.em-reminder-item:hover { background: #faf9f8; }\n.em-reminder-icon { margin-top: 2px; flex-shrink: 0; }\n.em-reminder-text { flex: 1; min-width: 0; cursor: pointer; }\n.em-reminder-title { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-reminder-sub { font-size: 12px; color: #605e5c; margin: 2px 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-reminder-when { font-size: 12px; color: #0f6cbd; font-weight: 500; }\n.em-reminder-dismiss { align-self: center; background: #f3f2f1; border: 1px solid #d8d8d8; border-radius: 5px; padding: 5px 10px; font-size: 12px; cursor: pointer; flex-shrink: 0; }\n.em-reminder-dismiss:hover { background: #e8e6e4; }\n.em-reminders-foot { padding: 10px 18px; border-top: 1px solid #ececec; text-align: right; }\n.em-reminders-dismissall { background: #0f6cbd; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; }\n.em-reminders-dismissall:hover { background: #0c5aa0; }\n\n/* ===================== RIBBON: COLOURED, SPACED, CLEANER ===================== */\n/* Left space so the toolbar isn't cluttered against the edge. */\n.em-ribbon-tabs { padding: 0 8px 0 22px; }\n.em-rb-content { padding: 7px 14px 3px 22px; gap: 2px; }\n\n/* More horizontal breathing room + softer separators between groups. */\n.em-rb-group { padding: 2px 15px 0; border-right: 1px solid #eef0f2; }\n.em-rb-group:last-child { border-right: none; }\n.em-rb-buttons { gap: 4px; }\n.em-rb-big { min-width: 48px; max-width: 74px; padding: 5px 7px; gap: 4px; }\n.em-rb-small { padding: 3px 7px 3px 5px; }\n.em-rb-stack { gap: 2px; padding: 0 3px; }\n.em-rb-group-label { color: #9aa0a6; padding-top: 5px; font-size: 10px; }\n\n/* Softer hover (keep the coloured icons visible). */\n.em-rb-big:hover, .em-rb-small:hover { background: #f2f5f9; border-color: #e2e8f0; }\n\n/* Active/toggled command — light rounded blue chip. */\n.em-rb-active { background: #eaf1fb !important; border-color: #cfe0f5 !important; border-radius: 6px; }\n.em-rb-big.em-rb-active .em-rb-big-label,\n.em-rb-small.em-rb-active span { color: #1a5fbf; font-weight: 600; }\n\n/* Search-people pill spacing. */\n.em-rb-people { margin-bottom: 3px; }\n\n/* ===================== NO SCROLLBARS — SHOW EVERYTHING ===================== */\n/* Ribbon: never scroll horizontally — wrap groups onto a second row instead. */\n.em-rb-content {\n  overflow-x: hidden;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  row-gap: 2px;\n}\n\n/* Folder pane: compact rows so all folders fit without a scrollbar. */\n.em-sidebar { overflow-y: auto; }\n.em-sidebar-newmail { margin: 5px 6px 6px; padding: 7px 12px; }\n.em-sidebar-search-btn { min-height: 26px; padding: 4px 10px; margin: 0 6px; }\n.em-sidebar-section { margin-top: 3px; padding: 1px 0 3px; border-top-color: #f0f0f0; }\n.em-sidebar-section-title { padding: 5px 12px 2px; }\n.em-sidebar-folder { min-height: 26px; padding: 4px 10px 4px 24px; margin: 0 6px; }\n.em-sidebar-more-btn { padding-top: 3px; padding-bottom: 3px; }\n\n/* Slim, unobtrusive scrollbar if content still just barely overflows. */\n.em-sidebar::-webkit-scrollbar { width: 6px; }\n.em-sidebar::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }\n.em-sidebar::-webkit-scrollbar-track { background: transparent; }\n\n/* ===================== COMPACT SINGLE-ROW OUTLOOK RIBBON (match reference) ===================== */\n.em-rb-content {\n  flex-wrap: nowrap;          /* single row like classic Outlook */\n  overflow-x: auto;\n  overflow-y: hidden;\n  align-content: stretch;\n  padding: 5px 8px 2px 12px;\n  gap: 0;\n  min-height: 82px;\n  row-gap: 0;\n}\n.em-rb-group { padding: 2px 8px 0; }\n.em-rb-buttons { gap: 1px; }\n.em-rb-stack { gap: 0; padding: 0 2px; }\n.em-rb-big { min-width: 40px; max-width: 64px; padding: 3px 5px; gap: 2px; }\n.em-rb-big svg { width: 17px; height: 17px; }\n.em-rb-big-label { font-size: 10px; line-height: 1.1; }\n.em-rb-small { padding: 2px 5px 2px 4px; font-size: 10.5px; gap: 4px; }\n.em-rb-small svg { width: 13px; height: 13px; }\n.em-rb-group-label { font-size: 9px; padding-top: 3px; }\n.em-rb-people { padding: 1px 6px; margin-bottom: 2px; }\n.em-rb-people input { width: 84px; font-size: 10.5px; }\n\n/* If it can't fit (very narrow window) the scrollbar is slim, not a big grey bar. */\n.em-rb-content::-webkit-scrollbar { height: 6px; }\n.em-rb-content::-webkit-scrollbar-thumb { background: #d8d8d8; border-radius: 3px; }\n.em-rb-content::-webkit-scrollbar-track { background: transparent; }\n\n/* ===================== CLEAN STRUCTURED EMAIL / TEMPLATE RENDERING ===================== */\n/* Reading pane = soft canvas; the email sits on a centered white \"sheet\". */\n.em-viewer-body {\n  background: #f3f4f6;\n  padding: 22px 18px;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  max-width: 840px;\n  margin: 0 auto;                 /* centered, not floating left */\n  background: #ffffff;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;               /* clip full-width headers to the rounded card */\n  padding: 0;\n}\n.em-viewer-html-body {\n  padding: 30px 36px;\n  text-align: left;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  font-size: 14px;\n  color: #242424;\n  line-height: 1.6;\n  overflow-x: auto;\n}\n.em-viewer-html-body img { max-width: 100%; height: auto; }\n.em-viewer-html-body table { max-width: 100%; }\n/* Centre the template's top-level blocks so headers/logos sit balanced. */\n.em-viewer-html-body > table,\n.em-viewer-html-body > div,\n.em-viewer-html-body > center,\n.em-viewer-html-body > center > table {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n.em-viewer-html-body p { margin: 0 0 12px; }\n.em-viewer-html-body ul,\n.em-viewer-html-body ol { padding-left: 1.5rem; margin: 10px 0; }\n.em-viewer-html-body a { color: #0f6cbd; }\n.em-viewer-text-body {\n  padding: 30px 36px;\n  max-width: none;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* ===================== IFRAME EMAIL RENDERING (clean, isolated) ===================== */\n.em-viewer-body {\n  background: #f3f4f6;\n  padding: 22px 18px;\n  overflow: auto;\n  flex: 1;\n}\n.em-viewer-paper {\n  max-width: 880px;\n  margin: 0 auto;\n  background: #ffffff;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;\n  padding: 0;\n}\n.em-viewer-frame {\n  width: 100%;\n  border: none;\n  display: block;\n  background: #ffffff;\n  min-height: 180px;\n}\n.em-viewer-text-body {\n  padding: 26px 30px;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* ===================== ACCOUNT AVATAR + POPOVER (ribbon top-right) ===================== */\n.em-ribbon-tabs { position: relative; }\n.em-ribbon-account { margin-left: auto; position: relative; display: flex; align-items: center; padding-right: 12px; }\n.em-ribbon-avatar-btn { background: none; border: none; cursor: pointer; padding: 3px; border-radius: 50%; display: inline-flex; }\n.em-ribbon-avatar-btn:hover { background: #e5e7eb; }\n.em-ribbon-avatar {\n  width: 28px; height: 28px; border-radius: 50%; background: #4b7c72; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600;\n}\n.em-account-backdrop { position: fixed; inset: 0; z-index: 6000; }\n.em-account-pop {\n  position: absolute; top: 40px; right: 8px; z-index: 6001; width: 330px;\n  background: #fff; border: 1px solid #e1dfdd; border-radius: 10px;\n  box-shadow: 0 12px 36px rgba(0,0,0,0.22); overflow: hidden;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-account-pop-main { display: flex; gap: 16px; padding: 20px; }\n.em-account-pop-avatar {\n  width: 58px; height: 58px; border-radius: 50%; background: #4b7c72; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 600; flex-shrink: 0;\n}\n.em-account-pop-info { min-width: 0; }\n.em-account-pop-name { font-size: 16px; font-weight: 700; color: #201f1e; word-break: break-word; line-height: 1.3; }\n.em-account-pop-email { font-size: 13px; color: #605e5c; margin: 2px 0 6px; word-break: break-word; }\n.em-account-pop-view { background: none; border: none; color: #0f6cbd; font-size: 13px; cursor: pointer; padding: 0; font-family: inherit; }\n.em-account-pop-view:hover { text-decoration: underline; }\n.em-account-pop-add {\n  display: flex; align-items: center; gap: 12px; width: 100%; padding: 14px 20px;\n  background: #fff; border: none; border-top: 1px solid #ececec; cursor: pointer;\n  font-size: 14px; color: #201f1e; font-family: inherit; text-align: left;\n}\n.em-account-pop-add svg { color: #605e5c; }\n.em-account-pop-add:hover { background: #f5f5f5; }\n\n/* ===================== SIDEBAR: MORE BREATHING ROOM (top actions) ===================== */\n.em-sidebar-newmail { margin: 10px 8px 8px; padding: 10px 14px; gap: 9px; }\n.em-sidebar-search-btn { min-height: 34px; padding: 8px 12px; margin: 2px 8px; gap: 12px; }\n.em-sidebar-search-btn:last-of-type { margin-bottom: 10px; }\n\n/* Account button now shows the name next to the avatar. */\n.em-ribbon-avatar-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 6px 3px 10px;\n  border-radius: 18px;\n}\n.em-ribbon-username {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #201f1e;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.em-ribbon-avatar-caret { color: #605e5c; flex-shrink: 0; }\n\n/* ===================== SIDEBAR COLLAPSE TOGGLE ===================== */\n.em-sidebar-collapsehdr { display: flex; justify-content: flex-end; padding: 4px 6px 0; }\n.em-sidebar-collapse-btn {\n  background: none; border: none; cursor: pointer; color: #605e5c;\n  padding: 4px; border-radius: 5px; display: inline-flex;\n}\n.em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }\n\n/* Narrow rail shown when the folder pane is collapsed — click to expand. */\n.em-collapsed-rail {\n  width: 34px; min-width: 34px; flex-shrink: 0;\n  background: #fbfbfa; border-right: 1px solid #ececec;\n  display: flex; flex-direction: column; align-items: center; padding-top: 8px;\n}\n.em-collapsed-expand {\n  background: none; border: none; cursor: pointer; color: #605e5c;\n  padding: 5px; border-radius: 5px; display: inline-flex;\n}\n.em-collapsed-expand:hover { background: #eceff2; color: #0f6cbd; }\n\n/* ===================== COMPACT ICON-ONLY MODULE RAIL (bottom-left) ===================== */\n.em-nav-rail-top { display: flex; flex-direction: row; align-items: center; gap: 2px; }\n.em-nav-rail-btn {\n  flex-direction: row; min-width: auto; padding: 6px 9px; gap: 0;\n}\n.em-nav-rail-label { display: none; }\n.em-nav-rail-more svg { color: #605e5c; }\n\n/* New mail button + collapse toggle on one row (no separate top row/space). */\n.em-sidebar-collapsehdr { display: none; }\n.em-sidebar-newmail-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 8px 8px 6px;\n}\n.em-sidebar-newmail-row .em-sidebar-newmail { flex: 1; margin: 0; }\n.em-sidebar-newmail-row .em-sidebar-collapse-btn {\n  flex-shrink: 0;\n  color: #605e5c;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: inline-flex;\n}\n.em-sidebar-newmail-row .em-sidebar-collapse-btn:hover { background: #eceff2; color: #0f6cbd; }\n\n/* ===================== OUTLOOK-WEB READING PANE TOOLBAR ===================== */\n.em-viewer-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  padding: 6px 12px;\n  border-bottom: 1px solid #eaeaea;\n  background: #ffffff;\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n.em-vt-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: none;\n  background: transparent;\n  border-radius: 5px;\n  cursor: pointer;\n  color: #3b3a39;\n  font-size: 13px;\n  font-family: inherit;\n  white-space: nowrap;\n}\n.em-vt-btn:hover { background: #f3f2f1; }\n.em-vt-btn svg { color: #605e5c; }\n.em-vt-icon { padding: 6px 8px; }\n.em-vt-sep { width: 1px; height: 20px; background: #e6e6e6; margin: 0 6px; flex-shrink: 0; }\n.em-vt-spacer { flex: 1; min-width: 8px; }\n\n/* Slim the sender row now that actions live in the top toolbar. */\n.em-viewer-header-right { text-align: right; }\n\n/* ===================== CRM / INSIGHTS RIGHT PANE ===================== */\n.em-crm {\n  width: 210px;\n  min-width: 210px;\n  flex-shrink: 0;\n  border-left: 1px solid #eaeaea;\n  background: #faf9f8;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  font-family: 'Segoe UI', Arial, sans-serif;\n}\n.em-crm-head { padding: 12px 16px; font-size: 13px; font-weight: 600; color: #605e5c; border-bottom: 1px solid #ededed; }\n.em-crm-body { padding: 14px 16px; }\n.em-crm-contact { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }\n.em-crm-avatar {\n  width: 40px; height: 40px; border-radius: 50%; background: #8764b8; color: #fff;\n  display: inline-flex; align-items: center; justify-content: center; font-size: 15px; font-weight: 600; flex-shrink: 0;\n}\n.em-crm-info { min-width: 0; }\n.em-crm-name { font-size: 13.5px; font-weight: 600; color: #201f1e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-crm-email { font-size: 12px; color: #605e5c; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.em-crm-note {\n  display: flex; gap: 8px; align-items: flex-start;\n  font-size: 12.5px; color: #605e5c; line-height: 1.45;\n  background: #fff; border: 1px solid #ededed; border-radius: 8px; padding: 10px 12px;\n}\n.em-crm-note svg { color: #0f6cbd; flex-shrink: 0; margin-top: 1px; }\n.em-crm-note strong { color: #201f1e; word-break: break-all; }\n.interview-booking-page{min-height:100vh;background:#f3f5f8;border-top:12px solid #294348;padding:28px 0}.interview-booking-shell{max-width:980px;margin:0 0 0 55px;background:#fff;border-radius:0 8px 8px 0;box-shadow:0 5px 18px rgba(15,23,42,.08);overflow:hidden}.interview-booking-progress{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;padding:14px 28px 0}.booking-step{border-top:3px solid #dfe4ea;padding:8px 0;color:#9aa4b2;font-size:11px;font-weight:700;letter-spacing:.04em}.booking-step.active{border-color:#6178ee;color:#536fee}.interview-booking-content{display:grid;grid-template-columns:365px 1fr}.booking-calendar-panel{padding:18px 24px 28px;border-right:1px solid #dfe4ea}.booking-time-panel{position:relative;padding:18px 24px}.booking-kicker,.booking-date-kicker{color:#8995a8;font-size:11px;font-weight:700;letter-spacing:.08em}.booking-month-row{display:flex;align-items:center;justify-content:space-between;margin:14px 0 22px}.booking-month-row strong{background:#f0f4f8;border-radius:9px;padding:11px 16px;color:#102a43;font-size:15px}.booking-month-row button{width:38px;height:38px;margin-left:8px;border:1px solid #dce4ed;border-radius:8px;background:#fff;color:#60758f;font-size:25px;line-height:1}.booking-weekdays,.booking-days{display:grid;grid-template-columns:repeat(7,1fr);gap:6px}.booking-weekdays{margin-bottom:8px;color:#52657d;font-size:13px;text-align:center}.booking-days button{position:relative;height:42px;border:1px solid #f2f4f7;border-radius:10px;background:#fff;color:#1e293b;font-size:14px}.booking-days button:hover{border-color:#6178ee}.booking-days button.muted{color:#e2e7ed;background:#fafbfc}.booking-days button.selected{background:#5275e8;color:#fff;border-color:#ffb300;box-shadow:0 2px 5px rgba(82,117,232,.25)}.booking-days button i{position:absolute;bottom:5px;left:50%;width:4px;height:4px;border-radius:50%;background:#6178ee;transform:translateX(-50%)}.booking-days button.selected i{background:#fff}.booking-legend{display:flex;flex-wrap:wrap;gap:18px;border-top:1px solid #e5eaf0;margin-top:30px;padding-top:18px;color:#65778d;font-size:11px;font-weight:700;letter-spacing:.06em}.dot{display:inline-block;width:10px;height:10px;margin-right:6px;border-radius:50%;background:#fff;border:2px solid #dce4ed}.selected-dot{background:#6178ee;border-color:#6178ee}.unavailable-dot{background:#f0f3f7;border-color:#f0f3f7}.booking-back{float:right;border:0;border-radius:9px;background:#ffb21b;color:#fff;padding:9px 15px;font-weight:700}.booking-date-kicker{margin-top:18px}.booking-time-panel h1{margin:6px 0 16px;color:#111827;font-size:18px}.booking-timezone{color:#8995a8;font-size:13px}.booking-slots{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:18px}.booking-slots button{height:44px;border:1px solid #cbd5e1;border-radius:7px;background:#fff;color:#526ff0;font-weight:600}.booking-slots button:hover,.booking-slots button.chosen{border-color:#5275e8;background:#eef2ff}@media(max-width:760px){.interview-booking-shell{margin:0 12px}.interview-booking-content{grid-template-columns:1fr}.booking-calendar-panel{border-right:0;border-bottom:1px solid #dfe4ea}.booking-slots{grid-template-columns:1fr 1fr}}@media(max-width:420px){.interview-booking-progress{padding-left:16px;padding-right:16px}.booking-calendar-panel,.booking-time-panel{padding-left:16px;padding-right:16px}.booking-legend{gap:10px}.booking-slots{grid-template-columns:1fr}}\n.interview-booking-page{position:fixed;inset:0;z-index:9999;overflow:auto;padding-top:27px}.interview-booking-shell{min-height:858px}\n.booking-info-panel{padding:18px 24px;border-left:1px solid #dfe4ea;background:#fbfcfe}.booking-info-panel h2{margin:18px 0 24px;color:#102a43;font-size:18px}.booking-info-panel label{display:block;margin:0 0 6px;color:#52657d;font-size:12px;font-weight:700}.booking-info-panel input{width:100%;height:42px;margin-bottom:18px;padding:0 11px;border:1px solid #cbd5e1;border-radius:7px;color:#243b53;font-size:13px;outline:none}.booking-info-panel input:focus{border-color:#5275e8;box-shadow:0 0 0 2px #eef2ff}.booking-continue{width:100%;height:42px;margin-top:8px;border:0;border-radius:7px;background:#5275e8;color:#fff;font-weight:700}.booking-continue:disabled{cursor:not-allowed;background:#cbd5e1}@media(max-width:900px){.interview-booking-content{grid-template-columns:365px 1fr}.booking-info-panel{grid-column:1/-1;border-top:1px solid #dfe4ea;border-left:0}}\n.interview-booking-content{grid-template-columns:220px 267px minmax(430px,1fr)}@media(max-width:900px){.interview-booking-content{grid-template-columns:267px 1fr}.booking-profile-panel{grid-column:1/-1;border-right:0;border-bottom:1px solid #dfe4ea}}\n.interview-booking-shell{width:calc(100vw - 110px);max-width:none;min-height:calc(100vh - 54px)}.interview-booking-content{grid-template-columns:260px 350px minmax(500px,1fr)}.booking-calendar-panel{padding-left:28px;padding-right:28px}.booking-time-panel{padding-left:30px;padding-right:30px}.booking-profile-panel{padding-left:24px;padding-right:24px}@media(max-width:900px){.interview-booking-shell{width:calc(100vw - 24px);margin-left:12px}.interview-booking-content{grid-template-columns:267px 1fr}}\n.booking-profile-panel{padding:22px 16px;border-right:1px solid #dfe4ea;color:#64748b}.booking-avatar{display:flex;align-items:center;justify-content:center;width:50px;height:50px;border-radius:50%;background:#5275e8;color:#fff;font-size:17px;font-weight:700;margin-bottom:14px}.booking-profile-label{font-size:12px;margin-bottom:3px}.booking-profile-panel h2{margin:0 0 10px;color:#102a43;font-size:16px}.booking-profile-detail{display:flex;gap:6px;align-items:flex-start;margin:8px 0;font-size:12px;line-height:1.35}.booking-profile-zone{border-top:1px solid #edf0f4;padding-top:12px;margin-top:365px;font-size:12px;line-height:1.5}.booking-profile-zone small{display:block;color:#8995a8;font-size:10px;font-weight:700;letter-spacing:.08em;margin-bottom:5px}.booking-profile-time{padding-left:15px}.booking-profile-time span{float:right;font-size:15px}.booking-info-panel{display:none}.booking-month-row strong{font-size:16px}.booking-weekdays{font-size:14px}.booking-days button{font-size:15px}.booking-kicker,.booking-date-kicker{font-size:12px}.booking-time-panel h1{font-size:20px}.booking-timezone{font-size:14px}.booking-slots button{font-size:14px}\n.interview-booking-page,.interview-booking-page button,.interview-booking-page input{font-family:\"Plus Jakarta Sans\",sans-serif}.interview-booking-shell{border:1px solid #e5eaf0}.booking-calendar-panel{background:#fff}.booking-time-panel{background:#fff}.booking-info-panel{background:linear-gradient(180deg,#fbfcff 0%,#f7fafc 100%)}.booking-month-row strong{font-weight:700}.booking-month-row button{transition:all .2s ease}.booking-month-row button:hover{background:#eef2ff;color:#5275e8;transform:translateY(-1px)}.booking-days button{font-weight:600;transition:all .18s ease}.booking-days button:not(.muted):hover{background:#f1f4ff;transform:translateY(-1px)}.booking-days button.selected{font-weight:700}.booking-slots button{font-family:inherit;font-size:13px;transition:all .2s ease}.booking-slots button:hover,.booking-slots button.chosen{box-shadow:0 3px 8px rgba(82,117,232,.16);transform:translateY(-1px)}.booking-back{font-family:inherit;font-size:12px;box-shadow:0 3px 8px rgba(255,178,27,.2);transition:transform .2s ease}.booking-back:hover{transform:translateY(-1px)}.booking-info-panel h2{font-weight:700;letter-spacing:-.01em}.booking-continue{font-family:inherit;font-size:13px;box-shadow:0 4px 10px rgba(82,117,232,.2);transition:all .2s ease}.booking-continue:not(:disabled):hover{background:#405ed8;transform:translateY(-1px)}\n.interview-booking-page{border-top:0!important;padding:40px 0 28px!important}.interview-booking-shell{width:calc(100vw - 120px);max-width:1800px!important;margin:0 auto!important;min-height:858px;border-radius:8px!important}.booking-calendar-panel{padding-top:26px!important;padding-bottom:36px!important}.booking-month-row{margin-top:16px!important;margin-bottom:26px!important}.booking-weekdays,.booking-days{gap:8px!important}.booking-days button{height:46px!important}.booking-month-row button{width:40px!important;height:40px!important}\n.swal2-container{z-index:20000!important}\n.interview-booking-content{grid-template-columns:300px 390px minmax(460px,1fr)!important}.booking-calendar-panel{padding-left:28px!important;padding-right:28px!important}.booking-weekdays,.booking-days{gap:10px!important}.booking-days button{height:48px!important}.booking-slots{max-width:820px;gap:8px 10px}.booking-slots button{height:42px}\n.booking-save{position:absolute;right:30px;bottom:28px;border:0;border-radius:8px;background:#5275e8;color:#fff;padding:10px 26px;font-family:inherit;font-size:13px;font-weight:700;box-shadow:0 4px 10px rgba(82,117,232,.2)}.booking-save:disabled{cursor:not-allowed;background:#cbd5e1;box-shadow:none}\n.booking-profile-panel{display:flex;flex-direction:column;min-height:858px}.booking-profile-zone{margin-top:auto!important}\n.booking-slots{width:100%;max-width:none;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:14px}.booking-time-panel{padding-right:34px}\n.booking-profile-zone select{width:100%;margin:2px 0;padding:0;border:0;background:transparent;color:#60758f;font-family:inherit;font-size:12px;outline:0;cursor:pointer}.booking-profile-zone select option{color:#243b53}\n.booking-profile-zone-row{display:flex;align-items:center;gap:8px}.booking-profile-zone-row select{flex:1;min-width:0}.booking-profile-zone-row .booking-profile-time{padding-left:0;white-space:nowrap;color:#60758f}\n.booking-save-spinner{display:inline-block;width:14px;height:14px;margin-right:7px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;vertical-align:-2px;animation:booking-save-spin .7s linear infinite}@keyframes booking-save-spin{to{transform:rotate(360deg)}}\n.booking-confirmation-card{width:min(560px,calc(100vw - 32px));margin:12vh auto 0;padding:48px 36px;text-align:center;background:#fff;border:1px solid #e5eaf0;border-radius:12px;box-shadow:0 8px 28px rgba(15,23,42,.1);font-family:\"Plus Jakarta Sans\",sans-serif}.booking-confirmation-icon{width:56px;height:56px;margin:0 auto 18px;border-radius:50%;background:#5275e8;color:#fff;font-size:34px;line-height:56px}.booking-confirmation-card h1{margin:0 0 10px;color:#102a43;font-size:24px}.booking-confirmation-type{color:#5275e8;font-weight:700}.booking-confirmation-details{display:flex;flex-direction:column;gap:8px;margin:24px 0;padding:18px;border:1px solid #dfe6f3;border-radius:8px;background:#f7f9ff;color:#334e68}.booking-confirmation-details span{color:#627d98}\n\n.schedule-review-modal {\n  max-width: min(1180px, calc(100vw - 42px)) !important;\n  width: 94% !important;\n}\n\n.schedule-review-modal .modal-content {\n  border: 0;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #f8fafc;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.22);\n}\n\n.schedule-review-header {\n  padding: 18px 22px !important;\n  border-bottom: 1px solid #dbe5f0 !important;\n  background: linear-gradient(135deg, #12385f 0%, #1f5f8f 100%) !important;\n  color: #ffffff !important;\n}\n\n.schedule-review-header .btn-close {\n  filter: invert(1) grayscale(1) brightness(1.8);\n  opacity: 0.9;\n}\n\n.schedule-review-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.schedule-review-title-icon {\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  font-size: 19px;\n  flex: 0 0 auto;\n}\n\n.schedule-review-title {\n  color: #ffffff;\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schedule-review-subtitle {\n  margin-top: 3px;\n  color: #d8eaff;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.schedule-review-body {\n  padding: 18px 20px 12px !important;\n  background: #f4f7fb !important;\n}\n\n.schedule-review-summary {\n  display: grid;\n  grid-template-columns: 150px minmax(220px, 1fr) 230px;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.schedule-review-summary > div {\n  min-width: 0;\n  padding: 10px 12px;\n  border: 1px solid #dbe5f0;\n  border-radius: 9px;\n  background: #ffffff;\n}\n\n.schedule-review-summary-label {\n  display: block;\n  margin-bottom: 3px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.schedule-review-summary strong {\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.schedule-review-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  padding: 10px 12px;\n  border: 1px solid #fecdd3;\n  border-radius: 9px;\n  background: #fff1f2;\n  color: #be123c;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.schedule-review-list {\n  max-height: 62vh;\n  overflow: auto;\n  padding-right: 4px;\n}\n\n.schedule-review-card {\n  margin-bottom: 14px;\n  padding: 16px;\n  border: 1px solid #d9e3ef;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.schedule-review-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.schedule-review-candidate-meta {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n}\n\n.schedule-review-avatar {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bfdbfe;\n  border-radius: 50%;\n  background: #eaf4ff;\n  color: #0f4f82;\n  font-size: 15px;\n  font-weight: 900;\n  flex: 0 0 auto;\n}\n\n.schedule-review-candidate-title {\n  color: #0f3f6e;\n  font-size: 14px;\n  font-weight: 900;\n  line-height: 1.2;\n}\n\n.schedule-review-candidate-email {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 4px;\n  min-width: 0;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.schedule-review-candidate-email span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.schedule-review-job-pill {\n  max-width: 360px;\n  overflow: hidden;\n  padding: 6px 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #f8fbff;\n  color: #1e4f78;\n  font-size: 12px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 0 1 auto;\n}\n\n.schedule-review-label {\n  display: block;\n  margin: 0 0 6px;\n  color: #1f2937;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.schedule-review-label span {\n  color: #dc2626;\n}\n\n.schedule-review-input.form-control {\n  height: 38px;\n  border: 1px solid #d5deea;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #111827;\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.schedule-review-input.form-control:focus {\n  border-color: #1a5fa8;\n  box-shadow: 0 0 0 3px rgba(26, 95, 168, 0.12);\n}\n\n.schedule-review-input.form-control:disabled {\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.schedule-review-footer {\n  display: flex;\n  justify-content: center !important;\n  gap: 10px;\n  padding: 14px 20px !important;\n  border-top: 1px solid #dbe5f0 !important;\n  background: #ffffff !important;\n}\n\n.schedule-review-cancel.btn {\n  min-width: 92px;\n  height: 38px;\n  border-color: #cbd5e1;\n  border-radius: 8px;\n  color: #334155;\n  font-weight: 700;\n}\n\n.schedule-review-primary.btn {\n  min-width: 210px;\n  height: 38px;\n  border: 0;\n  border-radius: 8px;\n  background: #126fb3;\n  color: #ffffff;\n  font-weight: 800;\n  box-shadow: 0 9px 18px rgba(18, 111, 179, 0.22);\n}\n\n.schedule-review-primary.btn:hover,\n.schedule-review-primary.btn:focus {\n  background: #0f5f9b;\n  color: #ffffff;\n}\n\n@media (max-width: 900px) {\n  .schedule-review-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .schedule-review-card-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .schedule-review-job-pill {\n    max-width: 100%;\n  }\n}\n.schedule-history-panel { margin-top:18px; padding:16px; border:1px solid #d9e7f5; border-radius:10px; background:#fff; }\n.schedule-history-title { color:#0b3f75; font-size:15px; font-weight:700; margin-bottom:12px; }\n.schedule-history-timeline { border-left:2px solid #cfe0f2; padding-left:16px; display:grid; gap:12px; }\n.schedule-history-item { position:relative; padding:11px 13px; border:1px solid #e1eaf3; border-radius:8px; background:#f8fbff; color:#52677d; font-size:12px; line-height:1.6; }\n.schedule-history-item::before { content:\"\"; position:absolute; width:9px; height:9px; border-radius:50%; background:#1a5fa8; left:-22px; top:16px; border:2px solid #fff; box-shadow:0 0 0 1px #9fc2df; }\n.schedule-history-badge { display:inline-block; padding:3px 8px; margin-bottom:5px; border-radius:999px; background:#eaf4ff; color:#1a5fa8; font-size:11px; font-weight:700; }\n.schedule-history-badge.is-deleted { background:#fff1f1; color:#b42318; }\n.schedule-history-summary { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:6px 18px; margin:8px 0 10px; padding:10px 12px; border:1px solid #e1eaf3; border-radius:8px; background:#fff; }\n.schedule-history-summary-row { display:grid; grid-template-columns:72px minmax(0, 1fr); gap:8px; align-items:start; min-width:0; font-size:12px; line-height:1.45; }\n.schedule-history-summary-row span { color:#728399; font-weight:600; }\n.schedule-history-summary-row strong { color:#25435f; font-weight:600; overflow-wrap:anywhere; }\n.schedule-history-summary-row.is-new strong { color:#16794a; }\n.schedule-history-summary-row.full-width { grid-column:1 / -1; }\n.schedule-history-multiline { display:flex; flex-direction:column; gap:2px; }\n.archive-reason { display:flex; align-items:center; gap:8px; min-width:220px; line-height:1.4; }\n.deleted-badge, .archived-badge { display:inline-block; flex:0 0 auto; border-radius:6px; padding:3px 8px; font-size:12px; font-weight:600; }\n.deleted-badge { color:#b91c1c; background:#fee2e2; }\n.archived-badge { color:#92400e; background:#fef3c7; }\n@media (max-width: 640px) {\n  .schedule-history-summary { grid-template-columns:1fr; gap:6px; }\n  .schedule-history-summary-row.full-width { grid-column:auto; }\n}\n.schedule-history-details { margin-top:9px; border-top:1px solid #e1eaf3; padding-top:8px; }\n.schedule-history-details summary { cursor:pointer; color:#1a5fa8; font-weight:700; font-size:12px; }\n.schedule-history-detail-grid { display:grid; grid-template-columns:minmax(100px, .8fr) minmax(120px, 1fr) minmax(120px, 1fr); margin-top:8px; border:1px solid #e1eaf3; border-radius:6px; overflow:hidden; font-size:11px; }\n.schedule-history-detail-grid > div { padding:6px 7px; border-bottom:1px solid #edf2f7; overflow-wrap:anywhere; }\n.schedule-history-detail-grid > div:nth-child(3n+1) { background:#f8fbff; font-weight:600; color:#52677d; }\n.schedule-history-detail-header { background:#eef5fc !important; color:#214c76 !important; font-weight:700 !important; }\n.salary-missing-alert { text-align:left; width:100%; box-sizing:border-box; }\n.salary-missing-intro { margin:0 0 12px; color:#5d6875; font-size:14px; }\n.salary-missing-table-wrap { max-height:220px; overflow:auto; border:1px solid #e4e9ef; border-radius:7px; }\n.salary-missing-table { width:100%; min-width:390px; table-layout:fixed; border-collapse:collapse; font-size:13px; }\n.salary-missing-table th { position:sticky; top:0; background:#f5f8fb; color:#52606d; font-weight:700; text-align:left; }\n.salary-missing-table th, .salary-missing-table td { padding:9px 10px; border:1px solid #dbe3ec; word-break:normal; overflow-wrap:break-word; }\n.salary-missing-table tbody tr:last-child td { border-bottom:0; }\n.salary-missing-table th:first-child, .salary-missing-table td:first-child { width:58px; min-width:58px; white-space:nowrap; color:#52606d; }\n.salary-missing-table th:nth-child(2), .salary-missing-table td:nth-child(2) { width:58%; }\n.salary-missing-table th:nth-child(3), .salary-missing-table td:nth-child(3) { width:27%; }\n.salary-missing-status { display:inline-block; padding:3px 8px; border-radius:999px; background:#fff1f0; color:#b42318; font-size:11px; font-weight:700; }\n\n/* Job action logs use a compact timeline so the modal stays easy to scan. */\n.action-timeline-modal .modal-dialog { width:calc(100% - 24px); max-width:860px; }\n.action-timeline-modal .modal-content { overflow:hidden; border:0; border-radius:16px; box-shadow:0 24px 60px rgba(16, 42, 67, .24); }\n.action-timeline-header { padding:18px 22px; border:0; background:linear-gradient(120deg, #0d4770, #087c83); color:#fff; }\n.action-timeline-header .btn-close { filter:brightness(0) invert(1); opacity:.9; }\n.action-timeline-heading { display:flex; align-items:center; gap:12px; padding-right:28px; }\n.action-timeline-heading-icon { display:grid; place-items:center; width:40px; height:40px; flex:0 0 40px; border:1px solid rgba(255,255,255,.28); border-radius:12px; background:rgba(255,255,255,.14); font-size:18px; }\n.action-timeline-title, .action-timeline-subtitle { display:block; }\n.action-timeline-title { font-size:18px; font-weight:750; line-height:1.25; }\n.action-timeline-subtitle { margin-top:3px; color:rgba(255,255,255,.76); font-size:12px; font-weight:500; }\n.action-timeline-count { margin-left:auto; padding:6px 10px; border:1px solid rgba(255,255,255,.24); border-radius:999px; background:rgba(255,255,255,.12); color:#fff; font-size:12px; font-weight:700; white-space:nowrap; }\n.action-timeline-body { max-height:min(68vh, 650px); overflow-y:auto; padding:20px 22px; background:#f4f8fb; }\n.action-timeline-list { display:grid; gap:14px; }\n.action-timeline-item { position:relative; display:grid; grid-template-columns:26px minmax(0, 1fr); gap:10px; }\n.action-timeline-rail { position:relative; display:flex; justify-content:center; }\n.action-timeline-rail::after { content:\"\"; position:absolute; top:28px; bottom:-20px; width:2px; background:#d8e6ef; }\n.action-timeline-item:last-child .action-timeline-rail::after { display:none; }\n.action-timeline-dot { z-index:1; display:grid; place-items:center; width:26px; height:26px; border:4px solid #f4f8fb; border-radius:50%; background:#0e7381; color:#fff; box-shadow:0 0 0 1px #b7d9df; font-size:10px; }\n.action-timeline-card { min-width:0; padding:15px 16px; border:1px solid #dce7ef; border-radius:12px; background:#fff; box-shadow:0 4px 12px rgba(31, 71, 98, .05); }\n.action-timeline-card-top { display:flex; align-items:center; justify-content:space-between; gap:12px; }\n.action-timeline-badge { display:inline-flex; max-width:70%; padding:5px 9px; border-radius:7px; background:#e8f5f3; color:#08726f; font-size:12px; font-weight:750; line-height:1.25; }\n.action-timeline-card time { color:#6a7e90; font-size:12px; white-space:nowrap; }\n.action-timeline-card time i { margin-right:4px; color:#0e7381; }\n.action-timeline-description { margin:11px 0 10px; color:#334d63; font-size:14px; line-height:1.55; }\n.action-timeline-meta { display:flex; flex-wrap:wrap; gap:8px 16px; color:#718497; font-size:11px; }\n.action-timeline-meta i { margin-right:4px; color:#0e7381; }\n.action-timeline-change-box { margin-top:13px; padding:12px; border:1px solid #d8e8ef; border-radius:9px; background:#f7fbfc; }\n.action-timeline-change-title { margin-bottom:9px; color:#0d5e70; font-size:11px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }\n.action-timeline-change-title i { margin-right:5px; }\n.action-timeline-change-box .activity-change-list { display:grid; gap:7px; }\n.action-timeline-change-box .activity-change-item { padding:9px 11px; border:1px solid #e0ebf0; border-radius:7px; background:#fff; font-size:12px; line-height:1.5; }\n.action-timeline-change-box .activity-change-item strong { display:block; margin-bottom:3px; color:#0c527d; font-size:12px; }\n.activity-detail-sections { display:grid; gap:12px; }\n.activity-detail-section { padding:12px; border:1px solid #dce9ef; border-radius:10px; background:#fbfdfe; }\n.activity-detail-section h6 { display:flex; align-items:center; gap:7px; margin:0 0 10px; color:#0d5e70; font-size:11px; font-weight:800; letter-spacing:.04em; text-transform:uppercase; }\n.activity-detail-section h6::before { content:\"\"; width:5px; height:16px; border-radius:4px; background:#0e8790; }\n.activity-field-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:8px; }\n.activity-before-after-table { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.activity-table-header, .activity-table-row { display:grid; grid-template-columns:minmax(150px, 1.15fr) minmax(130px, 1fr) minmax(130px, 1fr); gap:10px; align-items:start; padding:9px 10px; }\n.activity-table-header { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }\n.activity-table-row { border-top:1px solid #edf3f6; color:#38556b; font-size:12px; }\n.activity-table-row strong { color:#294a61; font-weight:700; overflow-wrap:anywhere; }\n.activity-table-row > span { overflow-wrap:anywhere; }\n.activity-table-row > span:last-child { color:#08726f; }\n.activity-html-text, .activity-html-details { display:block; white-space:pre-wrap; line-height:1.45; }\n.activity-html-details summary { cursor:pointer; color:#0e7381; font-size:11px; font-weight:700; }\n.activity-html-details > span { display:block; max-height:220px; margin-top:5px; overflow:auto; white-space:pre-wrap; }\n.skill-change-table .activity-table-header, .skill-change-table .activity-table-row { grid-template-columns:minmax(100px, .85fr) minmax(130px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr); }\n.recruiter-change-table .activity-table-header, .recruiter-change-table .activity-table-row { grid-template-columns:130px minmax(0, 1fr); }\n.permission-change-table .activity-table-header, .permission-change-table .activity-table-row { grid-template-columns:minmax(130px, 1.1fr) minmax(130px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr); }\n.talent-change-table .activity-table-header, .talent-change-table .activity-table-row { grid-template-columns:minmax(170px, 1fr) minmax(0, 1.4fr) minmax(0, 1.4fr); }\n.activity-field-card { padding:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.activity-field-card > strong { display:block; margin-bottom:7px; color:#294a61; font-size:12px; }\n.activity-field-card > div, .activity-permission > div { display:grid; grid-template-columns:52px minmax(0, 1fr); gap:8px; padding-top:4px; color:#708497; font-size:11px; }\n.activity-field-card > div b, .activity-permission > div b { overflow-wrap:anywhere; color:#38556b; font-weight:600; }\n.activity-field-card > div:last-child b { color:#08726f; }\n.activity-person-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:10px; }\n.activity-person-grid > div { display:flex; flex-direction:column; gap:5px; }\n.activity-person-grid > div > span, .activity-question-content span { color:#788d9d; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }\n.activity-person { display:block; padding:6px 9px; border-radius:7px; background:#eaf7f1; color:#16794a; font-size:12px; }\n.activity-person.removed { background:#fff1f0; color:#b42318; }\n.activity-permission-list, .activity-question-list { display:grid; gap:8px; }\n.activity-permission { padding:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.activity-permission > strong { display:block; margin-bottom:5px; color:#294a61; font-size:13px; }\n.activity-question { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.activity-question summary { cursor:pointer; padding:10px 12px; color:#294a61; font-size:12px; font-weight:650; line-height:1.45; }\n.activity-question summary::marker { color:#0e7381; }\n.activity-question-content { display:grid; gap:6px; padding:0 12px 11px; border-top:1px solid #edf3f6; }\n.activity-question-content > div { display:grid; grid-template-columns:145px minmax(0, 1fr); gap:8px; padding-top:8px; }\n.activity-question-content strong { overflow-wrap:anywhere; color:#38556b; font-size:12px; font-weight:600; }\n.activity-detail-empty { padding:14px; border:1px dashed #cbdce5; border-radius:9px; background:#f8fbfc; color:#7890a2; font-size:13px; text-align:center; }\n.activity-event-table, .activity-update-table { overflow:hidden; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.activity-event-table > div { display:grid; grid-template-columns:150px minmax(0, 1fr); gap:12px; padding:8px 10px; border-bottom:1px solid #edf3f6; }\n.activity-event-table > div:last-child, .activity-update-table > div:last-child { border-bottom:0; }\n.activity-event-table span, .activity-update-table span { color:#788d9d; font-size:11px; }\n.activity-event-table strong { overflow-wrap:anywhere; color:#294a61; font-size:12px; font-weight:650; }\n.activity-update-table { margin-top:10px; }\n.activity-update-table > div { display:grid; grid-template-columns:minmax(130px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr); gap:10px; padding:8px 10px; border-bottom:1px solid #edf3f6; }\n.activity-update-header { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }\n.activity-update-table strong { color:#294a61; font-size:11px; }\n.activity-update-table > div:not(.activity-update-header) span:last-child { color:#08726f; }\n.activity-inline-details summary { cursor:pointer; color:#0e7381; font-size:11px; font-weight:700; }\n.activity-inline-details > span { display:block; margin-top:5px; white-space:pre-wrap; }\n.question-activity-details { margin-top:14px; padding:18px; border:1px solid #d7e8ed; border-radius:14px; background:linear-gradient(180deg, #f7fcfd 0%, #f4f8fb 100%); }\n.question-activity-title-row { display:flex; align-items:center; gap:10px; margin-bottom:15px; }\n.question-activity-icon { display:grid; place-items:center; width:34px; height:34px; border-radius:10px; background:#dff3ef; color:#08726f; }\n.question-activity-title-row h5 { margin:0; color:#16475d; font-size:14px; font-weight:800; }\n.question-activity-title-row span:not(.question-activity-icon) { color:#7890a2; font-size:11px; }\n.question-activity-stats { display:grid; grid-template-columns:repeat(4, minmax(0, 1fr)); gap:9px; margin-bottom:14px; }\n.question-activity-stats > div { display:flex; min-height:72px; flex-direction:column; justify-content:center; padding:10px 12px; border:1px solid #dce9ef; border-radius:10px; background:#fff; }\n.question-activity-stats span { color:#7890a2; font-size:10px; font-weight:800; letter-spacing:.04em; text-transform:uppercase; }\n.question-activity-stats strong { margin-top:2px; color:#23465d; font-size:23px; line-height:1.1; }\n.question-activity-stats small { color:#7890a2; font-size:10px; }\n.question-activity-stats .is-positive { border-color:#bde3d5; background:#f5fffa; }\n.question-activity-stats .is-positive strong { color:#08794d; }\n.question-activity-stats .is-accent { border-color:#c7dff0; background:#f5faff; }\n.question-activity-stats .is-accent strong { color:#116da2; }\n.question-activity-panel { padding:14px; border:1px solid #dce9ef; border-radius:11px; background:#fff; box-shadow:0 3px 10px rgba(31, 71, 98, .04); }\n.question-activity-panel + .question-activity-panel { margin-top:10px; }\n.question-activity-panel h6 { display:flex; align-items:center; justify-content:space-between; margin:0 0 10px; color:#174b62; font-size:13px; font-weight:800; letter-spacing:0; text-transform:none; }\n.question-activity-panel h6::after { content:\"\"; width:32px; height:3px; border-radius:4px; background:#8bc9c7; }\n.question-activity-panel.after { border-color:#bfe3d7; background:#fbfffd; }\n.question-activity-table { overflow:auto; border:1px solid #e2edf1; border-radius:7px; }\n.question-activity-table-head, .question-activity-table-row { display:grid; grid-template-columns:1.35fr .7fr 1fr .8fr .8fr .7fr; min-width:620px; gap:8px; padding:8px; font-size:11px; }\n.question-activity-table-head { background:#f2f8fa; color:#0d5e70; font-size:9px; font-weight:800; letter-spacing:.03em; text-transform:uppercase; }\n.question-activity-table-row { border-top:1px solid #edf3f6; color:#38556b; }\n.question-activity-table-row strong { color:#294a61; }\n.question-activity-setting { display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid #edf3f6; color:#788d9d; font-size:11px; }\n.question-activity-setting strong { color:#38556b; }\n.question-activity-question-list { margin-top:10px; color:#38556b; font-size:12px; line-height:1.5; }\n.question-activity-label { display:block; margin-bottom:5px; color:#0d5e70; font-size:10px; font-weight:800; text-transform:uppercase; }\n.question-activity-question-list div { padding:7px 8px; border-top:1px solid #edf3f6; }\n.question-activity-generated-list { display:grid; gap:8px; }\n.question-activity-generated { overflow:hidden; border:1px solid #dce9ef; border-radius:8px; background:#fff; }\n.question-activity-generated summary { cursor:pointer; padding:9px 10px; color:#294a61; font-size:12px; font-weight:700; line-height:1.45; }\n.question-activity-generated > div { display:grid; grid-template-columns:130px minmax(0, 1fr); gap:8px; padding:7px 10px; border-top:1px solid #edf3f6; font-size:11px; }\n.question-activity-generated > div span { color:#788d9d; font-weight:700; text-transform:uppercase; }\n.question-activity-generated > div strong { overflow-wrap:anywhere; color:#38556b; }\n.question-activity-empty { margin-top:14px; padding:14px; border:1px dashed #cbdce5; border-radius:9px; background:#f8fbfc; color:#7890a2; font-size:12px; text-align:center; }\n.question-activity-preview { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-top:14px; padding:12px 14px; border:1px solid #cfe5ea; border-radius:10px; background:#f4fbfc; }\n.question-activity-preview > div { display:flex; align-items:center; gap:8px; color:#0d5e70; font-size:12px; font-weight:700; }\n.question-activity-preview > div i { color:#0e8790; }\n.question-activity-preview .btn { display:inline-flex; align-items:center; gap:7px; border:0; border-radius:8px; background:#0c6e9f; font-size:11px; font-weight:700; }\n.question-activity-modal .modal-dialog { width:calc(100% - 24px); max-width:1100px; }\n.question-activity-modal .modal-content { overflow:hidden; border:0; border-radius:16px; box-shadow:0 24px 70px rgba(16, 42, 67, .28); }\n.question-activity-modal-header { padding:18px 22px; border:0; background:linear-gradient(120deg, #0d4770, #087c83); color:#fff; }\n.question-activity-modal-header .btn-close { filter:brightness(0) invert(1); }\n.question-activity-modal-heading { display:flex; align-items:center; gap:12px; padding-right:28px; }\n.question-activity-modal-icon { display:grid; place-items:center; width:40px; height:40px; border:1px solid rgba(255,255,255,.28); border-radius:12px; background:rgba(255,255,255,.14); font-size:18px; }\n.question-activity-modal-heading strong, .question-activity-modal-heading span { display:block; }\n.question-activity-modal-heading strong { font-size:18px; }\n.question-activity-modal-heading span { margin-top:3px; color:rgba(255,255,255,.76); font-size:12px; }\n.question-activity-modal-body { max-height:calc(100vh - 150px); overflow-y:auto; padding:20px 22px; background:#f4f8fb; }\n.question-activity-modal-body .question-activity-details { margin-top:0; padding:16px; background:transparent; border:0; }\n.question-activity-count-table { overflow:hidden; margin-bottom:10px; border:1px solid #e0ebf0; border-radius:8px; background:#fff; }\n.question-activity-count-table > div { display:grid; grid-template-columns:minmax(170px, 1fr) repeat(4, minmax(70px, 100px)); gap:10px; padding:10px 12px; border-bottom:1px solid #edf3f6; font-size:12px; }\n.question-activity-count-table.activity-before-after-table > div { grid-template-columns:minmax(150px, 1fr) minmax(130px, 1fr) repeat(2, minmax(90px, 1fr)); }\n.question-activity-count-table > div:last-child { border-bottom:0; }\n.question-activity-count-table > div:first-child { background:#f2f8fa; color:#0d5e70; font-size:10px; font-weight:800; text-transform:uppercase; }\n.question-activity-count-table strong { color:#294a61; }\n.question-activity-group { margin-top:9px; border:1px solid #dce9ef; border-radius:9px; background:#fbfdfe; }\n.question-activity-group summary { cursor:pointer; padding:10px 12px; color:#0d5e70; font-size:12px; font-weight:800; }\n.question-activity-list { display:grid; gap:8px; margin:0; padding:0 12px 12px 30px; }\n.question-activity-list li { padding:10px 11px; border:1px solid #e4edf1; border-radius:8px; background:#fff; color:#294a61; font-size:12px; line-height:1.5; }\n.question-activity-list li strong, .question-activity-list li span { display:block; }\n.question-activity-list li span { margin-top:3px; color:#788d9d; font-size:11px; }\n.action-timeline-detail-grid { display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:7px; margin-top:12px; }\n.action-timeline-detail { display:flex; min-width:0; flex-direction:column; gap:3px; padding:8px 10px; border:1px solid #e5edf2; border-radius:7px; background:#f9fbfc; }\n.action-timeline-detail span { color:#7890a2; font-size:10px; font-weight:700; text-transform:uppercase; }\n.action-timeline-detail strong { overflow-wrap:anywhere; color:#38556b; font-size:12px; font-weight:600; }\n.action-timeline-empty { display:flex; min-height:240px; align-items:center; justify-content:center; flex-direction:column; gap:7px; color:#7890a2; text-align:center; }\n.action-timeline-empty strong { color:#294a61; font-size:16px; }\n.action-timeline-empty-icon { display:grid; place-items:center; width:48px; height:48px; margin-bottom:4px; border-radius:14px; background:#e6f1f5; color:#0e7381; font-size:21px; }\n.action-timeline-footer { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:13px 22px; border-top:1px solid #e2ebf1; background:#fff; color:#718497; font-size:12px; }\n.action-timeline-next { display:inline-flex; align-items:center; gap:7px; border:0; border-radius:8px; background:#0c6e9f; font-size:12px; font-weight:700; }\n.action-timeline-next:hover, .action-timeline-next:focus { background:#095b84; }\n@media (max-width:640px) {\n  .action-timeline-header, .action-timeline-body, .action-timeline-footer { padding-left:14px; padding-right:14px; }\n  .action-timeline-count { display:none; }\n  .action-timeline-card-top { align-items:flex-start; flex-direction:column; gap:8px; }\n  .action-timeline-badge { max-width:100%; }\n  .action-timeline-card time { font-size:11px; }\n  .action-timeline-detail-grid { grid-template-columns:1fr; }\n  .activity-field-grid, .activity-person-grid { grid-template-columns:1fr; }\n  .activity-table-header, .activity-table-row, .skill-change-table .activity-table-header, .skill-change-table .activity-table-row, .permission-change-table .activity-table-header, .permission-change-table .activity-table-row { grid-template-columns:repeat(4, minmax(90px, 1fr)); font-size:10px; gap:6px; padding:8px 6px; }\n  .recruiter-change-table .activity-table-header, .recruiter-change-table .activity-table-row { grid-template-columns:90px minmax(0, 1fr); }\n  .talent-change-table .activity-table-header, .talent-change-table .activity-table-row { grid-template-columns:120px minmax(0, 1fr) minmax(0, 1fr); }\n  .activity-question-content > div { grid-template-columns:1fr; gap:3px; }\n  .activity-event-table > div, .activity-update-table > div { grid-template-columns:1fr; gap:3px; }\n  .question-activity-generated > div { grid-template-columns:1fr; gap:3px; }\n  .question-activity-preview { align-items:flex-start; flex-direction:column; }\n  .question-activity-stats { grid-template-columns:repeat(2, minmax(0, 1fr)); }\n  .question-activity-count-table > div { grid-template-columns:minmax(110px, 1fr) repeat(4, minmax(52px, 72px)); gap:6px; font-size:10px; }\n  .question-activity-count-table.activity-before-after-table > div { grid-template-columns:minmax(90px, 1fr) minmax(90px, 1fr) repeat(2, minmax(62px, 1fr)); }\n}\n\n/* Recruiter activity report polish */\n.recruiter-report-page {\n  padding: 18px 20px 34px;\n  background: radial-gradient(circle at 92% 0%, rgba(14, 165, 233, 0.1), transparent 26%),\n    linear-gradient(180deg, #f7fbff 0%, #eef4fa 100%);\n}\n\n.recruiter-report-hero {\n  min-height: 142px;\n  border-radius: 24px;\n  background: linear-gradient(118deg, #10224f 0%, #1f4da7 48%, #0b9fda 100%);\n  box-shadow: 0 18px 38px rgba(15, 52, 96, 0.2);\n}\n\n.recruiter-report-hero::after {\n  content: \"\";\n  position: absolute;\n  width: 320px;\n  height: 320px;\n  right: 12%;\n  top: -210px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  pointer-events: none;\n}\n\n.recruiter-report-summary-grid {\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.recruiter-summary-card {\n  min-height: 88px;\n  border-radius: 16px;\n  box-shadow: 0 10px 24px rgba(15, 52, 96, 0.08);\n  transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\n.recruiter-summary-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 16px 30px rgba(15, 52, 96, 0.14);\n}\n\n.recruiter-breakdown-panel {\n  border-radius: 20px;\n  border-color: #d7e5f2;\n  box-shadow: 0 14px 32px rgba(15, 52, 96, 0.08);\n}\n\n.recruiter-breakdown-header {\n  padding: 20px 22px 16px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  border-bottom: 1px solid #e3edf6;\n}\n\n.recruiter-breakdown-table-wrap {\n  margin: 0 12px 12px !important;\n  border: 1px solid #dbe7f3;\n  border-radius: 14px;\n  overflow: auto;\n  background: #fff;\n}\n\n.recruiter-breakdown-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f1f7fd;\n  color: #234a73;\n  border-bottom: 1px solid #cfe0ef;\n}\n\n.recruiter-breakdown-table tbody tr:nth-child(even) td {\n  background: #fbfdff;\n}\n\n@media (max-width: 900px) {\n  .recruiter-report-page {\n    padding: 12px 10px 24px;\n  }\n\n  .recruiter-report-hero {\n    border-radius: 18px;\n  }\n\n  .recruiter-breakdown-header {\n    padding: 16px;\n  }\n}\n\n@media (min-width: 901px) {\n  .recruiter-report-hero {\n    padding: 24px 28px !important;\n  }\n}\n\n.recruiter-report-hero-orb {\n  display: none;\n}\n\n.recruiter-report-hero .recruiter-report-filter-label {\n  color: #dbeafe !important;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n}\n\n.recruiter-report-hero .recruiter-report-filter-input,\n.recruiter-report-hero .form-select {\n  min-height: 40px;\n  border-radius: 10px;\n  font-size: 13px;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);\n}\n\n.recruiter-report-hero .recruiter-report-filter-reset {\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.78);\n  color: #fff;\n  transition: background 160ms ease, transform 160ms ease;\n}\n\n.recruiter-report-hero .recruiter-report-filter-reset:hover {\n  background: rgba(15, 23, 42, 0.96);\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.recruiter-breakdown-header .form-control {\n  min-height: 38px;\n  border: 1px solid #d6e3ef;\n  border-radius: 9px;\n  color: #243b53;\n  font-size: 13px;\n  background: #fff;\n}\n\n.recruiter-breakdown-header .form-control:focus {\n  border-color: #4b8bd8;\n  box-shadow: 0 0 0 3px rgba(75, 139, 216, 0.14);\n}\n\n.recruiter-breakdown-header .btn {\n  min-height: 38px;\n  border-radius: 9px;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-breakdown-table td {\n  padding: 13px 16px;\n  border-color: #e8f0f7;\n}\n\n.recruiter-table-name {\n  font-weight: 700 !important;\n  color: #174a7c;\n}\n\n@media (max-width: 640px) {\n  .recruiter-report-hero {\n    padding: 18px 16px !important;\n  }\n\n  .recruiter-report-hero > div:last-child {\n    width: 100%;\n    flex-wrap: wrap !important;\n  }\n\n  .recruiter-report-hero > div:last-child > div {\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n  }\n\n  .recruiter-breakdown-table-wrap {\n    margin: 0 8px 8px !important;\n  }\n}\n\n/* KPI card finish */\n.recruiter-summary-card {\n  position: relative;\n  min-height: 96px;\n  padding: 16px 18px !important;\n  border-radius: 18px !important;\n  overflow: hidden;\n  box-shadow: 0 8px 18px rgba(20, 51, 84, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;\n}\n\n.recruiter-summary-card::before {\n  content: \"\";\n  position: absolute;\n  width: 90px;\n  height: 90px;\n  right: -34px;\n  bottom: -40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.46);\n  pointer-events: none;\n}\n\n.recruiter-summary-card-inner {\n  position: relative;\n  z-index: 1;\n  min-height: 64px;\n  align-items: center !important;\n}\n\n.recruiter-summary-value {\n  font-size: 28px !important;\n  font-weight: 800 !important;\n  letter-spacing: -0.02em;\n  line-height: 1 !important;\n}\n\n.recruiter-summary-label {\n  margin-top: 9px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.01em;\n}\n\n.recruiter-summary-accent {\n  width: 44px !important;\n  height: 44px !important;\n  border-radius: 14px !important;\n  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.07);\n}\n\n@media (max-width: 640px) {\n  .recruiter-summary-card {\n    min-height: 86px;\n    padding: 14px !important;\n  }\n\n  .recruiter-summary-value {\n    font-size: 24px !important;\n  }\n}\n\n/* Upload JD modal */\n.upload-jd-modal {\n  width: min(100% - 32px, 560px);\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.upload-jd-modal .modal-content {\n  overflow: hidden;\n  border: 1px solid #d8e6f3;\n  border-radius: 14px;\n  box-shadow: 0 24px 60px rgba(15, 42, 72, 0.2);\n}\n\n.upload-jd-modal .modal-header {\n  min-height: 62px;\n  padding: 16px 20px !important;\n  background: linear-gradient(135deg, #0f557f 0%, #1687c2 100%);\n  border: 0 !important;\n  color: #fff;\n}\n\n.upload-jd-modal .modal-header .modal-title {\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.upload-jd-modal .modal-header .btn-close {\n  filter: brightness(0) invert(1);\n  opacity: 0.9;\n}\n\n.upload-jd-modal .modal-body {\n  padding: 20px !important;\n  background: #fbfdff;\n}\n\n.upload-jd-modal .upload-jd-dropzone {\n  min-height: 172px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 24px !important;\n  border: 1.5px dashed #9fbdd7 !important;\n  border-radius: 12px !important;\n  background: linear-gradient(180deg, #ffffff 0%, #f4f9fe 100%) !important;\n  color: #334e68;\n  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.upload-jd-modal .upload-jd-dropzone:hover {\n  border-color: #2381bd !important;\n  background: #f1f8ff !important;\n  box-shadow: 0 8px 20px rgba(26, 95, 168, 0.08);\n}\n\n.upload-jd-modal .chooseFileSpan {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.upload-jd-modal .chooseFileSpan span {\n  color: #126fba !important;\n  font-weight: 800;\n}\n\n.upload-jd-modal .hintText {\n  margin: 8px 0 0;\n  color: #718096;\n  font-size: 12.5px;\n}\n\n.upload-jd-modal .upload-jd-file {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 12px;\n  margin-top: 12px !important;\n  padding: 11px 13px !important;\n  border: 1px solid #dbe8f4;\n  border-radius: 9px !important;\n  background: #fff !important;\n  box-shadow: 0 4px 12px rgba(15, 42, 72, 0.05);\n}\n\n.upload-jd-modal .upload-jd-file > div:first-child {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.upload-jd-modal .upload-jd-file > div:first-child > div {\n  min-width: 0;\n}\n\n.upload-jd-modal .upload-jd-file p:first-child {\n  overflow-wrap: anywhere;\n  line-height: 1.35;\n}\n\n.upload-jd-modal .upload-jd-file > img,\n.upload-jd-modal .upload-jd-file > div:last-child img {\n  flex: 0 0 auto;\n}\n\n.upload-jd-modal .modal-footer {\n  padding: 14px 20px 18px !important;\n  background: #f7fbff;\n  border-top: 1px solid #e0ebf5;\n}\n\n.upload-jd-modal .modal-footer .btn {\n  min-width: 98px;\n  min-height: 38px;\n  border-radius: 8px;\n  font-weight: 700;\n}\n\n.recruiter-table-email {\n  max-width: 230px;\n  margin-top: 4px;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recruiter-breakdown-table th:first-child,\n.recruiter-breakdown-table td:first-child {\n  min-width: 240px;\n}\n\n.recruiter-breakdown-table .btn.btn-link {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 0 !important;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: transparent;\n  font-size: 0;\n  cursor: pointer;\n  text-decoration: none !important;\n  opacity: 0;\n}\n\n.recruiter-breakdown-table .btn.btn-link::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  width: 7px;\n  height: 7px;\n  border-top: 2px solid #4b7da7;\n  border-right: 2px solid #4b7da7;\n  transform: translateY(-50%) rotate(45deg);\n  opacity: 0;\n  transition: opacity 150ms ease, right 150ms ease;\n}\n\n.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link) {\n  position: relative;\n  min-height: 30px;\n  cursor: pointer;\n}\n\n.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > span {\n  filter: brightness(0.94);\n  transform: scale(1.04);\n}\n\n.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > .btn.btn-link {\n  opacity: 1;\n}\n\n.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link):hover > .btn.btn-link::after {\n  right: 5px;\n  opacity: 1;\n}\n\n.recruiter-breakdown-table td > .d-flex:has(> .btn.btn-link) > span {\n  position: relative;\n  z-index: 1;\n  transition: filter 150ms ease, transform 150ms ease;\n}\n\n/* Detail modal: keep one scroll region for the records table */\n.recruiter-detail-modal .modal-dialog {\n  width: min(96vw, 1600px) !important;\n  max-width: min(96vw, 1600px) !important;\n  height: calc(100vh - 24px);\n  margin: 12px auto;\n}\n\n.recruiter-detail-modal .modal-content {\n  height: 100%;\n  max-height: calc(100vh - 24px);\n  display: flex;\n  flex-direction: column;\n}\n\n.recruiter-detail-modal .modal-header {\n  flex: 0 0 auto;\n}\n\n.recruiter-detail-modal .recruiter-detail-modal-body {\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 0 !important;\n}\n\n.recruiter-detail-modal .recruiter-detail-modal-table-wrap {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none !important;\n  overflow: auto !important;\n}\n\n@media (max-width: 575px) {\n  .recruiter-detail-modal .modal-dialog {\n    width: calc(100vw - 16px) !important;\n    max-width: calc(100vw - 16px) !important;\n    height: calc(100vh - 16px);\n    margin: 8px auto;\n  }\n\n  .recruiter-detail-modal .modal-content {\n    max-height: calc(100vh - 16px);\n  }\n}\n/* Ticket management */\n.ticket-page{padding:24px;min-height:calc(100vh - 80px);background:#f5f8fc;color:#172b4d}.ticket-hero{display:flex;align-items:center;gap:16px;padding:24px 28px;background:linear-gradient(110deg,#0c4a6e,#126e88);border-radius:12px;color:#fff;box-shadow:0 10px 24px rgba(12,74,110,.16)}.ticket-hero-icon{width:52px;height:52px;display:grid;place-items:center;border-radius:12px;background:rgba(255,255,255,.15);font-size:24px}.ticket-kicker{font-size:11px;font-weight:700;letter-spacing:.08em;opacity:.8}.ticket-hero h1,.ticket-detail-header h1{margin:3px 0 4px;font-size:26px;font-weight:700}.ticket-hero p,.ticket-detail-header p{margin:0;color:rgba(255,255,255,.78)}.ticket-company{margin-left:auto;min-width:220px}.ticket-company label{display:block;font-size:11px;text-transform:uppercase;font-weight:700;margin-bottom:5px}.ticket-company .form-control{background:#fff}.ticket-raise{margin-left:4px;white-space:nowrap}.ticket-raise svg,.ticket-empty button svg{margin-right:7px}.ticket-status-strip{display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin:20px 0}.ticket-count{padding:15px 18px;background:#fff;border:1px solid #dce7f3;border-top:3px solid #2563eb;border-radius:10px;box-shadow:0 4px 12px rgba(23,43,77,.05)}.ticket-count span{display:block;color:#718096;font-size:12px}.ticket-count strong{display:block;margin-top:4px;font-size:24px}.ticket-count.in-progress{border-top-color:#f59e0b}.ticket-count.resolved{border-top-color:#10b981}.ticket-count.closed{border-top-color:#64748b}.ticket-filter-bar{display:grid;grid-template-columns:1.25fr repeat(4,1fr) .8fr .8fr;gap:10px;align-items:center;padding:14px 16px;background:#fff;border:1px solid #dce7f3;border-radius:10px;margin-bottom:16px}.ticket-filter-heading{display:flex;gap:8px;align-items:center;color:#0c4a6e}.ticket-filter-bar .form-control{min-width:0}.ticket-list-panel,.ticket-panel{background:#fff;border:1px solid #dce7f3;border-radius:12px;box-shadow:0 4px 16px rgba(23,43,77,.05)}.ticket-list-heading{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #e5edf6}.ticket-list-heading h2{margin:0;font-size:18px}.ticket-list-heading span{color:#718096;font-size:12px}.ticket-heading-icon{color:#7b8ea8}.ticket-table-wrap{overflow:auto}.ticket-table{width:100%;border-collapse:collapse;min-width:900px}.ticket-table th{padding:12px 16px;background:#f7fafd;color:#5c6f89;font-size:11px;text-transform:uppercase;letter-spacing:.03em;text-align:left;white-space:nowrap}.ticket-table td{padding:15px 16px;border-top:1px solid #edf2f7;font-size:13px;vertical-align:middle}.ticket-table tbody tr{cursor:pointer;transition:background .15s}.ticket-table tbody tr:hover{background:#f7fbff}.ticket-table td strong{display:block}.ticket-table td small{color:#8291a7}.ticket-number-link{border:0;background:none;color:#1264c4;font-weight:700;padding:0;cursor:pointer}.ticket-module-pill,.ticket-priority,.ticket-status{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600}.ticket-module-pill{padding:5px 9px;border-radius:6px;background:#eef5ff;color:#2864a7}.ticket-priority{padding:4px 9px;border-radius:20px;background:#f1f5f9;color:#475569}.priority-low{background:#ecfdf5;color:#047857}.priority-medium{background:#eff6ff;color:#2563eb}.priority-high{background:#fff7ed;color:#c2410c}.priority-urgent{background:#fff1f2;color:#be123c}.ticket-status svg{font-size:11px}.status-open{color:#2563eb}.status-in-progress{color:#d97706}.status-resolved{color:#059669}.status-closed{color:#64748b}.ticket-loading,.ticket-empty{padding:70px 20px;text-align:center;color:#718096}.ticket-empty svg{font-size:28px;color:#8aa2be}.ticket-empty h3{margin:12px 0 5px;color:#334155}.ticket-empty p{margin-bottom:18px}.ticket-detail-header{display:flex;align-items:flex-start;gap:18px;margin-bottom:18px;padding:18px 0}.ticket-detail-header .ticket-back{padding:4px 0;color:#1264c4;white-space:nowrap}.ticket-detail-header p{color:#718096}.ticket-detail-grid{display:grid;grid-template-columns:minmax(0,1.2fr) minmax(320px,1fr);gap:16px}.ticket-panel{padding:22px}.ticket-description{grid-row:span 2}.ticket-panel-title{display:flex;align-items:center;gap:8px;margin-bottom:16px;font-weight:700;color:#0c4a6e}.ticket-description>p{line-height:1.7;color:#4a5c73;white-space:pre-wrap}.ticket-meta-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding-top:18px;margin-top:20px;border-top:1px solid #e5edf6}.ticket-meta-grid small{display:block;color:#8291a7;font-size:11px;margin-bottom:5px}.ticket-meta-grid strong{font-size:13px}.ticket-comments{max-height:340px;overflow:auto}.ticket-comment{display:flex;gap:10px;padding:12px 0;border-bottom:1px solid #edf2f7}.ticket-comment-avatar{width:30px;height:30px;display:grid;place-items:center;flex:0 0 30px;border-radius:50%;background:#e8f1fb;color:#1767ae;font-size:12px}.ticket-comment strong{font-size:13px}.ticket-comment small{margin-left:8px;color:#94a3b8;font-size:11px}.ticket-comment p{margin:5px 0 0;color:#52667f;white-space:pre-wrap}.ticket-empty-inline,.ticket-muted{padding:25px 0;color:#8795a8;text-align:center;font-size:13px}.ticket-comment-form{display:flex;gap:10px;align-items:flex-end;margin-top:16px}.ticket-comment-form .form-control{flex:1}.ticket-admin-controls{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;align-self:start}.ticket-admin-controls .ticket-panel-title{grid-column:1/-1;margin-bottom:0}.ticket-admin-controls label,.ticket-create-modal label{display:block;font-size:12px;font-weight:600;color:#53657d}.ticket-admin-controls .form-control,.ticket-create-modal .form-control{margin-top:6px;font-weight:400}.ticket-create-modal .modal-header{background:#0c6284;color:#fff}.ticket-create-modal .modal-header .close{color:#fff;opacity:1}.ticket-create-modal .modal-body{display:grid;gap:15px}.ticket-create-modal .modal-footer{border-top:1px solid #e5edf6}.ticket-create-modal .alert{margin:0}.ticket-back svg{margin-right:6px}@media(max-width:1100px){.ticket-filter-bar{grid-template-columns:repeat(3,1fr)}.ticket-filter-heading{grid-column:1/-1}.ticket-company{min-width:180px}}@media(max-width:760px){.ticket-page{padding:14px}.ticket-hero{align-items:flex-start;flex-wrap:wrap;padding:18px}.ticket-company{width:100%;margin-left:68px}.ticket-raise{margin-left:auto}.ticket-status-strip{grid-template-columns:repeat(2,1fr)}.ticket-filter-bar{grid-template-columns:1fr 1fr}.ticket-detail-grid{grid-template-columns:1fr}.ticket-description{grid-row:auto}.ticket-admin-controls{grid-template-columns:1fr}.ticket-detail-header{flex-direction:column;gap:6px}.ticket-detail-header h1{font-size:22px}}\n.ticket-page { margin-top: 70px; }\n.ticket-upload-area{display:flex;flex-direction:column;align-items:center;gap:6px;padding:22px 16px;border:1.5px dashed #9bb8d5;border-radius:10px;background:#f8fbff;color:#7186a0;text-align:center;transition:.15s}.ticket-upload-area.is-dragging{border-color:#1475c9;background:#edf7ff;box-shadow:0 0 0 3px rgba(20,117,201,.1)}.ticket-upload-area>svg{font-size:28px;color:#1874bb;margin-bottom:3px}.ticket-upload-area strong{color:#28445f;font-size:14px}.ticket-upload-area span{font-size:12px}.ticket-upload-area small{font-size:11px}.ticket-browse-button{display:inline-flex!important;align-items:center;justify-content:center;margin:2px 0 3px;padding:7px 13px;background:#1264a0;border-radius:6px;color:#fff!important;font-size:12px!important;font-weight:600!important;cursor:pointer}.ticket-browse-button input{display:none}.ticket-selected-files{display:grid;gap:8px;padding:12px;border:1px solid #e0e9f3;border-radius:8px;background:#fbfdff}.ticket-selected-files-heading{display:flex;justify-content:space-between;color:#4d6580;font-size:12px}.ticket-selected-files-heading span{color:#8797aa}.ticket-selected-file{display:flex;align-items:center;gap:10px;padding:8px 10px;background:#fff;border:1px solid #e5edf5;border-radius:7px;min-width:0}.ticket-selected-file img{width:38px;height:38px;object-fit:cover;border-radius:5px}.ticket-selected-file-icon{width:38px;height:38px;padding:10px;color:#2274b5;background:#edf5fd;border-radius:5px}.ticket-selected-file>div{min-width:0;flex:1}.ticket-selected-file strong,.ticket-selected-file small{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-selected-file strong{font-size:12px;color:#304a66}.ticket-selected-file small{margin-top:3px;color:#8b9aad;font-size:10px}.ticket-selected-file button,.ticket-attachment-delete,.ticket-attachment-download{border:0;background:none;color:#7890aa;cursor:pointer;padding:5px}.ticket-selected-file button:hover,.ticket-attachment-delete:hover{color:#d03e50}.ticket-upload-progress{position:relative;height:25px;overflow:hidden;border-radius:5px;background:#e7eff8;color:#456783}.ticket-upload-progress span{position:absolute;inset:0 auto 0 0;background:#2184c7;transition:width .2s}.ticket-upload-progress small{position:relative;z-index:1;display:block;padding:5px 8px;font-size:10px}.ticket-attachments-panel{grid-column:2}.ticket-attachment-list{display:grid;gap:8px}.ticket-attachment-item{display:flex;align-items:center;gap:10px;padding:8px;border:1px solid #e5edf5;border-radius:7px;min-width:0}.ticket-attachment-preview{width:42px;height:42px;padding:0;border:0;border-radius:5px;overflow:hidden;background:#edf5fd;cursor:pointer;flex:0 0 42px}.ticket-attachment-preview img{width:100%;height:100%;object-fit:cover}.ticket-attachment-file-icon{width:42px;height:42px;display:grid;place-items:center;flex:0 0 42px;border-radius:5px;background:#edf5fd;color:#2375b5;font-size:18px}.ticket-attachment-info{min-width:0;flex:1}.ticket-attachment-info strong,.ticket-attachment-info small{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-attachment-info strong{font-size:12px;color:#304a66}.ticket-attachment-info small{margin-top:3px;color:#8999ab;font-size:10px}.ticket-attachment-download{color:#2274b5}.ticket-attachment-download:hover{color:#0d4e83}.ticket-image-preview-modal .modal-body{display:flex;justify-content:center;padding:12px;background:#f5f8fc}.ticket-image-preview{display:block;max-width:100%;max-height:70vh;object-fit:contain;border-radius:5px}.ticket-image-preview-modal .modal-header{padding:12px 16px}.ticket-image-preview-modal .modal-title{font-size:14px}@media(max-width:760px){.ticket-attachments-panel{grid-column:auto}}\n.ticket-create-modal .modal-dialog{max-width:720px;width:calc(100% - 28px)}.ticket-create-modal .modal-content{max-height:90vh;overflow:hidden}.ticket-create-modal .modal-body{max-height:calc(90vh - 138px);overflow-y:auto}.ticket-selected-files{grid-template-columns:repeat(2,minmax(0,1fr));max-height:245px;overflow-y:auto}.ticket-selected-files-heading{grid-column:1/-1}.ticket-selected-file{min-width:0;display:grid;grid-template-columns:48px minmax(0,1fr) auto;align-items:center}.ticket-selected-file img,.ticket-selected-file-icon{width:48px;height:48px}.ticket-selected-file strong{font-size:11px}.ticket-selected-file small{font-size:9px}@media(max-width:620px){.ticket-create-modal .modal-dialog{width:calc(100% - 16px);margin:8px auto}.ticket-selected-files{grid-template-columns:1fr}}\n.ticket-create-modal .modal-footer{justify-content:center;gap:10px}\n.ticket-table th,.ticket-table td{border-right:1px solid #e5edf5}.ticket-table th:last-child,.ticket-table td:last-child{border-right:0}.ticket-table thead th{border-top:1px solid #d9e5f1;border-bottom:1px solid #d9e5f1}.ticket-table tbody tr:last-child td{border-bottom:1px solid #e5edf5}\n.ticket-detail-header{display:grid;grid-template-columns:auto 48px minmax(0,1fr) auto;align-items:center;gap:16px;margin-bottom:18px;padding:20px 24px;background:#fff;border:1px solid #dce7f3;border-radius:12px;box-shadow:0 5px 16px rgba(23,43,77,.05)}.ticket-detail-heading-icon{width:48px;height:48px;display:grid;place-items:center;border-radius:12px;background:#eaf4ff;color:#1768ad;font-size:20px}.ticket-detail-heading-content{min-width:0}.ticket-detail-reference-row{display:flex;align-items:center;gap:9px;margin-bottom:4px}.ticket-detail-reference-row .ticket-module-pill{font-size:10px;padding:3px 7px}.ticket-detail-heading-content h1{margin:0 0 4px;color:#172b4d;font-size:22px;line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ticket-detail-heading-content p{margin:0;color:#7890aa;font-size:12px}.ticket-detail-header-status{display:flex;align-items:center;gap:10px}.ticket-detail-header-status .ticket-status,.ticket-detail-header-status .ticket-priority{white-space:nowrap}.ticket-detail-header .ticket-back{padding:4px 0}@media(max-width:760px){.ticket-detail-header{grid-template-columns:auto 42px minmax(0,1fr);gap:10px;padding:16px}.ticket-detail-heading-icon{width:42px;height:42px}.ticket-detail-header-status{grid-column:2/-1}.ticket-detail-heading-content h1{font-size:19px}.ticket-detail-header .ticket-back{grid-column:1/-1}.ticket-detail-header .ticket-back svg{margin-right:4px}}\n.ticket-detail-header{position:relative;overflow:hidden;grid-template-columns:auto 52px minmax(0,1fr) auto;padding:22px 26px;background:linear-gradient(115deg,#103f70 0%,#126b86 58%,#128b82 100%);border:0;color:#fff;box-shadow:0 12px 28px rgba(16,63,112,.2)}.ticket-detail-header:after{content:\"\";position:absolute;right:12%;top:-90px;width:240px;height:240px;border:1px solid rgba(255,255,255,.12);border-radius:50%;box-shadow:0 0 0 28px rgba(255,255,255,.035),0 0 0 56px rgba(255,255,255,.025);pointer-events:none}.ticket-detail-header>*{position:relative;z-index:1}.ticket-detail-header .ticket-back{color:#fff;text-decoration:none;font-weight:600}.ticket-detail-header .ticket-back:hover{color:#d9f4ff}.ticket-detail-heading-icon{width:52px;height:52px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.14);color:#fff}.ticket-detail-reference-row{margin-bottom:6px}.ticket-detail-header .ticket-kicker{color:rgba(255,255,255,.82);letter-spacing:.1em}.ticket-detail-header .ticket-module-pill{background:rgba(255,255,255,.16);color:#fff;border:1px solid rgba(255,255,255,.18)}.ticket-detail-heading-content h1{color:#fff;font-size:25px;letter-spacing:0}.ticket-detail-heading-content p{color:rgba(255,255,255,.72)}.ticket-detail-header-status{padding-left:14px}.ticket-detail-header-status .ticket-status{padding:7px 11px;border-radius:20px;background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.2)}.ticket-detail-header-status .ticket-priority{padding:7px 11px}.ticket-detail-header .ticket-back svg{color:#a9e2ff}@media(max-width:760px){.ticket-detail-header{grid-template-columns:auto 44px minmax(0,1fr);padding:18px}.ticket-detail-heading-icon{width:44px;height:44px}.ticket-detail-heading-content h1{font-size:21px}.ticket-detail-header-status{padding-left:0}}\n.ticket-resolution-panel{grid-column:2;background:#fafdff;border-color:#cfe3f3}.ticket-resolution-copy{margin:-6px 0 14px;color:#647b93;font-size:13px}.ticket-resolution-options{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px}.ticket-resolution-option{padding:8px 12px;border:1px solid #c8d8e8;border-radius:7px;background:#fff;color:#3d5871;font-size:12px;font-weight:600;cursor:pointer;transition:.15s}.ticket-resolution-option:hover{border-color:#2180c4;color:#1768a5}.ticket-resolution-option.is-selected{border-color:#1475c9;background:#eaf5ff;color:#1165a4;box-shadow:0 0 0 2px rgba(20,117,201,.1)}.ticket-resolution-panel textarea{margin-bottom:10px}.ticket-resolution-panel .btn{font-size:12px}@media(max-width:760px){.ticket-resolution-panel{grid-column:auto}}\n.ticket-feedback-badge{display:inline-flex;align-items:center;padding:5px 9px;border-radius:999px;font-size:11px;font-weight:700;white-space:nowrap}.feedback-completed{background:#e9f9f0;color:#087443}.feedback-pending{background:#fff6df;color:#a66500}.feedback-not_completed{background:#fff0f1;color:#bb3047}.ticket-feedback-summary{margin:0 0 14px;padding:11px 12px;border:1px solid #dce8f2;border-radius:8px;background:#fff}.ticket-feedback-summary p{margin:8px 0 3px;color:#4d637b;font-size:13px;white-space:pre-wrap}.ticket-feedback-summary small{color:#8b9bad;font-size:10px}.ticket-resolution-option:disabled{cursor:not-allowed;opacity:.58}.ticket-count-cell{display:inline-flex;align-items:center;gap:5px;color:#607893;font-size:12px}.ticket-count-cell svg{color:#6e99bc;font-size:11px}.ticket-muted-cell{color:#a0adbb}.ticket-table{min-width:1200px}.ticket-filter-bar{grid-template-columns:1.1fr repeat(5,1fr) .8fr .8fr}.ticket-meta-grid{grid-template-columns:repeat(3,minmax(0,1fr))}@media(max-width:1100px){.ticket-filter-bar{grid-template-columns:repeat(3,1fr)}}\n.ticket-attachment-item.is-clickable{cursor:pointer}.ticket-attachment-item.is-clickable:hover{border-color:#70a9d4;background:#f7fbff;box-shadow:0 2px 8px rgba(20,117,201,.08)}.ticket-attachment-item.is-clickable:focus{outline:2px solid #2184c7;outline-offset:1px}\n.ticket-admin-controls {\n  display: block;\n  padding: 20px;\n  border: 1px solid #d9e6f2;\n  border-top: 3px solid #126e88;\n  background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);\n}\n\n.ticket-admin-controls-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 15px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #e5edf6;\n}\n\n.ticket-admin-controls-heading .ticket-panel-title {\n  margin: 0;\n  font-size: 15px;\n}\n\n.ticket-admin-controls-heading p {\n  margin: 2px 0 0;\n  color: #8191a7;\n  font-size: 12px;\n  text-align: right;\n}\n\n.ticket-admin-control-field {\n  display: block;\n  color: #53657d;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n.ticket-admin-control-field + .ticket-admin-control-field {\n  margin-top: 14px;\n}\n\n.ticket-admin-control-field .form-control {\n  height: 42px;\n  margin-top: 7px;\n  border: 1px solid #c9d9e8;\n  border-radius: 8px;\n  background: #fff;\n  color: #172b4d;\n  font-size: 14px;\n  box-shadow: 0 2px 5px rgba(23, 43, 77, .04);\n}\n\n.ticket-admin-control-field .form-control:focus {\n  border-color: #2583c5;\n  box-shadow: 0 0 0 3px rgba(37, 131, 197, .13);\n}\n\n@media (min-width: 761px) {\n  .ticket-admin-controls {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 14px;\n  }\n\n  .ticket-admin-controls-heading {\n    grid-column: 1 / -1;\n  }\n\n  .ticket-admin-control-field + .ticket-admin-control-field {\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 760px) {\n  .ticket-admin-controls-heading {\n    display: block;\n  }\n\n  .ticket-admin-controls-heading p {\n    margin-top: 5px;\n    text-align: left;\n  }\n}\n\n@media (min-width: 761px) {\n  .ticket-status-strip {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .ticket-detail-grid {\n    align-items: start;\n    grid-template-areas:\n      \"description attachments\"\n      \"conversation resolution\"\n      \"conversation admin\";\n  }\n\n  .ticket-description {\n    grid-area: description;\n    grid-row: auto;\n  }\n\n  .ticket-attachments-panel {\n    grid-area: attachments;\n    height: auto;\n    overflow-y: visible;\n  }\n\n  .ticket-conversation-panel {\n    grid-area: conversation;\n    height: 390px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ticket-conversation-panel .ticket-comments {\n    flex: 1;\n    min-height: 0;\n    max-height: none;\n    overflow-y: auto;\n  }\n\n  .ticket-resolution-panel {\n    grid-area: resolution;\n  }\n\n  .ticket-admin-controls {\n    grid-area: admin;\n  }\n}\n\n@media (max-width: 760px) {\n  .ticket-detail-grid {\n    grid-template-areas: none;\n  }\n\n  .ticket-attachments-panel,\n  .ticket-conversation-panel {\n    height: auto;\n    max-height: 360px;\n  }\n\n  .ticket-conversation-panel {\n    display: block;\n  }\n\n  .ticket-conversation-panel .ticket-comments {\n    max-height: 250px;\n  }\n}\n\n.ticket-count-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  margin: 0 auto;\n}\n\n.modal-dialog.ticket-image-preview-modal {\n  width: calc(100vw - 48px);\n  max-width: 1100px;\n  margin: 24px auto;\n}\n\n.ticket-image-preview-modal .modal-content {\n  overflow: hidden;\n}\n\n.ticket-image-preview-modal .modal-body {\n  min-height: 180px;\n  max-height: calc(100vh - 130px);\n}\n\n@media (max-width: 1100px) and (min-width: 761px) {\n  .ticket-status-strip {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.modal-dialog.ticket-create-modal {\n  width: calc(100vw - 48px);\n  max-width: 820px;\n  margin: 24px auto;\n}\n\n.ticket-create-modal .modal-content {\n  border: 0;\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(15, 39, 66, .25);\n}\n\n.ticket-create-modal .modal-header {\n  padding: 20px 24px;\n  border: 0;\n  background: linear-gradient(115deg, #0d5879, #147e96);\n}\n\n.ticket-create-modal .modal-title {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.ticket-create-modal .modal-body {\n  padding: 24px;\n}\n\n.ticket-create-modal .modal-footer {\n  padding: 16px 24px;\n  background: #f8fbfe;\n}\n\n.ticket-hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-left: auto;\n}\n\n.ticket-company:empty {\n  display: none;\n}\n\n.ticket-hero-actions .ticket-refresh,\n.ticket-hero-actions .ticket-raise {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 40px;\n  margin-left: 0;\n  white-space: nowrap;\n}\n\n.ticket-hero-actions .ticket-refresh {\n  width: 40px;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, .28);\n  background: rgba(255, 255, 255, .12);\n  color: #fff;\n}\n\n.ticket-hero-actions .ticket-refresh:hover:not(:disabled) {\n  background: rgba(255, 255, 255, .2);\n  color: #fff;\n}\n\n.ticket-hero-actions .ticket-refresh:disabled {\n  opacity: .7;\n}\n\n.ticket-hero-actions .is-spinning {\n  animation: ticket-refresh-spin .8s linear infinite;\n}\n\n@keyframes ticket-refresh-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (min-width: 761px) {\n  .ticket-create-modal .modal-body {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 18px;\n    align-items: start;\n  }\n\n  .ticket-create-modal .modal-body > label:nth-child(3),\n  .ticket-create-modal .ticket-create-priority-field,\n  .ticket-create-modal .ticket-upload-area,\n  .ticket-create-modal .ticket-selected-files,\n  .ticket-create-modal .ticket-upload-progress,\n  .ticket-create-modal .alert {\n    grid-column: 1 / -1;\n  }\n\n  .ticket-create-modal .ticket-create-priority-field .form-control {\n    width: 100%;\n  }\n}\n\n@media (max-width: 760px) {\n  .ticket-hero-actions {\n    width: 100%;\n    margin-left: 68px;\n  }\n\n  .modal-dialog.ticket-create-modal {\n    width: calc(100vw - 20px);\n    margin: 10px auto;\n  }\n}\n\n.ticket-description-cell {\n  display: block;\n  max-width: 220px;\n  overflow: hidden;\n  color: #52667f;\n  font-size: 12px;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ticket-search-filter-bar {\n  grid-template-columns: 1.1fr repeat(4, minmax(0, 1fr)) .9fr;\n}\n\n.ticket-search-filter-bar .btn {\n  min-height: 38px;\n  white-space: nowrap;\n}\n\n.ticket-sort-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  text-transform: inherit;\n  letter-spacing: inherit;\n  cursor: pointer;\n}\n\n.ticket-sort-button svg {\n  color: #8aa1b8;\n  font-size: 10px;\n}\n\n.ticket-sort-button:hover,\n.ticket-sort-button:focus-visible {\n  color: #1264a0;\n}\n\n.ticket-sort-button:focus-visible {\n  outline: 2px solid #5ea8d7;\n  outline-offset: 3px;\n  border-radius: 3px;\n}\n\n.ticket-feedback-summary {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 8px 10px;\n  padding: 12px 14px;\n  border: 1px solid #d5e5f2;\n  border-left: 3px solid #16a06d;\n  border-radius: 10px;\n  background: #f8fcff;\n}\n\n.ticket-feedback-summary p {\n  grid-column: 1 / -1;\n  margin: 0;\n  padding-top: 8px;\n  border-top: 1px solid #e3edf5;\n  color: #36536e;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.ticket-feedback-summary small {\n  justify-self: end;\n  color: #8799aa;\n  font-size: 10px;\n}\n\n.ticket-resolution-owner {\n  margin-left: auto;\n  padding: 4px 8px;\n  border: 1px solid #cfe3f1;\n  border-radius: 999px;\n  color: #6e879e;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n@media (min-width: 761px) {\n  .ticket-detail-heading-content {\n    display: block;\n  }\n\n  .ticket-detail-reference-row {\n    margin-bottom: 6px;\n  }\n\n  .ticket-detail-heading-content h1 {\n    display: block;\n    margin: 0;\n  }\n\n  .ticket-detail-heading-content p {\n    display: block;\n    margin: 4px 0 0;\n  }\n}\n\n@media (max-width: 760px) {\n  .ticket-detail-heading-content {\n    display: block;\n  }\n}\n\n.ticket-empty {\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  background: radial-gradient(circle at 50% 30%, #f7fbff 0, #fff 52%);\n}\n\n.ticket-empty-icon {\n  display: grid;\n  width: 58px;\n  height: 58px;\n  place-items: center;\n  margin-bottom: 14px;\n  border: 1px solid #cfe2f2;\n  border-radius: 16px;\n  background: #edf6fd;\n  color: #4b86b4;\n  font-size: 24px;\n  box-shadow: 0 8px 18px rgba(47, 105, 150, .1);\n}\n\n.ticket-empty-kicker {\n  color: #7890aa;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: .12em;\n}\n\n.ticket-empty h3 {\n  margin: 8px 0 5px;\n  color: #183b5d;\n  font-size: 23px;\n}\n\n.ticket-empty p {\n  max-width: 420px;\n  margin: 0 0 20px;\n  color: #7186a0;\n  font-size: 13px;\n  text-align: center;\n}\n\n.ticket-empty .btn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  box-shadow: 0 6px 14px rgba(22, 100, 164, .16);\n}\n\n.ticket-page {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.ticket-detail-grid,\n.ticket-panel {\n  min-width: 0;\n}\n\n.ticket-table-wrap {\n  overflow-x: hidden;\n}\n\n.ticket-table {\n  width: 100%;\n  min-width: 0;\n  table-layout: fixed;\n}\n\n.ticket-table th,\n.ticket-table td {\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.ticket-table th {\n  vertical-align: middle;\n}\n\n.ticket-table .ticket-sort-button {\n  max-width: 100%;\n  white-space: normal;\n}\n\n/* Keep New Mail full-screen after all email-module style bundles load. */\n.em-compose-overlay.em-compose-fullscreen {\n  inset: 0;\n  top: 0;\n  left: 0;\n  transform: none;\n  width: 100vw;\n  max-width: none;\n  height: 100vh;\n  max-height: none;\n  border: 0;\n  border-radius: 0;\n  z-index: 11000;\n}\n\n.em-compose-overlay.em-compose-fullscreen .em-compose-body {\n  flex: 1;\n  max-height: none;\n  min-height: 0;\n}\n\n.em-folder-modal-overlay {\n  align-items: center;\n  padding-top: 0;\n}\n\n.em-folder-modal-overlay .em-cal-modal {\n  width: min(460px, calc(100vw - 32px));\n  max-width: none;\n  align-self: center;\n}\n\n.em-folder-context-menu {\n  width: 220px;\n  padding: 5px 0;\n  background: #fff;\n  border: 1px solid #cfd8e3;\n  border-radius: 3px;\n  box-shadow: 0 8px 22px rgba(15, 35, 55, 0.22);\n}\n\n.em-folder-context-menu .em-context-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  min-height: 30px;\n  padding: 5px 10px;\n  border: 0;\n  background: transparent;\n  color: #263746;\n  font-size: 12px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.em-folder-context-menu .em-context-menu-item:hover:not(:disabled) {\n  background: #eaf3fb;\n  color: #075b93;\n}\n\n.em-folder-context-menu .em-context-menu-item:disabled {\n  color: #9aa6b2;\n  cursor: not-allowed;\n}\n\n.em-folder-context-menu .em-context-menu-divider {\n  height: 1px;\n  margin: 4px 0;\n  background: #e2e7ec;\n}\n\n.em-folder-properties {\n  width: min(520px, calc(100vw - 32px));\n}\n\n.em-folder-property-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 0.7fr) minmax(0, 1.3fr);\n  gap: 16px;\n  padding: 9px 0;\n  border-bottom: 1px solid #e8edf2;\n  color: #68798b;\n  font-size: 12px;\n}\n\n.em-folder-property-row:last-child {\n  border-bottom: 0;\n}\n\n.em-folder-property-row strong {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  color: #1f3447;\n  font-weight: 500;\n}\n\n.job-round-config-summary {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n  padding: 12px 16px;\n  border: 1px solid #d7e3ec;\n  border-top: 0;\n  background: #f7fafc;\n  color: #35536d;\n  font-size: 13px;\n}\n\n.job-round-config-summary span {\n  white-space: nowrap;\n}\n\n.job-round-config-summary strong {\n  color: #173d5c;\n}\n\n/* Compact Outlook-style compose window. */\n.em-compose-overlay {\n  width: min(600px, calc(100vw - 32px));\n  max-width: none;\n  max-height: min(78vh, 640px);\n  border: 1px solid #d7e0ea;\n  border-radius: 9px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 18px 42px rgba(15, 35, 55, 0.28), 0 2px 8px rgba(15, 35, 55, 0.12);\n}\n\n.em-compose-header {\n  min-height: 44px;\n  padding: 8px 12px;\n  background: #0864a2;\n  border-radius: 0;\n}\n\n.em-compose-header h3 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.em-compose-header-btn {\n  width: 26px;\n  height: 26px;\n}\n\n.em-compose-body {\n  max-height: min(520px, calc(78vh - 100px));\n  overflow-y: auto;\n  background: #fff;\n}\n\n.em-compose-field {\n  min-height: 40px;\n  padding: 0 10px;\n  border-bottom: 1px solid #e5ebf1;\n}\n\n.em-compose-field-label {\n  width: 40px;\n  padding: 10px 0;\n  color: #526579;\n  font-size: 12px;\n}\n\n.em-compose-tag-container {\n  min-height: 40px;\n  padding: 5px 0;\n  gap: 5px;\n}\n\n.em-compose-tag {\n  max-width: 100%;\n  padding: 5px 8px;\n  border: 1px solid #b9d5eb;\n  border-radius: 5px;\n  background: #f3f8fc;\n  color: #174c75;\n  font-size: 12px;\n}\n\n.em-compose-tag-input,\n.em-compose-subject-field input {\n  min-height: 28px;\n  font-size: 13px;\n}\n\n.em-compose-toggle-cc {\n  padding: 4px 7px;\n  border: 1px solid #9aaaba;\n  background: #f8fafc;\n  color: #1261a0;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.em-compose-toolbar {\n  min-height: 36px;\n  padding: 4px 10px;\n  border-bottom: 1px solid #e5ebf1;\n  background: #f8fafc;\n}\n\n.em-compose-tool-btn {\n  width: 28px;\n  height: 28px;\n  color: #526579;\n}\n\n.em-compose-editor {\n  min-height: 260px;\n  padding: 0;\n  background: #fff;\n}\n\n.em-compose-editor textarea {\n  min-height: 260px;\n  padding: 14px 12px;\n  color: #1c2d3d;\n  font-size: 13px;\n  line-height: 1.55;\n  resize: vertical;\n}\n\n.em-compose-footer {\n  min-height: 54px;\n  padding: 9px 12px;\n  border-top: 1px solid #dfe7ef;\n  background: #fff;\n}\n\n.em-compose-send-btn {\n  min-height: 36px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  background: #0864a2;\n  font-size: 13px;\n}\n\n.em-compose-attach-btn,\n.em-compose-trash-btn {\n  width: 34px;\n  height: 34px;\n  color: #526579;\n}\n\n@media (max-width: 640px) {\n  .em-compose-overlay {\n    width: calc(100vw - 16px);\n    max-height: calc(100vh - 24px);\n  }\n\n  .em-compose-body {\n    max-height: calc(100vh - 110px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
